/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
import type * as Types from "./CodegenTypes";

import { GraphQLClient, type RequestOptions } from "graphql-request";
import gql from "graphql-tag";
export type Maybe<T> = T;
export type InputMaybe<T> = T;
type GraphQLClientRequestHeaders = RequestOptions["requestHeaders"];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
};

/** Defines the bundle products to add to the cart. */
export type IAddBundleProductsToCartInput = {
  /** The ID of the cart. */
  cart_id: Scalars["String"]["input"];
  /** An array of bundle products to add. */
  cart_items: Array<InputMaybe<IBundleProductCartItemInput>>;
};

/** Contains details about the cart after adding bundle products. */
export type IAddBundleProductsToCartOutput = {
  /** The cart after adding products. */
  cart: ICart;
};

/** Defines the configurable products to add to the cart. */
export type IAddConfigurableProductsToCartInput = {
  /** The ID of the cart. */
  cart_id: Scalars["String"]["input"];
  /** An array of configurable products to add. */
  cart_items: Array<InputMaybe<IConfigurableProductCartItemInput>>;
};

/** Contains details about the cart after adding configurable products. */
export type IAddConfigurableProductsToCartOutput = {
  /** The cart after adding products. */
  cart: ICart;
};

/** Specifies the single coupon code to add to the cart. */
export type IAddCouponToCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars["String"]["input"];
  /** A valid single coupon code. */
  coupon_code: Scalars["String"]["input"];
};

/** Contains details about the cart after adding a coupon. */
export type IAddCouponToCartOutput = {
  /** The cart after applying a single coupon. */
  cart: ICart;
};

export type IAddDownloadableProductsToCartInput = {
  /** The ID of the cart. */
  cart_id: Scalars["String"]["input"];
  /** An array of downloadable products to add. */
  cart_items: Array<InputMaybe<IDownloadableProductCartItemInput>>;
};

/** Contains details about the cart after adding downloadable products. */
export type IAddDownloadableProductsToCartOutput = {
  /** The cart after adding products. */
  cart: ICart;
};

/** Defines an item to add to the gift registry. */
export type IAddGiftRegistryItemInput = {
  /** An array of options the customer has entered. */
  entered_options: InputMaybe<Array<InputMaybe<IEnteredOptionInput>>>;
  /** A brief note about the item. */
  note: InputMaybe<Scalars["String"]["input"]>;
  /** For complex product types, the SKU of the parent product. */
  parent_sku: InputMaybe<Scalars["String"]["input"]>;
  /** The quantity of the product to add. */
  quantity: Scalars["Float"]["input"];
  /** An array of strings corresponding to options the customer has selected. */
  selected_options: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** The SKU of the product to add to the gift registry. */
  sku: Scalars["String"]["input"];
};

/** Defines a new registrant. */
export type IAddGiftRegistryRegistrantInput = {
  /** Additional attributes specified as a code-value pair. */
  dynamic_attributes: InputMaybe<Array<InputMaybe<IGiftRegistryDynamicAttributeInput>>>;
  /** The email address of the registrant. */
  email: Scalars["String"]["input"];
  /** The first name of the registrant. */
  firstname: Scalars["String"]["input"];
  /** The last name of the registrant. */
  lastname: Scalars["String"]["input"];
};

/** Contains the results of a request to add registrants. */
export type IAddGiftRegistryRegistrantsOutput = {
  /** The gift registry after adding registrants. */
  gift_registry: Maybe<IGiftRegistry>;
};

/** Contains details about the cart after adding products to it. */
export type IAddProductsToCartOutput = {
  /** The cart after products have been added. */
  cart: ICart;
  /** Contains errors encountered while adding an item to the cart. */
  user_errors: Array<Maybe<IError>>;
};

/** Contains products to add to an existing compare list. */
export type IAddProductsToCompareListInput = {
  /** An array of product IDs to add to the compare list. */
  products: Array<InputMaybe<Scalars["ID"]["input"]>>;
  /** The unique identifier of the compare list to modify. */
  uid: Scalars["ID"]["input"];
};

/** Contains details about the cart after adding products to it. */
export type IAddProductsToNewCartOutput = {
  /** The cart after products have been added. */
  cart: Maybe<ICart>;
  /** Contains errors encountered while adding an item to the cart. */
  user_errors: Maybe<Array<Maybe<ICartUserInputError>>>;
};

/** Contains the customer's wish list and any errors encountered. */
export type IAddProductsToWishlistOutput = {
  /** An array of errors encountered while adding products to a wish list. */
  user_errors: Array<Maybe<IWishListUserInputError>>;
  /** Contains the wish list with all items that were successfully added. */
  wishlist: IWishlist;
};

/** Defines a return comment. */
export type IAddReturnCommentInput = {
  /** The text added to the return request. */
  comment_text: Scalars["String"]["input"];
  /** The unique ID for a `Return` object. */
  return_uid: Scalars["ID"]["input"];
};

/** Contains details about the return request. */
export type IAddReturnCommentOutput = {
  /** The modified return. */
  return: Maybe<IReturn>;
};

/** Defines tracking information to be added to the return. */
export type IAddReturnTrackingInput = {
  /** The unique ID for a `ReturnShippingCarrier` object. */
  carrier_uid: Scalars["ID"]["input"];
  /** The unique ID for a `Returns` object. */
  return_uid: Scalars["ID"]["input"];
  /** The shipping tracking number for this return request. */
  tracking_number: Scalars["String"]["input"];
};

/** Contains the response after adding tracking information. */
export type IAddReturnTrackingOutput = {
  /** Details about the modified return. */
  return: Maybe<IReturn>;
  /** Details about shipping for a return. */
  return_shipping_tracking: Maybe<IReturnShippingTracking>;
};

/** Defines the simple and group products to add to the cart. */
export type IAddSimpleProductsToCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars["String"]["input"];
  /** An array of simple and group items to add. */
  cart_items: Array<InputMaybe<ISimpleProductCartItemInput>>;
};

/** Contains details about the cart after adding simple or group products. */
export type IAddSimpleProductsToCartOutput = {
  /** The cart after adding products. */
  cart: ICart;
};

/** Defines the virtual products to add to the cart. */
export type IAddVirtualProductsToCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars["String"]["input"];
  /** An array of virtual products to add. */
  cart_items: Array<InputMaybe<IVirtualProductCartItemInput>>;
};

/** Contains details about the cart after adding virtual products. */
export type IAddVirtualProductsToCartOutput = {
  /** The cart after adding products. */
  cart: ICart;
};

/** Contains the resultant wish list and any error information. */
export type IAddWishlistItemsToCartOutput = {
  /** An array of errors encountered while adding products to the customer's cart. */
  add_wishlist_items_to_cart_user_errors: Array<Maybe<IWishlistCartUserInputError>>;
  /** Indicates whether the attempt to add items to the customer's cart was successful. */
  status: Scalars["Boolean"]["output"];
  /** Contains the wish list with all items that were successfully added. */
  wishlist: IWishlist;
};

export enum IAddressValidationErrorCode {
  InvalidAddress = "INVALID_ADDRESS",
  InvalidCity = "INVALID_CITY",
  InvalidPostcode = "INVALID_POSTCODE",
  InvalidProvince = "INVALID_PROVINCE",
  InvalidSa = "INVALID_SA",
  InvalidTelephone = "INVALID_TELEPHONE",
}

export enum IAgeVerificationMode {
  Cart = "CART",
  Disabled = "DISABLED",
  Shipping = "SHIPPING",
}

/** Contains information for each filterable option (such as price, category `UID`, and custom attributes). */
export type IAggregation = {
  /** Attribute code of the aggregation group. */
  attribute_code: Scalars["String"]["output"];
  /** The number of options in the aggregation group. */
  count: Maybe<Scalars["Int"]["output"]>;
  /** The aggregation display name. */
  label: Maybe<Scalars["String"]["output"]>;
  /** Array of options for the aggregation. */
  options: Maybe<Array<Maybe<IAggregationOption>>>;
  /** The relative position of the attribute in a layered navigation block. */
  position: Maybe<Scalars["Int"]["output"]>;
};

/** An implementation of `AggregationOptionInterface`. */
export type IAggregationOption = IAggregationOptionInterface & {
  /** The number of items that match the aggregation option. */
  count: Maybe<Scalars["Int"]["output"]>;
  /** The display label for an aggregation option. */
  label: Maybe<Scalars["String"]["output"]>;
  /** The internal ID that represents the value of the option. */
  value: Scalars["String"]["output"];
};

/** Defines aggregation option fields. */
export type IAggregationOptionInterface = {
  /** The number of items that match the aggregation option. */
  count: Maybe<Scalars["Int"]["output"]>;
  /** The display label for an aggregation option. */
  label: Maybe<Scalars["String"]["output"]>;
  /** The internal ID that represents the value of the option. */
  value: Scalars["String"]["output"];
};

/** Filter category aggregations in layered navigation. */
export type IAggregationsCategoryFilterInput = {
  /** Indicates whether to include only direct subcategories or all children categories at all levels. */
  includeDirectChildrenOnly: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** An input object that specifies the filters used in product aggregations. */
export type IAggregationsFilterInput = {
  /** Filter category aggregations in layered navigation. */
  category: InputMaybe<IAggregationsCategoryFilterInput>;
};

export type IApplePayConfig = IPaymentConfigItem & {
  /** The styles for the ApplePay Smart Button configuration */
  button_styles: Maybe<IButtonStyles>;
  /** The payment method code as defined in the payment gateway */
  code: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether the payment method is displayed */
  is_visible: Maybe<Scalars["Boolean"]["output"]>;
  /** Defines the payment intent (Authorize or Capture */
  payment_intent: Maybe<Scalars["String"]["output"]>;
  /** The payment source for the payment method */
  payment_source: Maybe<Scalars["String"]["output"]>;
  /** The PayPal parameters required to load the JS SDK */
  sdk_params: Maybe<Array<Maybe<ISdkParams>>>;
  /** The relative order the payment method is displayed on the checkout page */
  sort_order: Maybe<Scalars["String"]["output"]>;
  /** The name displayed for the payment method */
  title: Maybe<Scalars["String"]["output"]>;
};

/** Apple Pay inputs */
export type IApplePayMethodInput = {
  /** The payment source for the payment method */
  payment_source: InputMaybe<Scalars["String"]["input"]>;
  /** The payment services order ID */
  payments_order_id: InputMaybe<Scalars["String"]["input"]>;
  /** PayPal order ID */
  paypal_order_id: InputMaybe<Scalars["String"]["input"]>;
};

export type IAppliedCampaign = {
  loyalty_discount_amount: Maybe<Scalars["Float"]["output"]>;
  loyalty_discount_name: Maybe<Scalars["String"]["output"]>;
  loyalty_discount_points: Maybe<Scalars["Int"]["output"]>;
  loyalty_discount_skus: Maybe<Scalars["String"]["output"]>;
  loyalty_discount_uuid: Maybe<Scalars["String"]["output"]>;
};

/** Contains the applied coupon code. */
export type IAppliedCoupon = {
  /** The coupon code the shopper applied to the card. */
  code: Scalars["String"]["output"];
  /** The label of the coupon. */
  label: Maybe<Scalars["String"]["output"]>;
};

/** Contains an applied gift card with applied and remaining balance. */
export type IAppliedGiftCard = {
  /** The amount applied to the current cart. */
  applied_balance: Maybe<IMoney>;
  /** The gift card account code. */
  code: Maybe<Scalars["String"]["output"]>;
  /** The remaining balance on the gift card. */
  current_balance: Maybe<IMoney>;
  /** The expiration date of the gift card. */
  expiration_date: Maybe<Scalars["String"]["output"]>;
};

/** Contains the applied and current balances. */
export type IAppliedStoreCredit = {
  /** The applied store credit balance to the current cart. */
  applied_balance: Maybe<IMoney>;
  /** The current balance remaining on store credit. */
  current_balance: Maybe<IMoney>;
  /** Indicates whether store credits are enabled. If the feature is disabled, then the current balance will not be returned. */
  enabled: Maybe<Scalars["Boolean"]["output"]>;
};

export type IApplyCampaignToCartInput = {
  campaign_uuid: InputMaybe<Scalars["String"]["input"]>;
  cart_id: Scalars["String"]["input"];
  points: InputMaybe<Scalars["Int"]["input"]>;
};

export type IApplyCampaignToCartOutput = {
  cart: ICart;
};

/** Specifies the coupon code to apply to the cart. */
export type IApplyCouponToCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars["String"]["input"];
  /** A valid coupon code. */
  coupon_code: Scalars["String"]["input"];
};

/** Contains details about the cart after applying a coupon. */
export type IApplyCouponToCartOutput = {
  /** The cart after applying a coupon. */
  cart: ICart;
};

/** The strategy to apply coupons to the cart. */
export enum IApplyCouponsStrategy {
  /** Append new coupons keeping the coupons that have been applied before. */
  Append = "APPEND",
  /** Remove all the coupons from the cart and apply only new provided coupons. */
  Replace = "REPLACE",
}

/** Apply coupons to the cart. */
export type IApplyCouponsToCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars["String"]["input"];
  /** An array of valid coupon codes. */
  coupon_codes: Array<InputMaybe<Scalars["String"]["input"]>>;
  /** `replace` to replace the existing coupon(s) or `append` to add the coupon to the coupon(s) list. */
  type: InputMaybe<IApplyCouponsStrategy>;
};

/** Defines the input required to run the `applyGiftCardToCart` mutation. */
export type IApplyGiftCardToCartInput = {
  /** The unique ID that identifies the customer's cart. */
  cart_id: Scalars["String"]["input"];
  /** The gift card code to be applied to the cart. */
  gift_card_code: Scalars["String"]["input"];
};

/** Defines the possible output for the `applyGiftCardToCart` mutation. */
export type IApplyGiftCardToCartOutput = {
  /** Describes the contents of the specified shopping cart. */
  cart: ICart;
};

/** Contains applied gift cards with gift card code and amount. */
export type IApplyGiftCardToOrder = {
  /** The gift card amount applied to the current order. */
  applied_balance: IMoney;
  /** The gift card account code. */
  code: Scalars["String"]["output"];
};

/** Contains the customer cart. */
export type IApplyRewardPointsToCartOutput = {
  /** The customer cart after reward points are applied. */
  cart: ICart;
};

/** Defines the input required to run the `applyStoreCreditToCart` mutation. */
export type IApplyStoreCreditToCartInput = {
  /** The unique ID that identifies the customer's cart. */
  cart_id: Scalars["String"]["input"];
};

/** Defines the possible output for the `applyStoreCreditToCart` mutation. */
export type IApplyStoreCreditToCartOutput = {
  /** The contents of the specified shopping cart. */
  cart: ICart;
};

/** Contains the results of the request to assign a compare list. */
export type IAssignCompareListToCustomerOutput = {
  /** The contents of the customer's compare list. */
  compare_list: Maybe<ICompareList>;
  /** Indicates whether the compare list was successfully assigned to the customer. */
  result: Scalars["Boolean"]["output"];
};

/** Contains details about the attribute, including the code and type. */
export type IAttribute = {
  /** The unique identifier for an attribute code. This value should be in lowercase letters without spaces. */
  attribute_code: Maybe<Scalars["String"]["output"]>;
  /** Attribute options list. */
  attribute_options: Maybe<Array<Maybe<IAttributeOption>>>;
  /** The data type of the attribute. */
  attribute_type: Maybe<Scalars["String"]["output"]>;
  /** The type of entity that defines the attribute. */
  entity_type: Maybe<Scalars["String"]["output"]>;
  /** The frontend input type of the attribute. */
  input_type: Maybe<Scalars["String"]["output"]>;
  /** Details about the storefront properties configured for the attribute. */
  storefront_properties: Maybe<IStorefrontProperties>;
};

/** List of all entity types. Populated by the modules introducing EAV entities. */
export enum IAttributeEntityTypeEnum {
  CatalogCategory = "CATALOG_CATEGORY",
  CatalogProduct = "CATALOG_PRODUCT",
  Customer = "CUSTOMER",
  CustomerAddress = "CUSTOMER_ADDRESS",
  RmaItem = "RMA_ITEM",
}

/** An input object that specifies the filters used for attributes. */
export type IAttributeFilterInput = {
  /** Whether a product or category attribute can be compared against another or not. */
  is_comparable: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Whether a product or category attribute can be filtered or not. */
  is_filterable: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Whether a product or category attribute can be filtered in search or not. */
  is_filterable_in_search: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Whether a product or category attribute can use HTML on front or not. */
  is_html_allowed_on_front: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Whether a product or category attribute can be searched or not. */
  is_searchable: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Whether a customer or customer address attribute is used for customer segment or not. */
  is_used_for_customer_segment: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Whether a product or category attribute can be used for price rules or not. */
  is_used_for_price_rules: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Whether a product or category attribute is used for promo rules or not. */
  is_used_for_promo_rules: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Whether a product or category attribute is visible in advanced search or not. */
  is_visible_in_advanced_search: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Whether a product or category attribute is visible on front or not. */
  is_visible_on_front: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Whether a product or category attribute has WYSIWYG enabled or not. */
  is_wysiwyg_enabled: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Whether a product or category attribute is used in product listing or not. */
  used_in_product_listing: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** EAV attribute frontend input types. */
export enum IAttributeFrontendInputEnum {
  Boolean = "BOOLEAN",
  Date = "DATE",
  Datetime = "DATETIME",
  File = "FILE",
  Gallery = "GALLERY",
  Hidden = "HIDDEN",
  Image = "IMAGE",
  MediaImage = "MEDIA_IMAGE",
  Multiline = "MULTILINE",
  Multiselect = "MULTISELECT",
  Price = "PRICE",
  Select = "SELECT",
  Text = "TEXT",
  Textarea = "TEXTAREA",
  Undefined = "UNDEFINED",
  Weight = "WEIGHT",
}

/** Defines the attribute characteristics to search for the `attribute_code` and `entity_type` to search. */
export type IAttributeInput = {
  /** The unique identifier for an attribute code. This value should be in lowercase letters without spaces. */
  attribute_code: InputMaybe<Scalars["String"]["input"]>;
  /** The type of entity that defines the attribute. */
  entity_type: InputMaybe<Scalars["String"]["input"]>;
};

/** Specifies selected option for a select or multiselect attribute value. */
export type IAttributeInputSelectedOption = {
  /** The attribute option value. */
  value: Scalars["String"]["input"];
};

/** Base EAV implementation of CustomAttributeMetadataInterface. */
export type IAttributeMetadata = ICustomAttributeMetadataInterface & {
  /** The unique identifier for an attribute code. This value should be in lowercase letters without spaces. */
  code: Scalars["ID"]["output"];
  /** Default attribute value. */
  default_value: Maybe<Scalars["String"]["output"]>;
  /** The type of entity that defines the attribute. */
  entity_type: IAttributeEntityTypeEnum;
  /** The frontend class of the attribute. */
  frontend_class: Maybe<Scalars["String"]["output"]>;
  /** The frontend input type of the attribute. */
  frontend_input: Maybe<IAttributeFrontendInputEnum>;
  /** Whether the attribute value is required. */
  is_required: Scalars["Boolean"]["output"];
  /** Whether the attribute value must be unique. */
  is_unique: Scalars["Boolean"]["output"];
  /** The label assigned to the attribute. */
  label: Maybe<Scalars["String"]["output"]>;
  /** Attribute options. */
  options: Array<Maybe<ICustomAttributeOptionInterface>>;
};

/** Attribute metadata retrieval error. */
export type IAttributeMetadataError = {
  /** Attribute metadata retrieval error message. */
  message: Scalars["String"]["output"];
  /** Attribute metadata retrieval error type. */
  type: IAttributeMetadataErrorType;
};

/** Attribute metadata retrieval error types. */
export enum IAttributeMetadataErrorType {
  /** The requested attribute was not found. */
  AttributeNotFound = "ATTRIBUTE_NOT_FOUND",
  /** The requested entity was not found. */
  EntityNotFound = "ENTITY_NOT_FOUND",
  /** The filter cannot be applied as it does not belong to the entity */
  FilterNotFound = "FILTER_NOT_FOUND",
  /** Not categorized error, see the error message. */
  Undefined = "UNDEFINED",
}

/** Defines an attribute option. */
export type IAttributeOption = {
  /** The label assigned to the attribute option. */
  label: Maybe<Scalars["String"]["output"]>;
  /** The attribute option value. */
  value: Maybe<Scalars["String"]["output"]>;
};

/** Base EAV implementation of CustomAttributeOptionInterface. */
export type IAttributeOptionMetadata = ICustomAttributeOptionInterface & {
  /** Is the option value default. */
  is_default: Scalars["Boolean"]["output"];
  /** The label assigned to the attribute option. */
  label: Scalars["String"]["output"];
  /** The attribute option value. */
  value: Scalars["String"]["output"];
};

export type IAttributeSelectedOption = IAttributeSelectedOptionInterface & {
  /** The attribute selected option label. */
  label: Scalars["String"]["output"];
  /** The attribute selected option value. */
  value: Scalars["String"]["output"];
};

export type IAttributeSelectedOptionInterface = {
  /** The attribute selected option label. */
  label: Scalars["String"]["output"];
  /** The attribute selected option value. */
  value: Scalars["String"]["output"];
};

export type IAttributeSelectedOptions = IAttributeValueInterface & {
  /** The attribute code. */
  code: Scalars["ID"]["output"];
  selected_options: Array<Maybe<IAttributeSelectedOptionInterface>>;
};

export type IAttributeValue = IAttributeValueInterface & {
  /** The attribute code. */
  code: Scalars["ID"]["output"];
  /** The attribute value. */
  value: Scalars["String"]["output"];
};

/** Specifies the value for attribute. */
export type IAttributeValueInput = {
  /** The code of the attribute. */
  attribute_code: Scalars["String"]["input"];
  /** An array containing selected options for a select or multiselect attribute. */
  selected_options: InputMaybe<Array<InputMaybe<IAttributeInputSelectedOption>>>;
  /** The value assigned to the attribute. */
  value: InputMaybe<Scalars["String"]["input"]>;
};

export type IAttributeValueInterface = {
  /** The attribute code. */
  code: Scalars["ID"]["output"];
};

/** Metadata of EAV attributes associated to form */
export type IAttributesFormOutput = {
  /** Errors of retrieving certain attributes metadata. */
  errors: Array<Maybe<IAttributeMetadataError>>;
  /** Requested attributes metadata. */
  items: Array<Maybe<ICustomAttributeMetadataInterface>>;
};

/** Metadata of EAV attributes. */
export type IAttributesMetadataOutput = {
  /** Errors of retrieving certain attributes metadata. */
  errors: Array<Maybe<IAttributeMetadataError>>;
  /** Requested attributes metadata. */
  items: Array<Maybe<ICustomAttributeMetadataInterface>>;
};

export type IAvailableFreeGift = {
  /** Products the customer may choose as a free gift */
  allowed_gift_products: Maybe<Array<Maybe<IGiftSelectionProduct>>>;
  /** Maximum number of gift items the customer may add for this rule */
  gift_qty_limit: Scalars["Int"]["output"];
  /** Whether the customer is allowed to remove the selected gift */
  is_removable: Scalars["Boolean"]["output"];
  /** ID of the applied sales rule that enables gift selection */
  sales_rule_id: Scalars["Int"]["output"];
};

/** Describes a payment method that the shopper can use to pay for the order. */
export type IAvailablePaymentMethod = {
  /** The payment method code. */
  code: Scalars["String"]["output"];
  /** If the payment method is an online integration */
  is_deferred: Scalars["Boolean"]["output"];
  /** The payment method title. */
  title: Scalars["String"]["output"];
};

/** Contains details about the possible shipping methods and carriers. */
export type IAvailableShippingMethod = {
  /** The cost of shipping using this shipping method. */
  amount: IMoney;
  /** Indicates whether this shipping method can be applied to the cart. */
  available: Scalars["Boolean"]["output"];
  /** @deprecated The field should not be used on the storefront. */
  base_amount: Maybe<IMoney>;
  /** A string that identifies a commercial carrier or an offline shipping method. */
  carrier_code: Scalars["String"]["output"];
  /** The label for the carrier code. */
  carrier_title: Scalars["String"]["output"];
  description: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether this shipping method is disabled for subscriptions. */
  disable_for_subscription: Maybe<Scalars["Boolean"]["output"]>;
  /** Describes an error condition. */
  error_message: Maybe<Scalars["String"]["output"]>;
  estimated_delivery_time: Maybe<Scalars["String"]["output"]>;
  /** A shipping method code associated with a carrier. The value could be null if no method is available. */
  method_code: Maybe<Scalars["String"]["output"]>;
  /** The label for the shipping method code. The value could be null if no method is available. */
  method_title: Maybe<Scalars["String"]["output"]>;
  /** The cost of shipping using this shipping method, excluding tax. */
  price_excl_tax: IMoney;
  /** The cost of shipping using this shipping method, including tax. */
  price_incl_tax: IMoney;
};

export enum IBatchMutationStatus {
  Failure = "FAILURE",
  MixedResults = "MIXED_RESULTS",
  Success = "SUCCESS",
}

/** Defines the billing address. */
export type IBillingAddressInput = {
  /** Defines a billing address. */
  address: InputMaybe<ICartAddressInput>;
  /** An ID from the customer's address book that uniquely identifies the address to be used for billing. */
  customer_address_id: InputMaybe<Scalars["Int"]["input"]>;
  /** Indicates whether to set the billing address to be the same as the existing shipping address on the cart. */
  same_as_shipping: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Indicates whether to set the shipping address to be the same as this billing address. */
  use_for_shipping: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** The billing address information */
export type IBillingAddressPaymentSourceInput = {
  /** The first line of the address */
  address_line_1: InputMaybe<Scalars["String"]["input"]>;
  /** The second line of the address */
  address_line_2: InputMaybe<Scalars["String"]["input"]>;
  /** The city of the address */
  city: InputMaybe<Scalars["String"]["input"]>;
  /** The country of the address */
  country_code: Scalars["String"]["input"];
  /** The postal code of the address */
  postal_code: InputMaybe<Scalars["String"]["input"]>;
  /** The region of the address */
  region: InputMaybe<Scalars["String"]["input"]>;
};

/** Contains details about the billing address. */
export type IBillingCartAddress = ICartAddressInterface & {
  /** Administrative area level 2 */
  administrative_area_level_2: Maybe<Scalars["String"]["output"]>;
  /** Building Number */
  building_number: Maybe<Scalars["String"]["output"]>;
  /** The city specified for the billing or shipping address. */
  city: Scalars["String"]["output"];
  /** The company specified for the billing or shipping address. */
  company: Maybe<Scalars["String"]["output"]>;
  /** An object containing the country label and code. */
  country: ICartAddressCountry;
  /** The custom attribute values of the billing or shipping address. */
  custom_attributes: Array<Maybe<IAttributeValueInterface>>;
  /** @deprecated The field is used only in shipping address. */
  customer_notes: Maybe<Scalars["String"]["output"]>;
  /** District */
  district: Maybe<Scalars["String"]["output"]>;
  /** The customer's fax number. */
  fax: Maybe<Scalars["String"]["output"]>;
  /** The first name of the customer or guest. */
  firstname: Maybe<Scalars["String"]["output"]>;
  /** Apartment, floor, building, etc. */
  house_details: Maybe<Scalars["String"]["output"]>;
  /** Id of the customer address. */
  id: Maybe<Scalars["Int"]["output"]>;
  /** Landmark */
  landmark: Maybe<Scalars["String"]["output"]>;
  /** The last name of the customer or guest. */
  lastname: Scalars["String"]["output"];
  /** The middle name of the person associated with the billing/shipping address. */
  middlename: Maybe<Scalars["String"]["output"]>;
  /** Neighborhood */
  neighborhood: Maybe<Scalars["String"]["output"]>;
  /** The ZIP or postal code of the billing or shipping address. */
  postcode: Maybe<Scalars["String"]["output"]>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix: Maybe<Scalars["String"]["output"]>;
  /** Premise */
  premise: Maybe<Scalars["String"]["output"]>;
  /** An object containing the region label and code. */
  region: Maybe<ICartAddressRegion>;
  /** Short National Address */
  short_address: Maybe<Scalars["String"]["output"]>;
  /** An array containing the street for the billing or shipping address. */
  street: Array<Maybe<Scalars["String"]["output"]>>;
  /** Street number */
  street_nr: Maybe<Scalars["String"]["output"]>;
  /** Sublocality level 2 */
  sublocality_level_2: Maybe<Scalars["String"]["output"]>;
  /** A value such as Sr., Jr., or III. */
  suffix: Maybe<Scalars["String"]["output"]>;
  /** The telephone number for the billing or shipping address. */
  telephone: Maybe<Scalars["String"]["output"]>;
  /** The unique id of the customer address. */
  uid: Scalars["String"]["output"];
  /** The VAT company number for billing or shipping address. */
  vat_id: Maybe<Scalars["String"]["output"]>;
};

export type IBrandConsumablesMatrix = {
  brandIcon: Maybe<Scalars["String"]["output"]>;
  brandLabel: Scalars["String"]["output"];
  brandLabels: Array<Maybe<IBrandLabelTranslation>>;
  code: Scalars["String"]["output"];
  id: Scalars["Int"]["output"];
  isNew: Scalars["Boolean"]["output"];
  items: Array<Maybe<IConsumableMatrixItem>>;
  name: Scalars["String"]["output"];
  packagingFormats: Array<Maybe<IPackagingFormat>>;
  productBrandOptionId: Maybe<Scalars["Int"]["output"]>;
};

export type IBrandLabelTranslation = {
  label: Scalars["String"]["output"];
  language: Scalars["String"]["output"];
};

/** Contains details about an individual category that comprises a breadcrumb. */
export type IBreadcrumb = {
  /**
   * The ID of the category.
   * @deprecated Use `category_uid` instead.
   */
  category_id: Maybe<Scalars["Int"]["output"]>;
  /** The category level. */
  category_level: Maybe<Scalars["Int"]["output"]>;
  /** The display name of the category. */
  category_name: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `Breadcrumb` object. */
  category_uid: Scalars["ID"]["output"];
  /** The URL key of the category. */
  category_url_key: Maybe<Scalars["String"]["output"]>;
  /** The URL path of the category. */
  category_url_path: Maybe<Scalars["String"]["output"]>;
};

/** An implementation for bundle product cart items. */
export type IBundleCartItem = ICartItemInterface & {
  /** The list of available gift wrapping options for the cart item. */
  available_gift_wrapping: Array<Maybe<IGiftWrapping>>;
  /** An array containing the bundle options the shopper selected. */
  bundle_options: Array<Maybe<ISelectedBundleOption>>;
  /** An array containing the customizable options the shopper selected. */
  customizable_options: Array<Maybe<ISelectedCustomizableOption>>;
  /** An array of errors encountered while loading the cart item */
  errors: Maybe<Array<Maybe<ICartItemError>>>;
  /** Provides info regarding the gift added to the basket */
  gift_data: Maybe<IGiftData>;
  /** The entered gift message for the cart item */
  gift_message: Maybe<IGiftMessage>;
  /** The selected gift wrapping for the cart item. */
  gift_wrapping: Maybe<IGiftWrapping>;
  /** Provides the flag to show if consent was set or not */
  has_registration_consent: Maybe<Scalars["Boolean"]["output"]>;
  /** @deprecated Use `uid` instead. */
  id: Scalars["String"]["output"];
  /** True if requested quantity is less than available stock, false otherwise. */
  is_available: Scalars["Boolean"]["output"];
  /** Message to display when the product is not available with this selected option. */
  not_available_message: Maybe<Scalars["String"]["output"]>;
  /** Contains details about the price of the item, including taxes and discounts. */
  prices: Maybe<ICartItemPrices>;
  /** Details about an item in the cart. */
  product: IProductInterface;
  /** The quantity of this item in the cart. */
  quantity: Scalars["Float"]["output"];
  /** The unique ID for a `CartItemInterface` object. */
  uid: Scalars["ID"]["output"];
};

/** Defines bundle product options for `CreditMemoItemInterface`. */
export type IBundleCreditMemoItem = ICreditMemoItemInterface & {
  /** A list of bundle options that are assigned to a bundle product that is part of a credit memo. */
  bundle_options: Maybe<Array<Maybe<IItemSelectedBundleOption>>>;
  /** Details about the final discount amount for the base product, including discounts on options. */
  discounts: Maybe<Array<Maybe<IDiscount>>>;
  /** The unique ID for a `CreditMemoItemInterface` object. */
  id: Scalars["ID"]["output"];
  /** The order item the credit memo is applied to. */
  order_item: Maybe<IOrderItemInterface>;
  /** The name of the base product. */
  product_name: Maybe<Scalars["String"]["output"]>;
  /** The sale price for the base product, including selected options. */
  product_sale_price: IMoney;
  /** The SKU of the base product. */
  product_sku: Scalars["String"]["output"];
  /** The number of refunded items. */
  quantity_refunded: Maybe<Scalars["Float"]["output"]>;
};

/** Defines bundle product options for `InvoiceItemInterface`. */
export type IBundleInvoiceItem = IInvoiceItemInterface & {
  /** A list of bundle options that are assigned to an invoiced bundle product. */
  bundle_options: Maybe<Array<Maybe<IItemSelectedBundleOption>>>;
  /** Information about the final discount amount for the base product, including discounts on options. */
  discounts: Maybe<Array<Maybe<IDiscount>>>;
  /** The unique ID for an `InvoiceItemInterface` object. */
  id: Scalars["ID"]["output"];
  /** Details about an individual order item. */
  order_item: Maybe<IOrderItemInterface>;
  /** The name of the base product. */
  product_name: Maybe<Scalars["String"]["output"]>;
  /** The sale price for the base product including selected options. */
  product_sale_price: IMoney;
  /** The SKU of the base product. */
  product_sku: Scalars["String"]["output"];
  /** The number of invoiced items. */
  quantity_invoiced: Maybe<Scalars["Float"]["output"]>;
};

/** Defines an individual item within a bundle product. */
export type IBundleItem = {
  /** An array of additional options for this bundle item including out of stock options. */
  all_options: Maybe<Array<Maybe<IBundleItemOption>>>;
  /**
   * An ID assigned to each type of item in a bundle product.
   * @deprecated Use `uid` instead
   */
  option_id: Maybe<Scalars["Int"]["output"]>;
  /** An array of additional options for this bundle item. */
  options: Maybe<Array<Maybe<IBundleItemOption>>>;
  /** A number indicating the sequence order of this item compared to the other bundle items. */
  position: Maybe<Scalars["Int"]["output"]>;
  /** The range of prices for the product */
  price_range: IPriceRange;
  /** Maximum allowed qty of items selected for this option */
  qty: Maybe<Scalars["Int"]["output"]>;
  /** Indicates whether the item must be included in the bundle. */
  required: Maybe<Scalars["Boolean"]["output"]>;
  /** The SKU of the bundle product. */
  sku: Maybe<Scalars["String"]["output"]>;
  /** The display name of the item. */
  title: Maybe<Scalars["String"]["output"]>;
  /** The input type that the customer uses to select the item. Examples include radio button and checkbox. */
  type: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `BundleItem` object. */
  uid: Maybe<Scalars["ID"]["output"]>;
};

/** Defines the characteristics that comprise a specific bundle item and its options. */
export type IBundleItemOption = {
  /** Indicates whether the customer can change the number of items for this option. */
  can_change_quantity: Maybe<Scalars["Boolean"]["output"]>;
  /**
   * The ID assigned to the bundled item option.
   * @deprecated Use `uid` instead
   */
  id: Maybe<Scalars["Int"]["output"]>;
  /** Indicates whether this option is the default option. */
  is_default: Maybe<Scalars["Boolean"]["output"]>;
  /** The text that identifies the bundled item option. */
  label: Maybe<Scalars["String"]["output"]>;
  /** When a bundle item contains multiple options, the relative position of this option compared to the other options. */
  position: Maybe<Scalars["Int"]["output"]>;
  /** The price of the selected option. */
  price: Maybe<Scalars["Float"]["output"]>;
  /** One of FIXED, PERCENT, or DYNAMIC. */
  price_type: Maybe<IPriceTypeEnum>;
  /** Contains details about this product option. */
  product: Maybe<IProductInterface>;
  /**
   * Indicates the quantity of this specific bundle item.
   * @deprecated Use `quantity` instead.
   */
  qty: Maybe<Scalars["Float"]["output"]>;
  /** The quantity of this specific bundle item. */
  quantity: Maybe<Scalars["Float"]["output"]>;
  /** Swatch data for bundle product option - `color` attribute supported only. */
  swatch_data: Maybe<ISwatchDataInterface>;
  /** The unique ID for a `BundleItemOption` object. */
  uid: Scalars["ID"]["output"];
};

/** Defines the input for a bundle option. */
export type IBundleOptionInput = {
  /** The ID of the option. */
  id: Scalars["Int"]["input"];
  quantities: InputMaybe<Array<InputMaybe<IMultiselectQuantity>>>;
  /** The number of the selected item to add to the cart. */
  quantity: InputMaybe<Scalars["Float"]["input"]>;
  /** An array with the chosen value of the option. */
  value: Array<InputMaybe<Scalars["String"]["input"]>>;
};

/** Defines bundle product options for `OrderItemInterface`. */
export type IBundleOrderItem = IOrderItemInterface & {
  /** A list of bundle options that are assigned to the bundle product. */
  bundle_options: Maybe<Array<Maybe<IItemSelectedBundleOption>>>;
  /** The final discount information for the product. */
  discounts: Maybe<Array<Maybe<IDiscount>>>;
  /** Indicates whether the order item is eligible to be in a return request. */
  eligible_for_return: Maybe<Scalars["Boolean"]["output"]>;
  /** The entered option for the base product, such as a logo or image. */
  entered_options: Maybe<Array<Maybe<IOrderItemOption>>>;
  /** Provides info regarding the gift added to the basket */
  gift_data: Maybe<IGiftData>;
  /** The selected gift message for the order item */
  gift_message: Maybe<IGiftMessage>;
  /** The selected gift wrapping for the order item. */
  gift_wrapping: Maybe<IGiftWrapping>;
  /** Provides the flag to show if consent was set or not */
  has_registration_consent: Maybe<Scalars["Boolean"]["output"]>;
  /** The unique ID for an `OrderItemInterface` object. */
  id: Scalars["ID"]["output"];
  /** The original product price of the base product. */
  original_price: IMoney;
  /** The SKU of parent product. */
  parent_sku: Maybe<Scalars["String"]["output"]>;
  /** Contains details about the price of the item, including taxes and discounts. */
  prices: Maybe<IOrderItemPrices>;
  /** The ProductInterface object, which contains details about the base product */
  product: Maybe<IProductInterface>;
  /** The name of the base product. */
  product_name: Maybe<Scalars["String"]["output"]>;
  /** The sale price of the base product, including selected options. */
  product_sale_price: IMoney;
  /** The sale price of the base product, including tax. */
  product_sale_price_incl_tax: IMoney;
  /** The SKU of the base product. */
  product_sku: Scalars["String"]["output"];
  /** Indicates whether this product has subscription flag. */
  product_subscription: Maybe<Scalars["Boolean"]["output"]>;
  /** The type of product, such as simple, configurable, etc. */
  product_type: Maybe<Scalars["String"]["output"]>;
  /** URL key of the base product. */
  product_url_key: Maybe<Scalars["String"]["output"]>;
  /** The number of canceled items. */
  quantity_canceled: Maybe<Scalars["Float"]["output"]>;
  /** The number of invoiced items. */
  quantity_invoiced: Maybe<Scalars["Float"]["output"]>;
  /** The number of units ordered for this item. */
  quantity_ordered: Maybe<Scalars["Float"]["output"]>;
  /** The number of refunded items. */
  quantity_refunded: Maybe<Scalars["Float"]["output"]>;
  /** The requested return quantity of the item. */
  quantity_return_requested: Maybe<Scalars["Float"]["output"]>;
  /** The number of returned items. */
  quantity_returned: Maybe<Scalars["Float"]["output"]>;
  /** The number of shipped items. */
  quantity_shipped: Maybe<Scalars["Float"]["output"]>;
  /** Row total for product. */
  row_total: IMoney;
  /** Row total for product including tax. */
  row_total_incl_tax: IMoney;
  /** The selected options for the base product, such as color or size. */
  selected_options: Maybe<Array<Maybe<IOrderItemOption>>>;
  /** The status of the order item. */
  status: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether the product is eligible for a trade-in purchase. */
  trade_in: Scalars["Int"]["output"];
};

/** Defines basic features of a bundle product and contains multiple BundleItems. */
export type IBundleProduct = ICustomizableProductInterface &
  IPhysicalProductInterface &
  IProductInterface &
  IRoutableInterface & {
    /** @deprecated Use the `custom_attributes` field instead. */
    about_manufacturer: Maybe<Scalars["String"]["output"]>;
    /**
     * The attribute set assigned to the product.
     * @deprecated The field should not be used on the storefront.
     */
    attribute_set_id: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    available_date: Maybe<Scalars["String"]["output"]>;
    /**
     * Whether the product is explicitly available for Mobile App commerce exposure. 1 = eligible, 0 or null = not eligible.
     * @deprecated Use the `custom_attributes` field instead.
     */
    available_for_mobile_app: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    battery: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    buy_cta_pdp: Maybe<Scalars["Int"]["output"]>;
    /** CTA for PDP attribute translated label . */
    buy_cta_pdp_label: Scalars["String"]["output"];
    /** @deprecated Use the `custom_attributes` field instead. */
    buy_cta_plp: Maybe<Scalars["Int"]["output"]>;
    /** CTA for PLP attribute translated label . */
    buy_cta_plp_label: Scalars["String"]["output"];
    /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
    canonical_url: Maybe<Scalars["String"]["output"]>;
    /** The categories assigned to a product. */
    categories: Maybe<Array<Maybe<ICategoryInterface>>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    charging_time: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    color: Maybe<Scalars["Int"]["output"]>;
    /** Color attribute label. */
    color_label: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    connectors: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    connectors_1: Maybe<Scalars["String"]["output"]>;
    /** The product's country of origin. */
    country_of_manufacture: Maybe<Scalars["String"]["output"]>;
    /**
     * Timestamp indicating when the product was created.
     * @deprecated The field should not be used on the storefront.
     */
    created_at: Maybe<Scalars["String"]["output"]>;
    /** An array of cross-sell products. */
    crosssell_products: Maybe<Array<Maybe<IProductInterface>>>;
    /** Product custom attributes. */
    custom_attributesV2: Maybe<IProductCustomAttributes>;
    /** Delivery region this product may be shipped to — `ES` or `IC`, the same vocabulary as the region header and getDeliveryRegions.code. Distinct from `region_code` on address types, which carries a province code. Null when the product carries no region, or its attribute value is not mapped to one; either way the product is undeliverable everywhere. */
    delivery_region_code: Maybe<Scalars["String"]["output"]>;
    /** Detailed information about the product. The value can include simple HTML tags. */
    description: Maybe<IComplexTextValue>;
    /** @deprecated Use the `custom_attributes` field instead. */
    device_dimensions: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    dimensions: Maybe<Scalars["String"]["output"]>;
    /** Indicates whether the bundle product has a dynamic price. */
    dynamic_price: Maybe<Scalars["Boolean"]["output"]>;
    /** Indicates whether the bundle product has a dynamic SKU. */
    dynamic_sku: Maybe<Scalars["Boolean"]["output"]>;
    /** Indicates whether the bundle product has a dynamically calculated weight. */
    dynamic_weight: Maybe<Scalars["Boolean"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    enable_lifetime_quantity_limit: Maybe<Scalars["Int"]["output"]>;
    /**
     * Is quantity limit enabled for this product
     * @deprecated Use the `custom_attributes` field instead.
     */
    enable_order_quantity_limit: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    experience: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    flavor: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    flavor_family: Maybe<Scalars["String"]["output"]>;
    /** Color attribute label. */
    flavor_label: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    flavour: Maybe<Scalars["Int"]["output"]>;
    /** Get all details for flavour */
    flavour_details: Array<Maybe<IFlavourDetails>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    formula: Maybe<Scalars["Int"]["output"]>;
    /** A list of gift options for the given product */
    free_gifts: Maybe<IFreeGiftProductData>;
    /** Returns all attribute values and labels marked as visible on storefront */
    frontend_attributes: Maybe<Array<Maybe<IFrontendAttribute>>>;
    /** Returns a value indicating gift message availability for the product. */
    gift_message_available: Scalars["Boolean"]["output"];
    /** Returns a value indicating gift wrapping availability for the product. */
    gift_wrapping_available: Scalars["Boolean"]["output"];
    /** Returns value and currency indicating gift wrapping price for the product. */
    gift_wrapping_price: Maybe<IMoney>;
    /** @deprecated Use the `custom_attributes` field instead. */
    has_device: Maybe<Scalars["Int"]["output"]>;
    /** Provides the flag to show if consent is required or not */
    has_registration_consent: Maybe<Scalars["Boolean"]["output"]>;
    /** Product is hidden_sku or not */
    hidden_sku: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * The ID number assigned to the product.
     * @deprecated Use the `uid` field instead.
     */
    id: Maybe<Scalars["Int"]["output"]>;
    /** The relative path to the main image on the product page. */
    image: Maybe<IProductImage>;
    /** @deprecated Use the `custom_attributes` field instead. */
    importer: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    input_terminal: Maybe<Scalars["Int"]["output"]>;
    /** Product discontinued flag */
    is_discontinued: Maybe<Scalars["Boolean"]["output"]>;
    /** Indicates whether the product can be returned. */
    is_returnable: Maybe<Scalars["String"]["output"]>;
    /** An array containing information about individual bundle items. */
    items: Maybe<Array<Maybe<IBundleItem>>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    jti_brand_matrix: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    jti_category_redirect: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    jti_product_discontinued: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    jti_sku_redirect: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    large_stick_tray: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    lifetime_quantity_limit: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    main_specifications: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    mandatory_positive_consent: Maybe<Scalars["Int"]["output"]>;
    /**
     * A number representing the product's manufacturer.
     * @deprecated Use the `custom_attributes` field instead.
     */
    manufacturer: Maybe<Scalars["Int"]["output"]>;
    /** Product subscription format */
    manufacturer_label: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    material: Maybe<Scalars["String"]["output"]>;
    /** Maximum Qty Allowed in Shopping Cart */
    max_sale_qty: Maybe<Scalars["Float"]["output"]>;
    /** An array of media gallery objects. */
    media_gallery: Maybe<Array<Maybe<IMediaGalleryInterface>>>;
    /**
     * An array of MediaGalleryEntry objects.
     * @deprecated Use `media_gallery` instead.
     */
    media_gallery_entries: Maybe<Array<Maybe<IMediaGalleryEntry>>>;
    /** A brief overview of the product for search results listings, maximum 255 characters. */
    meta_description: Maybe<Scalars["String"]["output"]>;
    /** A comma-separated list of keywords that are visible only to search engines. */
    meta_keyword: Maybe<Scalars["String"]["output"]>;
    /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
    meta_title: Maybe<Scalars["String"]["output"]>;
    /** Minimum Qty Allowed in Shopping Cart */
    min_sale_qty: Maybe<Scalars["Float"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    minimum_amount: Maybe<Scalars["Float"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    minimum_amount_type: Maybe<Scalars["String"]["output"]>;
    /**
     * Multipack description for this product
     * @deprecated Use the `custom_attributes` field instead.
     */
    multipack_description: Maybe<Scalars["String"]["output"]>;
    /** Is multipacks selected enabled for this product */
    multipack_enabled: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * Multipack label for this product
     * @deprecated Use the `custom_attributes` field instead.
     */
    multipack_label: Maybe<Scalars["String"]["output"]>;
    /** Multipack price text for this product */
    multipack_price: Maybe<Scalars["String"]["output"]>;
    /** Multipack Products */
    multipack_products: Maybe<Array<Maybe<IProductInterface>>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    multipacks_enabled: Maybe<Scalars["Int"]["output"]>;
    /** The product name. Customers use this name to identify the product. */
    name: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    name_and_model: Maybe<Scalars["String"]["output"]>;
    /** The beginning date for new product listings, and determines if the product is featured as a new product. */
    new_from_date: Maybe<Scalars["String"]["output"]>;
    /** The end date for new product listings. */
    new_to_date: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    non_trade_in_sku: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    number_of_packs: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    number_of_sticks: Maybe<Scalars["Int"]["output"]>;
    /** Product stock only x left count */
    only_x_left_in_stock: Maybe<Scalars["Float"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    option_grouped_by_brand: Maybe<Scalars["Int"]["output"]>;
    /** An array of options for a customizable product. */
    options: Maybe<Array<Maybe<ICustomizableOptionInterface>>>;
    /** If the product has multiple options, determines where they appear on the product page. */
    options_container: Maybe<Scalars["String"]["output"]>;
    /**
     * Maximum quantity allowed per one order
     * @deprecated Use the `custom_attributes` field instead.
     */
    order_quantity_limit: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    portable_stick_tray: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    pouch_size: Maybe<Scalars["Int"]["output"]>;
    /**
     * Indicates the price of an item.
     * @deprecated Use `price_range` for product price information.
     */
    price: Maybe<IProductPrices>;
    /** The price details of the main product */
    price_details: Maybe<IPriceDetails>;
    /** The range of prices for the product */
    price_range: IPriceRange;
    /** An array of `TierPrice` objects. */
    price_tiers: Maybe<Array<Maybe<ITierPrice>>>;
    /** One of PRICE_RANGE or AS_LOW_AS. */
    price_view: Maybe<IPriceViewEnum>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_brand: Maybe<Scalars["String"]["output"]>;
    /** Product Brand Label */
    product_brand_label: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_category: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_category_type: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_color: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_disclaimer: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_family: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_generation: Maybe<Scalars["String"]["output"]>;
    /** An array of `ProductLinks` objects. */
    product_links: Maybe<Array<Maybe<IProductLinksInterface>>>;
    /** Get all special offers for a product. */
    promotionalOffers: Array<Maybe<ISpecialOffer>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    province: Maybe<Scalars["String"]["output"]>;
    /** Product provence label for PLP attribute. */
    province_label: Maybe<Scalars["String"]["output"]>;
    /** Amount of available stock */
    quantity: Maybe<Scalars["Float"]["output"]>;
    /** The average of all the ratings given to the product. */
    rating_summary: Scalars["Float"]["output"];
    /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
    redirect_code: Scalars["Int"]["output"];
    /** Redirect category URL path for discontinued product */
    redirect_product_category: Maybe<Scalars["String"]["output"]>;
    /** Redirect product SKU for discontinued product */
    redirect_sku: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    region: Maybe<Scalars["Int"]["output"]>;
    /** Product Region attribute translated label. */
    region_label: Maybe<Scalars["String"]["output"]>;
    /** An array of related products. */
    related_products: Maybe<Array<Maybe<IProductInterface>>>;
    /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
    relative_url: Maybe<Scalars["String"]["output"]>;
    /** The total count of all the reviews given to the product. */
    review_count: Scalars["Int"]["output"];
    /** @deprecated Use the `custom_attributes` field instead. */
    review_eligible: Maybe<Scalars["Int"]["output"]>;
    /** The list of products reviews. */
    reviews: IProductReviews;
    /** Indicates whether to ship bundle items together or individually. */
    ship_bundle_items: Maybe<IShipBundleItemsEnum>;
    /** A short description of the product. Its use depends on the theme. */
    short_description: Maybe<IComplexTextValue>;
    /** @deprecated Use the `custom_attributes` field instead. */
    size: Maybe<Scalars["String"]["output"]>;
    /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
    sku: Maybe<Scalars["String"]["output"]>;
    /** The relative path to the small image, which is used on catalog pages. */
    small_image: Maybe<IProductImage>;
    /** Get all special offers for a product. */
    specialOffers: Array<Maybe<ISpecialOffer>>;
    /**
     * The beginning date that a product has a special price.
     * @deprecated The field should not be used on the storefront.
     */
    special_from_date: Maybe<Scalars["String"]["output"]>;
    /** The discounted price of the product. */
    special_price: Maybe<Scalars["Float"]["output"]>;
    /** The end date for a product with a special price. */
    special_to_date: Maybe<Scalars["String"]["output"]>;
    /** Indicates whether the product is staged for a future campaign. */
    staged: Scalars["Boolean"]["output"];
    /** @deprecated Use the `custom_attributes` field instead. */
    stick_capability: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    stick_compatibility: Maybe<Scalars["String"]["output"]>;
    /** Stock status of the product */
    stock_status: Maybe<IProductStockStatus>;
    /** @deprecated Use the `custom_attributes` field instead. */
    strength: Maybe<Scalars["Int"]["output"]>;
    /** Get all details for strength */
    strength_details: Maybe<IStrengthDetails>;
    /** @deprecated Use the `custom_attributes` field instead. */
    subscription: Maybe<Scalars["Int"]["output"]>;
    /**
     * Product subscription format
     * @deprecated Use the `custom_attributes` field instead.
     */
    subscription_format: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    subtitle: Maybe<Scalars["String"]["output"]>;
    /** The file name of a swatch image. */
    swatch_image: Maybe<Scalars["String"]["output"]>;
    /** The relative path to the product's thumbnail image. */
    thumbnail: Maybe<IProductImage>;
    /**
     * The price when tier pricing is in effect and the items purchased threshold has been reached.
     * @deprecated Use `price_tiers` for product tier price information.
     */
    tier_price: Maybe<Scalars["Float"]["output"]>;
    /**
     * An array of ProductTierPrices objects.
     * @deprecated Use `price_tiers` for product tier price information.
     */
    tier_prices: Maybe<Array<Maybe<IProductTierPrices>>>;
    /**
     * Product tooltip information
     * @deprecated Use the `custom_attributes` field instead.
     */
    tooltip_info: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    trabka: Maybe<Scalars["String"]["output"]>;
    /**
     * Indicates whether the product is eligible for a trade-in purchase.
     * @deprecated Use the `custom_attributes` field instead.
     */
    trade_in: Scalars["Int"]["output"];
    /**
     * Specific to trial stores, provides information about the finalization sku
     * @deprecated Use the `custom_attributes` field instead.
     */
    trial_finalization_sku: Maybe<Scalars["String"]["output"]>;
    /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
    type: Maybe<IUrlRewriteEntityTypeEnum>;
    /**
     * One of simple, virtual, bundle, downloadable, grouped, or configurable.
     * @deprecated Use `__typename` instead.
     */
    type_id: Maybe<Scalars["String"]["output"]>;
    /** Product Type */
    type_label: Maybe<Scalars["String"]["output"]>;
    /** The unique ID for a `ProductInterface` object. */
    uid: Scalars["ID"]["output"];
    /**
     * Timestamp indicating when the product was updated.
     * @deprecated The field should not be used on the storefront.
     */
    updated_at: Maybe<Scalars["String"]["output"]>;
    /** An array of up-sell products. */
    upsell_products: Maybe<Array<Maybe<IProductInterface>>>;
    /** The part of the URL that identifies the product */
    url_key: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use product's `canonical_url` or url rewrites instead */
    url_path: Maybe<Scalars["String"]["output"]>;
    /** URL rewrites list */
    url_rewrites: Maybe<Array<Maybe<IUrlRewrite>>>;
    /** The part of the product URL that is appended after the url key */
    url_suffix: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    voltage: Maybe<Scalars["String"]["output"]>;
    /**
     * An array of websites in which the product is available.
     * @deprecated The field should not be used on the storefront.
     */
    websites: Maybe<Array<Maybe<IWebsite>>>;
    /** The weight of the item, in units defined by the store. */
    weight: Maybe<Scalars["Float"]["output"]>;
  };

/** Defines basic features of a bundle product and contains multiple BundleItems. */
export type IBundleProductCustom_AttributesV2Args = {
  filters: InputMaybe<IAttributeFilterInput>;
};

/** Defines basic features of a bundle product and contains multiple BundleItems. */
export type IBundleProductReviewsArgs = {
  currentPage?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Defines a single bundle product. */
export type IBundleProductCartItemInput = {
  /** A mandatory array of options for the bundle product, including each chosen option and specified quantity. */
  bundle_options: Array<InputMaybe<IBundleOptionInput>>;
  /** The ID and value of the option. */
  customizable_options: InputMaybe<Array<InputMaybe<ICustomizableOptionInput>>>;
  /** The quantity and SKU of the bundle product. */
  data: ICartItemInput;
};

/** Defines bundle product options for `ShipmentItemInterface`. */
export type IBundleShipmentItem = IShipmentItemInterface & {
  /** A list of bundle options that are assigned to a shipped product. */
  bundle_options: Maybe<Array<Maybe<IItemSelectedBundleOption>>>;
  /** The unique ID for a `ShipmentItemInterface` object. */
  id: Scalars["ID"]["output"];
  /** The order item associated with the shipment item. */
  order_item: Maybe<IOrderItemInterface>;
  /** The name of the base product. */
  product_name: Maybe<Scalars["String"]["output"]>;
  /** The sale price for the base product. */
  product_sale_price: IMoney;
  /** The SKU of the base product. */
  product_sku: Scalars["String"]["output"];
  /** The number of shipped items. */
  quantity_shipped: Scalars["Float"]["output"];
};

/** Defines bundle product options for `WishlistItemInterface`. */
export type IBundleWishlistItem = IWishlistItemInterface & {
  /** The date and time the item was added to the wish list. */
  added_at: Scalars["String"]["output"];
  /** An array containing information about the selected bundle items. */
  bundle_options: Maybe<Array<Maybe<ISelectedBundleOption>>>;
  /** Custom options selected for the wish list item. */
  customizable_options: Array<Maybe<ISelectedCustomizableOption>>;
  /** The description of the item. */
  description: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `WishlistItemInterface` object. */
  id: Scalars["ID"]["output"];
  /** Product details of the wish list item. */
  product: Maybe<IProductInterface>;
  /** The quantity of this wish list item. */
  quantity: Scalars["Float"]["output"];
};

export type IButtonStyles = {
  /** The button color */
  color: Maybe<Scalars["String"]["output"]>;
  /** The button height in pixels */
  height: Maybe<Scalars["Int"]["output"]>;
  /** The button label */
  label: Maybe<Scalars["String"]["output"]>;
  /** The button layout */
  layout: Maybe<Scalars["String"]["output"]>;
  /** The button shape */
  shape: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether the tagline is displayed */
  tagline: Maybe<Scalars["Boolean"]["output"]>;
  /** Defines if the button uses default height. If the value is false, the value of height is used */
  use_default_height: Maybe<Scalars["Boolean"]["output"]>;
};

export type ICanApplyCouponsInput = {
  cart_id: Scalars["String"]["input"];
};

export type ICancelOrderError = {
  /** An error code that is specific to cancel order. */
  code: ICancelOrderErrorCode;
  /** A localized error message. */
  message: Scalars["String"]["output"];
};

export enum ICancelOrderErrorCode {
  InvalidOrderStatus = "INVALID_ORDER_STATUS",
  OrderCancellationDisabled = "ORDER_CANCELLATION_DISABLED",
  OrderNotFound = "ORDER_NOT_FOUND",
  PartialOrderItemShipped = "PARTIAL_ORDER_ITEM_SHIPPED",
  Unauthorised = "UNAUTHORISED",
  Undefined = "UNDEFINED",
}

/** Defines the order to cancel. */
export type ICancelOrderInput = {
  /** The unique ID of an `Order` type. */
  order_id: Scalars["ID"]["input"];
  /** Cancellation reason. */
  reason: Scalars["String"]["input"];
};

/** Contains the updated customer order and error message if any. */
export type ICancelOrderOutput = {
  /** Error encountered while cancelling the order. */
  error: Maybe<Scalars["String"]["output"]>;
  errorV2: Maybe<ICancelOrderError>;
  /** Updated customer order. */
  order: Maybe<ICustomerOrder>;
};

export type ICancellationReason = {
  description: Scalars["String"]["output"];
};

export type ICard = {
  /** Card bin details */
  bin_details: Maybe<ICardBin>;
  /** Expiration month of the card */
  card_expiry_month: Maybe<Scalars["String"]["output"]>;
  /** Expiration year of the card */
  card_expiry_year: Maybe<Scalars["String"]["output"]>;
  /** Last four digits of the card */
  last_digits: Maybe<Scalars["String"]["output"]>;
  /** Name on the card */
  name: Maybe<Scalars["String"]["output"]>;
};

export type ICardBin = {
  /** Card bin number */
  bin: Maybe<Scalars["String"]["output"]>;
};

/** The card payment source information */
export type ICardPaymentSourceInput = {
  /** The billing address of the card */
  billing_address: IBillingAddressPaymentSourceInput;
  /** The name on the cardholder */
  name: InputMaybe<Scalars["String"]["input"]>;
};

/** The card payment source information */
export type ICardPaymentSourceOutput = {
  /** The brand of the card */
  brand: Maybe<Scalars["String"]["output"]>;
  /** The expiry of the card */
  expiry: Maybe<Scalars["String"]["output"]>;
  /** The last digits of the card */
  last_digits: Maybe<Scalars["String"]["output"]>;
};

/** Contains the contents and other details about a guest or customer cart. */
export type ICart = {
  /** Quote additional attributes */
  additional_attributes: Maybe<Array<Maybe<IQuoteAttribute>>>;
  applied_campaign: Maybe<IAppliedCampaign>;
  /** @deprecated Use `applied_coupons` instead. */
  applied_coupon: Maybe<IAppliedCoupon>;
  /** An array of `AppliedCoupon` objects. Each object contains the `code` text attribute, which specifies the coupon code. */
  applied_coupons: Maybe<Array<Maybe<IAppliedCoupon>>>;
  /** An array of gift card items applied to the cart. */
  applied_gift_cards: Maybe<Array<Maybe<IAppliedGiftCard>>>;
  /** The amount of reward points applied to the cart. */
  applied_reward_points: Maybe<IRewardPointsAmount>;
  /** Store credit information applied to the cart. */
  applied_store_credit: Maybe<IAppliedStoreCredit>;
  /** Free gift options available for customer selection (jti_free_gift_selection rules) */
  available_free_gifts: Maybe<Array<Maybe<IAvailableFreeGift>>>;
  /** The list of available gift wrapping options for the cart. */
  available_gift_wrappings: Array<Maybe<IGiftWrapping>>;
  /** An array of available payment methods. */
  available_payment_methods: Maybe<Array<Maybe<IAvailablePaymentMethod>>>;
  /** The billing address assigned to the cart. */
  billing_address: Maybe<IBillingCartAddress>;
  can_apply_coupons: Scalars["Boolean"]["output"];
  /** The cross-selling popup to display for this cart, or null when none applies. */
  cross_sell_popup: Maybe<ICrossSellPopup>;
  /** The email address of the guest or customer. */
  email: Maybe<Scalars["String"]["output"]>;
  /** Estimated shipping cost for display in the cart. Read-only — does not modify the quote. Requires the jti_quote_graphql/shipping/early_shipping_cost_display_enabled flag to be enabled. */
  estimated_shipping_cost: Maybe<IEstimatedShippingCost>;
  /** Effective free shipping threshold for the cart progress bar in the current store currency. Logged-in customers only. Returns null when no threshold is configured. */
  free_shipping_threshold: Maybe<Scalars["Float"]["output"]>;
  /** The entered gift message for the cart */
  gift_message: Maybe<IGiftMessage>;
  /** Indicates whether the shopper requested gift receipt for the cart. */
  gift_receipt_included: Scalars["Boolean"]["output"];
  /** The selected gift wrapping for the cart. */
  gift_wrapping: Maybe<IGiftWrapping>;
  /** The unique ID for a `Cart` object. */
  id: Scalars["ID"]["output"];
  is_trial_eligible: Scalars["Boolean"]["output"];
  /** Indicates whether the cart contains only virtual products. */
  is_virtual: Scalars["Boolean"]["output"];
  /**
   * An array of products that have been added to the cart.
   * @deprecated Use `itemsV2` instead.
   */
  items: Maybe<Array<Maybe<ICartItemInterface>>>;
  itemsV2: Maybe<ICartItems>;
  /** Unix timestamp of last cart modification. Used for conditional requests with if_modified_since. */
  last_modified: Maybe<Scalars["String"]["output"]>;
  /** Last modification time in RFC 7232 format (e.g., 'Thu, 16 Oct 2025 15:57:29 GMT') */
  last_modified_time: Maybe<Scalars["String"]["output"]>;
  /** Provides the minimum payable amount for the cart */
  minimum_payable_amount: Maybe<IMoney>;
  /** Pricing details for the quote. */
  prices: Maybe<ICartPrices>;
  /** Indicates whether the shopper requested a printed card for the cart. */
  printed_card_included: Scalars["Boolean"]["output"];
  /** Indicates which payment method was applied to the cart. */
  selected_payment_method: Maybe<ISelectedPaymentMethod>;
  /** An array of shipping addresses assigned to the cart. */
  shipping_addresses: Array<Maybe<IShippingCartAddress>>;
  subscription_amount: Maybe<Scalars["Float"]["output"]>;
  total_after_trial: Maybe<ITrialTotals>;
  total_including_trial: Maybe<ITrialTotals>;
  /** The total number of items in the cart. */
  total_quantity: Scalars["Float"]["output"];
  xselling_popup: Scalars["Boolean"]["output"];
};

/** Contains the contents and other details about a guest or customer cart. */
export type ICartItemsV2Args = {
  currentPage?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  sort: InputMaybe<IQuoteItemsSortInput>;
};

/** Contains details the country in a billing or shipping address. */
export type ICartAddressCountry = {
  /** The country code. */
  code: Scalars["String"]["output"];
  /** The display label for the country. */
  label: Scalars["String"]["output"];
};

/** Extended input for billing or shipping address with region_code support. */
export type ICartAddressInput = {
  /** Administrative area level 2 */
  administrative_area_level_2: InputMaybe<Scalars["String"]["input"]>;
  /** Building Number */
  building_number: InputMaybe<Scalars["String"]["input"]>;
  /** The city specified for the billing or shipping address. */
  city: Scalars["String"]["input"];
  /** The company specified for the billing or shipping address. */
  company: InputMaybe<Scalars["String"]["input"]>;
  /** The country code and label for the billing or shipping address. */
  country_code: Scalars["String"]["input"];
  /** The custom attribute values of the billing or shipping address. */
  custom_attributes: InputMaybe<Array<InputMaybe<IAttributeValueInput>>>;
  /** District */
  district: InputMaybe<Scalars["String"]["input"]>;
  /** The customer's fax number. */
  fax: InputMaybe<Scalars["String"]["input"]>;
  /** The first name of the customer or guest. */
  firstname: InputMaybe<Scalars["String"]["input"]>;
  /** Apartment, floor, building, etc. */
  house_details: InputMaybe<Scalars["String"]["input"]>;
  /** States if the selected address is a pickup address */
  is_pickup_address: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Landmark */
  landmark: InputMaybe<Scalars["String"]["input"]>;
  /** The last name of the customer or guest. */
  lastname: Scalars["String"]["input"];
  /** The middle name of the person associated with the billing/shipping address. */
  middlename: InputMaybe<Scalars["String"]["input"]>;
  /** Neighborhood */
  neighborhood: InputMaybe<Scalars["String"]["input"]>;
  /** JSON encoded string of required fields like store id etc for the pickup point */
  pickup_information: InputMaybe<Scalars["String"]["input"]>;
  /** The ZIP or postal code of the billing or shipping address. */
  postcode: InputMaybe<Scalars["String"]["input"]>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix: InputMaybe<Scalars["String"]["input"]>;
  /** Premise */
  premise: InputMaybe<Scalars["String"]["input"]>;
  /** A string that defines the state or province of the billing or shipping address. */
  region: InputMaybe<Scalars["String"]["input"]>;
  /** Two-letter region code (e.g., 'CA' for California). When provided, the region_id will be automatically resolved. */
  region_code: InputMaybe<Scalars["String"]["input"]>;
  /** An integer that defines the state or province of the billing or shipping address. */
  region_id: InputMaybe<Scalars["Int"]["input"]>;
  /** Determines whether to save the address in the customer's address book. The default value is true. */
  save_in_address_book: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Short National Address */
  short_address: InputMaybe<Scalars["String"]["input"]>;
  /** An array containing the street for the billing or shipping address. */
  street: Array<InputMaybe<Scalars["String"]["input"]>>;
  /** Street number */
  street_nr: InputMaybe<Scalars["String"]["input"]>;
  /** Sublocality level 2 */
  sublocality_level_2: InputMaybe<Scalars["String"]["input"]>;
  /** A value such as Sr., Jr., or III. */
  suffix: InputMaybe<Scalars["String"]["input"]>;
  /** The telephone number for the billing or shipping address. */
  telephone: InputMaybe<Scalars["String"]["input"]>;
  /** The VAT company number for billing or shipping address. */
  vat_id: InputMaybe<Scalars["String"]["input"]>;
};

export type ICartAddressInterface = {
  /** Administrative area level 2 */
  administrative_area_level_2: Maybe<Scalars["String"]["output"]>;
  /** Building Number */
  building_number: Maybe<Scalars["String"]["output"]>;
  /** The city specified for the billing or shipping address. */
  city: Scalars["String"]["output"];
  /** The company specified for the billing or shipping address. */
  company: Maybe<Scalars["String"]["output"]>;
  /** An object containing the country label and code. */
  country: ICartAddressCountry;
  /** The custom attribute values of the billing or shipping address. */
  custom_attributes: Array<Maybe<IAttributeValueInterface>>;
  /** District */
  district: Maybe<Scalars["String"]["output"]>;
  /** The customer's fax number. */
  fax: Maybe<Scalars["String"]["output"]>;
  /** The first name of the customer or guest. */
  firstname: Maybe<Scalars["String"]["output"]>;
  /** Apartment, floor, building, etc. */
  house_details: Maybe<Scalars["String"]["output"]>;
  /** Id of the customer address. */
  id: Maybe<Scalars["Int"]["output"]>;
  /** Landmark */
  landmark: Maybe<Scalars["String"]["output"]>;
  /** The last name of the customer or guest. */
  lastname: Scalars["String"]["output"];
  /** The middle name of the person associated with the billing/shipping address. */
  middlename: Maybe<Scalars["String"]["output"]>;
  /** Neighborhood */
  neighborhood: Maybe<Scalars["String"]["output"]>;
  /** The ZIP or postal code of the billing or shipping address. */
  postcode: Maybe<Scalars["String"]["output"]>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix: Maybe<Scalars["String"]["output"]>;
  /** Premise */
  premise: Maybe<Scalars["String"]["output"]>;
  /** An object containing the region label and code. */
  region: Maybe<ICartAddressRegion>;
  /** Short National Address */
  short_address: Maybe<Scalars["String"]["output"]>;
  /** An array containing the street for the billing or shipping address. */
  street: Array<Maybe<Scalars["String"]["output"]>>;
  /** Street number */
  street_nr: Maybe<Scalars["String"]["output"]>;
  /** Sublocality level 2 */
  sublocality_level_2: Maybe<Scalars["String"]["output"]>;
  /** A value such as Sr., Jr., or III. */
  suffix: Maybe<Scalars["String"]["output"]>;
  /** The telephone number for the billing or shipping address. */
  telephone: Maybe<Scalars["String"]["output"]>;
  /** The unique id of the customer address. */
  uid: Scalars["String"]["output"];
  /** The VAT company number for billing or shipping address. */
  vat_id: Maybe<Scalars["String"]["output"]>;
};

/** Contains details about the region in a billing or shipping address. */
export type ICartAddressRegion = {
  /** The state or province code. */
  code: Maybe<Scalars["String"]["output"]>;
  /** The display label for the region. */
  label: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a pre-defined region. */
  region_id: Maybe<Scalars["Int"]["output"]>;
};

/** Contains information about discounts applied to the cart. */
export type ICartDiscount = {
  /** The amount of the discount applied to the item. */
  amount: IMoney;
  /** The description of the discount. */
  label: Array<Maybe<Scalars["String"]["output"]>>;
};

export enum ICartDiscountType {
  Item = "ITEM",
  Shipping = "SHIPPING",
}

export type ICartItemError = {
  /** An error code that describes the error encountered */
  code: ICartItemErrorType;
  /** A localized error message */
  message: Scalars["String"]["output"];
};

export enum ICartItemErrorType {
  CartonsLimit = "CARTONS_LIMIT",
  FreegiftsNoSuchChild = "FREEGIFTS_NO_SUCH_CHILD",
  FreegiftsNoSuchParent = "FREEGIFTS_NO_SUCH_PARENT",
  FreegiftsQtyError = "FREEGIFTS_QTY_ERROR",
  FreegiftsUnavailable = "FREEGIFTS_UNAVAILABLE",
  ItemIncrement = "ITEM_INCREMENT",
  ItemIncrements = "ITEM_INCREMENTS",
  ItemQty = "ITEM_QTY",
  LifetimePurchaseRestricted = "LIFETIME_PURCHASE_RESTRICTED",
  OngoingSubscription = "ONGOING_SUBSCRIPTION",
  OrderPurchaseRestricted = "ORDER_PURCHASE_RESTRICTED",
  ProductDiscontinued = "PRODUCT_DISCONTINUED",
  ProductRegionMismatch = "PRODUCT_REGION_MISMATCH",
  SalesruleGiftNotValid = "SALESRULE_GIFT_NOT_VALID",
  TradeinLimit = "TRADEIN_LIMIT",
  Undefined = "UNDEFINED",
}

/** Defines an item to be added to the cart. */
export type ICartItemInput = {
  /** An array of entered options for the base product, such as personalization text. */
  entered_options: InputMaybe<Array<InputMaybe<IEnteredOptionInput>>>;
  /** For a child product, the SKU of its parent product. */
  parent_sku: InputMaybe<Scalars["String"]["input"]>;
  /** The amount or number of an item to add. */
  quantity: Scalars["Float"]["input"];
  /** The selected options for the base product, such as color or size, using the unique ID for an object such as `CustomizableRadioOption`, `CustomizableDropDownOption`, or `ConfigurableProductOptionsValues`. */
  selected_options: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  /** The SKU of the product. */
  sku: Scalars["String"]["input"];
};

/** An interface for products in a cart. */
export type ICartItemInterface = {
  /** An array of errors encountered while loading the cart item */
  errors: Maybe<Array<Maybe<ICartItemError>>>;
  /** Provides info regarding the gift added to the basket */
  gift_data: Maybe<IGiftData>;
  /** Provides the flag to show if consent was set or not */
  has_registration_consent: Maybe<Scalars["Boolean"]["output"]>;
  /** @deprecated Use `uid` instead. */
  id: Scalars["String"]["output"];
  /** True if requested quantity is less than available stock, false otherwise. */
  is_available: Scalars["Boolean"]["output"];
  /** Message to display when the product is not available with this selected option. */
  not_available_message: Maybe<Scalars["String"]["output"]>;
  /** Contains details about the price of the item, including taxes and discounts. */
  prices: Maybe<ICartItemPrices>;
  /** Details about an item in the cart. */
  product: IProductInterface;
  /** The quantity of this item in the cart. */
  quantity: Scalars["Float"]["output"];
  /** The unique ID for a `CartItemInterface` object. */
  uid: Scalars["ID"]["output"];
};

/** Contains details about the price of the item, including taxes and discounts. */
export type ICartItemPrices = {
  /** The price discount for the unit price of the item represents the difference between its regular price and final price. */
  catalog_discount: Maybe<IProductDiscount>;
  /** An array of discounts to be applied to the cart item. */
  discounts: Maybe<Array<Maybe<IDiscount>>>;
  /** An array of FPTs applied to the cart item. */
  fixed_product_taxes: Maybe<Array<Maybe<IFixedProductTax>>>;
  /** The value of the original unit price for the item, including discounts. */
  original_item_price: IMoney;
  /** The value of the original price multiplied by the quantity of the item. */
  original_row_total: IMoney;
  /** The price of the item before any discounts were applied. The price that might include tax, depending on the configured display settings for cart. */
  price: IMoney;
  /** The price of the item before any discounts were applied. The price that might include tax, depending on the configured display settings for cart. */
  price_including_tax: IMoney;
  /** The price discount multiplied by the item quantity represents the total difference between the regular price and the final price for the entire quote item. */
  row_catalog_discount: Maybe<IProductDiscount>;
  /** The value of the price multiplied by the quantity of the item. */
  row_total: IMoney;
  /** The value of `row_total` plus the tax applied to the item. */
  row_total_including_tax: IMoney;
  /** The total of all discounts applied to the item. */
  total_item_discount: Maybe<IMoney>;
};

/** Deprecated: The `ShippingCartAddress.cart_items` field now returns `CartItemInterface`. */
export type ICartItemQuantity = {
  /** @deprecated The `ShippingCartAddress.cart_items` field now returns `CartItemInterface`. */
  cart_item_id: Scalars["Int"]["output"];
  /** @deprecated The `ShippingCartAddress.cart_items` field now returns `CartItemInterface`. */
  quantity: Scalars["Float"]["output"];
};

/** Contains details about the price of a selected customizable value. */
export type ICartItemSelectedOptionValuePrice = {
  /** Indicates whether the price type is fixed, percent, or dynamic. */
  type: IPriceTypeEnum;
  /** A string that describes the unit of the value. */
  units: Scalars["String"]["output"];
  /** A price value. */
  value: Scalars["Float"]["output"];
};

/** A single item to be updated. */
export type ICartItemUpdateInput = {
  /** Deprecated. Use `cart_item_uid` instead. */
  cart_item_id: InputMaybe<Scalars["Int"]["input"]>;
  /** The unique ID for a `CartItemInterface` object. */
  cart_item_uid: InputMaybe<Scalars["ID"]["input"]>;
  /** An array that defines customizable options for the product. */
  customizable_options: InputMaybe<Array<InputMaybe<ICustomizableOptionInput>>>;
  /** Gift message details for the cart item */
  gift_message: InputMaybe<IGiftMessageInput>;
  /** The unique ID for a `GiftWrapping` object to be used for the cart item. */
  gift_wrapping_id: InputMaybe<Scalars["ID"]["input"]>;
  /** The new quantity of the item. */
  quantity: InputMaybe<Scalars["Float"]["input"]>;
};

export type ICartItems = {
  /** An array of products that have been added to the cart. */
  items: Array<Maybe<ICartItemInterface>>;
  /** Metadata for pagination rendering. */
  page_info: Maybe<ISearchResultPageInfo>;
  /** The number of returned cart items. */
  total_count: Scalars["Int"]["output"];
};

export enum ICartPerformanceErrorType {
  /** Cart has not been modified (HTTP 304 equivalent) */
  CartNotModified = "CART_NOT_MODIFIED",
}

/** Contains details about the final price of items in the cart, including discount and tax information. */
export type ICartPrices = {
  /** An array containing the names and amounts of taxes applied to each item in the cart. */
  applied_taxes: Maybe<Array<Maybe<ICartTaxItem>>>;
  /** @deprecated Use discounts instead. */
  discount: Maybe<ICartDiscount>;
  /** An array containing cart rule discounts, store credit and gift cards applied to the cart. */
  discounts: Maybe<Array<Maybe<IDiscount>>>;
  /** The list of prices for the selected gift options. */
  gift_options: Maybe<IGiftOptionsPrices>;
  /** The total, including discounts, taxes, shipping, and other fees. */
  grand_total: Maybe<IMoney>;
  /** The total of the cart, including discounts, shipping, and other fees without tax. */
  grand_total_excluding_tax: Maybe<IMoney>;
  /** The subtotal without any applied taxes. */
  subtotal_excluding_tax: Maybe<IMoney>;
  /** The subtotal including any applied taxes. */
  subtotal_including_tax: Maybe<IMoney>;
  /** The subtotal with any discounts applied, but not taxes. */
  subtotal_with_discount_excluding_tax: Maybe<IMoney>;
};

/** Contains tax information about an item in the cart. */
export type ICartTaxItem = {
  /** The amount of tax applied to the item. */
  amount: IMoney;
  /** The description of the tax. */
  label: Scalars["String"]["output"];
  /** The tax rate percentage. */
  rate: Maybe<Scalars["Float"]["output"]>;
};

export type ICartUserInputError = IError & {
  /** A cart-specific error code. */
  code: ICartUserInputErrorType;
  /** A localized error message. */
  message: Scalars["String"]["output"];
};

export enum ICartUserInputErrorType {
  CouldNotFindCartItem = "COULD_NOT_FIND_CART_ITEM",
  /** 2.4.6 adaptation to errors being thrown in graphql */
  GiftError = "GIFT_ERROR",
  InsufficientStock = "INSUFFICIENT_STOCK",
  InvalidParameterValue = "INVALID_PARAMETER_VALUE",
  LifetimePurchaseRestricted = "LIFETIME_PURCHASE_RESTRICTED",
  NotSalable = "NOT_SALABLE",
  OrderPurchaseRestricted = "ORDER_PURCHASE_RESTRICTED",
  PermissionDenied = "PERMISSION_DENIED",
  ProductDiscontinued = "PRODUCT_DISCONTINUED",
  ProductNotFound = "PRODUCT_NOT_FOUND",
  RequiredParameterMissing = "REQUIRED_PARAMETER_MISSING",
  Undefined = "UNDEFINED",
}

export enum ICatalogAttributeApplyToEnum {
  Bundle = "BUNDLE",
  Category = "CATEGORY",
  Configurable = "CONFIGURABLE",
  Downloadable = "DOWNLOADABLE",
  Grouped = "GROUPED",
  Simple = "SIMPLE",
  Virtual = "VIRTUAL",
}

/** Swatch attribute metadata. */
export type ICatalogAttributeMetadata = ICustomAttributeMetadataInterface & {
  /** To which catalog types an attribute can be applied. */
  apply_to: Maybe<Array<Maybe<ICatalogAttributeApplyToEnum>>>;
  /** The unique identifier for an attribute code. This value should be in lowercase letters without spaces. */
  code: Scalars["ID"]["output"];
  /** Default attribute value. */
  default_value: Maybe<Scalars["String"]["output"]>;
  /** The type of entity that defines the attribute. */
  entity_type: IAttributeEntityTypeEnum;
  /** The frontend class of the attribute. */
  frontend_class: Maybe<Scalars["String"]["output"]>;
  /** The frontend input type of the attribute. */
  frontend_input: Maybe<IAttributeFrontendInputEnum>;
  /** Whether a product or category attribute can be compared against another or not. */
  is_comparable: Maybe<Scalars["Boolean"]["output"]>;
  /** Whether a product or category attribute can be filtered or not. */
  is_filterable: Maybe<Scalars["Boolean"]["output"]>;
  /** Whether a product or category attribute can be filtered in search or not. */
  is_filterable_in_search: Maybe<Scalars["Boolean"]["output"]>;
  /** Whether a product or category attribute can use HTML on front or not. */
  is_html_allowed_on_front: Maybe<Scalars["Boolean"]["output"]>;
  /** Whether the attribute value is required. */
  is_required: Scalars["Boolean"]["output"];
  /** Whether a product or category attribute can be searched or not. */
  is_searchable: Maybe<Scalars["Boolean"]["output"]>;
  /** Whether the attribute value must be unique. */
  is_unique: Scalars["Boolean"]["output"];
  /** Whether a product or category attribute can be used for price rules or not. */
  is_used_for_price_rules: Maybe<Scalars["Boolean"]["output"]>;
  /** Whether a product or category attribute is used for promo rules or not. */
  is_used_for_promo_rules: Maybe<Scalars["Boolean"]["output"]>;
  /** Whether a product or category attribute is visible in advanced search or not. */
  is_visible_in_advanced_search: Maybe<Scalars["Boolean"]["output"]>;
  /** Whether a product or category attribute is visible on front or not. */
  is_visible_on_front: Maybe<Scalars["Boolean"]["output"]>;
  /** Whether a product or category attribute has WYSIWYG enabled or not. */
  is_wysiwyg_enabled: Maybe<Scalars["Boolean"]["output"]>;
  /** The label assigned to the attribute. */
  label: Maybe<Scalars["String"]["output"]>;
  /** Attribute options. */
  options: Array<Maybe<ICustomAttributeOptionInterface>>;
  /** Input type of the swatch attribute option. */
  swatch_input_type: Maybe<ISwatchInputTypeEnum>;
  /** Whether update product preview image or not. */
  update_product_preview_image: Maybe<Scalars["Boolean"]["output"]>;
  /** Whether use product image for swatch or not. */
  use_product_image_for_swatch: Maybe<Scalars["Boolean"]["output"]>;
  /** Whether a product or category attribute is used in product listing or not. */
  used_in_product_listing: Maybe<Scalars["Boolean"]["output"]>;
};

/** Defines the filters to be used in the search. A filter contains at least one attribute, a comparison operator, and the value that is being searched for. */
export type ICategoryFilterInput = {
  /** Filter by the unique category ID for a `CategoryInterface` object. */
  category_uid: InputMaybe<IFilterEqualTypeInput>;
  /** Deprecated: use 'category_uid' to filter uniquely identifiers of categories. */
  ids: InputMaybe<IFilterEqualTypeInput>;
  /** Filter by the display name of the category. */
  name: InputMaybe<IFilterMatchTypeInput>;
  /** Filter by the unique parent category ID for a `CategoryInterface` object. */
  parent_category_uid: InputMaybe<IFilterEqualTypeInput>;
  /** Filter by the unique parent category ID for a `CategoryInterface` object. */
  parent_id: InputMaybe<IFilterEqualTypeInput>;
  /** Filter by the part of the URL that identifies the category. */
  url_key: InputMaybe<IFilterEqualTypeInput>;
  /** Filter by the URL path for the category. */
  url_path: InputMaybe<IFilterEqualTypeInput>;
};

/** Contains the full set of attributes that can be returned in a category search. */
export type ICategoryInterface = {
  automatic_sorting: Maybe<Scalars["String"]["output"]>;
  available_sort_by: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  /** An array of breadcrumb items. */
  breadcrumbs: Maybe<Array<Maybe<IBreadcrumb>>>;
  /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Categories' is enabled. */
  canonical_url: Maybe<Scalars["String"]["output"]>;
  children_count: Maybe<Scalars["String"]["output"]>;
  /** Contains a category CMS block. */
  cms_block: Maybe<ICmsBlock>;
  /**
   * The timestamp indicating when the category was created.
   * @deprecated The field should not be used on the storefront.
   */
  created_at: Maybe<Scalars["String"]["output"]>;
  custom_layout_update_file: Maybe<Scalars["String"]["output"]>;
  /** The attribute to use for sorting. */
  default_sort_by: Maybe<Scalars["String"]["output"]>;
  /** An optional description of the category. */
  description: Maybe<Scalars["String"]["output"]>;
  display_mode: Maybe<Scalars["String"]["output"]>;
  filter_price_range: Maybe<Scalars["Float"]["output"]>;
  /**
   * An ID that uniquely identifies the category.
   * @deprecated Use `uid` instead.
   */
  id: Maybe<Scalars["Int"]["output"]>;
  image: Maybe<Scalars["String"]["output"]>;
  include_in_menu: Maybe<Scalars["Int"]["output"]>;
  is_anchor: Maybe<Scalars["Int"]["output"]>;
  jti_new_badge_enabled: Maybe<Scalars["Int"]["output"]>;
  jti_new_badge_label: Maybe<Scalars["String"]["output"]>;
  landing_page: Maybe<Scalars["Int"]["output"]>;
  /** The depth of the category within the tree. */
  level: Maybe<Scalars["Int"]["output"]>;
  meta_description: Maybe<Scalars["String"]["output"]>;
  meta_keywords: Maybe<Scalars["String"]["output"]>;
  meta_title: Maybe<Scalars["String"]["output"]>;
  /** The display name of the category. */
  name: Maybe<Scalars["String"]["output"]>;
  /** The full category path. */
  path: Maybe<Scalars["String"]["output"]>;
  /** The category path within the store. */
  path_in_store: Maybe<Scalars["String"]["output"]>;
  /** The position of the category relative to other categories at the same level in tree. */
  position: Maybe<Scalars["Int"]["output"]>;
  /** The number of products in the category that are marked as visible. By default, in complex products, parent products are visible, but their child products are not. */
  product_count: Maybe<Scalars["Int"]["output"]>;
  /** The list of products assigned to the category. */
  products: Maybe<ICategoryProducts>;
  /** Indicates whether the category is staged for a future campaign. */
  staged: Scalars["Boolean"]["output"];
  /** Store Locator Name. */
  store_locator_name: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `CategoryInterface` object. */
  uid: Scalars["ID"]["output"];
  /**
   * The timestamp indicating when the category was updated.
   * @deprecated The field should not be used on the storefront.
   */
  updated_at: Maybe<Scalars["String"]["output"]>;
  /** The URL key assigned to the category. */
  url_key: Maybe<Scalars["String"]["output"]>;
  /** The URL path assigned to the category. */
  url_path: Maybe<Scalars["String"]["output"]>;
  /** The part of the category URL that is appended after the url key */
  url_suffix: Maybe<Scalars["String"]["output"]>;
};

/** Contains the full set of attributes that can be returned in a category search. */
export type ICategoryInterfaceProductsArgs = {
  currentPage?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  sort: InputMaybe<IProductAttributeSortInput>;
};

/** Contains details about the products assigned to a category. */
export type ICategoryProducts = {
  /** An array of products that are assigned to the category. */
  items: Maybe<Array<Maybe<IProductInterface>>>;
  /** Pagination metadata. */
  page_info: Maybe<ISearchResultPageInfo>;
  /** The number of products in the category that are marked as visible. By default, in complex products, parent products are visible, but their child products are not. */
  total_count: Maybe<Scalars["Int"]["output"]>;
};

/** Contains a collection of `CategoryTree` objects and pagination information. */
export type ICategoryResult = {
  /** A list of categories that match the filter criteria. */
  items: Maybe<Array<Maybe<ICategoryTree>>>;
  /** An object that includes the `page_info` and `currentPage` values specified in the query. */
  page_info: Maybe<ISearchResultPageInfo>;
  /** The total number of categories that match the criteria. */
  total_count: Maybe<Scalars["Int"]["output"]>;
};

/** Contains the hierarchy of categories. */
export type ICategoryTree = ICategoryInterface &
  IRoutableInterface & {
    automatic_sorting: Maybe<Scalars["String"]["output"]>;
    available_sort_by: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    /** An array of breadcrumb items. */
    breadcrumbs: Maybe<Array<Maybe<IBreadcrumb>>>;
    /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Categories' is enabled. */
    canonical_url: Maybe<Scalars["String"]["output"]>;
    /** A tree of child categories. */
    children: Maybe<Array<Maybe<ICategoryTree>>>;
    children_count: Maybe<Scalars["String"]["output"]>;
    /** Contains a category CMS block. */
    cms_block: Maybe<ICmsBlock>;
    /**
     * The timestamp indicating when the category was created.
     * @deprecated The field should not be used on the storefront.
     */
    created_at: Maybe<Scalars["String"]["output"]>;
    custom_layout_update_file: Maybe<Scalars["String"]["output"]>;
    /** The attribute to use for sorting. */
    default_sort_by: Maybe<Scalars["String"]["output"]>;
    /** An optional description of the category. */
    description: Maybe<Scalars["String"]["output"]>;
    display_mode: Maybe<Scalars["String"]["output"]>;
    filter_price_range: Maybe<Scalars["Float"]["output"]>;
    /**
     * An ID that uniquely identifies the category.
     * @deprecated Use `uid` instead.
     */
    id: Maybe<Scalars["Int"]["output"]>;
    image: Maybe<Scalars["String"]["output"]>;
    include_in_menu: Maybe<Scalars["Int"]["output"]>;
    is_anchor: Maybe<Scalars["Int"]["output"]>;
    jti_new_badge_enabled: Maybe<Scalars["Int"]["output"]>;
    jti_new_badge_label: Maybe<Scalars["String"]["output"]>;
    landing_page: Maybe<Scalars["Int"]["output"]>;
    /** The depth of the category within the tree. */
    level: Maybe<Scalars["Int"]["output"]>;
    meta_description: Maybe<Scalars["String"]["output"]>;
    meta_keywords: Maybe<Scalars["String"]["output"]>;
    meta_title: Maybe<Scalars["String"]["output"]>;
    /** The display name of the category. */
    name: Maybe<Scalars["String"]["output"]>;
    /** The full category path. */
    path: Maybe<Scalars["String"]["output"]>;
    /** The category path within the store. */
    path_in_store: Maybe<Scalars["String"]["output"]>;
    /** The position of the category relative to other categories at the same level in tree. */
    position: Maybe<Scalars["Int"]["output"]>;
    /** The number of products in the category that are marked as visible. By default, in complex products, parent products are visible, but their child products are not. */
    product_count: Maybe<Scalars["Int"]["output"]>;
    /** The list of products assigned to the category. */
    products: Maybe<ICategoryProducts>;
    /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
    redirect_code: Scalars["Int"]["output"];
    /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
    relative_url: Maybe<Scalars["String"]["output"]>;
    /** Indicates whether the category is staged for a future campaign. */
    staged: Scalars["Boolean"]["output"];
    /** Store Locator Name. */
    store_locator_name: Maybe<Scalars["String"]["output"]>;
    /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
    type: Maybe<IUrlRewriteEntityTypeEnum>;
    /** The unique ID for a `CategoryInterface` object. */
    uid: Scalars["ID"]["output"];
    /**
     * The timestamp indicating when the category was updated.
     * @deprecated The field should not be used on the storefront.
     */
    updated_at: Maybe<Scalars["String"]["output"]>;
    /** The URL key assigned to the category. */
    url_key: Maybe<Scalars["String"]["output"]>;
    /** The URL path assigned to the category. */
    url_path: Maybe<Scalars["String"]["output"]>;
    /** The part of the category URL that is appended after the url key */
    url_suffix: Maybe<Scalars["String"]["output"]>;
  };

/** Contains the hierarchy of categories. */
export type ICategoryTreeProductsArgs = {
  currentPage?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  sort: InputMaybe<IProductAttributeSortInput>;
};

/** Defines details about an individual checkout agreement. */
export type ICheckoutAgreement = {
  /** The ID for a checkout agreement. */
  agreement_id: Scalars["Int"]["output"];
  /** The checkbox text for the checkout agreement. */
  checkbox_text: Scalars["String"]["output"];
  /** Required. The text of the agreement. */
  content: Scalars["String"]["output"];
  /** The height of the text box where the Terms and Conditions statement appears during checkout. */
  content_height: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether the `content` text is in HTML format. */
  is_html: Scalars["Boolean"]["output"];
  /** Indicates whether agreements are accepted automatically or manually. */
  mode: ICheckoutAgreementMode;
  /** The name given to the condition. */
  name: Scalars["String"]["output"];
};

/** Indicates how agreements are accepted. */
export enum ICheckoutAgreementMode {
  /** Conditions are automatically accepted upon checkout. */
  Auto = "AUTO",
  /** Shoppers must manually accept the conditions to place an order. */
  Manual = "MANUAL",
}

/** An error encountered while adding an item to the cart. */
export type ICheckoutUserInputError = {
  /** An error code that is specific to Checkout. */
  code: ICheckoutUserInputErrorCodes;
  /** A localized error message. */
  message: Scalars["String"]["output"];
  /** The path to the input field that caused an error. See the GraphQL specification about path errors for details: http://spec.graphql.org/draft/#sec-Errors */
  path: Array<Maybe<Scalars["String"]["output"]>>;
};

export enum ICheckoutUserInputErrorCodes {
  InsufficientStock = "INSUFFICIENT_STOCK",
  NotSalable = "NOT_SALABLE",
  ProductNotFound = "PRODUCT_NOT_FOUND",
  ReorderNotAvailable = "REORDER_NOT_AVAILABLE",
  Undefined = "UNDEFINED",
}

/** Contains details about errors encountered when a customer clear cart. */
export type IClearCartError = {
  /** A localized error message */
  message: Scalars["String"]["output"];
  /** A cart-specific error type. */
  type: IClearCartErrorType;
};

export enum IClearCartErrorType {
  Inactive = "INACTIVE",
  NotFound = "NOT_FOUND",
  Unauthorised = "UNAUTHORISED",
  Undefined = "UNDEFINED",
}

/** Assigns a specific `cart_id` to the empty cart. */
export type IClearCartInput = {
  /** The unique ID of a `Cart` object. */
  uid: Scalars["ID"]["input"];
};

/** Output of the request to clear the customer cart. */
export type IClearCartOutput = {
  /** The cart after clear cart items. */
  cart: Maybe<ICart>;
  /** An array of errors encountered while clearing the cart item */
  errors: Maybe<Array<Maybe<IClearCartError>>>;
};

/** Contains details about a specific CMS block. */
export type ICmsBlock = {
  /** The content of the CMS block in raw HTML. */
  content: Maybe<Scalars["String"]["output"]>;
  /** The CMS block identifier. */
  identifier: Maybe<Scalars["String"]["output"]>;
  /** The title assigned to the CMS block. */
  title: Maybe<Scalars["String"]["output"]>;
};

/** Contains an array CMS block items. */
export type ICmsBlocks = {
  /** An array of CMS blocks. */
  items: Maybe<Array<Maybe<ICmsBlock>>>;
};

/** Contains details about a CMS page. */
export type ICmsPage = IRoutableInterface & {
  /** The content of the CMS page in raw HTML. */
  content: Maybe<Scalars["String"]["output"]>;
  /** The heading that displays at the top of the CMS page. */
  content_heading: Maybe<Scalars["String"]["output"]>;
  /** The ID of a CMS page. */
  identifier: Maybe<Scalars["String"]["output"]>;
  /** A brief description of the page for search results listings. */
  meta_description: Maybe<Scalars["String"]["output"]>;
  /** A brief description of the page for search results listings. */
  meta_keywords: Maybe<Scalars["String"]["output"]>;
  /** A page title that is indexed by search engines and appears in search results listings. */
  meta_title: Maybe<Scalars["String"]["output"]>;
  /** The design layout of the page, indicating the number of columns and navigation features used on the page. */
  page_layout: Maybe<Scalars["String"]["output"]>;
  /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
  redirect_code: Scalars["Int"]["output"];
  /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
  relative_url: Maybe<Scalars["String"]["output"]>;
  /** The name that appears in the breadcrumb trail navigation and in the browser title bar and tab. */
  title: Maybe<Scalars["String"]["output"]>;
  /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
  type: Maybe<IUrlRewriteEntityTypeEnum>;
  /** The URL key of the CMS page, which is often based on the `content_heading`. */
  url_key: Maybe<Scalars["String"]["output"]>;
};

export type IColorSwatchData = ISwatchDataInterface & {
  /** The value can be represented as color (HEX code), image link, or text. */
  value: Maybe<Scalars["String"]["output"]>;
};

/** Contains an attribute code that is used for product comparisons. */
export type IComparableAttribute = {
  /** An attribute code that is enabled for product comparisons. */
  code: Scalars["String"]["output"];
  /** The label of the attribute code. */
  label: Scalars["String"]["output"];
};

/** Defines an object used to iterate through items for product comparisons. */
export type IComparableItem = {
  /** An array of product attributes that can be used to compare products. */
  attributes: Array<Maybe<IProductAttribute>>;
  /** Details about a product in a compare list. */
  product: IProductInterface;
  /** The unique ID of an item in a compare list. */
  uid: Scalars["ID"]["output"];
};

/** Contains iterable information such as the array of items, the count, and attributes that represent the compare list. */
export type ICompareList = {
  /** An array of attributes that can be used for comparing products. */
  attributes: Maybe<Array<Maybe<IComparableAttribute>>>;
  /** The number of items in the compare list. */
  item_count: Scalars["Int"]["output"];
  /** An array of products to compare. */
  items: Maybe<Array<Maybe<IComparableItem>>>;
  /** The unique ID assigned to the compare list. */
  uid: Scalars["ID"]["output"];
};

/** Update the quote and complete the order */
export type ICompleteOrderInput = {
  /** The customer cart ID */
  cartId: Scalars["String"]["input"];
  /** PayPal order ID */
  id: Scalars["String"]["input"];
};

export type IComplexTextValue = {
  /** Text that can contain HTML tags. */
  html: Scalars["String"]["output"];
};

/** Contains details about a configurable product attribute option. */
export type IConfigurableAttributeOption = {
  /** The ID assigned to the attribute. */
  code: Maybe<Scalars["String"]["output"]>;
  /** A string that describes the configurable attribute option. */
  label: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `ConfigurableAttributeOption` object. */
  uid: Scalars["ID"]["output"];
  /** A unique index number assigned to the configurable product option. */
  value_index: Maybe<Scalars["Int"]["output"]>;
};

/** An implementation for configurable product cart items. */
export type IConfigurableCartItem = ICartItemInterface & {
  /** The list of available gift wrapping options for the cart item. */
  available_gift_wrapping: Array<Maybe<IGiftWrapping>>;
  /** An array containing the configuranle options the shopper selected. */
  configurable_options: Array<Maybe<ISelectedConfigurableOption>>;
  /** Product details of the cart item. */
  configured_variant: IProductInterface;
  /** An array containing the customizable options the shopper selected. */
  customizable_options: Array<Maybe<ISelectedCustomizableOption>>;
  /** An array of errors encountered while loading the cart item */
  errors: Maybe<Array<Maybe<ICartItemError>>>;
  /** Provides info regarding the gift added to the basket */
  gift_data: Maybe<IGiftData>;
  /** The entered gift message for the cart item */
  gift_message: Maybe<IGiftMessage>;
  /** The selected gift wrapping for the cart item. */
  gift_wrapping: Maybe<IGiftWrapping>;
  /** Provides the flag to show if consent was set or not */
  has_registration_consent: Maybe<Scalars["Boolean"]["output"]>;
  /** @deprecated Use `uid` instead. */
  id: Scalars["String"]["output"];
  /** True if requested quantity is less than available stock, false otherwise. */
  is_available: Scalars["Boolean"]["output"];
  /** Message to display when the product is not available with this selected option. */
  not_available_message: Maybe<Scalars["String"]["output"]>;
  /** Contains details about the price of the item, including taxes and discounts. */
  prices: Maybe<ICartItemPrices>;
  /** Details about an item in the cart. */
  product: IProductInterface;
  /** The quantity of this item in the cart. */
  quantity: Scalars["Float"]["output"];
  /** The unique ID for a `CartItemInterface` object. */
  uid: Scalars["ID"]["output"];
};

/** Describes configurable options that have been selected and can be selected as a result of the previous selections. */
export type IConfigurableOptionAvailableForSelection = {
  /** An attribute code that uniquely identifies a configurable option. */
  attribute_code: Scalars["String"]["output"];
  /** An array of selectable option value IDs. */
  option_value_uids: Array<Maybe<Scalars["ID"]["output"]>>;
};

export type IConfigurableOrderItem = IOrderItemInterface & {
  /** The final discount information for the product. */
  discounts: Maybe<Array<Maybe<IDiscount>>>;
  /** Indicates whether the order item is eligible to be in a return request. */
  eligible_for_return: Maybe<Scalars["Boolean"]["output"]>;
  /** The entered option for the base product, such as a logo or image. */
  entered_options: Maybe<Array<Maybe<IOrderItemOption>>>;
  /** Provides info regarding the gift added to the basket */
  gift_data: Maybe<IGiftData>;
  /** The selected gift message for the order item */
  gift_message: Maybe<IGiftMessage>;
  /** The selected gift wrapping for the order item. */
  gift_wrapping: Maybe<IGiftWrapping>;
  /** Provides the flag to show if consent was set or not */
  has_registration_consent: Maybe<Scalars["Boolean"]["output"]>;
  /** The unique ID for an `OrderItemInterface` object. */
  id: Scalars["ID"]["output"];
  /** The original product price of the base product. */
  original_price: IMoney;
  /** The SKU of parent product. */
  parent_sku: Maybe<Scalars["String"]["output"]>;
  /** Contains details about the price of the item, including taxes and discounts. */
  prices: Maybe<IOrderItemPrices>;
  /** The ProductInterface object, which contains details about the base product */
  product: Maybe<IProductInterface>;
  /** The name of the base product. */
  product_name: Maybe<Scalars["String"]["output"]>;
  /** The sale price of the base product, including selected options. */
  product_sale_price: IMoney;
  /** The sale price of the base product, including tax. */
  product_sale_price_incl_tax: IMoney;
  /** The SKU of the base product. */
  product_sku: Scalars["String"]["output"];
  /** Indicates whether this product has subscription flag. */
  product_subscription: Maybe<Scalars["Boolean"]["output"]>;
  /** The type of product, such as simple, configurable, etc. */
  product_type: Maybe<Scalars["String"]["output"]>;
  /** URL key of the base product. */
  product_url_key: Maybe<Scalars["String"]["output"]>;
  /** The number of canceled items. */
  quantity_canceled: Maybe<Scalars["Float"]["output"]>;
  /** The number of invoiced items. */
  quantity_invoiced: Maybe<Scalars["Float"]["output"]>;
  /** The number of units ordered for this item. */
  quantity_ordered: Maybe<Scalars["Float"]["output"]>;
  /** The number of refunded items. */
  quantity_refunded: Maybe<Scalars["Float"]["output"]>;
  /** The requested return quantity of the item. */
  quantity_return_requested: Maybe<Scalars["Float"]["output"]>;
  /** The number of returned items. */
  quantity_returned: Maybe<Scalars["Float"]["output"]>;
  /** The number of shipped items. */
  quantity_shipped: Maybe<Scalars["Float"]["output"]>;
  /** Row total for product. */
  row_total: IMoney;
  /** Row total for product including tax. */
  row_total_incl_tax: IMoney;
  /** The selected options for the base product, such as color or size. */
  selected_options: Maybe<Array<Maybe<IOrderItemOption>>>;
  /** The status of the order item. */
  status: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether the product is eligible for a trade-in purchase. */
  trade_in: Scalars["Int"]["output"];
};

/** Defines basic features of a configurable product and its simple product variants. */
export type IConfigurableProduct = ICustomizableProductInterface &
  IPhysicalProductInterface &
  IProductInterface &
  IRoutableInterface & {
    /** @deprecated Use the `custom_attributes` field instead. */
    about_manufacturer: Maybe<Scalars["String"]["output"]>;
    /**
     * The attribute set assigned to the product.
     * @deprecated The field should not be used on the storefront.
     */
    attribute_set_id: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    available_date: Maybe<Scalars["String"]["output"]>;
    /**
     * Whether the product is explicitly available for Mobile App commerce exposure. 1 = eligible, 0 or null = not eligible.
     * @deprecated Use the `custom_attributes` field instead.
     */
    available_for_mobile_app: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    battery: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    buy_cta_pdp: Maybe<Scalars["Int"]["output"]>;
    /** CTA for PDP attribute translated label . */
    buy_cta_pdp_label: Scalars["String"]["output"];
    /** @deprecated Use the `custom_attributes` field instead. */
    buy_cta_plp: Maybe<Scalars["Int"]["output"]>;
    /** CTA for PLP attribute translated label . */
    buy_cta_plp_label: Scalars["String"]["output"];
    /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
    canonical_url: Maybe<Scalars["String"]["output"]>;
    /** The categories assigned to a product. */
    categories: Maybe<Array<Maybe<ICategoryInterface>>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    charging_time: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    color: Maybe<Scalars["Int"]["output"]>;
    /** Color attribute label. */
    color_label: Maybe<Scalars["String"]["output"]>;
    /** An array of options for the configurable product. */
    configurable_options: Maybe<Array<Maybe<IConfigurableProductOptions>>>;
    /** An array of media gallery items and other details about selected configurable product options as well as details about remaining selectable options. */
    configurable_product_options_selection: Maybe<IConfigurableProductOptionsSelection>;
    /** @deprecated Use the `custom_attributes` field instead. */
    connectors: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    connectors_1: Maybe<Scalars["String"]["output"]>;
    /** The product's country of origin. */
    country_of_manufacture: Maybe<Scalars["String"]["output"]>;
    /**
     * Timestamp indicating when the product was created.
     * @deprecated The field should not be used on the storefront.
     */
    created_at: Maybe<Scalars["String"]["output"]>;
    /** An array of cross-sell products. */
    crosssell_products: Maybe<Array<Maybe<IProductInterface>>>;
    /** Product custom attributes. */
    custom_attributesV2: Maybe<IProductCustomAttributes>;
    /** Delivery region this product may be shipped to — `ES` or `IC`, the same vocabulary as the region header and getDeliveryRegions.code. Distinct from `region_code` on address types, which carries a province code. Null when the product carries no region, or its attribute value is not mapped to one; either way the product is undeliverable everywhere. */
    delivery_region_code: Maybe<Scalars["String"]["output"]>;
    /** Detailed information about the product. The value can include simple HTML tags. */
    description: Maybe<IComplexTextValue>;
    /** @deprecated Use the `custom_attributes` field instead. */
    device_dimensions: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    dimensions: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    enable_lifetime_quantity_limit: Maybe<Scalars["Int"]["output"]>;
    /**
     * Is quantity limit enabled for this product
     * @deprecated Use the `custom_attributes` field instead.
     */
    enable_order_quantity_limit: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    experience: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    flavor: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    flavor_family: Maybe<Scalars["String"]["output"]>;
    /** Color attribute label. */
    flavor_label: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    flavour: Maybe<Scalars["Int"]["output"]>;
    /** Get all details for flavour */
    flavour_details: Array<Maybe<IFlavourDetails>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    formula: Maybe<Scalars["Int"]["output"]>;
    /** A list of gift options for the given product */
    free_gifts: Maybe<IFreeGiftProductData>;
    /** Returns all attribute values and labels marked as visible on storefront */
    frontend_attributes: Maybe<Array<Maybe<IFrontendAttribute>>>;
    /** Returns a value indicating gift message availability for the product. */
    gift_message_available: Scalars["Boolean"]["output"];
    /** Returns a value indicating gift wrapping availability for the product. */
    gift_wrapping_available: Scalars["Boolean"]["output"];
    /** Returns value and currency indicating gift wrapping price for the product. */
    gift_wrapping_price: Maybe<IMoney>;
    /** @deprecated Use the `custom_attributes` field instead. */
    has_device: Maybe<Scalars["Int"]["output"]>;
    /** Provides the flag to show if consent is required or not */
    has_registration_consent: Maybe<Scalars["Boolean"]["output"]>;
    /** Product is hidden_sku or not */
    hidden_sku: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * The ID number assigned to the product.
     * @deprecated Use the `uid` field instead.
     */
    id: Maybe<Scalars["Int"]["output"]>;
    /** The relative path to the main image on the product page. */
    image: Maybe<IProductImage>;
    /** @deprecated Use the `custom_attributes` field instead. */
    importer: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    input_terminal: Maybe<Scalars["Int"]["output"]>;
    /** Product discontinued flag */
    is_discontinued: Maybe<Scalars["Boolean"]["output"]>;
    /** Indicates whether the product can be returned. */
    is_returnable: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    jti_brand_matrix: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    jti_category_redirect: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    jti_product_discontinued: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    jti_sku_redirect: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    large_stick_tray: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    lifetime_quantity_limit: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    main_specifications: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    mandatory_positive_consent: Maybe<Scalars["Int"]["output"]>;
    /**
     * A number representing the product's manufacturer.
     * @deprecated Use the `custom_attributes` field instead.
     */
    manufacturer: Maybe<Scalars["Int"]["output"]>;
    /** Product subscription format */
    manufacturer_label: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    material: Maybe<Scalars["String"]["output"]>;
    /** Maximum Qty Allowed in Shopping Cart */
    max_sale_qty: Maybe<Scalars["Float"]["output"]>;
    /** An array of media gallery objects. */
    media_gallery: Maybe<Array<Maybe<IMediaGalleryInterface>>>;
    /**
     * An array of MediaGalleryEntry objects.
     * @deprecated Use `media_gallery` instead.
     */
    media_gallery_entries: Maybe<Array<Maybe<IMediaGalleryEntry>>>;
    /** A brief overview of the product for search results listings, maximum 255 characters. */
    meta_description: Maybe<Scalars["String"]["output"]>;
    /** A comma-separated list of keywords that are visible only to search engines. */
    meta_keyword: Maybe<Scalars["String"]["output"]>;
    /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
    meta_title: Maybe<Scalars["String"]["output"]>;
    /** Minimum Qty Allowed in Shopping Cart */
    min_sale_qty: Maybe<Scalars["Float"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    minimum_amount: Maybe<Scalars["Float"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    minimum_amount_type: Maybe<Scalars["String"]["output"]>;
    /**
     * Multipack description for this product
     * @deprecated Use the `custom_attributes` field instead.
     */
    multipack_description: Maybe<Scalars["String"]["output"]>;
    /** Is multipacks selected enabled for this product */
    multipack_enabled: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * Multipack label for this product
     * @deprecated Use the `custom_attributes` field instead.
     */
    multipack_label: Maybe<Scalars["String"]["output"]>;
    /** Multipack price text for this product */
    multipack_price: Maybe<Scalars["String"]["output"]>;
    /** Multipack Products */
    multipack_products: Maybe<Array<Maybe<IProductInterface>>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    multipacks_enabled: Maybe<Scalars["Int"]["output"]>;
    /** The product name. Customers use this name to identify the product. */
    name: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    name_and_model: Maybe<Scalars["String"]["output"]>;
    /** The beginning date for new product listings, and determines if the product is featured as a new product. */
    new_from_date: Maybe<Scalars["String"]["output"]>;
    /** The end date for new product listings. */
    new_to_date: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    non_trade_in_sku: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    number_of_packs: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    number_of_sticks: Maybe<Scalars["Int"]["output"]>;
    /** Product stock only x left count */
    only_x_left_in_stock: Maybe<Scalars["Float"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    option_grouped_by_brand: Maybe<Scalars["Int"]["output"]>;
    /** An array of options for a customizable product. */
    options: Maybe<Array<Maybe<ICustomizableOptionInterface>>>;
    /** If the product has multiple options, determines where they appear on the product page. */
    options_container: Maybe<Scalars["String"]["output"]>;
    /**
     * Maximum quantity allowed per one order
     * @deprecated Use the `custom_attributes` field instead.
     */
    order_quantity_limit: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    portable_stick_tray: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    pouch_size: Maybe<Scalars["Int"]["output"]>;
    /**
     * Indicates the price of an item.
     * @deprecated Use `price_range` for product price information.
     */
    price: Maybe<IProductPrices>;
    /** The range of prices for the product */
    price_range: IPriceRange;
    /** An array of `TierPrice` objects. */
    price_tiers: Maybe<Array<Maybe<ITierPrice>>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_brand: Maybe<Scalars["String"]["output"]>;
    /** Product Brand Label */
    product_brand_label: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_category: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_category_type: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_color: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_disclaimer: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_family: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_generation: Maybe<Scalars["String"]["output"]>;
    /** An array of `ProductLinks` objects. */
    product_links: Maybe<Array<Maybe<IProductLinksInterface>>>;
    /** Get all special offers for a product. */
    promotionalOffers: Array<Maybe<ISpecialOffer>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    province: Maybe<Scalars["String"]["output"]>;
    /** Product provence label for PLP attribute. */
    province_label: Maybe<Scalars["String"]["output"]>;
    /** Amount of available stock */
    quantity: Maybe<Scalars["Float"]["output"]>;
    /** The average of all the ratings given to the product. */
    rating_summary: Scalars["Float"]["output"];
    /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
    redirect_code: Scalars["Int"]["output"];
    /** Redirect category URL path for discontinued product */
    redirect_product_category: Maybe<Scalars["String"]["output"]>;
    /** Redirect product SKU for discontinued product */
    redirect_sku: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    region: Maybe<Scalars["Int"]["output"]>;
    /** Product Region attribute translated label. */
    region_label: Maybe<Scalars["String"]["output"]>;
    /** An array of related products. */
    related_products: Maybe<Array<Maybe<IProductInterface>>>;
    /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
    relative_url: Maybe<Scalars["String"]["output"]>;
    /** The total count of all the reviews given to the product. */
    review_count: Scalars["Int"]["output"];
    /** @deprecated Use the `custom_attributes` field instead. */
    review_eligible: Maybe<Scalars["Int"]["output"]>;
    /** The list of products reviews. */
    reviews: IProductReviews;
    /** A short description of the product. Its use depends on the theme. */
    short_description: Maybe<IComplexTextValue>;
    /** @deprecated Use the `custom_attributes` field instead. */
    size: Maybe<Scalars["String"]["output"]>;
    /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
    sku: Maybe<Scalars["String"]["output"]>;
    /** The relative path to the small image, which is used on catalog pages. */
    small_image: Maybe<IProductImage>;
    /** Get all special offers for a product. */
    specialOffers: Array<Maybe<ISpecialOffer>>;
    /**
     * The beginning date that a product has a special price.
     * @deprecated The field should not be used on the storefront.
     */
    special_from_date: Maybe<Scalars["String"]["output"]>;
    /** The discounted price of the product. */
    special_price: Maybe<Scalars["Float"]["output"]>;
    /** The end date for a product with a special price. */
    special_to_date: Maybe<Scalars["String"]["output"]>;
    /** Indicates whether the product is staged for a future campaign. */
    staged: Scalars["Boolean"]["output"];
    /** @deprecated Use the `custom_attributes` field instead. */
    stick_capability: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    stick_compatibility: Maybe<Scalars["String"]["output"]>;
    /** Stock status of the product */
    stock_status: Maybe<IProductStockStatus>;
    /** @deprecated Use the `custom_attributes` field instead. */
    strength: Maybe<Scalars["Int"]["output"]>;
    /** Get all details for strength */
    strength_details: Maybe<IStrengthDetails>;
    /** @deprecated Use the `custom_attributes` field instead. */
    subscription: Maybe<Scalars["Int"]["output"]>;
    /**
     * Product subscription format
     * @deprecated Use the `custom_attributes` field instead.
     */
    subscription_format: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    subtitle: Maybe<Scalars["String"]["output"]>;
    /** The file name of a swatch image. */
    swatch_image: Maybe<Scalars["String"]["output"]>;
    /** The relative path to the product's thumbnail image. */
    thumbnail: Maybe<IProductImage>;
    /**
     * The price when tier pricing is in effect and the items purchased threshold has been reached.
     * @deprecated Use `price_tiers` for product tier price information.
     */
    tier_price: Maybe<Scalars["Float"]["output"]>;
    /**
     * An array of ProductTierPrices objects.
     * @deprecated Use `price_tiers` for product tier price information.
     */
    tier_prices: Maybe<Array<Maybe<IProductTierPrices>>>;
    /**
     * Product tooltip information
     * @deprecated Use the `custom_attributes` field instead.
     */
    tooltip_info: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    trabka: Maybe<Scalars["String"]["output"]>;
    /**
     * Indicates whether the product is eligible for a trade-in purchase.
     * @deprecated Use the `custom_attributes` field instead.
     */
    trade_in: Scalars["Int"]["output"];
    /**
     * Specific to trial stores, provides information about the finalization sku
     * @deprecated Use the `custom_attributes` field instead.
     */
    trial_finalization_sku: Maybe<Scalars["String"]["output"]>;
    /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
    type: Maybe<IUrlRewriteEntityTypeEnum>;
    /**
     * One of simple, virtual, bundle, downloadable, grouped, or configurable.
     * @deprecated Use `__typename` instead.
     */
    type_id: Maybe<Scalars["String"]["output"]>;
    /** Product Type */
    type_label: Maybe<Scalars["String"]["output"]>;
    /** The unique ID for a `ProductInterface` object. */
    uid: Scalars["ID"]["output"];
    /**
     * Timestamp indicating when the product was updated.
     * @deprecated The field should not be used on the storefront.
     */
    updated_at: Maybe<Scalars["String"]["output"]>;
    /** An array of up-sell products. */
    upsell_products: Maybe<Array<Maybe<IProductInterface>>>;
    /** The part of the URL that identifies the product */
    url_key: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use product's `canonical_url` or url rewrites instead */
    url_path: Maybe<Scalars["String"]["output"]>;
    /** URL rewrites list */
    url_rewrites: Maybe<Array<Maybe<IUrlRewrite>>>;
    /** The part of the product URL that is appended after the url key */
    url_suffix: Maybe<Scalars["String"]["output"]>;
    /** An array of simple product variants. */
    variants: Maybe<Array<Maybe<IConfigurableVariant>>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    voltage: Maybe<Scalars["String"]["output"]>;
    /**
     * An array of websites in which the product is available.
     * @deprecated The field should not be used on the storefront.
     */
    websites: Maybe<Array<Maybe<IWebsite>>>;
    /** The weight of the item, in units defined by the store. */
    weight: Maybe<Scalars["Float"]["output"]>;
  };

/** Defines basic features of a configurable product and its simple product variants. */
export type IConfigurableProductConfigurable_Product_Options_SelectionArgs = {
  configurableOptionValueUids: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

/** Defines basic features of a configurable product and its simple product variants. */
export type IConfigurableProductCustom_AttributesV2Args = {
  filters: InputMaybe<IAttributeFilterInput>;
};

/** Defines basic features of a configurable product and its simple product variants. */
export type IConfigurableProductReviewsArgs = {
  currentPage?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

export type IConfigurableProductCartItemInput = {
  /** The ID and value of the option. */
  customizable_options: InputMaybe<Array<InputMaybe<ICustomizableOptionInput>>>;
  /** The quantity and SKU of the configurable product. */
  data: ICartItemInput;
  /** The SKU of the parent configurable product. */
  parent_sku: InputMaybe<Scalars["String"]["input"]>;
  variant_sku: InputMaybe<Scalars["String"]["input"]>;
};

/** Contains details about configurable product options. */
export type IConfigurableProductOption = {
  /** An attribute code that uniquely identifies a configurable option. */
  attribute_code: Scalars["String"]["output"];
  /** The display name of the option. */
  label: Scalars["String"]["output"];
  /** The unique ID of the configurable option. */
  uid: Scalars["ID"]["output"];
  /** An array of values that are applicable for this option. */
  values: Maybe<Array<Maybe<IConfigurableProductOptionValue>>>;
};

/** Defines a value for a configurable product option. */
export type IConfigurableProductOptionValue = {
  /** Indicates whether the product is available with this selected option. */
  is_available: Scalars["Boolean"]["output"];
  /** Indicates whether the value is the default. */
  is_use_default: Scalars["Boolean"]["output"];
  /** The display name of the value. */
  label: Scalars["String"]["output"];
  /** The URL assigned to the thumbnail of the swatch image. */
  swatch: Maybe<ISwatchDataInterface>;
  /** The unique ID of the value. */
  uid: Scalars["ID"]["output"];
};

/** Defines configurable attributes for the specified product. */
export type IConfigurableProductOptions = {
  /** A string that identifies the attribute. */
  attribute_code: Maybe<Scalars["String"]["output"]>;
  /**
   * The ID assigned to the attribute.
   * @deprecated Use `attribute_uid` instead.
   */
  attribute_id: Maybe<Scalars["String"]["output"]>;
  /**
   * The ID assigned to the attribute.
   * @deprecated Use `attribute_uid` instead.
   */
  attribute_id_v2: Maybe<Scalars["Int"]["output"]>;
  /** The unique ID for an `Attribute` object. */
  attribute_uid: Scalars["ID"]["output"];
  /**
   * The configurable option ID number assigned by the system.
   * @deprecated Use `uid` instead.
   */
  id: Maybe<Scalars["Int"]["output"]>;
  /** A displayed string that describes the configurable product option. */
  label: Maybe<Scalars["String"]["output"]>;
  /** A number that indicates the order in which the attribute is displayed. */
  position: Maybe<Scalars["Int"]["output"]>;
  /**
   * This is the same as a product's `id` field.
   * @deprecated `product_id` is not needed and can be obtained from its parent.
   */
  product_id: Maybe<Scalars["Int"]["output"]>;
  /** The unique ID for a `ConfigurableProductOptions` object. */
  uid: Scalars["ID"]["output"];
  /** Indicates whether the option is the default. */
  use_default: Maybe<Scalars["Boolean"]["output"]>;
  /** An array that defines the `value_index` codes assigned to the configurable product. */
  values: Maybe<Array<Maybe<IConfigurableProductOptionsValues>>>;
};

/** Contains metadata corresponding to the selected configurable options. */
export type IConfigurableProductOptionsSelection = {
  /** An array of all possible configurable options. */
  configurable_options: Maybe<Array<Maybe<IConfigurableProductOption>>>;
  /** Product images and videos corresponding to the specified configurable options selection. */
  media_gallery: Maybe<Array<Maybe<IMediaGalleryInterface>>>;
  /** The configurable options available for further selection based on the current selection. */
  options_available_for_selection: Maybe<Array<Maybe<IConfigurableOptionAvailableForSelection>>>;
  /** A variant represented by the specified configurable options selection. The value is expected to be null until selections are made for each configurable option. */
  variant: Maybe<ISimpleProduct>;
};

/** Contains the index number assigned to a configurable product option. */
export type IConfigurableProductOptionsValues = {
  /** The label of the product on the default store. */
  default_label: Maybe<Scalars["String"]["output"]>;
  /** The label of the product. */
  label: Maybe<Scalars["String"]["output"]>;
  /** The label of the product on the current store. */
  store_label: Maybe<Scalars["String"]["output"]>;
  /** Swatch data for a configurable product option. */
  swatch_data: Maybe<ISwatchDataInterface>;
  /** The unique ID for a `ConfigurableProductOptionsValues` object. */
  uid: Maybe<Scalars["ID"]["output"]>;
  /** Indicates whether to use the default_label. */
  use_default_value: Maybe<Scalars["Boolean"]["output"]>;
  /**
   * A unique index number assigned to the configurable product option.
   * @deprecated Use `uid` instead.
   */
  value_index: Maybe<Scalars["Int"]["output"]>;
};

/** Contains all the simple product variants of a configurable product. */
export type IConfigurableVariant = {
  /** An array of configurable attribute options. */
  attributes: Maybe<Array<Maybe<IConfigurableAttributeOption>>>;
  /** An array of linked simple products. */
  product: Maybe<ISimpleProduct>;
  variant_position: Maybe<Scalars["Int"]["output"]>;
};

/** A configurable product wish list item. */
export type IConfigurableWishlistItem = IWishlistItemInterface & {
  /** The date and time the item was added to the wish list. */
  added_at: Scalars["String"]["output"];
  /**
   * The SKU of the simple product corresponding to a set of selected configurable options.
   * @deprecated Use `ConfigurableWishlistItem.configured_variant.sku` instead.
   */
  child_sku: Scalars["String"]["output"];
  /** An array of selected configurable options. */
  configurable_options: Maybe<Array<Maybe<ISelectedConfigurableOption>>>;
  /** Product details of the selected variant. The value is null if some options are not configured. */
  configured_variant: Maybe<IProductInterface>;
  /** Custom options selected for the wish list item. */
  customizable_options: Array<Maybe<ISelectedCustomizableOption>>;
  /** The description of the item. */
  description: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `WishlistItemInterface` object. */
  id: Scalars["ID"]["output"];
  /** Product details of the wish list item. */
  product: Maybe<IProductInterface>;
  /** The quantity of this wish list item. */
  quantity: Scalars["Float"]["output"];
};

export type IConfirmCancelOrderInput = {
  /** Confirmation Key to cancel the order. */
  confirmation_key: Scalars["String"]["input"];
  /** The unique ID of an `Order` type. */
  order_id: Scalars["ID"]["input"];
};

/** Contains details about a customer email address to confirm. */
export type IConfirmEmailInput = {
  /** The key to confirm the email address. */
  confirmation_key: Scalars["String"]["input"];
  /** The email address to be confirmed. */
  email: Scalars["String"]["input"];
};

export type IConfirmReturnInput = {
  /** Confirmation Key to return order. */
  confirmation_key: Scalars["String"]["input"];
  /** The unique ID of an `Order` type. */
  order_id: Scalars["ID"]["input"];
};

/** List of account confirmation statuses. */
export enum IConfirmationStatusEnum {
  /** Account confirmation not required */
  AccountConfirmationNotRequired = "ACCOUNT_CONFIRMATION_NOT_REQUIRED",
  /** Account confirmed */
  AccountConfirmed = "ACCOUNT_CONFIRMED",
}

export type IConsumableMatrixItem = {
  brandId: Scalars["ID"]["output"];
  flavorDetails: IConsumableMatrixItemFlavorDetails;
  flavorFamily: Array<Maybe<Scalars["String"]["output"]>>;
  isDefault: Scalars["Boolean"]["output"];
  packagingFormatId: Scalars["ID"]["output"];
  purchaseType: Scalars["String"]["output"];
  sku: Scalars["String"]["output"];
  sortOrder: Scalars["Int"]["output"];
  /** Strength details associated with the matrix item SKU. */
  strengthDetails: Maybe<IConsumableMatrixItemStrengthDetails>;
};

export type IConsumableMatrixItemFlavorDetails = {
  flavour: Maybe<Scalars["Int"]["output"]>;
  flavour_label: Maybe<Scalars["String"]["output"]>;
  swatch_data: Maybe<Scalars["String"]["output"]>;
};

export type IConsumableMatrixItemStrengthDetails = {
  /** Strength label configured in Magento. */
  name: Scalars["String"]["output"];
  /** Numeric rating used to render the strength indicator. */
  rating: Scalars["Int"]["output"];
};

export type IConsumablesMatrix = {
  items: Array<Maybe<IConsumableMatrixItem>>;
  packagingFormats: Array<Maybe<IPackagingFormat>>;
};

export type IContactUsInput = {
  /** The shopper's comment to the merchant. */
  comment: Scalars["String"]["input"];
  /** The email address of the shopper. */
  email: Scalars["String"]["input"];
  /** The full name of the shopper. */
  name: Scalars["String"]["input"];
  /** The shopper's telephone number. */
  telephone: InputMaybe<Scalars["String"]["input"]>;
};

/** Contains the status of the request. */
export type IContactUsOutput = {
  /** Indicates whether the request was successful. */
  status: Scalars["Boolean"]["output"];
};

/** Contains the source and target wish lists after copying products. */
export type ICopyProductsBetweenWishlistsOutput = {
  /** The destination wish list containing the copied products. */
  destination_wishlist: IWishlist;
  /** The wish list that the products were copied from. */
  source_wishlist: IWishlist;
  /** An array of errors encountered while copying products in a wish list. */
  user_errors: Array<Maybe<IWishListUserInputError>>;
};

export type ICountry = {
  /** An array of regions within a particular country. */
  available_regions: Maybe<Array<Maybe<IRegion>>>;
  /** The name of the country in English. */
  full_name_english: Maybe<Scalars["String"]["output"]>;
  /** The name of the country in the current locale. */
  full_name_locale: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `Country` object. */
  id: Maybe<Scalars["String"]["output"]>;
  /** The three-letter abbreviation of the country, such as USA. */
  three_letter_abbreviation: Maybe<Scalars["String"]["output"]>;
  /** The two-letter abbreviation of the country, such as US. */
  two_letter_abbreviation: Maybe<Scalars["String"]["output"]>;
};

/** The list of country codes. */
export enum ICountryCodeEnum {
  /** Andorra */
  Ad = "AD",
  /** United Arab Emirates */
  Ae = "AE",
  /** Afghanistan */
  Af = "AF",
  /** Antigua & Barbuda */
  Ag = "AG",
  /** Anguilla */
  Ai = "AI",
  /** Albania */
  Al = "AL",
  /** Armenia */
  Am = "AM",
  /** Netherlands Antilles */
  An = "AN",
  /** Angola */
  Ao = "AO",
  /** Antarctica */
  Aq = "AQ",
  /** Argentina */
  Ar = "AR",
  /** American Samoa */
  As = "AS",
  /** Austria */
  At = "AT",
  /** Australia */
  Au = "AU",
  /** Aruba */
  Aw = "AW",
  /** Åland Islands */
  Ax = "AX",
  /** Azerbaijan */
  Az = "AZ",
  /** Bosnia & Herzegovina */
  Ba = "BA",
  /** Barbados */
  Bb = "BB",
  /** Bangladesh */
  Bd = "BD",
  /** Belgium */
  Be = "BE",
  /** Burkina Faso */
  Bf = "BF",
  /** Bulgaria */
  Bg = "BG",
  /** Bahrain */
  Bh = "BH",
  /** Burundi */
  Bi = "BI",
  /** Benin */
  Bj = "BJ",
  /** St. Barthélemy */
  Bl = "BL",
  /** Bermuda */
  Bm = "BM",
  /** Brunei */
  Bn = "BN",
  /** Bolivia */
  Bo = "BO",
  /** Brazil */
  Br = "BR",
  /** Bahamas */
  Bs = "BS",
  /** Bhutan */
  Bt = "BT",
  /** Bouvet Island */
  Bv = "BV",
  /** Botswana */
  Bw = "BW",
  /** Belarus */
  By = "BY",
  /** Belize */
  Bz = "BZ",
  /** Canada */
  Ca = "CA",
  /** Cocos (Keeling) Islands */
  Cc = "CC",
  /** Congo-Kinshasa */
  Cd = "CD",
  /** Central African Republic */
  Cf = "CF",
  /** Congo-Brazzaville */
  Cg = "CG",
  /** Switzerland */
  Ch = "CH",
  /** Côte d’Ivoire */
  Ci = "CI",
  /** Cook Islands */
  Ck = "CK",
  /** Chile */
  Cl = "CL",
  /** Cameroon */
  Cm = "CM",
  /** China */
  Cn = "CN",
  /** Colombia */
  Co = "CO",
  /** Costa Rica */
  Cr = "CR",
  /** Cuba */
  Cu = "CU",
  /** Cape Verde */
  Cv = "CV",
  /** Christmas Island */
  Cx = "CX",
  /** Cyprus */
  Cy = "CY",
  /** Czech Republic */
  Cz = "CZ",
  /** Germany */
  De = "DE",
  /** Djibouti */
  Dj = "DJ",
  /** Denmark */
  Dk = "DK",
  /** Dominica */
  Dm = "DM",
  /** Dominican Republic */
  Do = "DO",
  /** Algeria */
  Dz = "DZ",
  /** Ecuador */
  Ec = "EC",
  /** Estonia */
  Ee = "EE",
  /** Egypt */
  Eg = "EG",
  /** Western Sahara */
  Eh = "EH",
  /** Eritrea */
  Er = "ER",
  /** Spain */
  Es = "ES",
  /** Ethiopia */
  Et = "ET",
  /** Finland */
  Fi = "FI",
  /** Fiji */
  Fj = "FJ",
  /** Falkland Islands */
  Fk = "FK",
  /** Micronesia */
  Fm = "FM",
  /** Faroe Islands */
  Fo = "FO",
  /** France */
  Fr = "FR",
  /** Gabon */
  Ga = "GA",
  /** United Kingdom */
  Gb = "GB",
  /** Grenada */
  Gd = "GD",
  /** Georgia */
  Ge = "GE",
  /** French Guiana */
  Gf = "GF",
  /** Guernsey */
  Gg = "GG",
  /** Ghana */
  Gh = "GH",
  /** Gibraltar */
  Gi = "GI",
  /** Greenland */
  Gl = "GL",
  /** Gambia */
  Gm = "GM",
  /** Guinea */
  Gn = "GN",
  /** Guadeloupe */
  Gp = "GP",
  /** Equatorial Guinea */
  Gq = "GQ",
  /** Greece */
  Gr = "GR",
  /** South Georgia & South Sandwich Islands */
  Gs = "GS",
  /** Guatemala */
  Gt = "GT",
  /** Guam */
  Gu = "GU",
  /** Guinea-Bissau */
  Gw = "GW",
  /** Guyana */
  Gy = "GY",
  /** Hong Kong SAR China */
  Hk = "HK",
  /** Heard &amp; McDonald Islands */
  Hm = "HM",
  /** Honduras */
  Hn = "HN",
  /** Croatia */
  Hr = "HR",
  /** Haiti */
  Ht = "HT",
  /** Hungary */
  Hu = "HU",
  /** Indonesia */
  Id = "ID",
  /** Ireland */
  Ie = "IE",
  /** Israel */
  Il = "IL",
  /** Isle of Man */
  Im = "IM",
  /** India */
  In = "IN",
  /** British Indian Ocean Territory */
  Io = "IO",
  /** Iraq */
  Iq = "IQ",
  /** Iran */
  Ir = "IR",
  /** Iceland */
  Is = "IS",
  /** Italy */
  It = "IT",
  /** Jersey */
  Je = "JE",
  /** Jamaica */
  Jm = "JM",
  /** Jordan */
  Jo = "JO",
  /** Japan */
  Jp = "JP",
  /** Kenya */
  Ke = "KE",
  /** Kyrgyzstan */
  Kg = "KG",
  /** Cambodia */
  Kh = "KH",
  /** Kiribati */
  Ki = "KI",
  /** Comoros */
  Km = "KM",
  /** St. Kitts & Nevis */
  Kn = "KN",
  /** North Korea */
  Kp = "KP",
  /** South Korea */
  Kr = "KR",
  /** Kuwait */
  Kw = "KW",
  /** Cayman Islands */
  Ky = "KY",
  /** Kazakhstan */
  Kz = "KZ",
  /** Laos */
  La = "LA",
  /** Lebanon */
  Lb = "LB",
  /** St. Lucia */
  Lc = "LC",
  /** Liechtenstein */
  Li = "LI",
  /** Sri Lanka */
  Lk = "LK",
  /** Liberia */
  Lr = "LR",
  /** Lesotho */
  Ls = "LS",
  /** Lithuania */
  Lt = "LT",
  /** Luxembourg */
  Lu = "LU",
  /** Latvia */
  Lv = "LV",
  /** Libya */
  Ly = "LY",
  /** Morocco */
  Ma = "MA",
  /** Monaco */
  Mc = "MC",
  /** Moldova */
  Md = "MD",
  /** Montenegro */
  Me = "ME",
  /** St. Martin */
  Mf = "MF",
  /** Madagascar */
  Mg = "MG",
  /** Marshall Islands */
  Mh = "MH",
  /** Macedonia */
  Mk = "MK",
  /** Mali */
  Ml = "ML",
  /** Myanmar (Burma) */
  Mm = "MM",
  /** Mongolia */
  Mn = "MN",
  /** Macau SAR China */
  Mo = "MO",
  /** Northern Mariana Islands */
  Mp = "MP",
  /** Martinique */
  Mq = "MQ",
  /** Mauritania */
  Mr = "MR",
  /** Montserrat */
  Ms = "MS",
  /** Malta */
  Mt = "MT",
  /** Mauritius */
  Mu = "MU",
  /** Maldives */
  Mv = "MV",
  /** Malawi */
  Mw = "MW",
  /** Mexico */
  Mx = "MX",
  /** Malaysia */
  My = "MY",
  /** Mozambique */
  Mz = "MZ",
  /** Namibia */
  Na = "NA",
  /** New Caledonia */
  Nc = "NC",
  /** Niger */
  Ne = "NE",
  /** Norfolk Island */
  Nf = "NF",
  /** Nigeria */
  Ng = "NG",
  /** Nicaragua */
  Ni = "NI",
  /** Netherlands */
  Nl = "NL",
  /** Norway */
  No = "NO",
  /** Nepal */
  Np = "NP",
  /** Nauru */
  Nr = "NR",
  /** Niue */
  Nu = "NU",
  /** New Zealand */
  Nz = "NZ",
  /** Oman */
  Om = "OM",
  /** Panama */
  Pa = "PA",
  /** Peru */
  Pe = "PE",
  /** French Polynesia */
  Pf = "PF",
  /** Papua New Guinea */
  Pg = "PG",
  /** Philippines */
  Ph = "PH",
  /** Pakistan */
  Pk = "PK",
  /** Poland */
  Pl = "PL",
  /** St. Pierre & Miquelon */
  Pm = "PM",
  /** Pitcairn Islands */
  Pn = "PN",
  /** Palestinian Territories */
  Ps = "PS",
  /** Portugal */
  Pt = "PT",
  /** Palau */
  Pw = "PW",
  /** Paraguay */
  Py = "PY",
  /** Qatar */
  Qa = "QA",
  /** Réunion */
  Re = "RE",
  /** Romania */
  Ro = "RO",
  /** Serbia */
  Rs = "RS",
  /** Russia */
  Ru = "RU",
  /** Rwanda */
  Rw = "RW",
  /** Saudi Arabia */
  Sa = "SA",
  /** Solomon Islands */
  Sb = "SB",
  /** Seychelles */
  Sc = "SC",
  /** Sudan */
  Sd = "SD",
  /** Sweden */
  Se = "SE",
  /** Singapore */
  Sg = "SG",
  /** St. Helena */
  Sh = "SH",
  /** Slovenia */
  Si = "SI",
  /** Svalbard & Jan Mayen */
  Sj = "SJ",
  /** Slovakia */
  Sk = "SK",
  /** Sierra Leone */
  Sl = "SL",
  /** San Marino */
  Sm = "SM",
  /** Senegal */
  Sn = "SN",
  /** Somalia */
  So = "SO",
  /** Suriname */
  Sr = "SR",
  /** São Tomé & Príncipe */
  St = "ST",
  /** El Salvador */
  Sv = "SV",
  /** Syria */
  Sy = "SY",
  /** Eswatini */
  Sz = "SZ",
  /** Turks & Caicos Islands */
  Tc = "TC",
  /** Chad */
  Td = "TD",
  /** French Southern Territories */
  Tf = "TF",
  /** Togo */
  Tg = "TG",
  /** Thailand */
  Th = "TH",
  /** Tajikistan */
  Tj = "TJ",
  /** Tokelau */
  Tk = "TK",
  /** Timor-Leste */
  Tl = "TL",
  /** Turkmenistan */
  Tm = "TM",
  /** Tunisia */
  Tn = "TN",
  /** Tonga */
  To = "TO",
  /** Turkey */
  Tr = "TR",
  /** Trinidad & Tobago */
  Tt = "TT",
  /** Tuvalu */
  Tv = "TV",
  /** Taiwan */
  Tw = "TW",
  /** Tanzania */
  Tz = "TZ",
  /** Ukraine */
  Ua = "UA",
  /** Uganda */
  Ug = "UG",
  /** U.S. Outlying Islands */
  Um = "UM",
  /** United States */
  Us = "US",
  /** Uruguay */
  Uy = "UY",
  /** Uzbekistan */
  Uz = "UZ",
  /** Vatican City */
  Va = "VA",
  /** St. Vincent & Grenadines */
  Vc = "VC",
  /** Venezuela */
  Ve = "VE",
  /** British Virgin Islands */
  Vg = "VG",
  /** U.S. Virgin Islands */
  Vi = "VI",
  /** Vietnam */
  Vn = "VN",
  /** Vanuatu */
  Vu = "VU",
  /** Wallis & Futuna */
  Wf = "WF",
  /** Samoa */
  Ws = "WS",
  /** Yemen */
  Ye = "YE",
  /** Mayotte */
  Yt = "YT",
  /** South Africa */
  Za = "ZA",
  /** Zambia */
  Zm = "ZM",
  /** Zimbabwe */
  Zw = "ZW",
}

/** Contains an array of product IDs to use for creating a compare list. */
export type ICreateCompareListInput = {
  /** An array of product IDs to add to the compare list. */
  products: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

/** Defines a new gift registry. */
export type ICreateGiftRegistryInput = {
  /** Additional attributes specified as a code-value pair. */
  dynamic_attributes: InputMaybe<Array<InputMaybe<IGiftRegistryDynamicAttributeInput>>>;
  /** The name of the event. */
  event_name: Scalars["String"]["input"];
  /** The ID of the selected event type. */
  gift_registry_type_uid: Scalars["ID"]["input"];
  /** A message describing the event. */
  message: Scalars["String"]["input"];
  /** Indicates whether the registry is PRIVATE or PUBLIC. */
  privacy_settings: IGiftRegistryPrivacySettings;
  /** The list of people who receive notifications about the registry. */
  registrants: Array<InputMaybe<IAddGiftRegistryRegistrantInput>>;
  /** The shipping address for all gift registry items. */
  shipping_address: InputMaybe<IGiftRegistryShippingAddressInput>;
  /** Indicates whether the registry is ACTIVE or INACTIVE. */
  status: IGiftRegistryStatus;
};

/** Contains the results of a request to create a gift registry. */
export type ICreateGiftRegistryOutput = {
  /** The newly-created gift registry. */
  gift_registry: Maybe<IGiftRegistry>;
};

export type ICreateGuestCartInput = {
  /** Optional client-generated ID */
  cart_uid: InputMaybe<Scalars["ID"]["input"]>;
};

export type ICreateGuestCartOutput = {
  /** The newly created cart. */
  cart: Maybe<ICart>;
};

/** Contains the secure information used to authorize transaction. Applies to Payflow Pro and Payments Pro payment methods. */
export type ICreatePayflowProTokenOutput = {
  /** The RESPMSG returned by PayPal. If the `result` is `0`, then `response_message` is `Approved`. */
  response_message: Scalars["String"]["output"];
  /** A non-zero value if any errors occurred. */
  result: Scalars["Int"]["output"];
  /** The RESULT returned by PayPal. A value of `0` indicates the transaction was approved. */
  result_code: Scalars["Int"]["output"];
  /** A secure token generated by PayPal. */
  secure_token: Scalars["String"]["output"];
  /** A secure token ID generated by PayPal. */
  secure_token_id: Scalars["String"]["output"];
};

/** Contains payment order details that are used while processing the payment order */
export type ICreatePaymentOrderInput = {
  /** The customer cart ID */
  cartId: Scalars["String"]["input"];
  /** Defines the origin location for that payment request */
  location: IPaymentLocation;
  /** The code for the payment method used in the order */
  methodCode: Scalars["String"]["input"];
  /** The identifiable payment source for the payment method */
  paymentSource: Scalars["String"]["input"];
  /** Indicates whether the payment information should be vaulted */
  vaultIntent: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Contains payment order details that are used while processing the payment order */
export type ICreatePaymentOrderOutput = {
  /** The amount of the payment order */
  amount: Maybe<Scalars["Float"]["output"]>;
  /** The currency of the payment order */
  currency_code: Maybe<Scalars["String"]["output"]>;
  /** PayPal order ID */
  id: Maybe<Scalars["String"]["output"]>;
  /** The order ID generated by Payment Services */
  mp_order_id: Maybe<Scalars["String"]["output"]>;
  /** The status of the payment order */
  status: Maybe<Scalars["String"]["output"]>;
};

/** Defines a new product review. */
export type ICreateProductReviewInput = {
  /** The customer's nickname. Defaults to the customer name, if logged in. */
  nickname: Scalars["String"]["input"];
  /** The ratings details by category. For example, Price: 5 stars, Quality: 4 stars, etc. */
  ratings: Array<InputMaybe<IProductReviewRatingInput>>;
  /** The SKU of the reviewed product. */
  sku: Scalars["String"]["input"];
  /** The summary (title) of the review. */
  summary: Scalars["String"]["input"];
  /** The review text. */
  text: Scalars["String"]["input"];
};

/** Contains the completed product review. */
export type ICreateProductReviewOutput = {
  /** Product review details. */
  review: IProductReview;
};

/** Describe the variables needed to create a vault payment token */
export type ICreateVaultCardPaymentTokenInput = {
  /** Description of the vaulted card */
  card_description: InputMaybe<Scalars["String"]["input"]>;
  /** The setup token obtained by the createVaultCardSetupToken endpoint */
  setup_token_id: Scalars["String"]["input"];
};

/** The vault token id and information about the payment source */
export type ICreateVaultCardPaymentTokenOutput = {
  /** The payment source information */
  payment_source: IPaymentSourceOutput;
  /** The vault payment token information */
  vault_token_id: Scalars["String"]["output"];
};

/** Describe the variables needed to create a vault card setup token */
export type ICreateVaultCardSetupTokenInput = {
  /** The setup token information */
  setup_token: IVaultSetupTokenInput;
  /** The 3DS mode */
  three_ds_mode: InputMaybe<IThreeDsMode>;
};

/** The setup token id information */
export type ICreateVaultCardSetupTokenOutput = {
  /** The setup token id */
  setup_token: Scalars["String"]["output"];
};

/** Defines the name and visibility of a new wish list. */
export type ICreateWishlistInput = {
  /** The name of the new wish list. */
  name: Scalars["String"]["input"];
  /** Indicates whether the wish list is public or private. */
  visibility: IWishlistVisibilityEnum;
};

/** Contains the wish list. */
export type ICreateWishlistOutput = {
  /** The newly-created wish list */
  wishlist: IWishlist;
};

/** Required fields for Payflow Pro and Payments Pro credit card payments. */
export type ICreditCardDetailsInput = {
  /** The credit card expiration month. */
  cc_exp_month: Scalars["Int"]["input"];
  /** The credit card expiration year. */
  cc_exp_year: Scalars["Int"]["input"];
  /** The last 4 digits of the credit card. */
  cc_last_4: Scalars["Int"]["input"];
  /** The credit card type. */
  cc_type: Scalars["String"]["input"];
};

/** Contains credit memo details. */
export type ICreditMemo = {
  /** Comments on the credit memo. */
  comments: Maybe<Array<Maybe<ISalesCommentItem>>>;
  /** The unique ID for a `CreditMemo` object. */
  id: Scalars["ID"]["output"];
  /** An array containing details about refunded items. */
  items: Maybe<Array<Maybe<ICreditMemoItemInterface>>>;
  /** The sequential credit memo number. */
  number: Scalars["String"]["output"];
  /** Details about the total refunded amount. */
  total: Maybe<ICreditMemoTotal>;
};

export type ICreditMemoItem = ICreditMemoItemInterface & {
  /** Details about the final discount amount for the base product, including discounts on options. */
  discounts: Maybe<Array<Maybe<IDiscount>>>;
  /** The unique ID for a `CreditMemoItemInterface` object. */
  id: Scalars["ID"]["output"];
  /** The order item the credit memo is applied to. */
  order_item: Maybe<IOrderItemInterface>;
  /** The name of the base product. */
  product_name: Maybe<Scalars["String"]["output"]>;
  /** The sale price for the base product, including selected options. */
  product_sale_price: IMoney;
  /** The SKU of the base product. */
  product_sku: Scalars["String"]["output"];
  /** The number of refunded items. */
  quantity_refunded: Maybe<Scalars["Float"]["output"]>;
};

/** Credit memo item details. */
export type ICreditMemoItemInterface = {
  /** Details about the final discount amount for the base product, including discounts on options. */
  discounts: Maybe<Array<Maybe<IDiscount>>>;
  /** The unique ID for a `CreditMemoItemInterface` object. */
  id: Scalars["ID"]["output"];
  /** The order item the credit memo is applied to. */
  order_item: Maybe<IOrderItemInterface>;
  /** The name of the base product. */
  product_name: Maybe<Scalars["String"]["output"]>;
  /** The sale price for the base product, including selected options. */
  product_sale_price: IMoney;
  /** The SKU of the base product. */
  product_sku: Scalars["String"]["output"];
  /** The number of refunded items. */
  quantity_refunded: Maybe<Scalars["Float"]["output"]>;
};

/** Contains credit memo price details. */
export type ICreditMemoTotal = {
  /** An adjustment manually applied to the order. */
  adjustment: IMoney;
  /** The final base grand total amount in the base currency. */
  base_grand_total: IMoney;
  /** The applied discounts to the credit memo. */
  discounts: Maybe<Array<Maybe<IDiscount>>>;
  /** The final total amount, including shipping, discounts, and taxes. */
  grand_total: IMoney;
  /** Details about the shipping and handling costs for the credit memo. */
  shipping_handling: Maybe<IShippingHandling>;
  /** The subtotal of the invoice, excluding shipping, discounts, and taxes. */
  subtotal: IMoney;
  /** The credit memo tax details. */
  taxes: Maybe<Array<Maybe<ITaxItem>>>;
  /** The shipping amount for the credit memo. */
  total_shipping: IMoney;
  /** The amount of tax applied to the credit memo. */
  total_tax: IMoney;
};

/** Defines a cross-selling popup offer to display for a cart. */
export type ICrossSellPopup = {
  /** The identifier of the cross-selling rule that produced this popup. */
  id: Scalars["String"]["output"];
  /** How many times the popup may be displayed within a single session. */
  max_displays_per_session: Maybe<Scalars["Int"]["output"]>;
  /** The products offered by the popup. At most three. */
  offer: Maybe<Array<Maybe<ICrossSellPopupOffer>>>;
  /** The priority of the rule. The lowest value wins when several rules match. */
  priority: Maybe<Scalars["Int"]["output"]>;
};

/** Defines a product offered by a cross-selling popup. */
export type ICrossSellPopupOffer = {
  /** The price of the offered product. */
  price: Maybe<IMoney>;
  /** The SKU of the offered product. */
  sku: Scalars["String"]["output"];
};

export type ICurrency = {
  /** An array of three-letter currency codes accepted by the store, such as USD and EUR. */
  available_currency_codes: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  /** The base currency set for the store, such as USD. */
  base_currency_code: Maybe<Scalars["String"]["output"]>;
  /** The symbol for the specified base currency, such as $. */
  base_currency_symbol: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Symbol was missed. Use `default_display_currency_code`. */
  default_display_currecy_code: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Symbol was missed. Use `default_display_currency_code`. */
  default_display_currecy_symbol: Maybe<Scalars["String"]["output"]>;
  /** The currency that is displayed by default, such as USD. */
  default_display_currency_code: Maybe<Scalars["String"]["output"]>;
  /** The currency symbol that is displayed by default, such as $. */
  default_display_currency_symbol: Maybe<Scalars["String"]["output"]>;
  /** An array of exchange rates for currencies defined in the store. */
  exchange_rates: Maybe<Array<Maybe<IExchangeRate>>>;
};

/** The list of available currency codes. */
export enum ICurrencyEnum {
  Aed = "AED",
  Afn = "AFN",
  All = "ALL",
  Amd = "AMD",
  Ang = "ANG",
  Aoa = "AOA",
  Ars = "ARS",
  Aud = "AUD",
  Awg = "AWG",
  Azm = "AZM",
  Azn = "AZN",
  Bam = "BAM",
  Bbd = "BBD",
  Bdt = "BDT",
  Bgn = "BGN",
  Bhd = "BHD",
  Bif = "BIF",
  Bmd = "BMD",
  Bnd = "BND",
  Bob = "BOB",
  Brl = "BRL",
  Bsd = "BSD",
  Btn = "BTN",
  Buk = "BUK",
  Bwp = "BWP",
  Byn = "BYN",
  Bzd = "BZD",
  Cad = "CAD",
  Cdf = "CDF",
  Che = "CHE",
  Chf = "CHF",
  Chw = "CHW",
  Clp = "CLP",
  Cny = "CNY",
  Cop = "COP",
  Crc = "CRC",
  Cup = "CUP",
  Cve = "CVE",
  Czk = "CZK",
  Djf = "DJF",
  Dkk = "DKK",
  Dop = "DOP",
  Dzd = "DZD",
  Eek = "EEK",
  Egp = "EGP",
  Ern = "ERN",
  Etb = "ETB",
  Eur = "EUR",
  Fjd = "FJD",
  Fkp = "FKP",
  Gbp = "GBP",
  Gek = "GEK",
  Gel = "GEL",
  Ghs = "GHS",
  Gip = "GIP",
  Gmd = "GMD",
  Gnf = "GNF",
  Gqe = "GQE",
  Gtq = "GTQ",
  Gyd = "GYD",
  Hkd = "HKD",
  Hnl = "HNL",
  Hrk = "HRK",
  Htg = "HTG",
  Huf = "HUF",
  Idr = "IDR",
  Ils = "ILS",
  Inr = "INR",
  Iqd = "IQD",
  Irr = "IRR",
  Isk = "ISK",
  Jmd = "JMD",
  Jod = "JOD",
  Jpy = "JPY",
  Kes = "KES",
  Kgs = "KGS",
  Khr = "KHR",
  Kmf = "KMF",
  Kpw = "KPW",
  Krw = "KRW",
  Kwd = "KWD",
  Kyd = "KYD",
  Kzt = "KZT",
  Lak = "LAK",
  Lbp = "LBP",
  Lkr = "LKR",
  Lrd = "LRD",
  Lsl = "LSL",
  Lsm = "LSM",
  Ltl = "LTL",
  Lvl = "LVL",
  Lyd = "LYD",
  Mad = "MAD",
  Mdl = "MDL",
  Mga = "MGA",
  Mkd = "MKD",
  Mmk = "MMK",
  Mnt = "MNT",
  Mop = "MOP",
  Mro = "MRO",
  Mur = "MUR",
  Mvr = "MVR",
  Mwk = "MWK",
  Mxn = "MXN",
  Myr = "MYR",
  Mzn = "MZN",
  Nad = "NAD",
  Ngn = "NGN",
  Nic = "NIC",
  Nok = "NOK",
  Npr = "NPR",
  Nzd = "NZD",
  Omr = "OMR",
  Pab = "PAB",
  Pen = "PEN",
  Pgk = "PGK",
  Php = "PHP",
  Pkr = "PKR",
  Pln = "PLN",
  Pyg = "PYG",
  Qar = "QAR",
  Rhd = "RHD",
  Rol = "ROL",
  Ron = "RON",
  Rsd = "RSD",
  Rub = "RUB",
  Rwf = "RWF",
  Sar = "SAR",
  Sbd = "SBD",
  Scr = "SCR",
  Sdg = "SDG",
  Sek = "SEK",
  Sgd = "SGD",
  Shp = "SHP",
  Skk = "SKK",
  Sll = "SLL",
  Sos = "SOS",
  Srd = "SRD",
  Std = "STD",
  Svc = "SVC",
  Syp = "SYP",
  Szl = "SZL",
  Thb = "THB",
  Tjs = "TJS",
  Tmm = "TMM",
  Tnd = "TND",
  Top = "TOP",
  Trl = "TRL",
  Try = "TRY",
  Ttd = "TTD",
  Twd = "TWD",
  Tzs = "TZS",
  Uah = "UAH",
  Ugx = "UGX",
  Usd = "USD",
  Uyu = "UYU",
  Uzs = "UZS",
  Veb = "VEB",
  Vef = "VEF",
  Vnd = "VND",
  Vuv = "VUV",
  Wst = "WST",
  Xcd = "XCD",
  Xof = "XOF",
  Xpf = "XPF",
  Yer = "YER",
  Ytl = "YTL",
  Zar = "ZAR",
  Zmk = "ZMK",
  Zwd = "ZWD",
}

/** Defines an array of custom attributes. */
export type ICustomAttributeMetadata = {
  /** An array of attributes. */
  items: Maybe<Array<Maybe<IAttribute>>>;
};

/** An interface containing fields that define the EAV attribute. */
export type ICustomAttributeMetadataInterface = {
  /** The unique identifier for an attribute code. This value should be in lowercase letters without spaces. */
  code: Scalars["ID"]["output"];
  /** Default attribute value. */
  default_value: Maybe<Scalars["String"]["output"]>;
  /** The type of entity that defines the attribute. */
  entity_type: IAttributeEntityTypeEnum;
  /** The frontend class of the attribute. */
  frontend_class: Maybe<Scalars["String"]["output"]>;
  /** The frontend input type of the attribute. */
  frontend_input: Maybe<IAttributeFrontendInputEnum>;
  /** Whether the attribute value is required. */
  is_required: Scalars["Boolean"]["output"];
  /** Whether the attribute value must be unique. */
  is_unique: Scalars["Boolean"]["output"];
  /** The label assigned to the attribute. */
  label: Maybe<Scalars["String"]["output"]>;
  /** Attribute options. */
  options: Array<Maybe<ICustomAttributeOptionInterface>>;
};

export type ICustomAttributeOptionInterface = {
  /** Is the option value default. */
  is_default: Scalars["Boolean"]["output"];
  /** The label assigned to the attribute option. */
  label: Scalars["String"]["output"];
  /** The attribute option value. */
  value: Scalars["String"]["output"];
};

/** Customer defines the customer name and address and other details */
export type ICustomer = {
  /** An array containing the customer's shipping and billing addresses. */
  addresses: Maybe<Array<Maybe<ICustomerAddress>>>;
  /** An array containing the customer's shipping and billing addresses. */
  addressesV2: Maybe<ICustomerAddresses>;
  /** Indicates whether the customer has enabled remote shopping assistance. */
  allow_remote_shopping_assistance: Scalars["Boolean"]["output"];
  /** The contents of the customer's compare list. */
  compare_list: Maybe<ICompareList>;
  /** The customer's confirmation status. */
  confirmation_status: IConfirmationStatusEnum;
  /** Timestamp indicating when the account was created. */
  created_at: Maybe<Scalars["String"]["output"]>;
  /** Customer's custom attributes. */
  custom_attributes: Maybe<Array<Maybe<IAttributeValueInterface>>>;
  /** The customer's date of birth. */
  date_of_birth: Maybe<Scalars["String"]["output"]>;
  /** The ID assigned to the billing address. */
  default_billing: Maybe<Scalars["String"]["output"]>;
  /** The ID assigned to the shipping address. */
  default_shipping: Maybe<Scalars["String"]["output"]>;
  /**
   * The customer's date of birth.
   * @deprecated Use `date_of_birth` instead.
   */
  dob: Maybe<Scalars["String"]["output"]>;
  /** The customer's email address. Required. */
  email: Maybe<Scalars["String"]["output"]>;
  /** The customer's first name. */
  firstname: Maybe<Scalars["String"]["output"]>;
  /** The customer's gender (Male - 1, Female - 2). */
  gender: Maybe<Scalars["Int"]["output"]>;
  /** Details about all of the customer's gift registries. */
  gift_registries: Maybe<Array<Maybe<IGiftRegistry>>>;
  /** Details about a specific gift registry. */
  gift_registry: Maybe<IGiftRegistry>;
  /** @deprecated Customer group should not be exposed in the storefront scenarios. */
  group_id: Maybe<Scalars["Int"]["output"]>;
  /**
   * The ID assigned to the customer.
   * @deprecated `id` is not needed as part of `Customer`, because on the server side, it can be identified based on the customer token used for authentication. There is no need to know customer ID on the client side.
   */
  id: Maybe<Scalars["Int"]["output"]>;
  /** Indicates whether the customer is subscribed to the company's newsletter. */
  is_subscribed: Maybe<Scalars["Boolean"]["output"]>;
  /** The customer's family name. */
  lastname: Maybe<Scalars["String"]["output"]>;
  /** The customer's middle name. */
  middlename: Maybe<Scalars["String"]["output"]>;
  orders: Maybe<ICustomerOrders>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix: Maybe<Scalars["String"]["output"]>;
  /** Details about the specified return request from the unique ID for a `Return` object. */
  return: Maybe<IReturn>;
  /** Information about the customer's return requests. */
  returns: Maybe<IReturns>;
  /** Contains the customer's product reviews. */
  reviews: IProductReviews;
  /** Customer reward points details. */
  reward_points: Maybe<IRewardPoints>;
  /** Store credit information applied for the logged in customer. */
  store_credit: Maybe<ICustomerStoreCredit>;
  /** A value such as Sr., Jr., or III. */
  suffix: Maybe<Scalars["String"]["output"]>;
  /** The customer's Value-added tax (VAT) number (for corporate customers). */
  taxvat: Maybe<Scalars["String"]["output"]>;
  /** Unique user id. */
  uuid: Maybe<Scalars["String"]["output"]>;
  /**
   * Return a customer's wish lists.
   * @deprecated Use `Customer.wishlists` or `Customer.wishlist_v2` instead.
   */
  wishlist: IWishlist;
  /** Retrieve the wish list identified by the unique ID for a `Wishlist` object. */
  wishlist_v2: Maybe<IWishlist>;
  /** An array of wishlists. In Magento Open Source, customers are limited to one wish list. The number of wish lists is configurable for Adobe Commerce. */
  wishlists: Array<Maybe<IWishlist>>;
};

/** Customer defines the customer name and address and other details */
export type ICustomerAddressesV2Args = {
  currentPage?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Customer defines the customer name and address and other details */
export type ICustomerCustom_AttributesArgs = {
  attributeCodes: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

/** Customer defines the customer name and address and other details */
export type ICustomerGift_RegistryArgs = {
  giftRegistryUid: Scalars["ID"]["input"];
};

/** Customer defines the customer name and address and other details */
export type ICustomerOrdersArgs = {
  currentPage?: InputMaybe<Scalars["Int"]["input"]>;
  filter: InputMaybe<ICustomerOrdersFilterInput>;
  order_type: InputMaybe<IOrderTypeEnum>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  scope: InputMaybe<IScopeTypeEnum>;
  sort: InputMaybe<ICustomerOrderSortInput>;
};

/** Customer defines the customer name and address and other details */
export type ICustomerReturnArgs = {
  uid: Scalars["ID"]["input"];
};

/** Customer defines the customer name and address and other details */
export type ICustomerReturnsArgs = {
  currentPage?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Customer defines the customer name and address and other details */
export type ICustomerReviewsArgs = {
  currentPage?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Customer defines the customer name and address and other details */
export type ICustomerWishlist_V2Args = {
  id: Scalars["ID"]["input"];
};

/** Customer defines the customer name and address and other details */
export type ICustomerWishlistsArgs = {
  currentPage?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Contains detailed information about a customer's billing or shipping address. */
export type ICustomerAddress = {
  /** The customer's city or town. */
  city: Maybe<Scalars["String"]["output"]>;
  /** The customer's company. */
  company: Maybe<Scalars["String"]["output"]>;
  /** The customer's country. */
  country_code: Maybe<ICountryCodeEnum>;
  /**
   * The customer's country.
   * @deprecated Use `country_code` instead.
   */
  country_id: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use custom_attributesV2 instead. */
  custom_attributes: Maybe<Array<Maybe<ICustomerAddressAttribute>>>;
  /** Custom attributes assigned to the customer address. */
  custom_attributesV2: Array<Maybe<IAttributeValueInterface>>;
  /**
   * The customer ID
   * @deprecated `customer_id` is not needed as part of `CustomerAddress`. The `id` is a unique identifier for the addresses.
   */
  customer_id: Maybe<Scalars["Int"]["output"]>;
  /** Indicates whether the address is the customer's default billing address. */
  default_billing: Maybe<Scalars["Boolean"]["output"]>;
  /** Indicates whether the address is the customer's default shipping address. */
  default_shipping: Maybe<Scalars["Boolean"]["output"]>;
  /** Contains any extension attributes for the address. */
  extension_attributes: Maybe<Array<Maybe<ICustomerAddressAttribute>>>;
  /** The customer's fax number. */
  fax: Maybe<Scalars["String"]["output"]>;
  /** The first name of the person associated with the shipping/billing address. */
  firstname: Maybe<Scalars["String"]["output"]>;
  /** The ID of a `CustomerAddress` object. */
  id: Maybe<Scalars["Int"]["output"]>;
  /** The family name of the person associated with the shipping/billing address. */
  lastname: Maybe<Scalars["String"]["output"]>;
  /** The middle name of the person associated with the shipping/billing address. */
  middlename: Maybe<Scalars["String"]["output"]>;
  /** The customer's ZIP or postal code. */
  postcode: Maybe<Scalars["String"]["output"]>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix: Maybe<Scalars["String"]["output"]>;
  /** An object containing the region name, region code, and region ID. */
  region: Maybe<ICustomerAddressRegion>;
  /** The unique ID for a pre-defined region. */
  region_id: Maybe<Scalars["Int"]["output"]>;
  /** An array of strings that define the street number and name. */
  street: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  /** A value such as Sr., Jr., or III. */
  suffix: Maybe<Scalars["String"]["output"]>;
  /** The customer's telephone number. */
  telephone: Maybe<Scalars["String"]["output"]>;
  /** The customer's Value-added tax (VAT) number (for corporate customers). */
  vat_id: Maybe<Scalars["String"]["output"]>;
};

/** Contains detailed information about a customer's billing or shipping address. */
export type ICustomerAddressCustom_AttributesV2Args = {
  attributeCodes: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

/** Specifies the attribute code and value of a customer address attribute. */
export type ICustomerAddressAttribute = {
  /** The name assigned to the customer address attribute. */
  attribute_code: Maybe<Scalars["String"]["output"]>;
  /** The value assigned to the customer address attribute. */
  value: Maybe<Scalars["String"]["output"]>;
};

/** Specifies the attribute code and value of a customer attribute. */
export type ICustomerAddressAttributeInput = {
  /** The name assigned to the attribute. */
  attribute_code: Scalars["String"]["input"];
  /** The value assigned to the attribute. */
  value: Scalars["String"]["input"];
};

/** Contains details about a billing or shipping address. */
export type ICustomerAddressInput = {
  /** The customer's city or town. */
  city: InputMaybe<Scalars["String"]["input"]>;
  /** The customer's company. */
  company: InputMaybe<Scalars["String"]["input"]>;
  /** The two-letter code representing the customer's country. */
  country_code: InputMaybe<ICountryCodeEnum>;
  country_id: InputMaybe<ICountryCodeEnum>;
  custom_attributes: InputMaybe<Array<InputMaybe<ICustomerAddressAttributeInput>>>;
  /** Custom attributes assigned to the customer address. */
  custom_attributesV2: InputMaybe<Array<InputMaybe<IAttributeValueInput>>>;
  /** Indicates whether the address is the default billing address. */
  default_billing: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Indicates whether the address is the default shipping address. */
  default_shipping: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The customer's fax number. */
  fax: InputMaybe<Scalars["String"]["input"]>;
  /** The first name of the person associated with the billing/shipping address. */
  firstname: InputMaybe<Scalars["String"]["input"]>;
  /** The family name of the person associated with the billing/shipping address. */
  lastname: InputMaybe<Scalars["String"]["input"]>;
  /** The middle name of the person associated with the billing/shipping address. */
  middlename: InputMaybe<Scalars["String"]["input"]>;
  /** The customer's ZIP or postal code. */
  postcode: InputMaybe<Scalars["String"]["input"]>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix: InputMaybe<Scalars["String"]["input"]>;
  /** An object containing the region name, region code, and region ID. */
  region: InputMaybe<ICustomerAddressRegionInput>;
  /** An array of strings that define the street number and name. */
  street: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** A value such as Sr., Jr., or III. */
  suffix: InputMaybe<Scalars["String"]["input"]>;
  /** The customer's telephone number. */
  telephone: InputMaybe<Scalars["String"]["input"]>;
  /** The customer's Tax/VAT number (for corporate customers). */
  vat_id: InputMaybe<Scalars["String"]["input"]>;
};

/** Defines the customer's state or province. */
export type ICustomerAddressRegion = {
  /** The state or province name. */
  region: Maybe<Scalars["String"]["output"]>;
  /** The address region code. */
  region_code: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a pre-defined region. */
  region_id: Maybe<Scalars["Int"]["output"]>;
};

/** Defines the customer's state or province. */
export type ICustomerAddressRegionInput = {
  /** The state or province name. */
  region: InputMaybe<Scalars["String"]["input"]>;
  /** The address region code. */
  region_code: InputMaybe<Scalars["String"]["input"]>;
  /** The unique ID for a pre-defined region. */
  region_id: InputMaybe<Scalars["Int"]["input"]>;
};

export type ICustomerAddresses = {
  /** An array containing the customer's shipping and billing addresses. */
  items: Maybe<Array<Maybe<ICustomerAddress>>>;
  /** Contains pagination metadata. */
  page_info: Maybe<ISearchResultPageInfo>;
  /** The total count of customer addresses. */
  total_count: Maybe<Scalars["Int"]["output"]>;
};

/** Customer attribute metadata. */
export type ICustomerAttributeMetadata = ICustomAttributeMetadataInterface & {
  /** The unique identifier for an attribute code. This value should be in lowercase letters without spaces. */
  code: Scalars["ID"]["output"];
  /** Default attribute value. */
  default_value: Maybe<Scalars["String"]["output"]>;
  /** The type of entity that defines the attribute. */
  entity_type: IAttributeEntityTypeEnum;
  /** The frontend class of the attribute. */
  frontend_class: Maybe<Scalars["String"]["output"]>;
  /** The frontend input type of the attribute. */
  frontend_input: Maybe<IAttributeFrontendInputEnum>;
  /** The template used for the input of the attribute (e.g., 'date'). */
  input_filter: Maybe<IInputFilterEnum>;
  /** Whether the attribute value is required. */
  is_required: Scalars["Boolean"]["output"];
  /** Whether the attribute value must be unique. */
  is_unique: Scalars["Boolean"]["output"];
  /** The label assigned to the attribute. */
  label: Maybe<Scalars["String"]["output"]>;
  /** The number of lines of the attribute value. */
  multiline_count: Maybe<Scalars["Int"]["output"]>;
  /** Attribute options. */
  options: Array<Maybe<ICustomAttributeOptionInterface>>;
  /** The position of the attribute in the form. */
  sort_order: Maybe<Scalars["Int"]["output"]>;
  /** The validation rules of the attribute value. */
  validate_rules: Maybe<Array<Maybe<IValidationRule>>>;
};

/** An input object for creating a customer. */
export type ICustomerCreateInput = {
  /** Indicates whether the customer has enabled remote shopping assistance. */
  allow_remote_shopping_assistance: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The customer's custom attributes. */
  custom_attributes: InputMaybe<Array<InputMaybe<IAttributeValueInput>>>;
  /** The customer's date of birth. */
  date_of_birth: InputMaybe<Scalars["String"]["input"]>;
  dob: InputMaybe<Scalars["String"]["input"]>;
  /** The customer's email address. */
  email: Scalars["String"]["input"];
  /** The customer's first name. */
  firstname: Scalars["String"]["input"];
  /** The customer's gender (Male - 1, Female - 2). */
  gender: InputMaybe<Scalars["Int"]["input"]>;
  /** Indicates whether the customer is subscribed to the company's newsletter. */
  is_subscribed: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The customer's family name. */
  lastname: Scalars["String"]["input"];
  /** The customer's middle name. */
  middlename: InputMaybe<Scalars["String"]["input"]>;
  /** The customer's password. */
  password: InputMaybe<Scalars["String"]["input"]>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix: InputMaybe<Scalars["String"]["input"]>;
  /** A value such as Sr., Jr., or III. */
  suffix: InputMaybe<Scalars["String"]["input"]>;
  /** The customer's Tax/VAT number (for corporate customers). */
  taxvat: InputMaybe<Scalars["String"]["input"]>;
};

/** Contains details about a single downloadable product. */
export type ICustomerDownloadableProduct = {
  /** The date and time the purchase was made. */
  date: Maybe<Scalars["String"]["output"]>;
  /** The fully qualified URL to the download file. */
  download_url: Maybe<Scalars["String"]["output"]>;
  /** The unique ID assigned to the item. */
  order_increment_id: Maybe<Scalars["String"]["output"]>;
  /** The remaining number of times the customer can download the product. */
  remaining_downloads: Maybe<Scalars["String"]["output"]>;
  /** Indicates when the product becomes available for download. Options are `Pending` and `Invoiced`. */
  status: Maybe<Scalars["String"]["output"]>;
};

/** Contains a list of downloadable products. */
export type ICustomerDownloadableProducts = {
  /** An array of purchased downloadable items. */
  items: Maybe<Array<Maybe<ICustomerDownloadableProduct>>>;
};

/** An input object that assigns or updates customer attributes. */
export type ICustomerInput = {
  /** The customer's date of birth. */
  date_of_birth: InputMaybe<Scalars["String"]["input"]>;
  dob: InputMaybe<Scalars["String"]["input"]>;
  /** The customer's email address. Required when creating a customer. */
  email: InputMaybe<Scalars["String"]["input"]>;
  /** The customer's first name. */
  firstname: InputMaybe<Scalars["String"]["input"]>;
  /** The customer's gender (Male - 1, Female - 2). */
  gender: InputMaybe<Scalars["Int"]["input"]>;
  /** Indicates whether the customer is subscribed to the company's newsletter. */
  is_subscribed: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The customer's family name. */
  lastname: InputMaybe<Scalars["String"]["input"]>;
  /** The customer's middle name. */
  middlename: InputMaybe<Scalars["String"]["input"]>;
  /** The customer's password. */
  password: InputMaybe<Scalars["String"]["input"]>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix: InputMaybe<Scalars["String"]["input"]>;
  /** A value such as Sr., Jr., or III. */
  suffix: InputMaybe<Scalars["String"]["input"]>;
  /** The customer's Tax/VAT number (for corporate customers). */
  taxvat: InputMaybe<Scalars["String"]["input"]>;
};

/** Contains details about each of the customer's orders. */
export type ICustomerOrder = {
  /** A list of additional attributes for the order. */
  additional_attributes: Array<Maybe<IOrderAttributeOutput>>;
  /** Coupons applied to the order. */
  applied_coupons: Array<Maybe<IAppliedCoupon>>;
  /** An array of gift cards applied to the order. */
  applied_gift_cards: Maybe<Array<Maybe<IApplyGiftCardToOrder>>>;
  /** List of available order actions. */
  available_actions: Array<Maybe<IOrderActionType>>;
  /** The billing address for the order. */
  billing_address: Maybe<IOrderAddress>;
  /** The shipping carrier for the order delivery. */
  carrier: Maybe<Scalars["String"]["output"]>;
  /** Comments about the order. */
  comments: Maybe<Array<Maybe<ISalesCommentItem>>>;
  /** @deprecated Use the `order_date` field instead. */
  created_at: Maybe<Scalars["String"]["output"]>;
  /** A list of credit memos. */
  credit_memos: Maybe<Array<Maybe<ICreditMemo>>>;
  /** Returns customer information from order. */
  customer_info: IOrderCustomerInfo;
  /** Order customer email. */
  email: Maybe<Scalars["String"]["output"]>;
  /** The entered gift message for the order */
  gift_message: Maybe<IGiftMessage>;
  /** Indicates whether the customer requested a gift receipt for the order. */
  gift_receipt_included: Scalars["Boolean"]["output"];
  /** The selected gift wrapping for the order. */
  gift_wrapping: Maybe<IGiftWrapping>;
  /** @deprecated Use the `totals.grand_total` field instead. */
  grand_total: Maybe<Scalars["Float"]["output"]>;
  /** Whether the order already has a withdrawal ID. */
  has_withdrawal: Scalars["Boolean"]["output"];
  /** The unique ID for a `CustomerOrder` object. */
  id: Scalars["ID"]["output"];
  /** @deprecated Use the `id` field instead. */
  increment_id: Maybe<Scalars["String"]["output"]>;
  /** A list of invoices for the order. */
  invoices: Array<Maybe<IInvoice>>;
  /** `TRUE` if the order is virtual */
  is_virtual: Scalars["Boolean"]["output"];
  /** An array containing the items purchased in this order. */
  items: Maybe<Array<Maybe<IOrderItemInterface>>>;
  /** A list of order items eligible to be in a return request. */
  items_eligible_for_return: Maybe<Array<Maybe<IOrderItemInterface>>>;
  loyalty_info: Maybe<IAppliedCampaign>;
  /** The order number. */
  number: Scalars["String"]["output"];
  /** The date the order was placed. */
  order_date: Scalars["String"]["output"];
  /** @deprecated Use the `number` field instead. */
  order_number: Scalars["String"]["output"];
  /** The order origin. */
  order_origin: Scalars["Int"]["output"];
  /** The order origin Label. */
  order_origin_label: Scalars["String"]["output"];
  /** The date the order status was last updated. */
  order_status_change_date: Scalars["String"]["output"];
  /** Provides the JTI Order Type for a given order */
  order_type: Maybe<IOrderTypeEnum>;
  /** Payment details for the order. */
  payment_methods: Maybe<Array<Maybe<IOrderPaymentMethod>>>;
  /** Indicates whether the customer requested a printed card for the order. */
  printed_card_included: Scalars["Boolean"]["output"];
  reasons: Maybe<Array<Maybe<IOrderStatusReason>>>;
  /** Return requests associated with this order. */
  returns: Maybe<IReturns>;
  /** A list of shipments for the order. */
  shipments: Maybe<Array<Maybe<IOrderShipment>>>;
  /** The shipping address for the order. */
  shipping_address: Maybe<IOrderAddress>;
  /** The delivery method for the order. */
  shipping_method: Maybe<Scalars["String"]["output"]>;
  shipping_method_code: Maybe<Scalars["String"]["output"]>;
  /** The current status of the order. */
  status: Scalars["String"]["output"];
  status_reason: Maybe<IStatusReason>;
  /** The store_code of the store. */
  store_code: Maybe<Scalars["String"]["output"]>;
  /** The token that can be used to retrieve the order using order query. */
  token: Scalars["String"]["output"];
  /** Details about the calculated totals for this order. */
  total: Maybe<IOrderTotal>;
  total_after_trial: Maybe<ITrialTotals>;
  total_including_trial: Maybe<ITrialTotals>;
  /** The website_code of the website. */
  website_code: Maybe<Scalars["String"]["output"]>;
  /** The withdrawal ID saved on the order, if any. */
  withdrawal_id: Maybe<Scalars["String"]["output"]>;
};

/** Contains details about each of the customer's orders. */
export type ICustomerOrderReturnsArgs = {
  currentPage?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

/** CustomerOrderSortInput specifies the field to use for sorting search results and indicates whether the results are sorted in ascending or descending order. */
export type ICustomerOrderSortInput = {
  /** This enumeration indicates whether to return results in ascending or descending order */
  sort_direction: ISortEnum;
  /** Specifies the field to use for sorting */
  sort_field: ICustomerOrderSortableField;
};

/** Specifies the field to use for sorting */
export enum ICustomerOrderSortableField {
  /** Sorts customer orders by created_at field */
  CreatedAt = "CREATED_AT",
  /** Sorts customer orders by number */
  Number = "NUMBER",
}

/** The collection of orders that match the conditions defined in the filter. */
export type ICustomerOrders = {
  /** Date of the first order placed in the store */
  date_of_first_order: Maybe<Scalars["String"]["output"]>;
  /** An array of customer orders. */
  items: Array<Maybe<ICustomerOrder>>;
  /** Contains pagination metadata. */
  page_info: Maybe<ISearchResultPageInfo>;
  /** The total count of customer orders. */
  total_count: Maybe<Scalars["Int"]["output"]>;
};

/** Identifies the filter to use for filtering orders. */
export type ICustomerOrdersFilterInput = {
  /** Filters by order base grand total value. */
  grand_total: InputMaybe<IFilterRangeTypeInput>;
  /** Filters by order number. */
  number: InputMaybe<IFilterStringTypeInput>;
  /** Filters by order created_at time. */
  order_date: InputMaybe<IFilterRangeTypeInput>;
  /** Filters by order status. */
  status: InputMaybe<IFilterStringTypeInput>;
};

/** Contains details about a newly-created or updated customer. */
export type ICustomerOutput = {
  /** Customer details after creating or updating a customer. */
  customer: ICustomer;
};

/** Contains payment tokens stored in the customer's vault. */
export type ICustomerPaymentTokens = {
  /** An array of payment tokens. */
  items: Array<Maybe<IPaymentToken>>;
};

/** Contains store credit information with balance and history. */
export type ICustomerStoreCredit = {
  /** Contains the customer's store credit balance history. If the history or store credit feature is disabled, then a null value will be returned. */
  balance_history: Maybe<ICustomerStoreCreditHistory>;
  /** The current balance of store credit. */
  current_balance: Maybe<IMoney>;
  /** Indicates whether store credits are enabled. If the feature is disabled, then the balance will not be returned. */
  enabled: Maybe<Scalars["Boolean"]["output"]>;
};

/** Contains store credit information with balance and history. */
export type ICustomerStoreCreditBalance_HistoryArgs = {
  currentPage?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Lists changes to the amount of store credit available to the customer. */
export type ICustomerStoreCreditHistory = {
  /** An array containing information about changes to the store credit available to the customer. */
  items: Maybe<Array<Maybe<ICustomerStoreCreditHistoryItem>>>;
  /** Metadata for pagination rendering. */
  page_info: Maybe<ISearchResultPageInfo>;
  /** The number of items returned. */
  total_count: Maybe<Scalars["Int"]["output"]>;
};

/** Contains store credit history information. */
export type ICustomerStoreCreditHistoryItem = {
  /** The action that was made on the store credit. */
  action: Maybe<Scalars["String"]["output"]>;
  /** The store credit available to the customer as a result of this action.  */
  actual_balance: Maybe<IMoney>;
  /** The amount added to or subtracted from the store credit as a result of this action. */
  balance_change: Maybe<IMoney>;
  /** The date and time when the store credit change was made. */
  date_time_changed: Maybe<Scalars["String"]["output"]>;
};

/** Contains a customer authorization token. */
export type ICustomerToken = {
  /** The customer authorization token. */
  token: Maybe<Scalars["String"]["output"]>;
};

/** An input object for updating a customer. */
export type ICustomerUpdateInput = {
  /** Indicates whether the customer has enabled remote shopping assistance. */
  allow_remote_shopping_assistance: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The customer's custom attributes. */
  custom_attributes: InputMaybe<Array<InputMaybe<IAttributeValueInput>>>;
  /** The customer's date of birth. */
  date_of_birth: InputMaybe<Scalars["String"]["input"]>;
  dob: InputMaybe<Scalars["String"]["input"]>;
  /** The customer's first name. */
  firstname: InputMaybe<Scalars["String"]["input"]>;
  /** The customer's gender (Male - 1, Female - 2). */
  gender: InputMaybe<Scalars["Int"]["input"]>;
  /** Indicates whether the customer is subscribed to the company's newsletter. */
  is_subscribed: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The customer's family name. */
  lastname: InputMaybe<Scalars["String"]["input"]>;
  /** The customer's middle name. */
  middlename: InputMaybe<Scalars["String"]["input"]>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix: InputMaybe<Scalars["String"]["input"]>;
  /** A value such as Sr., Jr., or III. */
  suffix: InputMaybe<Scalars["String"]["input"]>;
  /** The customer's Tax/VAT number (for corporate customers). */
  taxvat: InputMaybe<Scalars["String"]["input"]>;
};

/** Contains information about a text area that is defined as part of a customizable option. */
export type ICustomizableAreaOption = ICustomizableOptionInterface & {
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id: Maybe<Scalars["Int"]["output"]>;
  /** The Stock Keeping Unit of the base product. */
  product_sku: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether the option is required. */
  required: Maybe<Scalars["Boolean"]["output"]>;
  /** The order in which the option is displayed. */
  sort_order: Maybe<Scalars["Int"]["output"]>;
  /** The display name for this option. */
  title: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars["ID"]["output"];
  /** An object that defines a text area. */
  value: Maybe<ICustomizableAreaValue>;
};

/** Defines the price and sku of a product whose page contains a customized text area. */
export type ICustomizableAreaValue = {
  /** The maximum number of characters that can be entered for this customizable option. */
  max_characters: Maybe<Scalars["Int"]["output"]>;
  /** The price assigned to this option. */
  price: Maybe<Scalars["Float"]["output"]>;
  /** FIXED, PERCENT, or DYNAMIC. */
  price_type: Maybe<IPriceTypeEnum>;
  /** The Stock Keeping Unit for this option. */
  sku: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `CustomizableAreaValue` object. */
  uid: Scalars["ID"]["output"];
};

/** Contains information about a set of checkbox values that are defined as part of a customizable option. */
export type ICustomizableCheckboxOption = ICustomizableOptionInterface & {
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id: Maybe<Scalars["Int"]["output"]>;
  /** Indicates whether the option is required. */
  required: Maybe<Scalars["Boolean"]["output"]>;
  /** The order in which the option is displayed. */
  sort_order: Maybe<Scalars["Int"]["output"]>;
  /** The display name for this option. */
  title: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars["ID"]["output"];
  /** An array that defines a set of checkbox values. */
  value: Maybe<Array<Maybe<ICustomizableCheckboxValue>>>;
};

/** Defines the price and sku of a product whose page contains a customized set of checkbox values. */
export type ICustomizableCheckboxValue = {
  /** The ID assigned to the value. */
  option_type_id: Maybe<Scalars["Int"]["output"]>;
  /** The price assigned to this option. */
  price: Maybe<Scalars["Float"]["output"]>;
  /** FIXED, PERCENT, or DYNAMIC. */
  price_type: Maybe<IPriceTypeEnum>;
  /** The Stock Keeping Unit for this option. */
  sku: Maybe<Scalars["String"]["output"]>;
  /** The order in which the checkbox value is displayed. */
  sort_order: Maybe<Scalars["Int"]["output"]>;
  /** The display name for this option. */
  title: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `CustomizableCheckboxValue` object. */
  uid: Scalars["ID"]["output"];
};

/** Contains information about a date picker that is defined as part of a customizable option. */
export type ICustomizableDateOption = ICustomizableOptionInterface & {
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id: Maybe<Scalars["Int"]["output"]>;
  /** The Stock Keeping Unit of the base product. */
  product_sku: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether the option is required. */
  required: Maybe<Scalars["Boolean"]["output"]>;
  /** The order in which the option is displayed. */
  sort_order: Maybe<Scalars["Int"]["output"]>;
  /** The display name for this option. */
  title: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars["ID"]["output"];
  /** An object that defines a date field in a customizable option. */
  value: Maybe<ICustomizableDateValue>;
};

/** Defines the customizable date type. */
export enum ICustomizableDateTypeEnum {
  Date = "DATE",
  DateTime = "DATE_TIME",
  Time = "TIME",
}

/** Defines the price and sku of a product whose page contains a customized date picker. */
export type ICustomizableDateValue = {
  /** The price assigned to this option. */
  price: Maybe<Scalars["Float"]["output"]>;
  /** FIXED, PERCENT, or DYNAMIC. */
  price_type: Maybe<IPriceTypeEnum>;
  /** The Stock Keeping Unit for this option. */
  sku: Maybe<Scalars["String"]["output"]>;
  /** DATE, DATE_TIME or TIME */
  type: Maybe<ICustomizableDateTypeEnum>;
  /** The unique ID for a `CustomizableDateValue` object. */
  uid: Scalars["ID"]["output"];
};

/** Contains information about a drop down menu that is defined as part of a customizable option. */
export type ICustomizableDropDownOption = ICustomizableOptionInterface & {
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id: Maybe<Scalars["Int"]["output"]>;
  /** Indicates whether the option is required. */
  required: Maybe<Scalars["Boolean"]["output"]>;
  /** The order in which the option is displayed. */
  sort_order: Maybe<Scalars["Int"]["output"]>;
  /** The display name for this option. */
  title: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars["ID"]["output"];
  /** An array that defines the set of options for a drop down menu. */
  value: Maybe<Array<Maybe<ICustomizableDropDownValue>>>;
};

/** Defines the price and sku of a product whose page contains a customized drop down menu. */
export type ICustomizableDropDownValue = {
  /** The ID assigned to the value. */
  option_type_id: Maybe<Scalars["Int"]["output"]>;
  /** The price assigned to this option. */
  price: Maybe<Scalars["Float"]["output"]>;
  /** FIXED, PERCENT, or DYNAMIC. */
  price_type: Maybe<IPriceTypeEnum>;
  /** The Stock Keeping Unit for this option. */
  sku: Maybe<Scalars["String"]["output"]>;
  /** The order in which the option is displayed. */
  sort_order: Maybe<Scalars["Int"]["output"]>;
  /** The display name for this option. */
  title: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `CustomizableDropDownValue` object. */
  uid: Scalars["ID"]["output"];
};

/** Contains information about a text field that is defined as part of a customizable option. */
export type ICustomizableFieldOption = ICustomizableOptionInterface & {
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id: Maybe<Scalars["Int"]["output"]>;
  /** The Stock Keeping Unit of the base product. */
  product_sku: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether the option is required. */
  required: Maybe<Scalars["Boolean"]["output"]>;
  /** The order in which the option is displayed. */
  sort_order: Maybe<Scalars["Int"]["output"]>;
  /** The display name for this option. */
  title: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars["ID"]["output"];
  /** An object that defines a text field. */
  value: Maybe<ICustomizableFieldValue>;
};

/** Defines the price and sku of a product whose page contains a customized text field. */
export type ICustomizableFieldValue = {
  /** The maximum number of characters that can be entered for this customizable option. */
  max_characters: Maybe<Scalars["Int"]["output"]>;
  /** The price of the custom value. */
  price: Maybe<Scalars["Float"]["output"]>;
  /** FIXED, PERCENT, or DYNAMIC. */
  price_type: Maybe<IPriceTypeEnum>;
  /** The Stock Keeping Unit for this option. */
  sku: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `CustomizableFieldValue` object. */
  uid: Scalars["ID"]["output"];
};

/** Contains information about a file picker that is defined as part of a customizable option. */
export type ICustomizableFileOption = ICustomizableOptionInterface & {
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id: Maybe<Scalars["Int"]["output"]>;
  /** The Stock Keeping Unit of the base product. */
  product_sku: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether the option is required. */
  required: Maybe<Scalars["Boolean"]["output"]>;
  /** The order in which the option is displayed. */
  sort_order: Maybe<Scalars["Int"]["output"]>;
  /** The display name for this option. */
  title: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars["ID"]["output"];
  /** An object that defines a file value. */
  value: Maybe<ICustomizableFileValue>;
};

/** Defines the price and sku of a product whose page contains a customized file picker. */
export type ICustomizableFileValue = {
  /** The file extension to accept. */
  file_extension: Maybe<Scalars["String"]["output"]>;
  /** The maximum width of an image. */
  image_size_x: Maybe<Scalars["Int"]["output"]>;
  /** The maximum height of an image. */
  image_size_y: Maybe<Scalars["Int"]["output"]>;
  /** The price assigned to this option. */
  price: Maybe<Scalars["Float"]["output"]>;
  /** FIXED, PERCENT, or DYNAMIC. */
  price_type: Maybe<IPriceTypeEnum>;
  /** The Stock Keeping Unit for this option. */
  sku: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `CustomizableFileValue` object. */
  uid: Scalars["ID"]["output"];
};

/** Contains information about a multiselect that is defined as part of a customizable option. */
export type ICustomizableMultipleOption = ICustomizableOptionInterface & {
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id: Maybe<Scalars["Int"]["output"]>;
  /** Indicates whether the option is required. */
  required: Maybe<Scalars["Boolean"]["output"]>;
  /** The order in which the option is displayed. */
  sort_order: Maybe<Scalars["Int"]["output"]>;
  /** The display name for this option. */
  title: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars["ID"]["output"];
  /** An array that defines the set of options for a multiselect. */
  value: Maybe<Array<Maybe<ICustomizableMultipleValue>>>;
};

/** Defines the price and sku of a product whose page contains a customized multiselect. */
export type ICustomizableMultipleValue = {
  /** The ID assigned to the value. */
  option_type_id: Maybe<Scalars["Int"]["output"]>;
  /** The price assigned to this option. */
  price: Maybe<Scalars["Float"]["output"]>;
  /** FIXED, PERCENT, or DYNAMIC. */
  price_type: Maybe<IPriceTypeEnum>;
  /** The Stock Keeping Unit for this option. */
  sku: Maybe<Scalars["String"]["output"]>;
  /** The order in which the option is displayed. */
  sort_order: Maybe<Scalars["Int"]["output"]>;
  /** The display name for this option. */
  title: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `CustomizableMultipleValue` object. */
  uid: Scalars["ID"]["output"];
};

/** Defines a customizable option. */
export type ICustomizableOptionInput = {
  /** The customizable option ID of the product. */
  id: InputMaybe<Scalars["Int"]["input"]>;
  /** The unique ID for a `CartItemInterface` object. */
  uid: InputMaybe<Scalars["ID"]["input"]>;
  /** The string value of the option. */
  value_string: Scalars["String"]["input"];
};

/** Contains basic information about a customizable option. It can be implemented by several types of configurable options. */
export type ICustomizableOptionInterface = {
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id: Maybe<Scalars["Int"]["output"]>;
  /** Indicates whether the option is required. */
  required: Maybe<Scalars["Boolean"]["output"]>;
  /** The order in which the option is displayed. */
  sort_order: Maybe<Scalars["Int"]["output"]>;
  /** The display name for this option. */
  title: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars["ID"]["output"];
};

/** Contains information about customizable product options. */
export type ICustomizableProductInterface = {
  /** An array of options for a customizable product. */
  options: Maybe<Array<Maybe<ICustomizableOptionInterface>>>;
};

/** Contains information about a set of radio buttons that are defined as part of a customizable option. */
export type ICustomizableRadioOption = ICustomizableOptionInterface & {
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id: Maybe<Scalars["Int"]["output"]>;
  /** Indicates whether the option is required. */
  required: Maybe<Scalars["Boolean"]["output"]>;
  /** The order in which the option is displayed. */
  sort_order: Maybe<Scalars["Int"]["output"]>;
  /** The display name for this option. */
  title: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars["ID"]["output"];
  /** An array that defines a set of radio buttons. */
  value: Maybe<Array<Maybe<ICustomizableRadioValue>>>;
};

/** Defines the price and sku of a product whose page contains a customized set of radio buttons. */
export type ICustomizableRadioValue = {
  /** The ID assigned to the value. */
  option_type_id: Maybe<Scalars["Int"]["output"]>;
  /** The price assigned to this option. */
  price: Maybe<Scalars["Float"]["output"]>;
  /** FIXED, PERCENT, or DYNAMIC. */
  price_type: Maybe<IPriceTypeEnum>;
  /** The Stock Keeping Unit for this option. */
  sku: Maybe<Scalars["String"]["output"]>;
  /** The order in which the radio button is displayed. */
  sort_order: Maybe<Scalars["Int"]["output"]>;
  /** The display name for this option. */
  title: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `CustomizableRadioValue` object. */
  uid: Scalars["ID"]["output"];
};

/** Contains the results of the request to delete a compare list. */
export type IDeleteCompareListOutput = {
  /** Indicates whether the compare list was successfully deleted. */
  result: Scalars["Boolean"]["output"];
};

/** Indicates whether the request succeeded and returns the remaining customer payment tokens. */
export type IDeletePaymentTokenOutput = {
  /** A container for the customer's remaining payment tokens. */
  customerPaymentTokens: Maybe<ICustomerPaymentTokens>;
  /** Indicates whether the request succeeded. */
  result: Scalars["Boolean"]["output"];
};

/** Contains the status of the request to delete a wish list and an array of the customer's remaining wish lists. */
export type IDeleteWishlistOutput = {
  /** Indicates whether the wish list was deleted. */
  status: Scalars["Boolean"]["output"];
  /** A list of undeleted wish lists. */
  wishlists: Array<Maybe<IWishlist>>;
};

export type IDeliveryLimits = {
  /** country id */
  country_id: Maybe<Scalars["String"]["output"]>;
  /** id */
  id: Maybe<Scalars["String"]["output"]>;
  /** city/province name */
  name: Maybe<Scalars["String"]["output"]>;
};

/** A province, matching an entry of the native available_regions query. */
export type IDeliveryProvince = {
  /** Directory region code — this is what the address payload expects in region_code. */
  code: Maybe<Scalars["String"]["output"]>;
  /** Directory region name. */
  name: Maybe<Scalars["String"]["output"]>;
  /** Directory region ID, the same value as Region.id. */
  region_id: Scalars["Int"]["output"];
};

/** A delivery region and the provinces it covers. */
export type IDeliveryRegion = {
  /** Region code, matching the product `region` attribute. Send this value in the region header. */
  code: Scalars["String"]["output"];
  /** True for the region covering every province not explicitly assigned elsewhere. */
  is_default: Maybe<Scalars["Boolean"]["output"]>;
  /** Translated region name for display. */
  label: Maybe<Scalars["String"]["output"]>;
  /** Value of the product `region` attribute mapped to this region. Option IDs are assigned per environment, so never hard-code one. Prefer `ProductInterface.region_code`, which resolves this server-side. Null when the admin has not mapped the region yet; if more than one option were ever mapped to it, the lowest is returned. */
  product_attribute_option_id: Maybe<Scalars["Int"]["output"]>;
  /** Every province in this region, fully expanded, so the address form can offer only the provinces valid for the selected region. */
  provinces: Maybe<Array<Maybe<IDeliveryProvince>>>;
};

/** Defines an individual discount. A discount can be applied to the cart as a whole or to an item, shipping. */
export type IDiscount = {
  /** The amount of the discount. */
  amount: IMoney;
  /** The type of the entity the discount is applied to. */
  applied_to: ICartDiscountType;
  /** The coupon related to the discount. */
  coupon: Maybe<IAppliedCoupon>;
  /** A valid single coupon code. */
  coupon_code: Maybe<Scalars["String"]["output"]>;
  /** A description of the discount. */
  label: Scalars["String"]["output"];
};

/** An implementation for downloadable product cart items. */
export type IDownloadableCartItem = ICartItemInterface & {
  /** An array containing the customizable options the shopper selected. */
  customizable_options: Array<Maybe<ISelectedCustomizableOption>>;
  /** An array of errors encountered while loading the cart item */
  errors: Maybe<Array<Maybe<ICartItemError>>>;
  /** Provides info regarding the gift added to the basket */
  gift_data: Maybe<IGiftData>;
  /** Provides the flag to show if consent was set or not */
  has_registration_consent: Maybe<Scalars["Boolean"]["output"]>;
  /** @deprecated Use `uid` instead. */
  id: Scalars["String"]["output"];
  /** True if requested quantity is less than available stock, false otherwise. */
  is_available: Scalars["Boolean"]["output"];
  /** An array containing information about the links for the downloadable product added to the cart. */
  links: Maybe<Array<Maybe<IDownloadableProductLinks>>>;
  /** Message to display when the product is not available with this selected option. */
  not_available_message: Maybe<Scalars["String"]["output"]>;
  /** Contains details about the price of the item, including taxes and discounts. */
  prices: Maybe<ICartItemPrices>;
  /** Details about an item in the cart. */
  product: IProductInterface;
  /** The quantity of this item in the cart. */
  quantity: Scalars["Float"]["output"];
  /** An array containing information about samples of the selected downloadable product. */
  samples: Maybe<Array<Maybe<IDownloadableProductSamples>>>;
  /** The unique ID for a `CartItemInterface` object. */
  uid: Scalars["ID"]["output"];
};

/** Defines downloadable product options for `CreditMemoItemInterface`. */
export type IDownloadableCreditMemoItem = ICreditMemoItemInterface & {
  /** Details about the final discount amount for the base product, including discounts on options. */
  discounts: Maybe<Array<Maybe<IDiscount>>>;
  /** A list of downloadable links that are refunded from the downloadable product. */
  downloadable_links: Maybe<Array<Maybe<IDownloadableItemsLinks>>>;
  /** The unique ID for a `CreditMemoItemInterface` object. */
  id: Scalars["ID"]["output"];
  /** The order item the credit memo is applied to. */
  order_item: Maybe<IOrderItemInterface>;
  /** The name of the base product. */
  product_name: Maybe<Scalars["String"]["output"]>;
  /** The sale price for the base product, including selected options. */
  product_sale_price: IMoney;
  /** The SKU of the base product. */
  product_sku: Scalars["String"]["output"];
  /** The number of refunded items. */
  quantity_refunded: Maybe<Scalars["Float"]["output"]>;
};

export enum IDownloadableFileTypeEnum {
  /** @deprecated `sample_url` serves to get the downloadable sample */
  File = "FILE",
  /** @deprecated `sample_url` serves to get the downloadable sample */
  Url = "URL",
}

/** Defines downloadable product options for `InvoiceItemInterface`. */
export type IDownloadableInvoiceItem = IInvoiceItemInterface & {
  /** Information about the final discount amount for the base product, including discounts on options. */
  discounts: Maybe<Array<Maybe<IDiscount>>>;
  /** A list of downloadable links that are invoiced from the downloadable product. */
  downloadable_links: Maybe<Array<Maybe<IDownloadableItemsLinks>>>;
  /** The unique ID for an `InvoiceItemInterface` object. */
  id: Scalars["ID"]["output"];
  /** Details about an individual order item. */
  order_item: Maybe<IOrderItemInterface>;
  /** The name of the base product. */
  product_name: Maybe<Scalars["String"]["output"]>;
  /** The sale price for the base product including selected options. */
  product_sale_price: IMoney;
  /** The SKU of the base product. */
  product_sku: Scalars["String"]["output"];
  /** The number of invoiced items. */
  quantity_invoiced: Maybe<Scalars["Float"]["output"]>;
};

/** Defines characteristics of the links for downloadable product. */
export type IDownloadableItemsLinks = {
  /** A number indicating the sort order. */
  sort_order: Maybe<Scalars["Int"]["output"]>;
  /** The display name of the link. */
  title: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `DownloadableItemsLinks` object. */
  uid: Scalars["ID"]["output"];
};

/** Defines downloadable product options for `OrderItemInterface`. */
export type IDownloadableOrderItem = IOrderItemInterface & {
  /** The final discount information for the product. */
  discounts: Maybe<Array<Maybe<IDiscount>>>;
  /** A list of downloadable links that are ordered from the downloadable product. */
  downloadable_links: Maybe<Array<Maybe<IDownloadableItemsLinks>>>;
  /** Indicates whether the order item is eligible to be in a return request. */
  eligible_for_return: Maybe<Scalars["Boolean"]["output"]>;
  /** The entered option for the base product, such as a logo or image. */
  entered_options: Maybe<Array<Maybe<IOrderItemOption>>>;
  /** Provides info regarding the gift added to the basket */
  gift_data: Maybe<IGiftData>;
  /** The selected gift message for the order item */
  gift_message: Maybe<IGiftMessage>;
  /** The selected gift wrapping for the order item. */
  gift_wrapping: Maybe<IGiftWrapping>;
  /** Provides the flag to show if consent was set or not */
  has_registration_consent: Maybe<Scalars["Boolean"]["output"]>;
  /** The unique ID for an `OrderItemInterface` object. */
  id: Scalars["ID"]["output"];
  /** The original product price of the base product. */
  original_price: IMoney;
  /** Contains details about the price of the item, including taxes and discounts. */
  prices: Maybe<IOrderItemPrices>;
  /** The ProductInterface object, which contains details about the base product */
  product: Maybe<IProductInterface>;
  /** The name of the base product. */
  product_name: Maybe<Scalars["String"]["output"]>;
  /** The sale price of the base product, including selected options. */
  product_sale_price: IMoney;
  /** The sale price of the base product, including tax. */
  product_sale_price_incl_tax: IMoney;
  /** The SKU of the base product. */
  product_sku: Scalars["String"]["output"];
  /** Indicates whether this product has subscription flag. */
  product_subscription: Maybe<Scalars["Boolean"]["output"]>;
  /** The type of product, such as simple, configurable, etc. */
  product_type: Maybe<Scalars["String"]["output"]>;
  /** URL key of the base product. */
  product_url_key: Maybe<Scalars["String"]["output"]>;
  /** The number of canceled items. */
  quantity_canceled: Maybe<Scalars["Float"]["output"]>;
  /** The number of invoiced items. */
  quantity_invoiced: Maybe<Scalars["Float"]["output"]>;
  /** The number of units ordered for this item. */
  quantity_ordered: Maybe<Scalars["Float"]["output"]>;
  /** The number of refunded items. */
  quantity_refunded: Maybe<Scalars["Float"]["output"]>;
  /** The requested return quantity of the item. */
  quantity_return_requested: Maybe<Scalars["Float"]["output"]>;
  /** The number of returned items. */
  quantity_returned: Maybe<Scalars["Float"]["output"]>;
  /** The number of shipped items. */
  quantity_shipped: Maybe<Scalars["Float"]["output"]>;
  /** Row total for product. */
  row_total: IMoney;
  /** Row total for product including tax. */
  row_total_incl_tax: IMoney;
  /** The selected options for the base product, such as color or size. */
  selected_options: Maybe<Array<Maybe<IOrderItemOption>>>;
  /** The status of the order item. */
  status: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether the product is eligible for a trade-in purchase. */
  trade_in: Scalars["Int"]["output"];
};

/** Defines a product that the shopper downloads. */
export type IDownloadableProduct = ICustomizableProductInterface &
  IProductInterface &
  IRoutableInterface & {
    /** @deprecated Use the `custom_attributes` field instead. */
    about_manufacturer: Maybe<Scalars["String"]["output"]>;
    /**
     * The attribute set assigned to the product.
     * @deprecated The field should not be used on the storefront.
     */
    attribute_set_id: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    available_date: Maybe<Scalars["String"]["output"]>;
    /**
     * Whether the product is explicitly available for Mobile App commerce exposure. 1 = eligible, 0 or null = not eligible.
     * @deprecated Use the `custom_attributes` field instead.
     */
    available_for_mobile_app: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    battery: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    buy_cta_pdp: Maybe<Scalars["Int"]["output"]>;
    /** CTA for PDP attribute translated label . */
    buy_cta_pdp_label: Scalars["String"]["output"];
    /** @deprecated Use the `custom_attributes` field instead. */
    buy_cta_plp: Maybe<Scalars["Int"]["output"]>;
    /** CTA for PLP attribute translated label . */
    buy_cta_plp_label: Scalars["String"]["output"];
    /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
    canonical_url: Maybe<Scalars["String"]["output"]>;
    /** The categories assigned to a product. */
    categories: Maybe<Array<Maybe<ICategoryInterface>>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    charging_time: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    color: Maybe<Scalars["Int"]["output"]>;
    /** Color attribute label. */
    color_label: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    connectors: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    connectors_1: Maybe<Scalars["String"]["output"]>;
    /** The product's country of origin. */
    country_of_manufacture: Maybe<Scalars["String"]["output"]>;
    /**
     * Timestamp indicating when the product was created.
     * @deprecated The field should not be used on the storefront.
     */
    created_at: Maybe<Scalars["String"]["output"]>;
    /** An array of cross-sell products. */
    crosssell_products: Maybe<Array<Maybe<IProductInterface>>>;
    /** Product custom attributes. */
    custom_attributesV2: Maybe<IProductCustomAttributes>;
    /** Delivery region this product may be shipped to — `ES` or `IC`, the same vocabulary as the region header and getDeliveryRegions.code. Distinct from `region_code` on address types, which carries a province code. Null when the product carries no region, or its attribute value is not mapped to one; either way the product is undeliverable everywhere. */
    delivery_region_code: Maybe<Scalars["String"]["output"]>;
    /** Detailed information about the product. The value can include simple HTML tags. */
    description: Maybe<IComplexTextValue>;
    /** @deprecated Use the `custom_attributes` field instead. */
    device_dimensions: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    dimensions: Maybe<Scalars["String"]["output"]>;
    /** An array containing information about the links for this downloadable product. */
    downloadable_product_links: Maybe<Array<Maybe<IDownloadableProductLinks>>>;
    /** An array containing information about samples of this downloadable product. */
    downloadable_product_samples: Maybe<Array<Maybe<IDownloadableProductSamples>>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    enable_lifetime_quantity_limit: Maybe<Scalars["Int"]["output"]>;
    /**
     * Is quantity limit enabled for this product
     * @deprecated Use the `custom_attributes` field instead.
     */
    enable_order_quantity_limit: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    experience: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    flavor: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    flavor_family: Maybe<Scalars["String"]["output"]>;
    /** Color attribute label. */
    flavor_label: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    flavour: Maybe<Scalars["Int"]["output"]>;
    /** Get all details for flavour */
    flavour_details: Array<Maybe<IFlavourDetails>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    formula: Maybe<Scalars["Int"]["output"]>;
    /** A list of gift options for the given product */
    free_gifts: Maybe<IFreeGiftProductData>;
    /** Returns all attribute values and labels marked as visible on storefront */
    frontend_attributes: Maybe<Array<Maybe<IFrontendAttribute>>>;
    /** Returns a value indicating gift message availability for the product. */
    gift_message_available: Scalars["Boolean"]["output"];
    /** Returns a value indicating gift wrapping availability for the product. */
    gift_wrapping_available: Scalars["Boolean"]["output"];
    /** Returns value and currency indicating gift wrapping price for the product. */
    gift_wrapping_price: Maybe<IMoney>;
    /** @deprecated Use the `custom_attributes` field instead. */
    has_device: Maybe<Scalars["Int"]["output"]>;
    /** Provides the flag to show if consent is required or not */
    has_registration_consent: Maybe<Scalars["Boolean"]["output"]>;
    /** Product is hidden_sku or not */
    hidden_sku: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * The ID number assigned to the product.
     * @deprecated Use the `uid` field instead.
     */
    id: Maybe<Scalars["Int"]["output"]>;
    /** The relative path to the main image on the product page. */
    image: Maybe<IProductImage>;
    /** @deprecated Use the `custom_attributes` field instead. */
    importer: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    input_terminal: Maybe<Scalars["Int"]["output"]>;
    /** Product discontinued flag */
    is_discontinued: Maybe<Scalars["Boolean"]["output"]>;
    /** Indicates whether the product can be returned. */
    is_returnable: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    jti_brand_matrix: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    jti_category_redirect: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    jti_product_discontinued: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    jti_sku_redirect: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    large_stick_tray: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    lifetime_quantity_limit: Maybe<Scalars["Int"]["output"]>;
    /** A value of 1 indicates that each link in the array must be purchased separately. */
    links_purchased_separately: Maybe<Scalars["Int"]["output"]>;
    /** The heading above the list of downloadable products. */
    links_title: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    main_specifications: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    mandatory_positive_consent: Maybe<Scalars["Int"]["output"]>;
    /**
     * A number representing the product's manufacturer.
     * @deprecated Use the `custom_attributes` field instead.
     */
    manufacturer: Maybe<Scalars["Int"]["output"]>;
    /** Product subscription format */
    manufacturer_label: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    material: Maybe<Scalars["String"]["output"]>;
    /** Maximum Qty Allowed in Shopping Cart */
    max_sale_qty: Maybe<Scalars["Float"]["output"]>;
    /** An array of media gallery objects. */
    media_gallery: Maybe<Array<Maybe<IMediaGalleryInterface>>>;
    /**
     * An array of MediaGalleryEntry objects.
     * @deprecated Use `media_gallery` instead.
     */
    media_gallery_entries: Maybe<Array<Maybe<IMediaGalleryEntry>>>;
    /** A brief overview of the product for search results listings, maximum 255 characters. */
    meta_description: Maybe<Scalars["String"]["output"]>;
    /** A comma-separated list of keywords that are visible only to search engines. */
    meta_keyword: Maybe<Scalars["String"]["output"]>;
    /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
    meta_title: Maybe<Scalars["String"]["output"]>;
    /** Minimum Qty Allowed in Shopping Cart */
    min_sale_qty: Maybe<Scalars["Float"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    minimum_amount: Maybe<Scalars["Float"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    minimum_amount_type: Maybe<Scalars["String"]["output"]>;
    /**
     * Multipack description for this product
     * @deprecated Use the `custom_attributes` field instead.
     */
    multipack_description: Maybe<Scalars["String"]["output"]>;
    /** Is multipacks selected enabled for this product */
    multipack_enabled: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * Multipack label for this product
     * @deprecated Use the `custom_attributes` field instead.
     */
    multipack_label: Maybe<Scalars["String"]["output"]>;
    /** Multipack price text for this product */
    multipack_price: Maybe<Scalars["String"]["output"]>;
    /** Multipack Products */
    multipack_products: Maybe<Array<Maybe<IProductInterface>>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    multipacks_enabled: Maybe<Scalars["Int"]["output"]>;
    /** The product name. Customers use this name to identify the product. */
    name: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    name_and_model: Maybe<Scalars["String"]["output"]>;
    /** The beginning date for new product listings, and determines if the product is featured as a new product. */
    new_from_date: Maybe<Scalars["String"]["output"]>;
    /** The end date for new product listings. */
    new_to_date: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    non_trade_in_sku: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    number_of_packs: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    number_of_sticks: Maybe<Scalars["Int"]["output"]>;
    /** Product stock only x left count */
    only_x_left_in_stock: Maybe<Scalars["Float"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    option_grouped_by_brand: Maybe<Scalars["Int"]["output"]>;
    /** An array of options for a customizable product. */
    options: Maybe<Array<Maybe<ICustomizableOptionInterface>>>;
    /** If the product has multiple options, determines where they appear on the product page. */
    options_container: Maybe<Scalars["String"]["output"]>;
    /**
     * Maximum quantity allowed per one order
     * @deprecated Use the `custom_attributes` field instead.
     */
    order_quantity_limit: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    portable_stick_tray: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    pouch_size: Maybe<Scalars["Int"]["output"]>;
    /**
     * Indicates the price of an item.
     * @deprecated Use `price_range` for product price information.
     */
    price: Maybe<IProductPrices>;
    /** The range of prices for the product */
    price_range: IPriceRange;
    /** An array of `TierPrice` objects. */
    price_tiers: Maybe<Array<Maybe<ITierPrice>>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_brand: Maybe<Scalars["String"]["output"]>;
    /** Product Brand Label */
    product_brand_label: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_category: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_category_type: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_color: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_disclaimer: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_family: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_generation: Maybe<Scalars["String"]["output"]>;
    /** An array of `ProductLinks` objects. */
    product_links: Maybe<Array<Maybe<IProductLinksInterface>>>;
    /** Get all special offers for a product. */
    promotionalOffers: Array<Maybe<ISpecialOffer>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    province: Maybe<Scalars["String"]["output"]>;
    /** Product provence label for PLP attribute. */
    province_label: Maybe<Scalars["String"]["output"]>;
    /** Amount of available stock */
    quantity: Maybe<Scalars["Float"]["output"]>;
    /** The average of all the ratings given to the product. */
    rating_summary: Scalars["Float"]["output"];
    /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
    redirect_code: Scalars["Int"]["output"];
    /** Redirect category URL path for discontinued product */
    redirect_product_category: Maybe<Scalars["String"]["output"]>;
    /** Redirect product SKU for discontinued product */
    redirect_sku: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    region: Maybe<Scalars["Int"]["output"]>;
    /** Product Region attribute translated label. */
    region_label: Maybe<Scalars["String"]["output"]>;
    /** An array of related products. */
    related_products: Maybe<Array<Maybe<IProductInterface>>>;
    /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
    relative_url: Maybe<Scalars["String"]["output"]>;
    /** The total count of all the reviews given to the product. */
    review_count: Scalars["Int"]["output"];
    /** @deprecated Use the `custom_attributes` field instead. */
    review_eligible: Maybe<Scalars["Int"]["output"]>;
    /** The list of products reviews. */
    reviews: IProductReviews;
    /** A short description of the product. Its use depends on the theme. */
    short_description: Maybe<IComplexTextValue>;
    /** @deprecated Use the `custom_attributes` field instead. */
    size: Maybe<Scalars["String"]["output"]>;
    /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
    sku: Maybe<Scalars["String"]["output"]>;
    /** The relative path to the small image, which is used on catalog pages. */
    small_image: Maybe<IProductImage>;
    /** Get all special offers for a product. */
    specialOffers: Array<Maybe<ISpecialOffer>>;
    /**
     * The beginning date that a product has a special price.
     * @deprecated The field should not be used on the storefront.
     */
    special_from_date: Maybe<Scalars["String"]["output"]>;
    /** The discounted price of the product. */
    special_price: Maybe<Scalars["Float"]["output"]>;
    /** The end date for a product with a special price. */
    special_to_date: Maybe<Scalars["String"]["output"]>;
    /** Indicates whether the product is staged for a future campaign. */
    staged: Scalars["Boolean"]["output"];
    /** @deprecated Use the `custom_attributes` field instead. */
    stick_capability: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    stick_compatibility: Maybe<Scalars["String"]["output"]>;
    /** Stock status of the product */
    stock_status: Maybe<IProductStockStatus>;
    /** @deprecated Use the `custom_attributes` field instead. */
    strength: Maybe<Scalars["Int"]["output"]>;
    /** Get all details for strength */
    strength_details: Maybe<IStrengthDetails>;
    /** @deprecated Use the `custom_attributes` field instead. */
    subscription: Maybe<Scalars["Int"]["output"]>;
    /**
     * Product subscription format
     * @deprecated Use the `custom_attributes` field instead.
     */
    subscription_format: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    subtitle: Maybe<Scalars["String"]["output"]>;
    /** The file name of a swatch image. */
    swatch_image: Maybe<Scalars["String"]["output"]>;
    /** The relative path to the product's thumbnail image. */
    thumbnail: Maybe<IProductImage>;
    /**
     * The price when tier pricing is in effect and the items purchased threshold has been reached.
     * @deprecated Use `price_tiers` for product tier price information.
     */
    tier_price: Maybe<Scalars["Float"]["output"]>;
    /**
     * An array of ProductTierPrices objects.
     * @deprecated Use `price_tiers` for product tier price information.
     */
    tier_prices: Maybe<Array<Maybe<IProductTierPrices>>>;
    /**
     * Product tooltip information
     * @deprecated Use the `custom_attributes` field instead.
     */
    tooltip_info: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    trabka: Maybe<Scalars["String"]["output"]>;
    /**
     * Indicates whether the product is eligible for a trade-in purchase.
     * @deprecated Use the `custom_attributes` field instead.
     */
    trade_in: Scalars["Int"]["output"];
    /**
     * Specific to trial stores, provides information about the finalization sku
     * @deprecated Use the `custom_attributes` field instead.
     */
    trial_finalization_sku: Maybe<Scalars["String"]["output"]>;
    /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
    type: Maybe<IUrlRewriteEntityTypeEnum>;
    /**
     * One of simple, virtual, bundle, downloadable, grouped, or configurable.
     * @deprecated Use `__typename` instead.
     */
    type_id: Maybe<Scalars["String"]["output"]>;
    /** Product Type */
    type_label: Maybe<Scalars["String"]["output"]>;
    /** The unique ID for a `ProductInterface` object. */
    uid: Scalars["ID"]["output"];
    /**
     * Timestamp indicating when the product was updated.
     * @deprecated The field should not be used on the storefront.
     */
    updated_at: Maybe<Scalars["String"]["output"]>;
    /** An array of up-sell products. */
    upsell_products: Maybe<Array<Maybe<IProductInterface>>>;
    /** The part of the URL that identifies the product */
    url_key: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use product's `canonical_url` or url rewrites instead */
    url_path: Maybe<Scalars["String"]["output"]>;
    /** URL rewrites list */
    url_rewrites: Maybe<Array<Maybe<IUrlRewrite>>>;
    /** The part of the product URL that is appended after the url key */
    url_suffix: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    voltage: Maybe<Scalars["String"]["output"]>;
    /**
     * An array of websites in which the product is available.
     * @deprecated The field should not be used on the storefront.
     */
    websites: Maybe<Array<Maybe<IWebsite>>>;
  };

/** Defines a product that the shopper downloads. */
export type IDownloadableProductCustom_AttributesV2Args = {
  filters: InputMaybe<IAttributeFilterInput>;
};

/** Defines a product that the shopper downloads. */
export type IDownloadableProductReviewsArgs = {
  currentPage?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Defines a single downloadable product. */
export type IDownloadableProductCartItemInput = {
  /** The ID and value of the option. */
  customizable_options: InputMaybe<Array<InputMaybe<ICustomizableOptionInput>>>;
  /** The quantity and SKU of the downloadable product. */
  data: ICartItemInput;
  /** An array of objects containing the link_id of the downloadable product link. */
  downloadable_product_links: InputMaybe<Array<InputMaybe<IDownloadableProductLinksInput>>>;
};

/** Defines characteristics of a downloadable product. */
export type IDownloadableProductLinks = {
  /** @deprecated This information should not be exposed on frontend. */
  id: Maybe<Scalars["Int"]["output"]>;
  /** @deprecated This information should not be exposed on frontend. */
  is_shareable: Maybe<Scalars["Boolean"]["output"]>;
  /** @deprecated `sample_url` serves to get the downloadable sample */
  link_type: Maybe<IDownloadableFileTypeEnum>;
  /** @deprecated This information should not be exposed on frontend. */
  number_of_downloads: Maybe<Scalars["Int"]["output"]>;
  /** The price of the downloadable product. */
  price: Maybe<Scalars["Float"]["output"]>;
  /** @deprecated `sample_url` serves to get the downloadable sample */
  sample_file: Maybe<Scalars["String"]["output"]>;
  /** @deprecated `sample_url` serves to get the downloadable sample */
  sample_type: Maybe<IDownloadableFileTypeEnum>;
  /** The full URL to the downloadable sample. */
  sample_url: Maybe<Scalars["String"]["output"]>;
  /** A number indicating the sort order. */
  sort_order: Maybe<Scalars["Int"]["output"]>;
  /** The display name of the link. */
  title: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `DownloadableProductLinks` object. */
  uid: Scalars["ID"]["output"];
};

/** Contains the link ID for the downloadable product. */
export type IDownloadableProductLinksInput = {
  /** The unique ID of the downloadable product link. */
  link_id: Scalars["Int"]["input"];
};

/** Defines characteristics of a downloadable product. */
export type IDownloadableProductSamples = {
  /** @deprecated This information should not be exposed on frontend. */
  id: Maybe<Scalars["Int"]["output"]>;
  /** @deprecated `sample_url` serves to get the downloadable sample */
  sample_file: Maybe<Scalars["String"]["output"]>;
  /** @deprecated `sample_url` serves to get the downloadable sample */
  sample_type: Maybe<IDownloadableFileTypeEnum>;
  /** The full URL to the downloadable sample. */
  sample_url: Maybe<Scalars["String"]["output"]>;
  /** A number indicating the sort order. */
  sort_order: Maybe<Scalars["Int"]["output"]>;
  /** The display name of the sample. */
  title: Maybe<Scalars["String"]["output"]>;
};

/** A downloadable product wish list item. */
export type IDownloadableWishlistItem = IWishlistItemInterface & {
  /** The date and time the item was added to the wish list. */
  added_at: Scalars["String"]["output"];
  /** Custom options selected for the wish list item. */
  customizable_options: Array<Maybe<ISelectedCustomizableOption>>;
  /** The description of the item. */
  description: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `WishlistItemInterface` object. */
  id: Scalars["ID"]["output"];
  /** An array containing information about the selected links. */
  links_v2: Maybe<Array<Maybe<IDownloadableProductLinks>>>;
  /** Product details of the wish list item. */
  product: Maybe<IProductInterface>;
  /** The quantity of this wish list item. */
  quantity: Scalars["Float"]["output"];
  /** An array containing information about the selected samples. */
  samples: Maybe<Array<Maybe<IDownloadableProductSamples>>>;
};

/** Contains a single dynamic block. */
export type IDynamicBlock = {
  /** The renderable HTML code of the dynamic block. */
  content: IComplexTextValue;
  /** The unique ID of a `DynamicBlock` object. */
  uid: Scalars["ID"]["output"];
};

/** Indicates the locations the dynamic block can be placed. If this field is not specified, the query returns all locations. */
export enum IDynamicBlockLocationEnum {
  Content = "CONTENT",
  Footer = "FOOTER",
  Header = "HEADER",
  Left = "LEFT",
  Right = "RIGHT",
}

/** Indicates the selected Dynamic Blocks Rotator inline widget. */
export enum IDynamicBlockTypeEnum {
  CartPriceRuleRelated = "CART_PRICE_RULE_RELATED",
  CatalogPriceRuleRelated = "CATALOG_PRICE_RULE_RELATED",
  Specified = "SPECIFIED",
}

/** Contains an array of dynamic blocks. */
export type IDynamicBlocks = {
  /** An array containing individual dynamic blocks. */
  items: Array<Maybe<IDynamicBlock>>;
  /** Metadata for pagination rendering. */
  page_info: Maybe<ISearchResultPageInfo>;
  /** The number of returned dynamic blocks. */
  total_count: Scalars["Int"]["output"];
};

/** Defines the dynamic block filter. The filter can identify the block type, location and IDs to return. */
export type IDynamicBlocksFilterInput = {
  /** An array of dynamic block UIDs to filter on. */
  dynamic_block_uids: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  /** An array indicating the locations the dynamic block can be placed. */
  locations: InputMaybe<Array<InputMaybe<IDynamicBlockLocationEnum>>>;
  /** A value indicating the type of dynamic block to filter on. */
  type: IDynamicBlockTypeEnum;
};

/** Contains details about a custom text attribute that the buyer entered. */
export type IEnteredCustomAttributeInput = {
  /** A string that identifies the entered custom attribute. */
  attribute_code: Scalars["String"]["input"];
  /** The text or other entered value. */
  value: Scalars["String"]["input"];
};

/** Defines a customer-entered option. */
export type IEnteredOptionInput = {
  /** The unique ID for a `CustomizableOptionInterface` object, such as a `CustomizableFieldOption`, `CustomizableFileOption`, or `CustomizableAreaOption` object. */
  uid: Scalars["ID"]["input"];
  /** Text the customer entered. */
  value: Scalars["String"]["input"];
};

/** Contains the `uid`, `relative_url`, and `type` attributes. */
export type IEntityUrl = {
  /** @deprecated Use `relative_url` instead. */
  canonical_url: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `ProductInterface`, `CategoryInterface`, `CmsPage`, or similar object associated with the specified URL. This could be a product, category, or CMS page UID. */
  entity_uid: Maybe<Scalars["ID"]["output"]>;
  /**
   * The ID assigned to the object associated with the specified url. This could be a product ID, category ID, or page ID.
   * @deprecated Use `entity_uid` instead.
   */
  id: Maybe<Scalars["Int"]["output"]>;
  /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
  redirectCode: Maybe<Scalars["Int"]["output"]>;
  /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
  relative_url: Maybe<Scalars["String"]["output"]>;
  /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
  type: Maybe<IUrlRewriteEntityTypeEnum>;
};

/** An error encountered while adding an item to the the cart. */
export type IError = {
  /** A cart-specific error code. */
  code: ICartUserInputErrorType;
  /** A localized error message. */
  message: Scalars["String"]["output"];
};

export type IErrorInterface = {
  /** The returned error message. */
  message: Scalars["String"]["output"];
};

/** Contains details about an address. */
export type IEstimateAddressInput = {
  /** The two-letter code representing the customer's country. */
  country_code: ICountryCodeEnum;
  /** The customer's ZIP or postal code. */
  postcode: InputMaybe<Scalars["String"]["input"]>;
  /** An object containing the region name, region code, and region ID. */
  region: InputMaybe<ICustomerAddressRegionInput>;
};

export type IEstimateTotalsInput = {
  /** Customer's address to estimate totals. */
  address: IEstimateAddressInput;
  /** The unique ID of the cart to query. */
  cart_id: Scalars["String"]["input"];
  /** Selected shipping method to estimate totals. */
  shipping_method: InputMaybe<IShippingMethodInput>;
};

/** Estimate totals output. */
export type IEstimateTotalsOutput = {
  /** Cart after totals estimation */
  cart: Maybe<ICart>;
};

/** Read-only shipping cost estimation for cart display. Does not affect the quote or shipping address. */
export type IEstimatedShippingCost = {
  /** The estimated shipping cost amount in the store currency. */
  amount: Maybe<IMoney>;
  /** The carrier code used for estimation. */
  carrier_code: Maybe<Scalars["String"]["output"]>;
  /** True when the estimation used the market default address (guest user or logged-in customer without a saved default address). False when the customer's own default shipping address was used. */
  is_market_default: Maybe<Scalars["Boolean"]["output"]>;
  /** The method code used for estimation. */
  method_code: Maybe<Scalars["String"]["output"]>;
  /** The display title of the estimated shipping method. */
  method_title: Maybe<Scalars["String"]["output"]>;
};

/** Lists the exchange rate. */
export type IExchangeRate = {
  /** Specifies the store’s default currency to exchange to. */
  currency_to: Maybe<Scalars["String"]["output"]>;
  /** The exchange rate for the store’s default currency. */
  rate: Maybe<Scalars["Float"]["output"]>;
};

export type IFastlaneConfig = IPaymentConfigItem & {
  /** The payment method code as defined in the payment gateway */
  code: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether the payment method is displayed */
  is_visible: Maybe<Scalars["Boolean"]["output"]>;
  /** Defines the payment intent (Authorize or Capture */
  payment_intent: Maybe<Scalars["String"]["output"]>;
  /** The payment source for the payment method */
  payment_source: Maybe<Scalars["String"]["output"]>;
  /** The PayPal parameters required to load the JS SDK */
  sdk_params: Maybe<Array<Maybe<ISdkParams>>>;
  /** The relative order the payment method is displayed on the checkout page */
  sort_order: Maybe<Scalars["String"]["output"]>;
  /** 3DS mode */
  three_ds_mode: Maybe<IThreeDsMode>;
  /** The name displayed for the payment method */
  title: Maybe<Scalars["String"]["output"]>;
};

/** Fastlane Payment inputs */
export type IFastlaneMethodInput = {
  /** The payment source for the payment method */
  payment_source: InputMaybe<Scalars["String"]["input"]>;
  /** The single use token from Fastlane */
  paypal_fastlane_token: InputMaybe<Scalars["String"]["input"]>;
};

/** Defines a filter that matches the input exactly. */
export type IFilterEqualTypeInput = {
  /** Use this attribute to exactly match the specified string. For example, to filter on a specific category ID, specify a value such as `5`. */
  eq: InputMaybe<Scalars["String"]["input"]>;
  /** Use this attribute to filter on an array of values. For example, to filter on category IDs 4, 5, and 6, specify a value of `["4", "5", "6"]`. */
  in: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export enum IFilterMatchTypeEnum {
  Full = "FULL",
  Partial = "PARTIAL",
}

/** Defines a filter that performs a fuzzy search. */
export type IFilterMatchTypeInput = {
  /** Use this attribute to fuzzy match the specified string. For example, to filter on a specific SKU, specify a value such as `24-MB01`. */
  match: InputMaybe<Scalars["String"]["input"]>;
  /** Filter match type for fine-tuned results. Possible values FULL or PARTIAL. If match_type is not provided, returned results will default to FULL match. */
  match_type: InputMaybe<IFilterMatchTypeEnum>;
};

/** Defines a filter that matches a range of values, such as prices or dates. */
export type IFilterRangeTypeInput = {
  /** Use this attribute to specify the lowest possible value in the range. */
  from: InputMaybe<Scalars["String"]["input"]>;
  /** Use this attribute to specify the highest possible value in the range. */
  to: InputMaybe<Scalars["String"]["input"]>;
};

/** Defines a filter for an input string. */
export type IFilterStringTypeInput = {
  /** Filters items that are exactly the same as the specified string. */
  eq: InputMaybe<Scalars["String"]["input"]>;
  /** Filters items that are exactly the same as entries specified in an array of strings. */
  in: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** Defines a filter that performs a fuzzy search using the specified string. */
  match: InputMaybe<Scalars["String"]["input"]>;
};

/** Defines the comparison operators that can be used in a filter. */
export type IFilterTypeInput = {
  /** Equals. */
  eq: InputMaybe<Scalars["String"]["input"]>;
  finset: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** From. Must be used with the `to` field. */
  from: InputMaybe<Scalars["String"]["input"]>;
  /** Greater than. */
  gt: InputMaybe<Scalars["String"]["input"]>;
  /** Greater than or equal to. */
  gteq: InputMaybe<Scalars["String"]["input"]>;
  /** In. The value can contain a set of comma-separated values. */
  in: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** Like. The specified value can contain % (percent signs) to allow matching of 0 or more characters. */
  like: InputMaybe<Scalars["String"]["input"]>;
  /** Less than. */
  lt: InputMaybe<Scalars["String"]["input"]>;
  /** Less than or equal to. */
  lteq: InputMaybe<Scalars["String"]["input"]>;
  /** More than or equal to. */
  moreq: InputMaybe<Scalars["String"]["input"]>;
  /** Not equal to. */
  neq: InputMaybe<Scalars["String"]["input"]>;
  /** Not in. The value can contain a set of comma-separated values. */
  nin: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** Not null. */
  notnull: InputMaybe<Scalars["String"]["input"]>;
  /** Is null. */
  null: InputMaybe<Scalars["String"]["input"]>;
  /** To. Must be used with the `from` field. */
  to: InputMaybe<Scalars["String"]["input"]>;
};

/** A single FPT that can be applied to a product price. */
export type IFixedProductTax = {
  /** The amount of the Fixed Product Tax. */
  amount: Maybe<IMoney>;
  /** The display label assigned to the Fixed Product Tax. */
  label: Maybe<Scalars["String"]["output"]>;
};

/** Lists display settings for the Fixed Product Tax. */
export enum IFixedProductTaxDisplaySettings {
  /** The displayed price does not include the FPT amount. The values of `ProductPrice.fixed_product_taxes` and the price including the FPT are displayed separately. This value corresponds to 'Excluding FPT, Including FPT description and final price.' */
  ExcludeFptAndIncludeWithDetails = "EXCLUDE_FPT_AND_INCLUDE_WITH_DETAILS",
  /** The displayed price does not include the FPT amount. The values from `ProductPrice.fixed_product_taxes` are not displayed. This value corresponds to 'Excluding FPT'. */
  ExcludeFptWithoutDetails = "EXCLUDE_FPT_WITHOUT_DETAILS",
  /** The FPT feature is not enabled. You can omit `ProductPrice.fixed_product_taxes` from your query. */
  FptDisabled = "FPT_DISABLED",
  /** The displayed price includes the FPT amount without displaying the `ProductPrice.fixed_product_taxes` values. This value corresponds to 'Including FPT only'. */
  IncludeFptWithoutDetails = "INCLUDE_FPT_WITHOUT_DETAILS",
  /** The displayed price includes the FPT amount while displaying the values of `ProductPrice.fixed_product_taxes` separately. This value corresponds to 'Including FPT and FPT description'. */
  IncludeFptWithDetails = "INCLUDE_FPT_WITH_DETAILS",
}

export type IFlavourAttribute = {
  /** Flavour attribute sub option ID. */
  id: Scalars["Int"]["output"];
  /** Flavour attribute sub option label. */
  name: Scalars["String"]["output"];
  /** Flavour attribute sub option sort_order. */
  sort_order: Scalars["Int"]["output"];
  /** Flavour attribute sub option value. */
  value: Scalars["String"]["output"];
};

export type IFlavourDetails = {
  /** Flavour attributes. */
  attributes: Maybe<Array<Maybe<IFlavourAttribute>>>;
  /** Flavour description. */
  description: Maybe<Scalars["String"]["output"]>;
  /** Flavour ID. */
  id: Scalars["Int"]["output"];
  /** Flavour label. */
  name: Maybe<Scalars["String"]["output"]>;
};

export type IFreeGiftProductData = {
  /** Maximum allowed quantity to be added in the basket for a given gift */
  allowed_qty: Maybe<Scalars["Int"]["output"]>;
  /** Gifting product limitation enabled */
  lifetime_limit_active: Maybe<Scalars["Boolean"]["output"]>;
  /** Gifting product limitation quantity */
  lifetime_limit_qty: Maybe<Scalars["Int"]["output"]>;
  /** list of gift products */
  products: Maybe<Array<Maybe<IGiftProductData>>>;
};

export type IFrontendAttribute = {
  /** Attribute label */
  label: Scalars["String"]["output"];
  /** Attribute values or attribute option values for selects and multiselects */
  values: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
};

/** Identifies which customer requires remote shopping assistance. */
export type IGenerateCustomerTokenAsAdminInput = {
  /** The email address of the customer requesting remote shopping assistance. */
  customer_email: Scalars["String"]["input"];
};

/** Contains the generated customer token. */
export type IGenerateCustomerTokenAsAdminOutput = {
  /** The generated customer token. */
  customer_token: Scalars["String"]["output"];
};

export type IGetOrderDeliveryLimits = {
  /** delivery limits enabled */
  limits: Maybe<Array<Maybe<IDeliveryLimits>>>;
  /** mode */
  mode: Maybe<Scalars["String"]["output"]>;
};

/** Gets the payment SDK URLs and values */
export type IGetPaymentSdkOutput = {
  /** The payment SDK parameters */
  sdkParams: Maybe<Array<Maybe<IPaymentSdkParamsItem>>>;
};

export type IGetorderstatus = {
  /** Is cancel order possible. */
  cancelable: Maybe<Scalars["Boolean"]["output"]>;
  /** Status label. */
  status_label: Maybe<Scalars["String"]["output"]>;
  /** Status value. */
  status_value: Maybe<Scalars["String"]["output"]>;
};

/** Contains details about the gift card account. */
export type IGiftCardAccount = {
  /** The balance remaining on the gift card. */
  balance: Maybe<IMoney>;
  /** The gift card account code. */
  code: Maybe<Scalars["String"]["output"]>;
  /** The expiration date of the gift card. */
  expiration_date: Maybe<Scalars["String"]["output"]>;
};

/** Contains the gift card code. */
export type IGiftCardAccountInput = {
  /** The applied gift card code. */
  gift_card_code: Scalars["String"]["input"];
};

/** Contains the value of a gift card, the website that generated the card, and related information. */
export type IGiftCardAmounts = {
  /** An internal attribute ID. */
  attribute_id: Maybe<Scalars["Int"]["output"]>;
  /** The unique ID for a `GiftCardAmounts` object. */
  uid: Scalars["ID"]["output"];
  /** The value of the gift card. */
  value: Maybe<Scalars["Float"]["output"]>;
  /**
   * An ID that is assigned to each unique gift card amount.
   * @deprecated Use `uid` instead
   */
  value_id: Maybe<Scalars["Int"]["output"]>;
  /** The ID of the website that generated the gift card. */
  website_id: Maybe<Scalars["Int"]["output"]>;
  /** The value of the gift card. */
  website_value: Maybe<Scalars["Float"]["output"]>;
};

/** Contains details about a gift card that has been added to a cart. */
export type IGiftCardCartItem = ICartItemInterface & {
  /** The amount and currency of the gift card. */
  amount: IMoney;
  /** The list of available gift wrapping options for the cart item. */
  available_gift_wrapping: Array<Maybe<IGiftWrapping>>;
  /** An array of customizations applied to the gift card. */
  customizable_options: Array<Maybe<ISelectedCustomizableOption>>;
  /** An array of errors encountered while loading the cart item */
  errors: Maybe<Array<Maybe<ICartItemError>>>;
  /** Provides info regarding the gift added to the basket */
  gift_data: Maybe<IGiftData>;
  /** The entered gift message data for the gift card cart item */
  gift_message: Maybe<IGiftMessage>;
  /** The selected gift wrapping option for the cart item. */
  gift_wrapping: Maybe<IGiftWrapping>;
  /** Provides the flag to show if consent was set or not */
  has_registration_consent: Maybe<Scalars["Boolean"]["output"]>;
  /** @deprecated Use `uid` instead. */
  id: Scalars["String"]["output"];
  /** True if requested quantity is less than available stock, false otherwise. */
  is_available: Scalars["Boolean"]["output"];
  /** The message from the sender to the recipient. */
  message: Maybe<Scalars["String"]["output"]>;
  /** Message to display when the product is not available with this selected option. */
  not_available_message: Maybe<Scalars["String"]["output"]>;
  /** Contains details about the price of the item, including taxes and discounts. */
  prices: Maybe<ICartItemPrices>;
  /** Details about an item in the cart. */
  product: IProductInterface;
  /** The quantity of this item in the cart. */
  quantity: Scalars["Float"]["output"];
  /** The email address of the person receiving the gift card. */
  recipient_email: Maybe<Scalars["String"]["output"]>;
  /** The name of the person receiving the gift card. */
  recipient_name: Scalars["String"]["output"];
  /** The email address of the sender. */
  sender_email: Maybe<Scalars["String"]["output"]>;
  /** The name of the sender. */
  sender_name: Scalars["String"]["output"];
  /** The unique ID for a `CartItemInterface` object. */
  uid: Scalars["ID"]["output"];
};

export type IGiftCardCreditMemoItem = ICreditMemoItemInterface & {
  /** Details about the final discount amount for the base product, including discounts on options. */
  discounts: Maybe<Array<Maybe<IDiscount>>>;
  /** Selected gift card properties for a credit memo item. */
  gift_card: Maybe<IGiftCardItem>;
  /** The unique ID for a `CreditMemoItemInterface` object. */
  id: Scalars["ID"]["output"];
  /** The order item the credit memo is applied to. */
  order_item: Maybe<IOrderItemInterface>;
  /** The name of the base product. */
  product_name: Maybe<Scalars["String"]["output"]>;
  /** The sale price for the base product, including selected options. */
  product_sale_price: IMoney;
  /** The SKU of the base product. */
  product_sku: Scalars["String"]["output"];
  /** The number of refunded items. */
  quantity_refunded: Maybe<Scalars["Float"]["output"]>;
};

export type IGiftCardInvoiceItem = IInvoiceItemInterface & {
  /** Information about the final discount amount for the base product, including discounts on options. */
  discounts: Maybe<Array<Maybe<IDiscount>>>;
  /** Selected gift card properties for an invoice item. */
  gift_card: Maybe<IGiftCardItem>;
  /** The unique ID for an `InvoiceItemInterface` object. */
  id: Scalars["ID"]["output"];
  /** Details about an individual order item. */
  order_item: Maybe<IOrderItemInterface>;
  /** The name of the base product. */
  product_name: Maybe<Scalars["String"]["output"]>;
  /** The sale price for the base product including selected options. */
  product_sale_price: IMoney;
  /** The SKU of the base product. */
  product_sku: Scalars["String"]["output"];
  /** The number of invoiced items. */
  quantity_invoiced: Maybe<Scalars["Float"]["output"]>;
};

/** Contains details about a gift card. */
export type IGiftCardItem = {
  /** The message from the sender to the recipient. */
  message: Maybe<Scalars["String"]["output"]>;
  /** The email address of the receiver of a virtual gift card. */
  recipient_email: Maybe<Scalars["String"]["output"]>;
  /** The name of the receiver of a physical or virtual gift card. */
  recipient_name: Maybe<Scalars["String"]["output"]>;
  /** The email address of the sender of a virtual gift card. */
  sender_email: Maybe<Scalars["String"]["output"]>;
  /** The name of the sender of a physical or virtual gift card. */
  sender_name: Maybe<Scalars["String"]["output"]>;
};

/** Contains details about the sender, recipient, and amount of a gift card. */
export type IGiftCardOptions = {
  /** The amount and currency of the gift card. */
  amount: Maybe<IMoney>;
  /** The custom amount and currency of the gift card. */
  custom_giftcard_amount: Maybe<IMoney>;
  /** The message from the sender to the recipient. */
  message: Maybe<Scalars["String"]["output"]>;
  /** The email address of the person receiving the gift card. */
  recipient_email: Maybe<Scalars["String"]["output"]>;
  /** The name of the person receiving the gift card. */
  recipient_name: Maybe<Scalars["String"]["output"]>;
  /** The email address of the sender. */
  sender_email: Maybe<Scalars["String"]["output"]>;
  /** The name of the sender. */
  sender_name: Maybe<Scalars["String"]["output"]>;
};

export type IGiftCardOrderItem = IOrderItemInterface & {
  /** The final discount information for the product. */
  discounts: Maybe<Array<Maybe<IDiscount>>>;
  /** Indicates whether the order item is eligible to be in a return request. */
  eligible_for_return: Maybe<Scalars["Boolean"]["output"]>;
  /** The entered option for the base product, such as a logo or image. */
  entered_options: Maybe<Array<Maybe<IOrderItemOption>>>;
  /** Selected gift card properties for an order item. */
  gift_card: Maybe<IGiftCardItem>;
  /** Provides info regarding the gift added to the basket */
  gift_data: Maybe<IGiftData>;
  /** The selected gift message for the order item */
  gift_message: Maybe<IGiftMessage>;
  /** The selected gift wrapping for the order item. */
  gift_wrapping: Maybe<IGiftWrapping>;
  /** Provides the flag to show if consent was set or not */
  has_registration_consent: Maybe<Scalars["Boolean"]["output"]>;
  /** The unique ID for an `OrderItemInterface` object. */
  id: Scalars["ID"]["output"];
  /** The original product price of the base product. */
  original_price: IMoney;
  /** Contains details about the price of the item, including taxes and discounts. */
  prices: Maybe<IOrderItemPrices>;
  /** The ProductInterface object, which contains details about the base product */
  product: Maybe<IProductInterface>;
  /** The name of the base product. */
  product_name: Maybe<Scalars["String"]["output"]>;
  /** The sale price of the base product, including selected options. */
  product_sale_price: IMoney;
  /** The sale price of the base product, including tax. */
  product_sale_price_incl_tax: IMoney;
  /** The SKU of the base product. */
  product_sku: Scalars["String"]["output"];
  /** Indicates whether this product has subscription flag. */
  product_subscription: Maybe<Scalars["Boolean"]["output"]>;
  /** The type of product, such as simple, configurable, etc. */
  product_type: Maybe<Scalars["String"]["output"]>;
  /** URL key of the base product. */
  product_url_key: Maybe<Scalars["String"]["output"]>;
  /** The number of canceled items. */
  quantity_canceled: Maybe<Scalars["Float"]["output"]>;
  /** The number of invoiced items. */
  quantity_invoiced: Maybe<Scalars["Float"]["output"]>;
  /** The number of units ordered for this item. */
  quantity_ordered: Maybe<Scalars["Float"]["output"]>;
  /** The number of refunded items. */
  quantity_refunded: Maybe<Scalars["Float"]["output"]>;
  /** The requested return quantity of the item. */
  quantity_return_requested: Maybe<Scalars["Float"]["output"]>;
  /** The number of returned items. */
  quantity_returned: Maybe<Scalars["Float"]["output"]>;
  /** The number of shipped items. */
  quantity_shipped: Maybe<Scalars["Float"]["output"]>;
  /** Row total for product. */
  row_total: IMoney;
  /** Row total for product including tax. */
  row_total_incl_tax: IMoney;
  /** The selected options for the base product, such as color or size. */
  selected_options: Maybe<Array<Maybe<IOrderItemOption>>>;
  /** The status of the order item. */
  status: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether the product is eligible for a trade-in purchase. */
  trade_in: Scalars["Int"]["output"];
};

/** Defines properties of a gift card. */
export type IGiftCardProduct = ICustomizableProductInterface &
  IPhysicalProductInterface &
  IProductInterface &
  IRoutableInterface & {
    /** @deprecated Use the `custom_attributes` field instead. */
    about_manufacturer: Maybe<Scalars["String"]["output"]>;
    /** Indicates whether the customer can provide a message to accompany the gift card. */
    allow_message: Maybe<Scalars["Boolean"]["output"]>;
    /** Indicates whether shoppers have the ability to set the value of the gift card. */
    allow_open_amount: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * The attribute set assigned to the product.
     * @deprecated The field should not be used on the storefront.
     */
    attribute_set_id: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    available_date: Maybe<Scalars["String"]["output"]>;
    /**
     * Whether the product is explicitly available for Mobile App commerce exposure. 1 = eligible, 0 or null = not eligible.
     * @deprecated Use the `custom_attributes` field instead.
     */
    available_for_mobile_app: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    battery: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    buy_cta_pdp: Maybe<Scalars["Int"]["output"]>;
    /** CTA for PDP attribute translated label . */
    buy_cta_pdp_label: Scalars["String"]["output"];
    /** @deprecated Use the `custom_attributes` field instead. */
    buy_cta_plp: Maybe<Scalars["Int"]["output"]>;
    /** CTA for PLP attribute translated label . */
    buy_cta_plp_label: Scalars["String"]["output"];
    /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
    canonical_url: Maybe<Scalars["String"]["output"]>;
    /** The categories assigned to a product. */
    categories: Maybe<Array<Maybe<ICategoryInterface>>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    charging_time: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    color: Maybe<Scalars["Int"]["output"]>;
    /** Color attribute label. */
    color_label: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    connectors: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    connectors_1: Maybe<Scalars["String"]["output"]>;
    /** The product's country of origin. */
    country_of_manufacture: Maybe<Scalars["String"]["output"]>;
    /**
     * Timestamp indicating when the product was created.
     * @deprecated The field should not be used on the storefront.
     */
    created_at: Maybe<Scalars["String"]["output"]>;
    /** An array of cross-sell products. */
    crosssell_products: Maybe<Array<Maybe<IProductInterface>>>;
    /** Product custom attributes. */
    custom_attributesV2: Maybe<IProductCustomAttributes>;
    /** Delivery region this product may be shipped to — `ES` or `IC`, the same vocabulary as the region header and getDeliveryRegions.code. Distinct from `region_code` on address types, which carries a province code. Null when the product carries no region, or its attribute value is not mapped to one; either way the product is undeliverable everywhere. */
    delivery_region_code: Maybe<Scalars["String"]["output"]>;
    /** Detailed information about the product. The value can include simple HTML tags. */
    description: Maybe<IComplexTextValue>;
    /** @deprecated Use the `custom_attributes` field instead. */
    device_dimensions: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    dimensions: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    enable_lifetime_quantity_limit: Maybe<Scalars["Int"]["output"]>;
    /**
     * Is quantity limit enabled for this product
     * @deprecated Use the `custom_attributes` field instead.
     */
    enable_order_quantity_limit: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    experience: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    flavor: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    flavor_family: Maybe<Scalars["String"]["output"]>;
    /** Color attribute label. */
    flavor_label: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    flavour: Maybe<Scalars["Int"]["output"]>;
    /** Get all details for flavour */
    flavour_details: Array<Maybe<IFlavourDetails>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    formula: Maybe<Scalars["Int"]["output"]>;
    /** A list of gift options for the given product */
    free_gifts: Maybe<IFreeGiftProductData>;
    /** Returns all attribute values and labels marked as visible on storefront */
    frontend_attributes: Maybe<Array<Maybe<IFrontendAttribute>>>;
    /** An array of customizable gift card options. */
    gift_card_options: Array<Maybe<ICustomizableOptionInterface>>;
    /** Returns a value indicating gift message availability for the product. */
    gift_message_available: Scalars["Boolean"]["output"];
    /** Returns a value indicating gift wrapping availability for the product. */
    gift_wrapping_available: Scalars["Boolean"]["output"];
    /** Returns value and currency indicating gift wrapping price for the product. */
    gift_wrapping_price: Maybe<IMoney>;
    /** An array that contains information about the values and ID of a gift card. */
    giftcard_amounts: Maybe<Array<Maybe<IGiftCardAmounts>>>;
    /** An enumeration that specifies the type of gift card. */
    giftcard_type: Maybe<IGiftCardTypeEnum>;
    /** @deprecated Use the `custom_attributes` field instead. */
    has_device: Maybe<Scalars["Int"]["output"]>;
    /** Provides the flag to show if consent is required or not */
    has_registration_consent: Maybe<Scalars["Boolean"]["output"]>;
    /** Product is hidden_sku or not */
    hidden_sku: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * The ID number assigned to the product.
     * @deprecated Use the `uid` field instead.
     */
    id: Maybe<Scalars["Int"]["output"]>;
    /** The relative path to the main image on the product page. */
    image: Maybe<IProductImage>;
    /** @deprecated Use the `custom_attributes` field instead. */
    importer: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    input_terminal: Maybe<Scalars["Int"]["output"]>;
    /** Product discontinued flag */
    is_discontinued: Maybe<Scalars["Boolean"]["output"]>;
    /** Indicates whether the customer can redeem the value on the card for cash. */
    is_redeemable: Maybe<Scalars["Boolean"]["output"]>;
    /** Indicates whether the product can be returned. */
    is_returnable: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    jti_brand_matrix: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    jti_category_redirect: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    jti_product_discontinued: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    jti_sku_redirect: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    large_stick_tray: Maybe<Scalars["String"]["output"]>;
    /** The number of days after purchase until the gift card expires. A null value means there is no limit. */
    lifetime: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    lifetime_quantity_limit: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    main_specifications: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    mandatory_positive_consent: Maybe<Scalars["Int"]["output"]>;
    /**
     * A number representing the product's manufacturer.
     * @deprecated Use the `custom_attributes` field instead.
     */
    manufacturer: Maybe<Scalars["Int"]["output"]>;
    /** Product subscription format */
    manufacturer_label: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    material: Maybe<Scalars["String"]["output"]>;
    /** Maximum Qty Allowed in Shopping Cart */
    max_sale_qty: Maybe<Scalars["Float"]["output"]>;
    /** An array of media gallery objects. */
    media_gallery: Maybe<Array<Maybe<IMediaGalleryInterface>>>;
    /**
     * An array of MediaGalleryEntry objects.
     * @deprecated Use `media_gallery` instead.
     */
    media_gallery_entries: Maybe<Array<Maybe<IMediaGalleryEntry>>>;
    /** The maximum number of characters the gift message can contain. */
    message_max_length: Maybe<Scalars["Int"]["output"]>;
    /** A brief overview of the product for search results listings, maximum 255 characters. */
    meta_description: Maybe<Scalars["String"]["output"]>;
    /** A comma-separated list of keywords that are visible only to search engines. */
    meta_keyword: Maybe<Scalars["String"]["output"]>;
    /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
    meta_title: Maybe<Scalars["String"]["output"]>;
    /** Minimum Qty Allowed in Shopping Cart */
    min_sale_qty: Maybe<Scalars["Float"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    minimum_amount: Maybe<Scalars["Float"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    minimum_amount_type: Maybe<Scalars["String"]["output"]>;
    /**
     * Multipack description for this product
     * @deprecated Use the `custom_attributes` field instead.
     */
    multipack_description: Maybe<Scalars["String"]["output"]>;
    /** Is multipacks selected enabled for this product */
    multipack_enabled: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * Multipack label for this product
     * @deprecated Use the `custom_attributes` field instead.
     */
    multipack_label: Maybe<Scalars["String"]["output"]>;
    /** Multipack price text for this product */
    multipack_price: Maybe<Scalars["String"]["output"]>;
    /** Multipack Products */
    multipack_products: Maybe<Array<Maybe<IProductInterface>>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    multipacks_enabled: Maybe<Scalars["Int"]["output"]>;
    /** The product name. Customers use this name to identify the product. */
    name: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    name_and_model: Maybe<Scalars["String"]["output"]>;
    /** The beginning date for new product listings, and determines if the product is featured as a new product. */
    new_from_date: Maybe<Scalars["String"]["output"]>;
    /** The end date for new product listings. */
    new_to_date: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    non_trade_in_sku: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    number_of_packs: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    number_of_sticks: Maybe<Scalars["Int"]["output"]>;
    /** Product stock only x left count */
    only_x_left_in_stock: Maybe<Scalars["Float"]["output"]>;
    /** The maximum acceptable value of an open amount gift card. */
    open_amount_max: Maybe<Scalars["Float"]["output"]>;
    /** The minimum acceptable value of an open amount gift card. */
    open_amount_min: Maybe<Scalars["Float"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    option_grouped_by_brand: Maybe<Scalars["Int"]["output"]>;
    /** An array of options for a customizable product. */
    options: Maybe<Array<Maybe<ICustomizableOptionInterface>>>;
    /** If the product has multiple options, determines where they appear on the product page. */
    options_container: Maybe<Scalars["String"]["output"]>;
    /**
     * Maximum quantity allowed per one order
     * @deprecated Use the `custom_attributes` field instead.
     */
    order_quantity_limit: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    portable_stick_tray: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    pouch_size: Maybe<Scalars["Int"]["output"]>;
    /**
     * Indicates the price of an item.
     * @deprecated Use `price_range` for product price information.
     */
    price: Maybe<IProductPrices>;
    /** The range of prices for the product */
    price_range: IPriceRange;
    /** An array of `TierPrice` objects. */
    price_tiers: Maybe<Array<Maybe<ITierPrice>>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_brand: Maybe<Scalars["String"]["output"]>;
    /** Product Brand Label */
    product_brand_label: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_category: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_category_type: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_color: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_disclaimer: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_family: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_generation: Maybe<Scalars["String"]["output"]>;
    /** An array of `ProductLinks` objects. */
    product_links: Maybe<Array<Maybe<IProductLinksInterface>>>;
    /** Get all special offers for a product. */
    promotionalOffers: Array<Maybe<ISpecialOffer>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    province: Maybe<Scalars["String"]["output"]>;
    /** Product provence label for PLP attribute. */
    province_label: Maybe<Scalars["String"]["output"]>;
    /** Amount of available stock */
    quantity: Maybe<Scalars["Float"]["output"]>;
    /** The average of all the ratings given to the product. */
    rating_summary: Scalars["Float"]["output"];
    /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
    redirect_code: Scalars["Int"]["output"];
    /** Redirect category URL path for discontinued product */
    redirect_product_category: Maybe<Scalars["String"]["output"]>;
    /** Redirect product SKU for discontinued product */
    redirect_sku: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    region: Maybe<Scalars["Int"]["output"]>;
    /** Product Region attribute translated label. */
    region_label: Maybe<Scalars["String"]["output"]>;
    /** An array of related products. */
    related_products: Maybe<Array<Maybe<IProductInterface>>>;
    /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
    relative_url: Maybe<Scalars["String"]["output"]>;
    /** The total count of all the reviews given to the product. */
    review_count: Scalars["Int"]["output"];
    /** @deprecated Use the `custom_attributes` field instead. */
    review_eligible: Maybe<Scalars["Int"]["output"]>;
    /** The list of products reviews. */
    reviews: IProductReviews;
    /** A short description of the product. Its use depends on the theme. */
    short_description: Maybe<IComplexTextValue>;
    /** @deprecated Use the `custom_attributes` field instead. */
    size: Maybe<Scalars["String"]["output"]>;
    /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
    sku: Maybe<Scalars["String"]["output"]>;
    /** The relative path to the small image, which is used on catalog pages. */
    small_image: Maybe<IProductImage>;
    /** Get all special offers for a product. */
    specialOffers: Array<Maybe<ISpecialOffer>>;
    /**
     * The beginning date that a product has a special price.
     * @deprecated The field should not be used on the storefront.
     */
    special_from_date: Maybe<Scalars["String"]["output"]>;
    /** The discounted price of the product. */
    special_price: Maybe<Scalars["Float"]["output"]>;
    /** The end date for a product with a special price. */
    special_to_date: Maybe<Scalars["String"]["output"]>;
    /** Indicates whether the product is staged for a future campaign. */
    staged: Scalars["Boolean"]["output"];
    /** @deprecated Use the `custom_attributes` field instead. */
    stick_capability: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    stick_compatibility: Maybe<Scalars["String"]["output"]>;
    /** Stock status of the product */
    stock_status: Maybe<IProductStockStatus>;
    /** @deprecated Use the `custom_attributes` field instead. */
    strength: Maybe<Scalars["Int"]["output"]>;
    /** Get all details for strength */
    strength_details: Maybe<IStrengthDetails>;
    /** @deprecated Use the `custom_attributes` field instead. */
    subscription: Maybe<Scalars["Int"]["output"]>;
    /**
     * Product subscription format
     * @deprecated Use the `custom_attributes` field instead.
     */
    subscription_format: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    subtitle: Maybe<Scalars["String"]["output"]>;
    /** The file name of a swatch image. */
    swatch_image: Maybe<Scalars["String"]["output"]>;
    /** The relative path to the product's thumbnail image. */
    thumbnail: Maybe<IProductImage>;
    /**
     * The price when tier pricing is in effect and the items purchased threshold has been reached.
     * @deprecated Use `price_tiers` for product tier price information.
     */
    tier_price: Maybe<Scalars["Float"]["output"]>;
    /**
     * An array of ProductTierPrices objects.
     * @deprecated Use `price_tiers` for product tier price information.
     */
    tier_prices: Maybe<Array<Maybe<IProductTierPrices>>>;
    /**
     * Product tooltip information
     * @deprecated Use the `custom_attributes` field instead.
     */
    tooltip_info: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    trabka: Maybe<Scalars["String"]["output"]>;
    /**
     * Indicates whether the product is eligible for a trade-in purchase.
     * @deprecated Use the `custom_attributes` field instead.
     */
    trade_in: Scalars["Int"]["output"];
    /**
     * Specific to trial stores, provides information about the finalization sku
     * @deprecated Use the `custom_attributes` field instead.
     */
    trial_finalization_sku: Maybe<Scalars["String"]["output"]>;
    /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
    type: Maybe<IUrlRewriteEntityTypeEnum>;
    /**
     * One of simple, virtual, bundle, downloadable, grouped, or configurable.
     * @deprecated Use `__typename` instead.
     */
    type_id: Maybe<Scalars["String"]["output"]>;
    /** Product Type */
    type_label: Maybe<Scalars["String"]["output"]>;
    /** The unique ID for a `ProductInterface` object. */
    uid: Scalars["ID"]["output"];
    /**
     * Timestamp indicating when the product was updated.
     * @deprecated The field should not be used on the storefront.
     */
    updated_at: Maybe<Scalars["String"]["output"]>;
    /** An array of up-sell products. */
    upsell_products: Maybe<Array<Maybe<IProductInterface>>>;
    /** The part of the URL that identifies the product */
    url_key: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use product's `canonical_url` or url rewrites instead */
    url_path: Maybe<Scalars["String"]["output"]>;
    /** URL rewrites list */
    url_rewrites: Maybe<Array<Maybe<IUrlRewrite>>>;
    /** The part of the product URL that is appended after the url key */
    url_suffix: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    voltage: Maybe<Scalars["String"]["output"]>;
    /**
     * An array of websites in which the product is available.
     * @deprecated The field should not be used on the storefront.
     */
    websites: Maybe<Array<Maybe<IWebsite>>>;
    /** The weight of the item, in units defined by the store. */
    weight: Maybe<Scalars["Float"]["output"]>;
  };

/** Defines properties of a gift card. */
export type IGiftCardProductCustom_AttributesV2Args = {
  filters: InputMaybe<IAttributeFilterInput>;
};

/** Defines properties of a gift card. */
export type IGiftCardProductReviewsArgs = {
  currentPage?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

export type IGiftCardShipmentItem = IShipmentItemInterface & {
  /** Selected gift card properties for a shipment item. */
  gift_card: Maybe<IGiftCardItem>;
  /** The unique ID for a `ShipmentItemInterface` object. */
  id: Scalars["ID"]["output"];
  /** The order item associated with the shipment item. */
  order_item: Maybe<IOrderItemInterface>;
  /** The name of the base product. */
  product_name: Maybe<Scalars["String"]["output"]>;
  /** The sale price for the base product. */
  product_sale_price: IMoney;
  /** The SKU of the base product. */
  product_sku: Scalars["String"]["output"];
  /** The number of shipped items. */
  quantity_shipped: Scalars["Float"]["output"];
};

/** Specifies the gift card type. */
export enum IGiftCardTypeEnum {
  Combined = "COMBINED",
  Physical = "PHYSICAL",
  Virtual = "VIRTUAL",
}

/** A single gift card added to a wish list. */
export type IGiftCardWishlistItem = IWishlistItemInterface & {
  /** The date and time the item was added to the wish list. */
  added_at: Scalars["String"]["output"];
  /** Custom options selected for the wish list item. */
  customizable_options: Array<Maybe<ISelectedCustomizableOption>>;
  /** The description of the item. */
  description: Maybe<Scalars["String"]["output"]>;
  /** Details about a gift card. */
  gift_card_options: IGiftCardOptions;
  /** The unique ID for a `WishlistItemInterface` object. */
  id: Scalars["ID"]["output"];
  /** Product details of the wish list item. */
  product: Maybe<IProductInterface>;
  /** The quantity of this wish list item. */
  quantity: Scalars["Float"]["output"];
};

export type IGiftData = {
  is_gift: Scalars["Boolean"]["output"];
  is_gift_removable: Maybe<Scalars["Boolean"]["output"]>;
  parent_gift_id: Maybe<Scalars["String"]["output"]>;
  parent_gift_sku: Scalars["String"]["output"];
};

/** Contains the text of a gift message, its sender, and recipient */
export type IGiftMessage = {
  /** Sender name */
  from: Scalars["String"]["output"];
  /** Gift message text */
  message: Scalars["String"]["output"];
  /** Recipient name */
  to: Scalars["String"]["output"];
};

/** Defines a gift message. */
export type IGiftMessageInput = {
  /** The name of the sender. */
  from: Scalars["String"]["input"];
  /** The text of the gift message. */
  message: Scalars["String"]["input"];
  /** The name of the recepient. */
  to: Scalars["String"]["input"];
};

/** Contains prices for gift wrapping options. */
export type IGiftOptionsPrices = {
  /** Price of the gift wrapping for all individual order items. */
  gift_wrapping_for_items: Maybe<IMoney>;
  /** Price of the gift wrapping for all individual order items including tax. */
  gift_wrapping_for_items_incl_tax: Maybe<IMoney>;
  /** Price of the gift wrapping for the whole order. */
  gift_wrapping_for_order: Maybe<IMoney>;
  /** Price of the gift wrapping for the whole order including tax. */
  gift_wrapping_for_order_incl_tax: Maybe<IMoney>;
  /** Price for the printed card. */
  printed_card: Maybe<IMoney>;
  /** Price for the printed card including tax. */
  printed_card_incl_tax: Maybe<IMoney>;
};

export type IGiftProductData = {
  /** Provides information about eligibility conditions */
  eligibility_description: Scalars["String"]["output"];
  /** Provides if the customer gift eligibility */
  is_eligible: Scalars["Boolean"]["output"];
  /** Gift Product */
  product: IProductInterface;
};

/** Contains details about a gift registry. */
export type IGiftRegistry = {
  /** The date on which the gift registry was created. Only the registry owner can access this attribute. */
  created_at: Scalars["String"]["output"];
  /** An array of attributes that define elements of the gift registry. Each attribute is specified as a code-value pair. */
  dynamic_attributes: Maybe<Array<Maybe<IGiftRegistryDynamicAttribute>>>;
  /** The name of the event. */
  event_name: Scalars["String"]["output"];
  /** An array of products added to the gift registry. */
  items: Maybe<Array<Maybe<IGiftRegistryItemInterface>>>;
  /** The message text the customer entered to describe the event. */
  message: Scalars["String"]["output"];
  /** The customer who created the gift registry. */
  owner_name: Scalars["String"]["output"];
  /** An enum that states whether the gift registry is PRIVATE or PUBLIC. Only the registry owner can access this attribute. */
  privacy_settings: IGiftRegistryPrivacySettings;
  /** Contains details about each registrant for the event. */
  registrants: Maybe<Array<Maybe<IGiftRegistryRegistrant>>>;
  /** Contains the customer's shipping address. Only the registry owner can access this attribute. */
  shipping_address: Maybe<ICustomerAddress>;
  /** An enum that states whether the gift registry is ACTIVE or INACTIVE. Only the registry owner can access this attribute. */
  status: IGiftRegistryStatus;
  /** The type of gift registry. */
  type: Maybe<IGiftRegistryType>;
  /** The unique ID assigned to the gift registry. */
  uid: Scalars["ID"]["output"];
};

export type IGiftRegistryDynamicAttribute = IGiftRegistryDynamicAttributeInterface & {
  /** The internal ID of the dynamic attribute. */
  code: Scalars["ID"]["output"];
  /** Indicates which group the dynamic attribute is a member of. */
  group: IGiftRegistryDynamicAttributeGroup;
  /** The display name of the dynamic attribute. */
  label: Scalars["String"]["output"];
  /** A corresponding value for the code. */
  value: Scalars["String"]["output"];
};

/** Defines the group type of a gift registry dynamic attribute. */
export enum IGiftRegistryDynamicAttributeGroup {
  DetailedInformation = "DETAILED_INFORMATION",
  EventInformation = "EVENT_INFORMATION",
  GeneralInformation = "GENERAL_INFORMATION",
  PrivacySettings = "PRIVACY_SETTINGS",
  Registrant = "REGISTRANT",
  ShippingAddress = "SHIPPING_ADDRESS",
}

/** Defines a dynamic attribute. */
export type IGiftRegistryDynamicAttributeInput = {
  /** A unique key for an additional attribute of the event. */
  code: Scalars["ID"]["input"];
  /** A string that describes a dynamic attribute. */
  value: Scalars["String"]["input"];
};

export type IGiftRegistryDynamicAttributeInterface = {
  /** The internal ID of the dynamic attribute. */
  code: Scalars["ID"]["output"];
  /** The display name of the dynamic attribute. */
  label: Scalars["String"]["output"];
  /** A corresponding value for the code. */
  value: Scalars["String"]["output"];
};

export type IGiftRegistryDynamicAttributeMetadata = IGiftRegistryDynamicAttributeMetadataInterface & {
  /** Indicates which group the dynamic attribute a member of. */
  attribute_group: Scalars["String"]["output"];
  /** The internal ID of the dynamic attribute. */
  code: Scalars["ID"]["output"];
  /** The selected input type for this dynamic attribute. The value can be one of several static or custom types. */
  input_type: Scalars["String"]["output"];
  /** Indicates whether the dynamic attribute is required. */
  is_required: Scalars["Boolean"]["output"];
  /** The display name of the dynamic attribute. */
  label: Scalars["String"]["output"];
  /** The order in which to display the dynamic attribute. */
  sort_order: Maybe<Scalars["Int"]["output"]>;
};

export type IGiftRegistryDynamicAttributeMetadataInterface = {
  /** Indicates which group the dynamic attribute a member of. */
  attribute_group: Scalars["String"]["output"];
  /** The internal ID of the dynamic attribute. */
  code: Scalars["ID"]["output"];
  /** The selected input type for this dynamic attribute. The value can be one of several static or custom types. */
  input_type: Scalars["String"]["output"];
  /** Indicates whether the dynamic attribute is required. */
  is_required: Scalars["Boolean"]["output"];
  /** The display name of the dynamic attribute. */
  label: Scalars["String"]["output"];
  /** The order in which to display the dynamic attribute. */
  sort_order: Maybe<Scalars["Int"]["output"]>;
};

export type IGiftRegistryItem = IGiftRegistryItemInterface & {
  /** The date the product was added to the gift registry. */
  created_at: Scalars["String"]["output"];
  /** A brief message about the gift registry item. */
  note: Maybe<Scalars["String"]["output"]>;
  /** Details about the gift registry item. */
  product: Maybe<IProductInterface>;
  /** The requested quantity of the product. */
  quantity: Scalars["Float"]["output"];
  /** The fulfilled quantity of the product. */
  quantity_fulfilled: Scalars["Float"]["output"];
  /** The unique ID of a gift registry item. */
  uid: Scalars["ID"]["output"];
};

export type IGiftRegistryItemInterface = {
  /** The date the product was added to the gift registry. */
  created_at: Scalars["String"]["output"];
  /** A brief message about the gift registry item. */
  note: Maybe<Scalars["String"]["output"]>;
  /** Details about the gift registry item. */
  product: Maybe<IProductInterface>;
  /** The requested quantity of the product. */
  quantity: Scalars["Float"]["output"];
  /** The fulfilled quantity of the product. */
  quantity_fulfilled: Scalars["Float"]["output"];
  /** The unique ID of a gift registry item. */
  uid: Scalars["ID"]["output"];
};

/** Contains the status and any errors that encountered with the customer's gift register item. */
export type IGiftRegistryItemUserErrorInterface = {
  /** Indicates whether the attempt to move the cart items to the gift registry was successful. */
  status: Scalars["Boolean"]["output"];
  /** An array of errors encountered while moving items from the cart to the gift registry. */
  user_errors: Array<Maybe<IGiftRegistryItemsUserError>>;
};

/** Contains error information. */
export type IGiftRegistryItemUserErrors = IGiftRegistryItemUserErrorInterface & {
  /** Indicates whether the attempt to move the cart items to the gift registry was successful. */
  status: Scalars["Boolean"]["output"];
  /** An array of errors encountered while moving items from the cart to the gift registry. */
  user_errors: Array<Maybe<IGiftRegistryItemsUserError>>;
};

/** Contains details about an error that occurred when processing a gift registry item. */
export type IGiftRegistryItemsUserError = {
  /** An error code that describes the error encountered. */
  code: IGiftRegistryItemsUserErrorType;
  /** The unique ID of the gift registry item containing an error. */
  gift_registry_item_uid: Maybe<Scalars["ID"]["output"]>;
  /** The unique ID of the `GiftRegistry` object containing an error. */
  gift_registry_uid: Maybe<Scalars["ID"]["output"]>;
  /** A localized error message. */
  message: Scalars["String"]["output"];
  /** The unique ID of the product containing an error. */
  product_uid: Maybe<Scalars["ID"]["output"]>;
};

/** Defines the error type. */
export enum IGiftRegistryItemsUserErrorType {
  /** Used for exceptions like EntityNotFound. */
  NotFound = "NOT_FOUND",
  /** Used for handling out of stock products. */
  OutOfStock = "OUT_OF_STOCK",
  /** Used for other exceptions, such as database connection failures. */
  Undefined = "UNDEFINED",
}

/** Contains details about the gift registry. */
export type IGiftRegistryOutput = IGiftRegistryOutputInterface & {
  /** The gift registry. */
  gift_registry: Maybe<IGiftRegistry>;
};

/** Contains the customer's gift registry. */
export type IGiftRegistryOutputInterface = {
  /** The gift registry. */
  gift_registry: Maybe<IGiftRegistry>;
};

/** Defines the privacy setting of the gift registry. */
export enum IGiftRegistryPrivacySettings {
  Private = "PRIVATE",
  Public = "PUBLIC",
}

/** Contains details about a registrant. */
export type IGiftRegistryRegistrant = {
  /** An array of dynamic attributes assigned to the registrant. */
  dynamic_attributes: Maybe<Array<Maybe<IGiftRegistryRegistrantDynamicAttribute>>>;
  /** The email address of the registrant. Only the registry owner can access this attribute. */
  email: Scalars["String"]["output"];
  /** The first name of the registrant. */
  firstname: Scalars["String"]["output"];
  /** The last name of the registrant. */
  lastname: Scalars["String"]["output"];
  /** The unique ID assigned to the registrant. */
  uid: Scalars["ID"]["output"];
};

export type IGiftRegistryRegistrantDynamicAttribute = IGiftRegistryDynamicAttributeInterface & {
  /** The internal ID of the dynamic attribute. */
  code: Scalars["ID"]["output"];
  /** The display name of the dynamic attribute. */
  label: Scalars["String"]["output"];
  /** A corresponding value for the code. */
  value: Scalars["String"]["output"];
};

/** Contains the results of a gift registry search. */
export type IGiftRegistrySearchResult = {
  /** The date of the event. */
  event_date: Maybe<Scalars["String"]["output"]>;
  /** The title given to the event. */
  event_title: Scalars["String"]["output"];
  /** The URL key of the gift registry. */
  gift_registry_uid: Scalars["ID"]["output"];
  /** The location of the event. */
  location: Maybe<Scalars["String"]["output"]>;
  /** The name of the gift registry owner. */
  name: Scalars["String"]["output"];
  /** The type of event being held. */
  type: Maybe<Scalars["String"]["output"]>;
};

/** Defines a shipping address for a gift registry. Specify either `address_data` or the `address_id`. If both are provided, validation will fail. */
export type IGiftRegistryShippingAddressInput = {
  /** Defines the shipping address for this gift registry. */
  address_data: InputMaybe<ICustomerAddressInput>;
  /** The ID assigned to this customer address. */
  address_id: InputMaybe<Scalars["ID"]["input"]>;
};

/** Defines the status of the gift registry. */
export enum IGiftRegistryStatus {
  Active = "ACTIVE",
  Inactive = "INACTIVE",
}

/** Contains details about a gift registry type. */
export type IGiftRegistryType = {
  /** An array of attributes that define elements of the gift registry. Each attribute is specified as a code-value pair. */
  dynamic_attributes_metadata: Maybe<Array<Maybe<IGiftRegistryDynamicAttributeMetadataInterface>>>;
  /** The label assigned to the gift registry type on the Admin. */
  label: Scalars["String"]["output"];
  /** The unique ID assigned to the gift registry type. */
  uid: Scalars["ID"]["output"];
};

export type IGiftSelectionProduct = {
  /** Product entity ID */
  id: Scalars["Int"]["output"];
  /** Product name */
  name: Scalars["String"]["output"];
  /** Product SKU */
  sku: Scalars["String"]["output"];
};

/** Contains details about the selected or available gift wrapping options. */
export type IGiftWrapping = {
  /** The name of the gift wrapping design. */
  design: Scalars["String"]["output"];
  /**
   * The unique ID for a `GiftWrapping` object.
   * @deprecated Use `uid` instead
   */
  id: Scalars["ID"]["output"];
  /** The preview image for a gift wrapping option. */
  image: Maybe<IGiftWrappingImage>;
  /** The gift wrapping price. */
  price: IMoney;
  /** The unique ID for a `GiftWrapping` object. */
  uid: Scalars["ID"]["output"];
};

/** Points to an image associated with a gift wrapping option. */
export type IGiftWrappingImage = {
  /** The gift wrapping preview image label. */
  label: Scalars["String"]["output"];
  /** The gift wrapping preview image URL. */
  url: Scalars["String"]["output"];
};

export type IGooglePayButtonStyles = {
  /** The button color */
  color: Maybe<Scalars["String"]["output"]>;
  /** The button height in pixels */
  height: Maybe<Scalars["Int"]["output"]>;
  /** The button type */
  type: Maybe<Scalars["String"]["output"]>;
};

export type IGooglePayConfig = IPaymentConfigItem & {
  /** The styles for the GooglePay Button configuration */
  button_styles: Maybe<IGooglePayButtonStyles>;
  /** The payment method code as defined in the payment gateway */
  code: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether the payment method is displayed */
  is_visible: Maybe<Scalars["Boolean"]["output"]>;
  /** Defines the payment intent (Authorize or Capture */
  payment_intent: Maybe<Scalars["String"]["output"]>;
  /** The payment source for the payment method */
  payment_source: Maybe<Scalars["String"]["output"]>;
  /** The PayPal parameters required to load the JS SDK */
  sdk_params: Maybe<Array<Maybe<ISdkParams>>>;
  /** The relative order the payment method is displayed on the checkout page */
  sort_order: Maybe<Scalars["String"]["output"]>;
  /** 3DS mode */
  three_ds_mode: Maybe<IThreeDsMode>;
  /** The name displayed for the payment method */
  title: Maybe<Scalars["String"]["output"]>;
};

/** Google Pay inputs */
export type IGooglePayMethodInput = {
  /** The payment source for the payment method */
  payment_source: InputMaybe<Scalars["String"]["input"]>;
  /** The payment services order ID */
  payments_order_id: InputMaybe<Scalars["String"]["input"]>;
  /** PayPal order ID */
  paypal_order_id: InputMaybe<Scalars["String"]["input"]>;
};

/** Defines a grouped product, which consists of simple standalone products that are presented as a group. */
export type IGroupedProduct = IPhysicalProductInterface &
  IProductInterface &
  IRoutableInterface & {
    /** @deprecated Use the `custom_attributes` field instead. */
    about_manufacturer: Maybe<Scalars["String"]["output"]>;
    /**
     * The attribute set assigned to the product.
     * @deprecated The field should not be used on the storefront.
     */
    attribute_set_id: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    available_date: Maybe<Scalars["String"]["output"]>;
    /**
     * Whether the product is explicitly available for Mobile App commerce exposure. 1 = eligible, 0 or null = not eligible.
     * @deprecated Use the `custom_attributes` field instead.
     */
    available_for_mobile_app: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    battery: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    buy_cta_pdp: Maybe<Scalars["Int"]["output"]>;
    /** CTA for PDP attribute translated label . */
    buy_cta_pdp_label: Scalars["String"]["output"];
    /** @deprecated Use the `custom_attributes` field instead. */
    buy_cta_plp: Maybe<Scalars["Int"]["output"]>;
    /** CTA for PLP attribute translated label . */
    buy_cta_plp_label: Scalars["String"]["output"];
    /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
    canonical_url: Maybe<Scalars["String"]["output"]>;
    /** The categories assigned to a product. */
    categories: Maybe<Array<Maybe<ICategoryInterface>>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    charging_time: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    color: Maybe<Scalars["Int"]["output"]>;
    /** Color attribute label. */
    color_label: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    connectors: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    connectors_1: Maybe<Scalars["String"]["output"]>;
    /** The product's country of origin. */
    country_of_manufacture: Maybe<Scalars["String"]["output"]>;
    /**
     * Timestamp indicating when the product was created.
     * @deprecated The field should not be used on the storefront.
     */
    created_at: Maybe<Scalars["String"]["output"]>;
    /** An array of cross-sell products. */
    crosssell_products: Maybe<Array<Maybe<IProductInterface>>>;
    /** Product custom attributes. */
    custom_attributesV2: Maybe<IProductCustomAttributes>;
    /** Delivery region this product may be shipped to — `ES` or `IC`, the same vocabulary as the region header and getDeliveryRegions.code. Distinct from `region_code` on address types, which carries a province code. Null when the product carries no region, or its attribute value is not mapped to one; either way the product is undeliverable everywhere. */
    delivery_region_code: Maybe<Scalars["String"]["output"]>;
    /** Detailed information about the product. The value can include simple HTML tags. */
    description: Maybe<IComplexTextValue>;
    /** @deprecated Use the `custom_attributes` field instead. */
    device_dimensions: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    dimensions: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    enable_lifetime_quantity_limit: Maybe<Scalars["Int"]["output"]>;
    /**
     * Is quantity limit enabled for this product
     * @deprecated Use the `custom_attributes` field instead.
     */
    enable_order_quantity_limit: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    experience: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    flavor: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    flavor_family: Maybe<Scalars["String"]["output"]>;
    /** Color attribute label. */
    flavor_label: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    flavour: Maybe<Scalars["Int"]["output"]>;
    /** Get all details for flavour */
    flavour_details: Array<Maybe<IFlavourDetails>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    formula: Maybe<Scalars["Int"]["output"]>;
    /** A list of gift options for the given product */
    free_gifts: Maybe<IFreeGiftProductData>;
    /** Returns all attribute values and labels marked as visible on storefront */
    frontend_attributes: Maybe<Array<Maybe<IFrontendAttribute>>>;
    /** Returns a value indicating gift message availability for the product. */
    gift_message_available: Scalars["Boolean"]["output"];
    /** Returns a value indicating gift wrapping availability for the product. */
    gift_wrapping_available: Scalars["Boolean"]["output"];
    /** Returns value and currency indicating gift wrapping price for the product. */
    gift_wrapping_price: Maybe<IMoney>;
    /** @deprecated Use the `custom_attributes` field instead. */
    has_device: Maybe<Scalars["Int"]["output"]>;
    /** Provides the flag to show if consent is required or not */
    has_registration_consent: Maybe<Scalars["Boolean"]["output"]>;
    /** Product is hidden_sku or not */
    hidden_sku: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * The ID number assigned to the product.
     * @deprecated Use the `uid` field instead.
     */
    id: Maybe<Scalars["Int"]["output"]>;
    /** The relative path to the main image on the product page. */
    image: Maybe<IProductImage>;
    /** @deprecated Use the `custom_attributes` field instead. */
    importer: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    input_terminal: Maybe<Scalars["Int"]["output"]>;
    /** Product discontinued flag */
    is_discontinued: Maybe<Scalars["Boolean"]["output"]>;
    /** Indicates whether the product can be returned. */
    is_returnable: Maybe<Scalars["String"]["output"]>;
    /** An array containing grouped product items. */
    items: Maybe<Array<Maybe<IGroupedProductItem>>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    jti_brand_matrix: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    jti_category_redirect: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    jti_product_discontinued: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    jti_sku_redirect: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    large_stick_tray: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    lifetime_quantity_limit: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    main_specifications: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    mandatory_positive_consent: Maybe<Scalars["Int"]["output"]>;
    /**
     * A number representing the product's manufacturer.
     * @deprecated Use the `custom_attributes` field instead.
     */
    manufacturer: Maybe<Scalars["Int"]["output"]>;
    /** Product subscription format */
    manufacturer_label: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    material: Maybe<Scalars["String"]["output"]>;
    /** Maximum Qty Allowed in Shopping Cart */
    max_sale_qty: Maybe<Scalars["Float"]["output"]>;
    /** An array of media gallery objects. */
    media_gallery: Maybe<Array<Maybe<IMediaGalleryInterface>>>;
    /**
     * An array of MediaGalleryEntry objects.
     * @deprecated Use `media_gallery` instead.
     */
    media_gallery_entries: Maybe<Array<Maybe<IMediaGalleryEntry>>>;
    /** A brief overview of the product for search results listings, maximum 255 characters. */
    meta_description: Maybe<Scalars["String"]["output"]>;
    /** A comma-separated list of keywords that are visible only to search engines. */
    meta_keyword: Maybe<Scalars["String"]["output"]>;
    /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
    meta_title: Maybe<Scalars["String"]["output"]>;
    /** Minimum Qty Allowed in Shopping Cart */
    min_sale_qty: Maybe<Scalars["Float"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    minimum_amount: Maybe<Scalars["Float"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    minimum_amount_type: Maybe<Scalars["String"]["output"]>;
    /**
     * Multipack description for this product
     * @deprecated Use the `custom_attributes` field instead.
     */
    multipack_description: Maybe<Scalars["String"]["output"]>;
    /** Is multipacks selected enabled for this product */
    multipack_enabled: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * Multipack label for this product
     * @deprecated Use the `custom_attributes` field instead.
     */
    multipack_label: Maybe<Scalars["String"]["output"]>;
    /** Multipack price text for this product */
    multipack_price: Maybe<Scalars["String"]["output"]>;
    /** Multipack Products */
    multipack_products: Maybe<Array<Maybe<IProductInterface>>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    multipacks_enabled: Maybe<Scalars["Int"]["output"]>;
    /** The product name. Customers use this name to identify the product. */
    name: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    name_and_model: Maybe<Scalars["String"]["output"]>;
    /** The beginning date for new product listings, and determines if the product is featured as a new product. */
    new_from_date: Maybe<Scalars["String"]["output"]>;
    /** The end date for new product listings. */
    new_to_date: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    non_trade_in_sku: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    number_of_packs: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    number_of_sticks: Maybe<Scalars["Int"]["output"]>;
    /** Product stock only x left count */
    only_x_left_in_stock: Maybe<Scalars["Float"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    option_grouped_by_brand: Maybe<Scalars["Int"]["output"]>;
    /** If the product has multiple options, determines where they appear on the product page. */
    options_container: Maybe<Scalars["String"]["output"]>;
    /**
     * Maximum quantity allowed per one order
     * @deprecated Use the `custom_attributes` field instead.
     */
    order_quantity_limit: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    portable_stick_tray: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    pouch_size: Maybe<Scalars["Int"]["output"]>;
    /**
     * Indicates the price of an item.
     * @deprecated Use `price_range` for product price information.
     */
    price: Maybe<IProductPrices>;
    /** The range of prices for the product */
    price_range: IPriceRange;
    /** An array of `TierPrice` objects. */
    price_tiers: Maybe<Array<Maybe<ITierPrice>>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_brand: Maybe<Scalars["String"]["output"]>;
    /** Product Brand Label */
    product_brand_label: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_category: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_category_type: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_color: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_disclaimer: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_family: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_generation: Maybe<Scalars["String"]["output"]>;
    /** An array of `ProductLinks` objects. */
    product_links: Maybe<Array<Maybe<IProductLinksInterface>>>;
    /** Get all special offers for a product. */
    promotionalOffers: Array<Maybe<ISpecialOffer>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    province: Maybe<Scalars["String"]["output"]>;
    /** Product provence label for PLP attribute. */
    province_label: Maybe<Scalars["String"]["output"]>;
    /** Amount of available stock */
    quantity: Maybe<Scalars["Float"]["output"]>;
    /** The average of all the ratings given to the product. */
    rating_summary: Scalars["Float"]["output"];
    /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
    redirect_code: Scalars["Int"]["output"];
    /** Redirect category URL path for discontinued product */
    redirect_product_category: Maybe<Scalars["String"]["output"]>;
    /** Redirect product SKU for discontinued product */
    redirect_sku: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    region: Maybe<Scalars["Int"]["output"]>;
    /** Product Region attribute translated label. */
    region_label: Maybe<Scalars["String"]["output"]>;
    /** An array of related products. */
    related_products: Maybe<Array<Maybe<IProductInterface>>>;
    /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
    relative_url: Maybe<Scalars["String"]["output"]>;
    /** The total count of all the reviews given to the product. */
    review_count: Scalars["Int"]["output"];
    /** @deprecated Use the `custom_attributes` field instead. */
    review_eligible: Maybe<Scalars["Int"]["output"]>;
    /** The list of products reviews. */
    reviews: IProductReviews;
    /** A short description of the product. Its use depends on the theme. */
    short_description: Maybe<IComplexTextValue>;
    /** @deprecated Use the `custom_attributes` field instead. */
    size: Maybe<Scalars["String"]["output"]>;
    /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
    sku: Maybe<Scalars["String"]["output"]>;
    /** The relative path to the small image, which is used on catalog pages. */
    small_image: Maybe<IProductImage>;
    /** Get all special offers for a product. */
    specialOffers: Array<Maybe<ISpecialOffer>>;
    /**
     * The beginning date that a product has a special price.
     * @deprecated The field should not be used on the storefront.
     */
    special_from_date: Maybe<Scalars["String"]["output"]>;
    /** The discounted price of the product. */
    special_price: Maybe<Scalars["Float"]["output"]>;
    /** The end date for a product with a special price. */
    special_to_date: Maybe<Scalars["String"]["output"]>;
    /** Indicates whether the product is staged for a future campaign. */
    staged: Scalars["Boolean"]["output"];
    /** @deprecated Use the `custom_attributes` field instead. */
    stick_capability: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    stick_compatibility: Maybe<Scalars["String"]["output"]>;
    /** Stock status of the product */
    stock_status: Maybe<IProductStockStatus>;
    /** @deprecated Use the `custom_attributes` field instead. */
    strength: Maybe<Scalars["Int"]["output"]>;
    /** Get all details for strength */
    strength_details: Maybe<IStrengthDetails>;
    /** @deprecated Use the `custom_attributes` field instead. */
    subscription: Maybe<Scalars["Int"]["output"]>;
    /**
     * Product subscription format
     * @deprecated Use the `custom_attributes` field instead.
     */
    subscription_format: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    subtitle: Maybe<Scalars["String"]["output"]>;
    /** The file name of a swatch image. */
    swatch_image: Maybe<Scalars["String"]["output"]>;
    /** The relative path to the product's thumbnail image. */
    thumbnail: Maybe<IProductImage>;
    /**
     * The price when tier pricing is in effect and the items purchased threshold has been reached.
     * @deprecated Use `price_tiers` for product tier price information.
     */
    tier_price: Maybe<Scalars["Float"]["output"]>;
    /**
     * An array of ProductTierPrices objects.
     * @deprecated Use `price_tiers` for product tier price information.
     */
    tier_prices: Maybe<Array<Maybe<IProductTierPrices>>>;
    /**
     * Product tooltip information
     * @deprecated Use the `custom_attributes` field instead.
     */
    tooltip_info: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    trabka: Maybe<Scalars["String"]["output"]>;
    /**
     * Indicates whether the product is eligible for a trade-in purchase.
     * @deprecated Use the `custom_attributes` field instead.
     */
    trade_in: Scalars["Int"]["output"];
    /**
     * Specific to trial stores, provides information about the finalization sku
     * @deprecated Use the `custom_attributes` field instead.
     */
    trial_finalization_sku: Maybe<Scalars["String"]["output"]>;
    /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
    type: Maybe<IUrlRewriteEntityTypeEnum>;
    /**
     * One of simple, virtual, bundle, downloadable, grouped, or configurable.
     * @deprecated Use `__typename` instead.
     */
    type_id: Maybe<Scalars["String"]["output"]>;
    /** Product Type */
    type_label: Maybe<Scalars["String"]["output"]>;
    /** The unique ID for a `ProductInterface` object. */
    uid: Scalars["ID"]["output"];
    /**
     * Timestamp indicating when the product was updated.
     * @deprecated The field should not be used on the storefront.
     */
    updated_at: Maybe<Scalars["String"]["output"]>;
    /** An array of up-sell products. */
    upsell_products: Maybe<Array<Maybe<IProductInterface>>>;
    /** The part of the URL that identifies the product */
    url_key: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use product's `canonical_url` or url rewrites instead */
    url_path: Maybe<Scalars["String"]["output"]>;
    /** URL rewrites list */
    url_rewrites: Maybe<Array<Maybe<IUrlRewrite>>>;
    /** The part of the product URL that is appended after the url key */
    url_suffix: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    voltage: Maybe<Scalars["String"]["output"]>;
    /**
     * An array of websites in which the product is available.
     * @deprecated The field should not be used on the storefront.
     */
    websites: Maybe<Array<Maybe<IWebsite>>>;
    /** The weight of the item, in units defined by the store. */
    weight: Maybe<Scalars["Float"]["output"]>;
  };

/** Defines a grouped product, which consists of simple standalone products that are presented as a group. */
export type IGroupedProductCustom_AttributesV2Args = {
  filters: InputMaybe<IAttributeFilterInput>;
};

/** Defines a grouped product, which consists of simple standalone products that are presented as a group. */
export type IGroupedProductReviewsArgs = {
  currentPage?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Contains information about an individual grouped product item. */
export type IGroupedProductItem = {
  /** The relative position of this item compared to the other group items. */
  position: Maybe<Scalars["Int"]["output"]>;
  /** Details about this product option. */
  product: Maybe<IProductInterface>;
  /** The quantity of this grouped product item. */
  qty: Maybe<Scalars["Float"]["output"]>;
};

/** A grouped product wish list item. */
export type IGroupedProductWishlistItem = IWishlistItemInterface & {
  /** The date and time the item was added to the wish list. */
  added_at: Scalars["String"]["output"];
  /** Custom options selected for the wish list item. */
  customizable_options: Array<Maybe<ISelectedCustomizableOption>>;
  /** The description of the item. */
  description: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `WishlistItemInterface` object. */
  id: Scalars["ID"]["output"];
  /** Product details of the wish list item. */
  product: Maybe<IProductInterface>;
  /** The quantity of this wish list item. */
  quantity: Scalars["Float"]["output"];
};

/** Input to retrieve a guest order based on token. */
export type IGuestOrderCancelInput = {
  /** Cancellation reason. */
  reason: Scalars["String"]["input"];
  /** Order token. */
  token: Scalars["String"]["input"];
};

export type IHostedFieldsConfig = IPaymentConfigItem & {
  /** Vault payment method code */
  cc_vault_code: Maybe<Scalars["String"]["output"]>;
  /** The payment method code as defined in the payment gateway */
  code: Maybe<Scalars["String"]["output"]>;
  /** Card vault enabled */
  is_vault_enabled: Maybe<Scalars["Boolean"]["output"]>;
  /** Indicates whether the payment method is displayed */
  is_visible: Maybe<Scalars["Boolean"]["output"]>;
  /** Defines the payment intent (Authorize or Capture */
  payment_intent: Maybe<Scalars["String"]["output"]>;
  /** The payment source for the payment method */
  payment_source: Maybe<Scalars["String"]["output"]>;
  /** Card and bin details required */
  requires_card_details: Maybe<Scalars["Boolean"]["output"]>;
  /** The PayPal parameters required to load the JS SDK */
  sdk_params: Maybe<Array<Maybe<ISdkParams>>>;
  /** The relative order the payment method is displayed on the checkout page */
  sort_order: Maybe<Scalars["String"]["output"]>;
  /**
   * Whether 3DS is activated; true if 3DS mode is not OFF.
   * @deprecated Use 'three_ds_mode' instead.
   */
  three_ds: Maybe<Scalars["Boolean"]["output"]>;
  /** 3DS mode */
  three_ds_mode: Maybe<IThreeDsMode>;
  /** The name displayed for the payment method */
  title: Maybe<Scalars["String"]["output"]>;
};

/** Hosted Fields payment inputs */
export type IHostedFieldsInput = {
  /** Card bin number */
  cardBin: InputMaybe<Scalars["String"]["input"]>;
  /** Expiration month of the card */
  cardExpiryMonth: InputMaybe<Scalars["String"]["input"]>;
  /** Expiration year of the card */
  cardExpiryYear: InputMaybe<Scalars["String"]["input"]>;
  /** Last four digits of the card */
  cardLast4: InputMaybe<Scalars["String"]["input"]>;
  /** Name on the card */
  holderName: InputMaybe<Scalars["String"]["input"]>;
  /** Indicates whether details about the shopper's credit/debit card should be tokenized for later usage. Required only if Vault is enabled for the Payment Services payment integration. */
  is_active_payment_token_enabler: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The payment source for the payment method */
  payment_source: InputMaybe<Scalars["String"]["input"]>;
  /** The payment services order ID */
  payments_order_id: InputMaybe<Scalars["String"]["input"]>;
  /** PayPal order ID */
  paypal_order_id: InputMaybe<Scalars["String"]["input"]>;
};

/** Contains a set of relative URLs that PayPal uses in response to various actions during the authorization process. Magento prepends the base URL to this value to create a full URL. For example, if the full URL is https://www.example.com/path/to/page.html, the relative URL is path/to/page.html. Use this input for Payments Pro Hosted Solution payment method. */
export type IHostedProInput = {
  /** The relative URL of the page that PayPal redirects to when the buyer cancels the transaction in order to choose a different payment method. For example, if the full URL to this page is https://www.example.com/paypal/action/cancel.html, the relative URL is paypal/action/cancel.html. */
  cancel_url: Scalars["String"]["input"];
  /** The relative URL of the final confirmation page that PayPal redirects to upon payment success. For example, if the full URL to this page is https://www.example.com/paypal/action/return.html, the relative URL is paypal/action/return.html. */
  return_url: Scalars["String"]["input"];
};

/** Contains the secure URL used for the Payments Pro Hosted Solution payment method. */
export type IHostedProUrl = {
  /** The secure URL generated by PayPal. */
  secure_form_url: Maybe<Scalars["String"]["output"]>;
};

/** Contains the required input to request the secure URL for Payments Pro Hosted Solution payment. */
export type IHostedProUrlInput = {
  /** The unique ID that identifies the shopper's cart. */
  cart_id: Scalars["String"]["input"];
};

/** Contains target path parameters. */
export type IHttpQueryParameter = {
  /** A parameter name. */
  name: Maybe<Scalars["String"]["output"]>;
  /** A parameter value. */
  value: Maybe<Scalars["String"]["output"]>;
};

export type IImageSwatchData = ISwatchDataInterface & {
  /** The URL assigned to the thumbnail of the swatch image. */
  thumbnail: Maybe<Scalars["String"]["output"]>;
  /** The value can be represented as color (HEX code), image link, or text. */
  value: Maybe<Scalars["String"]["output"]>;
};

/** List of templates/filters applied to customer attribute input. */
export enum IInputFilterEnum {
  /** Forces attribute input to follow the date format. */
  Date = "DATE",
  /** Escape HTML Entities. */
  Escapehtml = "ESCAPEHTML",
  /** There are no templates or filters to be applied. */
  None = "NONE",
  /** Strip HTML Tags. */
  Striptags = "STRIPTAGS",
  /** Strip whitespace (or other characters) from the beginning and end of the input. */
  Trim = "TRIM",
}

export type IInsufficientStockError = IError & {
  /** A cart-specific error code. */
  code: ICartUserInputErrorType;
  /** A localized error message. */
  message: Scalars["String"]["output"];
  /** Amount of available stock */
  quantity: Maybe<Scalars["Float"]["output"]>;
};

/** Contains an error message when an internal error occurred. */
export type IInternalError = IErrorInterface & {
  /** The returned error message. */
  message: Scalars["String"]["output"];
};

/** Contains invoice details. */
export type IInvoice = {
  /** Comments on the invoice. */
  comments: Maybe<Array<Maybe<ISalesCommentItem>>>;
  /** The unique ID for a `Invoice` object. */
  id: Scalars["ID"]["output"];
  /** Invoiced product details. */
  items: Maybe<Array<Maybe<IInvoiceItemInterface>>>;
  /** Sequential invoice number. */
  number: Scalars["String"]["output"];
  path: Maybe<Scalars["String"]["output"]>;
  /** Invoice total amount details. */
  total: Maybe<IInvoiceTotal>;
  url: Maybe<Scalars["String"]["output"]>;
};

export type IInvoiceItem = IInvoiceItemInterface & {
  /** Information about the final discount amount for the base product, including discounts on options. */
  discounts: Maybe<Array<Maybe<IDiscount>>>;
  /** The unique ID for an `InvoiceItemInterface` object. */
  id: Scalars["ID"]["output"];
  /** Details about an individual order item. */
  order_item: Maybe<IOrderItemInterface>;
  /** The name of the base product. */
  product_name: Maybe<Scalars["String"]["output"]>;
  /** The sale price for the base product including selected options. */
  product_sale_price: IMoney;
  /** The SKU of the base product. */
  product_sku: Scalars["String"]["output"];
  /** The number of invoiced items. */
  quantity_invoiced: Maybe<Scalars["Float"]["output"]>;
};

/** Contains detailes about invoiced items. */
export type IInvoiceItemInterface = {
  /** Information about the final discount amount for the base product, including discounts on options. */
  discounts: Maybe<Array<Maybe<IDiscount>>>;
  /** The unique ID for an `InvoiceItemInterface` object. */
  id: Scalars["ID"]["output"];
  /** Details about an individual order item. */
  order_item: Maybe<IOrderItemInterface>;
  /** The name of the base product. */
  product_name: Maybe<Scalars["String"]["output"]>;
  /** The sale price for the base product including selected options. */
  product_sale_price: IMoney;
  /** The SKU of the base product. */
  product_sku: Scalars["String"]["output"];
  /** The number of invoiced items. */
  quantity_invoiced: Maybe<Scalars["Float"]["output"]>;
};

/** Contains price details from an invoice. */
export type IInvoiceTotal = {
  /** The final base grand total amount in the base currency. */
  base_grand_total: IMoney;
  /** The applied discounts to the invoice. */
  discounts: Maybe<Array<Maybe<IDiscount>>>;
  /** The final total amount, including shipping, discounts, and taxes. */
  grand_total: IMoney;
  /** Details about the shipping and handling costs for the invoice. */
  shipping_handling: Maybe<IShippingHandling>;
  /** The subtotal of the invoice, excluding shipping, discounts, and taxes. */
  subtotal: IMoney;
  /** The invoice tax details. */
  taxes: Maybe<Array<Maybe<ITaxItem>>>;
  /** The shipping amount for the invoice. */
  total_shipping: IMoney;
  /** The amount of tax applied to the invoice. */
  total_tax: IMoney;
};

/** Contains the result of the `isEmailAvailable` query. */
export type IIsEmailAvailableOutput = {
  /** Indicates whether the specified email address can be used to create a customer. */
  is_email_available: Maybe<Scalars["Boolean"]["output"]>;
};

/** A list of options of the selected bundle product. */
export type IItemSelectedBundleOption = {
  /**
   * The unique ID for a `ItemSelectedBundleOption` object.
   * @deprecated Use `uid` instead.
   */
  id: Scalars["ID"]["output"];
  /** The label of the option. */
  label: Scalars["String"]["output"];
  /** The unique ID for a `ItemSelectedBundleOption` object. */
  uid: Scalars["ID"]["output"];
  /** A list of products that represent the values of the parent option. */
  values: Maybe<Array<Maybe<IItemSelectedBundleOptionValue>>>;
};

/** A list of values for the selected bundle product. */
export type IItemSelectedBundleOptionValue = {
  /**
   * The unique ID for a `ItemSelectedBundleOptionValue` object.
   * @deprecated Use `uid` instead.
   */
  id: Scalars["ID"]["output"];
  /** Provides information on the selections for presentation prices only on order item */
  presentation_info: Maybe<IPresentationPrices>;
  /** The price of the child bundle product. */
  price: IMoney;
  /** The name of the child bundle product. */
  product_name: Scalars["String"]["output"];
  /** The SKU of the child bundle product. */
  product_sku: Scalars["String"]["output"];
  /** The number of this bundle product that were ordered. */
  quantity: Scalars["Float"]["output"];
  /** The unique ID for a `ItemSelectedBundleOptionValue` object. */
  uid: Scalars["ID"]["output"];
};

/** Contains a key-value pair. */
export type IKeyValue = {
  /** The name part of the key/value pair. */
  name: Maybe<Scalars["String"]["output"]>;
  /** The value part of the key/value pair. */
  value: Maybe<Scalars["String"]["output"]>;
};

/** Contains information for rendering layered navigation. */
export type ILayerFilter = {
  /**
   * An array of filter items.
   * @deprecated Use `Aggregation.options` instead.
   */
  filter_items: Maybe<Array<Maybe<ILayerFilterItemInterface>>>;
  /**
   * The count of filter items in filter group.
   * @deprecated Use `Aggregation.count` instead.
   */
  filter_items_count: Maybe<Scalars["Int"]["output"]>;
  /**
   * The name of a layered navigation filter.
   * @deprecated Use `Aggregation.label` instead.
   */
  name: Maybe<Scalars["String"]["output"]>;
  /**
   * The request variable name for a filter query.
   * @deprecated Use `Aggregation.attribute_code` instead.
   */
  request_var: Maybe<Scalars["String"]["output"]>;
};

export type ILayerFilterItem = ILayerFilterItemInterface & {
  /**
   * The count of items per filter.
   * @deprecated Use `AggregationOption.count` instead.
   */
  items_count: Maybe<Scalars["Int"]["output"]>;
  /**
   * The label for a filter.
   * @deprecated Use `AggregationOption.label` instead.
   */
  label: Maybe<Scalars["String"]["output"]>;
  /**
   * The value of a filter request variable to be used in query.
   * @deprecated Use `AggregationOption.value` instead.
   */
  value_string: Maybe<Scalars["String"]["output"]>;
};

export type ILayerFilterItemInterface = {
  /**
   * The count of items per filter.
   * @deprecated Use `AggregationOption.count` instead.
   */
  items_count: Maybe<Scalars["Int"]["output"]>;
  /**
   * The label for a filter.
   * @deprecated Use `AggregationOption.label` instead.
   */
  label: Maybe<Scalars["String"]["output"]>;
  /**
   * The value of a filter request variable to be used in query.
   * @deprecated Use `AggregationOption.value` instead.
   */
  value_string: Maybe<Scalars["String"]["output"]>;
};

/** Defines characteristics about images and videos associated with a specific product. */
export type IMediaGalleryEntry = {
  /** Details about the content of the media gallery item. */
  content: Maybe<IProductMediaGalleryEntriesContent>;
  /** Indicates whether the image is hidden from view. */
  disabled: Maybe<Scalars["Boolean"]["output"]>;
  /** The path of the image on the server. */
  file: Maybe<Scalars["String"]["output"]>;
  /**
   * The identifier assigned to the object.
   * @deprecated Use `uid` instead.
   */
  id: Maybe<Scalars["Int"]["output"]>;
  /** The alt text displayed on the storefront when the user points to the image. */
  label: Maybe<Scalars["String"]["output"]>;
  /** Either `image` or `video`. */
  media_type: Maybe<Scalars["String"]["output"]>;
  /** The media item's position after it has been sorted. */
  position: Maybe<Scalars["Int"]["output"]>;
  /** Array of image types. It can have the following values: image, small_image, thumbnail. */
  types: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  /** The unique ID for a `MediaGalleryEntry` object. */
  uid: Scalars["ID"]["output"];
  /** Details about the content of a video item. */
  video_content: Maybe<IProductMediaGalleryEntriesVideoContent>;
};

/** Contains basic information about a product image or video. */
export type IMediaGalleryInterface = {
  /** Indicates whether the image is hidden from view. */
  disabled: Maybe<Scalars["Boolean"]["output"]>;
  /** The label of the product image or video. */
  label: Maybe<Scalars["String"]["output"]>;
  /** The media item's position after it has been sorted. */
  position: Maybe<Scalars["Int"]["output"]>;
  /** Array of image types. It can have the following values: image, small_image, thumbnail. */
  types: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  /** The URL of the product image or video. */
  url: Maybe<Scalars["String"]["output"]>;
};

/** Contains basic information about a product image or video. */
export type IMediaGalleryInterfaceUrlArgs = {
  dpr: InputMaybe<Scalars["Int"]["input"]>;
  fit: InputMaybe<Scalars["String"]["input"]>;
  height: InputMaybe<Scalars["Int"]["input"]>;
  quality: InputMaybe<Scalars["Int"]["input"]>;
  size: InputMaybe<Scalars["String"]["input"]>;
  width: InputMaybe<Scalars["Int"]["input"]>;
};

export type IMessageStyleLogo = {
  /** The type of logo for the PayPal Pay Later messaging */
  type: Maybe<Scalars["String"]["output"]>;
};

export type IMessageStyles = {
  /** The message layout */
  layout: Maybe<Scalars["String"]["output"]>;
  /** The message logo */
  logo: Maybe<IMessageStyleLogo>;
};

/** Defines a monetary value, including a numeric value and a currency code. */
export type IMoney = {
  /** A three-letter currency code, such as USD or EUR. */
  currency: Maybe<ICurrencyEnum>;
  /** A number expressing a monetary value. */
  value: Maybe<Scalars["Float"]["output"]>;
};

/** Defines a monetary value, including a numeric value and a currency code and multiplier. */
export type IMoneyMultiplier = {
  /** A three-letter currency code, such as USD or EUR. */
  currency: Maybe<ICurrencyEnum>;
  /** The specific multiplier for price value. */
  multiplier: Maybe<Scalars["Int"]["output"]>;
  /** A number expressing a monetary value. */
  value: Maybe<Scalars["Float"]["output"]>;
};

/** Contains the customer's gift registry and any errors encountered. */
export type IMoveCartItemsToGiftRegistryOutput = IGiftRegistryItemUserErrorInterface &
  IGiftRegistryOutputInterface & {
    /** The gift registry. */
    gift_registry: Maybe<IGiftRegistry>;
    /** Indicates whether the attempt to move the cart items to the gift registry was successful. */
    status: Scalars["Boolean"]["output"];
    /** An array of errors encountered while moving items from the cart to the gift registry. */
    user_errors: Array<Maybe<IGiftRegistryItemsUserError>>;
  };

/** Contains the source and target wish lists after moving products. */
export type IMoveProductsBetweenWishlistsOutput = {
  /** The destination wish list after receiving products moved from the source wish list. */
  destination_wishlist: IWishlist;
  /** The source wish list after moving products from it. */
  source_wishlist: IWishlist;
  /** An array of errors encountered while moving products to a wish list. */
  user_errors: Array<Maybe<IWishListUserInputError>>;
};

export type IMultiselectQuantity = {
  qty: InputMaybe<Array<InputMaybe<Scalars["Float"]["input"]>>>;
  selection_id: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type IMutation = {
  /** Add one or more bundle products to the specified cart. We recommend using `addProductsToCart` instead. */
  addBundleProductsToCart: Maybe<IAddBundleProductsToCartOutput>;
  /** Add one or more configurable products to the specified cart. We recommend using `addProductsToCart` instead. */
  addConfigurableProductsToCart: Maybe<IAddConfigurableProductsToCartOutput>;
  /** Add single pre-defined coupon code to the specified cart. */
  addCouponToCart: Maybe<IAddCouponToCartOutput>;
  /** Add one or more downloadable products to the specified cart. We recommend using `addProductsToCart` instead. */
  addDownloadableProductsToCart: Maybe<IAddDownloadableProductsToCartOutput>;
  /** Add registrants to the specified gift registry. */
  addGiftRegistryRegistrants: Maybe<IAddGiftRegistryRegistrantsOutput>;
  /** Add any type of product to the cart. */
  addProductsToCart: Maybe<IAddProductsToCartOutput>;
  /** Add products to the specified compare list. */
  addProductsToCompareList: Maybe<ICompareList>;
  /** Creates a new cart and add any type of product to it */
  addProductsToNewCart: Maybe<IAddProductsToNewCartOutput>;
  /** Add one or more products to the specified wish list. This mutation supports all product types. */
  addProductsToWishlist: Maybe<IAddProductsToWishlistOutput>;
  /** Add a comment to an existing return. */
  addReturnComment: Maybe<IAddReturnCommentOutput>;
  /** Add tracking information to the return. */
  addReturnTracking: Maybe<IAddReturnTrackingOutput>;
  /** Add one or more simple products to the specified cart. We recommend using `addProductsToCart` instead. */
  addSimpleProductsToCart: Maybe<IAddSimpleProductsToCartOutput>;
  /** Add one or more virtual products to the specified cart. We recommend using `addProductsToCart` instead. */
  addVirtualProductsToCart: Maybe<IAddVirtualProductsToCartOutput>;
  /** Add items in the specified wishlist to the customer's cart. */
  addWishlistItemsToCart: Maybe<IAddWishlistItemsToCartOutput>;
  applyCampaignToCart: Maybe<IApplyCampaignToCartOutput>;
  /** Apply a pre-defined coupon code to the specified cart. */
  applyCouponToCart: Maybe<IApplyCouponToCartOutput>;
  /** Apply a pre-defined coupon code to the specified cart. */
  applyCouponsToCart: Maybe<IApplyCouponToCartOutput>;
  /** Apply a pre-defined gift card code to the specified cart. */
  applyGiftCardToCart: Maybe<IApplyGiftCardToCartOutput>;
  /** Apply all available points, up to the cart total. Partial redemption is not available. */
  applyRewardPointsToCart: Maybe<IApplyRewardPointsToCartOutput>;
  /** Apply store credit to the specified cart. */
  applyStoreCreditToCart: Maybe<IApplyStoreCreditToCartOutput>;
  /** Assign the specified compare list to the logged in customer. */
  assignCompareListToCustomer: Maybe<IAssignCompareListToCustomerOutput>;
  /** Assign a logged-in customer to the specified guest shopping cart. */
  assignCustomerToGuestCart: ICart;
  /** Query by Subscribe for Back in Stock Notification. */
  backinstockSubscribe: Maybe<Scalars["String"]["output"]>;
  /** Cancel the specified customer order. */
  cancelOrder: Maybe<ICancelOrderOutput>;
  /** Query by Cancel Order. */
  cancelorder: Maybe<Scalars["Boolean"]["output"]>;
  cartCanApplyCoupons: Maybe<Scalars["Boolean"]["output"]>;
  /** Change the password for the logged-in customer. */
  changeCustomerPassword: Maybe<ICustomer>;
  /** Remove all items from the specified cart. */
  clearCart: IClearCartOutput;
  /** Synchronizes order details and place the order */
  completeOrder: Maybe<IPlaceOrderOutput>;
  /** Cancel the specified guest customer order. */
  confirmCancelOrder: Maybe<ICancelOrderOutput>;
  /** Confirms the email address for a customer. */
  confirmEmail: Maybe<ICustomerOutput>;
  /** Confirm the return. */
  confirmReturn: Maybe<IRequestReturnOutput>;
  /** Send a 'Contact Us' email to the merchant. */
  contactUs: Maybe<IContactUsOutput>;
  /** Copy products from one wish list to another. The original wish list is unchanged. */
  copyProductsBetweenWishlists: Maybe<ICopyProductsBetweenWishlistsOutput>;
  /** Create a new compare list. The compare list is saved for logged in customers. */
  createCompareList: Maybe<ICompareList>;
  /** @deprecated Use `createCustomerV2` instead. */
  createCustomer: Maybe<ICustomerOutput>;
  /** Create a billing or shipping address for a customer or guest. */
  createCustomerAddress: Maybe<ICustomerAddress>;
  /** Create a customer account. */
  createCustomerV2: Maybe<ICustomerOutput>;
  /**
   * Create an empty shopping cart for a guest or logged in user
   * @deprecated Use `Mutation.createGuestCart` or `Query.customerCart` for logged in customer
   */
  createEmptyCart: Maybe<Scalars["String"]["output"]>;
  /** Create a gift registry on behalf of the customer. */
  createGiftRegistry: Maybe<ICreateGiftRegistryOutput>;
  /** Create a new shopping cart */
  createGuestCart: Maybe<ICreateGuestCartOutput>;
  /** Initiate a transaction and receive a token. Use this mutation for Payflow Pro and Payments Pro payment methods */
  createPayflowProToken: Maybe<ICreatePayflowProTokenOutput>;
  /** Creates a payment order for further payment processing */
  createPaymentOrder: Maybe<ICreatePaymentOrderOutput>;
  /** Initiate an Express Checkout transaction and receive a token. Use this mutation for Express Checkout and Payments Standard payment methods. */
  createPaypalExpressToken: Maybe<IPaypalExpressTokenOutput>;
  /** Create a product review for the specified product. */
  createProductReview: ICreateProductReviewOutput;
  /** Creates a vault payment token */
  createVaultCardPaymentToken: Maybe<ICreateVaultCardPaymentTokenOutput>;
  /** Creates a vault card setup token */
  createVaultCardSetupToken: Maybe<ICreateVaultCardSetupTokenOutput>;
  /** Create a new wish list. */
  createWishlist: Maybe<ICreateWishlistOutput>;
  /** Delete the specified compare list. */
  deleteCompareList: Maybe<IDeleteCompareListOutput>;
  /** Delete customer account */
  deleteCustomer: Maybe<Scalars["Boolean"]["output"]>;
  /** Delete the billing or shipping address of a customer. */
  deleteCustomerAddress: Maybe<Scalars["Boolean"]["output"]>;
  /** Delete a customer's payment token. */
  deletePaymentToken: Maybe<IDeletePaymentTokenOutput>;
  /** Delete the specified wish list. You cannot delete the customer's default (first) wish list. */
  deleteWishlist: Maybe<IDeleteWishlistOutput>;
  /** Estimate shipping method(s) for cart based on address */
  estimateShippingMethods: Maybe<Array<Maybe<IAvailableShippingMethod>>>;
  /** Estimate totals for cart based on the address */
  estimateTotals: IEstimateTotalsOutput;
  /** Generate a token for specified customer. */
  generateCustomerToken: Maybe<ICustomerToken>;
  /** Request a customer token so that an administrator can perform remote shopping assistance. */
  generateCustomerTokenAsAdmin: Maybe<IGenerateCustomerTokenAsAdminOutput>;
  /** Handle a payment response and save the payment in Quote. Use this mutation for Payflow Pro and Payments Pro payment methods. */
  handlePayflowProResponse: Maybe<IPayflowProResponseOutput>;
  /** Transfer the contents of a guest cart into the cart of a logged-in customer. */
  mergeCarts: ICart;
  /** Move all items from the cart to a gift registry. */
  moveCartItemsToGiftRegistry: Maybe<IMoveCartItemsToGiftRegistryOutput>;
  /** Move products from one wish list to another. */
  moveProductsBetweenWishlists: Maybe<IMoveProductsBetweenWishlistsOutput>;
  /** Convert the quote into an order. */
  placeOrder: Maybe<IPlaceOrderOutput>;
  /** Redeem a gift card for store credit. */
  redeemGiftCardBalanceAsStoreCredit: Maybe<IGiftCardAccount>;
  removeCampaignFromCart: Maybe<IRemoveCampaignFromCartOutput>;
  /** Remove a previously-applied coupon from the cart. The cart must contain at least one item in order to remove the coupon. */
  removeCouponFromCart: Maybe<IRemoveCouponFromCartOutput>;
  /** Remove a previously-applied coupon from the cart. The cart must contain at least one item in order to remove the coupon. */
  removeCouponsFromCart: Maybe<IRemoveCouponFromCartOutput>;
  /** Removes a gift card from the cart. */
  removeGiftCardFromCart: Maybe<IRemoveGiftCardFromCartOutput>;
  /** Delete the specified gift registry. */
  removeGiftRegistry: Maybe<IRemoveGiftRegistryOutput>;
  /** Delete the specified items from a gift registry. */
  removeGiftRegistryItems: Maybe<IRemoveGiftRegistryItemsOutput>;
  /** Removes registrants from a gift registry. */
  removeGiftRegistryRegistrants: Maybe<IRemoveGiftRegistryRegistrantsOutput>;
  /** Delete the entire quantity of a specified item from the cart. If you remove all items from the cart, the cart continues to exist. */
  removeItemFromCart: Maybe<IRemoveItemFromCartOutput>;
  /** Remove products from the specified compare list. */
  removeProductsFromCompareList: Maybe<ICompareList>;
  /** Remove one or more products from the specified wish list. */
  removeProductsFromWishlist: Maybe<IRemoveProductsFromWishlistOutput>;
  /** Remove a tracked shipment from a return. */
  removeReturnTracking: Maybe<IRemoveReturnTrackingOutput>;
  /** Cancel the application of reward points to the cart. */
  removeRewardPointsFromCart: Maybe<IRemoveRewardPointsFromCartOutput>;
  /** Remove store credit that has been applied to the specified cart. */
  removeStoreCreditFromCart: Maybe<IRemoveStoreCreditFromCartOutput>;
  /** Add all products from a customer's previous order to the cart. */
  reorderItems: Maybe<IReorderItemsOutput>;
  /** Request to cancel specified guest order. */
  requestGuestOrderCancel: Maybe<ICancelOrderOutput>;
  requestGuestReturn: Maybe<IRequestReturnOutput>;
  /** Request an email with a reset password token for the registered customer identified by the specified email. */
  requestPasswordResetEmail: Maybe<Scalars["Boolean"]["output"]>;
  /** Initiates a buyer's request to return items for replacement or refund. */
  requestReturn: Maybe<IRequestReturnOutput>;
  /** Resends the confirmation email to a customer. */
  resendConfirmationEmail: Maybe<Scalars["Boolean"]["output"]>;
  /** Reset a customer's password using the reset password token that the customer received in an email after requesting it using `requestPasswordResetEmail`. */
  resetPassword: Maybe<Scalars["Boolean"]["output"]>;
  /** Revoke the customer token. */
  revokeCustomerToken: Maybe<IRevokeCustomerTokenOutput>;
  /** Send a message on behalf of a customer to the specified email addresses. */
  sendEmailToFriend: Maybe<ISendEmailToFriendOutput>;
  /** Set additional attributes for the selected cart */
  setAdditionalAttributes: Maybe<ISetAdditionalAttributesOutput>;
  /** Set the billing address on a specific cart. */
  setBillingAddressOnCart: Maybe<ISetBillingAddressOnCartOutput>;
  /** Sets the cart as inactive */
  setCartAsInactive: Maybe<ISetCartAsInactiveOutput>;
  /** Set gift options, including gift messages, gift wrapping, gift receipts, and printed cards. */
  setGiftOptionsOnCart: Maybe<ISetGiftOptionsOnCartOutput>;
  /** Assign the email address of a guest to the cart. */
  setGuestEmailOnCart: Maybe<ISetGuestEmailOnCartOutput>;
  /**
   * Set the cart payment method and convert the cart into an order.
   * @deprecated Should use setPaymentMethodOnCart and placeOrder mutations in single request.
   */
  setPaymentMethodAndPlaceOrder: Maybe<IPlaceOrderOutput>;
  /** Apply a payment method to the cart. */
  setPaymentMethodOnCart: Maybe<ISetPaymentMethodOnCartOutput>;
  /** Set one or more shipping addresses on a specific cart. */
  setShippingAddressesOnCart: Maybe<ISetShippingAddressesOnCartOutput>;
  /** Set one or more delivery methods on a cart. */
  setShippingMethodsOnCart: Maybe<ISetShippingMethodsOnCartOutput>;
  /** Send an email about the gift registry to a list of invitees. */
  shareGiftRegistry: Maybe<IShareGiftRegistryOutput>;
  /** Subscribe the specified email to the store's newsletter. */
  subscribeEmailToNewsletter: Maybe<ISubscribeEmailToNewsletterOutput>;
  /** Synchronizes the payment order details for further payment processing */
  syncPaymentOrder: Maybe<Scalars["Boolean"]["output"]>;
  /** Track that a product was viewed in adobe commerce */
  trackViewedProduct: Maybe<Scalars["Boolean"]["output"]>;
  /** Modify items in the cart. */
  updateCartItems: Maybe<IUpdateCartItemsOutput>;
  /** @deprecated Use `updateCustomerV2` instead. */
  updateCustomer: Maybe<ICustomerOutput>;
  /** Update the billing or shipping address of a customer or guest. */
  updateCustomerAddress: Maybe<ICustomerAddress>;
  /** Change the email address for the logged-in customer. */
  updateCustomerEmail: Maybe<ICustomerOutput>;
  /** Update the customer's personal information. */
  updateCustomerV2: Maybe<ICustomerOutput>;
  /** Update the specified gift registry. */
  updateGiftRegistry: Maybe<IUpdateGiftRegistryOutput>;
  /** Update the specified items in the gift registry. */
  updateGiftRegistryItems: Maybe<IUpdateGiftRegistryItemsOutput>;
  /** Modify the properties of one or more gift registry registrants. */
  updateGiftRegistryRegistrants: Maybe<IUpdateGiftRegistryRegistrantsOutput>;
  /** Main entrypoint to update payment methods */
  updatePaymentMethod: Maybe<IUpdatePaymentOutput>;
  /** Update one or more products in the specified wish list. */
  updateProductsInWishlist: Maybe<IUpdateProductsInWishlistOutput>;
  /** Change the name and visibility of the specified wish list. */
  updateWishlist: Maybe<IUpdateWishlistOutput>;
};

export type IMutationAddBundleProductsToCartArgs = {
  input: InputMaybe<IAddBundleProductsToCartInput>;
};

export type IMutationAddConfigurableProductsToCartArgs = {
  input: InputMaybe<IAddConfigurableProductsToCartInput>;
};

export type IMutationAddCouponToCartArgs = {
  input: InputMaybe<IAddCouponToCartInput>;
};

export type IMutationAddDownloadableProductsToCartArgs = {
  input: InputMaybe<IAddDownloadableProductsToCartInput>;
};

export type IMutationAddGiftRegistryRegistrantsArgs = {
  giftRegistryUid: Scalars["ID"]["input"];
  registrants: Array<IAddGiftRegistryRegistrantInput>;
};

export type IMutationAddProductsToCartArgs = {
  cartId: Scalars["String"]["input"];
  cartItems: Array<ICartItemInput>;
};

export type IMutationAddProductsToCompareListArgs = {
  input: InputMaybe<IAddProductsToCompareListInput>;
};

export type IMutationAddProductsToNewCartArgs = {
  cartItems: Array<ICartItemInput>;
};

export type IMutationAddProductsToWishlistArgs = {
  wishlistId: Scalars["ID"]["input"];
  wishlistItems: Array<IWishlistItemInput>;
};

export type IMutationAddReturnCommentArgs = {
  input: IAddReturnCommentInput;
};

export type IMutationAddReturnTrackingArgs = {
  input: IAddReturnTrackingInput;
};

export type IMutationAddSimpleProductsToCartArgs = {
  input: InputMaybe<IAddSimpleProductsToCartInput>;
};

export type IMutationAddVirtualProductsToCartArgs = {
  input: InputMaybe<IAddVirtualProductsToCartInput>;
};

export type IMutationAddWishlistItemsToCartArgs = {
  wishlistId: Scalars["ID"]["input"];
  wishlistItemIds: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type IMutationApplyCampaignToCartArgs = {
  input: InputMaybe<IApplyCampaignToCartInput>;
};

export type IMutationApplyCouponToCartArgs = {
  input: InputMaybe<IApplyCouponToCartInput>;
};

export type IMutationApplyCouponsToCartArgs = {
  input: InputMaybe<IApplyCouponsToCartInput>;
};

export type IMutationApplyGiftCardToCartArgs = {
  input: InputMaybe<IApplyGiftCardToCartInput>;
};

export type IMutationApplyRewardPointsToCartArgs = {
  cartId: Scalars["ID"]["input"];
};

export type IMutationApplyStoreCreditToCartArgs = {
  input: IApplyStoreCreditToCartInput;
};

export type IMutationAssignCompareListToCustomerArgs = {
  uid: Scalars["ID"]["input"];
};

export type IMutationAssignCustomerToGuestCartArgs = {
  cart_id: Scalars["String"]["input"];
};

export type IMutationBackinstockSubscribeArgs = {
  productId: InputMaybe<Scalars["String"]["input"]>;
};

export type IMutationCancelOrderArgs = {
  input: ICancelOrderInput;
};

export type IMutationCancelorderArgs = {
  orderId: InputMaybe<Scalars["String"]["input"]>;
};

export type IMutationCartCanApplyCouponsArgs = {
  input: InputMaybe<ICanApplyCouponsInput>;
};

export type IMutationChangeCustomerPasswordArgs = {
  currentPassword: Scalars["String"]["input"];
  newPassword: Scalars["String"]["input"];
};

export type IMutationClearCartArgs = {
  input: IClearCartInput;
};

export type IMutationCompleteOrderArgs = {
  input: InputMaybe<ICompleteOrderInput>;
};

export type IMutationConfirmCancelOrderArgs = {
  input: IConfirmCancelOrderInput;
};

export type IMutationConfirmEmailArgs = {
  input: IConfirmEmailInput;
};

export type IMutationConfirmReturnArgs = {
  input: IConfirmReturnInput;
};

export type IMutationContactUsArgs = {
  input: IContactUsInput;
};

export type IMutationCopyProductsBetweenWishlistsArgs = {
  destinationWishlistUid: Scalars["ID"]["input"];
  sourceWishlistUid: Scalars["ID"]["input"];
  wishlistItems: Array<IWishlistItemCopyInput>;
};

export type IMutationCreateCompareListArgs = {
  input: InputMaybe<ICreateCompareListInput>;
};

export type IMutationCreateCustomerArgs = {
  input: ICustomerInput;
};

export type IMutationCreateCustomerAddressArgs = {
  input: ICustomerAddressInput;
};

export type IMutationCreateCustomerV2Args = {
  input: ICustomerCreateInput;
};

export type IMutationCreateEmptyCartArgs = {
  input: InputMaybe<ICreateEmptyCartInput>;
};

export type IMutationCreateGiftRegistryArgs = {
  giftRegistry: ICreateGiftRegistryInput;
};

export type IMutationCreateGuestCartArgs = {
  input: InputMaybe<ICreateGuestCartInput>;
};

export type IMutationCreatePayflowProTokenArgs = {
  input: IPayflowProTokenInput;
};

export type IMutationCreatePaymentOrderArgs = {
  input: ICreatePaymentOrderInput;
};

export type IMutationCreatePaypalExpressTokenArgs = {
  input: IPaypalExpressTokenInput;
};

export type IMutationCreateProductReviewArgs = {
  input: ICreateProductReviewInput;
};

export type IMutationCreateVaultCardPaymentTokenArgs = {
  input: ICreateVaultCardPaymentTokenInput;
};

export type IMutationCreateVaultCardSetupTokenArgs = {
  input: ICreateVaultCardSetupTokenInput;
};

export type IMutationCreateWishlistArgs = {
  input: ICreateWishlistInput;
};

export type IMutationDeleteCompareListArgs = {
  uid: Scalars["ID"]["input"];
};

export type IMutationDeleteCustomerAddressArgs = {
  id: Scalars["Int"]["input"];
};

export type IMutationDeletePaymentTokenArgs = {
  public_hash: Scalars["String"]["input"];
};

export type IMutationDeleteWishlistArgs = {
  wishlistId: Scalars["ID"]["input"];
};

export type IMutationEstimateShippingMethodsArgs = {
  input: IEstimateTotalsInput;
};

export type IMutationEstimateTotalsArgs = {
  input: IEstimateTotalsInput;
};

export type IMutationGenerateCustomerTokenArgs = {
  email: Scalars["String"]["input"];
  password: Scalars["String"]["input"];
};

export type IMutationGenerateCustomerTokenAsAdminArgs = {
  input: IGenerateCustomerTokenAsAdminInput;
};

export type IMutationHandlePayflowProResponseArgs = {
  input: IPayflowProResponseInput;
};

export type IMutationMergeCartsArgs = {
  destination_cart_id: InputMaybe<Scalars["String"]["input"]>;
  source_cart_id: Scalars["String"]["input"];
};

export type IMutationMoveCartItemsToGiftRegistryArgs = {
  cartUid: Scalars["ID"]["input"];
  giftRegistryUid: Scalars["ID"]["input"];
};

export type IMutationMoveProductsBetweenWishlistsArgs = {
  destinationWishlistUid: Scalars["ID"]["input"];
  sourceWishlistUid: Scalars["ID"]["input"];
  wishlistItems: Array<IWishlistItemMoveInput>;
};

export type IMutationPlaceOrderArgs = {
  input: InputMaybe<IPlaceOrderInput>;
};

export type IMutationRedeemGiftCardBalanceAsStoreCreditArgs = {
  input: IGiftCardAccountInput;
};

export type IMutationRemoveCampaignFromCartArgs = {
  input: InputMaybe<IRemoveCampaignFromCartInput>;
};

export type IMutationRemoveCouponFromCartArgs = {
  input: InputMaybe<IRemoveCouponFromCartInput>;
};

export type IMutationRemoveCouponsFromCartArgs = {
  input: InputMaybe<IRemoveCouponsFromCartInput>;
};

export type IMutationRemoveGiftCardFromCartArgs = {
  input: InputMaybe<IRemoveGiftCardFromCartInput>;
};

export type IMutationRemoveGiftRegistryArgs = {
  giftRegistryUid: Scalars["ID"]["input"];
};

export type IMutationRemoveGiftRegistryItemsArgs = {
  giftRegistryUid: Scalars["ID"]["input"];
  itemsUid: Array<Scalars["ID"]["input"]>;
};

export type IMutationRemoveGiftRegistryRegistrantsArgs = {
  giftRegistryUid: Scalars["ID"]["input"];
  registrantsUid: Array<Scalars["ID"]["input"]>;
};

export type IMutationRemoveItemFromCartArgs = {
  input: InputMaybe<IRemoveItemFromCartInput>;
};

export type IMutationRemoveProductsFromCompareListArgs = {
  input: InputMaybe<IRemoveProductsFromCompareListInput>;
};

export type IMutationRemoveProductsFromWishlistArgs = {
  wishlistId: Scalars["ID"]["input"];
  wishlistItemsIds: Array<Scalars["ID"]["input"]>;
};

export type IMutationRemoveReturnTrackingArgs = {
  input: IRemoveReturnTrackingInput;
};

export type IMutationRemoveRewardPointsFromCartArgs = {
  cartId: Scalars["ID"]["input"];
};

export type IMutationRemoveStoreCreditFromCartArgs = {
  input: IRemoveStoreCreditFromCartInput;
};

export type IMutationReorderItemsArgs = {
  orderNumber: Scalars["String"]["input"];
};

export type IMutationRequestGuestOrderCancelArgs = {
  input: IGuestOrderCancelInput;
};

export type IMutationRequestGuestReturnArgs = {
  input: IRequestGuestReturnInput;
};

export type IMutationRequestPasswordResetEmailArgs = {
  email: Scalars["String"]["input"];
};

export type IMutationRequestReturnArgs = {
  input: IRequestReturnInput;
};

export type IMutationResendConfirmationEmailArgs = {
  email: Scalars["String"]["input"];
};

export type IMutationResetPasswordArgs = {
  email: Scalars["String"]["input"];
  newPassword: Scalars["String"]["input"];
  resetPasswordToken: Scalars["String"]["input"];
};

export type IMutationSendEmailToFriendArgs = {
  input: InputMaybe<ISendEmailToFriendInput>;
};

export type IMutationSetAdditionalAttributesArgs = {
  input: ISetAdditionalAttributesInput;
};

export type IMutationSetBillingAddressOnCartArgs = {
  input: InputMaybe<ISetBillingAddressOnCartInput>;
};

export type IMutationSetCartAsInactiveArgs = {
  cartId: Scalars["String"]["input"];
};

export type IMutationSetGiftOptionsOnCartArgs = {
  input: InputMaybe<ISetGiftOptionsOnCartInput>;
};

export type IMutationSetGuestEmailOnCartArgs = {
  input: InputMaybe<ISetGuestEmailOnCartInput>;
};

export type IMutationSetPaymentMethodAndPlaceOrderArgs = {
  input: InputMaybe<ISetPaymentMethodAndPlaceOrderInput>;
};

export type IMutationSetPaymentMethodOnCartArgs = {
  input: InputMaybe<ISetPaymentMethodOnCartInput>;
};

export type IMutationSetShippingAddressesOnCartArgs = {
  input: InputMaybe<ISetShippingAddressesOnCartInput>;
};

export type IMutationSetShippingMethodsOnCartArgs = {
  input: InputMaybe<ISetShippingMethodsOnCartInput>;
};

export type IMutationShareGiftRegistryArgs = {
  giftRegistryUid: Scalars["ID"]["input"];
  invitees: Array<IShareGiftRegistryInviteeInput>;
  sender: IShareGiftRegistrySenderInput;
};

export type IMutationSubscribeEmailToNewsletterArgs = {
  email: Scalars["String"]["input"];
};

export type IMutationSyncPaymentOrderArgs = {
  input: InputMaybe<ISyncPaymentOrderInput>;
};

export type IMutationTrackViewedProductArgs = {
  sku: Scalars["String"]["input"];
};

export type IMutationUpdateCartItemsArgs = {
  input: InputMaybe<IUpdateCartItemsInput>;
};

export type IMutationUpdateCustomerArgs = {
  input: ICustomerInput;
};

export type IMutationUpdateCustomerAddressArgs = {
  id: Scalars["Int"]["input"];
  input: InputMaybe<ICustomerAddressInput>;
};

export type IMutationUpdateCustomerEmailArgs = {
  email: Scalars["String"]["input"];
  password: Scalars["String"]["input"];
};

export type IMutationUpdateCustomerV2Args = {
  input: ICustomerUpdateInput;
};

export type IMutationUpdateGiftRegistryArgs = {
  giftRegistry: IUpdateGiftRegistryInput;
  giftRegistryUid: Scalars["ID"]["input"];
};

export type IMutationUpdateGiftRegistryItemsArgs = {
  giftRegistryUid: Scalars["ID"]["input"];
  items: Array<IUpdateGiftRegistryItemInput>;
};

export type IMutationUpdateGiftRegistryRegistrantsArgs = {
  giftRegistryUid: Scalars["ID"]["input"];
  registrants: Array<IUpdateGiftRegistryRegistrantInput>;
};

export type IMutationUpdatePaymentMethodArgs = {
  input: IUpdatePaymentInput;
};

export type IMutationUpdateProductsInWishlistArgs = {
  wishlistId: Scalars["ID"]["input"];
  wishlistItems: Array<IWishlistItemUpdateInput>;
};

export type IMutationUpdateWishlistArgs = {
  name: InputMaybe<Scalars["String"]["input"]>;
  visibility: InputMaybe<IWishlistVisibilityEnum>;
  wishlistId: Scalars["ID"]["input"];
};

/** Contains an error message when an invalid UID was specified. */
export type INoSuchEntityUidError = IErrorInterface & {
  /** The returned error message. */
  message: Scalars["String"]["output"];
  /** The specified invalid unique ID of an object. */
  uid: Scalars["ID"]["output"];
};

/** Contains the order ID. */
export type IOrder = {
  entity_id: Scalars["String"]["output"];
  /** @deprecated Use `order_number` instead. */
  order_id: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for an `Order` object. */
  order_number: Scalars["String"]["output"];
};

/** The list of available order actions. */
export enum IOrderActionType {
  Cancel = "CANCEL",
  Reorder = "REORDER",
  Return = "RETURN",
}

/** Contains detailed information about an order's billing and shipping addresses. */
export type IOrderAddress = {
  /** Administrative area level 2 */
  administrative_area_level_2: Maybe<Scalars["String"]["output"]>;
  /** Building Number */
  building_number: Maybe<Scalars["String"]["output"]>;
  /** The city or town. */
  city: Scalars["String"]["output"];
  /** The customer's company. */
  company: Maybe<Scalars["String"]["output"]>;
  /** The customer's country. */
  country_code: Maybe<ICountryCodeEnum>;
  /** Custom attributes assigned to the customer address. */
  custom_attributesV2: Array<Maybe<IAttributeValueInterface>>;
  /** District */
  district: Maybe<Scalars["String"]["output"]>;
  /** The fax number. */
  fax: Maybe<Scalars["String"]["output"]>;
  /** The first name of the person associated with the shipping/billing address. */
  firstname: Maybe<Scalars["String"]["output"]>;
  /** Apartment, floor, building, etc. */
  house_details: Maybe<Scalars["String"]["output"]>;
  /** States if the selected address is a pickup address */
  is_pickup_address: Maybe<Scalars["Boolean"]["output"]>;
  /** Landmark */
  landmark: Maybe<Scalars["String"]["output"]>;
  /** The family name of the person associated with the shipping/billing address. */
  lastname: Scalars["String"]["output"];
  /** The middle name of the person associated with the shipping/billing address. */
  middlename: Maybe<Scalars["String"]["output"]>;
  /** Neighborhood */
  neighborhood: Maybe<Scalars["String"]["output"]>;
  /** JSON encoded string of required fields like store id etc for the pickup point */
  pickup_information: Maybe<Scalars["String"]["output"]>;
  /** The customer's ZIP or postal code. */
  postcode: Maybe<Scalars["String"]["output"]>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix: Maybe<Scalars["String"]["output"]>;
  /** Premise */
  premise: Maybe<Scalars["String"]["output"]>;
  /** The state or province name. */
  region: Maybe<Scalars["String"]["output"]>;
  /** The region code resolved from region_id. */
  region_code: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `Region` object of a pre-defined region. */
  region_id: Maybe<Scalars["ID"]["output"]>;
  /** Short National Address */
  short_address: Maybe<Scalars["String"]["output"]>;
  /** An array of strings that define the street number and name. */
  street: Array<Maybe<Scalars["String"]["output"]>>;
  /** Street number */
  street_nr: Maybe<Scalars["String"]["output"]>;
  /** Sublocality level 2 */
  sublocality_level_2: Maybe<Scalars["String"]["output"]>;
  /** A value such as Sr., Jr., or III. */
  suffix: Maybe<Scalars["String"]["output"]>;
  /** The telephone number. */
  telephone: Maybe<Scalars["String"]["output"]>;
  /** The customer's Value-added tax (VAT) number (for corporate customers). */
  vat_id: Maybe<Scalars["String"]["output"]>;
};

/** Contains detailed information about an order's billing and shipping addresses. */
export type IOrderAddressCustom_AttributesV2Args = {
  attributeCodes: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type IOrderAttribute = {
  /** Attribute code */
  code: Scalars["String"]["output"];
  /** Any valid data type text, numeric, boolean etc, see OrderDataTypeEnum */
  data_type: IOrderDataTypeEnum;
  /** Attribute description */
  description: Scalars["String"]["output"];
  /** Any valid input html type checkbox, select, radio etc, see OrderInputTypeEnum */
  input_type: IOrderInputTypeEnum;
  is_required: Scalars["Boolean"]["output"];
  /** Attribute label */
  label: Scalars["String"]["output"];
  /** Max Value Length */
  max_length: Scalars["Int"]["output"];
  /** Min Value Length */
  min_length: Scalars["Int"]["output"];
  /** Attribute placeholder */
  placeholder: Scalars["String"]["output"];
  /** Placement of input */
  placement: Scalars["String"]["output"];
  /** Order of input */
  sort_order: Scalars["Int"]["output"];
  /** Validate Regex */
  validate_regex: Scalars["String"]["output"];
  /** Default Attribute Value */
  value: Scalars["String"]["output"];
};

/** Specifies the attribute code and value of an order attribute. */
export type IOrderAttributeInput = {
  /** The name assigned to the attribute. */
  attribute_code: InputMaybe<Scalars["String"]["input"]>;
  /** The value assigned to the attribute. */
  value: Scalars["String"]["input"];
};

/** Specifies the attribute code and value of an order attribute. */
export type IOrderAttributeOutput = {
  /** The name of the attribute. */
  attribute_code: Maybe<Scalars["String"]["output"]>;
  /** The value of the attribute. */
  value: Maybe<Scalars["String"]["output"]>;
};

export type IOrderCustomerInfo = {
  /** First name of the customer */
  firstname: Scalars["String"]["output"];
  /** Last name of the customer */
  lastname: Maybe<Scalars["String"]["output"]>;
  /** Middle name of the customer */
  middlename: Maybe<Scalars["String"]["output"]>;
  /** Prefix of the customer */
  prefix: Maybe<Scalars["String"]["output"]>;
  /** Suffix of the customer */
  suffix: Maybe<Scalars["String"]["output"]>;
};

export enum IOrderDataTypeEnum {
  Int = "int",
  Text = "text",
}

/** Input to retrieve an order based on details. */
export type IOrderInformationInput = {
  /** Order billing address email. */
  email: Scalars["String"]["input"];
  /** Order billing address lastname. */
  lastname: Scalars["String"]["input"];
  /** Order number. */
  number: Scalars["String"]["input"];
};

export enum IOrderInputTypeEnum {
  Checkbox = "checkbox",
  Multiselect = "multiselect",
  Radio = "radio",
  Select = "select",
  Text = "text",
  Textarea = "textarea",
}

export type IOrderItem = IOrderItemInterface & {
  /** The final discount information for the product. */
  discounts: Maybe<Array<Maybe<IDiscount>>>;
  /** Indicates whether the order item is eligible to be in a return request. */
  eligible_for_return: Maybe<Scalars["Boolean"]["output"]>;
  /** The entered option for the base product, such as a logo or image. */
  entered_options: Maybe<Array<Maybe<IOrderItemOption>>>;
  /** Provides info regarding the gift added to the basket */
  gift_data: Maybe<IGiftData>;
  /** The selected gift message for the order item */
  gift_message: Maybe<IGiftMessage>;
  /** The selected gift wrapping for the order item. */
  gift_wrapping: Maybe<IGiftWrapping>;
  /** Provides the flag to show if consent was set or not */
  has_registration_consent: Maybe<Scalars["Boolean"]["output"]>;
  /** The unique ID for an `OrderItemInterface` object. */
  id: Scalars["ID"]["output"];
  /** The original product price of the base product. */
  original_price: IMoney;
  /** Contains details about the price of the item, including taxes and discounts. */
  prices: Maybe<IOrderItemPrices>;
  /** The ProductInterface object, which contains details about the base product */
  product: Maybe<IProductInterface>;
  /** The name of the base product. */
  product_name: Maybe<Scalars["String"]["output"]>;
  /** The sale price of the base product, including selected options. */
  product_sale_price: IMoney;
  /** The sale price of the base product, including tax. */
  product_sale_price_incl_tax: IMoney;
  /** The SKU of the base product. */
  product_sku: Scalars["String"]["output"];
  /** Indicates whether this product has subscription flag. */
  product_subscription: Maybe<Scalars["Boolean"]["output"]>;
  /** The type of product, such as simple, configurable, etc. */
  product_type: Maybe<Scalars["String"]["output"]>;
  /** URL key of the base product. */
  product_url_key: Maybe<Scalars["String"]["output"]>;
  /** The number of canceled items. */
  quantity_canceled: Maybe<Scalars["Float"]["output"]>;
  /** The number of invoiced items. */
  quantity_invoiced: Maybe<Scalars["Float"]["output"]>;
  /** The number of units ordered for this item. */
  quantity_ordered: Maybe<Scalars["Float"]["output"]>;
  /** The number of refunded items. */
  quantity_refunded: Maybe<Scalars["Float"]["output"]>;
  /** The requested return quantity of the item. */
  quantity_return_requested: Maybe<Scalars["Float"]["output"]>;
  /** The number of returned items. */
  quantity_returned: Maybe<Scalars["Float"]["output"]>;
  /** The number of shipped items. */
  quantity_shipped: Maybe<Scalars["Float"]["output"]>;
  /** Row total for product. */
  row_total: IMoney;
  /** Row total for product including tax. */
  row_total_incl_tax: IMoney;
  /** The selected options for the base product, such as color or size. */
  selected_options: Maybe<Array<Maybe<IOrderItemOption>>>;
  /** The status of the order item. */
  status: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether the product is eligible for a trade-in purchase. */
  trade_in: Scalars["Int"]["output"];
};

/** Order item details. */
export type IOrderItemInterface = {
  /** The final discount information for the product. */
  discounts: Maybe<Array<Maybe<IDiscount>>>;
  /** Indicates whether the order item is eligible to be in a return request. */
  eligible_for_return: Maybe<Scalars["Boolean"]["output"]>;
  /** The entered option for the base product, such as a logo or image. */
  entered_options: Maybe<Array<Maybe<IOrderItemOption>>>;
  /** Provides info regarding the gift added to the basket */
  gift_data: Maybe<IGiftData>;
  /** The selected gift message for the order item */
  gift_message: Maybe<IGiftMessage>;
  /** The selected gift wrapping for the order item. */
  gift_wrapping: Maybe<IGiftWrapping>;
  /** Provides the flag to show if consent was set or not */
  has_registration_consent: Maybe<Scalars["Boolean"]["output"]>;
  /** The unique ID for an `OrderItemInterface` object. */
  id: Scalars["ID"]["output"];
  /** The original product price of the base product. */
  original_price: IMoney;
  /** Contains details about the price of the item, including taxes and discounts. */
  prices: Maybe<IOrderItemPrices>;
  /** The ProductInterface object, which contains details about the base product */
  product: Maybe<IProductInterface>;
  /** The name of the base product. */
  product_name: Maybe<Scalars["String"]["output"]>;
  /** The sale price of the base product, including selected options. */
  product_sale_price: IMoney;
  /** The sale price of the base product, including tax. */
  product_sale_price_incl_tax: IMoney;
  /** The SKU of the base product. */
  product_sku: Scalars["String"]["output"];
  /** Indicates whether this product has subscription flag. */
  product_subscription: Maybe<Scalars["Boolean"]["output"]>;
  /** The type of product, such as simple, configurable, etc. */
  product_type: Maybe<Scalars["String"]["output"]>;
  /** URL key of the base product. */
  product_url_key: Maybe<Scalars["String"]["output"]>;
  /** The number of canceled items. */
  quantity_canceled: Maybe<Scalars["Float"]["output"]>;
  /** The number of invoiced items. */
  quantity_invoiced: Maybe<Scalars["Float"]["output"]>;
  /** The number of units ordered for this item. */
  quantity_ordered: Maybe<Scalars["Float"]["output"]>;
  /** The number of refunded items. */
  quantity_refunded: Maybe<Scalars["Float"]["output"]>;
  /** The requested return quantity of the item. */
  quantity_return_requested: Maybe<Scalars["Float"]["output"]>;
  /** The number of returned items. */
  quantity_returned: Maybe<Scalars["Float"]["output"]>;
  /** The number of shipped items. */
  quantity_shipped: Maybe<Scalars["Float"]["output"]>;
  /** Row total for product. */
  row_total: IMoney;
  /** Row total for product including tax. */
  row_total_incl_tax: IMoney;
  /** The selected options for the base product, such as color or size. */
  selected_options: Maybe<Array<Maybe<IOrderItemOption>>>;
  /** The status of the order item. */
  status: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether the product is eligible for a trade-in purchase. */
  trade_in: Scalars["Int"]["output"];
};

/** Represents order item options like selected or entered. */
export type IOrderItemOption = {
  /** The name of the option. */
  label: Scalars["String"]["output"];
  /** The value of the option. */
  value: Scalars["String"]["output"];
};

export type IOrderItemPrices = {
  /** An array of discounts to be applied to the cart item. */
  discounts: Maybe<Array<Maybe<IDiscount>>>;
  fixed_product_taxes: Array<Maybe<IFixedProductTax>>;
  /** The original price of the item. */
  original_price: Maybe<IMoney>;
  /** The original price of the item including tax. */
  original_price_including_tax: Maybe<IMoney>;
  /** The value of the original price multiplied by the quantity of the item. */
  original_row_total: IMoney;
  /** The value of the original price multiplied by the quantity of the item including tax. */
  original_row_total_including_tax: IMoney;
  /** The price of the item before any discounts were applied. The price that might include tax, depending on the configured display settings for cart. */
  price: IMoney;
  /** The price of the item before any discounts were applied. The price that might include tax, depending on the configured display settings for cart. */
  price_including_tax: IMoney;
  /** The value of the price multiplied by the quantity of the item. */
  row_total: IMoney;
  /** The value of `row_total` plus the tax applied to the item. */
  row_total_including_tax: IMoney;
  /** The total of all discounts applied to the item. */
  total_item_discount: IMoney;
};

/** Contains details about the payment method used to pay for the order. */
export type IOrderPaymentMethod = {
  /** Additional data per payment method type. */
  additional_data: Maybe<Array<Maybe<IKeyValue>>>;
  /** Payment method code. */
  method_code: Scalars["String"]["output"];
  /** The label that describes the payment method. */
  name: Scalars["String"]["output"];
  /** The payment method code that indicates how the order was paid for. */
  type: Scalars["String"]["output"];
};

/** Contains order shipment details. */
export type IOrderShipment = {
  /** Comments added to the shipment. */
  comments: Maybe<Array<Maybe<ISalesCommentItem>>>;
  /** The unique ID for a `OrderShipment` object. */
  id: Scalars["ID"]["output"];
  /** An array of items included in the shipment. */
  items: Maybe<Array<Maybe<IShipmentItemInterface>>>;
  /** The sequential credit shipment number. */
  number: Scalars["String"]["output"];
  /** An array of shipment tracking details. */
  tracking: Maybe<Array<Maybe<IShipmentTracking>>>;
};

export type IOrderStatusReason = {
  /** Is order cancelled by user */
  cancelled_by_user: Maybe<Scalars["Boolean"]["output"]>;
  /** Time when reason was added */
  created_at: Scalars["String"]["output"];
  /** Unique reason id */
  entity_id: Scalars["Int"]["output"];
  /** Order for which reason was added */
  order_id: Scalars["Int"]["output"];
  /** Order status reason code */
  reason_code: Scalars["String"]["output"];
  /** Order status reason description */
  reason_description: Maybe<Scalars["String"]["output"]>;
  /** Order status for which reason was added */
  status: Scalars["String"]["output"];
};

/** Input to retrieve an order based on token. */
export type IOrderTokenInput = {
  /** Order token. */
  token: Scalars["String"]["input"];
};

/** Contains details about the sales total amounts used to calculate the final price. */
export type IOrderTotal = {
  /** The final base grand total amount in the base currency. */
  base_grand_total: IMoney;
  /** The applied discounts to the order. */
  discounts: Maybe<Array<Maybe<IDiscount>>>;
  gift_options: Maybe<IGiftOptionsPrices>;
  /** The final total amount, including shipping, discounts, and taxes. */
  grand_total: IMoney;
  /** Details about the shipping and handling costs for the order. */
  shipping_handling: Maybe<IShippingHandling>;
  /**
   * The subtotal of the order, excluding shipping, discounts, and taxes.
   * @deprecated Use subtotal_excl_tax field instead
   */
  subtotal: IMoney;
  /** The subtotal of the order, excluding taxes. */
  subtotal_excl_tax: IMoney;
  /** Subtotal incl tax */
  subtotal_incl_tax: IMoney;
  /** The order tax details. */
  taxes: Maybe<Array<Maybe<ITaxItem>>>;
  /** Total remained to refund */
  total_after_refund: IMoney;
  /** The gift card balance applied to the order. */
  total_giftcard: Maybe<IMoney>;
  /** Total paid */
  total_paid: IMoney;
  /** Refunded total amount */
  total_refunded: IMoney;
  /** The total reward points applied to the order. */
  total_reward_points: Maybe<IMoney>;
  /** The shipping amount for the order. */
  total_shipping: IMoney;
  /** The total store credit applied to the order. */
  total_store_credit: Maybe<IMoney>;
  /** The amount of tax applied to the order. */
  total_tax: IMoney;
};

export enum IOrderTypeEnum {
  Regular = "REGULAR",
  Trial = "TRIAL",
}

export type IPackagingFormat = {
  brandId: Scalars["ID"]["output"];
  contentsType: Scalars["String"]["output"];
  formatQuantity: Scalars["Int"]["output"];
  icon: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  itemsPerPackage: Scalars["Int"]["output"];
  label: Scalars["String"]["output"];
  packagesPerBundle: Scalars["Int"]["output"];
  productTypeName: Scalars["String"]["output"];
  sortOrder: Scalars["Int"]["output"];
};

/** Contains required input for Payflow Express Checkout payments. */
export type IPayflowExpressInput = {
  /** The unique ID of the PayPal user. */
  payer_id: Scalars["String"]["input"];
  /** The token returned by the createPaypalExpressToken mutation. */
  token: Scalars["String"]["input"];
};

/** A set of relative URLs that PayPal uses in response to various actions during the authorization process. Adobe Commerce prepends the base URL to this value to create a full URL. For example, if the full URL is https://www.example.com/path/to/page.html, the relative URL is path/to/page.html. Use this input for Payflow Link and Payments Advanced payment methods. */
export type IPayflowLinkInput = {
  /** The relative URL of the page that PayPal redirects to when the buyer cancels the transaction in order to choose a different payment method. If the full URL to this page is https://www.example.com/paypal/action/cancel.html, the relative URL is paypal/action/cancel.html. */
  cancel_url: Scalars["String"]["input"];
  /** The relative URL of the transaction error page that PayPal redirects to upon payment error. If the full URL to this page is https://www.example.com/paypal/action/error.html, the relative URL is paypal/action/error.html. */
  error_url: Scalars["String"]["input"];
  /** The relative URL of the order confirmation page that PayPal redirects to when the payment is successful and additional confirmation is not needed. If the full URL to this page is https://www.example.com/paypal/action/return.html, the relative URL is paypal/action/return.html. */
  return_url: Scalars["String"]["input"];
};

/** Indicates the mode for payment. Applies to the Payflow Link and Payments Advanced payment methods. */
export enum IPayflowLinkMode {
  Live = "LIVE",
  Test = "TEST",
}

/** Contains information used to generate PayPal iframe for transaction. Applies to Payflow Link and Payments Advanced payment methods. */
export type IPayflowLinkToken = {
  /** The mode for the Payflow transaction. */
  mode: Maybe<IPayflowLinkMode>;
  /** The PayPal URL used for requesting a Payflow form. */
  paypal_url: Maybe<Scalars["String"]["output"]>;
  /** The secure token generated by PayPal. */
  secure_token: Maybe<Scalars["String"]["output"]>;
  /** The secure token ID generated by PayPal. */
  secure_token_id: Maybe<Scalars["String"]["output"]>;
};

/** Contains information required to fetch payment token information for the Payflow Link and Payments Advanced payment methods. */
export type IPayflowLinkTokenInput = {
  /** The unique ID that identifies the customer's cart. */
  cart_id: Scalars["String"]["input"];
};

/** Contains input for the Payflow Pro and Payments Pro payment methods. */
export type IPayflowProInput = {
  /** Required input for credit card related information. */
  cc_details: ICreditCardDetailsInput;
  /** Indicates whether details about the shopper's credit/debit card should be tokenized for later usage. Required only if Vault is enabled for the PayPal Payflow Pro payment integration. */
  is_active_payment_token_enabler: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Input required to complete payment. Applies to Payflow Pro and Payments Pro payment methods. */
export type IPayflowProResponseInput = {
  /** The unique ID that identifies the shopper's cart. */
  cart_id: Scalars["String"]["input"];
  /** The payload returned from PayPal. */
  paypal_payload: Scalars["String"]["input"];
};

export type IPayflowProResponseOutput = {
  /** The cart with the updated selected payment method. */
  cart: ICart;
};

/** Contains the secure information used to authorize transaction. Applies to Payflow Pro and Payments Pro payment methods. */
export type IPayflowProToken = {
  /** The RESPMSG returned by PayPal. If the `result` is `0`, then `response_message` is `Approved`. */
  response_message: Scalars["String"]["output"];
  /** A non-zero value if any errors occurred. */
  result: Scalars["Int"]["output"];
  /** The RESULT returned by PayPal. A value of `0` indicates the transaction was approved. */
  result_code: Scalars["Int"]["output"];
  /** A secure token generated by PayPal. */
  secure_token: Scalars["String"]["output"];
  /** A secure token ID generated by PayPal. */
  secure_token_id: Scalars["String"]["output"];
};

/** Contains input required to fetch payment token information for the Payflow Pro and Payments Pro payment methods. */
export type IPayflowProTokenInput = {
  /** The unique ID that identifies the shopper's cart. */
  cart_id: Scalars["String"]["input"];
  /** A set of relative URLs that PayPal uses for callback. */
  urls: IPayflowProUrlInput;
};

/** Contains a set of relative URLs that PayPal uses in response to various actions during the authorization process. Magento prepends the base URL to this value to create a full URL. For example, if the full URL is https://www.example.com/path/to/page.html, the relative URL is path/to/page.html. Use this input for the Payflow Pro and Payment Pro payment methods. */
export type IPayflowProUrlInput = {
  /** The relative URL of the page that PayPal redirects to when the buyer cancels the transaction in order to choose a different payment method. If the full URL to this page is https://www.example.com/paypal/action/cancel.html, the relative URL is paypal/action/cancel.html. */
  cancel_url: Scalars["String"]["input"];
  /** The relative URL of the transaction error page that PayPal redirects to upon payment error. If the full URL to this page is https://www.example.com/paypal/action/error.html, the relative URL is paypal/action/error.html. */
  error_url: Scalars["String"]["input"];
  /** The relative URL of the final confirmation page that PayPal redirects to upon payment success. If the full URL to this page is https://www.example.com/paypal/action/return.html, the relative URL is paypal/action/return.html. */
  return_url: Scalars["String"]["input"];
};

export type IPaymentCommonConfig = IPaymentConfigItem & {
  /** The payment method code as defined in the payment gateway */
  code: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether the payment method is displayed */
  is_visible: Maybe<Scalars["Boolean"]["output"]>;
  /** Defines the payment intent (Authorize or Capture */
  payment_intent: Maybe<Scalars["String"]["output"]>;
  /** The PayPal parameters required to load the JS SDK */
  sdk_params: Maybe<Array<Maybe<ISdkParams>>>;
  /** The relative order the payment method is displayed on the checkout page */
  sort_order: Maybe<Scalars["String"]["output"]>;
  /** The name displayed for the payment method */
  title: Maybe<Scalars["String"]["output"]>;
};

/** Contains payment fields that are common to all types of payment methods. */
export type IPaymentConfigItem = {
  /** The payment method code as defined in the payment gateway */
  code: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether the payment method is displayed */
  is_visible: Maybe<Scalars["Boolean"]["output"]>;
  /** Defines the payment intent (Authorize or Capture */
  payment_intent: Maybe<Scalars["String"]["output"]>;
  /** The PayPal parameters required to load the JS SDK */
  sdk_params: Maybe<Array<Maybe<ISdkParams>>>;
  /** The relative order the payment method is displayed on the checkout page */
  sort_order: Maybe<Scalars["String"]["output"]>;
  /** The name displayed for the payment method */
  title: Maybe<Scalars["String"]["output"]>;
};

/** Retrieves the payment configuration for a given location */
export type IPaymentConfigOutput = {
  /** ApplePay payment method configuration */
  apple_pay: Maybe<IApplePayConfig>;
  /** Fastlane payment method configuration */
  fastlane: Maybe<IFastlaneConfig>;
  /** GooglePay payment method configuration */
  google_pay: Maybe<IGooglePayConfig>;
  /** Hosted fields payment method configuration */
  hosted_fields: Maybe<IHostedFieldsConfig>;
  /** Smart Buttons payment method configuration */
  smart_buttons: Maybe<ISmartButtonsConfig>;
};

/** Defines the origin location for that payment request */
export enum IPaymentLocation {
  Admin = "ADMIN",
  Cart = "CART",
  Checkout = "CHECKOUT",
  Minicart = "MINICART",
  ProductDetail = "PRODUCT_DETAIL",
  StartOfCheckout = "START_OF_CHECKOUT",
}

/** Defines the payment method. */
export type IPaymentMethodInput = {
  /** The internal name for the payment method. */
  code: Scalars["String"]["input"];
  /** Required input for PayPal Hosted pro payments. */
  hosted_pro: InputMaybe<IHostedProInput>;
  /** Required input for Payflow Express Checkout payments. */
  payflow_express: InputMaybe<IPayflowExpressInput>;
  /** Required input for PayPal Payflow Link and Payments Advanced payments. */
  payflow_link: InputMaybe<IPayflowLinkInput>;
  /** Required input for PayPal Payflow Pro and Payment Pro payments. */
  payflowpro: InputMaybe<IPayflowProInput>;
  /** Required input for PayPal Payflow Pro vault payments. */
  payflowpro_cc_vault: InputMaybe<IVaultTokenInput>;
  /** Required input for Apple Pay button */
  payment_services_paypal_apple_pay: InputMaybe<IApplePayMethodInput>;
  /** Required input for fastlane */
  payment_services_paypal_fastlane: InputMaybe<IFastlaneMethodInput>;
  /** Required input for Google Pay button */
  payment_services_paypal_google_pay: InputMaybe<IGooglePayMethodInput>;
  /** Required input for Hosted Fields */
  payment_services_paypal_hosted_fields: InputMaybe<IHostedFieldsInput>;
  /** Required input for Smart buttons */
  payment_services_paypal_smart_buttons: InputMaybe<ISmartButtonMethodInput>;
  /** Required input for vault */
  payment_services_paypal_vault: InputMaybe<IVaultMethodInput>;
  /** Required input for Express Checkout and Payments Standard payments. */
  paypal_express: InputMaybe<IPaypalExpressInput>;
  /** The purchase order number. Optional for most payment methods. */
  purchase_order_number: InputMaybe<Scalars["String"]["input"]>;
};

/** Contains the payment order details */
export type IPaymentOrderOutput = {
  /** PayPal order ID */
  id: Maybe<Scalars["String"]["output"]>;
  /** The order ID generated by Payment Services */
  mp_order_id: Maybe<Scalars["String"]["output"]>;
  /** Details about the card used on the order */
  payment_source_details: Maybe<IPaymentSourceDetails>;
  /** The status of the payment order */
  status: Maybe<Scalars["String"]["output"]>;
};

export type IPaymentSdkParamsItem = {
  /** The payment method code used in the order */
  code: Maybe<Scalars["String"]["output"]>;
  /** The payment SDK parameters */
  params: Maybe<Array<Maybe<ISdkParams>>>;
};

export type IPaymentSourceDetails = {
  /** Details about the card used on the order */
  card: Maybe<ICard>;
};

/** The payment source information */
export type IPaymentSourceInput = {
  /** The card payment source information */
  card: ICardPaymentSourceInput;
};

/** The payment source information */
export type IPaymentSourceOutput = {
  /** The card payment source information */
  card: ICardPaymentSourceOutput;
};

/** The stored payment method available to the customer. */
export type IPaymentToken = {
  /** A description of the stored account details. */
  details: Maybe<Scalars["String"]["output"]>;
  /** The payment method code associated with the token. */
  payment_method_code: Scalars["String"]["output"];
  /** The public hash of the token. */
  public_hash: Scalars["String"]["output"];
  /** Specifies the payment token type. */
  type: IPaymentTokenTypeEnum;
};

/** The list of available payment token types. */
export enum IPaymentTokenTypeEnum {
  /** phpcs:ignore Magento2.GraphQL.ValidArgumentName */
  Account = "account",
  /** phpcs:ignore Magento2.GraphQL.ValidArgumentName */
  Card = "card",
}

/** Contains required input for Express Checkout and Payments Standard payments. */
export type IPaypalExpressInput = {
  /** The unique ID of the PayPal user. */
  payer_id: Scalars["String"]["input"];
  /** The token returned by the `createPaypalExpressToken` mutation. */
  token: Scalars["String"]["input"];
};

/** Deprecated. Use `PaypalExpressTokenOutput` instead. */
export type IPaypalExpressToken = {
  /**
   * A set of URLs that allow the buyer to authorize payment and adjust checkout details.
   * @deprecated Use `PaypalExpressTokenOutput.paypal_urls` instead.
   */
  paypal_urls: Maybe<IPaypalExpressUrlList>;
  /**
   * The token returned by PayPal.
   * @deprecated Use `PaypalExpressTokenOutput.token` instead.
   */
  token: Maybe<Scalars["String"]["output"]>;
};

/** Defines the attributes required to receive a payment token for Express Checkout and Payments Standard payment methods. */
export type IPaypalExpressTokenInput = {
  /** The unique ID that identifies the customer's cart. */
  cart_id: Scalars["String"]["input"];
  /** The payment method code. */
  code: Scalars["String"]["input"];
  /** Indicates whether the buyer selected the quick checkout button. The default value is false. */
  express_button: InputMaybe<Scalars["Boolean"]["input"]>;
  /** A set of relative URLs that PayPal uses in response to various actions during the authorization process. */
  urls: IPaypalExpressUrlsInput;
  /** Indicates whether the buyer clicked the PayPal credit button. The default value is false. */
  use_paypal_credit: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Contains the token returned by PayPal and a set of URLs that allow the buyer to authorize payment and adjust checkout details. Applies to Express Checkout and Payments Standard payment methods. */
export type IPaypalExpressTokenOutput = {
  /** A set of URLs that allow the buyer to authorize payment and adjust checkout details. */
  paypal_urls: Maybe<IPaypalExpressUrlList>;
  /** The token returned by PayPal. */
  token: Maybe<Scalars["String"]["output"]>;
};

/** Contains a set of URLs that allow the buyer to authorize payment and adjust checkout details for Express Checkout and Payments Standard transactions. */
export type IPaypalExpressUrlList = {
  /** The PayPal URL that allows the buyer to edit their checkout details. */
  edit: Maybe<Scalars["String"]["output"]>;
  /** The URL to the PayPal login page. */
  start: Maybe<Scalars["String"]["output"]>;
};

/** Contains a set of relative URLs that PayPal uses in response to various actions during the authorization process. Magento prepends the base URL to this value to create a full URL. For example, if the full URL is https://www.example.com/path/to/page.html, the relative URL is path/to/page.html. Use this input for Express Checkout and Payments Standard payment methods. */
export type IPaypalExpressUrlsInput = {
  /** The relative URL of the page that PayPal redirects to when the buyer cancels the transaction in order to choose a different payment method. If the full URL to this page is https://www.example.com/paypal/action/cancel.html, the relative URL is paypal/action/cancel.html. */
  cancel_url: Scalars["String"]["input"];
  /** The relative URL of the page that PayPal redirects to when the payment has been put on hold for additional review. This condition mostly applies to ACH transactions, and is not applicable to most PayPal solutions. If the full URL to this page is https://www.example.com/paypal/action/success_pending.html, the relative URL is paypal/action/success_pending.html. */
  pending_url: InputMaybe<Scalars["String"]["input"]>;
  /** The relative URL of the final confirmation page that PayPal redirects to upon payment success. If the full URL to this page is https://www.example.com/paypal/action/return.html, the relative URL is paypal/action/return.html. */
  return_url: Scalars["String"]["input"];
  /** The relative URL of the order confirmation page that PayPal redirects to when the payment is successful and additional confirmation is not needed. Not applicable to most PayPal solutions. If the full URL to this page is https://www.example.com/paypal/action/success.html, the relative URL is paypal/action/success.html. */
  success_url: InputMaybe<Scalars["String"]["input"]>;
};

/** Contains attributes specific to tangible products. */
export type IPhysicalProductInterface = {
  /** The weight of the item, in units defined by the store. */
  weight: Maybe<Scalars["Float"]["output"]>;
};

/** An error encountered while placing an order. */
export type IPlaceOrderError = {
  /** An error code that is specific to place order. */
  code: IPlaceOrderErrorCodes;
  /** A localized error message. */
  message: Scalars["String"]["output"];
};

export enum IPlaceOrderErrorCodes {
  CartNotActive = "CART_NOT_ACTIVE",
  CartNotFound = "CART_NOT_FOUND",
  GuestEmailMissing = "GUEST_EMAIL_MISSING",
  SalesruleGiftNotValid = "SALESRULE_GIFT_NOT_VALID",
  UnableToPlaceOrder = "UNABLE_TO_PLACE_ORDER",
  Undefined = "UNDEFINED",
}

/** Specifies the quote to be converted to an order. */
export type IPlaceOrderInput = {
  /** Order Attributes */
  additional_attributes: InputMaybe<Array<InputMaybe<IOrderAttributeInput>>>;
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars["String"]["input"];
};

/** Contains the results of the request to place an order. */
export type IPlaceOrderOutput = {
  /** An array of place order errors. */
  errors: Array<Maybe<IPlaceOrderError>>;
  /**
   * The ID of the order.
   * @deprecated Use `orderV2` instead.
   */
  order: Maybe<IOrder>;
  /** Full order information. */
  orderV2: Maybe<ICustomerOrder>;
};

export type IPresentationPrices = {
  /** Catalog price */
  initial_price: Maybe<Scalars["Float"]["output"]>;
  /** Presentation Selection price, if layer is Presentation */
  presentation_price: Maybe<Scalars["Float"]["output"]>;
  /** Contains details about this product option. */
  product: Maybe<IProductInterface>;
};

/** Deprecated. Use `ProductPrice` instead. Defines the price of a product as well as any tax-related adjustments. */
export type IPrice = {
  /**
   * An array that provides information about tax, weee, or weee_tax adjustments.
   * @deprecated Use `ProductPrice` instead.
   */
  adjustments: Maybe<Array<Maybe<IPriceAdjustment>>>;
  /**
   * The price of a product plus a three-letter currency code.
   * @deprecated Use `ProductPrice` instead.
   */
  amount: Maybe<IMoney>;
};

/** Deprecated. Taxes will be included or excluded in the price. Defines the amount of money to apply as an adjustment, the type of adjustment to apply, and whether the item is included or excluded from the adjustment. */
export type IPriceAdjustment = {
  /** The amount of the price adjustment and its currency code. */
  amount: Maybe<IMoney>;
  /**
   * Indicates whether the adjustment involves tax, weee, or weee_tax.
   * @deprecated `PriceAdjustment` is deprecated.
   */
  code: Maybe<IPriceAdjustmentCodesEnum>;
  /**
   * Indicates whether the entity described by the code attribute is included or excluded from the adjustment.
   * @deprecated `PriceAdjustment` is deprecated.
   */
  description: Maybe<IPriceAdjustmentDescriptionEnum>;
};

/** `PriceAdjustment.code` is deprecated. */
export enum IPriceAdjustmentCodesEnum {
  /** @deprecated `PriceAdjustmentCodesEnum` is deprecated. Tax is included or excluded in the price. Tax is not shown separately in Catalog. */
  Tax = "TAX",
  /** @deprecated WEEE code is deprecated. Use `fixed_product_taxes.label` instead. */
  Weee = "WEEE",
  /** @deprecated Use `fixed_product_taxes` instead.  Tax is included or excluded in price. The tax is not shown separtely in Catalog. */
  WeeeTax = "WEEE_TAX",
}

/** `PriceAdjustmentDescriptionEnum` is deprecated. States whether a price adjustment is included or excluded. */
export enum IPriceAdjustmentDescriptionEnum {
  Excluded = "EXCLUDED",
  Included = "INCLUDED",
}

/** Can be used to retrieve the main price details in case of bundle product */
export type IPriceDetails = {
  /** The percentage of discount applied to the main product price */
  discount_percentage: Maybe<Scalars["Float"]["output"]>;
  /** The final price after applying the discount to the main product */
  main_final_price: Maybe<Scalars["Float"]["output"]>;
  /** The regular price of the main product */
  main_price: Maybe<Scalars["Float"]["output"]>;
};

/** Contains the price range for a product. If the product has a single price, the minimum and maximum price will be the same. */
export type IPriceRange = {
  /** The highest possible price for the product. */
  maximum_price: Maybe<IProductPrice>;
  /** The lowest possible price for the product. */
  minimum_price: IProductPrice;
};

/** Defines the price type. */
export enum IPriceTypeEnum {
  Dynamic = "DYNAMIC",
  Fixed = "FIXED",
  Percent = "PERCENT",
  Presentation = "PRESENTATION",
}

/** Defines whether a bundle product's price is displayed as the lowest possible value or as a range. */
export enum IPriceViewEnum {
  AsLowAs = "AS_LOW_AS",
  PriceRange = "PRICE_RANGE",
}

export type IProduct = {
  color_label: Maybe<Scalars["String"]["output"]>;
  flavor_label: Maybe<Scalars["String"]["output"]>;
};

/** Contains a product attribute code and value. */
export type IProductAttribute = {
  /** The unique identifier for a product attribute code. */
  code: Scalars["String"]["output"];
  /** The display value of the attribute. */
  value: Scalars["String"]["output"];
};

/** Defines the filters to be used in the search. A filter contains at least one attribute, a comparison operator, and the value that is being searched for. */
export type IProductAttributeFilterInput = {
  /** Attribute label: available_date */
  available_date: InputMaybe<IFilterRangeTypeInput>;
  /** Attribute label: Available for Mobile App */
  available_for_mobile_app: InputMaybe<IFilterEqualTypeInput>;
  /** Deprecated: use `category_uid` to filter product by category ID. */
  category_id: InputMaybe<IFilterEqualTypeInput>;
  /** Filter product by the unique ID for a `CategoryInterface` object. */
  category_uid: InputMaybe<IFilterEqualTypeInput>;
  /** Filter product by category URL path. */
  category_url_path: InputMaybe<IFilterEqualTypeInput>;
  /** Attribute label: Color */
  color: InputMaybe<IFilterEqualTypeInput>;
  /** Attribute label: Description */
  description: InputMaybe<IFilterMatchTypeInput>;
  /** Attribute label: Experience */
  experience: InputMaybe<IFilterEqualTypeInput>;
  /** Attribute label: Flavor */
  flavor: InputMaybe<IFilterEqualTypeInput>;
  /** Attribute label: Flavor Families */
  flavor_family: InputMaybe<IFilterEqualTypeInput>;
  /** Attribute label: Flavour */
  flavour: InputMaybe<IFilterEqualTypeInput>;
  /** Attribute label: Formula */
  formula: InputMaybe<IFilterEqualTypeInput>;
  /** Attribute label: Importer */
  importer: InputMaybe<IFilterMatchTypeInput>;
  /** Attribute label: Main Specifications */
  main_specifications: InputMaybe<IFilterMatchTypeInput>;
  /** Attribute label: Manufacturer */
  manufacturer: InputMaybe<IFilterEqualTypeInput>;
  /** Attribute label: Product Name */
  name: InputMaybe<IFilterMatchTypeInput>;
  /** Attribute label: Name & Model */
  name_and_model: InputMaybe<IFilterMatchTypeInput>;
  /** Attribute label: Portable Stick Tray */
  portable_stick_tray: InputMaybe<IFilterMatchTypeInput>;
  /** Attribute label: Pouch Size */
  pouch_size: InputMaybe<IFilterEqualTypeInput>;
  /** Attribute label: Price */
  price: InputMaybe<IFilterRangeTypeInput>;
  /** Attribute label: Province */
  province: InputMaybe<IFilterEqualTypeInput>;
  /** Attribute label: Region */
  region: InputMaybe<IFilterEqualTypeInput>;
  /** Attribute label: Short Description */
  short_description: InputMaybe<IFilterMatchTypeInput>;
  /** Attribute label: SKU */
  sku: InputMaybe<IFilterEqualTypeInput>;
  /** Attribute label: Strength */
  strength: InputMaybe<IFilterEqualTypeInput>;
  /** The part of the URL that identifies the product */
  url_key: InputMaybe<IFilterEqualTypeInput>;
};

/** Specifies the attribute to use for sorting search results and indicates whether the results are sorted in ascending or descending order. It's possible to sort products using searchable attributes with enabled 'Use in Filter Options' option */
export type IProductAttributeSortInput = {
  /** Attribute label: Color */
  color: InputMaybe<ISortEnum>;
  /** Attribute label: Product Name */
  name: InputMaybe<ISortEnum>;
  /** Sort by the position assigned to each product. */
  position: InputMaybe<ISortEnum>;
  /** Attribute label: Price */
  price: InputMaybe<ISortEnum>;
  /** Sort by the search relevance score (default). */
  relevance: InputMaybe<ISortEnum>;
};

/** Product custom attributes */
export type IProductCustomAttributes = {
  /** Errors when retrieving custom attributes metadata. */
  errors: Array<Maybe<IAttributeMetadataError>>;
  /** Requested custom attributes */
  items: Array<Maybe<IAttributeValueInterface>>;
};

/** Contains the discount applied to a product price. */
export type IProductDiscount = {
  /** The actual value of the discount. */
  amount_off: Maybe<Scalars["Float"]["output"]>;
  /** The discount expressed a percentage. */
  percent_off: Maybe<Scalars["Float"]["output"]>;
};

/** ProductFilterInput is deprecated, use @ProductAttributeFilterInput instead. ProductFilterInput defines the filters to be used in the search. A filter contains at least one attribute, a comparison operator, and the value that is being searched for. */
export type IProductFilterInput = {
  /** The category ID the product belongs to. */
  category_id: InputMaybe<IFilterTypeInput>;
  /** The product's country of origin. */
  country_of_manufacture: InputMaybe<IFilterTypeInput>;
  /** The timestamp indicating when the product was created. */
  created_at: InputMaybe<IFilterTypeInput>;
  /** The name of a custom layout. */
  custom_layout: InputMaybe<IFilterTypeInput>;
  /** XML code that is applied as a layout update to the product page. */
  custom_layout_update: InputMaybe<IFilterTypeInput>;
  /** Detailed information about the product. The value can include simple HTML tags. */
  description: InputMaybe<IFilterTypeInput>;
  /** Indicates whether a gift message is available. */
  gift_message_available: InputMaybe<IFilterTypeInput>;
  /** Indicates whether additional attributes have been created for the product. */
  has_options: InputMaybe<IFilterTypeInput>;
  /** The relative path to the main image on the product page. */
  image: InputMaybe<IFilterTypeInput>;
  /** The label assigned to a product image. */
  image_label: InputMaybe<IFilterTypeInput>;
  /** Indicates whether the product can be returned. */
  is_returnable: InputMaybe<IFilterTypeInput>;
  /** A number representing the product's manufacturer. */
  manufacturer: InputMaybe<IFilterTypeInput>;
  /** The numeric maximal price of the product. Do not include the currency code. */
  max_price: InputMaybe<IFilterTypeInput>;
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description: InputMaybe<IFilterTypeInput>;
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword: InputMaybe<IFilterTypeInput>;
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title: InputMaybe<IFilterTypeInput>;
  /** The numeric minimal price of the product. Do not include the currency code. */
  min_price: InputMaybe<IFilterTypeInput>;
  /** The product name. Customers use this name to identify the product. */
  name: InputMaybe<IFilterTypeInput>;
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  news_from_date: InputMaybe<IFilterTypeInput>;
  /** The end date for new product listings. */
  news_to_date: InputMaybe<IFilterTypeInput>;
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container: InputMaybe<IFilterTypeInput>;
  /** The keyword required to perform a logical OR comparison. */
  or: InputMaybe<IProductFilterInput>;
  /** The price of an item. */
  price: InputMaybe<IFilterTypeInput>;
  /** Indicates whether the product has required options. */
  required_options: InputMaybe<IFilterTypeInput>;
  /** A short description of the product. Its use depends on the theme. */
  short_description: InputMaybe<IFilterTypeInput>;
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku: InputMaybe<IFilterTypeInput>;
  /** The relative path to the small image, which is used on catalog pages. */
  small_image: InputMaybe<IFilterTypeInput>;
  /** The label assigned to a product's small image. */
  small_image_label: InputMaybe<IFilterTypeInput>;
  /** The beginning date that a product has a special price. */
  special_from_date: InputMaybe<IFilterTypeInput>;
  /** The discounted price of the product. Do not include the currency code. */
  special_price: InputMaybe<IFilterTypeInput>;
  /** The end date that a product has a special price. */
  special_to_date: InputMaybe<IFilterTypeInput>;
  /** The file name of a swatch image. */
  swatch_image: InputMaybe<IFilterTypeInput>;
  /** The relative path to the product's thumbnail image. */
  thumbnail: InputMaybe<IFilterTypeInput>;
  /** The label assigned to a product's thumbnail image. */
  thumbnail_label: InputMaybe<IFilterTypeInput>;
  /** The price when tier pricing is in effect and the items purchased threshold has been reached. */
  tier_price: InputMaybe<IFilterTypeInput>;
  /** The timestamp indicating when the product was updated. */
  updated_at: InputMaybe<IFilterTypeInput>;
  /** The part of the URL that identifies the product */
  url_key: InputMaybe<IFilterTypeInput>;
  url_path: InputMaybe<IFilterTypeInput>;
  /** The weight of the item, in units defined by the store. */
  weight: InputMaybe<IFilterTypeInput>;
};

/** Contains product image information, including the image URL and label. */
export type IProductImage = IMediaGalleryInterface & {
  /** Indicates whether the image is hidden from view. */
  disabled: Maybe<Scalars["Boolean"]["output"]>;
  /** Alt text of the image */
  image_alt: Maybe<Scalars["String"]["output"]>;
  /** The label of the product image or video. */
  label: Maybe<Scalars["String"]["output"]>;
  /** The media item's position after it has been sorted. */
  position: Maybe<Scalars["Int"]["output"]>;
  /** Role of the image */
  role: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  /** Array of image types. It can have the following values: image, small_image, thumbnail. */
  types: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  /** The URL of the product image or video. */
  url: Maybe<Scalars["String"]["output"]>;
};

/** Contains product image information, including the image URL and label. */
export type IProductImageUrlArgs = {
  dpr: InputMaybe<Scalars["Int"]["input"]>;
  fit: InputMaybe<Scalars["String"]["input"]>;
  height: InputMaybe<Scalars["Int"]["input"]>;
  quality: InputMaybe<Scalars["Int"]["input"]>;
  size: InputMaybe<Scalars["String"]["input"]>;
  width: InputMaybe<Scalars["Int"]["input"]>;
};

export enum IProductImageThumbnail {
  /** Use thumbnail of product as image. */
  Itself = "ITSELF",
  /** Use thumbnail of product's parent as image. */
  Parent = "PARENT",
}

/** Contains fields that are common to all types of products. */
export type IProductInterface = {
  /** @deprecated Use the `custom_attributes` field instead. */
  about_manufacturer: Maybe<Scalars["String"]["output"]>;
  /**
   * The attribute set assigned to the product.
   * @deprecated The field should not be used on the storefront.
   */
  attribute_set_id: Maybe<Scalars["Int"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  available_date: Maybe<Scalars["String"]["output"]>;
  /**
   * Whether the product is explicitly available for Mobile App commerce exposure. 1 = eligible, 0 or null = not eligible.
   * @deprecated Use the `custom_attributes` field instead.
   */
  available_for_mobile_app: Maybe<Scalars["Int"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  battery: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  buy_cta_pdp: Maybe<Scalars["Int"]["output"]>;
  /** CTA for PDP attribute translated label . */
  buy_cta_pdp_label: Scalars["String"]["output"];
  /** @deprecated Use the `custom_attributes` field instead. */
  buy_cta_plp: Maybe<Scalars["Int"]["output"]>;
  /** CTA for PLP attribute translated label . */
  buy_cta_plp_label: Scalars["String"]["output"];
  /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
  canonical_url: Maybe<Scalars["String"]["output"]>;
  /** The categories assigned to a product. */
  categories: Maybe<Array<Maybe<ICategoryInterface>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  charging_time: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  color: Maybe<Scalars["Int"]["output"]>;
  /** Color attribute label. */
  color_label: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  connectors: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  connectors_1: Maybe<Scalars["String"]["output"]>;
  /** The product's country of origin. */
  country_of_manufacture: Maybe<Scalars["String"]["output"]>;
  /**
   * Timestamp indicating when the product was created.
   * @deprecated The field should not be used on the storefront.
   */
  created_at: Maybe<Scalars["String"]["output"]>;
  /** An array of cross-sell products. */
  crosssell_products: Maybe<Array<Maybe<IProductInterface>>>;
  /** Product custom attributes. */
  custom_attributesV2: Maybe<IProductCustomAttributes>;
  /** Delivery region this product may be shipped to — `ES` or `IC`, the same vocabulary as the region header and getDeliveryRegions.code. Distinct from `region_code` on address types, which carries a province code. Null when the product carries no region, or its attribute value is not mapped to one; either way the product is undeliverable everywhere. */
  delivery_region_code: Maybe<Scalars["String"]["output"]>;
  /** Detailed information about the product. The value can include simple HTML tags. */
  description: Maybe<IComplexTextValue>;
  /** @deprecated Use the `custom_attributes` field instead. */
  device_dimensions: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  dimensions: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  enable_lifetime_quantity_limit: Maybe<Scalars["Int"]["output"]>;
  /**
   * Is quantity limit enabled for this product
   * @deprecated Use the `custom_attributes` field instead.
   */
  enable_order_quantity_limit: Maybe<Scalars["Int"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  experience: Maybe<Scalars["Int"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  flavor: Maybe<Scalars["Int"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  flavor_family: Maybe<Scalars["String"]["output"]>;
  /** Color attribute label. */
  flavor_label: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  flavour: Maybe<Scalars["Int"]["output"]>;
  /** Get all details for flavour */
  flavour_details: Array<Maybe<IFlavourDetails>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  formula: Maybe<Scalars["Int"]["output"]>;
  /** A list of gift options for the given product */
  free_gifts: Maybe<IFreeGiftProductData>;
  /** Returns all attribute values and labels marked as visible on storefront */
  frontend_attributes: Maybe<Array<Maybe<IFrontendAttribute>>>;
  /** Returns a value indicating gift message availability for the product. */
  gift_message_available: Scalars["Boolean"]["output"];
  /** Returns a value indicating gift wrapping availability for the product. */
  gift_wrapping_available: Scalars["Boolean"]["output"];
  /** Returns value and currency indicating gift wrapping price for the product. */
  gift_wrapping_price: Maybe<IMoney>;
  /** @deprecated Use the `custom_attributes` field instead. */
  has_device: Maybe<Scalars["Int"]["output"]>;
  /** Provides the flag to show if consent is required or not */
  has_registration_consent: Maybe<Scalars["Boolean"]["output"]>;
  /** Product is hidden_sku or not */
  hidden_sku: Maybe<Scalars["Boolean"]["output"]>;
  /**
   * The ID number assigned to the product.
   * @deprecated Use the `uid` field instead.
   */
  id: Maybe<Scalars["Int"]["output"]>;
  /** The relative path to the main image on the product page. */
  image: Maybe<IProductImage>;
  /** @deprecated Use the `custom_attributes` field instead. */
  importer: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  input_terminal: Maybe<Scalars["Int"]["output"]>;
  /** Product discontinued flag */
  is_discontinued: Maybe<Scalars["Boolean"]["output"]>;
  /** Indicates whether the product can be returned. */
  is_returnable: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  jti_brand_matrix: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  jti_category_redirect: Maybe<Scalars["Int"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  jti_product_discontinued: Maybe<Scalars["Int"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  jti_sku_redirect: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  large_stick_tray: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  lifetime_quantity_limit: Maybe<Scalars["Int"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  main_specifications: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  mandatory_positive_consent: Maybe<Scalars["Int"]["output"]>;
  /**
   * A number representing the product's manufacturer.
   * @deprecated Use the `custom_attributes` field instead.
   */
  manufacturer: Maybe<Scalars["Int"]["output"]>;
  /** Product subscription format */
  manufacturer_label: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  material: Maybe<Scalars["String"]["output"]>;
  /** Maximum Qty Allowed in Shopping Cart */
  max_sale_qty: Maybe<Scalars["Float"]["output"]>;
  /** An array of media gallery objects. */
  media_gallery: Maybe<Array<Maybe<IMediaGalleryInterface>>>;
  /**
   * An array of MediaGalleryEntry objects.
   * @deprecated Use `media_gallery` instead.
   */
  media_gallery_entries: Maybe<Array<Maybe<IMediaGalleryEntry>>>;
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description: Maybe<Scalars["String"]["output"]>;
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword: Maybe<Scalars["String"]["output"]>;
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title: Maybe<Scalars["String"]["output"]>;
  /** Minimum Qty Allowed in Shopping Cart */
  min_sale_qty: Maybe<Scalars["Float"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  minimum_amount: Maybe<Scalars["Float"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  minimum_amount_type: Maybe<Scalars["String"]["output"]>;
  /**
   * Multipack description for this product
   * @deprecated Use the `custom_attributes` field instead.
   */
  multipack_description: Maybe<Scalars["String"]["output"]>;
  /** Is multipacks selected enabled for this product */
  multipack_enabled: Maybe<Scalars["Boolean"]["output"]>;
  /**
   * Multipack label for this product
   * @deprecated Use the `custom_attributes` field instead.
   */
  multipack_label: Maybe<Scalars["String"]["output"]>;
  /** Multipack price text for this product */
  multipack_price: Maybe<Scalars["String"]["output"]>;
  /** Multipack Products */
  multipack_products: Maybe<Array<Maybe<IProductInterface>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  multipacks_enabled: Maybe<Scalars["Int"]["output"]>;
  /** The product name. Customers use this name to identify the product. */
  name: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  name_and_model: Maybe<Scalars["String"]["output"]>;
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  new_from_date: Maybe<Scalars["String"]["output"]>;
  /** The end date for new product listings. */
  new_to_date: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  non_trade_in_sku: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  number_of_packs: Maybe<Scalars["Int"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  number_of_sticks: Maybe<Scalars["Int"]["output"]>;
  /** Product stock only x left count */
  only_x_left_in_stock: Maybe<Scalars["Float"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  option_grouped_by_brand: Maybe<Scalars["Int"]["output"]>;
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container: Maybe<Scalars["String"]["output"]>;
  /**
   * Maximum quantity allowed per one order
   * @deprecated Use the `custom_attributes` field instead.
   */
  order_quantity_limit: Maybe<Scalars["Int"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  portable_stick_tray: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  pouch_size: Maybe<Scalars["Int"]["output"]>;
  /**
   * Indicates the price of an item.
   * @deprecated Use `price_range` for product price information.
   */
  price: Maybe<IProductPrices>;
  /** The range of prices for the product */
  price_range: IPriceRange;
  /** An array of `TierPrice` objects. */
  price_tiers: Maybe<Array<Maybe<ITierPrice>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  product_brand: Maybe<Scalars["String"]["output"]>;
  /** Product Brand Label */
  product_brand_label: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  product_category: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  product_category_type: Maybe<Scalars["Int"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  product_color: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  product_disclaimer: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  product_family: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  product_generation: Maybe<Scalars["String"]["output"]>;
  /** An array of `ProductLinks` objects. */
  product_links: Maybe<Array<Maybe<IProductLinksInterface>>>;
  /** Get all special offers for a product. */
  promotionalOffers: Array<Maybe<ISpecialOffer>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  province: Maybe<Scalars["String"]["output"]>;
  /** Product provence label for PLP attribute. */
  province_label: Maybe<Scalars["String"]["output"]>;
  /** Amount of available stock */
  quantity: Maybe<Scalars["Float"]["output"]>;
  /** The average of all the ratings given to the product. */
  rating_summary: Scalars["Float"]["output"];
  /** Redirect category URL path for discontinued product */
  redirect_product_category: Maybe<Scalars["String"]["output"]>;
  /** Redirect product SKU for discontinued product */
  redirect_sku: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  region: Maybe<Scalars["Int"]["output"]>;
  /** Product Region attribute translated label. */
  region_label: Maybe<Scalars["String"]["output"]>;
  /** An array of related products. */
  related_products: Maybe<Array<Maybe<IProductInterface>>>;
  /** The total count of all the reviews given to the product. */
  review_count: Scalars["Int"]["output"];
  /** @deprecated Use the `custom_attributes` field instead. */
  review_eligible: Maybe<Scalars["Int"]["output"]>;
  /** The list of products reviews. */
  reviews: IProductReviews;
  /** A short description of the product. Its use depends on the theme. */
  short_description: Maybe<IComplexTextValue>;
  /** @deprecated Use the `custom_attributes` field instead. */
  size: Maybe<Scalars["String"]["output"]>;
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku: Maybe<Scalars["String"]["output"]>;
  /** The relative path to the small image, which is used on catalog pages. */
  small_image: Maybe<IProductImage>;
  /** Get all special offers for a product. */
  specialOffers: Array<Maybe<ISpecialOffer>>;
  /**
   * The beginning date that a product has a special price.
   * @deprecated The field should not be used on the storefront.
   */
  special_from_date: Maybe<Scalars["String"]["output"]>;
  /** The discounted price of the product. */
  special_price: Maybe<Scalars["Float"]["output"]>;
  /** The end date for a product with a special price. */
  special_to_date: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether the product is staged for a future campaign. */
  staged: Scalars["Boolean"]["output"];
  /** @deprecated Use the `custom_attributes` field instead. */
  stick_capability: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  stick_compatibility: Maybe<Scalars["String"]["output"]>;
  /** Stock status of the product */
  stock_status: Maybe<IProductStockStatus>;
  /** @deprecated Use the `custom_attributes` field instead. */
  strength: Maybe<Scalars["Int"]["output"]>;
  /** Get all details for strength */
  strength_details: Maybe<IStrengthDetails>;
  /** @deprecated Use the `custom_attributes` field instead. */
  subscription: Maybe<Scalars["Int"]["output"]>;
  /**
   * Product subscription format
   * @deprecated Use the `custom_attributes` field instead.
   */
  subscription_format: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  subtitle: Maybe<Scalars["String"]["output"]>;
  /** The file name of a swatch image. */
  swatch_image: Maybe<Scalars["String"]["output"]>;
  /** The relative path to the product's thumbnail image. */
  thumbnail: Maybe<IProductImage>;
  /**
   * The price when tier pricing is in effect and the items purchased threshold has been reached.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_price: Maybe<Scalars["Float"]["output"]>;
  /**
   * An array of ProductTierPrices objects.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_prices: Maybe<Array<Maybe<IProductTierPrices>>>;
  /**
   * Product tooltip information
   * @deprecated Use the `custom_attributes` field instead.
   */
  tooltip_info: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  trabka: Maybe<Scalars["String"]["output"]>;
  /**
   * Indicates whether the product is eligible for a trade-in purchase.
   * @deprecated Use the `custom_attributes` field instead.
   */
  trade_in: Scalars["Int"]["output"];
  /**
   * Specific to trial stores, provides information about the finalization sku
   * @deprecated Use the `custom_attributes` field instead.
   */
  trial_finalization_sku: Maybe<Scalars["String"]["output"]>;
  /**
   * One of simple, virtual, bundle, downloadable, grouped, or configurable.
   * @deprecated Use `__typename` instead.
   */
  type_id: Maybe<Scalars["String"]["output"]>;
  /** Product Type */
  type_label: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `ProductInterface` object. */
  uid: Scalars["ID"]["output"];
  /**
   * Timestamp indicating when the product was updated.
   * @deprecated The field should not be used on the storefront.
   */
  updated_at: Maybe<Scalars["String"]["output"]>;
  /** An array of up-sell products. */
  upsell_products: Maybe<Array<Maybe<IProductInterface>>>;
  /** The part of the URL that identifies the product */
  url_key: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use product's `canonical_url` or url rewrites instead */
  url_path: Maybe<Scalars["String"]["output"]>;
  /** URL rewrites list */
  url_rewrites: Maybe<Array<Maybe<IUrlRewrite>>>;
  /** The part of the product URL that is appended after the url key */
  url_suffix: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use the `custom_attributes` field instead. */
  voltage: Maybe<Scalars["String"]["output"]>;
  /**
   * An array of websites in which the product is available.
   * @deprecated The field should not be used on the storefront.
   */
  websites: Maybe<Array<Maybe<IWebsite>>>;
};

/** Contains fields that are common to all types of products. */
export type IProductInterfaceCustom_AttributesV2Args = {
  filters: InputMaybe<IAttributeFilterInput>;
};

/** Contains fields that are common to all types of products. */
export type IProductInterfaceReviewsArgs = {
  currentPage?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

/** An implementation of `ProductLinksInterface`. */
export type IProductLinks = IProductLinksInterface & {
  /** One of related, associated, upsell, or crosssell. */
  link_type: Maybe<Scalars["String"]["output"]>;
  /** The SKU of the linked product. */
  linked_product_sku: Maybe<Scalars["String"]["output"]>;
  /** The type of linked product (simple, virtual, bundle, downloadable, grouped, configurable). */
  linked_product_type: Maybe<Scalars["String"]["output"]>;
  /** The position within the list of product links. */
  position: Maybe<Scalars["Int"]["output"]>;
  /** The identifier of the linked product. */
  sku: Maybe<Scalars["String"]["output"]>;
};

/** Contains information about linked products, including the link type and product type of each item. */
export type IProductLinksInterface = {
  /** One of related, associated, upsell, or crosssell. */
  link_type: Maybe<Scalars["String"]["output"]>;
  /** The SKU of the linked product. */
  linked_product_sku: Maybe<Scalars["String"]["output"]>;
  /** The type of linked product (simple, virtual, bundle, downloadable, grouped, configurable). */
  linked_product_type: Maybe<Scalars["String"]["output"]>;
  /** The position within the list of product links. */
  position: Maybe<Scalars["Int"]["output"]>;
  /** The identifier of the linked product. */
  sku: Maybe<Scalars["String"]["output"]>;
};

/** Contains an image in base64 format and basic information about the image. */
export type IProductMediaGalleryEntriesContent = {
  /** The image in base64 format. */
  base64_encoded_data: Maybe<Scalars["String"]["output"]>;
  /** The file name of the image. */
  name: Maybe<Scalars["String"]["output"]>;
  /** The MIME type of the file, such as image/png. */
  type: Maybe<Scalars["String"]["output"]>;
};

/** Contains a link to a video file and basic information about the video. */
export type IProductMediaGalleryEntriesVideoContent = {
  /** Must be external-video. */
  media_type: Maybe<Scalars["String"]["output"]>;
  /** A description of the video. */
  video_description: Maybe<Scalars["String"]["output"]>;
  /** Optional data about the video. */
  video_metadata: Maybe<Scalars["String"]["output"]>;
  /** Describes the video source. */
  video_provider: Maybe<Scalars["String"]["output"]>;
  /** The title of the video. */
  video_title: Maybe<Scalars["String"]["output"]>;
  /** The URL to the video. */
  video_url: Maybe<Scalars["String"]["output"]>;
};

/** Represents a product price. */
export type IProductPrice = {
  /** The price discount. Represents the difference between the regular and final price. */
  discount: Maybe<IProductDiscount>;
  /** The final price of the product after applying discounts. */
  final_price: IMoney;
  /** The final prices of the product after applying discounts with multipliers from 1 to 5. */
  final_prices: Maybe<Array<Maybe<IMoneyMultiplier>>>;
  /** An array of the multiple Fixed Product Taxes that can be applied to a product price. */
  fixed_product_taxes: Maybe<Array<Maybe<IFixedProductTax>>>;
  /** The regular price of the product. */
  regular_price: IMoney;
  /** The regular prices of the product with multipliers from 1 to 5. */
  regular_prices: Maybe<Array<Maybe<IMoneyMultiplier>>>;
};

/** Deprecated. Use `PriceRange` instead. Contains the regular price of an item, as well as its minimum and maximum prices. Only composite products, which include bundle, configurable, and grouped products, can contain a minimum and maximum price. */
export type IProductPrices = {
  /**
   * The highest possible final price for all the options defined within a composite product. If you are specifying a price range, this would be the `to` value.
   * @deprecated Use `PriceRange.maximum_price` instead.
   */
  maximalPrice: Maybe<IPrice>;
  /**
   * The lowest possible final price for all the options defined within a composite product. If you are specifying a price range, this would be the `from` value.
   * @deprecated Use `PriceRange.minimum_price` instead.
   */
  minimalPrice: Maybe<IPrice>;
  /**
   * The base price of a product.
   * @deprecated Use `regular_price` from `PriceRange.minimum_price` or `PriceRange.maximum_price` instead.
   */
  regularPrice: Maybe<IPrice>;
};

/** Contains details of a product review. */
export type IProductReview = {
  /** The average of all ratings for this product. */
  average_rating: Scalars["Float"]["output"];
  /** The date the review was created. */
  created_at: Scalars["String"]["output"];
  /** The customer's nickname. Defaults to the customer name, if logged in. */
  nickname: Scalars["String"]["output"];
  /** The reviewed product. */
  product: IProductInterface;
  /** An array of ratings by rating category, such as quality, price, and value. */
  ratings_breakdown: Array<Maybe<IProductReviewRating>>;
  /** The summary (title) of the review. */
  summary: Scalars["String"]["output"];
  /** The review text. */
  text: Scalars["String"]["output"];
};

/** Contains data about a single aspect of a product review. */
export type IProductReviewRating = {
  /** The label assigned to an aspect of a product that is being rated, such as quality or price. */
  name: Scalars["String"]["output"];
  /** The rating value given by customer. By default, possible values range from 1 to 5. */
  value: Scalars["String"]["output"];
};

/** Contains the reviewer's rating for a single aspect of a review. */
export type IProductReviewRatingInput = {
  /** An encoded rating ID. */
  id: Scalars["String"]["input"];
  /** An encoded rating value ID. */
  value_id: Scalars["String"]["input"];
};

/** Contains details about a single aspect of a product review. */
export type IProductReviewRatingMetadata = {
  /** An encoded rating ID. */
  id: Scalars["String"]["output"];
  /** The label assigned to an aspect of a product that is being rated, such as quality or price. */
  name: Scalars["String"]["output"];
  /** List of product review ratings sorted by position. */
  values: Array<Maybe<IProductReviewRatingValueMetadata>>;
};

/** Contains details about a single value in a product review. */
export type IProductReviewRatingValueMetadata = {
  /** A ratings scale, such as the number of stars awarded. */
  value: Scalars["String"]["output"];
  /** An encoded rating value ID. */
  value_id: Scalars["String"]["output"];
};

/** Contains an array of metadata about each aspect of a product review. */
export type IProductReviewRatingsMetadata = {
  /** An array of product reviews sorted by position. */
  items: Array<Maybe<IProductReviewRatingMetadata>>;
};

/** Contains an array of product reviews. */
export type IProductReviews = {
  /** An array of product reviews. */
  items: Array<Maybe<IProductReview>>;
  /** Metadata for pagination rendering. */
  page_info: ISearchResultPageInfo;
};

export type IProductSkuFilterInput = {
  /** Product SKU */
  sku: InputMaybe<IFilterTypeInput>;
};

/** Deprecated. Use `ProductAttributeSortInput` instead. Specifies the attribute to use for sorting search results and indicates whether the results are sorted in ascending or descending order. */
export type IProductSortInput = {
  /** The product's country of origin. */
  country_of_manufacture: InputMaybe<ISortEnum>;
  /** The timestamp indicating when the product was created. */
  created_at: InputMaybe<ISortEnum>;
  /** The name of a custom layout. */
  custom_layout: InputMaybe<ISortEnum>;
  /** XML code that is applied as a layout update to the product page. */
  custom_layout_update: InputMaybe<ISortEnum>;
  /** Detailed information about the product. The value can include simple HTML tags. */
  description: InputMaybe<ISortEnum>;
  /** Indicates whether a gift message is available. */
  gift_message_available: InputMaybe<ISortEnum>;
  /** Indicates whether additional attributes have been created for the product. */
  has_options: InputMaybe<ISortEnum>;
  /** The relative path to the main image on the product page. */
  image: InputMaybe<ISortEnum>;
  /** The label assigned to a product image. */
  image_label: InputMaybe<ISortEnum>;
  /** Indicates whether the product can be returned. */
  is_returnable: InputMaybe<ISortEnum>;
  /** A number representing the product's manufacturer. */
  manufacturer: InputMaybe<ISortEnum>;
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description: InputMaybe<ISortEnum>;
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword: InputMaybe<ISortEnum>;
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title: InputMaybe<ISortEnum>;
  /** The product name. Customers use this name to identify the product. */
  name: InputMaybe<ISortEnum>;
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  news_from_date: InputMaybe<ISortEnum>;
  /** The end date for new product listings. */
  news_to_date: InputMaybe<ISortEnum>;
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container: InputMaybe<ISortEnum>;
  /** The price of the item. */
  price: InputMaybe<ISortEnum>;
  /** Indicates whether the product has required options. */
  required_options: InputMaybe<ISortEnum>;
  /** A short description of the product. Its use depends on the theme. */
  short_description: InputMaybe<ISortEnum>;
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku: InputMaybe<ISortEnum>;
  /** The relative path to the small image, which is used on catalog pages. */
  small_image: InputMaybe<ISortEnum>;
  /** The label assigned to a product's small image. */
  small_image_label: InputMaybe<ISortEnum>;
  /** The beginning date that a product has a special price. */
  special_from_date: InputMaybe<ISortEnum>;
  /** The discounted price of the product. */
  special_price: InputMaybe<ISortEnum>;
  /** The end date that a product has a special price. */
  special_to_date: InputMaybe<ISortEnum>;
  /** Indicates the criteria to sort swatches. */
  swatch_image: InputMaybe<ISortEnum>;
  /** The relative path to the product's thumbnail image. */
  thumbnail: InputMaybe<ISortEnum>;
  /** The label assigned to a product's thumbnail image. */
  thumbnail_label: InputMaybe<ISortEnum>;
  /** The price when tier pricing is in effect and the items purchased threshold has been reached. */
  tier_price: InputMaybe<ISortEnum>;
  /** The timestamp indicating when the product was updated. */
  updated_at: InputMaybe<ISortEnum>;
  /** The part of the URL that identifies the product */
  url_key: InputMaybe<ISortEnum>;
  url_path: InputMaybe<ISortEnum>;
  /** The weight of the item, in units defined by the store. */
  weight: InputMaybe<ISortEnum>;
};

/** This enumeration states whether a product stock status is in stock or out of stock */
export enum IProductStockStatus {
  /** Product is not available for online purchase but can be found in physical stores. */
  AvailableInStores = "AVAILABLE_IN_STORES",
  InStock = "IN_STOCK",
  OutOfStock = "OUT_OF_STOCK",
}

/** Deprecated. Use `TierPrice` instead. Defines a tier price, which is a quantity discount offered to a specific customer group. */
export type IProductTierPrices = {
  /**
   * The ID of the customer group.
   * @deprecated Not relevant for the storefront.
   */
  customer_group_id: Maybe<Scalars["String"]["output"]>;
  /**
   * The percentage discount of the item.
   * @deprecated Use `TierPrice.discount` instead.
   */
  percentage_value: Maybe<Scalars["Float"]["output"]>;
  /**
   * The number of items that must be purchased to qualify for tier pricing.
   * @deprecated Use `TierPrice.quantity` instead.
   */
  qty: Maybe<Scalars["Float"]["output"]>;
  /**
   * The price of the fixed price item.
   * @deprecated Use `TierPrice.final_price` instead.
   */
  value: Maybe<Scalars["Float"]["output"]>;
  /**
   * The ID assigned to the website.
   * @deprecated Not relevant for the storefront.
   */
  website_id: Maybe<Scalars["Float"]["output"]>;
};

/** Contains information about a product video. */
export type IProductVideo = IMediaGalleryInterface & {
  /** Indicates whether the image is hidden from view. */
  disabled: Maybe<Scalars["Boolean"]["output"]>;
  /** The label of the product image or video. */
  label: Maybe<Scalars["String"]["output"]>;
  /** The media item's position after it has been sorted. */
  position: Maybe<Scalars["Int"]["output"]>;
  /** Role of the image */
  role: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  /** Array of image types. It can have the following values: image, small_image, thumbnail. */
  types: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  /** The URL of the product image or video. */
  url: Maybe<Scalars["String"]["output"]>;
  /** Contains a `ProductMediaGalleryEntriesVideoContent` object. */
  video_content: Maybe<IProductMediaGalleryEntriesVideoContent>;
};

/** Contains information about a product video. */
export type IProductVideoUrlArgs = {
  dpr: InputMaybe<Scalars["Int"]["input"]>;
  fit: InputMaybe<Scalars["String"]["input"]>;
  height: InputMaybe<Scalars["Int"]["input"]>;
  quality: InputMaybe<Scalars["Int"]["input"]>;
  size: InputMaybe<Scalars["String"]["input"]>;
  width: InputMaybe<Scalars["Int"]["input"]>;
};

/** Contains the results of a `products` query. */
export type IProducts = {
  /** A bucket that contains the attribute code and label for each filterable option. */
  aggregations: Maybe<Array<Maybe<IAggregation>>>;
  /**
   * Layered navigation filters array.
   * @deprecated Use `aggregations` instead.
   */
  filters: Maybe<Array<Maybe<ILayerFilter>>>;
  /** An array of products that match the specified search criteria. */
  items: Maybe<Array<Maybe<IProductInterface>>>;
  /** An object that includes the page_info and currentPage values specified in the query. */
  page_info: Maybe<ISearchResultPageInfo>;
  /** An object that includes the default sort field and all available sort fields. */
  sort_fields: Maybe<ISortFields>;
  /** An array of search suggestions for case when search query have no results. */
  suggestions: Maybe<Array<Maybe<ISearchSuggestion>>>;
  /** The number of products that are marked as visible. By default, in complex products, parent products are visible, but their child products are not. */
  total_count: Maybe<Scalars["Int"]["output"]>;
};

/** Contains the results of a `products` query. */
export type IProductsAggregationsArgs = {
  filter: InputMaybe<IAggregationsFilterInput>;
};

export type IProductsPrices = {
  items: Maybe<Array<Maybe<IProductsPricesItem>>>;
  total_count: Maybe<Scalars["Int"]["output"]>;
};

export type IProductsPricesItem = {
  price_range: IPriceRange;
  sku: Maybe<Scalars["String"]["output"]>;
  stock_status: Maybe<IProductStockStatus>;
};

export type IQuery = {
  /** Returns data for the customer's most recent order. */
  LastCustomerOrder: Maybe<ICustomerOrder>;
  /** Retrieve EAV attributes associated to a frontend form. Use countries query provided by DirectoryGraphQl module to retrieve region_id and country_id attribute options. */
  attributesForm: IAttributesFormOutput;
  /** Returns a list of attributes metadata for a given entity type. */
  attributesList: Maybe<IAttributesMetadataOutput>;
  /** Get a list of available store views and their config information. */
  availableStores: Maybe<Array<Maybe<IStoreConfig>>>;
  /** Return information about the specified shopping cart with conditional request support. */
  cart: Maybe<ICart>;
  /** Return a list of categories that match the specified filter. */
  categories: Maybe<ICategoryResult>;
  /**
   * Search for categories that match the criteria specified in the `search` and `filter` attributes.
   * @deprecated Use `categories` instead.
   */
  category: Maybe<ICategoryTree>;
  /**
   * Return an array of categories based on the specified filters.
   * @deprecated Use `categories` instead.
   */
  categoryList: Maybe<Array<Maybe<ICategoryTree>>>;
  /** Return Terms and Conditions configuration information. */
  checkoutAgreements: Maybe<Array<Maybe<ICheckoutAgreement>>>;
  /** Return information about CMS blocks. */
  cmsBlocks: Maybe<ICmsBlocks>;
  /** Return details about a CMS page. */
  cmsPage: Maybe<ICmsPage>;
  /** Return products that have been added to the specified compare list. */
  compareList: Maybe<ICompareList>;
  /** The countries query provides information for all countries. */
  countries: Maybe<Array<Maybe<ICountry>>>;
  /** The countries query provides information for a single country. */
  country: Maybe<ICountry>;
  /** Return information about the store's currency. */
  currency: Maybe<ICurrency>;
  /**
   * Return the attribute type, given an attribute code and entity type.
   * @deprecated Use `customAttributeMetadataV2` query instead.
   */
  customAttributeMetadata: Maybe<ICustomAttributeMetadata>;
  /** Retrieve EAV attributes metadata. */
  customAttributeMetadataV2: IAttributesMetadataOutput;
  /** Return detailed information about a customer account. */
  customer: Maybe<ICustomer>;
  /** Return information about the customer's shopping cart. */
  customerCart: ICart;
  /** Return a list of downloadable products the customer has purchased. */
  customerDownloadableProducts: Maybe<ICustomerDownloadableProducts>;
  /** @deprecated Use the `customer` query instead. */
  customerOrders: Maybe<ICustomerOrders>;
  /** Return a list of customer payment tokens stored in the vault. */
  customerPaymentTokens: Maybe<ICustomerPaymentTokens>;
  /** Return a list of dynamic blocks filtered by type, location, or UIDs. */
  dynamicBlocks: IDynamicBlocks;
  getBrandConsumableMatrix: Array<Maybe<IBrandConsumablesMatrix>>;
  getConsumablesMatrix: Maybe<IConsumablesMatrix>;
  /** Delivery regions and the provinces belonging to each. Empty when region validation is not enabled. */
  getDeliveryRegions: Maybe<Array<Maybe<IDeliveryRegion>>>;
  /** Retrieve the secure PayPal URL for a Payments Pro Hosted Solution transaction. */
  getHostedProUrl: Maybe<IHostedProUrl>;
  /** Provides the necessary attributes for the FE */
  getOrderAttributes: Maybe<Array<Maybe<IOrderAttribute>>>;
  /** Query by Get Order Delivery Limits. */
  getOrderDeliveryLimits: Maybe<IGetOrderDeliveryLimits>;
  /** Retrieve payment credentials for a transaction. Use this query for Payflow Link and Payments Advanced payment methods. */
  getPayflowLinkToken: Maybe<IPayflowLinkToken>;
  /** Retrieves the payment configuration for a given location */
  getPaymentConfig: Maybe<IPaymentConfigOutput>;
  /** Retrieves the payment details for the order */
  getPaymentOrder: Maybe<IPaymentOrderOutput>;
  /** Gets the payment SDK urls and values */
  getPaymentSDK: Maybe<IGetPaymentSdkOutput>;
  /** The range of prices for the product */
  getProductPrice: IPriceRange;
  /** Query for SpecialOffersList. */
  getPromotionalOffersList: Maybe<ISpecialOfferList>;
  /** Query for SpecialOffersList. */
  getSpecialOffersList: Maybe<ISpecialOfferList>;
  /** Provides the necessary attributes for the FE */
  getSticksMatrix: Maybe<ISticksMatrix>;
  /** Retrieves the vault configuration */
  getVaultConfig: Maybe<IVaultConfigOutput>;
  /** Query to retrieve the list of order statuses. */
  getorderstatus: Maybe<Array<Maybe<IGetorderstatus>>>;
  /** Return details about a specific gift card. */
  giftCardAccount: Maybe<IGiftCardAccount>;
  /** Return the specified gift registry. Some details will not be available to guests. */
  giftRegistry: Maybe<IGiftRegistry>;
  /** Search for gift registries by specifying a registrant email address. */
  giftRegistryEmailSearch: Maybe<Array<Maybe<IGiftRegistrySearchResult>>>;
  /** Search for gift registries by specifying a registry URL key. */
  giftRegistryIdSearch: Maybe<Array<Maybe<IGiftRegistrySearchResult>>>;
  /** Search for gift registries by specifying the registrant name and registry type ID. */
  giftRegistryTypeSearch: Maybe<Array<Maybe<IGiftRegistrySearchResult>>>;
  /** Get a list of available gift registry types. */
  giftRegistryTypes: Maybe<Array<Maybe<IGiftRegistryType>>>;
  /** Retrieve guest order details based on number, email and billing last name. */
  guestOrder: ICustomerOrder;
  /** Retrieve guest order details based on token. */
  guestOrderByToken: ICustomerOrder;
  /** Check whether the specified email has already been used to create a customer account. */
  isEmailAvailable: Maybe<IIsEmailAvailableOutput>;
  /** Return the active ratings attributes and the values each rating can have. */
  productReviewRatingsMetadata: IProductReviewRatingsMetadata;
  /** Search for products that match the criteria specified in the `search` and `filter` attributes. */
  products: Maybe<IProducts>;
  products_prices: Maybe<IProductsPrices>;
  recaptchaFormConfig: Maybe<IReCaptchaConfigOutput>;
  /** Returns details about Google reCAPTCHA V3-Invisible configuration. */
  recaptchaV3Config: Maybe<IReCaptchaConfigurationV3>;
  /** Return the full details for a specified product, category, or CMS page. */
  route: Maybe<IRoutableInterface>;
  /** Return details about the store's configuration. */
  storeConfig: Maybe<IStoreConfig>;
  /**
   * Return the relative URL for a specified product, category or CMS page.
   * @deprecated Use the `route` query instead.
   */
  urlResolver: Maybe<IEntityUrl>;
  /**
   * Return the contents of a customer's wish list.
   * @deprecated Moved under `Customer.wishlist`.
   */
  wishlist: Maybe<IWishlistOutput>;
};

export type IQueryAttributesFormArgs = {
  formCode: Scalars["String"]["input"];
};

export type IQueryAttributesListArgs = {
  entityType: IAttributeEntityTypeEnum;
  filters: InputMaybe<IAttributeFilterInput>;
};

export type IQueryAvailableStoresArgs = {
  useCurrentGroup: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type IQueryCartArgs = {
  cart_id: Scalars["String"]["input"];
  if_modified_since: InputMaybe<Scalars["String"]["input"]>;
};

export type IQueryCategoriesArgs = {
  currentPage?: InputMaybe<Scalars["Int"]["input"]>;
  filters: InputMaybe<ICategoryFilterInput>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

export type IQueryCategoryArgs = {
  id: InputMaybe<Scalars["Int"]["input"]>;
};

export type IQueryCategoryListArgs = {
  currentPage?: InputMaybe<Scalars["Int"]["input"]>;
  filters: InputMaybe<ICategoryFilterInput>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

export type IQueryCmsBlocksArgs = {
  identifiers: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type IQueryCmsPageArgs = {
  id: InputMaybe<Scalars["Int"]["input"]>;
  identifier: InputMaybe<Scalars["String"]["input"]>;
};

export type IQueryCompareListArgs = {
  uid: Scalars["ID"]["input"];
};

export type IQueryCountryArgs = {
  id: InputMaybe<Scalars["String"]["input"]>;
};

export type IQueryCustomAttributeMetadataArgs = {
  attributes: Array<IAttributeInput>;
};

export type IQueryCustomAttributeMetadataV2Args = {
  attributes: InputMaybe<Array<IAttributeInput>>;
};

export type IQueryDynamicBlocksArgs = {
  currentPage?: InputMaybe<Scalars["Int"]["input"]>;
  input: InputMaybe<IDynamicBlocksFilterInput>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

export type IQueryGetBrandConsumableMatrixArgs = {
  brandCode: Scalars["String"]["input"];
};

export type IQueryGetHostedProUrlArgs = {
  input: IHostedProUrlInput;
};

export type IQueryGetPayflowLinkTokenArgs = {
  input: IPayflowLinkTokenInput;
};

export type IQueryGetPaymentConfigArgs = {
  location: IPaymentLocation;
};

export type IQueryGetPaymentOrderArgs = {
  cartId: Scalars["String"]["input"];
  id: Scalars["String"]["input"];
};

export type IQueryGetPaymentSdkArgs = {
  location: IPaymentLocation;
};

export type IQueryGetProductPriceArgs = {
  quantity: Scalars["Int"]["input"];
  sku: Scalars["String"]["input"];
};

export type IQueryGiftCardAccountArgs = {
  input: IGiftCardAccountInput;
};

export type IQueryGiftRegistryArgs = {
  giftRegistryUid: Scalars["ID"]["input"];
};

export type IQueryGiftRegistryEmailSearchArgs = {
  email: Scalars["String"]["input"];
};

export type IQueryGiftRegistryIdSearchArgs = {
  giftRegistryUid: Scalars["ID"]["input"];
};

export type IQueryGiftRegistryTypeSearchArgs = {
  firstName: Scalars["String"]["input"];
  giftRegistryTypeUid: InputMaybe<Scalars["ID"]["input"]>;
  lastName: Scalars["String"]["input"];
};

export type IQueryGuestOrderArgs = {
  input: IOrderInformationInput;
};

export type IQueryGuestOrderByTokenArgs = {
  input: IOrderTokenInput;
};

export type IQueryIsEmailAvailableArgs = {
  email: Scalars["String"]["input"];
};

export type IQueryProductsArgs = {
  currentPage?: InputMaybe<Scalars["Int"]["input"]>;
  filter: InputMaybe<IProductAttributeFilterInput>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  search: InputMaybe<Scalars["String"]["input"]>;
  sort: InputMaybe<IProductAttributeSortInput>;
};

export type IQueryProducts_PricesArgs = {
  filter: InputMaybe<IProductSkuFilterInput>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

export type IQueryRecaptchaFormConfigArgs = {
  formType: IReCaptchaFormEnum;
};

export type IQueryRouteArgs = {
  url: Scalars["String"]["input"];
};

export type IQueryUrlResolverArgs = {
  url: Scalars["String"]["input"];
};

export type IQuoteAttribute = {
  attribute_code: Scalars["String"]["output"];
  value: Scalars["String"]["output"];
};

export type IQuoteAttributeInput = {
  attribute_code: Scalars["String"]["input"];
  value: Scalars["String"]["input"];
};

/** Specifies the field to use for sorting quote items */
export type IQuoteItemsSortInput = {
  /** Specifies the quote items field to sort by */
  field: ISortQuoteItemsEnum;
  /** Specifies the order of quote items' sorting */
  order: ISortEnum;
};

export type IReCaptchaConfigOutput = {
  /** Configuration details for reCaptcha type */
  configurations: Maybe<IReCaptchaConfiguration>;
  /** Indicates whether reCaptcha type is enabled */
  is_enabled: Scalars["Boolean"]["output"];
};

/** Contains reCAPTCHA form configuration details. */
export type IReCaptchaConfiguration = {
  /** The position of the invisible reCAPTCHA badge on each page. */
  badge_position: Maybe<Scalars["String"]["output"]>;
  /** A two-character code that specifies the language that is used for Google reCAPTCHA text and messaging. */
  language_code: Maybe<Scalars["String"]["output"]>;
  /** The minimum score that identifies a user interaction as a potential risk. */
  minimum_score: Maybe<Scalars["Float"]["output"]>;
  re_captcha_type: IReCaptchaTypeEmum;
  /** The message that appears when reCaptcha fails. */
  technical_failure_message: Scalars["String"]["output"];
  /** Theme to be used to render reCaptcha. */
  theme: Scalars["String"]["output"];
  /** The message that appears to the user if validation fails. */
  validation_failure_message: Scalars["String"]["output"];
  /** The website key generated when the Google reCAPTCHA account was registered. */
  website_key: Scalars["String"]["output"];
};

/** Contains reCAPTCHA V3-Invisible configuration details. */
export type IReCaptchaConfigurationV3 = {
  /** The position of the invisible reCAPTCHA badge on each page. */
  badge_position: Scalars["String"]["output"];
  /** The message that appears to the user if validation fails. */
  failure_message: Scalars["String"]["output"];
  /** A list of forms on the storefront that have been configured to use reCAPTCHA V3. */
  forms: Array<Maybe<IReCaptchaFormEnum>>;
  /** Return whether recaptcha is enabled or not */
  is_enabled: Scalars["Boolean"]["output"];
  /** A two-character code that specifies the language that is used for Google reCAPTCHA text and messaging. */
  language_code: Maybe<Scalars["String"]["output"]>;
  /** The minimum score that identifies a user interaction as a potential risk. */
  minimum_score: Scalars["Float"]["output"];
  /** Theme to be used to render reCaptcha. */
  theme: Scalars["String"]["output"];
  /** The website key generated when the Google reCAPTCHA account was registered. */
  website_key: Scalars["String"]["output"];
};

export enum IReCaptchaFormEnum {
  Braintree = "BRAINTREE",
  Contact = "CONTACT",
  CustomerCreate = "CUSTOMER_CREATE",
  CustomerEdit = "CUSTOMER_EDIT",
  CustomerForgotPassword = "CUSTOMER_FORGOT_PASSWORD",
  CustomerLogin = "CUSTOMER_LOGIN",
  Newsletter = "NEWSLETTER",
  PlaceOrder = "PLACE_ORDER",
  ProductReview = "PRODUCT_REVIEW",
  ResendConfirmationEmail = "RESEND_CONFIRMATION_EMAIL",
  Sendfriend = "SENDFRIEND",
}

export enum IReCaptchaTypeEmum {
  Invisible = "INVISIBLE",
  Recaptcha = "RECAPTCHA",
  RecaptchaV3 = "RECAPTCHA_V3",
}

export type IRegion = {
  /** The two-letter code for the region, such as TX for Texas. */
  code: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `Region` object. */
  id: Maybe<Scalars["Int"]["output"]>;
  /** The name of the region, such as Texas. */
  name: Maybe<Scalars["String"]["output"]>;
};

export type IRemoveCampaignFromCartInput = {
  cart_id: Scalars["String"]["input"];
};

export type IRemoveCampaignFromCartOutput = {
  cart: Maybe<ICart>;
};

/** Specifies the cart from which to remove a coupon. */
export type IRemoveCouponFromCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars["String"]["input"];
  /** The coupon code to remove (will remove all coupons if empty). */
  coupon_code: InputMaybe<Scalars["String"]["input"]>;
};

/** Contains details about the cart after removing a coupon. */
export type IRemoveCouponFromCartOutput = {
  /** The cart after removing a coupon. */
  cart: Maybe<ICart>;
};

/** Remove coupons from the cart. */
export type IRemoveCouponsFromCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars["String"]["input"];
  /** An array of coupon codes to be removed from the quote. If coupon_codes is empty all coupons will be removed from the quote. */
  coupon_codes: Array<InputMaybe<Scalars["String"]["input"]>>;
};

/** Defines the input required to run the `removeGiftCardFromCart` mutation. */
export type IRemoveGiftCardFromCartInput = {
  /** The unique ID that identifies the customer's cart. */
  cart_id: Scalars["String"]["input"];
  /** The gift card code to be removed to the cart. */
  gift_card_code: Scalars["String"]["input"];
};

/** Defines the possible output for the `removeGiftCardFromCart` mutation. */
export type IRemoveGiftCardFromCartOutput = {
  /** The contents of the specified shopping cart. */
  cart: ICart;
};

/** Contains the results of a request to remove an item from a gift registry. */
export type IRemoveGiftRegistryItemsOutput = {
  /** The gift registry after removing items. */
  gift_registry: Maybe<IGiftRegistry>;
};

/** Contains the results of a request to delete a gift registry. */
export type IRemoveGiftRegistryOutput = {
  /** Indicates whether the gift registry was successfully deleted. */
  success: Scalars["Boolean"]["output"];
};

/** Contains the results of a request to delete a registrant. */
export type IRemoveGiftRegistryRegistrantsOutput = {
  /** The gift registry after deleting registrants. */
  gift_registry: Maybe<IGiftRegistry>;
};

/** Specifies which items to remove from the cart. */
export type IRemoveItemFromCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars["String"]["input"];
  /** Deprecated. Use `cart_item_uid` instead. */
  cart_item_id: InputMaybe<Scalars["Int"]["input"]>;
  /** Required field. The unique ID for a `CartItemInterface` object. */
  cart_item_uid: InputMaybe<Scalars["ID"]["input"]>;
};

/** Contains details about the cart after removing an item. */
export type IRemoveItemFromCartOutput = {
  /** The cart after removing an item. */
  cart: ICart;
};

/** Defines which products to remove from a compare list. */
export type IRemoveProductsFromCompareListInput = {
  /** An array of product IDs to remove from the compare list. */
  products: Array<InputMaybe<Scalars["ID"]["input"]>>;
  /** The unique identifier of the compare list to modify. */
  uid: Scalars["ID"]["input"];
};

/** Contains the customer's wish list and any errors encountered. */
export type IRemoveProductsFromWishlistOutput = {
  /** An array of errors encountered while deleting products from a wish list. */
  user_errors: Array<Maybe<IWishListUserInputError>>;
  /** Contains the wish list with after items were successfully deleted. */
  wishlist: IWishlist;
};

/** Defines the tracking information to delete. */
export type IRemoveReturnTrackingInput = {
  /** The unique ID for a `ReturnShippingTracking` object. */
  return_shipping_tracking_uid: Scalars["ID"]["input"];
};

/** Contains the response after deleting tracking information. */
export type IRemoveReturnTrackingOutput = {
  /** Contains details about the modified return. */
  return: Maybe<IReturn>;
};

/** Contains the customer cart. */
export type IRemoveRewardPointsFromCartOutput = {
  /** The customer cart after reward points are removed. */
  cart: ICart;
};

/** Defines the input required to run the `removeStoreCreditFromCart` mutation. */
export type IRemoveStoreCreditFromCartInput = {
  /** The unique ID that identifies the customer's cart. */
  cart_id: Scalars["String"]["input"];
};

/** Defines the possible output for the `removeStoreCreditFromCart` mutation. */
export type IRemoveStoreCreditFromCartOutput = {
  /** The contents of the specified shopping cart. */
  cart: ICart;
};

/** Contains the cart and any errors after adding products. */
export type IReorderItemsOutput = {
  /** Detailed information about the customer's cart. */
  cart: ICart;
  /** An array of reordering errors. */
  userInputErrors: Array<Maybe<ICheckoutUserInputError>>;
};

/** Contains information needed to start a return request. */
export type IRequestGuestReturnInput = {
  /** Text the buyer entered that describes the reason for the refund request. */
  comment_text: InputMaybe<Scalars["String"]["input"]>;
  /** The email address the buyer enters to receive notifications about the status of the return. */
  contact_email: InputMaybe<Scalars["String"]["input"]>;
  /** An array of items to be returned. */
  items: Array<InputMaybe<IRequestReturnItemInput>>;
  /** Order token. */
  token: Scalars["String"]["input"];
};

/** Contains information needed to start a return request. */
export type IRequestReturnInput = {
  /** Text the buyer entered that describes the reason for the refund request. */
  comment_text: InputMaybe<Scalars["String"]["input"]>;
  /** The email address the buyer enters to receive notifications about the status of the return. */
  contact_email: InputMaybe<Scalars["String"]["input"]>;
  /** An array of items to be returned. */
  items: Array<InputMaybe<IRequestReturnItemInput>>;
  /** The unique ID for a `Order` object. */
  order_uid: Scalars["ID"]["input"];
};

/** Contains details about an item to be returned. */
export type IRequestReturnItemInput = {
  /** Details about a custom attribute that was entered. */
  entered_custom_attributes: InputMaybe<Array<InputMaybe<IEnteredCustomAttributeInput>>>;
  /** The unique ID for a `OrderItemInterface` object. */
  order_item_uid: Scalars["ID"]["input"];
  /** The quantity of the item to be returned. */
  quantity_to_return: Scalars["Float"]["input"];
  /** An array of selected custom option IDs associated with the item to be returned. For example, the IDs for the selected color and size of a configurable product. */
  selected_custom_attributes: InputMaybe<Array<InputMaybe<ISelectedCustomAttributeInput>>>;
};

/** Contains the response to a return request. */
export type IRequestReturnOutput = {
  /** Details about a single return request. */
  return: Maybe<IReturn>;
  /** An array of return requests. */
  returns: Maybe<IReturns>;
};

/** Contains the response to a return request. */
export type IRequestReturnOutputReturnsArgs = {
  currentPage?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Contains details about a return. */
export type IReturn = {
  /** A list of shipping carriers available for returns. */
  available_shipping_carriers: Maybe<Array<Maybe<IReturnShippingCarrier>>>;
  /** A list of comments posted for the return request. */
  comments: Maybe<Array<Maybe<IReturnComment>>>;
  /** The date the return was requested. */
  created_at: Scalars["String"]["output"];
  /** Data from the customer who created the return request. */
  customer: IReturnCustomer;
  /** A list of items being returned. */
  items: Maybe<Array<Maybe<IReturnItem>>>;
  /** A human-readable return number. */
  number: Scalars["String"]["output"];
  /** The order associated with the return. */
  order: Maybe<ICustomerOrder>;
  /** Shipping information for the return. */
  shipping: Maybe<IReturnShipping>;
  /** The status of the return request. */
  status: Maybe<IReturnStatus>;
  /** The unique ID for a `Return` object. */
  uid: Scalars["ID"]["output"];
};

/** Contains details about a return comment. */
export type IReturnComment = {
  /** The name or author who posted the comment. */
  author_name: Scalars["String"]["output"];
  /** The date and time the comment was posted. */
  created_at: Scalars["String"]["output"];
  /** The contents of the comment. */
  text: Scalars["String"]["output"];
  /** The unique ID for a `ReturnComment` object. */
  uid: Scalars["ID"]["output"];
};

/** Contains details about a `ReturnCustomerAttribute` object. */
export type IReturnCustomAttribute = {
  /** A description of the attribute. */
  label: Scalars["String"]["output"];
  /** The unique ID for a `ReturnCustomAttribute` object. */
  uid: Scalars["ID"]["output"];
  /** A JSON-encoded value of the attribute. */
  value: Scalars["String"]["output"];
};

/** The customer information for the return. */
export type IReturnCustomer = {
  /** The email address of the customer. */
  email: Scalars["String"]["output"];
  /** The first name of the customer. */
  firstname: Maybe<Scalars["String"]["output"]>;
  /** The last name of the customer. */
  lastname: Maybe<Scalars["String"]["output"]>;
};

/** Contains details about a product being returned. */
export type IReturnItem = {
  /**
   * Return item custom attributes that are visible on the storefront.
   * @deprecated Use custom_attributesV2 instead.
   */
  custom_attributes: Maybe<Array<Maybe<IReturnCustomAttribute>>>;
  /** Custom attributes that are visible on the storefront. */
  custom_attributesV2: Maybe<Array<Maybe<IAttributeValueInterface>>>;
  /** Provides access to the product being returned, including information about selected and entered options. */
  order_item: IOrderItemInterface;
  /** The quantity of the item the merchant authorized to be returned. */
  quantity: Scalars["Float"]["output"];
  /** The quantity of the item requested to be returned. */
  request_quantity: Scalars["Float"]["output"];
  /** The return status of the item. */
  status: IReturnItemStatus;
  /** The unique ID for a `ReturnItem` object. */
  uid: Scalars["ID"]["output"];
};

/** Return Item attribute metadata. */
export type IReturnItemAttributeMetadata = ICustomAttributeMetadataInterface & {
  /** The unique identifier for an attribute code. This value should be in lowercase letters without spaces. */
  code: Scalars["ID"]["output"];
  /** Default attribute value. */
  default_value: Maybe<Scalars["String"]["output"]>;
  /** The type of entity that defines the attribute. */
  entity_type: IAttributeEntityTypeEnum;
  /** The frontend class of the attribute. */
  frontend_class: Maybe<Scalars["String"]["output"]>;
  /** The frontend input type of the attribute. */
  frontend_input: Maybe<IAttributeFrontendInputEnum>;
  /** The template used for the input of the attribute (e.g., 'date'). */
  input_filter: Maybe<IInputFilterEnum>;
  /** Whether the attribute value is required. */
  is_required: Scalars["Boolean"]["output"];
  /** Whether the attribute value must be unique. */
  is_unique: Scalars["Boolean"]["output"];
  /** The label assigned to the attribute. */
  label: Maybe<Scalars["String"]["output"]>;
  /** The number of lines of the attribute value. */
  multiline_count: Maybe<Scalars["Int"]["output"]>;
  /** Attribute options. */
  options: Array<Maybe<ICustomAttributeOptionInterface>>;
  /** The position of the attribute in the form. */
  sort_order: Maybe<Scalars["Int"]["output"]>;
  /** The validation rules of the attribute value. */
  validate_rules: Maybe<Array<Maybe<IValidationRule>>>;
};

export enum IReturnItemStatus {
  Approved = "APPROVED",
  Authorized = "AUTHORIZED",
  Denied = "DENIED",
  Pending = "PENDING",
  Received = "RECEIVED",
  Rejected = "REJECTED",
}

/** Contains details about the return shipping address. */
export type IReturnShipping = {
  /** The merchant-defined return shipping address. */
  address: Maybe<IReturnShippingAddress>;
  /** The unique ID for a `ReturnShippingTracking` object. If a single UID is specified, the array contains a single tracking record. Otherwise, array contains all tracking information. */
  tracking: Maybe<Array<Maybe<IReturnShippingTracking>>>;
};

/** Contains details about the return shipping address. */
export type IReturnShippingTrackingArgs = {
  uid: InputMaybe<Scalars["ID"]["input"]>;
};

/** Contains details about the shipping address used for receiving returned items. */
export type IReturnShippingAddress = {
  /** The city for product returns. */
  city: Scalars["String"]["output"];
  /** The merchant's contact person. */
  contact_name: Maybe<Scalars["String"]["output"]>;
  /** An object that defines the country for product returns. */
  country: ICountry;
  /** The postal code for product returns. */
  postcode: Scalars["String"]["output"];
  /** An object that defines the state or province for product returns. */
  region: IRegion;
  /** The street address for product returns. */
  street: Array<Maybe<Scalars["String"]["output"]>>;
  /** The telephone number for product returns. */
  telephone: Maybe<Scalars["String"]["output"]>;
};

/** Contains details about the carrier on a return. */
export type IReturnShippingCarrier = {
  /** A description of the shipping carrier. */
  label: Scalars["String"]["output"];
  /** The unique ID for a `ReturnShippingCarrier` object assigned to the shipping carrier. */
  uid: Scalars["ID"]["output"];
};

/** Contains shipping and tracking details. */
export type IReturnShippingTracking = {
  /** Contains details of a shipping carrier. */
  carrier: IReturnShippingCarrier;
  /** Details about the status of a shipment. */
  status: Maybe<IReturnShippingTrackingStatus>;
  /** A tracking number assigned by the carrier. */
  tracking_number: Scalars["String"]["output"];
  /** The unique ID for a `ReturnShippingTracking` object assigned to the tracking item. */
  uid: Scalars["ID"]["output"];
};

/** Contains the status of a shipment. */
export type IReturnShippingTrackingStatus = {
  /** Text that describes the status. */
  text: Scalars["String"]["output"];
  /** Indicates whether the status type is informational or an error. */
  type: IReturnShippingTrackingStatusType;
};

export enum IReturnShippingTrackingStatusType {
  Error = "ERROR",
  Information = "INFORMATION",
}

export enum IReturnStatus {
  Approved = "APPROVED",
  Authorized = "AUTHORIZED",
  Closed = "CLOSED",
  Denied = "DENIED",
  PartiallyApproved = "PARTIALLY_APPROVED",
  PartiallyAuthorized = "PARTIALLY_AUTHORIZED",
  PartiallyReceived = "PARTIALLY_RECEIVED",
  PartiallyRejected = "PARTIALLY_REJECTED",
  Pending = "PENDING",
  ProcessedAndClosed = "PROCESSED_AND_CLOSED",
  Received = "RECEIVED",
  Rejected = "REJECTED",
  Unconfirmed = "UNCONFIRMED",
}

/** Contains a list of customer return requests. */
export type IReturns = {
  /** A list of return requests. */
  items: Maybe<Array<Maybe<IReturn>>>;
  /** Pagination metadata. */
  page_info: Maybe<ISearchResultPageInfo>;
  /** The total number of return requests. */
  total_count: Maybe<Scalars["Int"]["output"]>;
};

/** Contains the result of a request to revoke a customer token. */
export type IRevokeCustomerTokenOutput = {
  /** The result of a request to revoke a customer token. */
  result: Scalars["Boolean"]["output"];
};

/** Contains details about a customer's reward points. */
export type IRewardPoints = {
  /** The current balance of reward points. */
  balance: Maybe<IRewardPointsAmount>;
  /** The balance history of reward points. If the ability for customers to view the balance history has been disabled in the Admin, this field will be set to null. */
  balance_history: Maybe<Array<Maybe<IRewardPointsBalanceHistoryItem>>>;
  /** The current exchange rates for reward points. */
  exchange_rates: Maybe<IRewardPointsExchangeRates>;
  /** The subscription status of emails related to reward points. */
  subscription_status: Maybe<IRewardPointsSubscriptionStatus>;
};

export type IRewardPointsAmount = {
  /** The reward points amount in store currency. */
  money: IMoney;
  /** The reward points amount in points. */
  points: Scalars["Float"]["output"];
};

/** Contain details about the reward points transaction. */
export type IRewardPointsBalanceHistoryItem = {
  /** The award points balance after the completion of the transaction. */
  balance: Maybe<IRewardPointsAmount>;
  /** The reason the balance changed. */
  change_reason: Scalars["String"]["output"];
  /** The date of the transaction. */
  date: Scalars["String"]["output"];
  /** The number of points added or deducted in the transaction. */
  points_change: Scalars["Float"]["output"];
};

/** Lists the reward points exchange rates. The values depend on the customer group. */
export type IRewardPointsExchangeRates = {
  /** How many points are earned for a given amount spent. */
  earning: Maybe<IRewardPointsRate>;
  /** How many points must be redeemed to get a given amount of currency discount at the checkout. */
  redemption: Maybe<IRewardPointsRate>;
};

/** Contains details about customer's reward points rate. */
export type IRewardPointsRate = {
  /** The money value for the exchange rate. For earnings, this is the amount spent to earn the specified points. For redemption, this is the amount of money the number of points represents. */
  currency_amount: Scalars["Float"]["output"];
  /** The number of points for an exchange rate. For earnings, this is the number of points earned. For redemption, this is the number of points needed for redemption. */
  points: Scalars["Float"]["output"];
};

/** Indicates whether the customer subscribes to reward points emails. */
export type IRewardPointsSubscriptionStatus = {
  /** Indicates whether the customer subscribes to 'Reward points balance updates' emails. */
  balance_updates: IRewardPointsSubscriptionStatusesEnum;
  /** Indicates whether the customer subscribes to 'Reward points expiration notifications' emails. */
  points_expiration_notifications: IRewardPointsSubscriptionStatusesEnum;
};

export enum IRewardPointsSubscriptionStatusesEnum {
  NotSubscribed = "NOT_SUBSCRIBED",
  Subscribed = "SUBSCRIBED",
}

/** Routable entities serve as the model for a rendered page. */
export type IRoutableInterface = {
  /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
  redirect_code: Scalars["Int"]["output"];
  /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
  relative_url: Maybe<Scalars["String"]["output"]>;
  /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
  type: Maybe<IUrlRewriteEntityTypeEnum>;
};

/** Default implementation of RoutableInterface. This type is returned when the URL is not linked to an entity. */
export type IRoutableUrl = IRoutableInterface & {
  /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
  redirect_code: Scalars["Int"]["output"];
  /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
  relative_url: Maybe<Scalars["String"]["output"]>;
  /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
  type: Maybe<IUrlRewriteEntityTypeEnum>;
};

/** Defines the name and value of a SDK parameter */
export type ISdkParams = {
  /** The name of the SDK parameter */
  name: Maybe<Scalars["String"]["output"]>;
  /** The value of the SDK parameter */
  value: Maybe<Scalars["String"]["output"]>;
};

/** Contains details about a comment. */
export type ISalesCommentItem = {
  /** The text of the message. */
  message: Scalars["String"]["output"];
  /** The timestamp of the comment. */
  timestamp: Scalars["String"]["output"];
};

export type ISalesItemInterface = {
  /** The entered gift message for the order item */
  gift_message: Maybe<IGiftMessage>;
};

/** This enumeration defines the scope type for customer orders. */
export enum IScopeTypeEnum {
  Global = "GLOBAL",
  Store = "STORE",
  Website = "WEBSITE",
}

/** Provides navigation for the query response. */
export type ISearchResultPageInfo = {
  /** The specific page to return. */
  current_page: Maybe<Scalars["Int"]["output"]>;
  /** The maximum number of items to return per page of results. */
  page_size: Maybe<Scalars["Int"]["output"]>;
  /** The total number of pages in the response. */
  total_pages: Maybe<Scalars["Int"]["output"]>;
};

/** A string that contains search suggestion */
export type ISearchSuggestion = {
  /** The search suggestion of existing product. */
  search: Scalars["String"]["output"];
};

/** Contains details about a selected bundle option. */
export type ISelectedBundleOption = {
  /** @deprecated Use `uid` instead */
  id: Scalars["Int"]["output"];
  /** The display name of the selected bundle product option. */
  label: Scalars["String"]["output"];
  /** The type of selected bundle product option. */
  type: Scalars["String"]["output"];
  /** The unique ID for a `SelectedBundleOption` object */
  uid: Scalars["ID"]["output"];
  /** An array of selected bundle option values. */
  values: Array<Maybe<ISelectedBundleOptionValue>>;
};

/** Contains details about a value for a selected bundle option. */
export type ISelectedBundleOptionValue = {
  /** Use `uid` instead */
  id: Scalars["Int"]["output"];
  /** The display name of the value for the selected bundle product option. */
  label: Scalars["String"]["output"];
  /** The original price of the value for the selected bundle product option. */
  original_price: IMoney;
  /** Provides information on the selections for presentation prices only on quote item */
  presentation_info: Maybe<IPresentationPrices>;
  /**
   * The price of the value for the selected bundle product option.
   * @deprecated Use priceV2 instead.
   */
  price: Scalars["Float"]["output"];
  /** The price of the value for the selected bundle product option. */
  priceV2: IMoney;
  /** The quantity of the value for the selected bundle product option. */
  quantity: Scalars["Float"]["output"];
  /** The unique ID for a `SelectedBundleOptionValue` object */
  uid: Scalars["ID"]["output"];
};

/** Contains details about a selected configurable option. */
export type ISelectedConfigurableOption = {
  /** The unique ID for a `ConfigurableProductOptions` object. */
  configurable_product_option_uid: Scalars["ID"]["output"];
  /** The unique ID for a `ConfigurableProductOptionsValues` object. */
  configurable_product_option_value_uid: Scalars["ID"]["output"];
  /** @deprecated Use `SelectedConfigurableOption.configurable_product_option_uid` instead. */
  id: Scalars["Int"]["output"];
  /** The display text for the option. */
  option_label: Scalars["String"]["output"];
  /** @deprecated Use `SelectedConfigurableOption.configurable_product_option_value_uid` instead. */
  value_id: Scalars["Int"]["output"];
  /** The display name of the selected configurable option. */
  value_label: Scalars["String"]["output"];
};

/** Contains details about an attribute the buyer selected. */
export type ISelectedCustomAttributeInput = {
  /** A string that identifies the selected attribute. */
  attribute_code: Scalars["String"]["input"];
  /** The unique ID for a selected custom attribute value. */
  value: Scalars["String"]["input"];
};

/** Identifies a customized product that has been placed in a cart. */
export type ISelectedCustomizableOption = {
  /** The unique ID for a specific `CustomizableOptionInterface` object, such as a `CustomizableFieldOption`, `CustomizableFileOption`, or `CustomizableAreaOption` object. */
  customizable_option_uid: Scalars["ID"]["output"];
  /** @deprecated Use `SelectedCustomizableOption.customizable_option_uid` instead. */
  id: Scalars["Int"]["output"];
  /** Indicates whether the customizable option is required. */
  is_required: Scalars["Boolean"]["output"];
  /** The display name of the selected customizable option. */
  label: Scalars["String"]["output"];
  /** A value indicating the order to display this option. */
  sort_order: Scalars["Int"]["output"];
  /** The type of `CustomizableOptionInterface` object. */
  type: Scalars["String"]["output"];
  /** An array of selectable values. */
  values: Array<Maybe<ISelectedCustomizableOptionValue>>;
};

/** Identifies the value of the selected customized option. */
export type ISelectedCustomizableOptionValue = {
  /** The unique ID for a value object that corresponds to the object represented by the `customizable_option_uid` attribute. */
  customizable_option_value_uid: Scalars["ID"]["output"];
  /** @deprecated Use `SelectedCustomizableOptionValue.customizable_option_value_uid` instead. */
  id: Scalars["Int"]["output"];
  /** The display name of the selected value. */
  label: Scalars["String"]["output"];
  /** The price of the selected customizable value. */
  price: ICartItemSelectedOptionValuePrice;
  /** The text identifying the selected value. */
  value: Scalars["String"]["output"];
};

/** Describes the payment method the shopper selected. */
export type ISelectedPaymentMethod = {
  /** The payment method code. */
  code: Scalars["String"]["output"];
  /** The purchase order number. */
  purchase_order_number: Maybe<Scalars["String"]["output"]>;
  /** The payment method title. */
  title: Scalars["String"]["output"];
};

/** Contains details about the selected shipping method and carrier. */
export type ISelectedShippingMethod = {
  /** The cost of shipping using this shipping method. */
  amount: IMoney;
  /** @deprecated The field should not be used on the storefront. */
  base_amount: Maybe<IMoney>;
  /** A string that identifies a commercial carrier or an offline shipping method. */
  carrier_code: Scalars["String"]["output"];
  /** The label for the carrier code. */
  carrier_title: Scalars["String"]["output"];
  estimated_delivery_time: Maybe<Scalars["String"]["output"]>;
  /** A shipping method code associated with a carrier. */
  method_code: Scalars["String"]["output"];
  /** The label for the method code. */
  method_title: Scalars["String"]["output"];
  /** The cost of shipping using this shipping method, excluding tax. */
  price_excl_tax: IMoney;
  /** The cost of shipping using this shipping method, including tax. */
  price_incl_tax: IMoney;
};

/** Defines the referenced product and the email sender and recipients. */
export type ISendEmailToFriendInput = {
  /** The ID of the product that the sender is referencing. */
  product_id: Scalars["Int"]["input"];
  /** An array containing information about each recipient. */
  recipients: Array<InputMaybe<ISendEmailToFriendRecipientInput>>;
  /** Information about the customer and the content of the message. */
  sender: ISendEmailToFriendSenderInput;
};

/** Contains information about the sender and recipients. */
export type ISendEmailToFriendOutput = {
  /** An array containing information about each recipient. */
  recipients: Maybe<Array<Maybe<ISendEmailToFriendRecipient>>>;
  /** Information about the customer and the content of the message. */
  sender: Maybe<ISendEmailToFriendSender>;
};

/** An output object that contains information about the recipient. */
export type ISendEmailToFriendRecipient = {
  /** The email address of the recipient. */
  email: Scalars["String"]["output"];
  /** The name of the recipient. */
  name: Scalars["String"]["output"];
};

/** Contains details about a recipient. */
export type ISendEmailToFriendRecipientInput = {
  /** The email address of the recipient. */
  email: Scalars["String"]["input"];
  /** The name of the recipient. */
  name: Scalars["String"]["input"];
};

/** An output object that contains information about the sender. */
export type ISendEmailToFriendSender = {
  /** The email address of the sender. */
  email: Scalars["String"]["output"];
  /** The text of the message to be sent. */
  message: Scalars["String"]["output"];
  /** The name of the sender. */
  name: Scalars["String"]["output"];
};

/** Contains details about the sender. */
export type ISendEmailToFriendSenderInput = {
  /** The email address of the sender. */
  email: Scalars["String"]["input"];
  /** The text of the message to be sent. */
  message: Scalars["String"]["input"];
  /** The name of the sender. */
  name: Scalars["String"]["input"];
};

/** Contains details about the configuration of the Email to a Friend feature. */
export type ISendFriendConfiguration = {
  /** Indicates whether the Email to a Friend feature is enabled. */
  enabled_for_customers: Scalars["Boolean"]["output"];
  /** Indicates whether the Email to a Friend feature is enabled for guests. */
  enabled_for_guests: Scalars["Boolean"]["output"];
};

export type ISetAdditionalAttributesError = {
  code: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

export type ISetAdditionalAttributesInput = {
  additional_attributes: Array<InputMaybe<IQuoteAttributeInput>>;
  /** Masked cart ID */
  cart_id: Scalars["String"]["input"];
};

export type ISetAdditionalAttributesOutput = {
  errors: Array<Maybe<ISetAdditionalAttributesError>>;
};

/** Sets the billing address. */
export type ISetBillingAddressOnCartInput = {
  /** The billing address. */
  billing_address: IBillingAddressInput;
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars["String"]["input"];
};

/** Contains details about the cart after setting the billing address. */
export type ISetBillingAddressOnCartOutput = {
  /** The cart after setting the billing address. */
  cart: ICart;
};

/** Sets the cart as inactive */
export type ISetCartAsInactiveOutput = {
  /** The error message returned after failing to set the cart as inactive */
  error: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether the cart was set as inactive */
  success: Scalars["Boolean"]["output"];
};

/** Defines the gift options applied to the cart. */
export type ISetGiftOptionsOnCartInput = {
  /** The unique ID that identifies the shopper's cart. */
  cart_id: Scalars["String"]["input"];
  /** Gift message details for the cart. */
  gift_message: InputMaybe<IGiftMessageInput>;
  /** Whether customer requested gift receipt for the cart. */
  gift_receipt_included: Scalars["Boolean"]["input"];
  /** The unique ID for a `GiftWrapping` object to be used for the cart. */
  gift_wrapping_id: InputMaybe<Scalars["ID"]["input"]>;
  /** Whether customer requested printed card for the cart. */
  printed_card_included: Scalars["Boolean"]["input"];
};

/** Contains the cart after gift options have been applied. */
export type ISetGiftOptionsOnCartOutput = {
  /** The modified cart object. */
  cart: ICart;
};

/** Defines the guest email and cart. */
export type ISetGuestEmailOnCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars["String"]["input"];
  /** The email address of the guest. */
  email: Scalars["String"]["input"];
};

/** Contains details about the cart after setting the email of a guest. */
export type ISetGuestEmailOnCartOutput = {
  /** The cart after setting the guest email. */
  cart: ICart;
};

/** Applies a payment method to the quote. */
export type ISetPaymentMethodAndPlaceOrderInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars["String"]["input"];
  /** The payment method data to apply to the cart. */
  payment_method: IPaymentMethodInput;
};

/** Applies a payment method to the cart. */
export type ISetPaymentMethodOnCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars["String"]["input"];
  /** The payment method data to apply to the cart. */
  payment_method: IPaymentMethodInput;
};

/** Contains details about the cart after setting the payment method. */
export type ISetPaymentMethodOnCartOutput = {
  /** The cart after setting the payment method. */
  cart: ICart;
};

/** Specifies an array of addresses to use for shipping. */
export type ISetShippingAddressesOnCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars["String"]["input"];
  /** An array of shipping addresses. */
  shipping_addresses: Array<InputMaybe<IShippingAddressInput>>;
};

/** Contains details about the cart after setting the shipping addresses. */
export type ISetShippingAddressesOnCartOutput = {
  /** The cart after setting the shipping addresses. */
  cart: ICart;
};

/** Applies one or shipping methods to the cart. */
export type ISetShippingMethodsOnCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars["String"]["input"];
  /** An array of shipping methods. */
  shipping_methods: Array<InputMaybe<IShippingMethodInput>>;
};

/** Contains details about the cart after setting the shipping methods. */
export type ISetShippingMethodsOnCartOutput = {
  /** The cart after setting the shipping methods. */
  cart: ICart;
};

/** Defines a gift registry invitee. */
export type IShareGiftRegistryInviteeInput = {
  /** The email address of the gift registry invitee. */
  email: Scalars["String"]["input"];
  /** The name of the gift registry invitee. */
  name: Scalars["String"]["input"];
};

/** Contains the results of a request to share a gift registry. */
export type IShareGiftRegistryOutput = {
  /** Indicates whether the gift registry was successfully shared. */
  is_shared: Scalars["Boolean"]["output"];
};

/** Defines the sender of an invitation to view a gift registry. */
export type IShareGiftRegistrySenderInput = {
  /** A brief message from the sender. */
  message: Scalars["String"]["input"];
  /** The sender of the gift registry invitation. */
  name: Scalars["String"]["input"];
};

/** Defines whether bundle items must be shipped together. */
export enum IShipBundleItemsEnum {
  Separately = "SEPARATELY",
  Together = "TOGETHER",
}

export type IShipmentItem = IShipmentItemInterface & {
  /** The unique ID for a `ShipmentItemInterface` object. */
  id: Scalars["ID"]["output"];
  /** The order item associated with the shipment item. */
  order_item: Maybe<IOrderItemInterface>;
  /** The name of the base product. */
  product_name: Maybe<Scalars["String"]["output"]>;
  /** The sale price for the base product. */
  product_sale_price: IMoney;
  /** The SKU of the base product. */
  product_sku: Scalars["String"]["output"];
  /** The number of shipped items. */
  quantity_shipped: Scalars["Float"]["output"];
};

/** Order shipment item details. */
export type IShipmentItemInterface = {
  /** The unique ID for a `ShipmentItemInterface` object. */
  id: Scalars["ID"]["output"];
  /** The order item associated with the shipment item. */
  order_item: Maybe<IOrderItemInterface>;
  /** The name of the base product. */
  product_name: Maybe<Scalars["String"]["output"]>;
  /** The sale price for the base product. */
  product_sale_price: IMoney;
  /** The SKU of the base product. */
  product_sku: Scalars["String"]["output"];
  /** The number of shipped items. */
  quantity_shipped: Scalars["Float"]["output"];
};

/** Contains order shipment tracking details. */
export type IShipmentTracking = {
  /** The shipping carrier for the order delivery. */
  carrier: Scalars["String"]["output"];
  /** The tracking number of the order shipment. */
  number: Maybe<Scalars["String"]["output"]>;
  /** The shipment tracking title. */
  title: Scalars["String"]["output"];
  /** The tracking URL of the order shipment. */
  track_url: Maybe<Scalars["String"]["output"]>;
};

/** Defines a single shipping address. */
export type IShippingAddressInput = {
  /** Defines a shipping address. */
  address: InputMaybe<ICartAddressInput>;
  /** An ID from the customer's address book that uniquely identifies the address to be used for shipping. */
  customer_address_id: InputMaybe<Scalars["Int"]["input"]>;
  /** Text provided by the shopper. */
  customer_notes: InputMaybe<Scalars["String"]["input"]>;
};

/** Contains shipping addresses and methods. */
export type IShippingCartAddress = ICartAddressInterface & {
  /** Administrative area level 2 */
  administrative_area_level_2: Maybe<Scalars["String"]["output"]>;
  /** An array that lists the shipping methods that can be applied to the cart. */
  available_shipping_methods: Maybe<Array<Maybe<IAvailableShippingMethod>>>;
  /** Building Number */
  building_number: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use `cart_items_v2` instead. */
  cart_items: Maybe<Array<Maybe<ICartItemQuantity>>>;
  /** An array that lists the items in the cart. */
  cart_items_v2: Maybe<Array<Maybe<ICartItemInterface>>>;
  /** The city specified for the billing or shipping address. */
  city: Scalars["String"]["output"];
  /** The company specified for the billing or shipping address. */
  company: Maybe<Scalars["String"]["output"]>;
  /** An object containing the country label and code. */
  country: ICartAddressCountry;
  /** The custom attribute values of the billing or shipping address. */
  custom_attributes: Array<Maybe<IAttributeValueInterface>>;
  /** Text provided by the shopper. */
  customer_notes: Maybe<Scalars["String"]["output"]>;
  /** District */
  district: Maybe<Scalars["String"]["output"]>;
  /** The customer's fax number. */
  fax: Maybe<Scalars["String"]["output"]>;
  /** The first name of the customer or guest. */
  firstname: Maybe<Scalars["String"]["output"]>;
  /** Apartment, floor, building, etc. */
  house_details: Maybe<Scalars["String"]["output"]>;
  /** Id of the customer address. */
  id: Maybe<Scalars["Int"]["output"]>;
  /** States if the selected address is a pickup address */
  is_pickup_address: Maybe<Scalars["Boolean"]["output"]>;
  /** @deprecated This information should not be exposed on the frontend. */
  items_weight: Maybe<Scalars["Float"]["output"]>;
  /** Landmark */
  landmark: Maybe<Scalars["String"]["output"]>;
  /** The last name of the customer or guest. */
  lastname: Scalars["String"]["output"];
  /** The middle name of the person associated with the billing/shipping address. */
  middlename: Maybe<Scalars["String"]["output"]>;
  /** Neighborhood */
  neighborhood: Maybe<Scalars["String"]["output"]>;
  /** JSON encoded string of required fields like store id etc for the pickup point */
  pickup_information: Maybe<Scalars["String"]["output"]>;
  /** The ZIP or postal code of the billing or shipping address. */
  postcode: Maybe<Scalars["String"]["output"]>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix: Maybe<Scalars["String"]["output"]>;
  /** Premise */
  premise: Maybe<Scalars["String"]["output"]>;
  /** An object containing the region label and code. */
  region: Maybe<ICartAddressRegion>;
  /** Indicates whether the shipping address is same as billing address. */
  same_as_billing: Scalars["Boolean"]["output"];
  /** An object that describes the selected shipping method. */
  selected_shipping_method: Maybe<ISelectedShippingMethod>;
  /** Short National Address */
  short_address: Maybe<Scalars["String"]["output"]>;
  /** An array containing the street for the billing or shipping address. */
  street: Array<Maybe<Scalars["String"]["output"]>>;
  /** Street number */
  street_nr: Maybe<Scalars["String"]["output"]>;
  /** Sublocality level 2 */
  sublocality_level_2: Maybe<Scalars["String"]["output"]>;
  /** A value such as Sr., Jr., or III. */
  suffix: Maybe<Scalars["String"]["output"]>;
  /** The telephone number for the billing or shipping address. */
  telephone: Maybe<Scalars["String"]["output"]>;
  /** The unique id of the customer address. */
  uid: Scalars["String"]["output"];
  /** The VAT company number for billing or shipping address. */
  vat_id: Maybe<Scalars["String"]["output"]>;
};

/** Defines an individual shipping discount. This discount can be applied to shipping. */
export type IShippingDiscount = {
  /** The amount of the discount. */
  amount: IMoney;
};

/** Contains details about shipping and handling costs. */
export type IShippingHandling = {
  /** The shipping amount, excluding tax. */
  amount_excluding_tax: Maybe<IMoney>;
  /** The shipping amount, including tax. */
  amount_including_tax: Maybe<IMoney>;
  /** The applied discounts to the shipping. */
  discounts: Maybe<Array<Maybe<IShippingDiscount>>>;
  /** Details about taxes applied for shipping. */
  taxes: Maybe<Array<Maybe<ITaxItem>>>;
  /** The total amount for shipping. */
  total_amount: IMoney;
};

/** Defines the shipping carrier and method. */
export type IShippingMethodInput = {
  /** A string that identifies a commercial carrier or an offline delivery method. */
  carrier_code: Scalars["String"]["input"];
  /** A string that indicates which service a commercial carrier will use to ship items. For offline delivery methods, this value is similar to the label displayed on the checkout page. */
  method_code: Scalars["String"]["input"];
};

/** An implementation for simple product cart items. */
export type ISimpleCartItem = ICartItemInterface & {
  /** The list of available gift wrapping options for the cart item. */
  available_gift_wrapping: Array<Maybe<IGiftWrapping>>;
  /** An array containing the customizable options the shopper selected. */
  customizable_options: Array<Maybe<ISelectedCustomizableOption>>;
  /** An array of errors encountered while loading the cart item */
  errors: Maybe<Array<Maybe<ICartItemError>>>;
  /** Provides info regarding the gift added to the basket */
  gift_data: Maybe<IGiftData>;
  /** The entered gift message for the cart item */
  gift_message: Maybe<IGiftMessage>;
  /** The selected gift wrapping for the cart item. */
  gift_wrapping: Maybe<IGiftWrapping>;
  /** Provides the flag to show if consent was set or not */
  has_registration_consent: Maybe<Scalars["Boolean"]["output"]>;
  /** @deprecated Use `uid` instead. */
  id: Scalars["String"]["output"];
  /** True if requested quantity is less than available stock, false otherwise. */
  is_available: Scalars["Boolean"]["output"];
  /** Message to display when the product is not available with this selected option. */
  not_available_message: Maybe<Scalars["String"]["output"]>;
  /** Contains details about the price of the item, including taxes and discounts. */
  prices: Maybe<ICartItemPrices>;
  /** Details about an item in the cart. */
  product: IProductInterface;
  /** The quantity of this item in the cart. */
  quantity: Scalars["Float"]["output"];
  /** The unique ID for a `CartItemInterface` object. */
  uid: Scalars["ID"]["output"];
};

/** Defines a simple product, which is tangible and is usually sold in single units or in fixed quantities. */
export type ISimpleProduct = ICustomizableProductInterface &
  IPhysicalProductInterface &
  IProductInterface &
  IRoutableInterface & {
    /** @deprecated Use the `custom_attributes` field instead. */
    about_manufacturer: Maybe<Scalars["String"]["output"]>;
    /**
     * The attribute set assigned to the product.
     * @deprecated The field should not be used on the storefront.
     */
    attribute_set_id: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    available_date: Maybe<Scalars["String"]["output"]>;
    /**
     * Whether the product is explicitly available for Mobile App commerce exposure. 1 = eligible, 0 or null = not eligible.
     * @deprecated Use the `custom_attributes` field instead.
     */
    available_for_mobile_app: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    battery: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    buy_cta_pdp: Maybe<Scalars["Int"]["output"]>;
    /** CTA for PDP attribute translated label . */
    buy_cta_pdp_label: Scalars["String"]["output"];
    /** @deprecated Use the `custom_attributes` field instead. */
    buy_cta_plp: Maybe<Scalars["Int"]["output"]>;
    /** CTA for PLP attribute translated label . */
    buy_cta_plp_label: Scalars["String"]["output"];
    /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
    canonical_url: Maybe<Scalars["String"]["output"]>;
    /** The categories assigned to a product. */
    categories: Maybe<Array<Maybe<ICategoryInterface>>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    charging_time: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    color: Maybe<Scalars["Int"]["output"]>;
    /** Color attribute label. */
    color_label: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    connectors: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    connectors_1: Maybe<Scalars["String"]["output"]>;
    /** The product's country of origin. */
    country_of_manufacture: Maybe<Scalars["String"]["output"]>;
    /**
     * Timestamp indicating when the product was created.
     * @deprecated The field should not be used on the storefront.
     */
    created_at: Maybe<Scalars["String"]["output"]>;
    /** An array of cross-sell products. */
    crosssell_products: Maybe<Array<Maybe<IProductInterface>>>;
    /** Product custom attributes. */
    custom_attributesV2: Maybe<IProductCustomAttributes>;
    /** Delivery region this product may be shipped to — `ES` or `IC`, the same vocabulary as the region header and getDeliveryRegions.code. Distinct from `region_code` on address types, which carries a province code. Null when the product carries no region, or its attribute value is not mapped to one; either way the product is undeliverable everywhere. */
    delivery_region_code: Maybe<Scalars["String"]["output"]>;
    /** Detailed information about the product. The value can include simple HTML tags. */
    description: Maybe<IComplexTextValue>;
    /** @deprecated Use the `custom_attributes` field instead. */
    device_dimensions: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    dimensions: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    enable_lifetime_quantity_limit: Maybe<Scalars["Int"]["output"]>;
    /**
     * Is quantity limit enabled for this product
     * @deprecated Use the `custom_attributes` field instead.
     */
    enable_order_quantity_limit: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    experience: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    flavor: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    flavor_family: Maybe<Scalars["String"]["output"]>;
    /** Color attribute label. */
    flavor_label: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    flavour: Maybe<Scalars["Int"]["output"]>;
    /** Get all details for flavour */
    flavour_details: Array<Maybe<IFlavourDetails>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    formula: Maybe<Scalars["Int"]["output"]>;
    /** A list of gift options for the given product */
    free_gifts: Maybe<IFreeGiftProductData>;
    /** Returns all attribute values and labels marked as visible on storefront */
    frontend_attributes: Maybe<Array<Maybe<IFrontendAttribute>>>;
    /** Returns a value indicating gift message availability for the product. */
    gift_message_available: Scalars["Boolean"]["output"];
    /** Returns a value indicating gift wrapping availability for the product. */
    gift_wrapping_available: Scalars["Boolean"]["output"];
    /** Returns value and currency indicating gift wrapping price for the product. */
    gift_wrapping_price: Maybe<IMoney>;
    /** @deprecated Use the `custom_attributes` field instead. */
    has_device: Maybe<Scalars["Int"]["output"]>;
    /** Provides the flag to show if consent is required or not */
    has_registration_consent: Maybe<Scalars["Boolean"]["output"]>;
    /** Product is hidden_sku or not */
    hidden_sku: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * The ID number assigned to the product.
     * @deprecated Use the `uid` field instead.
     */
    id: Maybe<Scalars["Int"]["output"]>;
    /** The relative path to the main image on the product page. */
    image: Maybe<IProductImage>;
    /** @deprecated Use the `custom_attributes` field instead. */
    importer: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    input_terminal: Maybe<Scalars["Int"]["output"]>;
    /** Product discontinued flag */
    is_discontinued: Maybe<Scalars["Boolean"]["output"]>;
    /** Indicates whether the product can be returned. */
    is_returnable: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    jti_brand_matrix: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    jti_category_redirect: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    jti_product_discontinued: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    jti_sku_redirect: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    large_stick_tray: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    lifetime_quantity_limit: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    main_specifications: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    mandatory_positive_consent: Maybe<Scalars["Int"]["output"]>;
    /**
     * A number representing the product's manufacturer.
     * @deprecated Use the `custom_attributes` field instead.
     */
    manufacturer: Maybe<Scalars["Int"]["output"]>;
    /** Product subscription format */
    manufacturer_label: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    material: Maybe<Scalars["String"]["output"]>;
    /** Maximum Qty Allowed in Shopping Cart */
    max_sale_qty: Maybe<Scalars["Float"]["output"]>;
    /** An array of media gallery objects. */
    media_gallery: Maybe<Array<Maybe<IMediaGalleryInterface>>>;
    /**
     * An array of MediaGalleryEntry objects.
     * @deprecated Use `media_gallery` instead.
     */
    media_gallery_entries: Maybe<Array<Maybe<IMediaGalleryEntry>>>;
    /** A brief overview of the product for search results listings, maximum 255 characters. */
    meta_description: Maybe<Scalars["String"]["output"]>;
    /** A comma-separated list of keywords that are visible only to search engines. */
    meta_keyword: Maybe<Scalars["String"]["output"]>;
    /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
    meta_title: Maybe<Scalars["String"]["output"]>;
    /** Minimum Qty Allowed in Shopping Cart */
    min_sale_qty: Maybe<Scalars["Float"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    minimum_amount: Maybe<Scalars["Float"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    minimum_amount_type: Maybe<Scalars["String"]["output"]>;
    /**
     * Multipack description for this product
     * @deprecated Use the `custom_attributes` field instead.
     */
    multipack_description: Maybe<Scalars["String"]["output"]>;
    /** Is multipacks selected enabled for this product */
    multipack_enabled: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * Multipack label for this product
     * @deprecated Use the `custom_attributes` field instead.
     */
    multipack_label: Maybe<Scalars["String"]["output"]>;
    /** Multipack price text for this product */
    multipack_price: Maybe<Scalars["String"]["output"]>;
    /** Multipack Products */
    multipack_products: Maybe<Array<Maybe<IProductInterface>>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    multipacks_enabled: Maybe<Scalars["Int"]["output"]>;
    /** The product name. Customers use this name to identify the product. */
    name: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    name_and_model: Maybe<Scalars["String"]["output"]>;
    /** The beginning date for new product listings, and determines if the product is featured as a new product. */
    new_from_date: Maybe<Scalars["String"]["output"]>;
    /** The end date for new product listings. */
    new_to_date: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    non_trade_in_sku: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    number_of_packs: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    number_of_sticks: Maybe<Scalars["Int"]["output"]>;
    /** Product stock only x left count */
    only_x_left_in_stock: Maybe<Scalars["Float"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    option_grouped_by_brand: Maybe<Scalars["Int"]["output"]>;
    /** An array of options for a customizable product. */
    options: Maybe<Array<Maybe<ICustomizableOptionInterface>>>;
    /** If the product has multiple options, determines where they appear on the product page. */
    options_container: Maybe<Scalars["String"]["output"]>;
    /**
     * Maximum quantity allowed per one order
     * @deprecated Use the `custom_attributes` field instead.
     */
    order_quantity_limit: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    portable_stick_tray: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    pouch_size: Maybe<Scalars["Int"]["output"]>;
    /**
     * Indicates the price of an item.
     * @deprecated Use `price_range` for product price information.
     */
    price: Maybe<IProductPrices>;
    /** The range of prices for the product */
    price_range: IPriceRange;
    /** An array of `TierPrice` objects. */
    price_tiers: Maybe<Array<Maybe<ITierPrice>>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_brand: Maybe<Scalars["String"]["output"]>;
    /** Product Brand Label */
    product_brand_label: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_category: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_category_type: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_color: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_disclaimer: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_family: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_generation: Maybe<Scalars["String"]["output"]>;
    /** An array of `ProductLinks` objects. */
    product_links: Maybe<Array<Maybe<IProductLinksInterface>>>;
    /** Get all special offers for a product. */
    promotionalOffers: Array<Maybe<ISpecialOffer>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    province: Maybe<Scalars["String"]["output"]>;
    /** Product provence label for PLP attribute. */
    province_label: Maybe<Scalars["String"]["output"]>;
    /** Amount of available stock */
    quantity: Maybe<Scalars["Float"]["output"]>;
    /** The average of all the ratings given to the product. */
    rating_summary: Scalars["Float"]["output"];
    /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
    redirect_code: Scalars["Int"]["output"];
    /** Redirect category URL path for discontinued product */
    redirect_product_category: Maybe<Scalars["String"]["output"]>;
    /** Redirect product SKU for discontinued product */
    redirect_sku: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    region: Maybe<Scalars["Int"]["output"]>;
    /** Product Region attribute translated label. */
    region_label: Maybe<Scalars["String"]["output"]>;
    /** An array of related products. */
    related_products: Maybe<Array<Maybe<IProductInterface>>>;
    /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
    relative_url: Maybe<Scalars["String"]["output"]>;
    /** The total count of all the reviews given to the product. */
    review_count: Scalars["Int"]["output"];
    /** @deprecated Use the `custom_attributes` field instead. */
    review_eligible: Maybe<Scalars["Int"]["output"]>;
    /** The list of products reviews. */
    reviews: IProductReviews;
    /** A short description of the product. Its use depends on the theme. */
    short_description: Maybe<IComplexTextValue>;
    /** @deprecated Use the `custom_attributes` field instead. */
    size: Maybe<Scalars["String"]["output"]>;
    /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
    sku: Maybe<Scalars["String"]["output"]>;
    /** The relative path to the small image, which is used on catalog pages. */
    small_image: Maybe<IProductImage>;
    /** Get all special offers for a product. */
    specialOffers: Array<Maybe<ISpecialOffer>>;
    /**
     * The beginning date that a product has a special price.
     * @deprecated The field should not be used on the storefront.
     */
    special_from_date: Maybe<Scalars["String"]["output"]>;
    /** The discounted price of the product. */
    special_price: Maybe<Scalars["Float"]["output"]>;
    /** The end date for a product with a special price. */
    special_to_date: Maybe<Scalars["String"]["output"]>;
    /** Indicates whether the product is staged for a future campaign. */
    staged: Scalars["Boolean"]["output"];
    /** @deprecated Use the `custom_attributes` field instead. */
    stick_capability: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    stick_compatibility: Maybe<Scalars["String"]["output"]>;
    /** Stock status of the product */
    stock_status: Maybe<IProductStockStatus>;
    /** @deprecated Use the `custom_attributes` field instead. */
    strength: Maybe<Scalars["Int"]["output"]>;
    /** Get all details for strength */
    strength_details: Maybe<IStrengthDetails>;
    /** @deprecated Use the `custom_attributes` field instead. */
    subscription: Maybe<Scalars["Int"]["output"]>;
    /**
     * Product subscription format
     * @deprecated Use the `custom_attributes` field instead.
     */
    subscription_format: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    subtitle: Maybe<Scalars["String"]["output"]>;
    /** The file name of a swatch image. */
    swatch_image: Maybe<Scalars["String"]["output"]>;
    /** The relative path to the product's thumbnail image. */
    thumbnail: Maybe<IProductImage>;
    /**
     * The price when tier pricing is in effect and the items purchased threshold has been reached.
     * @deprecated Use `price_tiers` for product tier price information.
     */
    tier_price: Maybe<Scalars["Float"]["output"]>;
    /**
     * An array of ProductTierPrices objects.
     * @deprecated Use `price_tiers` for product tier price information.
     */
    tier_prices: Maybe<Array<Maybe<IProductTierPrices>>>;
    /**
     * Product tooltip information
     * @deprecated Use the `custom_attributes` field instead.
     */
    tooltip_info: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    trabka: Maybe<Scalars["String"]["output"]>;
    /**
     * Indicates whether the product is eligible for a trade-in purchase.
     * @deprecated Use the `custom_attributes` field instead.
     */
    trade_in: Scalars["Int"]["output"];
    /**
     * Specific to trial stores, provides information about the finalization sku
     * @deprecated Use the `custom_attributes` field instead.
     */
    trial_finalization_sku: Maybe<Scalars["String"]["output"]>;
    /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
    type: Maybe<IUrlRewriteEntityTypeEnum>;
    /**
     * One of simple, virtual, bundle, downloadable, grouped, or configurable.
     * @deprecated Use `__typename` instead.
     */
    type_id: Maybe<Scalars["String"]["output"]>;
    /** Product Type */
    type_label: Maybe<Scalars["String"]["output"]>;
    /** The unique ID for a `ProductInterface` object. */
    uid: Scalars["ID"]["output"];
    /**
     * Timestamp indicating when the product was updated.
     * @deprecated The field should not be used on the storefront.
     */
    updated_at: Maybe<Scalars["String"]["output"]>;
    /** An array of up-sell products. */
    upsell_products: Maybe<Array<Maybe<IProductInterface>>>;
    /** The part of the URL that identifies the product */
    url_key: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use product's `canonical_url` or url rewrites instead */
    url_path: Maybe<Scalars["String"]["output"]>;
    /** URL rewrites list */
    url_rewrites: Maybe<Array<Maybe<IUrlRewrite>>>;
    /** The part of the product URL that is appended after the url key */
    url_suffix: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    voltage: Maybe<Scalars["String"]["output"]>;
    /**
     * An array of websites in which the product is available.
     * @deprecated The field should not be used on the storefront.
     */
    websites: Maybe<Array<Maybe<IWebsite>>>;
    /** The weight of the item, in units defined by the store. */
    weight: Maybe<Scalars["Float"]["output"]>;
  };

/** Defines a simple product, which is tangible and is usually sold in single units or in fixed quantities. */
export type ISimpleProductCustom_AttributesV2Args = {
  filters: InputMaybe<IAttributeFilterInput>;
};

/** Defines a simple product, which is tangible and is usually sold in single units or in fixed quantities. */
export type ISimpleProductReviewsArgs = {
  currentPage?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Defines a single product to add to the cart. */
export type ISimpleProductCartItemInput = {
  /** An array that defines customizable options for the product. */
  customizable_options: InputMaybe<Array<InputMaybe<ICustomizableOptionInput>>>;
  /** An object containing the `sku`, `quantity`, and other relevant information about the product. */
  data: ICartItemInput;
};

/** Contains a simple product wish list item. */
export type ISimpleWishlistItem = IWishlistItemInterface & {
  /** The date and time the item was added to the wish list. */
  added_at: Scalars["String"]["output"];
  /** Custom options selected for the wish list item. */
  customizable_options: Array<Maybe<ISelectedCustomizableOption>>;
  /** The description of the item. */
  description: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `WishlistItemInterface` object. */
  id: Scalars["ID"]["output"];
  /** Product details of the wish list item. */
  product: Maybe<IProductInterface>;
  /** The quantity of this wish list item. */
  quantity: Scalars["Float"]["output"];
};

/** Smart button payment inputs */
export type ISmartButtonMethodInput = {
  /** The payment source for the payment method */
  payment_source: InputMaybe<Scalars["String"]["input"]>;
  /** The payment services order ID */
  payments_order_id: InputMaybe<Scalars["String"]["input"]>;
  /** PayPal order ID */
  paypal_order_id: InputMaybe<Scalars["String"]["input"]>;
};

export type ISmartButtonsConfig = IPaymentConfigItem & {
  /** Indicated whether to use App Switch on enabled mobile devices */
  app_switch_when_available: Maybe<Scalars["Boolean"]["output"]>;
  /** The styles for the PayPal Smart Button configuration */
  button_styles: Maybe<IButtonStyles>;
  /** The payment method code as defined in the payment gateway */
  code: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether to display the PayPal Pay Later message */
  display_message: Maybe<Scalars["Boolean"]["output"]>;
  /** Indicates whether to display Venmo */
  display_venmo: Maybe<Scalars["Boolean"]["output"]>;
  /** Indicates whether the payment method is displayed */
  is_visible: Maybe<Scalars["Boolean"]["output"]>;
  /** Contains details about the styles for the PayPal Pay Later message */
  message_styles: Maybe<IMessageStyles>;
  /** Defines the payment intent (Authorize or Capture */
  payment_intent: Maybe<Scalars["String"]["output"]>;
  /** The PayPal parameters required to load the JS SDK */
  sdk_params: Maybe<Array<Maybe<ISdkParams>>>;
  /** The relative order the payment method is displayed on the checkout page */
  sort_order: Maybe<Scalars["String"]["output"]>;
  /** The name displayed for the payment method */
  title: Maybe<Scalars["String"]["output"]>;
};

/** Indicates whether to return results in ascending or descending order. */
export enum ISortEnum {
  Asc = "ASC",
  Desc = "DESC",
}

/** Defines a possible sort field. */
export type ISortField = {
  /** The label of the sort field. */
  label: Maybe<Scalars["String"]["output"]>;
  /** The attribute code of the sort field. */
  value: Maybe<Scalars["String"]["output"]>;
};

/** Contains a default value for sort fields and all available sort fields. */
export type ISortFields = {
  /** The default sort field value. */
  default: Maybe<Scalars["String"]["output"]>;
  /** An array of possible sort fields. */
  options: Maybe<Array<Maybe<ISortField>>>;
};

/** Specifies the field to use for sorting quote items */
export enum ISortQuoteItemsEnum {
  BaseDiscountAmount = "BASE_DISCOUNT_AMOUNT",
  BaseDiscountTaxCompensationAmount = "BASE_DISCOUNT_TAX_COMPENSATION_AMOUNT",
  BasePrice = "BASE_PRICE",
  BasePriceIncTax = "BASE_PRICE_INC_TAX",
  BaseRowTotal = "BASE_ROW_TOTAL",
  BaseRowTotalIncTax = "BASE_ROW_TOTAL_INC_TAX",
  BaseTaxAmount = "BASE_TAX_AMOUNT",
  BaseTaxBeforeDiscount = "BASE_TAX_BEFORE_DISCOUNT",
  CreatedAt = "CREATED_AT",
  CustomPrice = "CUSTOM_PRICE",
  Description = "DESCRIPTION",
  DiscountAmount = "DISCOUNT_AMOUNT",
  DiscountPercent = "DISCOUNT_PERCENT",
  DiscountTaxCompensationAmount = "DISCOUNT_TAX_COMPENSATION_AMOUNT",
  FreeShipping = "FREE_SHIPPING",
  ItemId = "ITEM_ID",
  Name = "NAME",
  OriginalCustomPrice = "ORIGINAL_CUSTOM_PRICE",
  Price = "PRICE",
  PriceIncTax = "PRICE_INC_TAX",
  ProductId = "PRODUCT_ID",
  ProductType = "PRODUCT_TYPE",
  Qty = "QTY",
  RowTotal = "ROW_TOTAL",
  RowTotalIncTax = "ROW_TOTAL_INC_TAX",
  RowTotalWithDiscount = "ROW_TOTAL_WITH_DISCOUNT",
  RowWeight = "ROW_WEIGHT",
  Sku = "SKU",
  TaxAmount = "TAX_AMOUNT",
  TaxBeforeDiscount = "TAX_BEFORE_DISCOUNT",
  TaxPercent = "TAX_PERCENT",
  UpdatedAt = "UPDATED_AT",
  Weight = "WEIGHT",
}

export type ISpecialOffer = {
  /** Promotional Campaign changeable code/indentifier */
  code: Scalars["String"]["output"];
  /** Promotional Campaign description type */
  description: Maybe<ISpecialOfferDescription>;
  /** Promotional Campaign can be used by customer or not */
  eligible: Scalars["Boolean"]["output"];
  /** Maximum uses per user */
  limit_qty: Maybe<Scalars["Int"]["output"]>;
  /** Promotional Campaign can be POTENTIALLY used by customer or not */
  potentially_eligible: Scalars["Boolean"]["output"];
  /** Promotional Campaign applicable products */
  skus: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  /** Promotion type */
  type: ISpecialOfferTypeEnum;
};

export type ISpecialOfferDescription = {
  /** Promotional Campaign description */
  description: Maybe<Scalars["String"]["output"]>;
  /** Promotional Campaign hint */
  hint: Maybe<Scalars["String"]["output"]>;
  /** Promotional Campaign label */
  label: Maybe<Scalars["String"]["output"]>;
  /** Promotional Campaign title */
  title: Maybe<Scalars["String"]["output"]>;
};

export type ISpecialOfferList = {
  /** List of promotional campaigns */
  items: Maybe<Array<Maybe<ISpecialOffer>>>;
};

export enum ISpecialOfferTypeEnum {
  ConditionalPurchase = "conditional_purchase",
  FreeGiftFixed = "free_gift_fixed",
  FreeGiftFlexible = "free_gift_flexible",
}

export type IStatusReason = {
  reason_code: Scalars["String"]["output"];
  reason_message: Scalars["String"]["output"];
};

export type IStick = {
  /** Flavour attribute ID. */
  flavour: Maybe<Scalars["Int"]["output"]>;
  /** Flavour attribute label. */
  flavour_label: Maybe<Scalars["String"]["output"]>;
  /** The SKU of the stick product. */
  sku: Maybe<Scalars["String"]["output"]>;
  /** The Color Swatch Data in Hex of the stick product. */
  swatch_data: Maybe<Scalars["String"]["output"]>;
};

export type ISticksMatrix = {
  /** Carton configuration. */
  cartons: ISticksPeriod;
  /** Mix-n-match configuration. */
  mix_n_match: ISticksPeriod;
  /** Single packs configuration. */
  single_packs: ISticksPeriod;
};

export type ISticksPeriod = {
  /** Onetime sticks configuration. */
  onetime: Array<Maybe<IStick>>;
  /** Subscription sticks configuration. */
  subscription: Array<Maybe<IStick>>;
};

/** Contains information about a store's configuration. */
export type IStoreConfig = {
  /** Contains scripts that must be included in the HTML before the closing `<body>` tag. */
  absolute_footer: Maybe<Scalars["String"]["output"]>;
  /** Configured age verification journey mode */
  age_verification_mode: IAgeVerificationMode;
  /** If allowed empty firstname */
  allow_empty_firstname: Maybe<Scalars["Boolean"]["output"]>;
  /** Indicates if the gift sender has the option to send a gift receipt. Possible values: 1 (Yes) and 0 (No). */
  allow_gift_receipt: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether gift wrapping can be added for the entire order. Possible values: 1 (Yes) and 0 (No). */
  allow_gift_wrapping_on_order: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether gift wrapping can be added for individual order items. Possible values: 1 (Yes) and 0 (No). */
  allow_gift_wrapping_on_order_items: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether guest users can write product reviews. Possible values: 1 (Yes) and 0 (No). */
  allow_guests_to_write_product_reviews: Maybe<Scalars["String"]["output"]>;
  /** The value of the Allow Gift Messages for Order Items option */
  allow_items: Maybe<Scalars["String"]["output"]>;
  /** The value of the Allow Gift Messages on Order Level option */
  allow_order: Maybe<Scalars["String"]["output"]>;
  /** Indicates if a printed card can accompany an order. Possible values: 1 (Yes) and 0 (No). */
  allow_printed_card: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether to enable autocomplete on login and forgot password forms. */
  autocomplete_on_storefront: Maybe<Scalars["Boolean"]["output"]>;
  /** The base currency code. */
  base_currency_code: Maybe<Scalars["String"]["output"]>;
  /** A fully-qualified URL that is used to create relative links to the `base_url`. */
  base_link_url: Maybe<Scalars["String"]["output"]>;
  /** The fully-qualified URL that specifies the location of media files. */
  base_media_url: Maybe<Scalars["String"]["output"]>;
  /** The fully-qualified URL that specifies the location of static view files. */
  base_static_url: Maybe<Scalars["String"]["output"]>;
  /** The store’s fully-qualified base URL. */
  base_url: Maybe<Scalars["String"]["output"]>;
  /** checkout/cart/delete_quote_after: quote lifetime in days. */
  cart_expires_in_days: Maybe<Scalars["Int"]["output"]>;
  /** Indicates if gift wrapping prices are displayed on the Shopping Cart page. Possible values: 1 (Yes) and 0 (No). */
  cart_gift_wrapping: Maybe<Scalars["String"]["output"]>;
  /** Indicates if printed card prices are displayed on the Shopping Cart page. Possible values: 1 (Yes) and 0 (No). */
  cart_printed_card: Maybe<Scalars["String"]["output"]>;
  /** checkout/cart_link/use_qty: what to show in the display cart summary, number of items or item quantities. */
  cart_summary_display_quantity: Maybe<Scalars["Int"]["output"]>;
  /** Cartons limit value */
  cartons_limit_value: Maybe<Scalars["Int"]["output"]>;
  /** The default sort order of the search results list. */
  catalog_default_sort_by: Maybe<Scalars["String"]["output"]>;
  /** Corresponds to the 'Display Prices In Product Lists' field in the Admin. It indicates how FPT information is displayed on category pages. */
  category_fixed_product_tax_display_setting: Maybe<IFixedProductTaxDisplaySettings>;
  /** The suffix applied to category pages, such as `.htm` or `.html`. */
  category_url_suffix: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether only specific countries can use this payment method. */
  check_money_order_enable_for_specific_countries: Maybe<Scalars["Boolean"]["output"]>;
  /** Indicates whether the Check/Money Order payment method is enabled. */
  check_money_order_enabled: Maybe<Scalars["Boolean"]["output"]>;
  /** The name of the party to whom the check must be payable. */
  check_money_order_make_check_payable_to: Maybe<Scalars["String"]["output"]>;
  /** The maximum order amount required to qualify for the Check/Money Order payment method. */
  check_money_order_max_order_total: Maybe<Scalars["String"]["output"]>;
  /** The minimum order amount required to qualify for the Check/Money Order payment method. */
  check_money_order_min_order_total: Maybe<Scalars["String"]["output"]>;
  /** The status of new orders placed using the Check/Money Order payment method. */
  check_money_order_new_order_status: Maybe<Scalars["String"]["output"]>;
  /** A comma-separated list of specific countries allowed to use the Check/Money Order payment method. */
  check_money_order_payment_from_specific_countries: Maybe<Scalars["String"]["output"]>;
  /** The full street address or PO Box where the checks are mailed. */
  check_money_order_send_check_to: Maybe<Scalars["String"]["output"]>;
  /** A number indicating the position of the Check/Money Order payment method in the list of available payment methods during checkout. */
  check_money_order_sort_order: Maybe<Scalars["Int"]["output"]>;
  /** The title of the Check/Money Order payment method displayed on the storefront. */
  check_money_order_title: Maybe<Scalars["String"]["output"]>;
  /** The name of the CMS page that identifies the home page for the store. */
  cms_home_page: Maybe<Scalars["String"]["output"]>;
  /** A specific CMS page that displays when cookies are not enabled for the browser. */
  cms_no_cookies: Maybe<Scalars["String"]["output"]>;
  /** A specific CMS page that displays when a 404 'Page Not Found' error occurs. */
  cms_no_route: Maybe<Scalars["String"]["output"]>;
  /**
   * A code assigned to the store to identify it.
   * @deprecated Use `store_code` instead.
   */
  code: Maybe<Scalars["String"]["output"]>;
  /** checkout/cart/configurable_product_image: which image to use for configurable products. */
  configurable_product_image: IProductImageThumbnail;
  /** Indicates whether the `parent` or child (`itself`) thumbnail should be used in the cart for configurable products. */
  configurable_thumbnail_source: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether the Contact Us form in enabled. */
  contact_enabled: Scalars["Boolean"]["output"];
  /** The copyright statement that appears at the bottom of each page. */
  copyright: Maybe<Scalars["String"]["output"]>;
  /** Extended Config Data - general/region/state_required */
  countries_with_required_region: Maybe<Scalars["String"]["output"]>;
  /** Indicates if the new accounts need confirmation. */
  create_account_confirmation: Maybe<Scalars["Boolean"]["output"]>;
  /** Query by creditmemo_creditmemo_enabled. */
  creditmemo_creditmemo_enabled: Maybe<Scalars["String"]["output"]>;
  /** Customer access token lifetime. */
  customer_access_token_lifetime: Maybe<Scalars["Float"]["output"]>;
  /** Extended Config Data - general/country/default */
  default_country: Maybe<Scalars["String"]["output"]>;
  /** The description that provides a summary of your site for search engine listings. It should not be more than 160 characters in length. */
  default_description: Maybe<Scalars["String"]["output"]>;
  /** The default display currency code. */
  default_display_currency_code: Maybe<Scalars["String"]["output"]>;
  /** A series of keywords that describe your store, each separated by a comma. */
  default_keywords: Maybe<Scalars["String"]["output"]>;
  /** The title that appears at the title bar of each page when viewed in a browser. */
  default_title: Maybe<Scalars["String"]["output"]>;
  /** Controls the display of the demo store notice at the top of the page. Options: 0 (No) or 1 (Yes). */
  demonotice: Maybe<Scalars["Int"]["output"]>;
  /** Configuration data from tax/display/type */
  display_product_prices_in_catalog: Scalars["Int"]["output"];
  /** Configuration data from tax/display/shipping */
  display_shipping_prices: Scalars["Int"]["output"];
  /** Extended Config Data - general/region/display_all */
  display_state_if_optional: Maybe<Scalars["Boolean"]["output"]>;
  /** Indicates whether customers can have multiple wish lists. Possible values: 1 (Yes) and 0 (No). */
  enable_multiple_wishlists: Maybe<Scalars["String"]["output"]>;
  /** Configuration data from tax/weee/apply_vat */
  fixed_product_taxes_apply_tax_to_fpt: Scalars["Boolean"]["output"];
  /** Configuration data from tax/weee/display_email */
  fixed_product_taxes_display_prices_in_emails: Scalars["Int"]["output"];
  /** Configuration data from tax/weee/display_list */
  fixed_product_taxes_display_prices_in_product_lists: Scalars["Int"]["output"];
  /** Configuration data from tax/weee/display_sales */
  fixed_product_taxes_display_prices_in_sales_modules: Scalars["Int"]["output"];
  /** Configuration data from tax/weee/display */
  fixed_product_taxes_display_prices_on_product_view_page: Scalars["Int"]["output"];
  /** Configuration data from tax/weee/enable */
  fixed_product_taxes_enable: Scalars["Boolean"]["output"];
  /** Configuration data from tax/weee/include_in_subtotal */
  fixed_product_taxes_include_fpt_in_subtotal: Scalars["Boolean"]["output"];
  /** The landing page that is associated with the base URL. */
  front: Maybe<Scalars["String"]["output"]>;
  /** Provides total amount of gifts in the basket */
  gift_basket_quantity_limitation: Maybe<Scalars["String"]["output"]>;
  /** The default number of products per page in Grid View. */
  grid_per_page: Maybe<Scalars["Int"]["output"]>;
  /** A list of numbers that define how many products can be displayed in Grid View. */
  grid_per_page_values: Maybe<Scalars["String"]["output"]>;
  /** checkout/cart/grouped_product_image: which image to use for grouped products. */
  grouped_product_image: IProductImageThumbnail;
  /** Scripts that must be included in the HTML before the closing `<head>` tag. */
  head_includes: Maybe<Scalars["String"]["output"]>;
  /** The small graphic image (favicon) that appears in the address bar and tab of the browser. */
  head_shortcut_icon: Maybe<Scalars["String"]["output"]>;
  /** The path to the logo that appears in the header. */
  header_logo_src: Maybe<Scalars["String"]["output"]>;
  /**
   * The ID number assigned to the store.
   * @deprecated Use `store_code` instead.
   */
  id: Maybe<Scalars["Int"]["output"]>;
  /** Is 2FA verification module enabled */
  is_2fa_verification_enabled: Maybe<Scalars["Boolean"]["output"]>;
  /** Is 2FA verification logging enabled */
  is_2fa_verification_logging_enabled: Maybe<Scalars["Boolean"]["output"]>;
  /** Whether cart-level age verification is enabled */
  is_age_verification_enabled: Maybe<Scalars["Boolean"]["output"]>;
  /** Is age verification logging enabled */
  is_age_verification_logging_enabled: Maybe<Scalars["Boolean"]["output"]>;
  /** Configuration data from checkout/options/enable_agreements */
  is_checkout_agreements_enabled: Scalars["Boolean"]["output"];
  /** Is order filtering enabled in customer area */
  is_customer_area_order_filtering_enabled: Maybe<Scalars["Boolean"]["output"]>;
  /** Indicates whether the store view has been designated as the default within the store group. */
  is_default_store: Maybe<Scalars["Boolean"]["output"]>;
  /** Indicates whether the store group has been designated as the default within the website. */
  is_default_store_group: Maybe<Scalars["Boolean"]["output"]>;
  /** Provides the flag to show if gifts are enabled or not */
  is_free_gifts_enabled: Maybe<Scalars["Boolean"]["output"]>;
  /** checkout/options/guest_checkout: whether the guest checkout is enabled or not. */
  is_guest_checkout_enabled: Maybe<Scalars["Boolean"]["output"]>;
  /** checkout/options/onepage_checkout_enabled: whether the one page checkout is enabled or not */
  is_one_page_checkout_enabled: Maybe<Scalars["Boolean"]["output"]>;
  /** Is order limit module enabled */
  is_order_limit_enabled: Maybe<Scalars["Boolean"]["output"]>;
  /** Is order value limit enabled */
  is_order_value_limit_enabled: Maybe<Scalars["Boolean"]["output"]>;
  /** The format of the search results list. */
  list_mode: Maybe<Scalars["String"]["output"]>;
  /** The default number of products per page in List View. */
  list_per_page: Maybe<Scalars["Int"]["output"]>;
  /** A list of numbers that define how many products can be displayed in List View. */
  list_per_page_values: Maybe<Scalars["String"]["output"]>;
  /** The store locale. */
  locale: Maybe<Scalars["String"]["output"]>;
  /** The Alt text that is associated with the logo. */
  logo_alt: Maybe<Scalars["String"]["output"]>;
  /** The height of the logo image, in pixels. */
  logo_height: Maybe<Scalars["Int"]["output"]>;
  /** The width of the logo image, in pixels. */
  logo_width: Maybe<Scalars["Int"]["output"]>;
  /** Indicates whether reward points functionality is enabled. Possible values: 1 (Enabled) and 0 (Disabled). */
  magento_reward_general_is_enabled: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether reward points functionality is enabled on the storefront. Possible values: 1 (Enabled) and 0 (Disabled). */
  magento_reward_general_is_enabled_on_front: Maybe<Scalars["String"]["output"]>;
  /** The minimum point balance customers must have before they can redeem them. A null value indicates no minimum. */
  magento_reward_general_min_points_balance: Maybe<Scalars["String"]["output"]>;
  /** When enabled, customers can see a detailed history of their reward points. Possible values: 1 (Enabled) and 0 (Disabled). */
  magento_reward_general_publish_history: Maybe<Scalars["String"]["output"]>;
  /** The number of points for a referral when an invitee registers on the site. */
  magento_reward_points_invitation_customer: Maybe<Scalars["String"]["output"]>;
  /** The maximum number of registration referrals that will qualify for rewards. A null value indicates no limit. */
  magento_reward_points_invitation_customer_limit: Maybe<Scalars["String"]["output"]>;
  /** The number of points for a referral, when an invitee places their first order on the site. */
  magento_reward_points_invitation_order: Maybe<Scalars["String"]["output"]>;
  /** The number of order conversions that can earn points for the customer who sends the invitation. A null value indicates no limit. */
  magento_reward_points_invitation_order_limit: Maybe<Scalars["String"]["output"]>;
  /** The number of points earned by registered customers who subscribe to a newsletter. */
  magento_reward_points_newsletter: Maybe<Scalars["String"]["output"]>;
  /** Indicates customers earn points for shopping according to the reward point exchange rate. In Luma, this also controls whether to show a message in the shopping cart about the rewards points earned for the purchase, as well as the customer’s current reward point balance. */
  magento_reward_points_order: Maybe<Scalars["String"]["output"]>;
  /** The number of points customer gets for registering. */
  magento_reward_points_register: Maybe<Scalars["String"]["output"]>;
  /** The number of points for writing a review. */
  magento_reward_points_review: Maybe<Scalars["String"]["output"]>;
  /** The maximum number of reviews that will qualify for the rewards. A null value indicates no limit. */
  magento_reward_points_review_limit: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether wishlists are enabled (1) or disabled (0). */
  magento_wishlist_general_is_enabled: Maybe<Scalars["String"]["output"]>;
  /** checkout/options/max_items_display_count: maximum number of items to display in order summary. */
  max_items_in_order_summary: Maybe<Scalars["Int"]["output"]>;
  /** If multiple wish lists are enabled, the maximum number of wish lists the customer can have. */
  maximum_number_of_wishlists: Maybe<Scalars["String"]["output"]>;
  /** checkout/sidebar/display: whether to display the minicart or not. */
  minicart_display: Maybe<Scalars["Boolean"]["output"]>;
  /** checkout/sidebar/count: maximum number of items to show in minicart. */
  minicart_max_items: Maybe<Scalars["Int"]["output"]>;
  /** The minimum number of characters required for a valid password. */
  minimum_password_length: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether newsletters are enabled. */
  newsletter_enabled: Scalars["Boolean"]["output"];
  /** The default page that displays when a 404 'Page not Found' error occurs. */
  no_route: Maybe<Scalars["String"]["output"]>;
  /** Extended Config Data - general/country/optional_zip_countries */
  optional_zip_countries: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether orders can be cancelled by customers or not. */
  order_cancellation_enabled: Scalars["Boolean"]["output"];
  /** An array containing available cancellation reasons. */
  order_cancellation_reasons: Array<Maybe<ICancellationReason>>;
  /** Order limit value */
  order_limit_value: Maybe<Scalars["Float"]["output"]>;
  /** Configuration data from tax/sales_display/full_summary */
  orders_invoices_credit_memos_display_full_summary: Scalars["Boolean"]["output"];
  /** Configuration data from tax/sales_display/grandtotal */
  orders_invoices_credit_memos_display_grandtotal: Scalars["Boolean"]["output"];
  /** Configuration data from tax/sales_display/price */
  orders_invoices_credit_memos_display_price: Scalars["Int"]["output"];
  /** Configuration data from tax/sales_display/shipping */
  orders_invoices_credit_memos_display_shipping_amount: Scalars["Int"]["output"];
  /** Configuration data from tax/sales_display/subtotal */
  orders_invoices_credit_memos_display_subtotal: Scalars["Int"]["output"];
  /** Configuration data from tax/sales_display/zero_tax */
  orders_invoices_credit_memos_display_zero_tax: Scalars["Boolean"]["output"];
  /** Payflow Pro vault status. */
  payment_payflowpro_cc_vault_active: Maybe<Scalars["String"]["output"]>;
  /** Is postcode required / mandatory */
  postcode_is_required: Maybe<Scalars["Boolean"]["output"]>;
  /** Postcode max value length */
  postcode_max_length: Maybe<Scalars["Int"]["output"]>;
  /** Postcode min value length */
  postcode_min_length: Maybe<Scalars["Int"]["output"]>;
  /** Postcode regex pattern validate */
  postcode_validate_regex: Maybe<Scalars["String"]["output"]>;
  /** Is postcode validation enabled */
  postcode_validation_enabled: Maybe<Scalars["Boolean"]["output"]>;
  /**
   * The default price of a printed card that accompanies an order.
   * @deprecated Use printed_card_priceV2 instead
   */
  printed_card_price: Maybe<Scalars["String"]["output"]>;
  /** The default price of a printed card that accompanies an order. */
  printed_card_priceV2: Maybe<IMoney>;
  /** Corresponds to the 'Display Prices On Product View Page' field in the Admin. It indicates how FPT information is displayed on product pages. */
  product_fixed_product_tax_display_setting: Maybe<IFixedProductTaxDisplaySettings>;
  /** Indicates whether product reviews are enabled. Possible values: 1 (Yes) and 0 (No). */
  product_reviews_enabled: Maybe<Scalars["String"]["output"]>;
  /** The suffix applied to product pages, such as `.htm` or `.html`. */
  product_url_suffix: Maybe<Scalars["String"]["output"]>;
  /** The number of different character classes (lowercase, uppercase, digits, special characters) required in a password. */
  required_character_classes_number: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether RMA is enabled on the storefront. Possible values: enabled/disabled. */
  returns_enabled: Scalars["String"]["output"];
  /**
   * The ID of the root category.
   * @deprecated Use `root_category_uid` instead.
   */
  root_category_id: Maybe<Scalars["Int"]["output"]>;
  /** The unique ID for a `CategoryInterface` object. */
  root_category_uid: Maybe<Scalars["ID"]["output"]>;
  /** Corresponds to the 'Display Prices In Sales Modules' field in the Admin. It indicates how FPT information is displayed on cart, checkout, and order pages. */
  sales_fixed_product_tax_display_setting: Maybe<IFixedProductTaxDisplaySettings>;
  /** Indicates if gift wrapping prices are displayed on the Orders page. Possible values: 1 (Yes) and 0 (No). */
  sales_gift_wrapping: Maybe<Scalars["String"]["output"]>;
  /** Indicates if printed card prices are displayed on the Orders page. Possible values: 1 (Yes) and 0 (No). */
  sales_printed_card: Maybe<Scalars["String"]["output"]>;
  /** A secure fully-qualified URL that is used to create relative links to the `base_url`. */
  secure_base_link_url: Maybe<Scalars["String"]["output"]>;
  /** The secure fully-qualified URL that specifies the location of media files. */
  secure_base_media_url: Maybe<Scalars["String"]["output"]>;
  /** The secure fully-qualified URL that specifies the location of static view files. */
  secure_base_static_url: Maybe<Scalars["String"]["output"]>;
  /** The store’s fully-qualified secure base URL. */
  secure_base_url: Maybe<Scalars["String"]["output"]>;
  /** Email to a Friend configuration. */
  send_friend: Maybe<ISendFriendConfiguration>;
  /** Extended Config Data - tax/cart_display/full_summary */
  shopping_cart_display_full_summary: Maybe<Scalars["Boolean"]["output"]>;
  /** Extended Config Data - tax/cart_display/grandtotal */
  shopping_cart_display_grand_total: Maybe<Scalars["Boolean"]["output"]>;
  /** Extended Config Data - tax/cart_display/price */
  shopping_cart_display_price: Maybe<Scalars["Int"]["output"]>;
  /** Extended Config Data - tax/cart_display/shipping */
  shopping_cart_display_shipping: Maybe<Scalars["Int"]["output"]>;
  /** Extended Config Data - tax/cart_display/subtotal */
  shopping_cart_display_subtotal: Maybe<Scalars["Int"]["output"]>;
  /** Extended Config Data - tax/cart_display/gift_wrapping */
  shopping_cart_display_tax_gift_wrapping: Maybe<ITaxWrappingEnum>;
  /** Extended Config Data - tax/cart_display/zero_tax */
  shopping_cart_display_zero_tax: Maybe<Scalars["Boolean"]["output"]>;
  /** Indicates whether a breadcrumb trail appears on all CMS pages in the catalog. 0 (No) or 1 (Yes). */
  show_cms_breadcrumbs: Maybe<Scalars["Int"]["output"]>;
  /** The unique ID of the store view. In the Admin, this is called the Store View Code. When making a GraphQL call, assign this value to the `Store` header to provide the scope. */
  store_code: Maybe<Scalars["ID"]["output"]>;
  /** The unique ID assigned to the store group. In the Admin, this is called the Store Name. */
  store_group_code: Maybe<Scalars["ID"]["output"]>;
  /** The label assigned to the store group. */
  store_group_name: Maybe<Scalars["String"]["output"]>;
  /** The label assigned to the store view. */
  store_name: Maybe<Scalars["String"]["output"]>;
  /** The store view sort order. */
  store_sort_order: Maybe<Scalars["Int"]["output"]>;
  /** The time zone of the store. */
  timezone: Maybe<Scalars["String"]["output"]>;
  /** A prefix that appears before the title to create a two- or three-part title. */
  title_prefix: Maybe<Scalars["String"]["output"]>;
  /** The character that separates the category name and subcategory in the browser title bar. */
  title_separator: Maybe<Scalars["String"]["output"]>;
  /** A suffix that appears after the title to create a two- or three-part title. */
  title_suffix: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether the store code should be used in the URL. */
  use_store_in_url: Maybe<Scalars["Boolean"]["output"]>;
  /** Is postcode region validation enabled */
  validate_region: Maybe<Scalars["Boolean"]["output"]>;
  /** The unique ID for the website. */
  website_code: Maybe<Scalars["ID"]["output"]>;
  /**
   * The ID number assigned to the website store.
   * @deprecated The field should not be used on the storefront.
   */
  website_id: Maybe<Scalars["Int"]["output"]>;
  /** The label assigned to the website. */
  website_name: Maybe<Scalars["String"]["output"]>;
  /** The unit of weight. */
  weight_unit: Maybe<Scalars["String"]["output"]>;
  /** Text that appears in the header of the page and includes the name of the logged in customer. */
  welcome: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether only specific countries can use this payment method. */
  zero_subtotal_enable_for_specific_countries: Maybe<Scalars["Boolean"]["output"]>;
  /** Indicates whether the Zero Subtotal payment method is enabled. */
  zero_subtotal_enabled: Maybe<Scalars["Boolean"]["output"]>;
  /** The status of new orders placed using the Zero Subtotal payment method. */
  zero_subtotal_new_order_status: Maybe<Scalars["String"]["output"]>;
  /** When the new order status is 'Processing', this can be set to `authorize_capture` to automatically invoice all items that have a zero balance. */
  zero_subtotal_payment_action: Maybe<Scalars["String"]["output"]>;
  /** A comma-separated list of specific countries allowed to use the Zero Subtotal payment method. */
  zero_subtotal_payment_from_specific_countries: Maybe<Scalars["String"]["output"]>;
  /** A number indicating the position of the Zero Subtotal payment method in the list of available payment methods during checkout. */
  zero_subtotal_sort_order: Maybe<Scalars["Int"]["output"]>;
  /** The title of the Zero Subtotal payment method displayed on the storefront. */
  zero_subtotal_title: Maybe<Scalars["String"]["output"]>;
};

/** Indicates where an attribute can be displayed. */
export type IStorefrontProperties = {
  /** The relative position of the attribute in the layered navigation block. */
  position: Maybe<Scalars["Int"]["output"]>;
  /** Indicates whether the attribute is filterable with results, without results, or not at all. */
  use_in_layered_navigation: Maybe<IUseInLayeredNavigationOptions>;
  /** Indicates whether the attribute is displayed in product listings. */
  use_in_product_listing: Maybe<Scalars["Boolean"]["output"]>;
  /** Indicates whether the attribute can be used in layered navigation on search results pages. */
  use_in_search_results_layered_navigation: Maybe<Scalars["Boolean"]["output"]>;
  /** Indicates whether the attribute is displayed on product pages. */
  visible_on_catalog_pages: Maybe<Scalars["Boolean"]["output"]>;
};

export type IStrengthDetails = {
  /** Strength level. */
  level: Scalars["String"]["output"];
  /** Strength label. */
  name: Scalars["String"]["output"];
  /** Strength rating. */
  rating: Scalars["Int"]["output"];
};

/** Contains the result of the `subscribeEmailToNewsletter` operation. */
export type ISubscribeEmailToNewsletterOutput = {
  /** The status of the subscription request. */
  status: Maybe<ISubscriptionStatusesEnum>;
};

/** Indicates the status of the request. */
export enum ISubscriptionStatusesEnum {
  NotActive = "NOT_ACTIVE",
  Subscribed = "SUBSCRIBED",
  Unconfirmed = "UNCONFIRMED",
  Unsubscribed = "UNSUBSCRIBED",
}

/** Describes the swatch type and a value. */
export type ISwatchData = {
  /** The type of swatch filter item: 1 - text; 2 - image. */
  type: Maybe<Scalars["String"]["output"]>;
  /** The value for the swatch item. It could be text or an image link. */
  value: Maybe<Scalars["String"]["output"]>;
};

export type ISwatchDataInterface = {
  /** The value can be represented as color (HEX code), image link, or text. */
  value: Maybe<Scalars["String"]["output"]>;
};

/** Swatch attribute metadata input types. */
export enum ISwatchInputTypeEnum {
  Boolean = "BOOLEAN",
  Date = "DATE",
  Datetime = "DATETIME",
  Dropdown = "DROPDOWN",
  File = "FILE",
  Gallery = "GALLERY",
  Hidden = "HIDDEN",
  Image = "IMAGE",
  MediaImage = "MEDIA_IMAGE",
  Multiline = "MULTILINE",
  Multiselect = "MULTISELECT",
  Price = "PRICE",
  Select = "SELECT",
  Text = "TEXT",
  Textarea = "TEXTAREA",
  Undefined = "UNDEFINED",
  Visual = "VISUAL",
  Weight = "WEIGHT",
}

export type ISwatchLayerFilterItem = ILayerFilterItemInterface &
  ISwatchLayerFilterItemInterface & {
    /**
     * The count of items per filter.
     * @deprecated Use `AggregationOption.count` instead.
     */
    items_count: Maybe<Scalars["Int"]["output"]>;
    /**
     * The label for a filter.
     * @deprecated Use `AggregationOption.label` instead.
     */
    label: Maybe<Scalars["String"]["output"]>;
    /** Data required to render a swatch filter item. */
    swatch_data: Maybe<ISwatchData>;
    /**
     * The value of a filter request variable to be used in query.
     * @deprecated Use `AggregationOption.value` instead.
     */
    value_string: Maybe<Scalars["String"]["output"]>;
  };

export type ISwatchLayerFilterItemInterface = {
  /** Data required to render a swatch filter item. */
  swatch_data: Maybe<ISwatchData>;
};

/** Synchronizes the payment order details */
export type ISyncPaymentOrderInput = {
  /** The customer cart ID */
  cartId: Scalars["String"]["input"];
  /** PayPal order ID */
  id: Scalars["String"]["input"];
};

/** Contains tax item details. */
export type ITaxItem = {
  /** The amount of tax applied to the item. */
  amount: IMoney;
  /** The rate used to calculate the tax. */
  rate: Scalars["Float"]["output"];
  /** A title that describes the tax. */
  title: Scalars["String"]["output"];
};

export enum ITaxWrappingEnum {
  DisplayExcludingTax = "DISPLAY_EXCLUDING_TAX",
  DisplayIncludingTax = "DISPLAY_INCLUDING_TAX",
  DisplayTypeBoth = "DISPLAY_TYPE_BOTH",
}

export type ITextSwatchData = ISwatchDataInterface & {
  /** The value can be represented as color (HEX code), image link, or text. */
  value: Maybe<Scalars["String"]["output"]>;
};

/** 3D Secure mode. */
export enum IThreeDsMode {
  Off = "OFF",
  ScaAlways = "SCA_ALWAYS",
  ScaWhenRequired = "SCA_WHEN_REQUIRED",
}

/** Defines a price based on the quantity purchased. */
export type ITierPrice = {
  /** The price discount that this tier represents. */
  discount: Maybe<IProductDiscount>;
  /** The price of the product at this tier. */
  final_price: Maybe<IMoney>;
  /** Label of the tier price. */
  label: Maybe<Scalars["String"]["output"]>;
  /** The minimum number of items that must be purchased to qualify for this price tier. */
  quantity: Maybe<Scalars["Float"]["output"]>;
  /** Total_price => final_price * quantity. */
  total_price: Maybe<IMoney>;
};

/** Provides necessary information about the full order trial amounts in the process */
export type ITrialTotals = {
  tax: Maybe<IMoney>;
  total: Maybe<IMoney>;
  total_incl_tax: Maybe<IMoney>;
};

/** Modifies the specified items in the cart. */
export type IUpdateCartItemsInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars["String"]["input"];
  /** An array of items to be updated. */
  cart_items: Array<InputMaybe<ICartItemUpdateInput>>;
};

/** Contains details about the cart after updating items. */
export type IUpdateCartItemsOutput = {
  /** The cart after updating products. */
  cart: ICart;
  /** Contains errors encountered while updating an item to the cart. */
  errors: Array<Maybe<ICartUserInputError>>;
};

/** Defines updates to a `GiftRegistry` object. */
export type IUpdateGiftRegistryInput = {
  /** Additional attributes specified as a code-value pair. Unspecified dynamic attributes are not changed. */
  dynamic_attributes: InputMaybe<Array<InputMaybe<IGiftRegistryDynamicAttributeInput>>>;
  /** The updated name of the event. */
  event_name: InputMaybe<Scalars["String"]["input"]>;
  /** The updated message describing the event. */
  message: InputMaybe<Scalars["String"]["input"]>;
  /** Indicates whether the gift registry is PRIVATE or PUBLIC. */
  privacy_settings: InputMaybe<IGiftRegistryPrivacySettings>;
  /** The updated shipping address for all gift registry items. */
  shipping_address: InputMaybe<IGiftRegistryShippingAddressInput>;
  /** Indicates whether the gift registry is ACTIVE or INACTIVE. */
  status: InputMaybe<IGiftRegistryStatus>;
};

/** Defines updates to an item in a gift registry. */
export type IUpdateGiftRegistryItemInput = {
  /** The unique ID of a `giftRegistryItem` object. */
  gift_registry_item_uid: Scalars["ID"]["input"];
  /** The updated description of the item. */
  note: InputMaybe<Scalars["String"]["input"]>;
  /** The updated quantity of the gift registry item. */
  quantity: Scalars["Float"]["input"];
};

/** Contains the results of a request to update gift registry items. */
export type IUpdateGiftRegistryItemsOutput = {
  /** The gift registry after updating updating items. */
  gift_registry: Maybe<IGiftRegistry>;
};

/** Contains the results of a request to update a gift registry. */
export type IUpdateGiftRegistryOutput = {
  /** The updated gift registry. */
  gift_registry: Maybe<IGiftRegistry>;
};

/** Defines updates to an existing registrant. */
export type IUpdateGiftRegistryRegistrantInput = {
  /** As a result of the update, only the values of provided attributes will be affected. If the attribute is missing in the request, its value will not be changed. */
  dynamic_attributes: InputMaybe<Array<InputMaybe<IGiftRegistryDynamicAttributeInput>>>;
  /** The updated email address of the registrant. */
  email: InputMaybe<Scalars["String"]["input"]>;
  /** The updated first name of the registrant. */
  firstname: InputMaybe<Scalars["String"]["input"]>;
  /** The unique ID of a `giftRegistryRegistrant` object. */
  gift_registry_registrant_uid: Scalars["ID"]["input"];
  /** The updated last name of the registrant. */
  lastname: InputMaybe<Scalars["String"]["input"]>;
};

/** Contains the results a request to update registrants. */
export type IUpdateGiftRegistryRegistrantsOutput = {
  /** The gift registry after updating registrants. */
  gift_registry: Maybe<IGiftRegistry>;
};

export type IUpdatePaymentInput = {
  /** Method code of the payment to be updated */
  method_code: Scalars["String"]["input"];
  /** Order ID for the update action */
  order_id: Scalars["String"]["input"];
};

export type IUpdatePaymentOutput = {
  success: Scalars["Boolean"]["output"];
};

/** Contains the customer's wish list and any errors encountered. */
export type IUpdateProductsInWishlistOutput = {
  /** An array of errors encountered while updating products in a wish list. */
  user_errors: Array<Maybe<IWishListUserInputError>>;
  /** Contains the wish list with all items that were successfully updated. */
  wishlist: IWishlist;
};

/** Contains the name and visibility of an updated wish list. */
export type IUpdateWishlistOutput = {
  /** The wish list name. */
  name: Scalars["String"]["output"];
  /** The unique ID of a `Wishlist` object. */
  uid: Scalars["ID"]["output"];
  /** Indicates whether the wish list is public or private. */
  visibility: IWishlistVisibilityEnum;
};

/** Contains URL rewrite details. */
export type IUrlRewrite = {
  /** An array of request parameters. */
  parameters: Maybe<Array<Maybe<IHttpQueryParameter>>>;
  /** The request URL. */
  url: Maybe<Scalars["String"]["output"]>;
};

/** This enumeration defines the entity type. */
export enum IUrlRewriteEntityTypeEnum {
  Category = "CATEGORY",
  CmsPage = "CMS_PAGE",
  Product = "PRODUCT",
}

/** Defines whether the attribute is filterable in layered navigation. */
export enum IUseInLayeredNavigationOptions {
  FilterableNoResult = "FILTERABLE_NO_RESULT",
  FilterableWithResults = "FILTERABLE_WITH_RESULTS",
  No = "NO",
}

/** Defines a customer attribute validation rule. */
export type IValidationRule = {
  /** Validation rule name applied to a customer attribute. */
  name: Maybe<IValidationRuleEnum>;
  /** Validation rule value. */
  value: Maybe<Scalars["String"]["output"]>;
};

/** List of validation rule names applied to a customer attribute. */
export enum IValidationRuleEnum {
  DateRangeMax = "DATE_RANGE_MAX",
  DateRangeMin = "DATE_RANGE_MIN",
  FileExtensions = "FILE_EXTENSIONS",
  InputValidation = "INPUT_VALIDATION",
  MaxFileSize = "MAX_FILE_SIZE",
  MaxImageHeight = "MAX_IMAGE_HEIGHT",
  MaxImageWidth = "MAX_IMAGE_WIDTH",
  MaxTextLength = "MAX_TEXT_LENGTH",
  MinTextLength = "MIN_TEXT_LENGTH",
}

/** Retrieves the vault configuration */
export type IVaultConfigOutput = {
  /** Credit card vault method configuration */
  credit_card: Maybe<IVaultCreditCardConfig>;
};

export type IVaultCreditCardConfig = {
  /** Is vault enabled */
  is_vault_enabled: Maybe<Scalars["Boolean"]["output"]>;
  /** The parameters required to load the Paypal JS SDK */
  sdk_params: Maybe<Array<Maybe<ISdkParams>>>;
  /** 3DS mode */
  three_ds_mode: Maybe<IThreeDsMode>;
};

/** Vault payment inputs */
export type IVaultMethodInput = {
  /** The payment source for the payment method */
  payment_source: InputMaybe<Scalars["String"]["input"]>;
  /** The payment services order ID */
  payments_order_id: InputMaybe<Scalars["String"]["input"]>;
  /** PayPal order ID */
  paypal_order_id: InputMaybe<Scalars["String"]["input"]>;
  /** The public hash of the token. */
  public_hash: InputMaybe<Scalars["String"]["input"]>;
};

/** The payment source information */
export type IVaultSetupTokenInput = {
  /** The payment source information */
  payment_source: IPaymentSourceInput;
};

/** Contains required input for payment methods with Vault support. */
export type IVaultTokenInput = {
  /** The public hash of the payment token. */
  public_hash: Scalars["String"]["input"];
};

/** An implementation for virtual product cart items. */
export type IVirtualCartItem = ICartItemInterface & {
  /** An array containing customizable options the shopper selected. */
  customizable_options: Array<Maybe<ISelectedCustomizableOption>>;
  /** An array of errors encountered while loading the cart item */
  errors: Maybe<Array<Maybe<ICartItemError>>>;
  /** Provides info regarding the gift added to the basket */
  gift_data: Maybe<IGiftData>;
  /** Provides the flag to show if consent was set or not */
  has_registration_consent: Maybe<Scalars["Boolean"]["output"]>;
  /** @deprecated Use `uid` instead. */
  id: Scalars["String"]["output"];
  /** True if requested quantity is less than available stock, false otherwise. */
  is_available: Scalars["Boolean"]["output"];
  /** Message to display when the product is not available with this selected option. */
  not_available_message: Maybe<Scalars["String"]["output"]>;
  /** Contains details about the price of the item, including taxes and discounts. */
  prices: Maybe<ICartItemPrices>;
  /** Details about an item in the cart. */
  product: IProductInterface;
  /** The quantity of this item in the cart. */
  quantity: Scalars["Float"]["output"];
  /** The unique ID for a `CartItemInterface` object. */
  uid: Scalars["ID"]["output"];
};

/** Defines a virtual product, which is a non-tangible product that does not require shipping and is not kept in inventory. */
export type IVirtualProduct = ICustomizableProductInterface &
  IProductInterface &
  IRoutableInterface & {
    /** @deprecated Use the `custom_attributes` field instead. */
    about_manufacturer: Maybe<Scalars["String"]["output"]>;
    /**
     * The attribute set assigned to the product.
     * @deprecated The field should not be used on the storefront.
     */
    attribute_set_id: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    available_date: Maybe<Scalars["String"]["output"]>;
    /**
     * Whether the product is explicitly available for Mobile App commerce exposure. 1 = eligible, 0 or null = not eligible.
     * @deprecated Use the `custom_attributes` field instead.
     */
    available_for_mobile_app: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    battery: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    buy_cta_pdp: Maybe<Scalars["Int"]["output"]>;
    /** CTA for PDP attribute translated label . */
    buy_cta_pdp_label: Scalars["String"]["output"];
    /** @deprecated Use the `custom_attributes` field instead. */
    buy_cta_plp: Maybe<Scalars["Int"]["output"]>;
    /** CTA for PLP attribute translated label . */
    buy_cta_plp_label: Scalars["String"]["output"];
    /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
    canonical_url: Maybe<Scalars["String"]["output"]>;
    /** The categories assigned to a product. */
    categories: Maybe<Array<Maybe<ICategoryInterface>>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    charging_time: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    color: Maybe<Scalars["Int"]["output"]>;
    /** Color attribute label. */
    color_label: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    connectors: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    connectors_1: Maybe<Scalars["String"]["output"]>;
    /** The product's country of origin. */
    country_of_manufacture: Maybe<Scalars["String"]["output"]>;
    /**
     * Timestamp indicating when the product was created.
     * @deprecated The field should not be used on the storefront.
     */
    created_at: Maybe<Scalars["String"]["output"]>;
    /** An array of cross-sell products. */
    crosssell_products: Maybe<Array<Maybe<IProductInterface>>>;
    /** Product custom attributes. */
    custom_attributesV2: Maybe<IProductCustomAttributes>;
    /** Delivery region this product may be shipped to — `ES` or `IC`, the same vocabulary as the region header and getDeliveryRegions.code. Distinct from `region_code` on address types, which carries a province code. Null when the product carries no region, or its attribute value is not mapped to one; either way the product is undeliverable everywhere. */
    delivery_region_code: Maybe<Scalars["String"]["output"]>;
    /** Detailed information about the product. The value can include simple HTML tags. */
    description: Maybe<IComplexTextValue>;
    /** @deprecated Use the `custom_attributes` field instead. */
    device_dimensions: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    dimensions: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    enable_lifetime_quantity_limit: Maybe<Scalars["Int"]["output"]>;
    /**
     * Is quantity limit enabled for this product
     * @deprecated Use the `custom_attributes` field instead.
     */
    enable_order_quantity_limit: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    experience: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    flavor: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    flavor_family: Maybe<Scalars["String"]["output"]>;
    /** Color attribute label. */
    flavor_label: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    flavour: Maybe<Scalars["Int"]["output"]>;
    /** Get all details for flavour */
    flavour_details: Array<Maybe<IFlavourDetails>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    formula: Maybe<Scalars["Int"]["output"]>;
    /** A list of gift options for the given product */
    free_gifts: Maybe<IFreeGiftProductData>;
    /** Returns all attribute values and labels marked as visible on storefront */
    frontend_attributes: Maybe<Array<Maybe<IFrontendAttribute>>>;
    /** Returns a value indicating gift message availability for the product. */
    gift_message_available: Scalars["Boolean"]["output"];
    /** Returns a value indicating gift wrapping availability for the product. */
    gift_wrapping_available: Scalars["Boolean"]["output"];
    /** Returns value and currency indicating gift wrapping price for the product. */
    gift_wrapping_price: Maybe<IMoney>;
    /** @deprecated Use the `custom_attributes` field instead. */
    has_device: Maybe<Scalars["Int"]["output"]>;
    /** Provides the flag to show if consent is required or not */
    has_registration_consent: Maybe<Scalars["Boolean"]["output"]>;
    /** Product is hidden_sku or not */
    hidden_sku: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * The ID number assigned to the product.
     * @deprecated Use the `uid` field instead.
     */
    id: Maybe<Scalars["Int"]["output"]>;
    /** The relative path to the main image on the product page. */
    image: Maybe<IProductImage>;
    /** @deprecated Use the `custom_attributes` field instead. */
    importer: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    input_terminal: Maybe<Scalars["Int"]["output"]>;
    /** Product discontinued flag */
    is_discontinued: Maybe<Scalars["Boolean"]["output"]>;
    /** Indicates whether the product can be returned. */
    is_returnable: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    jti_brand_matrix: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    jti_category_redirect: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    jti_product_discontinued: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    jti_sku_redirect: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    large_stick_tray: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    lifetime_quantity_limit: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    main_specifications: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    mandatory_positive_consent: Maybe<Scalars["Int"]["output"]>;
    /**
     * A number representing the product's manufacturer.
     * @deprecated Use the `custom_attributes` field instead.
     */
    manufacturer: Maybe<Scalars["Int"]["output"]>;
    /** Product subscription format */
    manufacturer_label: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    material: Maybe<Scalars["String"]["output"]>;
    /** Maximum Qty Allowed in Shopping Cart */
    max_sale_qty: Maybe<Scalars["Float"]["output"]>;
    /** An array of media gallery objects. */
    media_gallery: Maybe<Array<Maybe<IMediaGalleryInterface>>>;
    /**
     * An array of MediaGalleryEntry objects.
     * @deprecated Use `media_gallery` instead.
     */
    media_gallery_entries: Maybe<Array<Maybe<IMediaGalleryEntry>>>;
    /** A brief overview of the product for search results listings, maximum 255 characters. */
    meta_description: Maybe<Scalars["String"]["output"]>;
    /** A comma-separated list of keywords that are visible only to search engines. */
    meta_keyword: Maybe<Scalars["String"]["output"]>;
    /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
    meta_title: Maybe<Scalars["String"]["output"]>;
    /** Minimum Qty Allowed in Shopping Cart */
    min_sale_qty: Maybe<Scalars["Float"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    minimum_amount: Maybe<Scalars["Float"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    minimum_amount_type: Maybe<Scalars["String"]["output"]>;
    /**
     * Multipack description for this product
     * @deprecated Use the `custom_attributes` field instead.
     */
    multipack_description: Maybe<Scalars["String"]["output"]>;
    /** Is multipacks selected enabled for this product */
    multipack_enabled: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * Multipack label for this product
     * @deprecated Use the `custom_attributes` field instead.
     */
    multipack_label: Maybe<Scalars["String"]["output"]>;
    /** Multipack price text for this product */
    multipack_price: Maybe<Scalars["String"]["output"]>;
    /** Multipack Products */
    multipack_products: Maybe<Array<Maybe<IProductInterface>>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    multipacks_enabled: Maybe<Scalars["Int"]["output"]>;
    /** The product name. Customers use this name to identify the product. */
    name: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    name_and_model: Maybe<Scalars["String"]["output"]>;
    /** The beginning date for new product listings, and determines if the product is featured as a new product. */
    new_from_date: Maybe<Scalars["String"]["output"]>;
    /** The end date for new product listings. */
    new_to_date: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    non_trade_in_sku: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    number_of_packs: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    number_of_sticks: Maybe<Scalars["Int"]["output"]>;
    /** Product stock only x left count */
    only_x_left_in_stock: Maybe<Scalars["Float"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    option_grouped_by_brand: Maybe<Scalars["Int"]["output"]>;
    /** An array of options for a customizable product. */
    options: Maybe<Array<Maybe<ICustomizableOptionInterface>>>;
    /** If the product has multiple options, determines where they appear on the product page. */
    options_container: Maybe<Scalars["String"]["output"]>;
    /**
     * Maximum quantity allowed per one order
     * @deprecated Use the `custom_attributes` field instead.
     */
    order_quantity_limit: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    portable_stick_tray: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    pouch_size: Maybe<Scalars["Int"]["output"]>;
    /**
     * Indicates the price of an item.
     * @deprecated Use `price_range` for product price information.
     */
    price: Maybe<IProductPrices>;
    /** The range of prices for the product */
    price_range: IPriceRange;
    /** An array of `TierPrice` objects. */
    price_tiers: Maybe<Array<Maybe<ITierPrice>>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_brand: Maybe<Scalars["String"]["output"]>;
    /** Product Brand Label */
    product_brand_label: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_category: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_category_type: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_color: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_disclaimer: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_family: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    product_generation: Maybe<Scalars["String"]["output"]>;
    /** An array of `ProductLinks` objects. */
    product_links: Maybe<Array<Maybe<IProductLinksInterface>>>;
    /** Get all special offers for a product. */
    promotionalOffers: Array<Maybe<ISpecialOffer>>;
    /** @deprecated Use the `custom_attributes` field instead. */
    province: Maybe<Scalars["String"]["output"]>;
    /** Product provence label for PLP attribute. */
    province_label: Maybe<Scalars["String"]["output"]>;
    /** Amount of available stock */
    quantity: Maybe<Scalars["Float"]["output"]>;
    /** The average of all the ratings given to the product. */
    rating_summary: Scalars["Float"]["output"];
    /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
    redirect_code: Scalars["Int"]["output"];
    /** Redirect category URL path for discontinued product */
    redirect_product_category: Maybe<Scalars["String"]["output"]>;
    /** Redirect product SKU for discontinued product */
    redirect_sku: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    region: Maybe<Scalars["Int"]["output"]>;
    /** Product Region attribute translated label. */
    region_label: Maybe<Scalars["String"]["output"]>;
    /** An array of related products. */
    related_products: Maybe<Array<Maybe<IProductInterface>>>;
    /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
    relative_url: Maybe<Scalars["String"]["output"]>;
    /** The total count of all the reviews given to the product. */
    review_count: Scalars["Int"]["output"];
    /** @deprecated Use the `custom_attributes` field instead. */
    review_eligible: Maybe<Scalars["Int"]["output"]>;
    /** The list of products reviews. */
    reviews: IProductReviews;
    /** A short description of the product. Its use depends on the theme. */
    short_description: Maybe<IComplexTextValue>;
    /** @deprecated Use the `custom_attributes` field instead. */
    size: Maybe<Scalars["String"]["output"]>;
    /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
    sku: Maybe<Scalars["String"]["output"]>;
    /** The relative path to the small image, which is used on catalog pages. */
    small_image: Maybe<IProductImage>;
    /** Get all special offers for a product. */
    specialOffers: Array<Maybe<ISpecialOffer>>;
    /**
     * The beginning date that a product has a special price.
     * @deprecated The field should not be used on the storefront.
     */
    special_from_date: Maybe<Scalars["String"]["output"]>;
    /** The discounted price of the product. */
    special_price: Maybe<Scalars["Float"]["output"]>;
    /** The end date for a product with a special price. */
    special_to_date: Maybe<Scalars["String"]["output"]>;
    /** Indicates whether the product is staged for a future campaign. */
    staged: Scalars["Boolean"]["output"];
    /** @deprecated Use the `custom_attributes` field instead. */
    stick_capability: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    stick_compatibility: Maybe<Scalars["String"]["output"]>;
    /** Stock status of the product */
    stock_status: Maybe<IProductStockStatus>;
    /** @deprecated Use the `custom_attributes` field instead. */
    strength: Maybe<Scalars["Int"]["output"]>;
    /** Get all details for strength */
    strength_details: Maybe<IStrengthDetails>;
    /** @deprecated Use the `custom_attributes` field instead. */
    subscription: Maybe<Scalars["Int"]["output"]>;
    /**
     * Product subscription format
     * @deprecated Use the `custom_attributes` field instead.
     */
    subscription_format: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    subtitle: Maybe<Scalars["String"]["output"]>;
    /** The file name of a swatch image. */
    swatch_image: Maybe<Scalars["String"]["output"]>;
    /** The relative path to the product's thumbnail image. */
    thumbnail: Maybe<IProductImage>;
    /**
     * The price when tier pricing is in effect and the items purchased threshold has been reached.
     * @deprecated Use `price_tiers` for product tier price information.
     */
    tier_price: Maybe<Scalars["Float"]["output"]>;
    /**
     * An array of ProductTierPrices objects.
     * @deprecated Use `price_tiers` for product tier price information.
     */
    tier_prices: Maybe<Array<Maybe<IProductTierPrices>>>;
    /**
     * Product tooltip information
     * @deprecated Use the `custom_attributes` field instead.
     */
    tooltip_info: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    trabka: Maybe<Scalars["String"]["output"]>;
    /**
     * Indicates whether the product is eligible for a trade-in purchase.
     * @deprecated Use the `custom_attributes` field instead.
     */
    trade_in: Scalars["Int"]["output"];
    /**
     * Specific to trial stores, provides information about the finalization sku
     * @deprecated Use the `custom_attributes` field instead.
     */
    trial_finalization_sku: Maybe<Scalars["String"]["output"]>;
    /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
    type: Maybe<IUrlRewriteEntityTypeEnum>;
    /**
     * One of simple, virtual, bundle, downloadable, grouped, or configurable.
     * @deprecated Use `__typename` instead.
     */
    type_id: Maybe<Scalars["String"]["output"]>;
    /** Product Type */
    type_label: Maybe<Scalars["String"]["output"]>;
    /** The unique ID for a `ProductInterface` object. */
    uid: Scalars["ID"]["output"];
    /**
     * Timestamp indicating when the product was updated.
     * @deprecated The field should not be used on the storefront.
     */
    updated_at: Maybe<Scalars["String"]["output"]>;
    /** An array of up-sell products. */
    upsell_products: Maybe<Array<Maybe<IProductInterface>>>;
    /** The part of the URL that identifies the product */
    url_key: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use product's `canonical_url` or url rewrites instead */
    url_path: Maybe<Scalars["String"]["output"]>;
    /** URL rewrites list */
    url_rewrites: Maybe<Array<Maybe<IUrlRewrite>>>;
    /** The part of the product URL that is appended after the url key */
    url_suffix: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the `custom_attributes` field instead. */
    voltage: Maybe<Scalars["String"]["output"]>;
    /**
     * An array of websites in which the product is available.
     * @deprecated The field should not be used on the storefront.
     */
    websites: Maybe<Array<Maybe<IWebsite>>>;
  };

/** Defines a virtual product, which is a non-tangible product that does not require shipping and is not kept in inventory. */
export type IVirtualProductCustom_AttributesV2Args = {
  filters: InputMaybe<IAttributeFilterInput>;
};

/** Defines a virtual product, which is a non-tangible product that does not require shipping and is not kept in inventory. */
export type IVirtualProductReviewsArgs = {
  currentPage?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Defines a single product to add to the cart. */
export type IVirtualProductCartItemInput = {
  /** An array that defines customizable options for the product. */
  customizable_options: InputMaybe<Array<InputMaybe<ICustomizableOptionInput>>>;
  /** An object containing the `sku`, `quantity`, and other relevant information about the product. */
  data: ICartItemInput;
};

/** Contains a virtual product wish list item. */
export type IVirtualWishlistItem = IWishlistItemInterface & {
  /** The date and time the item was added to the wish list. */
  added_at: Scalars["String"]["output"];
  /** Custom options selected for the wish list item. */
  customizable_options: Array<Maybe<ISelectedCustomizableOption>>;
  /** The description of the item. */
  description: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `WishlistItemInterface` object. */
  id: Scalars["ID"]["output"];
  /** Product details of the wish list item. */
  product: Maybe<IProductInterface>;
  /** The quantity of this wish list item. */
  quantity: Scalars["Float"]["output"];
};

/** Deprecated. It should not be used on the storefront. Contains information about a website. */
export type IWebsite = {
  /**
   * A code assigned to the website to identify it.
   * @deprecated The field should not be used on the storefront.
   */
  code: Maybe<Scalars["String"]["output"]>;
  /**
   * The default group ID of the website.
   * @deprecated The field should not be used on the storefront.
   */
  default_group_id: Maybe<Scalars["String"]["output"]>;
  /**
   * The ID number assigned to the website.
   * @deprecated The field should not be used on the storefront.
   */
  id: Maybe<Scalars["Int"]["output"]>;
  /**
   * Indicates whether this is the default website.
   * @deprecated The field should not be used on the storefront.
   */
  is_default: Maybe<Scalars["Boolean"]["output"]>;
  /**
   * The website name. Websites use this name to identify it easier.
   * @deprecated The field should not be used on the storefront.
   */
  name: Maybe<Scalars["String"]["output"]>;
  /**
   * The attribute to use for sorting websites.
   * @deprecated The field should not be used on the storefront.
   */
  sort_order: Maybe<Scalars["Int"]["output"]>;
};

/** An error encountered while performing operations with WishList. */
export type IWishListUserInputError = {
  /** A wish list-specific error code. */
  code: IWishListUserInputErrorType;
  /** A localized error message. */
  message: Scalars["String"]["output"];
};

/** A list of possible error types. */
export enum IWishListUserInputErrorType {
  ProductNotFound = "PRODUCT_NOT_FOUND",
  Undefined = "UNDEFINED",
}

/** Contains a customer wish list. */
export type IWishlist = {
  /** The unique ID for a `Wishlist` object. */
  id: Maybe<Scalars["ID"]["output"]>;
  /** @deprecated Use the `items_v2` field instead. */
  items: Maybe<Array<Maybe<IWishlistItem>>>;
  /** The number of items in the wish list. */
  items_count: Maybe<Scalars["Int"]["output"]>;
  /** An array of items in the customer's wish list. */
  items_v2: Maybe<IWishlistItems>;
  /** The name of the wish list. */
  name: Maybe<Scalars["String"]["output"]>;
  /** An encrypted code that Magento uses to link to the wish list. */
  sharing_code: Maybe<Scalars["String"]["output"]>;
  /** The time of the last modification to the wish list. */
  updated_at: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether the wish list is public or private. */
  visibility: IWishlistVisibilityEnum;
};

/** Contains a customer wish list. */
export type IWishlistItems_V2Args = {
  currentPage?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Contains details about errors encountered when a customer added wish list items to the cart. */
export type IWishlistCartUserInputError = {
  /** An error code that describes the error encountered. */
  code: IWishlistCartUserInputErrorType;
  /** A localized error message. */
  message: Scalars["String"]["output"];
  /** The unique ID of the `Wishlist` object containing an error. */
  wishlistId: Scalars["ID"]["output"];
  /** The unique ID of the wish list item containing an error. */
  wishlistItemId: Scalars["ID"]["output"];
};

/** A list of possible error types. */
export enum IWishlistCartUserInputErrorType {
  InsufficientStock = "INSUFFICIENT_STOCK",
  NotSalable = "NOT_SALABLE",
  ProductNotFound = "PRODUCT_NOT_FOUND",
  Undefined = "UNDEFINED",
}

/** Contains details about a wish list item. */
export type IWishlistItem = {
  /** The time when the customer added the item to the wish list. */
  added_at: Maybe<Scalars["String"]["output"]>;
  /** The customer's comment about this item. */
  description: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `WishlistItem` object. */
  id: Maybe<Scalars["Int"]["output"]>;
  /** Details about the wish list item. */
  product: Maybe<IProductInterface>;
  /** The quantity of this wish list item */
  qty: Maybe<Scalars["Float"]["output"]>;
};

/** Specifies the IDs of items to copy and their quantities. */
export type IWishlistItemCopyInput = {
  /** The quantity of this item to copy to the destination wish list. This value can't be greater than the quantity in the source wish list. */
  quantity: InputMaybe<Scalars["Float"]["input"]>;
  /** The unique ID of the `WishlistItemInterface` object to be copied. */
  wishlist_item_id: Scalars["ID"]["input"];
};

/** Defines the items to add to a wish list. */
export type IWishlistItemInput = {
  /** An array of options that the customer entered. */
  entered_options: InputMaybe<Array<InputMaybe<IEnteredOptionInput>>>;
  /** For complex product types, the SKU of the parent product. */
  parent_sku: InputMaybe<Scalars["String"]["input"]>;
  /** The amount or number of items to add. */
  quantity: Scalars["Float"]["input"];
  /** An array of strings corresponding to options the customer selected. */
  selected_options: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  /** The SKU of the product to add. For complex product types, specify the child product SKU. */
  sku: Scalars["String"]["input"];
};

/** The interface for wish list items. */
export type IWishlistItemInterface = {
  /** The date and time the item was added to the wish list. */
  added_at: Scalars["String"]["output"];
  /** Custom options selected for the wish list item. */
  customizable_options: Array<Maybe<ISelectedCustomizableOption>>;
  /** The description of the item. */
  description: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for a `WishlistItemInterface` object. */
  id: Scalars["ID"]["output"];
  /** Product details of the wish list item. */
  product: Maybe<IProductInterface>;
  /** The quantity of this wish list item. */
  quantity: Scalars["Float"]["output"];
};

/** Specifies the IDs of the items to move and their quantities. */
export type IWishlistItemMoveInput = {
  /** The quantity of this item to move to the destination wish list. This value can't be greater than the quantity in the source wish list. */
  quantity: InputMaybe<Scalars["Float"]["input"]>;
  /** The unique ID of the `WishlistItemInterface` object to be moved. */
  wishlist_item_id: Scalars["ID"]["input"];
};

/** Defines updates to items in a wish list. */
export type IWishlistItemUpdateInput = {
  /** Customer-entered comments about the item. */
  description: InputMaybe<Scalars["String"]["input"]>;
  /** An array of options that the customer entered. */
  entered_options: InputMaybe<Array<InputMaybe<IEnteredOptionInput>>>;
  /** The new amount or number of this item. */
  quantity: InputMaybe<Scalars["Float"]["input"]>;
  /** An array of strings corresponding to options the customer selected. */
  selected_options: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  /** The unique ID for a `WishlistItemInterface` object. */
  wishlist_item_id: Scalars["ID"]["input"];
};

/** Contains an array of items in a wish list. */
export type IWishlistItems = {
  /** A list of items in the wish list. */
  items: Array<Maybe<IWishlistItemInterface>>;
  /** Contains pagination metadata. */
  page_info: Maybe<ISearchResultPageInfo>;
};

/** Deprecated: Use the `Wishlist` type instead. */
export type IWishlistOutput = {
  /**
   * An array of items in the customer's wish list
   * @deprecated Use the `Wishlist.items` field instead.
   */
  items: Maybe<Array<Maybe<IWishlistItem>>>;
  /**
   * The number of items in the wish list.
   * @deprecated Use the `Wishlist.items_count` field instead.
   */
  items_count: Maybe<Scalars["Int"]["output"]>;
  /**
   * When multiple wish lists are enabled, the name the customer assigns to the wishlist.
   * @deprecated This field is related to Commerce functionality and is always `null` in Open Source.
   */
  name: Maybe<Scalars["String"]["output"]>;
  /**
   * An encrypted code that links to the wish list.
   * @deprecated Use the `Wishlist.sharing_code` field instead.
   */
  sharing_code: Maybe<Scalars["String"]["output"]>;
  /**
   * The time of the last modification to the wish list.
   * @deprecated Use the `Wishlist.updated_at` field instead.
   */
  updated_at: Maybe<Scalars["String"]["output"]>;
};

/** Defines the wish list visibility types. */
export enum IWishlistVisibilityEnum {
  Private = "PRIVATE",
  Public = "PUBLIC",
}

/** Assigns a specific `cart_id` to the empty cart. */
export type ICreateEmptyCartInput = {
  /** The ID to assign to the cart. */
  cart_id: InputMaybe<Scalars["String"]["input"]>;
};

export type ICustomerOrderFragmentFragment = {
  id: string;
  carrier: string;
  number: string;
  order_date: string;
  shipping_method: string;
  shipping_method_code: string;
  status: string;
  items: Array<
    | {
        id: string;
        product_name: string;
        product_sku: string;
        product_type: string;
        quantity_ordered: number;
        trade_in: number;
        bundle_options: Array<{
          id: string;
          label: string;
          values: Array<{
            id: string;
            product_name: string;
            quantity: number;
            presentation_info: {
              initial_price: number;
              presentation_price: number;
              product:
                | { tooltip_info: string; small_image: { label: string; url: string } }
                | { tooltip_info: string; small_image: { label: string; url: string } }
                | { tooltip_info: string; small_image: { label: string; url: string } }
                | { tooltip_info: string; small_image: { label: string; url: string } }
                | { tooltip_info: string; small_image: { label: string; url: string } }
                | { tooltip_info: string; small_image: { label: string; url: string } }
                | { tooltip_info: string; small_image: { label: string; url: string } };
            };
          }>;
        }>;
        row_total: { currency: Types.ICurrencyEnum; value: number };
        row_total_incl_tax: { currency: Types.ICurrencyEnum; value: number };
        product_sale_price: { currency: Types.ICurrencyEnum; value: number };
        product_sale_price_incl_tax: { currency: Types.ICurrencyEnum; value: number };
        gift_data: { is_gift: boolean; parent_gift_sku: string; parent_gift_id: string };
        product:
          | {
              subscription: number;
              subscription_format: string;
              enable_order_quantity_limit: number;
              order_quantity_limit: number;
              strength: number;
              description: { html: string };
              short_description: { html: string };
              categories: Array<{ name: string; uid: string }>;
              image: { url: string };
              strength_details: { name: string; rating: number };
              price_range: {
                minimum_price: {
                  regular_price: { value: number; currency: Types.ICurrencyEnum };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
                maximum_price: {
                  discount: { amount_off: number; percent_off: number };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
              };
            }
          | {
              subscription: number;
              subscription_format: string;
              enable_order_quantity_limit: number;
              order_quantity_limit: number;
              strength: number;
              description: { html: string };
              short_description: { html: string };
              categories: Array<{ name: string; uid: string }>;
              image: { url: string };
              strength_details: { name: string; rating: number };
              price_range: {
                minimum_price: {
                  regular_price: { value: number; currency: Types.ICurrencyEnum };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
                maximum_price: {
                  discount: { amount_off: number; percent_off: number };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
              };
            }
          | {
              subscription: number;
              subscription_format: string;
              enable_order_quantity_limit: number;
              order_quantity_limit: number;
              strength: number;
              description: { html: string };
              short_description: { html: string };
              categories: Array<{ name: string; uid: string }>;
              image: { url: string };
              strength_details: { name: string; rating: number };
              price_range: {
                minimum_price: {
                  regular_price: { value: number; currency: Types.ICurrencyEnum };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
                maximum_price: {
                  discount: { amount_off: number; percent_off: number };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
              };
            }
          | {
              subscription: number;
              subscription_format: string;
              enable_order_quantity_limit: number;
              order_quantity_limit: number;
              strength: number;
              description: { html: string };
              short_description: { html: string };
              categories: Array<{ name: string; uid: string }>;
              image: { url: string };
              strength_details: { name: string; rating: number };
              price_range: {
                minimum_price: {
                  regular_price: { value: number; currency: Types.ICurrencyEnum };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
                maximum_price: {
                  discount: { amount_off: number; percent_off: number };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
              };
            }
          | {
              subscription: number;
              subscription_format: string;
              enable_order_quantity_limit: number;
              order_quantity_limit: number;
              strength: number;
              description: { html: string };
              short_description: { html: string };
              categories: Array<{ name: string; uid: string }>;
              image: { url: string };
              strength_details: { name: string; rating: number };
              price_range: {
                minimum_price: {
                  regular_price: { value: number; currency: Types.ICurrencyEnum };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
                maximum_price: {
                  discount: { amount_off: number; percent_off: number };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
              };
            }
          | {
              subscription: number;
              subscription_format: string;
              enable_order_quantity_limit: number;
              order_quantity_limit: number;
              strength: number;
              description: { html: string };
              short_description: { html: string };
              categories: Array<{ name: string; uid: string }>;
              image: { url: string };
              strength_details: { name: string; rating: number };
              price_range: {
                minimum_price: {
                  regular_price: { value: number; currency: Types.ICurrencyEnum };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
                maximum_price: {
                  discount: { amount_off: number; percent_off: number };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
              };
            }
          | {
              subscription: number;
              subscription_format: string;
              enable_order_quantity_limit: number;
              order_quantity_limit: number;
              strength: number;
              description: { html: string };
              short_description: { html: string };
              categories: Array<{ name: string; uid: string }>;
              image: { url: string };
              strength_details: { name: string; rating: number };
              price_range: {
                minimum_price: {
                  regular_price: { value: number; currency: Types.ICurrencyEnum };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
                maximum_price: {
                  discount: { amount_off: number; percent_off: number };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
              };
            };
      }
    | {
        id: string;
        product_name: string;
        product_sku: string;
        product_type: string;
        quantity_ordered: number;
        trade_in: number;
        row_total: { currency: Types.ICurrencyEnum; value: number };
        row_total_incl_tax: { currency: Types.ICurrencyEnum; value: number };
        product_sale_price: { currency: Types.ICurrencyEnum; value: number };
        product_sale_price_incl_tax: { currency: Types.ICurrencyEnum; value: number };
        gift_data: { is_gift: boolean; parent_gift_sku: string; parent_gift_id: string };
        product:
          | {
              subscription: number;
              subscription_format: string;
              enable_order_quantity_limit: number;
              order_quantity_limit: number;
              strength: number;
              description: { html: string };
              short_description: { html: string };
              categories: Array<{ name: string; uid: string }>;
              image: { url: string };
              strength_details: { name: string; rating: number };
              price_range: {
                minimum_price: {
                  regular_price: { value: number; currency: Types.ICurrencyEnum };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
                maximum_price: {
                  discount: { amount_off: number; percent_off: number };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
              };
            }
          | {
              subscription: number;
              subscription_format: string;
              enable_order_quantity_limit: number;
              order_quantity_limit: number;
              strength: number;
              description: { html: string };
              short_description: { html: string };
              categories: Array<{ name: string; uid: string }>;
              image: { url: string };
              strength_details: { name: string; rating: number };
              price_range: {
                minimum_price: {
                  regular_price: { value: number; currency: Types.ICurrencyEnum };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
                maximum_price: {
                  discount: { amount_off: number; percent_off: number };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
              };
            }
          | {
              subscription: number;
              subscription_format: string;
              enable_order_quantity_limit: number;
              order_quantity_limit: number;
              strength: number;
              description: { html: string };
              short_description: { html: string };
              categories: Array<{ name: string; uid: string }>;
              image: { url: string };
              strength_details: { name: string; rating: number };
              price_range: {
                minimum_price: {
                  regular_price: { value: number; currency: Types.ICurrencyEnum };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
                maximum_price: {
                  discount: { amount_off: number; percent_off: number };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
              };
            }
          | {
              subscription: number;
              subscription_format: string;
              enable_order_quantity_limit: number;
              order_quantity_limit: number;
              strength: number;
              description: { html: string };
              short_description: { html: string };
              categories: Array<{ name: string; uid: string }>;
              image: { url: string };
              strength_details: { name: string; rating: number };
              price_range: {
                minimum_price: {
                  regular_price: { value: number; currency: Types.ICurrencyEnum };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
                maximum_price: {
                  discount: { amount_off: number; percent_off: number };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
              };
            }
          | {
              subscription: number;
              subscription_format: string;
              enable_order_quantity_limit: number;
              order_quantity_limit: number;
              strength: number;
              description: { html: string };
              short_description: { html: string };
              categories: Array<{ name: string; uid: string }>;
              image: { url: string };
              strength_details: { name: string; rating: number };
              price_range: {
                minimum_price: {
                  regular_price: { value: number; currency: Types.ICurrencyEnum };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
                maximum_price: {
                  discount: { amount_off: number; percent_off: number };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
              };
            }
          | {
              subscription: number;
              subscription_format: string;
              enable_order_quantity_limit: number;
              order_quantity_limit: number;
              strength: number;
              description: { html: string };
              short_description: { html: string };
              categories: Array<{ name: string; uid: string }>;
              image: { url: string };
              strength_details: { name: string; rating: number };
              price_range: {
                minimum_price: {
                  regular_price: { value: number; currency: Types.ICurrencyEnum };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
                maximum_price: {
                  discount: { amount_off: number; percent_off: number };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
              };
            }
          | {
              subscription: number;
              subscription_format: string;
              enable_order_quantity_limit: number;
              order_quantity_limit: number;
              strength: number;
              description: { html: string };
              short_description: { html: string };
              categories: Array<{ name: string; uid: string }>;
              image: { url: string };
              strength_details: { name: string; rating: number };
              price_range: {
                minimum_price: {
                  regular_price: { value: number; currency: Types.ICurrencyEnum };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
                maximum_price: {
                  discount: { amount_off: number; percent_off: number };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
              };
            };
      }
    | {
        id: string;
        product_name: string;
        product_sku: string;
        product_type: string;
        quantity_ordered: number;
        trade_in: number;
        row_total: { currency: Types.ICurrencyEnum; value: number };
        row_total_incl_tax: { currency: Types.ICurrencyEnum; value: number };
        product_sale_price: { currency: Types.ICurrencyEnum; value: number };
        product_sale_price_incl_tax: { currency: Types.ICurrencyEnum; value: number };
        gift_data: { is_gift: boolean; parent_gift_sku: string; parent_gift_id: string };
        product:
          | {
              subscription: number;
              subscription_format: string;
              enable_order_quantity_limit: number;
              order_quantity_limit: number;
              strength: number;
              description: { html: string };
              short_description: { html: string };
              categories: Array<{ name: string; uid: string }>;
              image: { url: string };
              strength_details: { name: string; rating: number };
              price_range: {
                minimum_price: {
                  regular_price: { value: number; currency: Types.ICurrencyEnum };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
                maximum_price: {
                  discount: { amount_off: number; percent_off: number };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
              };
            }
          | {
              subscription: number;
              subscription_format: string;
              enable_order_quantity_limit: number;
              order_quantity_limit: number;
              strength: number;
              description: { html: string };
              short_description: { html: string };
              categories: Array<{ name: string; uid: string }>;
              image: { url: string };
              strength_details: { name: string; rating: number };
              price_range: {
                minimum_price: {
                  regular_price: { value: number; currency: Types.ICurrencyEnum };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
                maximum_price: {
                  discount: { amount_off: number; percent_off: number };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
              };
            }
          | {
              subscription: number;
              subscription_format: string;
              enable_order_quantity_limit: number;
              order_quantity_limit: number;
              strength: number;
              description: { html: string };
              short_description: { html: string };
              categories: Array<{ name: string; uid: string }>;
              image: { url: string };
              strength_details: { name: string; rating: number };
              price_range: {
                minimum_price: {
                  regular_price: { value: number; currency: Types.ICurrencyEnum };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
                maximum_price: {
                  discount: { amount_off: number; percent_off: number };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
              };
            }
          | {
              subscription: number;
              subscription_format: string;
              enable_order_quantity_limit: number;
              order_quantity_limit: number;
              strength: number;
              description: { html: string };
              short_description: { html: string };
              categories: Array<{ name: string; uid: string }>;
              image: { url: string };
              strength_details: { name: string; rating: number };
              price_range: {
                minimum_price: {
                  regular_price: { value: number; currency: Types.ICurrencyEnum };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
                maximum_price: {
                  discount: { amount_off: number; percent_off: number };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
              };
            }
          | {
              subscription: number;
              subscription_format: string;
              enable_order_quantity_limit: number;
              order_quantity_limit: number;
              strength: number;
              description: { html: string };
              short_description: { html: string };
              categories: Array<{ name: string; uid: string }>;
              image: { url: string };
              strength_details: { name: string; rating: number };
              price_range: {
                minimum_price: {
                  regular_price: { value: number; currency: Types.ICurrencyEnum };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
                maximum_price: {
                  discount: { amount_off: number; percent_off: number };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
              };
            }
          | {
              subscription: number;
              subscription_format: string;
              enable_order_quantity_limit: number;
              order_quantity_limit: number;
              strength: number;
              description: { html: string };
              short_description: { html: string };
              categories: Array<{ name: string; uid: string }>;
              image: { url: string };
              strength_details: { name: string; rating: number };
              price_range: {
                minimum_price: {
                  regular_price: { value: number; currency: Types.ICurrencyEnum };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
                maximum_price: {
                  discount: { amount_off: number; percent_off: number };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
              };
            }
          | {
              subscription: number;
              subscription_format: string;
              enable_order_quantity_limit: number;
              order_quantity_limit: number;
              strength: number;
              description: { html: string };
              short_description: { html: string };
              categories: Array<{ name: string; uid: string }>;
              image: { url: string };
              strength_details: { name: string; rating: number };
              price_range: {
                minimum_price: {
                  regular_price: { value: number; currency: Types.ICurrencyEnum };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
                maximum_price: {
                  discount: { amount_off: number; percent_off: number };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
              };
            };
      }
    | {
        id: string;
        product_name: string;
        product_sku: string;
        product_type: string;
        quantity_ordered: number;
        trade_in: number;
        row_total: { currency: Types.ICurrencyEnum; value: number };
        row_total_incl_tax: { currency: Types.ICurrencyEnum; value: number };
        product_sale_price: { currency: Types.ICurrencyEnum; value: number };
        product_sale_price_incl_tax: { currency: Types.ICurrencyEnum; value: number };
        gift_data: { is_gift: boolean; parent_gift_sku: string; parent_gift_id: string };
        product:
          | {
              subscription: number;
              subscription_format: string;
              enable_order_quantity_limit: number;
              order_quantity_limit: number;
              strength: number;
              description: { html: string };
              short_description: { html: string };
              categories: Array<{ name: string; uid: string }>;
              image: { url: string };
              strength_details: { name: string; rating: number };
              price_range: {
                minimum_price: {
                  regular_price: { value: number; currency: Types.ICurrencyEnum };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
                maximum_price: {
                  discount: { amount_off: number; percent_off: number };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
              };
            }
          | {
              subscription: number;
              subscription_format: string;
              enable_order_quantity_limit: number;
              order_quantity_limit: number;
              strength: number;
              description: { html: string };
              short_description: { html: string };
              categories: Array<{ name: string; uid: string }>;
              image: { url: string };
              strength_details: { name: string; rating: number };
              price_range: {
                minimum_price: {
                  regular_price: { value: number; currency: Types.ICurrencyEnum };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
                maximum_price: {
                  discount: { amount_off: number; percent_off: number };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
              };
            }
          | {
              subscription: number;
              subscription_format: string;
              enable_order_quantity_limit: number;
              order_quantity_limit: number;
              strength: number;
              description: { html: string };
              short_description: { html: string };
              categories: Array<{ name: string; uid: string }>;
              image: { url: string };
              strength_details: { name: string; rating: number };
              price_range: {
                minimum_price: {
                  regular_price: { value: number; currency: Types.ICurrencyEnum };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
                maximum_price: {
                  discount: { amount_off: number; percent_off: number };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
              };
            }
          | {
              subscription: number;
              subscription_format: string;
              enable_order_quantity_limit: number;
              order_quantity_limit: number;
              strength: number;
              description: { html: string };
              short_description: { html: string };
              categories: Array<{ name: string; uid: string }>;
              image: { url: string };
              strength_details: { name: string; rating: number };
              price_range: {
                minimum_price: {
                  regular_price: { value: number; currency: Types.ICurrencyEnum };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
                maximum_price: {
                  discount: { amount_off: number; percent_off: number };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
              };
            }
          | {
              subscription: number;
              subscription_format: string;
              enable_order_quantity_limit: number;
              order_quantity_limit: number;
              strength: number;
              description: { html: string };
              short_description: { html: string };
              categories: Array<{ name: string; uid: string }>;
              image: { url: string };
              strength_details: { name: string; rating: number };
              price_range: {
                minimum_price: {
                  regular_price: { value: number; currency: Types.ICurrencyEnum };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
                maximum_price: {
                  discount: { amount_off: number; percent_off: number };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
              };
            }
          | {
              subscription: number;
              subscription_format: string;
              enable_order_quantity_limit: number;
              order_quantity_limit: number;
              strength: number;
              description: { html: string };
              short_description: { html: string };
              categories: Array<{ name: string; uid: string }>;
              image: { url: string };
              strength_details: { name: string; rating: number };
              price_range: {
                minimum_price: {
                  regular_price: { value: number; currency: Types.ICurrencyEnum };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
                maximum_price: {
                  discount: { amount_off: number; percent_off: number };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
              };
            }
          | {
              subscription: number;
              subscription_format: string;
              enable_order_quantity_limit: number;
              order_quantity_limit: number;
              strength: number;
              description: { html: string };
              short_description: { html: string };
              categories: Array<{ name: string; uid: string }>;
              image: { url: string };
              strength_details: { name: string; rating: number };
              price_range: {
                minimum_price: {
                  regular_price: { value: number; currency: Types.ICurrencyEnum };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
                maximum_price: {
                  discount: { amount_off: number; percent_off: number };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
              };
            };
      }
    | {
        id: string;
        product_name: string;
        product_sku: string;
        product_type: string;
        quantity_ordered: number;
        trade_in: number;
        row_total: { currency: Types.ICurrencyEnum; value: number };
        row_total_incl_tax: { currency: Types.ICurrencyEnum; value: number };
        product_sale_price: { currency: Types.ICurrencyEnum; value: number };
        product_sale_price_incl_tax: { currency: Types.ICurrencyEnum; value: number };
        gift_data: { is_gift: boolean; parent_gift_sku: string; parent_gift_id: string };
        product:
          | {
              subscription: number;
              subscription_format: string;
              enable_order_quantity_limit: number;
              order_quantity_limit: number;
              strength: number;
              description: { html: string };
              short_description: { html: string };
              categories: Array<{ name: string; uid: string }>;
              image: { url: string };
              strength_details: { name: string; rating: number };
              price_range: {
                minimum_price: {
                  regular_price: { value: number; currency: Types.ICurrencyEnum };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
                maximum_price: {
                  discount: { amount_off: number; percent_off: number };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
              };
            }
          | {
              subscription: number;
              subscription_format: string;
              enable_order_quantity_limit: number;
              order_quantity_limit: number;
              strength: number;
              description: { html: string };
              short_description: { html: string };
              categories: Array<{ name: string; uid: string }>;
              image: { url: string };
              strength_details: { name: string; rating: number };
              price_range: {
                minimum_price: {
                  regular_price: { value: number; currency: Types.ICurrencyEnum };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
                maximum_price: {
                  discount: { amount_off: number; percent_off: number };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
              };
            }
          | {
              subscription: number;
              subscription_format: string;
              enable_order_quantity_limit: number;
              order_quantity_limit: number;
              strength: number;
              description: { html: string };
              short_description: { html: string };
              categories: Array<{ name: string; uid: string }>;
              image: { url: string };
              strength_details: { name: string; rating: number };
              price_range: {
                minimum_price: {
                  regular_price: { value: number; currency: Types.ICurrencyEnum };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
                maximum_price: {
                  discount: { amount_off: number; percent_off: number };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
              };
            }
          | {
              subscription: number;
              subscription_format: string;
              enable_order_quantity_limit: number;
              order_quantity_limit: number;
              strength: number;
              description: { html: string };
              short_description: { html: string };
              categories: Array<{ name: string; uid: string }>;
              image: { url: string };
              strength_details: { name: string; rating: number };
              price_range: {
                minimum_price: {
                  regular_price: { value: number; currency: Types.ICurrencyEnum };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
                maximum_price: {
                  discount: { amount_off: number; percent_off: number };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
              };
            }
          | {
              subscription: number;
              subscription_format: string;
              enable_order_quantity_limit: number;
              order_quantity_limit: number;
              strength: number;
              description: { html: string };
              short_description: { html: string };
              categories: Array<{ name: string; uid: string }>;
              image: { url: string };
              strength_details: { name: string; rating: number };
              price_range: {
                minimum_price: {
                  regular_price: { value: number; currency: Types.ICurrencyEnum };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
                maximum_price: {
                  discount: { amount_off: number; percent_off: number };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
              };
            }
          | {
              subscription: number;
              subscription_format: string;
              enable_order_quantity_limit: number;
              order_quantity_limit: number;
              strength: number;
              description: { html: string };
              short_description: { html: string };
              categories: Array<{ name: string; uid: string }>;
              image: { url: string };
              strength_details: { name: string; rating: number };
              price_range: {
                minimum_price: {
                  regular_price: { value: number; currency: Types.ICurrencyEnum };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
                maximum_price: {
                  discount: { amount_off: number; percent_off: number };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
              };
            }
          | {
              subscription: number;
              subscription_format: string;
              enable_order_quantity_limit: number;
              order_quantity_limit: number;
              strength: number;
              description: { html: string };
              short_description: { html: string };
              categories: Array<{ name: string; uid: string }>;
              image: { url: string };
              strength_details: { name: string; rating: number };
              price_range: {
                minimum_price: {
                  regular_price: { value: number; currency: Types.ICurrencyEnum };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
                maximum_price: {
                  discount: { amount_off: number; percent_off: number };
                  fixed_product_taxes: Array<{
                    label: string;
                    amount: { value: number; currency: Types.ICurrencyEnum };
                  }>;
                };
              };
            };
      }
  >;
  payment_methods: Array<{ type: string; name: string; additional_data: Array<{ name: string; value: string }> }>;
  additional_attributes: Array<{ attribute_code: string; value: string }>;
  billing_address: {
    city: string;
    country_code: Types.ICountryCodeEnum;
    firstname: string;
    lastname: string;
    postcode: string;
    street: Array<string>;
    telephone: string;
    administrative_area_level_2: string;
    sublocality_level_2: string;
    premise: string;
    neighborhood: string;
    landmark: string;
    building_number: string;
    district: string;
    region: string;
    short_address: string;
  };
  shipping_address: {
    city: string;
    country_code: Types.ICountryCodeEnum;
    firstname: string;
    lastname: string;
    postcode: string;
    street: Array<string>;
    telephone: string;
    pickup_information: string;
    administrative_area_level_2: string;
    sublocality_level_2: string;
    premise: string;
    neighborhood: string;
    landmark: string;
    building_number: string;
    district: string;
    region: string;
    short_address: string;
  };
  loyalty_info: {
    loyalty_discount_amount: number;
    loyalty_discount_points: number | null;
    loyalty_discount_uuid: string;
  };
  invoices: Array<{ url: string }>;
  total: {
    discounts: Array<{ label: string; coupon_code: string; amount: { currency: Types.ICurrencyEnum; value: number } }>;
    grand_total: { currency: Types.ICurrencyEnum; value: number };
    subtotal: { currency: Types.ICurrencyEnum; value: number };
    subtotal_incl_tax: { currency: Types.ICurrencyEnum; value: number };
    taxes: Array<{ title: string; rate: number; amount: { currency: Types.ICurrencyEnum; value: number } }>;
    total_shipping: { currency: Types.ICurrencyEnum; value: number };
    total_refunded: { currency: Types.ICurrencyEnum; value: number };
    total_tax: { currency: Types.ICurrencyEnum; value: number };
  };
  total_including_trial: {
    total: { currency: Types.ICurrencyEnum; value: number };
    total_incl_tax: { currency: Types.ICurrencyEnum; value: number };
    tax: { currency: Types.ICurrencyEnum; value: number };
  };
  total_after_trial: {
    total: { currency: Types.ICurrencyEnum; value: number };
    total_incl_tax: { currency: Types.ICurrencyEnum; value: number };
    tax: { currency: Types.ICurrencyEnum; value: number };
  };
};

export type ICustomerOrderItemFragment_BundleOrderItem_Fragment = {
  id: string;
  product_name: string;
  product_sku: string;
  product_type: string;
  quantity_ordered: number;
  trade_in: number;
  bundle_options: Array<{
    id: string;
    label: string;
    values: Array<{
      id: string;
      product_name: string;
      quantity: number;
      presentation_info: {
        initial_price: number;
        presentation_price: number;
        product:
          | { tooltip_info: string; small_image: { label: string; url: string } }
          | { tooltip_info: string; small_image: { label: string; url: string } }
          | { tooltip_info: string; small_image: { label: string; url: string } }
          | { tooltip_info: string; small_image: { label: string; url: string } }
          | { tooltip_info: string; small_image: { label: string; url: string } }
          | { tooltip_info: string; small_image: { label: string; url: string } }
          | { tooltip_info: string; small_image: { label: string; url: string } };
      };
    }>;
  }>;
  row_total: { currency: Types.ICurrencyEnum; value: number };
  row_total_incl_tax: { currency: Types.ICurrencyEnum; value: number };
  product_sale_price: { currency: Types.ICurrencyEnum; value: number };
  product_sale_price_incl_tax: { currency: Types.ICurrencyEnum; value: number };
  gift_data: { is_gift: boolean; parent_gift_sku: string; parent_gift_id: string };
  product:
    | {
        subscription: number;
        subscription_format: string;
        enable_order_quantity_limit: number;
        order_quantity_limit: number;
        strength: number;
        description: { html: string };
        short_description: { html: string };
        categories: Array<{ name: string; uid: string }>;
        image: { url: string };
        strength_details: { name: string; rating: number };
        price_range: {
          minimum_price: {
            regular_price: { value: number; currency: Types.ICurrencyEnum };
            final_price: { value: number; currency: Types.ICurrencyEnum };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
          maximum_price: {
            discount: { amount_off: number; percent_off: number };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
        };
      }
    | {
        subscription: number;
        subscription_format: string;
        enable_order_quantity_limit: number;
        order_quantity_limit: number;
        strength: number;
        description: { html: string };
        short_description: { html: string };
        categories: Array<{ name: string; uid: string }>;
        image: { url: string };
        strength_details: { name: string; rating: number };
        price_range: {
          minimum_price: {
            regular_price: { value: number; currency: Types.ICurrencyEnum };
            final_price: { value: number; currency: Types.ICurrencyEnum };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
          maximum_price: {
            discount: { amount_off: number; percent_off: number };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
        };
      }
    | {
        subscription: number;
        subscription_format: string;
        enable_order_quantity_limit: number;
        order_quantity_limit: number;
        strength: number;
        description: { html: string };
        short_description: { html: string };
        categories: Array<{ name: string; uid: string }>;
        image: { url: string };
        strength_details: { name: string; rating: number };
        price_range: {
          minimum_price: {
            regular_price: { value: number; currency: Types.ICurrencyEnum };
            final_price: { value: number; currency: Types.ICurrencyEnum };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
          maximum_price: {
            discount: { amount_off: number; percent_off: number };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
        };
      }
    | {
        subscription: number;
        subscription_format: string;
        enable_order_quantity_limit: number;
        order_quantity_limit: number;
        strength: number;
        description: { html: string };
        short_description: { html: string };
        categories: Array<{ name: string; uid: string }>;
        image: { url: string };
        strength_details: { name: string; rating: number };
        price_range: {
          minimum_price: {
            regular_price: { value: number; currency: Types.ICurrencyEnum };
            final_price: { value: number; currency: Types.ICurrencyEnum };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
          maximum_price: {
            discount: { amount_off: number; percent_off: number };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
        };
      }
    | {
        subscription: number;
        subscription_format: string;
        enable_order_quantity_limit: number;
        order_quantity_limit: number;
        strength: number;
        description: { html: string };
        short_description: { html: string };
        categories: Array<{ name: string; uid: string }>;
        image: { url: string };
        strength_details: { name: string; rating: number };
        price_range: {
          minimum_price: {
            regular_price: { value: number; currency: Types.ICurrencyEnum };
            final_price: { value: number; currency: Types.ICurrencyEnum };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
          maximum_price: {
            discount: { amount_off: number; percent_off: number };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
        };
      }
    | {
        subscription: number;
        subscription_format: string;
        enable_order_quantity_limit: number;
        order_quantity_limit: number;
        strength: number;
        description: { html: string };
        short_description: { html: string };
        categories: Array<{ name: string; uid: string }>;
        image: { url: string };
        strength_details: { name: string; rating: number };
        price_range: {
          minimum_price: {
            regular_price: { value: number; currency: Types.ICurrencyEnum };
            final_price: { value: number; currency: Types.ICurrencyEnum };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
          maximum_price: {
            discount: { amount_off: number; percent_off: number };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
        };
      }
    | {
        subscription: number;
        subscription_format: string;
        enable_order_quantity_limit: number;
        order_quantity_limit: number;
        strength: number;
        description: { html: string };
        short_description: { html: string };
        categories: Array<{ name: string; uid: string }>;
        image: { url: string };
        strength_details: { name: string; rating: number };
        price_range: {
          minimum_price: {
            regular_price: { value: number; currency: Types.ICurrencyEnum };
            final_price: { value: number; currency: Types.ICurrencyEnum };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
          maximum_price: {
            discount: { amount_off: number; percent_off: number };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
        };
      };
};

export type ICustomerOrderItemFragment_ConfigurableOrderItem_Fragment = {
  id: string;
  product_name: string;
  product_sku: string;
  product_type: string;
  quantity_ordered: number;
  trade_in: number;
  row_total: { currency: Types.ICurrencyEnum; value: number };
  row_total_incl_tax: { currency: Types.ICurrencyEnum; value: number };
  product_sale_price: { currency: Types.ICurrencyEnum; value: number };
  product_sale_price_incl_tax: { currency: Types.ICurrencyEnum; value: number };
  gift_data: { is_gift: boolean; parent_gift_sku: string; parent_gift_id: string };
  product:
    | {
        subscription: number;
        subscription_format: string;
        enable_order_quantity_limit: number;
        order_quantity_limit: number;
        strength: number;
        description: { html: string };
        short_description: { html: string };
        categories: Array<{ name: string; uid: string }>;
        image: { url: string };
        strength_details: { name: string; rating: number };
        price_range: {
          minimum_price: {
            regular_price: { value: number; currency: Types.ICurrencyEnum };
            final_price: { value: number; currency: Types.ICurrencyEnum };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
          maximum_price: {
            discount: { amount_off: number; percent_off: number };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
        };
      }
    | {
        subscription: number;
        subscription_format: string;
        enable_order_quantity_limit: number;
        order_quantity_limit: number;
        strength: number;
        description: { html: string };
        short_description: { html: string };
        categories: Array<{ name: string; uid: string }>;
        image: { url: string };
        strength_details: { name: string; rating: number };
        price_range: {
          minimum_price: {
            regular_price: { value: number; currency: Types.ICurrencyEnum };
            final_price: { value: number; currency: Types.ICurrencyEnum };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
          maximum_price: {
            discount: { amount_off: number; percent_off: number };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
        };
      }
    | {
        subscription: number;
        subscription_format: string;
        enable_order_quantity_limit: number;
        order_quantity_limit: number;
        strength: number;
        description: { html: string };
        short_description: { html: string };
        categories: Array<{ name: string; uid: string }>;
        image: { url: string };
        strength_details: { name: string; rating: number };
        price_range: {
          minimum_price: {
            regular_price: { value: number; currency: Types.ICurrencyEnum };
            final_price: { value: number; currency: Types.ICurrencyEnum };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
          maximum_price: {
            discount: { amount_off: number; percent_off: number };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
        };
      }
    | {
        subscription: number;
        subscription_format: string;
        enable_order_quantity_limit: number;
        order_quantity_limit: number;
        strength: number;
        description: { html: string };
        short_description: { html: string };
        categories: Array<{ name: string; uid: string }>;
        image: { url: string };
        strength_details: { name: string; rating: number };
        price_range: {
          minimum_price: {
            regular_price: { value: number; currency: Types.ICurrencyEnum };
            final_price: { value: number; currency: Types.ICurrencyEnum };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
          maximum_price: {
            discount: { amount_off: number; percent_off: number };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
        };
      }
    | {
        subscription: number;
        subscription_format: string;
        enable_order_quantity_limit: number;
        order_quantity_limit: number;
        strength: number;
        description: { html: string };
        short_description: { html: string };
        categories: Array<{ name: string; uid: string }>;
        image: { url: string };
        strength_details: { name: string; rating: number };
        price_range: {
          minimum_price: {
            regular_price: { value: number; currency: Types.ICurrencyEnum };
            final_price: { value: number; currency: Types.ICurrencyEnum };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
          maximum_price: {
            discount: { amount_off: number; percent_off: number };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
        };
      }
    | {
        subscription: number;
        subscription_format: string;
        enable_order_quantity_limit: number;
        order_quantity_limit: number;
        strength: number;
        description: { html: string };
        short_description: { html: string };
        categories: Array<{ name: string; uid: string }>;
        image: { url: string };
        strength_details: { name: string; rating: number };
        price_range: {
          minimum_price: {
            regular_price: { value: number; currency: Types.ICurrencyEnum };
            final_price: { value: number; currency: Types.ICurrencyEnum };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
          maximum_price: {
            discount: { amount_off: number; percent_off: number };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
        };
      }
    | {
        subscription: number;
        subscription_format: string;
        enable_order_quantity_limit: number;
        order_quantity_limit: number;
        strength: number;
        description: { html: string };
        short_description: { html: string };
        categories: Array<{ name: string; uid: string }>;
        image: { url: string };
        strength_details: { name: string; rating: number };
        price_range: {
          minimum_price: {
            regular_price: { value: number; currency: Types.ICurrencyEnum };
            final_price: { value: number; currency: Types.ICurrencyEnum };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
          maximum_price: {
            discount: { amount_off: number; percent_off: number };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
        };
      };
};

export type ICustomerOrderItemFragment_DownloadableOrderItem_Fragment = {
  id: string;
  product_name: string;
  product_sku: string;
  product_type: string;
  quantity_ordered: number;
  trade_in: number;
  row_total: { currency: Types.ICurrencyEnum; value: number };
  row_total_incl_tax: { currency: Types.ICurrencyEnum; value: number };
  product_sale_price: { currency: Types.ICurrencyEnum; value: number };
  product_sale_price_incl_tax: { currency: Types.ICurrencyEnum; value: number };
  gift_data: { is_gift: boolean; parent_gift_sku: string; parent_gift_id: string };
  product:
    | {
        subscription: number;
        subscription_format: string;
        enable_order_quantity_limit: number;
        order_quantity_limit: number;
        strength: number;
        description: { html: string };
        short_description: { html: string };
        categories: Array<{ name: string; uid: string }>;
        image: { url: string };
        strength_details: { name: string; rating: number };
        price_range: {
          minimum_price: {
            regular_price: { value: number; currency: Types.ICurrencyEnum };
            final_price: { value: number; currency: Types.ICurrencyEnum };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
          maximum_price: {
            discount: { amount_off: number; percent_off: number };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
        };
      }
    | {
        subscription: number;
        subscription_format: string;
        enable_order_quantity_limit: number;
        order_quantity_limit: number;
        strength: number;
        description: { html: string };
        short_description: { html: string };
        categories: Array<{ name: string; uid: string }>;
        image: { url: string };
        strength_details: { name: string; rating: number };
        price_range: {
          minimum_price: {
            regular_price: { value: number; currency: Types.ICurrencyEnum };
            final_price: { value: number; currency: Types.ICurrencyEnum };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
          maximum_price: {
            discount: { amount_off: number; percent_off: number };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
        };
      }
    | {
        subscription: number;
        subscription_format: string;
        enable_order_quantity_limit: number;
        order_quantity_limit: number;
        strength: number;
        description: { html: string };
        short_description: { html: string };
        categories: Array<{ name: string; uid: string }>;
        image: { url: string };
        strength_details: { name: string; rating: number };
        price_range: {
          minimum_price: {
            regular_price: { value: number; currency: Types.ICurrencyEnum };
            final_price: { value: number; currency: Types.ICurrencyEnum };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
          maximum_price: {
            discount: { amount_off: number; percent_off: number };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
        };
      }
    | {
        subscription: number;
        subscription_format: string;
        enable_order_quantity_limit: number;
        order_quantity_limit: number;
        strength: number;
        description: { html: string };
        short_description: { html: string };
        categories: Array<{ name: string; uid: string }>;
        image: { url: string };
        strength_details: { name: string; rating: number };
        price_range: {
          minimum_price: {
            regular_price: { value: number; currency: Types.ICurrencyEnum };
            final_price: { value: number; currency: Types.ICurrencyEnum };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
          maximum_price: {
            discount: { amount_off: number; percent_off: number };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
        };
      }
    | {
        subscription: number;
        subscription_format: string;
        enable_order_quantity_limit: number;
        order_quantity_limit: number;
        strength: number;
        description: { html: string };
        short_description: { html: string };
        categories: Array<{ name: string; uid: string }>;
        image: { url: string };
        strength_details: { name: string; rating: number };
        price_range: {
          minimum_price: {
            regular_price: { value: number; currency: Types.ICurrencyEnum };
            final_price: { value: number; currency: Types.ICurrencyEnum };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
          maximum_price: {
            discount: { amount_off: number; percent_off: number };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
        };
      }
    | {
        subscription: number;
        subscription_format: string;
        enable_order_quantity_limit: number;
        order_quantity_limit: number;
        strength: number;
        description: { html: string };
        short_description: { html: string };
        categories: Array<{ name: string; uid: string }>;
        image: { url: string };
        strength_details: { name: string; rating: number };
        price_range: {
          minimum_price: {
            regular_price: { value: number; currency: Types.ICurrencyEnum };
            final_price: { value: number; currency: Types.ICurrencyEnum };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
          maximum_price: {
            discount: { amount_off: number; percent_off: number };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
        };
      }
    | {
        subscription: number;
        subscription_format: string;
        enable_order_quantity_limit: number;
        order_quantity_limit: number;
        strength: number;
        description: { html: string };
        short_description: { html: string };
        categories: Array<{ name: string; uid: string }>;
        image: { url: string };
        strength_details: { name: string; rating: number };
        price_range: {
          minimum_price: {
            regular_price: { value: number; currency: Types.ICurrencyEnum };
            final_price: { value: number; currency: Types.ICurrencyEnum };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
          maximum_price: {
            discount: { amount_off: number; percent_off: number };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
        };
      };
};

export type ICustomerOrderItemFragment_GiftCardOrderItem_Fragment = {
  id: string;
  product_name: string;
  product_sku: string;
  product_type: string;
  quantity_ordered: number;
  trade_in: number;
  row_total: { currency: Types.ICurrencyEnum; value: number };
  row_total_incl_tax: { currency: Types.ICurrencyEnum; value: number };
  product_sale_price: { currency: Types.ICurrencyEnum; value: number };
  product_sale_price_incl_tax: { currency: Types.ICurrencyEnum; value: number };
  gift_data: { is_gift: boolean; parent_gift_sku: string; parent_gift_id: string };
  product:
    | {
        subscription: number;
        subscription_format: string;
        enable_order_quantity_limit: number;
        order_quantity_limit: number;
        strength: number;
        description: { html: string };
        short_description: { html: string };
        categories: Array<{ name: string; uid: string }>;
        image: { url: string };
        strength_details: { name: string; rating: number };
        price_range: {
          minimum_price: {
            regular_price: { value: number; currency: Types.ICurrencyEnum };
            final_price: { value: number; currency: Types.ICurrencyEnum };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
          maximum_price: {
            discount: { amount_off: number; percent_off: number };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
        };
      }
    | {
        subscription: number;
        subscription_format: string;
        enable_order_quantity_limit: number;
        order_quantity_limit: number;
        strength: number;
        description: { html: string };
        short_description: { html: string };
        categories: Array<{ name: string; uid: string }>;
        image: { url: string };
        strength_details: { name: string; rating: number };
        price_range: {
          minimum_price: {
            regular_price: { value: number; currency: Types.ICurrencyEnum };
            final_price: { value: number; currency: Types.ICurrencyEnum };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
          maximum_price: {
            discount: { amount_off: number; percent_off: number };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
        };
      }
    | {
        subscription: number;
        subscription_format: string;
        enable_order_quantity_limit: number;
        order_quantity_limit: number;
        strength: number;
        description: { html: string };
        short_description: { html: string };
        categories: Array<{ name: string; uid: string }>;
        image: { url: string };
        strength_details: { name: string; rating: number };
        price_range: {
          minimum_price: {
            regular_price: { value: number; currency: Types.ICurrencyEnum };
            final_price: { value: number; currency: Types.ICurrencyEnum };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
          maximum_price: {
            discount: { amount_off: number; percent_off: number };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
        };
      }
    | {
        subscription: number;
        subscription_format: string;
        enable_order_quantity_limit: number;
        order_quantity_limit: number;
        strength: number;
        description: { html: string };
        short_description: { html: string };
        categories: Array<{ name: string; uid: string }>;
        image: { url: string };
        strength_details: { name: string; rating: number };
        price_range: {
          minimum_price: {
            regular_price: { value: number; currency: Types.ICurrencyEnum };
            final_price: { value: number; currency: Types.ICurrencyEnum };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
          maximum_price: {
            discount: { amount_off: number; percent_off: number };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
        };
      }
    | {
        subscription: number;
        subscription_format: string;
        enable_order_quantity_limit: number;
        order_quantity_limit: number;
        strength: number;
        description: { html: string };
        short_description: { html: string };
        categories: Array<{ name: string; uid: string }>;
        image: { url: string };
        strength_details: { name: string; rating: number };
        price_range: {
          minimum_price: {
            regular_price: { value: number; currency: Types.ICurrencyEnum };
            final_price: { value: number; currency: Types.ICurrencyEnum };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
          maximum_price: {
            discount: { amount_off: number; percent_off: number };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
        };
      }
    | {
        subscription: number;
        subscription_format: string;
        enable_order_quantity_limit: number;
        order_quantity_limit: number;
        strength: number;
        description: { html: string };
        short_description: { html: string };
        categories: Array<{ name: string; uid: string }>;
        image: { url: string };
        strength_details: { name: string; rating: number };
        price_range: {
          minimum_price: {
            regular_price: { value: number; currency: Types.ICurrencyEnum };
            final_price: { value: number; currency: Types.ICurrencyEnum };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
          maximum_price: {
            discount: { amount_off: number; percent_off: number };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
        };
      }
    | {
        subscription: number;
        subscription_format: string;
        enable_order_quantity_limit: number;
        order_quantity_limit: number;
        strength: number;
        description: { html: string };
        short_description: { html: string };
        categories: Array<{ name: string; uid: string }>;
        image: { url: string };
        strength_details: { name: string; rating: number };
        price_range: {
          minimum_price: {
            regular_price: { value: number; currency: Types.ICurrencyEnum };
            final_price: { value: number; currency: Types.ICurrencyEnum };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
          maximum_price: {
            discount: { amount_off: number; percent_off: number };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
        };
      };
};

export type ICustomerOrderItemFragment_OrderItem_Fragment = {
  id: string;
  product_name: string;
  product_sku: string;
  product_type: string;
  quantity_ordered: number;
  trade_in: number;
  row_total: { currency: Types.ICurrencyEnum; value: number };
  row_total_incl_tax: { currency: Types.ICurrencyEnum; value: number };
  product_sale_price: { currency: Types.ICurrencyEnum; value: number };
  product_sale_price_incl_tax: { currency: Types.ICurrencyEnum; value: number };
  gift_data: { is_gift: boolean; parent_gift_sku: string; parent_gift_id: string };
  product:
    | {
        subscription: number;
        subscription_format: string;
        enable_order_quantity_limit: number;
        order_quantity_limit: number;
        strength: number;
        description: { html: string };
        short_description: { html: string };
        categories: Array<{ name: string; uid: string }>;
        image: { url: string };
        strength_details: { name: string; rating: number };
        price_range: {
          minimum_price: {
            regular_price: { value: number; currency: Types.ICurrencyEnum };
            final_price: { value: number; currency: Types.ICurrencyEnum };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
          maximum_price: {
            discount: { amount_off: number; percent_off: number };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
        };
      }
    | {
        subscription: number;
        subscription_format: string;
        enable_order_quantity_limit: number;
        order_quantity_limit: number;
        strength: number;
        description: { html: string };
        short_description: { html: string };
        categories: Array<{ name: string; uid: string }>;
        image: { url: string };
        strength_details: { name: string; rating: number };
        price_range: {
          minimum_price: {
            regular_price: { value: number; currency: Types.ICurrencyEnum };
            final_price: { value: number; currency: Types.ICurrencyEnum };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
          maximum_price: {
            discount: { amount_off: number; percent_off: number };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
        };
      }
    | {
        subscription: number;
        subscription_format: string;
        enable_order_quantity_limit: number;
        order_quantity_limit: number;
        strength: number;
        description: { html: string };
        short_description: { html: string };
        categories: Array<{ name: string; uid: string }>;
        image: { url: string };
        strength_details: { name: string; rating: number };
        price_range: {
          minimum_price: {
            regular_price: { value: number; currency: Types.ICurrencyEnum };
            final_price: { value: number; currency: Types.ICurrencyEnum };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
          maximum_price: {
            discount: { amount_off: number; percent_off: number };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
        };
      }
    | {
        subscription: number;
        subscription_format: string;
        enable_order_quantity_limit: number;
        order_quantity_limit: number;
        strength: number;
        description: { html: string };
        short_description: { html: string };
        categories: Array<{ name: string; uid: string }>;
        image: { url: string };
        strength_details: { name: string; rating: number };
        price_range: {
          minimum_price: {
            regular_price: { value: number; currency: Types.ICurrencyEnum };
            final_price: { value: number; currency: Types.ICurrencyEnum };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
          maximum_price: {
            discount: { amount_off: number; percent_off: number };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
        };
      }
    | {
        subscription: number;
        subscription_format: string;
        enable_order_quantity_limit: number;
        order_quantity_limit: number;
        strength: number;
        description: { html: string };
        short_description: { html: string };
        categories: Array<{ name: string; uid: string }>;
        image: { url: string };
        strength_details: { name: string; rating: number };
        price_range: {
          minimum_price: {
            regular_price: { value: number; currency: Types.ICurrencyEnum };
            final_price: { value: number; currency: Types.ICurrencyEnum };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
          maximum_price: {
            discount: { amount_off: number; percent_off: number };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
        };
      }
    | {
        subscription: number;
        subscription_format: string;
        enable_order_quantity_limit: number;
        order_quantity_limit: number;
        strength: number;
        description: { html: string };
        short_description: { html: string };
        categories: Array<{ name: string; uid: string }>;
        image: { url: string };
        strength_details: { name: string; rating: number };
        price_range: {
          minimum_price: {
            regular_price: { value: number; currency: Types.ICurrencyEnum };
            final_price: { value: number; currency: Types.ICurrencyEnum };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
          maximum_price: {
            discount: { amount_off: number; percent_off: number };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
        };
      }
    | {
        subscription: number;
        subscription_format: string;
        enable_order_quantity_limit: number;
        order_quantity_limit: number;
        strength: number;
        description: { html: string };
        short_description: { html: string };
        categories: Array<{ name: string; uid: string }>;
        image: { url: string };
        strength_details: { name: string; rating: number };
        price_range: {
          minimum_price: {
            regular_price: { value: number; currency: Types.ICurrencyEnum };
            final_price: { value: number; currency: Types.ICurrencyEnum };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
          maximum_price: {
            discount: { amount_off: number; percent_off: number };
            fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
          };
        };
      };
};

export type ICustomerOrderItemFragmentFragment =
  | ICustomerOrderItemFragment_BundleOrderItem_Fragment
  | ICustomerOrderItemFragment_ConfigurableOrderItem_Fragment
  | ICustomerOrderItemFragment_DownloadableOrderItem_Fragment
  | ICustomerOrderItemFragment_GiftCardOrderItem_Fragment
  | ICustomerOrderItemFragment_OrderItem_Fragment;

export type ICustomerOrderProductFragment_BundleProduct_Fragment = {
  subscription: number;
  subscription_format: string;
  enable_order_quantity_limit: number;
  order_quantity_limit: number;
  strength: number;
  description: { html: string };
  short_description: { html: string };
  categories: Array<{ name: string; uid: string }>;
  image: { url: string };
  strength_details: { name: string; rating: number };
  price_range: {
    minimum_price: {
      regular_price: { value: number; currency: Types.ICurrencyEnum };
      final_price: { value: number; currency: Types.ICurrencyEnum };
      fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
    };
    maximum_price: {
      discount: { amount_off: number; percent_off: number };
      fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
    };
  };
};

export type ICustomerOrderProductFragment_ConfigurableProduct_Fragment = {
  subscription: number;
  subscription_format: string;
  enable_order_quantity_limit: number;
  order_quantity_limit: number;
  strength: number;
  description: { html: string };
  short_description: { html: string };
  categories: Array<{ name: string; uid: string }>;
  image: { url: string };
  strength_details: { name: string; rating: number };
  price_range: {
    minimum_price: {
      regular_price: { value: number; currency: Types.ICurrencyEnum };
      final_price: { value: number; currency: Types.ICurrencyEnum };
      fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
    };
    maximum_price: {
      discount: { amount_off: number; percent_off: number };
      fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
    };
  };
};

export type ICustomerOrderProductFragment_DownloadableProduct_Fragment = {
  subscription: number;
  subscription_format: string;
  enable_order_quantity_limit: number;
  order_quantity_limit: number;
  strength: number;
  description: { html: string };
  short_description: { html: string };
  categories: Array<{ name: string; uid: string }>;
  image: { url: string };
  strength_details: { name: string; rating: number };
  price_range: {
    minimum_price: {
      regular_price: { value: number; currency: Types.ICurrencyEnum };
      final_price: { value: number; currency: Types.ICurrencyEnum };
      fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
    };
    maximum_price: {
      discount: { amount_off: number; percent_off: number };
      fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
    };
  };
};

export type ICustomerOrderProductFragment_GiftCardProduct_Fragment = {
  subscription: number;
  subscription_format: string;
  enable_order_quantity_limit: number;
  order_quantity_limit: number;
  strength: number;
  description: { html: string };
  short_description: { html: string };
  categories: Array<{ name: string; uid: string }>;
  image: { url: string };
  strength_details: { name: string; rating: number };
  price_range: {
    minimum_price: {
      regular_price: { value: number; currency: Types.ICurrencyEnum };
      final_price: { value: number; currency: Types.ICurrencyEnum };
      fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
    };
    maximum_price: {
      discount: { amount_off: number; percent_off: number };
      fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
    };
  };
};

export type ICustomerOrderProductFragment_GroupedProduct_Fragment = {
  subscription: number;
  subscription_format: string;
  enable_order_quantity_limit: number;
  order_quantity_limit: number;
  strength: number;
  description: { html: string };
  short_description: { html: string };
  categories: Array<{ name: string; uid: string }>;
  image: { url: string };
  strength_details: { name: string; rating: number };
  price_range: {
    minimum_price: {
      regular_price: { value: number; currency: Types.ICurrencyEnum };
      final_price: { value: number; currency: Types.ICurrencyEnum };
      fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
    };
    maximum_price: {
      discount: { amount_off: number; percent_off: number };
      fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
    };
  };
};

export type ICustomerOrderProductFragment_SimpleProduct_Fragment = {
  subscription: number;
  subscription_format: string;
  enable_order_quantity_limit: number;
  order_quantity_limit: number;
  strength: number;
  description: { html: string };
  short_description: { html: string };
  categories: Array<{ name: string; uid: string }>;
  image: { url: string };
  strength_details: { name: string; rating: number };
  price_range: {
    minimum_price: {
      regular_price: { value: number; currency: Types.ICurrencyEnum };
      final_price: { value: number; currency: Types.ICurrencyEnum };
      fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
    };
    maximum_price: {
      discount: { amount_off: number; percent_off: number };
      fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
    };
  };
};

export type ICustomerOrderProductFragment_VirtualProduct_Fragment = {
  subscription: number;
  subscription_format: string;
  enable_order_quantity_limit: number;
  order_quantity_limit: number;
  strength: number;
  description: { html: string };
  short_description: { html: string };
  categories: Array<{ name: string; uid: string }>;
  image: { url: string };
  strength_details: { name: string; rating: number };
  price_range: {
    minimum_price: {
      regular_price: { value: number; currency: Types.ICurrencyEnum };
      final_price: { value: number; currency: Types.ICurrencyEnum };
      fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
    };
    maximum_price: {
      discount: { amount_off: number; percent_off: number };
      fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
    };
  };
};

export type ICustomerOrderProductFragmentFragment =
  | ICustomerOrderProductFragment_BundleProduct_Fragment
  | ICustomerOrderProductFragment_ConfigurableProduct_Fragment
  | ICustomerOrderProductFragment_DownloadableProduct_Fragment
  | ICustomerOrderProductFragment_GiftCardProduct_Fragment
  | ICustomerOrderProductFragment_GroupedProduct_Fragment
  | ICustomerOrderProductFragment_SimpleProduct_Fragment
  | ICustomerOrderProductFragment_VirtualProduct_Fragment;

export type ICustomerOrderPriceRangeFragmentFragment = {
  minimum_price: {
    regular_price: { value: number; currency: Types.ICurrencyEnum };
    final_price: { value: number; currency: Types.ICurrencyEnum };
    fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
  };
  maximum_price: {
    discount: { amount_off: number; percent_off: number };
    fixed_product_taxes: Array<{ label: string; amount: { value: number; currency: Types.ICurrencyEnum } }>;
  };
};

export type ICustomerOrderBillingAddressFragmentFragment = {
  city: string;
  country_code: Types.ICountryCodeEnum;
  firstname: string;
  lastname: string;
  postcode: string;
  street: Array<string>;
  telephone: string;
  administrative_area_level_2: string;
  sublocality_level_2: string;
  premise: string;
  neighborhood: string;
  landmark: string;
  building_number: string;
  district: string;
  region: string;
  short_address: string;
};

export type ICustomerOrderShippingAddressFragmentFragment = {
  city: string;
  country_code: Types.ICountryCodeEnum;
  firstname: string;
  lastname: string;
  postcode: string;
  street: Array<string>;
  telephone: string;
  pickup_information: string;
  administrative_area_level_2: string;
  sublocality_level_2: string;
  premise: string;
  neighborhood: string;
  landmark: string;
  building_number: string;
  district: string;
  region: string;
  short_address: string;
};

export type ICustomerOrderTotalFragmentFragment = {
  discounts: Array<{ label: string; coupon_code: string; amount: { currency: Types.ICurrencyEnum; value: number } }>;
  grand_total: { currency: Types.ICurrencyEnum; value: number };
  subtotal: { currency: Types.ICurrencyEnum; value: number };
  subtotal_incl_tax: { currency: Types.ICurrencyEnum; value: number };
  taxes: Array<{ title: string; rate: number; amount: { currency: Types.ICurrencyEnum; value: number } }>;
  total_shipping: { currency: Types.ICurrencyEnum; value: number };
  total_refunded: { currency: Types.ICurrencyEnum; value: number };
  total_tax: { currency: Types.ICurrencyEnum; value: number };
};

export type IAddBundleProductsToCartMutationVariables = Exact<{
  cartId: string;
  cartItems: Array<Types.IBundleProductCartItemInput> | Types.IBundleProductCartItemInput;
}>;

export type IAddBundleProductsToCartMutation = { addBundleProductsToCart: { cart: { id: string } } };

export type IAddConfigurableProductsToCartMutationVariables = Exact<{
  cartId: string;
  sku: string;
  parentSku: string;
  quantity: number;
}>;

export type IAddConfigurableProductsToCartMutation = { addConfigurableProductsToCart: { cart: { id: string } } };

export type IAddProductsToCartMutationVariables = Exact<{
  cartId: string;
  cartItems: Array<Types.ICartItemInput> | Types.ICartItemInput;
}>;

export type IAddProductsToCartMutation = { addProductsToCart: { cart: { id: string } } };

export type IAddSimpleProductsToCartMutationVariables = Exact<{
  cartId: string;
  cartItems: Array<Types.ISimpleProductCartItemInput> | Types.ISimpleProductCartItemInput;
}>;

export type IAddSimpleProductsToCartMutation = { addSimpleProductsToCart: { cart: { id: string } } };

export type IApplyCampaignToCartMutationVariables = Exact<{
  cartId: string;
  campaign_uuid: string;
}>;

export type IApplyCampaignToCartMutation = {
  applyCampaignToCart: {
    cart: {
      id: string;
      is_virtual: boolean;
      applied_campaign: {
        loyalty_discount_uuid: string;
        loyalty_discount_points: number | null;
        loyalty_discount_amount: number;
      };
      items: Array<
        | {
            quantity: number;
            product:
              | { sku: string }
              | { sku: string }
              | { sku: string }
              | { sku: string }
              | { sku: string }
              | { sku: string }
              | { sku: string };
          }
        | {
            quantity: number;
            product:
              | { sku: string }
              | { sku: string }
              | { sku: string }
              | { sku: string }
              | { sku: string }
              | { sku: string }
              | { sku: string };
          }
        | {
            quantity: number;
            product:
              | { sku: string }
              | { sku: string }
              | { sku: string }
              | { sku: string }
              | { sku: string }
              | { sku: string }
              | { sku: string };
          }
        | {
            quantity: number;
            product:
              | { sku: string }
              | { sku: string }
              | { sku: string }
              | { sku: string }
              | { sku: string }
              | { sku: string }
              | { sku: string };
          }
        | {
            quantity: number;
            product:
              | { sku: string }
              | { sku: string }
              | { sku: string }
              | { sku: string }
              | { sku: string }
              | { sku: string }
              | { sku: string };
          }
        | {
            quantity: number;
            product:
              | { sku: string }
              | { sku: string }
              | { sku: string }
              | { sku: string }
              | { sku: string }
              | { sku: string }
              | { sku: string };
          }
      >;
    };
  };
};

export type IApplyCouponsToCartMutationVariables = Exact<{
  cartId: string;
  couponCodes: Array<string> | string;
}>;

export type IApplyCouponsToCartMutation = {
  applyCouponsToCart: {
    cart: {
      id: string;
      applied_coupons: Array<{ code: string; label: string }>;
      prices: { discounts: Array<{ label: string; amount: { currency: Types.ICurrencyEnum; value: number } }> };
    };
  };
};

export type ICancelOrderMutationVariables = Exact<{
  orderNumber: string;
}>;

export type ICancelOrderMutation = { cancelorder: boolean };

export type ICreateEmptyCartMutationVariables = Exact<{ [key: string]: never }>;

export type ICreateEmptyCartMutation = { createEmptyCart: string };

export type IGetOrderStatusesQueryVariables = Exact<{ [key: string]: never }>;

export type IGetOrderStatusesQuery = {
  getorderstatus: Array<{ status_label: string; status_value: string; cancelable: boolean }>;
};

export type IMergeCartsMutationVariables = Exact<{
  sourceCartId: string;
  destinationCartId: string;
}>;

export type IMergeCartsMutation = { mergeCarts: { id: string } };

export type IPlaceOrderMutationVariables = Exact<{
  cartId: string;
  additionalAttributes?:
    Array<Types.IOrderAttributeInput | null | undefined> | Types.IOrderAttributeInput | null | undefined;
}>;

export type IPlaceOrderMutation = {
  placeOrder: {
    orderV2: {
      id: string;
      carrier: string;
      number: string;
      order_date: string;
      shipping_method: string;
      shipping_method_code: string;
      status: string;
      items: Array<
        | {
            id: string;
            product_name: string;
            product_sku: string;
            product_type: string;
            quantity_ordered: number;
            trade_in: number;
            bundle_options: Array<{
              id: string;
              label: string;
              values: Array<{
                id: string;
                product_name: string;
                quantity: number;
                presentation_info: {
                  initial_price: number;
                  presentation_price: number;
                  product:
                    | { tooltip_info: string; small_image: { label: string; url: string } }
                    | { tooltip_info: string; small_image: { label: string; url: string } }
                    | { tooltip_info: string; small_image: { label: string; url: string } }
                    | { tooltip_info: string; small_image: { label: string; url: string } }
                    | { tooltip_info: string; small_image: { label: string; url: string } }
                    | { tooltip_info: string; small_image: { label: string; url: string } }
                    | { tooltip_info: string; small_image: { label: string; url: string } };
                };
              }>;
            }>;
            row_total: { currency: Types.ICurrencyEnum; value: number };
            row_total_incl_tax: { currency: Types.ICurrencyEnum; value: number };
            product_sale_price: { currency: Types.ICurrencyEnum; value: number };
            product_sale_price_incl_tax: { currency: Types.ICurrencyEnum; value: number };
            gift_data: { is_gift: boolean; parent_gift_sku: string; parent_gift_id: string };
            product:
              | {
                  subscription: number;
                  subscription_format: string;
                  enable_order_quantity_limit: number;
                  order_quantity_limit: number;
                  strength: number;
                  description: { html: string };
                  short_description: { html: string };
                  categories: Array<{ name: string; uid: string }>;
                  image: { url: string };
                  strength_details: { name: string; rating: number };
                  price_range: {
                    minimum_price: {
                      regular_price: { value: number; currency: Types.ICurrencyEnum };
                      final_price: { value: number; currency: Types.ICurrencyEnum };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                    maximum_price: {
                      discount: { amount_off: number; percent_off: number };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                  };
                }
              | {
                  subscription: number;
                  subscription_format: string;
                  enable_order_quantity_limit: number;
                  order_quantity_limit: number;
                  strength: number;
                  description: { html: string };
                  short_description: { html: string };
                  categories: Array<{ name: string; uid: string }>;
                  image: { url: string };
                  strength_details: { name: string; rating: number };
                  price_range: {
                    minimum_price: {
                      regular_price: { value: number; currency: Types.ICurrencyEnum };
                      final_price: { value: number; currency: Types.ICurrencyEnum };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                    maximum_price: {
                      discount: { amount_off: number; percent_off: number };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                  };
                }
              | {
                  subscription: number;
                  subscription_format: string;
                  enable_order_quantity_limit: number;
                  order_quantity_limit: number;
                  strength: number;
                  description: { html: string };
                  short_description: { html: string };
                  categories: Array<{ name: string; uid: string }>;
                  image: { url: string };
                  strength_details: { name: string; rating: number };
                  price_range: {
                    minimum_price: {
                      regular_price: { value: number; currency: Types.ICurrencyEnum };
                      final_price: { value: number; currency: Types.ICurrencyEnum };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                    maximum_price: {
                      discount: { amount_off: number; percent_off: number };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                  };
                }
              | {
                  subscription: number;
                  subscription_format: string;
                  enable_order_quantity_limit: number;
                  order_quantity_limit: number;
                  strength: number;
                  description: { html: string };
                  short_description: { html: string };
                  categories: Array<{ name: string; uid: string }>;
                  image: { url: string };
                  strength_details: { name: string; rating: number };
                  price_range: {
                    minimum_price: {
                      regular_price: { value: number; currency: Types.ICurrencyEnum };
                      final_price: { value: number; currency: Types.ICurrencyEnum };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                    maximum_price: {
                      discount: { amount_off: number; percent_off: number };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                  };
                }
              | {
                  subscription: number;
                  subscription_format: string;
                  enable_order_quantity_limit: number;
                  order_quantity_limit: number;
                  strength: number;
                  description: { html: string };
                  short_description: { html: string };
                  categories: Array<{ name: string; uid: string }>;
                  image: { url: string };
                  strength_details: { name: string; rating: number };
                  price_range: {
                    minimum_price: {
                      regular_price: { value: number; currency: Types.ICurrencyEnum };
                      final_price: { value: number; currency: Types.ICurrencyEnum };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                    maximum_price: {
                      discount: { amount_off: number; percent_off: number };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                  };
                }
              | {
                  subscription: number;
                  subscription_format: string;
                  enable_order_quantity_limit: number;
                  order_quantity_limit: number;
                  strength: number;
                  description: { html: string };
                  short_description: { html: string };
                  categories: Array<{ name: string; uid: string }>;
                  image: { url: string };
                  strength_details: { name: string; rating: number };
                  price_range: {
                    minimum_price: {
                      regular_price: { value: number; currency: Types.ICurrencyEnum };
                      final_price: { value: number; currency: Types.ICurrencyEnum };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                    maximum_price: {
                      discount: { amount_off: number; percent_off: number };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                  };
                }
              | {
                  subscription: number;
                  subscription_format: string;
                  enable_order_quantity_limit: number;
                  order_quantity_limit: number;
                  strength: number;
                  description: { html: string };
                  short_description: { html: string };
                  categories: Array<{ name: string; uid: string }>;
                  image: { url: string };
                  strength_details: { name: string; rating: number };
                  price_range: {
                    minimum_price: {
                      regular_price: { value: number; currency: Types.ICurrencyEnum };
                      final_price: { value: number; currency: Types.ICurrencyEnum };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                    maximum_price: {
                      discount: { amount_off: number; percent_off: number };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                  };
                };
          }
        | {
            id: string;
            product_name: string;
            product_sku: string;
            product_type: string;
            quantity_ordered: number;
            trade_in: number;
            row_total: { currency: Types.ICurrencyEnum; value: number };
            row_total_incl_tax: { currency: Types.ICurrencyEnum; value: number };
            product_sale_price: { currency: Types.ICurrencyEnum; value: number };
            product_sale_price_incl_tax: { currency: Types.ICurrencyEnum; value: number };
            gift_data: { is_gift: boolean; parent_gift_sku: string; parent_gift_id: string };
            product:
              | {
                  subscription: number;
                  subscription_format: string;
                  enable_order_quantity_limit: number;
                  order_quantity_limit: number;
                  strength: number;
                  description: { html: string };
                  short_description: { html: string };
                  categories: Array<{ name: string; uid: string }>;
                  image: { url: string };
                  strength_details: { name: string; rating: number };
                  price_range: {
                    minimum_price: {
                      regular_price: { value: number; currency: Types.ICurrencyEnum };
                      final_price: { value: number; currency: Types.ICurrencyEnum };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                    maximum_price: {
                      discount: { amount_off: number; percent_off: number };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                  };
                }
              | {
                  subscription: number;
                  subscription_format: string;
                  enable_order_quantity_limit: number;
                  order_quantity_limit: number;
                  strength: number;
                  description: { html: string };
                  short_description: { html: string };
                  categories: Array<{ name: string; uid: string }>;
                  image: { url: string };
                  strength_details: { name: string; rating: number };
                  price_range: {
                    minimum_price: {
                      regular_price: { value: number; currency: Types.ICurrencyEnum };
                      final_price: { value: number; currency: Types.ICurrencyEnum };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                    maximum_price: {
                      discount: { amount_off: number; percent_off: number };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                  };
                }
              | {
                  subscription: number;
                  subscription_format: string;
                  enable_order_quantity_limit: number;
                  order_quantity_limit: number;
                  strength: number;
                  description: { html: string };
                  short_description: { html: string };
                  categories: Array<{ name: string; uid: string }>;
                  image: { url: string };
                  strength_details: { name: string; rating: number };
                  price_range: {
                    minimum_price: {
                      regular_price: { value: number; currency: Types.ICurrencyEnum };
                      final_price: { value: number; currency: Types.ICurrencyEnum };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                    maximum_price: {
                      discount: { amount_off: number; percent_off: number };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                  };
                }
              | {
                  subscription: number;
                  subscription_format: string;
                  enable_order_quantity_limit: number;
                  order_quantity_limit: number;
                  strength: number;
                  description: { html: string };
                  short_description: { html: string };
                  categories: Array<{ name: string; uid: string }>;
                  image: { url: string };
                  strength_details: { name: string; rating: number };
                  price_range: {
                    minimum_price: {
                      regular_price: { value: number; currency: Types.ICurrencyEnum };
                      final_price: { value: number; currency: Types.ICurrencyEnum };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                    maximum_price: {
                      discount: { amount_off: number; percent_off: number };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                  };
                }
              | {
                  subscription: number;
                  subscription_format: string;
                  enable_order_quantity_limit: number;
                  order_quantity_limit: number;
                  strength: number;
                  description: { html: string };
                  short_description: { html: string };
                  categories: Array<{ name: string; uid: string }>;
                  image: { url: string };
                  strength_details: { name: string; rating: number };
                  price_range: {
                    minimum_price: {
                      regular_price: { value: number; currency: Types.ICurrencyEnum };
                      final_price: { value: number; currency: Types.ICurrencyEnum };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                    maximum_price: {
                      discount: { amount_off: number; percent_off: number };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                  };
                }
              | {
                  subscription: number;
                  subscription_format: string;
                  enable_order_quantity_limit: number;
                  order_quantity_limit: number;
                  strength: number;
                  description: { html: string };
                  short_description: { html: string };
                  categories: Array<{ name: string; uid: string }>;
                  image: { url: string };
                  strength_details: { name: string; rating: number };
                  price_range: {
                    minimum_price: {
                      regular_price: { value: number; currency: Types.ICurrencyEnum };
                      final_price: { value: number; currency: Types.ICurrencyEnum };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                    maximum_price: {
                      discount: { amount_off: number; percent_off: number };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                  };
                }
              | {
                  subscription: number;
                  subscription_format: string;
                  enable_order_quantity_limit: number;
                  order_quantity_limit: number;
                  strength: number;
                  description: { html: string };
                  short_description: { html: string };
                  categories: Array<{ name: string; uid: string }>;
                  image: { url: string };
                  strength_details: { name: string; rating: number };
                  price_range: {
                    minimum_price: {
                      regular_price: { value: number; currency: Types.ICurrencyEnum };
                      final_price: { value: number; currency: Types.ICurrencyEnum };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                    maximum_price: {
                      discount: { amount_off: number; percent_off: number };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                  };
                };
          }
        | {
            id: string;
            product_name: string;
            product_sku: string;
            product_type: string;
            quantity_ordered: number;
            trade_in: number;
            row_total: { currency: Types.ICurrencyEnum; value: number };
            row_total_incl_tax: { currency: Types.ICurrencyEnum; value: number };
            product_sale_price: { currency: Types.ICurrencyEnum; value: number };
            product_sale_price_incl_tax: { currency: Types.ICurrencyEnum; value: number };
            gift_data: { is_gift: boolean; parent_gift_sku: string; parent_gift_id: string };
            product:
              | {
                  subscription: number;
                  subscription_format: string;
                  enable_order_quantity_limit: number;
                  order_quantity_limit: number;
                  strength: number;
                  description: { html: string };
                  short_description: { html: string };
                  categories: Array<{ name: string; uid: string }>;
                  image: { url: string };
                  strength_details: { name: string; rating: number };
                  price_range: {
                    minimum_price: {
                      regular_price: { value: number; currency: Types.ICurrencyEnum };
                      final_price: { value: number; currency: Types.ICurrencyEnum };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                    maximum_price: {
                      discount: { amount_off: number; percent_off: number };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                  };
                }
              | {
                  subscription: number;
                  subscription_format: string;
                  enable_order_quantity_limit: number;
                  order_quantity_limit: number;
                  strength: number;
                  description: { html: string };
                  short_description: { html: string };
                  categories: Array<{ name: string; uid: string }>;
                  image: { url: string };
                  strength_details: { name: string; rating: number };
                  price_range: {
                    minimum_price: {
                      regular_price: { value: number; currency: Types.ICurrencyEnum };
                      final_price: { value: number; currency: Types.ICurrencyEnum };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                    maximum_price: {
                      discount: { amount_off: number; percent_off: number };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                  };
                }
              | {
                  subscription: number;
                  subscription_format: string;
                  enable_order_quantity_limit: number;
                  order_quantity_limit: number;
                  strength: number;
                  description: { html: string };
                  short_description: { html: string };
                  categories: Array<{ name: string; uid: string }>;
                  image: { url: string };
                  strength_details: { name: string; rating: number };
                  price_range: {
                    minimum_price: {
                      regular_price: { value: number; currency: Types.ICurrencyEnum };
                      final_price: { value: number; currency: Types.ICurrencyEnum };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                    maximum_price: {
                      discount: { amount_off: number; percent_off: number };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                  };
                }
              | {
                  subscription: number;
                  subscription_format: string;
                  enable_order_quantity_limit: number;
                  order_quantity_limit: number;
                  strength: number;
                  description: { html: string };
                  short_description: { html: string };
                  categories: Array<{ name: string; uid: string }>;
                  image: { url: string };
                  strength_details: { name: string; rating: number };
                  price_range: {
                    minimum_price: {
                      regular_price: { value: number; currency: Types.ICurrencyEnum };
                      final_price: { value: number; currency: Types.ICurrencyEnum };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                    maximum_price: {
                      discount: { amount_off: number; percent_off: number };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                  };
                }
              | {
                  subscription: number;
                  subscription_format: string;
                  enable_order_quantity_limit: number;
                  order_quantity_limit: number;
                  strength: number;
                  description: { html: string };
                  short_description: { html: string };
                  categories: Array<{ name: string; uid: string }>;
                  image: { url: string };
                  strength_details: { name: string; rating: number };
                  price_range: {
                    minimum_price: {
                      regular_price: { value: number; currency: Types.ICurrencyEnum };
                      final_price: { value: number; currency: Types.ICurrencyEnum };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                    maximum_price: {
                      discount: { amount_off: number; percent_off: number };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                  };
                }
              | {
                  subscription: number;
                  subscription_format: string;
                  enable_order_quantity_limit: number;
                  order_quantity_limit: number;
                  strength: number;
                  description: { html: string };
                  short_description: { html: string };
                  categories: Array<{ name: string; uid: string }>;
                  image: { url: string };
                  strength_details: { name: string; rating: number };
                  price_range: {
                    minimum_price: {
                      regular_price: { value: number; currency: Types.ICurrencyEnum };
                      final_price: { value: number; currency: Types.ICurrencyEnum };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                    maximum_price: {
                      discount: { amount_off: number; percent_off: number };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                  };
                }
              | {
                  subscription: number;
                  subscription_format: string;
                  enable_order_quantity_limit: number;
                  order_quantity_limit: number;
                  strength: number;
                  description: { html: string };
                  short_description: { html: string };
                  categories: Array<{ name: string; uid: string }>;
                  image: { url: string };
                  strength_details: { name: string; rating: number };
                  price_range: {
                    minimum_price: {
                      regular_price: { value: number; currency: Types.ICurrencyEnum };
                      final_price: { value: number; currency: Types.ICurrencyEnum };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                    maximum_price: {
                      discount: { amount_off: number; percent_off: number };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                  };
                };
          }
        | {
            id: string;
            product_name: string;
            product_sku: string;
            product_type: string;
            quantity_ordered: number;
            trade_in: number;
            row_total: { currency: Types.ICurrencyEnum; value: number };
            row_total_incl_tax: { currency: Types.ICurrencyEnum; value: number };
            product_sale_price: { currency: Types.ICurrencyEnum; value: number };
            product_sale_price_incl_tax: { currency: Types.ICurrencyEnum; value: number };
            gift_data: { is_gift: boolean; parent_gift_sku: string; parent_gift_id: string };
            product:
              | {
                  subscription: number;
                  subscription_format: string;
                  enable_order_quantity_limit: number;
                  order_quantity_limit: number;
                  strength: number;
                  description: { html: string };
                  short_description: { html: string };
                  categories: Array<{ name: string; uid: string }>;
                  image: { url: string };
                  strength_details: { name: string; rating: number };
                  price_range: {
                    minimum_price: {
                      regular_price: { value: number; currency: Types.ICurrencyEnum };
                      final_price: { value: number; currency: Types.ICurrencyEnum };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                    maximum_price: {
                      discount: { amount_off: number; percent_off: number };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                  };
                }
              | {
                  subscription: number;
                  subscription_format: string;
                  enable_order_quantity_limit: number;
                  order_quantity_limit: number;
                  strength: number;
                  description: { html: string };
                  short_description: { html: string };
                  categories: Array<{ name: string; uid: string }>;
                  image: { url: string };
                  strength_details: { name: string; rating: number };
                  price_range: {
                    minimum_price: {
                      regular_price: { value: number; currency: Types.ICurrencyEnum };
                      final_price: { value: number; currency: Types.ICurrencyEnum };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                    maximum_price: {
                      discount: { amount_off: number; percent_off: number };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                  };
                }
              | {
                  subscription: number;
                  subscription_format: string;
                  enable_order_quantity_limit: number;
                  order_quantity_limit: number;
                  strength: number;
                  description: { html: string };
                  short_description: { html: string };
                  categories: Array<{ name: string; uid: string }>;
                  image: { url: string };
                  strength_details: { name: string; rating: number };
                  price_range: {
                    minimum_price: {
                      regular_price: { value: number; currency: Types.ICurrencyEnum };
                      final_price: { value: number; currency: Types.ICurrencyEnum };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                    maximum_price: {
                      discount: { amount_off: number; percent_off: number };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                  };
                }
              | {
                  subscription: number;
                  subscription_format: string;
                  enable_order_quantity_limit: number;
                  order_quantity_limit: number;
                  strength: number;
                  description: { html: string };
                  short_description: { html: string };
                  categories: Array<{ name: string; uid: string }>;
                  image: { url: string };
                  strength_details: { name: string; rating: number };
                  price_range: {
                    minimum_price: {
                      regular_price: { value: number; currency: Types.ICurrencyEnum };
                      final_price: { value: number; currency: Types.ICurrencyEnum };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                    maximum_price: {
                      discount: { amount_off: number; percent_off: number };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                  };
                }
              | {
                  subscription: number;
                  subscription_format: string;
                  enable_order_quantity_limit: number;
                  order_quantity_limit: number;
                  strength: number;
                  description: { html: string };
                  short_description: { html: string };
                  categories: Array<{ name: string; uid: string }>;
                  image: { url: string };
                  strength_details: { name: string; rating: number };
                  price_range: {
                    minimum_price: {
                      regular_price: { value: number; currency: Types.ICurrencyEnum };
                      final_price: { value: number; currency: Types.ICurrencyEnum };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                    maximum_price: {
                      discount: { amount_off: number; percent_off: number };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                  };
                }
              | {
                  subscription: number;
                  subscription_format: string;
                  enable_order_quantity_limit: number;
                  order_quantity_limit: number;
                  strength: number;
                  description: { html: string };
                  short_description: { html: string };
                  categories: Array<{ name: string; uid: string }>;
                  image: { url: string };
                  strength_details: { name: string; rating: number };
                  price_range: {
                    minimum_price: {
                      regular_price: { value: number; currency: Types.ICurrencyEnum };
                      final_price: { value: number; currency: Types.ICurrencyEnum };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                    maximum_price: {
                      discount: { amount_off: number; percent_off: number };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                  };
                }
              | {
                  subscription: number;
                  subscription_format: string;
                  enable_order_quantity_limit: number;
                  order_quantity_limit: number;
                  strength: number;
                  description: { html: string };
                  short_description: { html: string };
                  categories: Array<{ name: string; uid: string }>;
                  image: { url: string };
                  strength_details: { name: string; rating: number };
                  price_range: {
                    minimum_price: {
                      regular_price: { value: number; currency: Types.ICurrencyEnum };
                      final_price: { value: number; currency: Types.ICurrencyEnum };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                    maximum_price: {
                      discount: { amount_off: number; percent_off: number };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                  };
                };
          }
        | {
            id: string;
            product_name: string;
            product_sku: string;
            product_type: string;
            quantity_ordered: number;
            trade_in: number;
            row_total: { currency: Types.ICurrencyEnum; value: number };
            row_total_incl_tax: { currency: Types.ICurrencyEnum; value: number };
            product_sale_price: { currency: Types.ICurrencyEnum; value: number };
            product_sale_price_incl_tax: { currency: Types.ICurrencyEnum; value: number };
            gift_data: { is_gift: boolean; parent_gift_sku: string; parent_gift_id: string };
            product:
              | {
                  subscription: number;
                  subscription_format: string;
                  enable_order_quantity_limit: number;
                  order_quantity_limit: number;
                  strength: number;
                  description: { html: string };
                  short_description: { html: string };
                  categories: Array<{ name: string; uid: string }>;
                  image: { url: string };
                  strength_details: { name: string; rating: number };
                  price_range: {
                    minimum_price: {
                      regular_price: { value: number; currency: Types.ICurrencyEnum };
                      final_price: { value: number; currency: Types.ICurrencyEnum };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                    maximum_price: {
                      discount: { amount_off: number; percent_off: number };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                  };
                }
              | {
                  subscription: number;
                  subscription_format: string;
                  enable_order_quantity_limit: number;
                  order_quantity_limit: number;
                  strength: number;
                  description: { html: string };
                  short_description: { html: string };
                  categories: Array<{ name: string; uid: string }>;
                  image: { url: string };
                  strength_details: { name: string; rating: number };
                  price_range: {
                    minimum_price: {
                      regular_price: { value: number; currency: Types.ICurrencyEnum };
                      final_price: { value: number; currency: Types.ICurrencyEnum };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                    maximum_price: {
                      discount: { amount_off: number; percent_off: number };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                  };
                }
              | {
                  subscription: number;
                  subscription_format: string;
                  enable_order_quantity_limit: number;
                  order_quantity_limit: number;
                  strength: number;
                  description: { html: string };
                  short_description: { html: string };
                  categories: Array<{ name: string; uid: string }>;
                  image: { url: string };
                  strength_details: { name: string; rating: number };
                  price_range: {
                    minimum_price: {
                      regular_price: { value: number; currency: Types.ICurrencyEnum };
                      final_price: { value: number; currency: Types.ICurrencyEnum };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                    maximum_price: {
                      discount: { amount_off: number; percent_off: number };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                  };
                }
              | {
                  subscription: number;
                  subscription_format: string;
                  enable_order_quantity_limit: number;
                  order_quantity_limit: number;
                  strength: number;
                  description: { html: string };
                  short_description: { html: string };
                  categories: Array<{ name: string; uid: string }>;
                  image: { url: string };
                  strength_details: { name: string; rating: number };
                  price_range: {
                    minimum_price: {
                      regular_price: { value: number; currency: Types.ICurrencyEnum };
                      final_price: { value: number; currency: Types.ICurrencyEnum };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                    maximum_price: {
                      discount: { amount_off: number; percent_off: number };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                  };
                }
              | {
                  subscription: number;
                  subscription_format: string;
                  enable_order_quantity_limit: number;
                  order_quantity_limit: number;
                  strength: number;
                  description: { html: string };
                  short_description: { html: string };
                  categories: Array<{ name: string; uid: string }>;
                  image: { url: string };
                  strength_details: { name: string; rating: number };
                  price_range: {
                    minimum_price: {
                      regular_price: { value: number; currency: Types.ICurrencyEnum };
                      final_price: { value: number; currency: Types.ICurrencyEnum };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                    maximum_price: {
                      discount: { amount_off: number; percent_off: number };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                  };
                }
              | {
                  subscription: number;
                  subscription_format: string;
                  enable_order_quantity_limit: number;
                  order_quantity_limit: number;
                  strength: number;
                  description: { html: string };
                  short_description: { html: string };
                  categories: Array<{ name: string; uid: string }>;
                  image: { url: string };
                  strength_details: { name: string; rating: number };
                  price_range: {
                    minimum_price: {
                      regular_price: { value: number; currency: Types.ICurrencyEnum };
                      final_price: { value: number; currency: Types.ICurrencyEnum };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                    maximum_price: {
                      discount: { amount_off: number; percent_off: number };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                  };
                }
              | {
                  subscription: number;
                  subscription_format: string;
                  enable_order_quantity_limit: number;
                  order_quantity_limit: number;
                  strength: number;
                  description: { html: string };
                  short_description: { html: string };
                  categories: Array<{ name: string; uid: string }>;
                  image: { url: string };
                  strength_details: { name: string; rating: number };
                  price_range: {
                    minimum_price: {
                      regular_price: { value: number; currency: Types.ICurrencyEnum };
                      final_price: { value: number; currency: Types.ICurrencyEnum };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                    maximum_price: {
                      discount: { amount_off: number; percent_off: number };
                      fixed_product_taxes: Array<{
                        label: string;
                        amount: { value: number; currency: Types.ICurrencyEnum };
                      }>;
                    };
                  };
                };
          }
      >;
      payment_methods: Array<{ type: string; name: string; additional_data: Array<{ name: string; value: string }> }>;
      additional_attributes: Array<{ attribute_code: string; value: string }>;
      billing_address: {
        city: string;
        country_code: Types.ICountryCodeEnum;
        firstname: string;
        lastname: string;
        postcode: string;
        street: Array<string>;
        telephone: string;
        administrative_area_level_2: string;
        sublocality_level_2: string;
        premise: string;
        neighborhood: string;
        landmark: string;
        building_number: string;
        district: string;
        region: string;
        short_address: string;
      };
      shipping_address: {
        city: string;
        country_code: Types.ICountryCodeEnum;
        firstname: string;
        lastname: string;
        postcode: string;
        street: Array<string>;
        telephone: string;
        pickup_information: string;
        administrative_area_level_2: string;
        sublocality_level_2: string;
        premise: string;
        neighborhood: string;
        landmark: string;
        building_number: string;
        district: string;
        region: string;
        short_address: string;
      };
      loyalty_info: {
        loyalty_discount_amount: number;
        loyalty_discount_points: number | null;
        loyalty_discount_uuid: string;
      };
      invoices: Array<{ url: string }>;
      total: {
        discounts: Array<{
          label: string;
          coupon_code: string;
          amount: { currency: Types.ICurrencyEnum; value: number };
        }>;
        grand_total: { currency: Types.ICurrencyEnum; value: number };
        subtotal: { currency: Types.ICurrencyEnum; value: number };
        subtotal_incl_tax: { currency: Types.ICurrencyEnum; value: number };
        taxes: Array<{ title: string; rate: number; amount: { currency: Types.ICurrencyEnum; value: number } }>;
        total_shipping: { currency: Types.ICurrencyEnum; value: number };
        total_refunded: { currency: Types.ICurrencyEnum; value: number };
        total_tax: { currency: Types.ICurrencyEnum; value: number };
      };
      total_including_trial: {
        total: { currency: Types.ICurrencyEnum; value: number };
        total_incl_tax: { currency: Types.ICurrencyEnum; value: number };
        tax: { currency: Types.ICurrencyEnum; value: number };
      };
      total_after_trial: {
        total: { currency: Types.ICurrencyEnum; value: number };
        total_incl_tax: { currency: Types.ICurrencyEnum; value: number };
        tax: { currency: Types.ICurrencyEnum; value: number };
      };
    };
    errors: Array<{ message: string; code: Types.IPlaceOrderErrorCodes }>;
  };
};

export type IRemoveCampaignFromCartMutationVariables = Exact<{
  cartId: string;
}>;

export type IRemoveCampaignFromCartMutation = {
  removeCampaignFromCart: {
    cart: {
      id: string;
      is_virtual: boolean;
      applied_campaign: {
        loyalty_discount_uuid: string;
        loyalty_discount_points: number | null;
        loyalty_discount_amount: number;
      };
      items: Array<
        | {
            quantity: number;
            product:
              | { sku: string }
              | { sku: string }
              | { sku: string }
              | { sku: string }
              | { sku: string }
              | { sku: string }
              | { sku: string };
          }
        | {
            quantity: number;
            product:
              | { sku: string }
              | { sku: string }
              | { sku: string }
              | { sku: string }
              | { sku: string }
              | { sku: string }
              | { sku: string };
          }
        | {
            quantity: number;
            product:
              | { sku: string }
              | { sku: string }
              | { sku: string }
              | { sku: string }
              | { sku: string }
              | { sku: string }
              | { sku: string };
          }
        | {
            quantity: number;
            product:
              | { sku: string }
              | { sku: string }
              | { sku: string }
              | { sku: string }
              | { sku: string }
              | { sku: string }
              | { sku: string };
          }
        | {
            quantity: number;
            product:
              | { sku: string }
              | { sku: string }
              | { sku: string }
              | { sku: string }
              | { sku: string }
              | { sku: string }
              | { sku: string };
          }
        | {
            quantity: number;
            product:
              | { sku: string }
              | { sku: string }
              | { sku: string }
              | { sku: string }
              | { sku: string }
              | { sku: string }
              | { sku: string };
          }
      >;
    };
  };
};

export type IRemoveCouponsFromCartMutationVariables = Exact<{
  cartId: string;
  couponCodes: Array<string> | string;
}>;

export type IRemoveCouponsFromCartMutation = {
  removeCouponsFromCart: {
    cart: {
      id: string;
      applied_coupons: Array<{ code: string }>;
      prices: { discounts: Array<{ label: string; amount: { currency: Types.ICurrencyEnum; value: number } }> };
    };
  };
};

export type IRemoveItemFromCartMutationVariables = Exact<{
  cartId: string;
  itemId: number;
}>;

export type IRemoveItemFromCartMutation = { removeItemFromCart: { cart: { id: string } } };

export type ISetAdditionalAttributesMutationVariables = Exact<{
  cartId: string;
  additionalAttributes: Array<Types.IQuoteAttributeInput> | Types.IQuoteAttributeInput;
}>;

export type ISetAdditionalAttributesMutation = {
  setAdditionalAttributes: { errors: Array<{ code: string; message: string }> };
};

export type ISetAddressesOnCartMutationVariables = Exact<{
  cartId: string;
  shipping_addresses: Types.ICartAddressInput;
  billing_address: Types.ICartAddressInput;
}>;

export type ISetAddressesOnCartMutation = {
  setShippingAddressesOnCart: { cart: { id: string } };
  setBillingAddressOnCart: { cart: { id: string } };
};

export type ISetBillingAddressOnCartMutationVariables = Exact<{
  cartId: string;
  address: Types.ICartAddressInput;
}>;

export type ISetBillingAddressOnCartMutation = { setBillingAddressOnCart: { cart: { id: string } } };

export type ISetBillingAddressOnCartByAddressIdMutationVariables = Exact<{
  cartId: string;
  customer_address_id: number;
}>;

export type ISetBillingAddressOnCartByAddressIdMutation = { setBillingAddressOnCart: { cart: { id: string } } };

export type ISetCheckoutFastFlowCartMutationVariables = Exact<{
  cartId: string;
  shippingAddress: Types.ICartAddressInput;
  billingAddress: Types.ICartAddressInput;
  carrierCode: string;
  methodCode: string;
}>;

export type ISetCheckoutFastFlowCartMutation = {
  setShippingAddressesOnCart: { cart: { id: string } };
  setShippingMethodsOnCart: { cart: { id: string } };
  setBillingAddressOnCart: { cart: { id: string } };
};

export type ISetPaymentMethodOnCartMutationVariables = Exact<{
  cartId: string;
  code: string;
}>;

export type ISetPaymentMethodOnCartMutation = {
  setPaymentMethodOnCart: { cart: { selected_payment_method: { code: string } } };
};

export type ISetShippingAddressesOnCartMutationVariables = Exact<{
  cartId: string;
  address: Types.ICartAddressInput;
}>;

export type ISetShippingAddressesOnCartMutation = { setShippingAddressesOnCart: { cart: { id: string } } };

export type ISetShippingAddressesOnCartByAddressIdMutationVariables = Exact<{
  cartId: string;
  customer_address_id: number;
}>;

export type ISetShippingAddressesOnCartByAddressIdMutation = { setShippingAddressesOnCart: { cart: { id: string } } };

export type ISetShippingAddressesOnCartWithMethodsMutationVariables = Exact<{
  cartId: string;
  address: Types.ICartAddressInput;
}>;

export type ISetShippingAddressesOnCartWithMethodsMutation = {
  setShippingAddressesOnCart: {
    cart: {
      shipping_addresses: Array<{
        available_shipping_methods: Array<{
          available: boolean;
          disable_for_subscription: boolean;
          carrier_code: string;
          carrier_title: string;
          method_code: string;
          method_title: string;
          description: string;
          estimated_delivery_time: string;
          amount: { currency: Types.ICurrencyEnum; value: number };
        }>;
        selected_shipping_method: {
          carrier_code: string;
          method_code: string;
          method_title: string;
          amount: { currency: Types.ICurrencyEnum; value: number };
        };
      }>;
    };
  };
};

export type ISetShippingMethodsOnCartMutationVariables = Exact<{
  cartId: string;
  carrierCode: string;
  methodCode: string;
}>;

export type ISetShippingMethodsOnCartMutation = { setShippingMethodsOnCart: { cart: { id: string } } };

export type IUpdateCartItemQuantityMutationVariables = Exact<{
  cartId: string;
  cartItemId: number;
  quantity: number;
}>;

export type IUpdateCartItemQuantityMutation = { updateCartItems: { cart: { id: string } } };

export type IUpdateCustomerAddressMutationVariables = Exact<{
  addressId: number;
  address: Types.ICustomerAddressInput;
}>;

export type IUpdateCustomerAddressMutation = {
  updateCustomerAddress: {
    city: string;
    company: string;
    country_code: Types.ICountryCodeEnum;
    country_id: string;
    default_billing: boolean;
    default_shipping: boolean;
    firstname: string;
    id: number;
    lastname: string;
    middlename: string;
    postcode: string;
    prefix: string;
    street: Array<string>;
    suffix: string;
    telephone: string;
    region: { region: string; region_code: string; region_id: number };
  };
};

export type IUpdatePaymentMethodMutationVariables = Exact<{
  orderId: string;
  methodCode: string;
}>;

export type IUpdatePaymentMethodMutation = { updatePaymentMethod: { success: boolean } };

export type IGetAvailablePaymentMethodsQueryVariables = Exact<{
  cartId: string;
}>;

export type IGetAvailablePaymentMethodsQuery = {
  cart: { available_payment_methods: Array<{ code: string; title: string }> };
};

export type IGetBrandConsumablesMatrixQueryVariables = Exact<{
  brandCode: string;
}>;

export type IGetBrandConsumablesMatrixQuery = {
  getBrandConsumableMatrix: Array<{
    id: number;
    code: string;
    name: string;
    brandIcon: string;
    isNew: boolean;
    brandLabel: string;
    productBrandOptionId: number;
    brandLabels: Array<{ label: string; language: string }>;
  }>;
};

export type IGetBrandConsumablesQueryVariables = Exact<{
  brandCode: string;
}>;

export type IGetBrandConsumablesQuery = {
  getBrandConsumableMatrix: Array<{
    id: number;
    code: string;
    name: string;
    brandIcon: string;
    brandLabel: string;
    packagingFormats: Array<{
      id: string;
      brandId: string;
      label: string;
      contentsType: string;
      itemsPerPackage: number;
      packagesPerBundle: number;
      formatQuantity: number;
      productTypeName: string;
      icon: string;
    }>;
    items: Array<{
      sku: string;
      brandId: string;
      packagingFormatId: string;
      purchaseType: string;
      sortOrder: number;
      isDefault: boolean;
      flavorDetails: { flavour: number; flavour_label: string; swatch_data: string };
    }>;
  }>;
};

export type IGetCartIdQueryVariables = Exact<{
  cartId: string;
}>;

export type IGetCartIdQuery = { cart: { id: string } };

export type IGetCartItemsQueryVariables = Exact<{
  cartId: string;
}>;

export type IGetCartItemsQuery = {
  cart: {
    available_free_gifts: Array<{
      sales_rule_id: number;
      gift_qty_limit: number;
      is_removable: boolean;
      allowed_gift_products: Array<{ id: number; sku: string; name: string }>;
    }>;
    items: Array<
      | {
          id: string;
          has_registration_consent: boolean;
          quantity: number;
          bundle_options: Array<{
            id: number;
            label: string;
            type: string;
            values: Array<{
              id: number;
              label: string;
              price: number;
              quantity: number;
              presentation_info: {
                initial_price: number;
                presentation_price: number;
                product:
                  | {
                      stock_status: Types.IProductStockStatus;
                      tooltip_info: string;
                      is_discontinued: boolean;
                      small_image: { url: string };
                      price_range: {
                        maximum_price: {
                          final_price: { currency: Types.ICurrencyEnum; value: number };
                          regular_price: { currency: Types.ICurrencyEnum; value: number };
                        };
                        minimum_price: {
                          final_price: { currency: Types.ICurrencyEnum; value: number };
                          regular_price: { currency: Types.ICurrencyEnum; value: number };
                        };
                      };
                    }
                  | {
                      stock_status: Types.IProductStockStatus;
                      tooltip_info: string;
                      is_discontinued: boolean;
                      small_image: { url: string };
                      price_range: {
                        maximum_price: {
                          final_price: { currency: Types.ICurrencyEnum; value: number };
                          regular_price: { currency: Types.ICurrencyEnum; value: number };
                        };
                        minimum_price: {
                          final_price: { currency: Types.ICurrencyEnum; value: number };
                          regular_price: { currency: Types.ICurrencyEnum; value: number };
                        };
                      };
                    }
                  | {
                      stock_status: Types.IProductStockStatus;
                      tooltip_info: string;
                      is_discontinued: boolean;
                      small_image: { url: string };
                      price_range: {
                        maximum_price: {
                          final_price: { currency: Types.ICurrencyEnum; value: number };
                          regular_price: { currency: Types.ICurrencyEnum; value: number };
                        };
                        minimum_price: {
                          final_price: { currency: Types.ICurrencyEnum; value: number };
                          regular_price: { currency: Types.ICurrencyEnum; value: number };
                        };
                      };
                    }
                  | {
                      stock_status: Types.IProductStockStatus;
                      tooltip_info: string;
                      is_discontinued: boolean;
                      small_image: { url: string };
                      price_range: {
                        maximum_price: {
                          final_price: { currency: Types.ICurrencyEnum; value: number };
                          regular_price: { currency: Types.ICurrencyEnum; value: number };
                        };
                        minimum_price: {
                          final_price: { currency: Types.ICurrencyEnum; value: number };
                          regular_price: { currency: Types.ICurrencyEnum; value: number };
                        };
                      };
                    }
                  | {
                      stock_status: Types.IProductStockStatus;
                      tooltip_info: string;
                      is_discontinued: boolean;
                      small_image: { url: string };
                      price_range: {
                        maximum_price: {
                          final_price: { currency: Types.ICurrencyEnum; value: number };
                          regular_price: { currency: Types.ICurrencyEnum; value: number };
                        };
                        minimum_price: {
                          final_price: { currency: Types.ICurrencyEnum; value: number };
                          regular_price: { currency: Types.ICurrencyEnum; value: number };
                        };
                      };
                    }
                  | {
                      stock_status: Types.IProductStockStatus;
                      tooltip_info: string;
                      is_discontinued: boolean;
                      small_image: { url: string };
                      price_range: {
                        maximum_price: {
                          final_price: { currency: Types.ICurrencyEnum; value: number };
                          regular_price: { currency: Types.ICurrencyEnum; value: number };
                        };
                        minimum_price: {
                          final_price: { currency: Types.ICurrencyEnum; value: number };
                          regular_price: { currency: Types.ICurrencyEnum; value: number };
                        };
                      };
                    }
                  | {
                      stock_status: Types.IProductStockStatus;
                      tooltip_info: string;
                      is_discontinued: boolean;
                      small_image: { url: string };
                      price_range: {
                        maximum_price: {
                          final_price: { currency: Types.ICurrencyEnum; value: number };
                          regular_price: { currency: Types.ICurrencyEnum; value: number };
                        };
                        minimum_price: {
                          final_price: { currency: Types.ICurrencyEnum; value: number };
                          regular_price: { currency: Types.ICurrencyEnum; value: number };
                        };
                      };
                    };
              };
            }>;
          }>;
          errors: Array<{ code: Types.ICartItemErrorType; message: string }>;
          product:
            | {
                id: number;
                name: string;
                sku: string;
                subscription: number;
                has_registration_consent: boolean;
                trade_in: number;
                type_id: string;
                stock_status: Types.IProductStockStatus;
                has_device: number;
                is_discontinued: boolean;
                subscription_format: string;
                delivery_region_code: string;
                region: number;
                region_label: string;
                flavor: number;
                flavor_label: string;
                enable_order_quantity_limit: number;
                order_quantity_limit: number;
                color_label: string;
                strength: number;
                promotionalOffers: Array<{
                  code: string;
                  limit_qty: number;
                  eligible: boolean;
                  type: Types.ISpecialOfferTypeEnum;
                  skus: Array<string>;
                  description: { title: string; description: string; hint: string; label: string };
                }>;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                image: { url: string; label: string };
                short_description: { html: string };
                categories: Array<{ name: string; uid: string; store_locator_name: string }>;
                free_gifts: {
                  allowed_qty: number;
                  products: Array<{
                    is_eligible: boolean;
                    eligibility_description: string;
                    product:
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        };
                  }>;
                };
                strength_details: { name: string; rating: number };
              }
            | {
                id: number;
                name: string;
                sku: string;
                subscription: number;
                has_registration_consent: boolean;
                trade_in: number;
                type_id: string;
                stock_status: Types.IProductStockStatus;
                has_device: number;
                is_discontinued: boolean;
                subscription_format: string;
                delivery_region_code: string;
                region: number;
                region_label: string;
                flavor: number;
                flavor_label: string;
                enable_order_quantity_limit: number;
                order_quantity_limit: number;
                color_label: string;
                strength: number;
                promotionalOffers: Array<{
                  code: string;
                  limit_qty: number;
                  eligible: boolean;
                  type: Types.ISpecialOfferTypeEnum;
                  skus: Array<string>;
                  description: { title: string; description: string; hint: string; label: string };
                }>;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                image: { url: string; label: string };
                short_description: { html: string };
                categories: Array<{ name: string; uid: string; store_locator_name: string }>;
                free_gifts: {
                  allowed_qty: number;
                  products: Array<{
                    is_eligible: boolean;
                    eligibility_description: string;
                    product:
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        };
                  }>;
                };
                strength_details: { name: string; rating: number };
              }
            | {
                id: number;
                name: string;
                sku: string;
                subscription: number;
                has_registration_consent: boolean;
                trade_in: number;
                type_id: string;
                stock_status: Types.IProductStockStatus;
                has_device: number;
                is_discontinued: boolean;
                subscription_format: string;
                delivery_region_code: string;
                region: number;
                region_label: string;
                flavor: number;
                flavor_label: string;
                enable_order_quantity_limit: number;
                order_quantity_limit: number;
                color_label: string;
                strength: number;
                promotionalOffers: Array<{
                  code: string;
                  limit_qty: number;
                  eligible: boolean;
                  type: Types.ISpecialOfferTypeEnum;
                  skus: Array<string>;
                  description: { title: string; description: string; hint: string; label: string };
                }>;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                image: { url: string; label: string };
                short_description: { html: string };
                categories: Array<{ name: string; uid: string; store_locator_name: string }>;
                free_gifts: {
                  allowed_qty: number;
                  products: Array<{
                    is_eligible: boolean;
                    eligibility_description: string;
                    product:
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        };
                  }>;
                };
                strength_details: { name: string; rating: number };
              }
            | {
                id: number;
                name: string;
                sku: string;
                subscription: number;
                has_registration_consent: boolean;
                trade_in: number;
                type_id: string;
                stock_status: Types.IProductStockStatus;
                has_device: number;
                is_discontinued: boolean;
                subscription_format: string;
                delivery_region_code: string;
                region: number;
                region_label: string;
                flavor: number;
                flavor_label: string;
                enable_order_quantity_limit: number;
                order_quantity_limit: number;
                color_label: string;
                strength: number;
                promotionalOffers: Array<{
                  code: string;
                  limit_qty: number;
                  eligible: boolean;
                  type: Types.ISpecialOfferTypeEnum;
                  skus: Array<string>;
                  description: { title: string; description: string; hint: string; label: string };
                }>;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                image: { url: string; label: string };
                short_description: { html: string };
                categories: Array<{ name: string; uid: string; store_locator_name: string }>;
                free_gifts: {
                  allowed_qty: number;
                  products: Array<{
                    is_eligible: boolean;
                    eligibility_description: string;
                    product:
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        };
                  }>;
                };
                strength_details: { name: string; rating: number };
              }
            | {
                id: number;
                name: string;
                sku: string;
                subscription: number;
                has_registration_consent: boolean;
                trade_in: number;
                type_id: string;
                stock_status: Types.IProductStockStatus;
                has_device: number;
                is_discontinued: boolean;
                subscription_format: string;
                delivery_region_code: string;
                region: number;
                region_label: string;
                flavor: number;
                flavor_label: string;
                enable_order_quantity_limit: number;
                order_quantity_limit: number;
                color_label: string;
                strength: number;
                promotionalOffers: Array<{
                  code: string;
                  limit_qty: number;
                  eligible: boolean;
                  type: Types.ISpecialOfferTypeEnum;
                  skus: Array<string>;
                  description: { title: string; description: string; hint: string; label: string };
                }>;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                image: { url: string; label: string };
                short_description: { html: string };
                categories: Array<{ name: string; uid: string; store_locator_name: string }>;
                free_gifts: {
                  allowed_qty: number;
                  products: Array<{
                    is_eligible: boolean;
                    eligibility_description: string;
                    product:
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        };
                  }>;
                };
                strength_details: { name: string; rating: number };
              }
            | {
                id: number;
                name: string;
                sku: string;
                subscription: number;
                has_registration_consent: boolean;
                trade_in: number;
                type_id: string;
                stock_status: Types.IProductStockStatus;
                has_device: number;
                is_discontinued: boolean;
                subscription_format: string;
                delivery_region_code: string;
                region: number;
                region_label: string;
                flavor: number;
                flavor_label: string;
                enable_order_quantity_limit: number;
                order_quantity_limit: number;
                color_label: string;
                strength: number;
                promotionalOffers: Array<{
                  code: string;
                  limit_qty: number;
                  eligible: boolean;
                  type: Types.ISpecialOfferTypeEnum;
                  skus: Array<string>;
                  description: { title: string; description: string; hint: string; label: string };
                }>;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                image: { url: string; label: string };
                short_description: { html: string };
                categories: Array<{ name: string; uid: string; store_locator_name: string }>;
                free_gifts: {
                  allowed_qty: number;
                  products: Array<{
                    is_eligible: boolean;
                    eligibility_description: string;
                    product:
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        };
                  }>;
                };
                strength_details: { name: string; rating: number };
              }
            | {
                id: number;
                name: string;
                sku: string;
                subscription: number;
                has_registration_consent: boolean;
                trade_in: number;
                type_id: string;
                stock_status: Types.IProductStockStatus;
                has_device: number;
                is_discontinued: boolean;
                subscription_format: string;
                delivery_region_code: string;
                region: number;
                region_label: string;
                flavor: number;
                flavor_label: string;
                enable_order_quantity_limit: number;
                order_quantity_limit: number;
                color_label: string;
                strength: number;
                promotionalOffers: Array<{
                  code: string;
                  limit_qty: number;
                  eligible: boolean;
                  type: Types.ISpecialOfferTypeEnum;
                  skus: Array<string>;
                  description: { title: string; description: string; hint: string; label: string };
                }>;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                image: { url: string; label: string };
                short_description: { html: string };
                categories: Array<{ name: string; uid: string; store_locator_name: string }>;
                free_gifts: {
                  allowed_qty: number;
                  products: Array<{
                    is_eligible: boolean;
                    eligibility_description: string;
                    product:
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        };
                  }>;
                };
                strength_details: { name: string; rating: number };
              };
          gift_data: { is_gift: boolean; parent_gift_sku: string; parent_gift_id: string; is_gift_removable: boolean };
          prices: {
            discounts: Array<{ label: string; amount: { currency: Types.ICurrencyEnum; value: number } }>;
            price: { currency: Types.ICurrencyEnum; value: number };
            row_total: { currency: Types.ICurrencyEnum; value: number };
            row_total_including_tax: { currency: Types.ICurrencyEnum; value: number };
            total_item_discount: { currency: Types.ICurrencyEnum; value: number };
          };
        }
      | {
          id: string;
          has_registration_consent: boolean;
          quantity: number;
          configured_variant:
            | { is_discontinued: boolean }
            | { is_discontinued: boolean }
            | { is_discontinued: boolean }
            | { is_discontinued: boolean }
            | { is_discontinued: boolean }
            | { is_discontinued: boolean }
            | { is_discontinued: boolean };
          errors: Array<{ code: Types.ICartItemErrorType; message: string }>;
          product:
            | {
                id: number;
                name: string;
                sku: string;
                subscription: number;
                has_registration_consent: boolean;
                trade_in: number;
                type_id: string;
                stock_status: Types.IProductStockStatus;
                has_device: number;
                is_discontinued: boolean;
                subscription_format: string;
                delivery_region_code: string;
                region: number;
                region_label: string;
                flavor: number;
                flavor_label: string;
                enable_order_quantity_limit: number;
                order_quantity_limit: number;
                color_label: string;
                strength: number;
                promotionalOffers: Array<{
                  code: string;
                  limit_qty: number;
                  eligible: boolean;
                  type: Types.ISpecialOfferTypeEnum;
                  skus: Array<string>;
                  description: { title: string; description: string; hint: string; label: string };
                }>;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                image: { url: string; label: string };
                short_description: { html: string };
                categories: Array<{ name: string; uid: string; store_locator_name: string }>;
                free_gifts: {
                  allowed_qty: number;
                  products: Array<{
                    is_eligible: boolean;
                    eligibility_description: string;
                    product:
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        };
                  }>;
                };
                strength_details: { name: string; rating: number };
              }
            | {
                id: number;
                name: string;
                sku: string;
                subscription: number;
                has_registration_consent: boolean;
                trade_in: number;
                type_id: string;
                stock_status: Types.IProductStockStatus;
                has_device: number;
                is_discontinued: boolean;
                subscription_format: string;
                delivery_region_code: string;
                region: number;
                region_label: string;
                flavor: number;
                flavor_label: string;
                enable_order_quantity_limit: number;
                order_quantity_limit: number;
                color_label: string;
                strength: number;
                promotionalOffers: Array<{
                  code: string;
                  limit_qty: number;
                  eligible: boolean;
                  type: Types.ISpecialOfferTypeEnum;
                  skus: Array<string>;
                  description: { title: string; description: string; hint: string; label: string };
                }>;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                image: { url: string; label: string };
                short_description: { html: string };
                categories: Array<{ name: string; uid: string; store_locator_name: string }>;
                free_gifts: {
                  allowed_qty: number;
                  products: Array<{
                    is_eligible: boolean;
                    eligibility_description: string;
                    product:
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        };
                  }>;
                };
                strength_details: { name: string; rating: number };
              }
            | {
                id: number;
                name: string;
                sku: string;
                subscription: number;
                has_registration_consent: boolean;
                trade_in: number;
                type_id: string;
                stock_status: Types.IProductStockStatus;
                has_device: number;
                is_discontinued: boolean;
                subscription_format: string;
                delivery_region_code: string;
                region: number;
                region_label: string;
                flavor: number;
                flavor_label: string;
                enable_order_quantity_limit: number;
                order_quantity_limit: number;
                color_label: string;
                strength: number;
                promotionalOffers: Array<{
                  code: string;
                  limit_qty: number;
                  eligible: boolean;
                  type: Types.ISpecialOfferTypeEnum;
                  skus: Array<string>;
                  description: { title: string; description: string; hint: string; label: string };
                }>;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                image: { url: string; label: string };
                short_description: { html: string };
                categories: Array<{ name: string; uid: string; store_locator_name: string }>;
                free_gifts: {
                  allowed_qty: number;
                  products: Array<{
                    is_eligible: boolean;
                    eligibility_description: string;
                    product:
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        };
                  }>;
                };
                strength_details: { name: string; rating: number };
              }
            | {
                id: number;
                name: string;
                sku: string;
                subscription: number;
                has_registration_consent: boolean;
                trade_in: number;
                type_id: string;
                stock_status: Types.IProductStockStatus;
                has_device: number;
                is_discontinued: boolean;
                subscription_format: string;
                delivery_region_code: string;
                region: number;
                region_label: string;
                flavor: number;
                flavor_label: string;
                enable_order_quantity_limit: number;
                order_quantity_limit: number;
                color_label: string;
                strength: number;
                promotionalOffers: Array<{
                  code: string;
                  limit_qty: number;
                  eligible: boolean;
                  type: Types.ISpecialOfferTypeEnum;
                  skus: Array<string>;
                  description: { title: string; description: string; hint: string; label: string };
                }>;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                image: { url: string; label: string };
                short_description: { html: string };
                categories: Array<{ name: string; uid: string; store_locator_name: string }>;
                free_gifts: {
                  allowed_qty: number;
                  products: Array<{
                    is_eligible: boolean;
                    eligibility_description: string;
                    product:
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        };
                  }>;
                };
                strength_details: { name: string; rating: number };
              }
            | {
                id: number;
                name: string;
                sku: string;
                subscription: number;
                has_registration_consent: boolean;
                trade_in: number;
                type_id: string;
                stock_status: Types.IProductStockStatus;
                has_device: number;
                is_discontinued: boolean;
                subscription_format: string;
                delivery_region_code: string;
                region: number;
                region_label: string;
                flavor: number;
                flavor_label: string;
                enable_order_quantity_limit: number;
                order_quantity_limit: number;
                color_label: string;
                strength: number;
                promotionalOffers: Array<{
                  code: string;
                  limit_qty: number;
                  eligible: boolean;
                  type: Types.ISpecialOfferTypeEnum;
                  skus: Array<string>;
                  description: { title: string; description: string; hint: string; label: string };
                }>;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                image: { url: string; label: string };
                short_description: { html: string };
                categories: Array<{ name: string; uid: string; store_locator_name: string }>;
                free_gifts: {
                  allowed_qty: number;
                  products: Array<{
                    is_eligible: boolean;
                    eligibility_description: string;
                    product:
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        };
                  }>;
                };
                strength_details: { name: string; rating: number };
              }
            | {
                id: number;
                name: string;
                sku: string;
                subscription: number;
                has_registration_consent: boolean;
                trade_in: number;
                type_id: string;
                stock_status: Types.IProductStockStatus;
                has_device: number;
                is_discontinued: boolean;
                subscription_format: string;
                delivery_region_code: string;
                region: number;
                region_label: string;
                flavor: number;
                flavor_label: string;
                enable_order_quantity_limit: number;
                order_quantity_limit: number;
                color_label: string;
                strength: number;
                promotionalOffers: Array<{
                  code: string;
                  limit_qty: number;
                  eligible: boolean;
                  type: Types.ISpecialOfferTypeEnum;
                  skus: Array<string>;
                  description: { title: string; description: string; hint: string; label: string };
                }>;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                image: { url: string; label: string };
                short_description: { html: string };
                categories: Array<{ name: string; uid: string; store_locator_name: string }>;
                free_gifts: {
                  allowed_qty: number;
                  products: Array<{
                    is_eligible: boolean;
                    eligibility_description: string;
                    product:
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        };
                  }>;
                };
                strength_details: { name: string; rating: number };
              }
            | {
                id: number;
                name: string;
                sku: string;
                subscription: number;
                has_registration_consent: boolean;
                trade_in: number;
                type_id: string;
                stock_status: Types.IProductStockStatus;
                has_device: number;
                is_discontinued: boolean;
                subscription_format: string;
                delivery_region_code: string;
                region: number;
                region_label: string;
                flavor: number;
                flavor_label: string;
                enable_order_quantity_limit: number;
                order_quantity_limit: number;
                color_label: string;
                strength: number;
                promotionalOffers: Array<{
                  code: string;
                  limit_qty: number;
                  eligible: boolean;
                  type: Types.ISpecialOfferTypeEnum;
                  skus: Array<string>;
                  description: { title: string; description: string; hint: string; label: string };
                }>;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                image: { url: string; label: string };
                short_description: { html: string };
                categories: Array<{ name: string; uid: string; store_locator_name: string }>;
                free_gifts: {
                  allowed_qty: number;
                  products: Array<{
                    is_eligible: boolean;
                    eligibility_description: string;
                    product:
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        };
                  }>;
                };
                strength_details: { name: string; rating: number };
              };
          gift_data: { is_gift: boolean; parent_gift_sku: string; parent_gift_id: string; is_gift_removable: boolean };
          prices: {
            discounts: Array<{ label: string; amount: { currency: Types.ICurrencyEnum; value: number } }>;
            price: { currency: Types.ICurrencyEnum; value: number };
            row_total: { currency: Types.ICurrencyEnum; value: number };
            row_total_including_tax: { currency: Types.ICurrencyEnum; value: number };
            total_item_discount: { currency: Types.ICurrencyEnum; value: number };
          };
        }
      | {
          id: string;
          has_registration_consent: boolean;
          quantity: number;
          errors: Array<{ code: Types.ICartItemErrorType; message: string }>;
          product:
            | {
                id: number;
                name: string;
                sku: string;
                subscription: number;
                has_registration_consent: boolean;
                trade_in: number;
                type_id: string;
                stock_status: Types.IProductStockStatus;
                has_device: number;
                is_discontinued: boolean;
                subscription_format: string;
                delivery_region_code: string;
                region: number;
                region_label: string;
                flavor: number;
                flavor_label: string;
                enable_order_quantity_limit: number;
                order_quantity_limit: number;
                color_label: string;
                strength: number;
                promotionalOffers: Array<{
                  code: string;
                  limit_qty: number;
                  eligible: boolean;
                  type: Types.ISpecialOfferTypeEnum;
                  skus: Array<string>;
                  description: { title: string; description: string; hint: string; label: string };
                }>;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                image: { url: string; label: string };
                short_description: { html: string };
                categories: Array<{ name: string; uid: string; store_locator_name: string }>;
                free_gifts: {
                  allowed_qty: number;
                  products: Array<{
                    is_eligible: boolean;
                    eligibility_description: string;
                    product:
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        };
                  }>;
                };
                strength_details: { name: string; rating: number };
              }
            | {
                id: number;
                name: string;
                sku: string;
                subscription: number;
                has_registration_consent: boolean;
                trade_in: number;
                type_id: string;
                stock_status: Types.IProductStockStatus;
                has_device: number;
                is_discontinued: boolean;
                subscription_format: string;
                delivery_region_code: string;
                region: number;
                region_label: string;
                flavor: number;
                flavor_label: string;
                enable_order_quantity_limit: number;
                order_quantity_limit: number;
                color_label: string;
                strength: number;
                promotionalOffers: Array<{
                  code: string;
                  limit_qty: number;
                  eligible: boolean;
                  type: Types.ISpecialOfferTypeEnum;
                  skus: Array<string>;
                  description: { title: string; description: string; hint: string; label: string };
                }>;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                image: { url: string; label: string };
                short_description: { html: string };
                categories: Array<{ name: string; uid: string; store_locator_name: string }>;
                free_gifts: {
                  allowed_qty: number;
                  products: Array<{
                    is_eligible: boolean;
                    eligibility_description: string;
                    product:
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        };
                  }>;
                };
                strength_details: { name: string; rating: number };
              }
            | {
                id: number;
                name: string;
                sku: string;
                subscription: number;
                has_registration_consent: boolean;
                trade_in: number;
                type_id: string;
                stock_status: Types.IProductStockStatus;
                has_device: number;
                is_discontinued: boolean;
                subscription_format: string;
                delivery_region_code: string;
                region: number;
                region_label: string;
                flavor: number;
                flavor_label: string;
                enable_order_quantity_limit: number;
                order_quantity_limit: number;
                color_label: string;
                strength: number;
                promotionalOffers: Array<{
                  code: string;
                  limit_qty: number;
                  eligible: boolean;
                  type: Types.ISpecialOfferTypeEnum;
                  skus: Array<string>;
                  description: { title: string; description: string; hint: string; label: string };
                }>;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                image: { url: string; label: string };
                short_description: { html: string };
                categories: Array<{ name: string; uid: string; store_locator_name: string }>;
                free_gifts: {
                  allowed_qty: number;
                  products: Array<{
                    is_eligible: boolean;
                    eligibility_description: string;
                    product:
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        };
                  }>;
                };
                strength_details: { name: string; rating: number };
              }
            | {
                id: number;
                name: string;
                sku: string;
                subscription: number;
                has_registration_consent: boolean;
                trade_in: number;
                type_id: string;
                stock_status: Types.IProductStockStatus;
                has_device: number;
                is_discontinued: boolean;
                subscription_format: string;
                delivery_region_code: string;
                region: number;
                region_label: string;
                flavor: number;
                flavor_label: string;
                enable_order_quantity_limit: number;
                order_quantity_limit: number;
                color_label: string;
                strength: number;
                promotionalOffers: Array<{
                  code: string;
                  limit_qty: number;
                  eligible: boolean;
                  type: Types.ISpecialOfferTypeEnum;
                  skus: Array<string>;
                  description: { title: string; description: string; hint: string; label: string };
                }>;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                image: { url: string; label: string };
                short_description: { html: string };
                categories: Array<{ name: string; uid: string; store_locator_name: string }>;
                free_gifts: {
                  allowed_qty: number;
                  products: Array<{
                    is_eligible: boolean;
                    eligibility_description: string;
                    product:
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        };
                  }>;
                };
                strength_details: { name: string; rating: number };
              }
            | {
                id: number;
                name: string;
                sku: string;
                subscription: number;
                has_registration_consent: boolean;
                trade_in: number;
                type_id: string;
                stock_status: Types.IProductStockStatus;
                has_device: number;
                is_discontinued: boolean;
                subscription_format: string;
                delivery_region_code: string;
                region: number;
                region_label: string;
                flavor: number;
                flavor_label: string;
                enable_order_quantity_limit: number;
                order_quantity_limit: number;
                color_label: string;
                strength: number;
                promotionalOffers: Array<{
                  code: string;
                  limit_qty: number;
                  eligible: boolean;
                  type: Types.ISpecialOfferTypeEnum;
                  skus: Array<string>;
                  description: { title: string; description: string; hint: string; label: string };
                }>;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                image: { url: string; label: string };
                short_description: { html: string };
                categories: Array<{ name: string; uid: string; store_locator_name: string }>;
                free_gifts: {
                  allowed_qty: number;
                  products: Array<{
                    is_eligible: boolean;
                    eligibility_description: string;
                    product:
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        };
                  }>;
                };
                strength_details: { name: string; rating: number };
              }
            | {
                id: number;
                name: string;
                sku: string;
                subscription: number;
                has_registration_consent: boolean;
                trade_in: number;
                type_id: string;
                stock_status: Types.IProductStockStatus;
                has_device: number;
                is_discontinued: boolean;
                subscription_format: string;
                delivery_region_code: string;
                region: number;
                region_label: string;
                flavor: number;
                flavor_label: string;
                enable_order_quantity_limit: number;
                order_quantity_limit: number;
                color_label: string;
                strength: number;
                promotionalOffers: Array<{
                  code: string;
                  limit_qty: number;
                  eligible: boolean;
                  type: Types.ISpecialOfferTypeEnum;
                  skus: Array<string>;
                  description: { title: string; description: string; hint: string; label: string };
                }>;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                image: { url: string; label: string };
                short_description: { html: string };
                categories: Array<{ name: string; uid: string; store_locator_name: string }>;
                free_gifts: {
                  allowed_qty: number;
                  products: Array<{
                    is_eligible: boolean;
                    eligibility_description: string;
                    product:
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        };
                  }>;
                };
                strength_details: { name: string; rating: number };
              }
            | {
                id: number;
                name: string;
                sku: string;
                subscription: number;
                has_registration_consent: boolean;
                trade_in: number;
                type_id: string;
                stock_status: Types.IProductStockStatus;
                has_device: number;
                is_discontinued: boolean;
                subscription_format: string;
                delivery_region_code: string;
                region: number;
                region_label: string;
                flavor: number;
                flavor_label: string;
                enable_order_quantity_limit: number;
                order_quantity_limit: number;
                color_label: string;
                strength: number;
                promotionalOffers: Array<{
                  code: string;
                  limit_qty: number;
                  eligible: boolean;
                  type: Types.ISpecialOfferTypeEnum;
                  skus: Array<string>;
                  description: { title: string; description: string; hint: string; label: string };
                }>;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                image: { url: string; label: string };
                short_description: { html: string };
                categories: Array<{ name: string; uid: string; store_locator_name: string }>;
                free_gifts: {
                  allowed_qty: number;
                  products: Array<{
                    is_eligible: boolean;
                    eligibility_description: string;
                    product:
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        };
                  }>;
                };
                strength_details: { name: string; rating: number };
              };
          gift_data: { is_gift: boolean; parent_gift_sku: string; parent_gift_id: string; is_gift_removable: boolean };
          prices: {
            discounts: Array<{ label: string; amount: { currency: Types.ICurrencyEnum; value: number } }>;
            price: { currency: Types.ICurrencyEnum; value: number };
            row_total: { currency: Types.ICurrencyEnum; value: number };
            row_total_including_tax: { currency: Types.ICurrencyEnum; value: number };
            total_item_discount: { currency: Types.ICurrencyEnum; value: number };
          };
        }
      | {
          id: string;
          has_registration_consent: boolean;
          quantity: number;
          errors: Array<{ code: Types.ICartItemErrorType; message: string }>;
          product:
            | {
                id: number;
                name: string;
                sku: string;
                subscription: number;
                has_registration_consent: boolean;
                trade_in: number;
                type_id: string;
                stock_status: Types.IProductStockStatus;
                has_device: number;
                is_discontinued: boolean;
                subscription_format: string;
                delivery_region_code: string;
                region: number;
                region_label: string;
                flavor: number;
                flavor_label: string;
                enable_order_quantity_limit: number;
                order_quantity_limit: number;
                color_label: string;
                strength: number;
                promotionalOffers: Array<{
                  code: string;
                  limit_qty: number;
                  eligible: boolean;
                  type: Types.ISpecialOfferTypeEnum;
                  skus: Array<string>;
                  description: { title: string; description: string; hint: string; label: string };
                }>;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                image: { url: string; label: string };
                short_description: { html: string };
                categories: Array<{ name: string; uid: string; store_locator_name: string }>;
                free_gifts: {
                  allowed_qty: number;
                  products: Array<{
                    is_eligible: boolean;
                    eligibility_description: string;
                    product:
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        };
                  }>;
                };
                strength_details: { name: string; rating: number };
              }
            | {
                id: number;
                name: string;
                sku: string;
                subscription: number;
                has_registration_consent: boolean;
                trade_in: number;
                type_id: string;
                stock_status: Types.IProductStockStatus;
                has_device: number;
                is_discontinued: boolean;
                subscription_format: string;
                delivery_region_code: string;
                region: number;
                region_label: string;
                flavor: number;
                flavor_label: string;
                enable_order_quantity_limit: number;
                order_quantity_limit: number;
                color_label: string;
                strength: number;
                promotionalOffers: Array<{
                  code: string;
                  limit_qty: number;
                  eligible: boolean;
                  type: Types.ISpecialOfferTypeEnum;
                  skus: Array<string>;
                  description: { title: string; description: string; hint: string; label: string };
                }>;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                image: { url: string; label: string };
                short_description: { html: string };
                categories: Array<{ name: string; uid: string; store_locator_name: string }>;
                free_gifts: {
                  allowed_qty: number;
                  products: Array<{
                    is_eligible: boolean;
                    eligibility_description: string;
                    product:
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        };
                  }>;
                };
                strength_details: { name: string; rating: number };
              }
            | {
                id: number;
                name: string;
                sku: string;
                subscription: number;
                has_registration_consent: boolean;
                trade_in: number;
                type_id: string;
                stock_status: Types.IProductStockStatus;
                has_device: number;
                is_discontinued: boolean;
                subscription_format: string;
                delivery_region_code: string;
                region: number;
                region_label: string;
                flavor: number;
                flavor_label: string;
                enable_order_quantity_limit: number;
                order_quantity_limit: number;
                color_label: string;
                strength: number;
                promotionalOffers: Array<{
                  code: string;
                  limit_qty: number;
                  eligible: boolean;
                  type: Types.ISpecialOfferTypeEnum;
                  skus: Array<string>;
                  description: { title: string; description: string; hint: string; label: string };
                }>;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                image: { url: string; label: string };
                short_description: { html: string };
                categories: Array<{ name: string; uid: string; store_locator_name: string }>;
                free_gifts: {
                  allowed_qty: number;
                  products: Array<{
                    is_eligible: boolean;
                    eligibility_description: string;
                    product:
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        };
                  }>;
                };
                strength_details: { name: string; rating: number };
              }
            | {
                id: number;
                name: string;
                sku: string;
                subscription: number;
                has_registration_consent: boolean;
                trade_in: number;
                type_id: string;
                stock_status: Types.IProductStockStatus;
                has_device: number;
                is_discontinued: boolean;
                subscription_format: string;
                delivery_region_code: string;
                region: number;
                region_label: string;
                flavor: number;
                flavor_label: string;
                enable_order_quantity_limit: number;
                order_quantity_limit: number;
                color_label: string;
                strength: number;
                promotionalOffers: Array<{
                  code: string;
                  limit_qty: number;
                  eligible: boolean;
                  type: Types.ISpecialOfferTypeEnum;
                  skus: Array<string>;
                  description: { title: string; description: string; hint: string; label: string };
                }>;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                image: { url: string; label: string };
                short_description: { html: string };
                categories: Array<{ name: string; uid: string; store_locator_name: string }>;
                free_gifts: {
                  allowed_qty: number;
                  products: Array<{
                    is_eligible: boolean;
                    eligibility_description: string;
                    product:
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        };
                  }>;
                };
                strength_details: { name: string; rating: number };
              }
            | {
                id: number;
                name: string;
                sku: string;
                subscription: number;
                has_registration_consent: boolean;
                trade_in: number;
                type_id: string;
                stock_status: Types.IProductStockStatus;
                has_device: number;
                is_discontinued: boolean;
                subscription_format: string;
                delivery_region_code: string;
                region: number;
                region_label: string;
                flavor: number;
                flavor_label: string;
                enable_order_quantity_limit: number;
                order_quantity_limit: number;
                color_label: string;
                strength: number;
                promotionalOffers: Array<{
                  code: string;
                  limit_qty: number;
                  eligible: boolean;
                  type: Types.ISpecialOfferTypeEnum;
                  skus: Array<string>;
                  description: { title: string; description: string; hint: string; label: string };
                }>;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                image: { url: string; label: string };
                short_description: { html: string };
                categories: Array<{ name: string; uid: string; store_locator_name: string }>;
                free_gifts: {
                  allowed_qty: number;
                  products: Array<{
                    is_eligible: boolean;
                    eligibility_description: string;
                    product:
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        };
                  }>;
                };
                strength_details: { name: string; rating: number };
              }
            | {
                id: number;
                name: string;
                sku: string;
                subscription: number;
                has_registration_consent: boolean;
                trade_in: number;
                type_id: string;
                stock_status: Types.IProductStockStatus;
                has_device: number;
                is_discontinued: boolean;
                subscription_format: string;
                delivery_region_code: string;
                region: number;
                region_label: string;
                flavor: number;
                flavor_label: string;
                enable_order_quantity_limit: number;
                order_quantity_limit: number;
                color_label: string;
                strength: number;
                promotionalOffers: Array<{
                  code: string;
                  limit_qty: number;
                  eligible: boolean;
                  type: Types.ISpecialOfferTypeEnum;
                  skus: Array<string>;
                  description: { title: string; description: string; hint: string; label: string };
                }>;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                image: { url: string; label: string };
                short_description: { html: string };
                categories: Array<{ name: string; uid: string; store_locator_name: string }>;
                free_gifts: {
                  allowed_qty: number;
                  products: Array<{
                    is_eligible: boolean;
                    eligibility_description: string;
                    product:
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        };
                  }>;
                };
                strength_details: { name: string; rating: number };
              }
            | {
                id: number;
                name: string;
                sku: string;
                subscription: number;
                has_registration_consent: boolean;
                trade_in: number;
                type_id: string;
                stock_status: Types.IProductStockStatus;
                has_device: number;
                is_discontinued: boolean;
                subscription_format: string;
                delivery_region_code: string;
                region: number;
                region_label: string;
                flavor: number;
                flavor_label: string;
                enable_order_quantity_limit: number;
                order_quantity_limit: number;
                color_label: string;
                strength: number;
                promotionalOffers: Array<{
                  code: string;
                  limit_qty: number;
                  eligible: boolean;
                  type: Types.ISpecialOfferTypeEnum;
                  skus: Array<string>;
                  description: { title: string; description: string; hint: string; label: string };
                }>;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                image: { url: string; label: string };
                short_description: { html: string };
                categories: Array<{ name: string; uid: string; store_locator_name: string }>;
                free_gifts: {
                  allowed_qty: number;
                  products: Array<{
                    is_eligible: boolean;
                    eligibility_description: string;
                    product:
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        };
                  }>;
                };
                strength_details: { name: string; rating: number };
              };
          gift_data: { is_gift: boolean; parent_gift_sku: string; parent_gift_id: string; is_gift_removable: boolean };
          prices: {
            discounts: Array<{ label: string; amount: { currency: Types.ICurrencyEnum; value: number } }>;
            price: { currency: Types.ICurrencyEnum; value: number };
            row_total: { currency: Types.ICurrencyEnum; value: number };
            row_total_including_tax: { currency: Types.ICurrencyEnum; value: number };
            total_item_discount: { currency: Types.ICurrencyEnum; value: number };
          };
        }
      | {
          id: string;
          has_registration_consent: boolean;
          quantity: number;
          errors: Array<{ code: Types.ICartItemErrorType; message: string }>;
          product:
            | {
                id: number;
                name: string;
                sku: string;
                subscription: number;
                has_registration_consent: boolean;
                trade_in: number;
                type_id: string;
                stock_status: Types.IProductStockStatus;
                has_device: number;
                is_discontinued: boolean;
                subscription_format: string;
                delivery_region_code: string;
                region: number;
                region_label: string;
                flavor: number;
                flavor_label: string;
                enable_order_quantity_limit: number;
                order_quantity_limit: number;
                color_label: string;
                strength: number;
                promotionalOffers: Array<{
                  code: string;
                  limit_qty: number;
                  eligible: boolean;
                  type: Types.ISpecialOfferTypeEnum;
                  skus: Array<string>;
                  description: { title: string; description: string; hint: string; label: string };
                }>;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                image: { url: string; label: string };
                short_description: { html: string };
                categories: Array<{ name: string; uid: string; store_locator_name: string }>;
                free_gifts: {
                  allowed_qty: number;
                  products: Array<{
                    is_eligible: boolean;
                    eligibility_description: string;
                    product:
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        };
                  }>;
                };
                strength_details: { name: string; rating: number };
              }
            | {
                id: number;
                name: string;
                sku: string;
                subscription: number;
                has_registration_consent: boolean;
                trade_in: number;
                type_id: string;
                stock_status: Types.IProductStockStatus;
                has_device: number;
                is_discontinued: boolean;
                subscription_format: string;
                delivery_region_code: string;
                region: number;
                region_label: string;
                flavor: number;
                flavor_label: string;
                enable_order_quantity_limit: number;
                order_quantity_limit: number;
                color_label: string;
                strength: number;
                promotionalOffers: Array<{
                  code: string;
                  limit_qty: number;
                  eligible: boolean;
                  type: Types.ISpecialOfferTypeEnum;
                  skus: Array<string>;
                  description: { title: string; description: string; hint: string; label: string };
                }>;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                image: { url: string; label: string };
                short_description: { html: string };
                categories: Array<{ name: string; uid: string; store_locator_name: string }>;
                free_gifts: {
                  allowed_qty: number;
                  products: Array<{
                    is_eligible: boolean;
                    eligibility_description: string;
                    product:
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        };
                  }>;
                };
                strength_details: { name: string; rating: number };
              }
            | {
                id: number;
                name: string;
                sku: string;
                subscription: number;
                has_registration_consent: boolean;
                trade_in: number;
                type_id: string;
                stock_status: Types.IProductStockStatus;
                has_device: number;
                is_discontinued: boolean;
                subscription_format: string;
                delivery_region_code: string;
                region: number;
                region_label: string;
                flavor: number;
                flavor_label: string;
                enable_order_quantity_limit: number;
                order_quantity_limit: number;
                color_label: string;
                strength: number;
                promotionalOffers: Array<{
                  code: string;
                  limit_qty: number;
                  eligible: boolean;
                  type: Types.ISpecialOfferTypeEnum;
                  skus: Array<string>;
                  description: { title: string; description: string; hint: string; label: string };
                }>;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                image: { url: string; label: string };
                short_description: { html: string };
                categories: Array<{ name: string; uid: string; store_locator_name: string }>;
                free_gifts: {
                  allowed_qty: number;
                  products: Array<{
                    is_eligible: boolean;
                    eligibility_description: string;
                    product:
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        };
                  }>;
                };
                strength_details: { name: string; rating: number };
              }
            | {
                id: number;
                name: string;
                sku: string;
                subscription: number;
                has_registration_consent: boolean;
                trade_in: number;
                type_id: string;
                stock_status: Types.IProductStockStatus;
                has_device: number;
                is_discontinued: boolean;
                subscription_format: string;
                delivery_region_code: string;
                region: number;
                region_label: string;
                flavor: number;
                flavor_label: string;
                enable_order_quantity_limit: number;
                order_quantity_limit: number;
                color_label: string;
                strength: number;
                promotionalOffers: Array<{
                  code: string;
                  limit_qty: number;
                  eligible: boolean;
                  type: Types.ISpecialOfferTypeEnum;
                  skus: Array<string>;
                  description: { title: string; description: string; hint: string; label: string };
                }>;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                image: { url: string; label: string };
                short_description: { html: string };
                categories: Array<{ name: string; uid: string; store_locator_name: string }>;
                free_gifts: {
                  allowed_qty: number;
                  products: Array<{
                    is_eligible: boolean;
                    eligibility_description: string;
                    product:
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        };
                  }>;
                };
                strength_details: { name: string; rating: number };
              }
            | {
                id: number;
                name: string;
                sku: string;
                subscription: number;
                has_registration_consent: boolean;
                trade_in: number;
                type_id: string;
                stock_status: Types.IProductStockStatus;
                has_device: number;
                is_discontinued: boolean;
                subscription_format: string;
                delivery_region_code: string;
                region: number;
                region_label: string;
                flavor: number;
                flavor_label: string;
                enable_order_quantity_limit: number;
                order_quantity_limit: number;
                color_label: string;
                strength: number;
                promotionalOffers: Array<{
                  code: string;
                  limit_qty: number;
                  eligible: boolean;
                  type: Types.ISpecialOfferTypeEnum;
                  skus: Array<string>;
                  description: { title: string; description: string; hint: string; label: string };
                }>;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                image: { url: string; label: string };
                short_description: { html: string };
                categories: Array<{ name: string; uid: string; store_locator_name: string }>;
                free_gifts: {
                  allowed_qty: number;
                  products: Array<{
                    is_eligible: boolean;
                    eligibility_description: string;
                    product:
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        };
                  }>;
                };
                strength_details: { name: string; rating: number };
              }
            | {
                id: number;
                name: string;
                sku: string;
                subscription: number;
                has_registration_consent: boolean;
                trade_in: number;
                type_id: string;
                stock_status: Types.IProductStockStatus;
                has_device: number;
                is_discontinued: boolean;
                subscription_format: string;
                delivery_region_code: string;
                region: number;
                region_label: string;
                flavor: number;
                flavor_label: string;
                enable_order_quantity_limit: number;
                order_quantity_limit: number;
                color_label: string;
                strength: number;
                promotionalOffers: Array<{
                  code: string;
                  limit_qty: number;
                  eligible: boolean;
                  type: Types.ISpecialOfferTypeEnum;
                  skus: Array<string>;
                  description: { title: string; description: string; hint: string; label: string };
                }>;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                image: { url: string; label: string };
                short_description: { html: string };
                categories: Array<{ name: string; uid: string; store_locator_name: string }>;
                free_gifts: {
                  allowed_qty: number;
                  products: Array<{
                    is_eligible: boolean;
                    eligibility_description: string;
                    product:
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        };
                  }>;
                };
                strength_details: { name: string; rating: number };
              }
            | {
                id: number;
                name: string;
                sku: string;
                subscription: number;
                has_registration_consent: boolean;
                trade_in: number;
                type_id: string;
                stock_status: Types.IProductStockStatus;
                has_device: number;
                is_discontinued: boolean;
                subscription_format: string;
                delivery_region_code: string;
                region: number;
                region_label: string;
                flavor: number;
                flavor_label: string;
                enable_order_quantity_limit: number;
                order_quantity_limit: number;
                color_label: string;
                strength: number;
                promotionalOffers: Array<{
                  code: string;
                  limit_qty: number;
                  eligible: boolean;
                  type: Types.ISpecialOfferTypeEnum;
                  skus: Array<string>;
                  description: { title: string; description: string; hint: string; label: string };
                }>;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                image: { url: string; label: string };
                short_description: { html: string };
                categories: Array<{ name: string; uid: string; store_locator_name: string }>;
                free_gifts: {
                  allowed_qty: number;
                  products: Array<{
                    is_eligible: boolean;
                    eligibility_description: string;
                    product:
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        };
                  }>;
                };
                strength_details: { name: string; rating: number };
              };
          gift_data: { is_gift: boolean; parent_gift_sku: string; parent_gift_id: string; is_gift_removable: boolean };
          prices: {
            discounts: Array<{ label: string; amount: { currency: Types.ICurrencyEnum; value: number } }>;
            price: { currency: Types.ICurrencyEnum; value: number };
            row_total: { currency: Types.ICurrencyEnum; value: number };
            row_total_including_tax: { currency: Types.ICurrencyEnum; value: number };
            total_item_discount: { currency: Types.ICurrencyEnum; value: number };
          };
        }
      | {
          id: string;
          has_registration_consent: boolean;
          quantity: number;
          errors: Array<{ code: Types.ICartItemErrorType; message: string }>;
          product:
            | {
                id: number;
                name: string;
                sku: string;
                subscription: number;
                has_registration_consent: boolean;
                trade_in: number;
                type_id: string;
                stock_status: Types.IProductStockStatus;
                has_device: number;
                is_discontinued: boolean;
                subscription_format: string;
                delivery_region_code: string;
                region: number;
                region_label: string;
                flavor: number;
                flavor_label: string;
                enable_order_quantity_limit: number;
                order_quantity_limit: number;
                color_label: string;
                strength: number;
                promotionalOffers: Array<{
                  code: string;
                  limit_qty: number;
                  eligible: boolean;
                  type: Types.ISpecialOfferTypeEnum;
                  skus: Array<string>;
                  description: { title: string; description: string; hint: string; label: string };
                }>;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                image: { url: string; label: string };
                short_description: { html: string };
                categories: Array<{ name: string; uid: string; store_locator_name: string }>;
                free_gifts: {
                  allowed_qty: number;
                  products: Array<{
                    is_eligible: boolean;
                    eligibility_description: string;
                    product:
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        };
                  }>;
                };
                strength_details: { name: string; rating: number };
              }
            | {
                id: number;
                name: string;
                sku: string;
                subscription: number;
                has_registration_consent: boolean;
                trade_in: number;
                type_id: string;
                stock_status: Types.IProductStockStatus;
                has_device: number;
                is_discontinued: boolean;
                subscription_format: string;
                delivery_region_code: string;
                region: number;
                region_label: string;
                flavor: number;
                flavor_label: string;
                enable_order_quantity_limit: number;
                order_quantity_limit: number;
                color_label: string;
                strength: number;
                promotionalOffers: Array<{
                  code: string;
                  limit_qty: number;
                  eligible: boolean;
                  type: Types.ISpecialOfferTypeEnum;
                  skus: Array<string>;
                  description: { title: string; description: string; hint: string; label: string };
                }>;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                image: { url: string; label: string };
                short_description: { html: string };
                categories: Array<{ name: string; uid: string; store_locator_name: string }>;
                free_gifts: {
                  allowed_qty: number;
                  products: Array<{
                    is_eligible: boolean;
                    eligibility_description: string;
                    product:
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        };
                  }>;
                };
                strength_details: { name: string; rating: number };
              }
            | {
                id: number;
                name: string;
                sku: string;
                subscription: number;
                has_registration_consent: boolean;
                trade_in: number;
                type_id: string;
                stock_status: Types.IProductStockStatus;
                has_device: number;
                is_discontinued: boolean;
                subscription_format: string;
                delivery_region_code: string;
                region: number;
                region_label: string;
                flavor: number;
                flavor_label: string;
                enable_order_quantity_limit: number;
                order_quantity_limit: number;
                color_label: string;
                strength: number;
                promotionalOffers: Array<{
                  code: string;
                  limit_qty: number;
                  eligible: boolean;
                  type: Types.ISpecialOfferTypeEnum;
                  skus: Array<string>;
                  description: { title: string; description: string; hint: string; label: string };
                }>;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                image: { url: string; label: string };
                short_description: { html: string };
                categories: Array<{ name: string; uid: string; store_locator_name: string }>;
                free_gifts: {
                  allowed_qty: number;
                  products: Array<{
                    is_eligible: boolean;
                    eligibility_description: string;
                    product:
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        };
                  }>;
                };
                strength_details: { name: string; rating: number };
              }
            | {
                id: number;
                name: string;
                sku: string;
                subscription: number;
                has_registration_consent: boolean;
                trade_in: number;
                type_id: string;
                stock_status: Types.IProductStockStatus;
                has_device: number;
                is_discontinued: boolean;
                subscription_format: string;
                delivery_region_code: string;
                region: number;
                region_label: string;
                flavor: number;
                flavor_label: string;
                enable_order_quantity_limit: number;
                order_quantity_limit: number;
                color_label: string;
                strength: number;
                promotionalOffers: Array<{
                  code: string;
                  limit_qty: number;
                  eligible: boolean;
                  type: Types.ISpecialOfferTypeEnum;
                  skus: Array<string>;
                  description: { title: string; description: string; hint: string; label: string };
                }>;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                image: { url: string; label: string };
                short_description: { html: string };
                categories: Array<{ name: string; uid: string; store_locator_name: string }>;
                free_gifts: {
                  allowed_qty: number;
                  products: Array<{
                    is_eligible: boolean;
                    eligibility_description: string;
                    product:
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        };
                  }>;
                };
                strength_details: { name: string; rating: number };
              }
            | {
                id: number;
                name: string;
                sku: string;
                subscription: number;
                has_registration_consent: boolean;
                trade_in: number;
                type_id: string;
                stock_status: Types.IProductStockStatus;
                has_device: number;
                is_discontinued: boolean;
                subscription_format: string;
                delivery_region_code: string;
                region: number;
                region_label: string;
                flavor: number;
                flavor_label: string;
                enable_order_quantity_limit: number;
                order_quantity_limit: number;
                color_label: string;
                strength: number;
                promotionalOffers: Array<{
                  code: string;
                  limit_qty: number;
                  eligible: boolean;
                  type: Types.ISpecialOfferTypeEnum;
                  skus: Array<string>;
                  description: { title: string; description: string; hint: string; label: string };
                }>;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                image: { url: string; label: string };
                short_description: { html: string };
                categories: Array<{ name: string; uid: string; store_locator_name: string }>;
                free_gifts: {
                  allowed_qty: number;
                  products: Array<{
                    is_eligible: boolean;
                    eligibility_description: string;
                    product:
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        };
                  }>;
                };
                strength_details: { name: string; rating: number };
              }
            | {
                id: number;
                name: string;
                sku: string;
                subscription: number;
                has_registration_consent: boolean;
                trade_in: number;
                type_id: string;
                stock_status: Types.IProductStockStatus;
                has_device: number;
                is_discontinued: boolean;
                subscription_format: string;
                delivery_region_code: string;
                region: number;
                region_label: string;
                flavor: number;
                flavor_label: string;
                enable_order_quantity_limit: number;
                order_quantity_limit: number;
                color_label: string;
                strength: number;
                promotionalOffers: Array<{
                  code: string;
                  limit_qty: number;
                  eligible: boolean;
                  type: Types.ISpecialOfferTypeEnum;
                  skus: Array<string>;
                  description: { title: string; description: string; hint: string; label: string };
                }>;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                image: { url: string; label: string };
                short_description: { html: string };
                categories: Array<{ name: string; uid: string; store_locator_name: string }>;
                free_gifts: {
                  allowed_qty: number;
                  products: Array<{
                    is_eligible: boolean;
                    eligibility_description: string;
                    product:
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        };
                  }>;
                };
                strength_details: { name: string; rating: number };
              }
            | {
                id: number;
                name: string;
                sku: string;
                subscription: number;
                has_registration_consent: boolean;
                trade_in: number;
                type_id: string;
                stock_status: Types.IProductStockStatus;
                has_device: number;
                is_discontinued: boolean;
                subscription_format: string;
                delivery_region_code: string;
                region: number;
                region_label: string;
                flavor: number;
                flavor_label: string;
                enable_order_quantity_limit: number;
                order_quantity_limit: number;
                color_label: string;
                strength: number;
                promotionalOffers: Array<{
                  code: string;
                  limit_qty: number;
                  eligible: boolean;
                  type: Types.ISpecialOfferTypeEnum;
                  skus: Array<string>;
                  description: { title: string; description: string; hint: string; label: string };
                }>;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                image: { url: string; label: string };
                short_description: { html: string };
                categories: Array<{ name: string; uid: string; store_locator_name: string }>;
                free_gifts: {
                  allowed_qty: number;
                  products: Array<{
                    is_eligible: boolean;
                    eligibility_description: string;
                    product:
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        }
                      | {
                          name: string;
                          sku: string;
                          tooltip_info: string;
                          stock_status: Types.IProductStockStatus;
                          image: { url: string; label: string };
                        };
                  }>;
                };
                strength_details: { name: string; rating: number };
              };
          gift_data: { is_gift: boolean; parent_gift_sku: string; parent_gift_id: string; is_gift_removable: boolean };
          prices: {
            discounts: Array<{ label: string; amount: { currency: Types.ICurrencyEnum; value: number } }>;
            price: { currency: Types.ICurrencyEnum; value: number };
            row_total: { currency: Types.ICurrencyEnum; value: number };
            row_total_including_tax: { currency: Types.ICurrencyEnum; value: number };
            total_item_discount: { currency: Types.ICurrencyEnum; value: number };
          };
        }
    >;
  };
};

export type IGetCartPricesQueryVariables = Exact<{
  cartId: string;
}>;

export type IGetCartPricesQuery = {
  cart: {
    subscription_amount: number;
    shipping_addresses: Array<{
      selected_shipping_method: { amount: { currency: Types.ICurrencyEnum; value: number } };
    }>;
    estimated_shipping_cost: {
      carrier_code: string;
      method_code: string;
      method_title: string;
      is_market_default: boolean;
      amount: { value: number; currency: Types.ICurrencyEnum };
    };
    applied_coupons: Array<{ code: string; label: string }>;
    applied_campaign: { loyalty_discount_amount: number; loyalty_discount_uuid: string };
    prices: {
      grand_total: { currency: Types.ICurrencyEnum; value: number };
      subtotal_excluding_tax: { currency: Types.ICurrencyEnum; value: number };
      subtotal_including_tax: { currency: Types.ICurrencyEnum; value: number };
      applied_taxes: Array<{ label: string; rate: number; amount: { currency: Types.ICurrencyEnum; value: number } }>;
      discounts: Array<{
        label: string;
        coupon_code: string;
        amount: { currency: Types.ICurrencyEnum; value: number };
      }>;
    };
    total_after_trial: {
      total: { currency: Types.ICurrencyEnum; value: number };
      total_incl_tax: { currency: Types.ICurrencyEnum; value: number };
      tax: { currency: Types.ICurrencyEnum; value: number };
    };
    available_payment_methods: Array<{ code: string; title: string }>;
    minimum_payable_amount: { currency: Types.ICurrencyEnum; value: number };
  };
};

export type IGetCartSelectedPaymentMethodQueryVariables = Exact<{
  cartId: string;
}>;

export type IGetCartSelectedPaymentMethodQuery = {
  cart: { selected_payment_method: { purchase_order_number: string } };
};

export type IGetConsumablesMatrixQueryVariables = Exact<{ [key: string]: never }>;

export type IGetConsumablesMatrixQuery = {
  getConsumablesMatrix: {
    packagingFormats: Array<{
      id: string;
      label: string;
      contentsType: string;
      itemsPerPackage: number;
      packagesPerBundle: number;
      formatQuantity: number;
      productTypeName: string;
      icon: string;
    }>;
    items: Array<{
      sku: string;
      packagingFormatId: string;
      purchaseType: string;
      brandId: string;
      flavorDetails: { flavour: number; flavour_label: string; swatch_data: string };
    }>;
  };
};

export type IGetCountiesForProfileQueryVariables = Exact<{ [key: string]: never }>;

export type IGetCountiesForProfileQuery = {
  countries: Array<{
    full_name_english: string;
    full_name_locale: string;
    id: string;
    three_letter_abbreviation: string;
    two_letter_abbreviation: string;
    available_regions: Array<{ id: number; code: string; name: string }>;
  }>;
};

export type IGetCountriesQueryVariables = Exact<{ [key: string]: never }>;

export type IGetCountriesQuery = {
  countries: Array<{
    full_name_english: string;
    full_name_locale: string;
    id: string;
    three_letter_abbreviation: string;
    two_letter_abbreviation: string;
    available_regions: Array<{ id: number; code: string; name: string }>;
  }>;
};

export type IGetCountryQueryVariables = Exact<{
  id: string;
}>;

export type IGetCountryQuery = {
  country: {
    id: string;
    two_letter_abbreviation: string;
    three_letter_abbreviation: string;
    full_name_english: string;
    full_name_locale: string;
    available_regions: Array<{ id: number; code: string; name: string }>;
  };
};

export type IGetCurrencyQueryVariables = Exact<{ [key: string]: never }>;

export type IGetCurrencyQuery = {
  currency: { default_display_currency_code: string; default_display_currency_symbol: string };
};

export type IGetCustomerAddressesQueryVariables = Exact<{ [key: string]: never }>;

export type IGetCustomerAddressesQuery = {
  customer: {
    default_shipping: string;
    addresses: Array<{
      id: number;
      country_code: Types.ICountryCodeEnum;
      city: string;
      company: string;
      telephone: string;
      firstname: string;
      lastname: string;
      middlename: string;
      postcode: string;
      street: Array<string>;
      region: { region: string; region_code: string; region_id: number };
    }>;
  };
};

export type IGetCustomerCartQueryVariables = Exact<{ [key: string]: never }>;

export type IGetCustomerCartQuery = {
  customerCart: {
    id: string;
    is_trial_eligible: boolean;
    can_apply_coupons: boolean;
    free_shipping_threshold: number;
    available_payment_methods: Array<{ code: string; title: string }>;
    applied_campaign: {
      loyalty_discount_uuid: string;
      loyalty_discount_points: number | null;
      loyalty_discount_amount: number;
    };
    additional_attributes: Array<{ attribute_code: string; value: string }>;
  };
};

export type IGetCustomerCartIdQueryVariables = Exact<{ [key: string]: never }>;

export type IGetCustomerCartIdQuery = { customerCart: { id: string } };

export type IGetCustomerCartOrderPricesQueryVariables = Exact<{
  cartId: string;
}>;

export type IGetCustomerCartOrderPricesQuery = {
  cart: {
    subscription_amount: number;
    shipping_addresses: Array<{
      selected_shipping_method: { amount: { currency: Types.ICurrencyEnum; value: number } };
    }>;
    estimated_shipping_cost: {
      carrier_code: string;
      method_code: string;
      method_title: string;
      is_market_default: boolean;
      amount: { value: number; currency: Types.ICurrencyEnum };
    };
    applied_campaign: { loyalty_discount_amount: number; loyalty_discount_uuid: string };
    prices: {
      grand_total: { currency: Types.ICurrencyEnum; value: number };
      subtotal_including_tax: { currency: Types.ICurrencyEnum; value: number };
      subtotal_excluding_tax: { currency: Types.ICurrencyEnum; value: number };
      applied_taxes: Array<{ label: string; rate: number; amount: { currency: Types.ICurrencyEnum; value: number } }>;
      discounts: Array<{
        label: string;
        coupon_code: string;
        amount: { currency: Types.ICurrencyEnum; value: number };
      }>;
    };
    minimum_payable_amount: { currency: Types.ICurrencyEnum; value: number };
  };
};

export type IGetCustomerCartPricesQueryVariables = Exact<{
  cartId: string;
}>;

export type IGetCustomerCartPricesQuery = {
  cart: {
    email: string;
    shipping_addresses: Array<{
      selected_shipping_method: { amount: { currency: Types.ICurrencyEnum; value: number } };
    }>;
    items: Array<
      | {
          uid: string;
          quantity: number;
          product:
            | {
                sku: string;
                special_price: number;
                name: string;
                id: number;
                uid: string;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                price_tiers: Array<{
                  quantity: number;
                  discount: { percent_off: number; amount_off: number };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                }>;
              }
            | {
                sku: string;
                special_price: number;
                name: string;
                id: number;
                uid: string;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                price_tiers: Array<{
                  quantity: number;
                  discount: { percent_off: number; amount_off: number };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                }>;
              }
            | {
                sku: string;
                special_price: number;
                name: string;
                id: number;
                uid: string;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                price_tiers: Array<{
                  quantity: number;
                  discount: { percent_off: number; amount_off: number };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                }>;
              }
            | {
                sku: string;
                special_price: number;
                name: string;
                id: number;
                uid: string;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                price_tiers: Array<{
                  quantity: number;
                  discount: { percent_off: number; amount_off: number };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                }>;
              }
            | {
                sku: string;
                special_price: number;
                name: string;
                id: number;
                uid: string;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                price_tiers: Array<{
                  quantity: number;
                  discount: { percent_off: number; amount_off: number };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                }>;
              }
            | {
                sku: string;
                special_price: number;
                name: string;
                id: number;
                uid: string;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                price_tiers: Array<{
                  quantity: number;
                  discount: { percent_off: number; amount_off: number };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                }>;
              }
            | {
                sku: string;
                special_price: number;
                name: string;
                id: number;
                uid: string;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                price_tiers: Array<{
                  quantity: number;
                  discount: { percent_off: number; amount_off: number };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                }>;
              };
          prices: { price: { value: number } };
        }
      | {
          uid: string;
          quantity: number;
          product:
            | {
                sku: string;
                special_price: number;
                name: string;
                id: number;
                uid: string;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                price_tiers: Array<{
                  quantity: number;
                  discount: { percent_off: number; amount_off: number };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                }>;
              }
            | {
                sku: string;
                special_price: number;
                name: string;
                id: number;
                uid: string;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                price_tiers: Array<{
                  quantity: number;
                  discount: { percent_off: number; amount_off: number };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                }>;
              }
            | {
                sku: string;
                special_price: number;
                name: string;
                id: number;
                uid: string;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                price_tiers: Array<{
                  quantity: number;
                  discount: { percent_off: number; amount_off: number };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                }>;
              }
            | {
                sku: string;
                special_price: number;
                name: string;
                id: number;
                uid: string;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                price_tiers: Array<{
                  quantity: number;
                  discount: { percent_off: number; amount_off: number };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                }>;
              }
            | {
                sku: string;
                special_price: number;
                name: string;
                id: number;
                uid: string;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                price_tiers: Array<{
                  quantity: number;
                  discount: { percent_off: number; amount_off: number };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                }>;
              }
            | {
                sku: string;
                special_price: number;
                name: string;
                id: number;
                uid: string;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                price_tiers: Array<{
                  quantity: number;
                  discount: { percent_off: number; amount_off: number };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                }>;
              }
            | {
                sku: string;
                special_price: number;
                name: string;
                id: number;
                uid: string;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                price_tiers: Array<{
                  quantity: number;
                  discount: { percent_off: number; amount_off: number };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                }>;
              };
          prices: { price: { value: number } };
        }
      | {
          uid: string;
          quantity: number;
          product:
            | {
                sku: string;
                special_price: number;
                name: string;
                id: number;
                uid: string;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                price_tiers: Array<{
                  quantity: number;
                  discount: { percent_off: number; amount_off: number };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                }>;
              }
            | {
                sku: string;
                special_price: number;
                name: string;
                id: number;
                uid: string;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                price_tiers: Array<{
                  quantity: number;
                  discount: { percent_off: number; amount_off: number };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                }>;
              }
            | {
                sku: string;
                special_price: number;
                name: string;
                id: number;
                uid: string;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                price_tiers: Array<{
                  quantity: number;
                  discount: { percent_off: number; amount_off: number };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                }>;
              }
            | {
                sku: string;
                special_price: number;
                name: string;
                id: number;
                uid: string;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                price_tiers: Array<{
                  quantity: number;
                  discount: { percent_off: number; amount_off: number };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                }>;
              }
            | {
                sku: string;
                special_price: number;
                name: string;
                id: number;
                uid: string;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                price_tiers: Array<{
                  quantity: number;
                  discount: { percent_off: number; amount_off: number };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                }>;
              }
            | {
                sku: string;
                special_price: number;
                name: string;
                id: number;
                uid: string;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                price_tiers: Array<{
                  quantity: number;
                  discount: { percent_off: number; amount_off: number };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                }>;
              }
            | {
                sku: string;
                special_price: number;
                name: string;
                id: number;
                uid: string;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                price_tiers: Array<{
                  quantity: number;
                  discount: { percent_off: number; amount_off: number };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                }>;
              };
          prices: { price: { value: number } };
        }
      | {
          uid: string;
          quantity: number;
          product:
            | {
                sku: string;
                special_price: number;
                name: string;
                id: number;
                uid: string;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                price_tiers: Array<{
                  quantity: number;
                  discount: { percent_off: number; amount_off: number };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                }>;
              }
            | {
                sku: string;
                special_price: number;
                name: string;
                id: number;
                uid: string;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                price_tiers: Array<{
                  quantity: number;
                  discount: { percent_off: number; amount_off: number };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                }>;
              }
            | {
                sku: string;
                special_price: number;
                name: string;
                id: number;
                uid: string;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                price_tiers: Array<{
                  quantity: number;
                  discount: { percent_off: number; amount_off: number };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                }>;
              }
            | {
                sku: string;
                special_price: number;
                name: string;
                id: number;
                uid: string;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                price_tiers: Array<{
                  quantity: number;
                  discount: { percent_off: number; amount_off: number };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                }>;
              }
            | {
                sku: string;
                special_price: number;
                name: string;
                id: number;
                uid: string;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                price_tiers: Array<{
                  quantity: number;
                  discount: { percent_off: number; amount_off: number };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                }>;
              }
            | {
                sku: string;
                special_price: number;
                name: string;
                id: number;
                uid: string;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                price_tiers: Array<{
                  quantity: number;
                  discount: { percent_off: number; amount_off: number };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                }>;
              }
            | {
                sku: string;
                special_price: number;
                name: string;
                id: number;
                uid: string;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                price_tiers: Array<{
                  quantity: number;
                  discount: { percent_off: number; amount_off: number };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                }>;
              };
          prices: { price: { value: number } };
        }
      | {
          uid: string;
          quantity: number;
          product:
            | {
                sku: string;
                special_price: number;
                name: string;
                id: number;
                uid: string;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                price_tiers: Array<{
                  quantity: number;
                  discount: { percent_off: number; amount_off: number };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                }>;
              }
            | {
                sku: string;
                special_price: number;
                name: string;
                id: number;
                uid: string;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                price_tiers: Array<{
                  quantity: number;
                  discount: { percent_off: number; amount_off: number };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                }>;
              }
            | {
                sku: string;
                special_price: number;
                name: string;
                id: number;
                uid: string;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                price_tiers: Array<{
                  quantity: number;
                  discount: { percent_off: number; amount_off: number };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                }>;
              }
            | {
                sku: string;
                special_price: number;
                name: string;
                id: number;
                uid: string;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                price_tiers: Array<{
                  quantity: number;
                  discount: { percent_off: number; amount_off: number };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                }>;
              }
            | {
                sku: string;
                special_price: number;
                name: string;
                id: number;
                uid: string;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                price_tiers: Array<{
                  quantity: number;
                  discount: { percent_off: number; amount_off: number };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                }>;
              }
            | {
                sku: string;
                special_price: number;
                name: string;
                id: number;
                uid: string;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                price_tiers: Array<{
                  quantity: number;
                  discount: { percent_off: number; amount_off: number };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                }>;
              }
            | {
                sku: string;
                special_price: number;
                name: string;
                id: number;
                uid: string;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                price_tiers: Array<{
                  quantity: number;
                  discount: { percent_off: number; amount_off: number };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                }>;
              };
          prices: { price: { value: number } };
        }
      | {
          uid: string;
          quantity: number;
          product:
            | {
                sku: string;
                special_price: number;
                name: string;
                id: number;
                uid: string;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                price_tiers: Array<{
                  quantity: number;
                  discount: { percent_off: number; amount_off: number };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                }>;
              }
            | {
                sku: string;
                special_price: number;
                name: string;
                id: number;
                uid: string;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                price_tiers: Array<{
                  quantity: number;
                  discount: { percent_off: number; amount_off: number };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                }>;
              }
            | {
                sku: string;
                special_price: number;
                name: string;
                id: number;
                uid: string;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                price_tiers: Array<{
                  quantity: number;
                  discount: { percent_off: number; amount_off: number };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                }>;
              }
            | {
                sku: string;
                special_price: number;
                name: string;
                id: number;
                uid: string;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                price_tiers: Array<{
                  quantity: number;
                  discount: { percent_off: number; amount_off: number };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                }>;
              }
            | {
                sku: string;
                special_price: number;
                name: string;
                id: number;
                uid: string;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                price_tiers: Array<{
                  quantity: number;
                  discount: { percent_off: number; amount_off: number };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                }>;
              }
            | {
                sku: string;
                special_price: number;
                name: string;
                id: number;
                uid: string;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                price_tiers: Array<{
                  quantity: number;
                  discount: { percent_off: number; amount_off: number };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                }>;
              }
            | {
                sku: string;
                special_price: number;
                name: string;
                id: number;
                uid: string;
                price_range: {
                  minimum_price: {
                    regular_price: { value: number; currency: Types.ICurrencyEnum };
                    final_price: { value: number; currency: Types.ICurrencyEnum };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                  maximum_price: {
                    discount: { amount_off: number; percent_off: number };
                    fixed_product_taxes: Array<{
                      label: string;
                      amount: { value: number; currency: Types.ICurrencyEnum };
                    }>;
                  };
                };
                price_tiers: Array<{
                  quantity: number;
                  discount: { percent_off: number; amount_off: number };
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                }>;
              };
          prices: { price: { value: number } };
        }
    >;
    prices: {
      discounts: Array<{ label: string; amount: { value: number } }>;
      subtotal_including_tax: { value: number };
      subtotal_excluding_tax: { value: number };
      applied_taxes: Array<{ label: string; amount: { value: number } }>;
      grand_total: { currency: Types.ICurrencyEnum; value: number };
    };
    total_including_trial: {
      total: { currency: Types.ICurrencyEnum; value: number };
      total_incl_tax: { currency: Types.ICurrencyEnum; value: number };
      tax: { currency: Types.ICurrencyEnum; value: number };
    };
    total_after_trial: {
      total: { currency: Types.ICurrencyEnum; value: number };
      total_incl_tax: { currency: Types.ICurrencyEnum; value: number };
      tax: { currency: Types.ICurrencyEnum; value: number };
    };
    available_payment_methods: Array<{ code: string; title: string }>;
    minimum_payable_amount: { currency: Types.ICurrencyEnum; value: number };
  };
};

export type IGetCustomerCouponsQueryVariables = Exact<{
  cartId: string;
}>;

export type IGetCustomerCouponsQuery = {
  cart: { can_apply_coupons: boolean; applied_coupons: Array<{ code: string; label: string }> };
};

export type IGetCustomerExportedOrderDetailsQueryVariables = Exact<{
  number: string;
}>;

export type IGetCustomerExportedOrderDetailsQuery = {
  customer: {
    orders: {
      items: Array<{
        id: string;
        order_date: string;
        status: string;
        shipping_method: string;
        items: Array<
          | {
              product_name: string;
              quantity_ordered: number;
              quantity_refunded: number;
              quantity_canceled: number;
              product_sku: string;
              selected_options: Array<{ label: string; value: string }>;
              product_sale_price: { value: number; currency: Types.ICurrencyEnum };
              product_sale_price_incl_tax: { currency: Types.ICurrencyEnum; value: number };
            }
          | {
              product_name: string;
              quantity_ordered: number;
              quantity_refunded: number;
              quantity_canceled: number;
              product_sku: string;
              selected_options: Array<{ label: string; value: string }>;
              product_sale_price: { value: number; currency: Types.ICurrencyEnum };
              product_sale_price_incl_tax: { currency: Types.ICurrencyEnum; value: number };
            }
          | {
              product_name: string;
              quantity_ordered: number;
              quantity_refunded: number;
              quantity_canceled: number;
              product_sku: string;
              selected_options: Array<{ label: string; value: string }>;
              product_sale_price: { value: number; currency: Types.ICurrencyEnum };
              product_sale_price_incl_tax: { currency: Types.ICurrencyEnum; value: number };
            }
          | {
              product_name: string;
              quantity_ordered: number;
              quantity_refunded: number;
              quantity_canceled: number;
              product_sku: string;
              selected_options: Array<{ label: string; value: string }>;
              product_sale_price: { value: number; currency: Types.ICurrencyEnum };
              product_sale_price_incl_tax: { currency: Types.ICurrencyEnum; value: number };
            }
          | {
              product_name: string;
              quantity_ordered: number;
              quantity_refunded: number;
              quantity_canceled: number;
              product_sku: string;
              selected_options: Array<{ label: string; value: string }>;
              product_sale_price: { value: number; currency: Types.ICurrencyEnum };
              product_sale_price_incl_tax: { currency: Types.ICurrencyEnum; value: number };
            }
        >;
        shipping_address: {
          firstname: string;
          lastname: string;
          street: Array<string>;
          city: string;
          country_code: Types.ICountryCodeEnum;
          postcode: string;
          telephone: string;
        };
        billing_address: {
          firstname: string;
          lastname: string;
          street: Array<string>;
          city: string;
          country_code: Types.ICountryCodeEnum;
        };
        shipments: Array<{ tracking: Array<{ number: string }> }>;
        payment_methods: Array<{ type: string; name: string; additional_data: Array<{ name: string; value: string }> }>;
        total: {
          subtotal: { currency: Types.ICurrencyEnum; value: number };
          taxes: Array<{ amount: { currency: Types.ICurrencyEnum; value: number } }>;
          discounts: Array<{ label: string; amount: { currency: Types.ICurrencyEnum; value: number } }>;
          total_shipping: { currency: Types.ICurrencyEnum; value: number };
          grand_total: { value: number; currency: Types.ICurrencyEnum };
        };
        invoices: Array<{ url: string }>;
      }>;
    };
  };
};

export type IGetCustomerOrderQueryVariables = Exact<{
  orderNumber: string;
}>;

export type IGetCustomerOrderQuery = {
  customer: {
    orders: {
      items: Array<{
        id: string;
        carrier: string;
        number: string;
        order_date: string;
        shipping_method: string;
        shipping_method_code: string;
        status: string;
        items: Array<
          | {
              id: string;
              product_name: string;
              product_sku: string;
              product_type: string;
              quantity_ordered: number;
              trade_in: number;
              bundle_options: Array<{
                id: string;
                label: string;
                values: Array<{
                  id: string;
                  product_name: string;
                  quantity: number;
                  presentation_info: {
                    initial_price: number;
                    presentation_price: number;
                    product:
                      | { tooltip_info: string; small_image: { label: string; url: string } }
                      | { tooltip_info: string; small_image: { label: string; url: string } }
                      | { tooltip_info: string; small_image: { label: string; url: string } }
                      | { tooltip_info: string; small_image: { label: string; url: string } }
                      | { tooltip_info: string; small_image: { label: string; url: string } }
                      | { tooltip_info: string; small_image: { label: string; url: string } }
                      | { tooltip_info: string; small_image: { label: string; url: string } };
                  };
                }>;
              }>;
              row_total: { currency: Types.ICurrencyEnum; value: number };
              row_total_incl_tax: { currency: Types.ICurrencyEnum; value: number };
              product_sale_price: { currency: Types.ICurrencyEnum; value: number };
              product_sale_price_incl_tax: { currency: Types.ICurrencyEnum; value: number };
              gift_data: { is_gift: boolean; parent_gift_sku: string; parent_gift_id: string };
              product:
                | {
                    subscription: number;
                    subscription_format: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    strength: number;
                    description: { html: string };
                    short_description: { html: string };
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                    strength_details: { name: string; rating: number };
                    price_range: {
                      minimum_price: {
                        regular_price: { value: number; currency: Types.ICurrencyEnum };
                        final_price: { value: number; currency: Types.ICurrencyEnum };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                      maximum_price: {
                        discount: { amount_off: number; percent_off: number };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                    };
                  }
                | {
                    subscription: number;
                    subscription_format: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    strength: number;
                    description: { html: string };
                    short_description: { html: string };
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                    strength_details: { name: string; rating: number };
                    price_range: {
                      minimum_price: {
                        regular_price: { value: number; currency: Types.ICurrencyEnum };
                        final_price: { value: number; currency: Types.ICurrencyEnum };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                      maximum_price: {
                        discount: { amount_off: number; percent_off: number };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                    };
                  }
                | {
                    subscription: number;
                    subscription_format: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    strength: number;
                    description: { html: string };
                    short_description: { html: string };
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                    strength_details: { name: string; rating: number };
                    price_range: {
                      minimum_price: {
                        regular_price: { value: number; currency: Types.ICurrencyEnum };
                        final_price: { value: number; currency: Types.ICurrencyEnum };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                      maximum_price: {
                        discount: { amount_off: number; percent_off: number };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                    };
                  }
                | {
                    subscription: number;
                    subscription_format: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    strength: number;
                    description: { html: string };
                    short_description: { html: string };
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                    strength_details: { name: string; rating: number };
                    price_range: {
                      minimum_price: {
                        regular_price: { value: number; currency: Types.ICurrencyEnum };
                        final_price: { value: number; currency: Types.ICurrencyEnum };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                      maximum_price: {
                        discount: { amount_off: number; percent_off: number };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                    };
                  }
                | {
                    subscription: number;
                    subscription_format: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    strength: number;
                    description: { html: string };
                    short_description: { html: string };
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                    strength_details: { name: string; rating: number };
                    price_range: {
                      minimum_price: {
                        regular_price: { value: number; currency: Types.ICurrencyEnum };
                        final_price: { value: number; currency: Types.ICurrencyEnum };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                      maximum_price: {
                        discount: { amount_off: number; percent_off: number };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                    };
                  }
                | {
                    subscription: number;
                    subscription_format: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    strength: number;
                    description: { html: string };
                    short_description: { html: string };
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                    strength_details: { name: string; rating: number };
                    price_range: {
                      minimum_price: {
                        regular_price: { value: number; currency: Types.ICurrencyEnum };
                        final_price: { value: number; currency: Types.ICurrencyEnum };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                      maximum_price: {
                        discount: { amount_off: number; percent_off: number };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                    };
                  }
                | {
                    subscription: number;
                    subscription_format: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    strength: number;
                    description: { html: string };
                    short_description: { html: string };
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                    strength_details: { name: string; rating: number };
                    price_range: {
                      minimum_price: {
                        regular_price: { value: number; currency: Types.ICurrencyEnum };
                        final_price: { value: number; currency: Types.ICurrencyEnum };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                      maximum_price: {
                        discount: { amount_off: number; percent_off: number };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                    };
                  };
            }
          | {
              id: string;
              product_name: string;
              product_sku: string;
              product_type: string;
              quantity_ordered: number;
              trade_in: number;
              row_total: { currency: Types.ICurrencyEnum; value: number };
              row_total_incl_tax: { currency: Types.ICurrencyEnum; value: number };
              product_sale_price: { currency: Types.ICurrencyEnum; value: number };
              product_sale_price_incl_tax: { currency: Types.ICurrencyEnum; value: number };
              gift_data: { is_gift: boolean; parent_gift_sku: string; parent_gift_id: string };
              product:
                | {
                    subscription: number;
                    subscription_format: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    strength: number;
                    description: { html: string };
                    short_description: { html: string };
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                    strength_details: { name: string; rating: number };
                    price_range: {
                      minimum_price: {
                        regular_price: { value: number; currency: Types.ICurrencyEnum };
                        final_price: { value: number; currency: Types.ICurrencyEnum };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                      maximum_price: {
                        discount: { amount_off: number; percent_off: number };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                    };
                  }
                | {
                    subscription: number;
                    subscription_format: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    strength: number;
                    description: { html: string };
                    short_description: { html: string };
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                    strength_details: { name: string; rating: number };
                    price_range: {
                      minimum_price: {
                        regular_price: { value: number; currency: Types.ICurrencyEnum };
                        final_price: { value: number; currency: Types.ICurrencyEnum };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                      maximum_price: {
                        discount: { amount_off: number; percent_off: number };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                    };
                  }
                | {
                    subscription: number;
                    subscription_format: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    strength: number;
                    description: { html: string };
                    short_description: { html: string };
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                    strength_details: { name: string; rating: number };
                    price_range: {
                      minimum_price: {
                        regular_price: { value: number; currency: Types.ICurrencyEnum };
                        final_price: { value: number; currency: Types.ICurrencyEnum };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                      maximum_price: {
                        discount: { amount_off: number; percent_off: number };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                    };
                  }
                | {
                    subscription: number;
                    subscription_format: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    strength: number;
                    description: { html: string };
                    short_description: { html: string };
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                    strength_details: { name: string; rating: number };
                    price_range: {
                      minimum_price: {
                        regular_price: { value: number; currency: Types.ICurrencyEnum };
                        final_price: { value: number; currency: Types.ICurrencyEnum };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                      maximum_price: {
                        discount: { amount_off: number; percent_off: number };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                    };
                  }
                | {
                    subscription: number;
                    subscription_format: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    strength: number;
                    description: { html: string };
                    short_description: { html: string };
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                    strength_details: { name: string; rating: number };
                    price_range: {
                      minimum_price: {
                        regular_price: { value: number; currency: Types.ICurrencyEnum };
                        final_price: { value: number; currency: Types.ICurrencyEnum };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                      maximum_price: {
                        discount: { amount_off: number; percent_off: number };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                    };
                  }
                | {
                    subscription: number;
                    subscription_format: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    strength: number;
                    description: { html: string };
                    short_description: { html: string };
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                    strength_details: { name: string; rating: number };
                    price_range: {
                      minimum_price: {
                        regular_price: { value: number; currency: Types.ICurrencyEnum };
                        final_price: { value: number; currency: Types.ICurrencyEnum };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                      maximum_price: {
                        discount: { amount_off: number; percent_off: number };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                    };
                  }
                | {
                    subscription: number;
                    subscription_format: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    strength: number;
                    description: { html: string };
                    short_description: { html: string };
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                    strength_details: { name: string; rating: number };
                    price_range: {
                      minimum_price: {
                        regular_price: { value: number; currency: Types.ICurrencyEnum };
                        final_price: { value: number; currency: Types.ICurrencyEnum };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                      maximum_price: {
                        discount: { amount_off: number; percent_off: number };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                    };
                  };
            }
          | {
              id: string;
              product_name: string;
              product_sku: string;
              product_type: string;
              quantity_ordered: number;
              trade_in: number;
              row_total: { currency: Types.ICurrencyEnum; value: number };
              row_total_incl_tax: { currency: Types.ICurrencyEnum; value: number };
              product_sale_price: { currency: Types.ICurrencyEnum; value: number };
              product_sale_price_incl_tax: { currency: Types.ICurrencyEnum; value: number };
              gift_data: { is_gift: boolean; parent_gift_sku: string; parent_gift_id: string };
              product:
                | {
                    subscription: number;
                    subscription_format: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    strength: number;
                    description: { html: string };
                    short_description: { html: string };
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                    strength_details: { name: string; rating: number };
                    price_range: {
                      minimum_price: {
                        regular_price: { value: number; currency: Types.ICurrencyEnum };
                        final_price: { value: number; currency: Types.ICurrencyEnum };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                      maximum_price: {
                        discount: { amount_off: number; percent_off: number };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                    };
                  }
                | {
                    subscription: number;
                    subscription_format: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    strength: number;
                    description: { html: string };
                    short_description: { html: string };
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                    strength_details: { name: string; rating: number };
                    price_range: {
                      minimum_price: {
                        regular_price: { value: number; currency: Types.ICurrencyEnum };
                        final_price: { value: number; currency: Types.ICurrencyEnum };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                      maximum_price: {
                        discount: { amount_off: number; percent_off: number };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                    };
                  }
                | {
                    subscription: number;
                    subscription_format: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    strength: number;
                    description: { html: string };
                    short_description: { html: string };
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                    strength_details: { name: string; rating: number };
                    price_range: {
                      minimum_price: {
                        regular_price: { value: number; currency: Types.ICurrencyEnum };
                        final_price: { value: number; currency: Types.ICurrencyEnum };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                      maximum_price: {
                        discount: { amount_off: number; percent_off: number };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                    };
                  }
                | {
                    subscription: number;
                    subscription_format: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    strength: number;
                    description: { html: string };
                    short_description: { html: string };
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                    strength_details: { name: string; rating: number };
                    price_range: {
                      minimum_price: {
                        regular_price: { value: number; currency: Types.ICurrencyEnum };
                        final_price: { value: number; currency: Types.ICurrencyEnum };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                      maximum_price: {
                        discount: { amount_off: number; percent_off: number };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                    };
                  }
                | {
                    subscription: number;
                    subscription_format: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    strength: number;
                    description: { html: string };
                    short_description: { html: string };
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                    strength_details: { name: string; rating: number };
                    price_range: {
                      minimum_price: {
                        regular_price: { value: number; currency: Types.ICurrencyEnum };
                        final_price: { value: number; currency: Types.ICurrencyEnum };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                      maximum_price: {
                        discount: { amount_off: number; percent_off: number };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                    };
                  }
                | {
                    subscription: number;
                    subscription_format: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    strength: number;
                    description: { html: string };
                    short_description: { html: string };
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                    strength_details: { name: string; rating: number };
                    price_range: {
                      minimum_price: {
                        regular_price: { value: number; currency: Types.ICurrencyEnum };
                        final_price: { value: number; currency: Types.ICurrencyEnum };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                      maximum_price: {
                        discount: { amount_off: number; percent_off: number };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                    };
                  }
                | {
                    subscription: number;
                    subscription_format: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    strength: number;
                    description: { html: string };
                    short_description: { html: string };
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                    strength_details: { name: string; rating: number };
                    price_range: {
                      minimum_price: {
                        regular_price: { value: number; currency: Types.ICurrencyEnum };
                        final_price: { value: number; currency: Types.ICurrencyEnum };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                      maximum_price: {
                        discount: { amount_off: number; percent_off: number };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                    };
                  };
            }
          | {
              id: string;
              product_name: string;
              product_sku: string;
              product_type: string;
              quantity_ordered: number;
              trade_in: number;
              row_total: { currency: Types.ICurrencyEnum; value: number };
              row_total_incl_tax: { currency: Types.ICurrencyEnum; value: number };
              product_sale_price: { currency: Types.ICurrencyEnum; value: number };
              product_sale_price_incl_tax: { currency: Types.ICurrencyEnum; value: number };
              gift_data: { is_gift: boolean; parent_gift_sku: string; parent_gift_id: string };
              product:
                | {
                    subscription: number;
                    subscription_format: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    strength: number;
                    description: { html: string };
                    short_description: { html: string };
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                    strength_details: { name: string; rating: number };
                    price_range: {
                      minimum_price: {
                        regular_price: { value: number; currency: Types.ICurrencyEnum };
                        final_price: { value: number; currency: Types.ICurrencyEnum };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                      maximum_price: {
                        discount: { amount_off: number; percent_off: number };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                    };
                  }
                | {
                    subscription: number;
                    subscription_format: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    strength: number;
                    description: { html: string };
                    short_description: { html: string };
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                    strength_details: { name: string; rating: number };
                    price_range: {
                      minimum_price: {
                        regular_price: { value: number; currency: Types.ICurrencyEnum };
                        final_price: { value: number; currency: Types.ICurrencyEnum };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                      maximum_price: {
                        discount: { amount_off: number; percent_off: number };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                    };
                  }
                | {
                    subscription: number;
                    subscription_format: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    strength: number;
                    description: { html: string };
                    short_description: { html: string };
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                    strength_details: { name: string; rating: number };
                    price_range: {
                      minimum_price: {
                        regular_price: { value: number; currency: Types.ICurrencyEnum };
                        final_price: { value: number; currency: Types.ICurrencyEnum };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                      maximum_price: {
                        discount: { amount_off: number; percent_off: number };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                    };
                  }
                | {
                    subscription: number;
                    subscription_format: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    strength: number;
                    description: { html: string };
                    short_description: { html: string };
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                    strength_details: { name: string; rating: number };
                    price_range: {
                      minimum_price: {
                        regular_price: { value: number; currency: Types.ICurrencyEnum };
                        final_price: { value: number; currency: Types.ICurrencyEnum };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                      maximum_price: {
                        discount: { amount_off: number; percent_off: number };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                    };
                  }
                | {
                    subscription: number;
                    subscription_format: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    strength: number;
                    description: { html: string };
                    short_description: { html: string };
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                    strength_details: { name: string; rating: number };
                    price_range: {
                      minimum_price: {
                        regular_price: { value: number; currency: Types.ICurrencyEnum };
                        final_price: { value: number; currency: Types.ICurrencyEnum };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                      maximum_price: {
                        discount: { amount_off: number; percent_off: number };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                    };
                  }
                | {
                    subscription: number;
                    subscription_format: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    strength: number;
                    description: { html: string };
                    short_description: { html: string };
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                    strength_details: { name: string; rating: number };
                    price_range: {
                      minimum_price: {
                        regular_price: { value: number; currency: Types.ICurrencyEnum };
                        final_price: { value: number; currency: Types.ICurrencyEnum };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                      maximum_price: {
                        discount: { amount_off: number; percent_off: number };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                    };
                  }
                | {
                    subscription: number;
                    subscription_format: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    strength: number;
                    description: { html: string };
                    short_description: { html: string };
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                    strength_details: { name: string; rating: number };
                    price_range: {
                      minimum_price: {
                        regular_price: { value: number; currency: Types.ICurrencyEnum };
                        final_price: { value: number; currency: Types.ICurrencyEnum };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                      maximum_price: {
                        discount: { amount_off: number; percent_off: number };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                    };
                  };
            }
          | {
              id: string;
              product_name: string;
              product_sku: string;
              product_type: string;
              quantity_ordered: number;
              trade_in: number;
              row_total: { currency: Types.ICurrencyEnum; value: number };
              row_total_incl_tax: { currency: Types.ICurrencyEnum; value: number };
              product_sale_price: { currency: Types.ICurrencyEnum; value: number };
              product_sale_price_incl_tax: { currency: Types.ICurrencyEnum; value: number };
              gift_data: { is_gift: boolean; parent_gift_sku: string; parent_gift_id: string };
              product:
                | {
                    subscription: number;
                    subscription_format: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    strength: number;
                    description: { html: string };
                    short_description: { html: string };
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                    strength_details: { name: string; rating: number };
                    price_range: {
                      minimum_price: {
                        regular_price: { value: number; currency: Types.ICurrencyEnum };
                        final_price: { value: number; currency: Types.ICurrencyEnum };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                      maximum_price: {
                        discount: { amount_off: number; percent_off: number };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                    };
                  }
                | {
                    subscription: number;
                    subscription_format: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    strength: number;
                    description: { html: string };
                    short_description: { html: string };
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                    strength_details: { name: string; rating: number };
                    price_range: {
                      minimum_price: {
                        regular_price: { value: number; currency: Types.ICurrencyEnum };
                        final_price: { value: number; currency: Types.ICurrencyEnum };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                      maximum_price: {
                        discount: { amount_off: number; percent_off: number };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                    };
                  }
                | {
                    subscription: number;
                    subscription_format: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    strength: number;
                    description: { html: string };
                    short_description: { html: string };
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                    strength_details: { name: string; rating: number };
                    price_range: {
                      minimum_price: {
                        regular_price: { value: number; currency: Types.ICurrencyEnum };
                        final_price: { value: number; currency: Types.ICurrencyEnum };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                      maximum_price: {
                        discount: { amount_off: number; percent_off: number };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                    };
                  }
                | {
                    subscription: number;
                    subscription_format: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    strength: number;
                    description: { html: string };
                    short_description: { html: string };
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                    strength_details: { name: string; rating: number };
                    price_range: {
                      minimum_price: {
                        regular_price: { value: number; currency: Types.ICurrencyEnum };
                        final_price: { value: number; currency: Types.ICurrencyEnum };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                      maximum_price: {
                        discount: { amount_off: number; percent_off: number };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                    };
                  }
                | {
                    subscription: number;
                    subscription_format: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    strength: number;
                    description: { html: string };
                    short_description: { html: string };
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                    strength_details: { name: string; rating: number };
                    price_range: {
                      minimum_price: {
                        regular_price: { value: number; currency: Types.ICurrencyEnum };
                        final_price: { value: number; currency: Types.ICurrencyEnum };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                      maximum_price: {
                        discount: { amount_off: number; percent_off: number };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                    };
                  }
                | {
                    subscription: number;
                    subscription_format: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    strength: number;
                    description: { html: string };
                    short_description: { html: string };
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                    strength_details: { name: string; rating: number };
                    price_range: {
                      minimum_price: {
                        regular_price: { value: number; currency: Types.ICurrencyEnum };
                        final_price: { value: number; currency: Types.ICurrencyEnum };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                      maximum_price: {
                        discount: { amount_off: number; percent_off: number };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                    };
                  }
                | {
                    subscription: number;
                    subscription_format: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    strength: number;
                    description: { html: string };
                    short_description: { html: string };
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                    strength_details: { name: string; rating: number };
                    price_range: {
                      minimum_price: {
                        regular_price: { value: number; currency: Types.ICurrencyEnum };
                        final_price: { value: number; currency: Types.ICurrencyEnum };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                      maximum_price: {
                        discount: { amount_off: number; percent_off: number };
                        fixed_product_taxes: Array<{
                          label: string;
                          amount: { value: number; currency: Types.ICurrencyEnum };
                        }>;
                      };
                    };
                  };
            }
        >;
        payment_methods: Array<{ type: string; name: string; additional_data: Array<{ name: string; value: string }> }>;
        additional_attributes: Array<{ attribute_code: string; value: string }>;
        billing_address: {
          city: string;
          country_code: Types.ICountryCodeEnum;
          firstname: string;
          lastname: string;
          postcode: string;
          street: Array<string>;
          telephone: string;
          administrative_area_level_2: string;
          sublocality_level_2: string;
          premise: string;
          neighborhood: string;
          landmark: string;
          building_number: string;
          district: string;
          region: string;
          short_address: string;
        };
        shipping_address: {
          city: string;
          country_code: Types.ICountryCodeEnum;
          firstname: string;
          lastname: string;
          postcode: string;
          street: Array<string>;
          telephone: string;
          pickup_information: string;
          administrative_area_level_2: string;
          sublocality_level_2: string;
          premise: string;
          neighborhood: string;
          landmark: string;
          building_number: string;
          district: string;
          region: string;
          short_address: string;
        };
        loyalty_info: {
          loyalty_discount_amount: number;
          loyalty_discount_points: number | null;
          loyalty_discount_uuid: string;
        };
        invoices: Array<{ url: string }>;
        total: {
          discounts: Array<{
            label: string;
            coupon_code: string;
            amount: { currency: Types.ICurrencyEnum; value: number };
          }>;
          grand_total: { currency: Types.ICurrencyEnum; value: number };
          subtotal: { currency: Types.ICurrencyEnum; value: number };
          subtotal_incl_tax: { currency: Types.ICurrencyEnum; value: number };
          taxes: Array<{ title: string; rate: number; amount: { currency: Types.ICurrencyEnum; value: number } }>;
          total_shipping: { currency: Types.ICurrencyEnum; value: number };
          total_refunded: { currency: Types.ICurrencyEnum; value: number };
          total_tax: { currency: Types.ICurrencyEnum; value: number };
        };
        total_including_trial: {
          total: { currency: Types.ICurrencyEnum; value: number };
          total_incl_tax: { currency: Types.ICurrencyEnum; value: number };
          tax: { currency: Types.ICurrencyEnum; value: number };
        };
        total_after_trial: {
          total: { currency: Types.ICurrencyEnum; value: number };
          total_incl_tax: { currency: Types.ICurrencyEnum; value: number };
          tax: { currency: Types.ICurrencyEnum; value: number };
        };
      }>;
    };
  };
};

export type IGetCustomerOrderDetailsQueryVariables = Exact<{
  number: string;
  scope?: Types.IScopeTypeEnum | null | undefined;
}>;

export type IGetCustomerOrderDetailsQuery = {
  customer: {
    orders: {
      items: Array<{
        id: string;
        order_date: string;
        website_code: string;
        has_withdrawal: boolean;
        withdrawal_id: string;
        status: string;
        shipping_method: string;
        status_reason: { reason_code: string; reason_message: string };
        items: Array<
          | {
              id: string;
              product_type: string;
              product_name: string;
              quantity_ordered: number;
              quantity_refunded: number;
              quantity_canceled: number;
              product_sku: string;
              bundle_options: Array<{
                id: string;
                label: string;
                values: Array<{
                  uid: string;
                  id: string;
                  product_name: string;
                  quantity: number;
                  presentation_info: {
                    initial_price: number;
                    presentation_price: number;
                    product:
                      | {
                          uid: string;
                          id: number;
                          tooltip_info: string;
                          is_discontinued: boolean;
                          small_image: { url: string };
                        }
                      | {
                          uid: string;
                          id: number;
                          tooltip_info: string;
                          is_discontinued: boolean;
                          small_image: { url: string };
                        }
                      | {
                          uid: string;
                          id: number;
                          tooltip_info: string;
                          is_discontinued: boolean;
                          small_image: { url: string };
                        }
                      | {
                          uid: string;
                          id: number;
                          tooltip_info: string;
                          is_discontinued: boolean;
                          small_image: { url: string };
                        }
                      | {
                          uid: string;
                          id: number;
                          tooltip_info: string;
                          is_discontinued: boolean;
                          small_image: { url: string };
                        }
                      | {
                          uid: string;
                          id: number;
                          tooltip_info: string;
                          is_discontinued: boolean;
                          small_image: { url: string };
                        }
                      | {
                          uid: string;
                          id: number;
                          tooltip_info: string;
                          is_discontinued: boolean;
                          small_image: { url: string };
                        };
                  };
                }>;
              }>;
              product:
                | {
                    __typename: "BundleProduct";
                    color_label: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    hidden_sku: boolean;
                    subscription: number;
                    is_discontinued: boolean;
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                  }
                | {
                    __typename: "ConfigurableProduct";
                    color_label: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    hidden_sku: boolean;
                    subscription: number;
                    is_discontinued: boolean;
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                  }
                | {
                    __typename: "DownloadableProduct";
                    color_label: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    hidden_sku: boolean;
                    subscription: number;
                    is_discontinued: boolean;
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                  }
                | {
                    __typename: "GiftCardProduct";
                    color_label: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    hidden_sku: boolean;
                    subscription: number;
                    is_discontinued: boolean;
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                  }
                | {
                    __typename: "GroupedProduct";
                    color_label: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    hidden_sku: boolean;
                    subscription: number;
                    is_discontinued: boolean;
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                  }
                | {
                    __typename: "SimpleProduct";
                    color_label: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    hidden_sku: boolean;
                    subscription: number;
                    is_discontinued: boolean;
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                  }
                | {
                    __typename: "VirtualProduct";
                    color_label: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    hidden_sku: boolean;
                    subscription: number;
                    is_discontinued: boolean;
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                  };
              selected_options: Array<{ label: string; value: string }>;
              row_total: { currency: Types.ICurrencyEnum; value: number };
              row_total_incl_tax: { currency: Types.ICurrencyEnum; value: number };
              product_sale_price: { value: number; currency: Types.ICurrencyEnum };
              product_sale_price_incl_tax: { currency: Types.ICurrencyEnum; value: number };
              gift_data: { is_gift: boolean; parent_gift_sku: string; parent_gift_id: string };
            }
          | {
              id: string;
              product_type: string;
              product_name: string;
              quantity_ordered: number;
              quantity_refunded: number;
              quantity_canceled: number;
              product_sku: string;
              product:
                | {
                    __typename: "BundleProduct";
                    color_label: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    hidden_sku: boolean;
                    subscription: number;
                    is_discontinued: boolean;
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                  }
                | {
                    __typename: "ConfigurableProduct";
                    color_label: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    hidden_sku: boolean;
                    subscription: number;
                    is_discontinued: boolean;
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                  }
                | {
                    __typename: "DownloadableProduct";
                    color_label: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    hidden_sku: boolean;
                    subscription: number;
                    is_discontinued: boolean;
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                  }
                | {
                    __typename: "GiftCardProduct";
                    color_label: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    hidden_sku: boolean;
                    subscription: number;
                    is_discontinued: boolean;
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                  }
                | {
                    __typename: "GroupedProduct";
                    color_label: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    hidden_sku: boolean;
                    subscription: number;
                    is_discontinued: boolean;
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                  }
                | {
                    __typename: "SimpleProduct";
                    color_label: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    hidden_sku: boolean;
                    subscription: number;
                    is_discontinued: boolean;
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                  }
                | {
                    __typename: "VirtualProduct";
                    color_label: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    hidden_sku: boolean;
                    subscription: number;
                    is_discontinued: boolean;
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                  };
              selected_options: Array<{ label: string; value: string }>;
              row_total: { currency: Types.ICurrencyEnum; value: number };
              row_total_incl_tax: { currency: Types.ICurrencyEnum; value: number };
              product_sale_price: { value: number; currency: Types.ICurrencyEnum };
              product_sale_price_incl_tax: { currency: Types.ICurrencyEnum; value: number };
              gift_data: { is_gift: boolean; parent_gift_sku: string; parent_gift_id: string };
            }
          | {
              id: string;
              product_type: string;
              product_name: string;
              quantity_ordered: number;
              quantity_refunded: number;
              quantity_canceled: number;
              product_sku: string;
              product:
                | {
                    __typename: "BundleProduct";
                    color_label: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    hidden_sku: boolean;
                    subscription: number;
                    is_discontinued: boolean;
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                  }
                | {
                    __typename: "ConfigurableProduct";
                    color_label: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    hidden_sku: boolean;
                    subscription: number;
                    is_discontinued: boolean;
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                  }
                | {
                    __typename: "DownloadableProduct";
                    color_label: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    hidden_sku: boolean;
                    subscription: number;
                    is_discontinued: boolean;
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                  }
                | {
                    __typename: "GiftCardProduct";
                    color_label: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    hidden_sku: boolean;
                    subscription: number;
                    is_discontinued: boolean;
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                  }
                | {
                    __typename: "GroupedProduct";
                    color_label: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    hidden_sku: boolean;
                    subscription: number;
                    is_discontinued: boolean;
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                  }
                | {
                    __typename: "SimpleProduct";
                    color_label: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    hidden_sku: boolean;
                    subscription: number;
                    is_discontinued: boolean;
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                  }
                | {
                    __typename: "VirtualProduct";
                    color_label: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    hidden_sku: boolean;
                    subscription: number;
                    is_discontinued: boolean;
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                  };
              selected_options: Array<{ label: string; value: string }>;
              row_total: { currency: Types.ICurrencyEnum; value: number };
              row_total_incl_tax: { currency: Types.ICurrencyEnum; value: number };
              product_sale_price: { value: number; currency: Types.ICurrencyEnum };
              product_sale_price_incl_tax: { currency: Types.ICurrencyEnum; value: number };
              gift_data: { is_gift: boolean; parent_gift_sku: string; parent_gift_id: string };
            }
          | {
              id: string;
              product_type: string;
              product_name: string;
              quantity_ordered: number;
              quantity_refunded: number;
              quantity_canceled: number;
              product_sku: string;
              product:
                | {
                    __typename: "BundleProduct";
                    color_label: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    hidden_sku: boolean;
                    subscription: number;
                    is_discontinued: boolean;
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                  }
                | {
                    __typename: "ConfigurableProduct";
                    color_label: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    hidden_sku: boolean;
                    subscription: number;
                    is_discontinued: boolean;
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                  }
                | {
                    __typename: "DownloadableProduct";
                    color_label: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    hidden_sku: boolean;
                    subscription: number;
                    is_discontinued: boolean;
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                  }
                | {
                    __typename: "GiftCardProduct";
                    color_label: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    hidden_sku: boolean;
                    subscription: number;
                    is_discontinued: boolean;
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                  }
                | {
                    __typename: "GroupedProduct";
                    color_label: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    hidden_sku: boolean;
                    subscription: number;
                    is_discontinued: boolean;
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                  }
                | {
                    __typename: "SimpleProduct";
                    color_label: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    hidden_sku: boolean;
                    subscription: number;
                    is_discontinued: boolean;
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                  }
                | {
                    __typename: "VirtualProduct";
                    color_label: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    hidden_sku: boolean;
                    subscription: number;
                    is_discontinued: boolean;
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                  };
              selected_options: Array<{ label: string; value: string }>;
              row_total: { currency: Types.ICurrencyEnum; value: number };
              row_total_incl_tax: { currency: Types.ICurrencyEnum; value: number };
              product_sale_price: { value: number; currency: Types.ICurrencyEnum };
              product_sale_price_incl_tax: { currency: Types.ICurrencyEnum; value: number };
              gift_data: { is_gift: boolean; parent_gift_sku: string; parent_gift_id: string };
            }
          | {
              id: string;
              product_type: string;
              product_name: string;
              quantity_ordered: number;
              quantity_refunded: number;
              quantity_canceled: number;
              product_sku: string;
              product:
                | {
                    __typename: "BundleProduct";
                    color_label: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    hidden_sku: boolean;
                    subscription: number;
                    is_discontinued: boolean;
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                  }
                | {
                    __typename: "ConfigurableProduct";
                    color_label: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    hidden_sku: boolean;
                    subscription: number;
                    is_discontinued: boolean;
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                  }
                | {
                    __typename: "DownloadableProduct";
                    color_label: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    hidden_sku: boolean;
                    subscription: number;
                    is_discontinued: boolean;
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                  }
                | {
                    __typename: "GiftCardProduct";
                    color_label: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    hidden_sku: boolean;
                    subscription: number;
                    is_discontinued: boolean;
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                  }
                | {
                    __typename: "GroupedProduct";
                    color_label: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    hidden_sku: boolean;
                    subscription: number;
                    is_discontinued: boolean;
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                  }
                | {
                    __typename: "SimpleProduct";
                    color_label: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    hidden_sku: boolean;
                    subscription: number;
                    is_discontinued: boolean;
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                  }
                | {
                    __typename: "VirtualProduct";
                    color_label: string;
                    enable_order_quantity_limit: number;
                    order_quantity_limit: number;
                    hidden_sku: boolean;
                    subscription: number;
                    is_discontinued: boolean;
                    categories: Array<{ name: string; uid: string }>;
                    image: { url: string };
                  };
              selected_options: Array<{ label: string; value: string }>;
              row_total: { currency: Types.ICurrencyEnum; value: number };
              row_total_incl_tax: { currency: Types.ICurrencyEnum; value: number };
              product_sale_price: { value: number; currency: Types.ICurrencyEnum };
              product_sale_price_incl_tax: { currency: Types.ICurrencyEnum; value: number };
              gift_data: { is_gift: boolean; parent_gift_sku: string; parent_gift_id: string };
            }
        >;
        additional_attributes: Array<{ attribute_code: string; value: string }>;
        shipping_address: {
          firstname: string;
          lastname: string;
          street: Array<string>;
          city: string;
          country_code: Types.ICountryCodeEnum;
          postcode: string;
          telephone: string;
          pickup_information: string;
          administrative_area_level_2: string;
          sublocality_level_2: string;
          premise: string;
          neighborhood: string;
          landmark: string;
          building_number: string;
          district: string;
          region: string;
          region_code: string;
          region_id: string;
        };
        billing_address: {
          firstname: string;
          lastname: string;
          street: Array<string>;
          city: string;
          postcode: string;
          country_code: Types.ICountryCodeEnum;
          administrative_area_level_2: string;
          sublocality_level_2: string;
          premise: string;
          neighborhood: string;
          landmark: string;
          building_number: string;
          district: string;
          region: string;
          region_code: string;
          region_id: string;
        };
        loyalty_info: {
          loyalty_discount_amount: number;
          loyalty_discount_points: number | null;
          loyalty_discount_uuid: string;
        };
        shipments: Array<{ tracking: Array<{ carrier: string; number: string; track_url: string }> }>;
        payment_methods: Array<{
          type: string;
          name: string;
          method_code: string;
          additional_data: Array<{ name: string; value: string }>;
        }>;
        total: {
          subtotal: { currency: Types.ICurrencyEnum; value: number };
          subtotal_incl_tax: { currency: Types.ICurrencyEnum; value: number };
          taxes: Array<{ title: string; rate: number; amount: { currency: Types.ICurrencyEnum; value: number } }>;
          discounts: Array<{ label: string; amount: { currency: Types.ICurrencyEnum; value: number } }>;
          total_shipping: { currency: Types.ICurrencyEnum; value: number };
          total_refunded: { currency: Types.ICurrencyEnum; value: number };
          total_after_refund: { currency: Types.ICurrencyEnum; value: number };
          grand_total: { value: number; currency: Types.ICurrencyEnum };
        };
        total_after_trial: {
          total: { currency: Types.ICurrencyEnum; value: number };
          total_incl_tax: { currency: Types.ICurrencyEnum; value: number };
          tax: { currency: Types.ICurrencyEnum; value: number };
        };
        invoices: Array<{ url: string }>;
      }>;
    };
  };
};

export type IGetCustomerOrdersQueryVariables = Exact<{
  filter?: Types.ICustomerOrdersFilterInput | null | undefined;
}>;

export type IGetCustomerOrdersQuery = {
  customer: {
    orders: {
      items: Array<{
        id: string;
        status: string;
        shipping_method: string;
        carrier: string;
        order_date: string;
        number: string;
        items: Array<
          | {
              id: string;
              product_name: string;
              quantity_shipped: number;
              quantity_refunded: number;
              quantity_canceled: number;
              row_total_incl_tax: { currency: Types.ICurrencyEnum; value: number };
            }
          | {
              id: string;
              product_name: string;
              quantity_shipped: number;
              quantity_refunded: number;
              quantity_canceled: number;
              row_total_incl_tax: { currency: Types.ICurrencyEnum; value: number };
            }
          | {
              id: string;
              product_name: string;
              quantity_shipped: number;
              quantity_refunded: number;
              quantity_canceled: number;
              row_total_incl_tax: { currency: Types.ICurrencyEnum; value: number };
            }
          | {
              id: string;
              product_name: string;
              quantity_shipped: number;
              quantity_refunded: number;
              quantity_canceled: number;
              row_total_incl_tax: { currency: Types.ICurrencyEnum; value: number };
            }
          | {
              id: string;
              product_name: string;
              quantity_shipped: number;
              quantity_refunded: number;
              quantity_canceled: number;
              row_total_incl_tax: { currency: Types.ICurrencyEnum; value: number };
            }
        >;
        total: {
          grand_total: { currency: Types.ICurrencyEnum; value: number };
          subtotal: { currency: Types.ICurrencyEnum; value: number };
        };
      }>;
    };
  };
};

export type IGetCustomerOrdersAllStoresQueryVariables = Exact<{ [key: string]: never }>;

export type IGetCustomerOrdersAllStoresQuery = {
  customer: {
    orders: { items: Array<{ id: string; number: string; status: string; created_at: string; store_code: string }> };
  };
};

export type IGetCustomerOrdersCountQueryVariables = Exact<{
  scope?: Types.IScopeTypeEnum | null | undefined;
}>;

export type IGetCustomerOrdersCountQuery = { customer: { orders: { total_count: number } } };

export type IGetCustomerOrdersPaginationQueryVariables = Exact<{
  filter?: Types.ICustomerOrdersFilterInput | null | undefined;
  currentPage?: number | null | undefined;
  sort?: Types.ICustomerOrderSortInput | null | undefined;
  scope?: Types.IScopeTypeEnum | null | undefined;
  order_type?: Types.IOrderTypeEnum | null | undefined;
}>;

export type IGetCustomerOrdersPaginationQuery = {
  customer: {
    orders: {
      page_info: { current_page: number; total_pages: number };
      items: Array<{
        id: string;
        status: string;
        shipping_method: string;
        carrier: string;
        order_date: string;
        store_code: string;
        website_code: string;
        number: string;
        items: Array<
          | { id: string; product_name: string; quantity_shipped: number; product_subscription: boolean }
          | { id: string; product_name: string; quantity_shipped: number; product_subscription: boolean }
          | { id: string; product_name: string; quantity_shipped: number; product_subscription: boolean }
          | { id: string; product_name: string; quantity_shipped: number; product_subscription: boolean }
          | { id: string; product_name: string; quantity_shipped: number; product_subscription: boolean }
        >;
        payment_methods: Array<{ type: string; name: string }>;
        shipments: Array<{ tracking: Array<{ track_url: string }> }>;
        total: {
          grand_total: { currency: Types.ICurrencyEnum; value: number };
          subtotal: { currency: Types.ICurrencyEnum; value: number };
        };
      }>;
    };
  };
};

export type IGetCustomerOrdersStatusesQueryVariables = Exact<{
  filter?: Types.ICustomerOrdersFilterInput | null | undefined;
}>;

export type IGetCustomerOrdersStatusesQuery = {
  customer: { orders: { items: Array<{ id: string; status: string }> } };
};

export type IGetLastCustomerOrderQueryVariables = Exact<{ [key: string]: never }>;

export type IGetLastCustomerOrderQuery = {
  LastCustomerOrder: {
    shipping_method_code: string;
    payment_methods: Array<{ type: string; method_code: string }>;
    additional_attributes: Array<{ attribute_code: string; value: string }>;
  };
};

export type IGetOrderAttributesQueryVariables = Exact<{ [key: string]: never }>;

export type IGetOrderAttributesQuery = {
  getOrderAttributes: Array<{
    code: string;
    label: string;
    input_type: Types.IOrderInputTypeEnum;
    data_type: Types.IOrderDataTypeEnum;
    is_required: boolean;
    min_length: number;
    max_length: number;
    validate_regex: string;
    value: string;
    description: string;
    placeholder: string;
    placement: string;
    sort_order: number;
  }>;
};

export type IGetOrderDeliveryLimitsQueryVariables = Exact<{ [key: string]: never }>;

export type IGetOrderDeliveryLimitsQuery = {
  getOrderDeliveryLimits: { mode: string; limits: Array<{ id: string; country_id: string; name: string }> };
};

export type IGetProductImageQueryVariables = Exact<{
  sku: string;
}>;

export type IGetProductImageQuery = {
  products: {
    items: Array<
      | { sku: string; image: { url: string }; small_image: { url: string } }
      | { sku: string; image: { url: string }; small_image: { url: string } }
      | { sku: string; image: { url: string }; small_image: { url: string } }
      | { sku: string; image: { url: string }; small_image: { url: string } }
      | { sku: string; image: { url: string }; small_image: { url: string } }
      | { sku: string; image: { url: string }; small_image: { url: string } }
      | { sku: string; image: { url: string }; small_image: { url: string } }
    >;
  };
};

export type IGetProductImageDescriptionQueryVariables = Exact<{
  sku: Array<string | null | undefined> | string;
}>;

export type IGetProductImageDescriptionQuery = {
  products: {
    items: Array<
      | { sku: string; description: { html: string }; image: { url: string } }
      | { sku: string; description: { html: string }; image: { url: string } }
      | { sku: string; description: { html: string }; image: { url: string } }
      | { sku: string; description: { html: string }; image: { url: string } }
      | { sku: string; description: { html: string }; image: { url: string } }
      | { sku: string; description: { html: string }; image: { url: string } }
      | { sku: string; description: { html: string }; image: { url: string } }
    >;
  };
};

export type IGetProductPriceQueryVariables = Exact<{
  sku: string;
  quantity: number;
}>;

export type IGetProductPriceQuery = {
  getProductPrice: {
    maximum_price: {
      final_price: { currency: Types.ICurrencyEnum; value: number };
      regular_price: { currency: Types.ICurrencyEnum; value: number };
    };
    minimum_price: {
      final_price: { currency: Types.ICurrencyEnum; value: number };
      regular_price: { currency: Types.ICurrencyEnum; value: number };
    };
  };
};

export type IGetProductsQueryVariables = Exact<{
  sku?: Array<string | null | undefined> | string | null | undefined;
  pageSize?: number | null | undefined;
}>;

export type IGetProductsQuery = {
  currency: { base_currency_code: string; base_currency_symbol: string };
  products: {
    aggregations: Array<{
      attribute_code: string;
      label: string;
      options: Array<{ count: number; label: string; value: string }>;
    }>;
    items: Array<
      | {
          __typename: "BundleProduct";
          sku: string;
          id: number;
          name: string;
          stock_status: Types.IProductStockStatus;
          flavor: number;
          flavor_label: string;
          product_brand: string;
          color: number;
          subtitle: string;
          product_disclaimer: string;
          items: Array<{
            __typename: "BundleItem";
            option_id: number;
            title: string;
            required: boolean;
            type: string;
            qty: number;
            sku: string;
            all_options: Array<{
              id: number;
              label: string;
              qty: number;
              quantity: number;
              is_default: boolean;
              product:
                | {
                    __typename: "BundleProduct";
                    id: number;
                    name: string;
                    sku: string;
                    flavor: number;
                    flavor_label: string;
                    product_brand: string;
                    stock_status: Types.IProductStockStatus;
                    color_label: string;
                    subtitle: string;
                    flavour_details: Array<{
                      name: string;
                      description: string;
                      attributes: Array<{ id: number; name: string; sort_order: number; value: string }>;
                    }>;
                    thumbnail: { url: string };
                    media_gallery: Array<
                      | { role: Array<string>; label: string; url: string }
                      | { label: string; url: string; video_content: { video_title: string; video_url: string } }
                    >;
                    categories: Array<{ name: string }>;
                    price_range: {
                      minimum_price: {
                        final_price: { value: number; currency: Types.ICurrencyEnum };
                        regular_price: { value: number; currency: Types.ICurrencyEnum };
                        discount: { percent_off: number };
                      };
                    };
                  }
                | {
                    __typename: "ConfigurableProduct";
                    id: number;
                    name: string;
                    sku: string;
                    flavor: number;
                    flavor_label: string;
                    product_brand: string;
                    stock_status: Types.IProductStockStatus;
                    color_label: string;
                    subtitle: string;
                    flavour_details: Array<{
                      name: string;
                      description: string;
                      attributes: Array<{ id: number; name: string; sort_order: number; value: string }>;
                    }>;
                    thumbnail: { url: string };
                    media_gallery: Array<
                      | { role: Array<string>; label: string; url: string }
                      | { label: string; url: string; video_content: { video_title: string; video_url: string } }
                    >;
                    categories: Array<{ name: string }>;
                    price_range: {
                      minimum_price: {
                        final_price: { value: number; currency: Types.ICurrencyEnum };
                        regular_price: { value: number; currency: Types.ICurrencyEnum };
                        discount: { percent_off: number };
                      };
                    };
                  }
                | {
                    __typename: "DownloadableProduct";
                    id: number;
                    name: string;
                    sku: string;
                    flavor: number;
                    flavor_label: string;
                    product_brand: string;
                    stock_status: Types.IProductStockStatus;
                    color_label: string;
                    subtitle: string;
                    flavour_details: Array<{
                      name: string;
                      description: string;
                      attributes: Array<{ id: number; name: string; sort_order: number; value: string }>;
                    }>;
                    thumbnail: { url: string };
                    media_gallery: Array<
                      | { role: Array<string>; label: string; url: string }
                      | { label: string; url: string; video_content: { video_title: string; video_url: string } }
                    >;
                    categories: Array<{ name: string }>;
                    price_range: {
                      minimum_price: {
                        final_price: { value: number; currency: Types.ICurrencyEnum };
                        regular_price: { value: number; currency: Types.ICurrencyEnum };
                        discount: { percent_off: number };
                      };
                    };
                  }
                | {
                    __typename: "GiftCardProduct";
                    id: number;
                    name: string;
                    sku: string;
                    flavor: number;
                    flavor_label: string;
                    product_brand: string;
                    stock_status: Types.IProductStockStatus;
                    color_label: string;
                    subtitle: string;
                    flavour_details: Array<{
                      name: string;
                      description: string;
                      attributes: Array<{ id: number; name: string; sort_order: number; value: string }>;
                    }>;
                    thumbnail: { url: string };
                    media_gallery: Array<
                      | { role: Array<string>; label: string; url: string }
                      | { label: string; url: string; video_content: { video_title: string; video_url: string } }
                    >;
                    categories: Array<{ name: string }>;
                    price_range: {
                      minimum_price: {
                        final_price: { value: number; currency: Types.ICurrencyEnum };
                        regular_price: { value: number; currency: Types.ICurrencyEnum };
                        discount: { percent_off: number };
                      };
                    };
                  }
                | {
                    __typename: "GroupedProduct";
                    id: number;
                    name: string;
                    sku: string;
                    flavor: number;
                    flavor_label: string;
                    product_brand: string;
                    stock_status: Types.IProductStockStatus;
                    color_label: string;
                    subtitle: string;
                    flavour_details: Array<{
                      name: string;
                      description: string;
                      attributes: Array<{ id: number; name: string; sort_order: number; value: string }>;
                    }>;
                    thumbnail: { url: string };
                    media_gallery: Array<
                      | { role: Array<string>; label: string; url: string }
                      | { label: string; url: string; video_content: { video_title: string; video_url: string } }
                    >;
                    categories: Array<{ name: string }>;
                    price_range: {
                      minimum_price: {
                        final_price: { value: number; currency: Types.ICurrencyEnum };
                        regular_price: { value: number; currency: Types.ICurrencyEnum };
                        discount: { percent_off: number };
                      };
                    };
                  }
                | {
                    __typename: "SimpleProduct";
                    id: number;
                    name: string;
                    sku: string;
                    flavor: number;
                    flavor_label: string;
                    product_brand: string;
                    stock_status: Types.IProductStockStatus;
                    color_label: string;
                    subtitle: string;
                    flavour_details: Array<{
                      name: string;
                      description: string;
                      attributes: Array<{ id: number; name: string; sort_order: number; value: string }>;
                    }>;
                    thumbnail: { url: string };
                    media_gallery: Array<
                      | { role: Array<string>; label: string; url: string }
                      | { label: string; url: string; video_content: { video_title: string; video_url: string } }
                    >;
                    categories: Array<{ name: string }>;
                    price_range: {
                      minimum_price: {
                        final_price: { value: number; currency: Types.ICurrencyEnum };
                        regular_price: { value: number; currency: Types.ICurrencyEnum };
                        discount: { percent_off: number };
                      };
                    };
                  }
                | {
                    __typename: "VirtualProduct";
                    id: number;
                    name: string;
                    sku: string;
                    flavor: number;
                    flavor_label: string;
                    product_brand: string;
                    stock_status: Types.IProductStockStatus;
                    color_label: string;
                    subtitle: string;
                    flavour_details: Array<{
                      name: string;
                      description: string;
                      attributes: Array<{ id: number; name: string; sort_order: number; value: string }>;
                    }>;
                    thumbnail: { url: string };
                    media_gallery: Array<
                      | { role: Array<string>; label: string; url: string }
                      | { label: string; url: string; video_content: { video_title: string; video_url: string } }
                    >;
                    categories: Array<{ name: string }>;
                    price_range: {
                      minimum_price: {
                        final_price: { value: number; currency: Types.ICurrencyEnum };
                        regular_price: { value: number; currency: Types.ICurrencyEnum };
                        discount: { percent_off: number };
                      };
                    };
                  };
            }>;
          }>;
          categories: Array<{ name: string }>;
          flavour_details: Array<{
            name: string;
            description: string;
            attributes: Array<{ id: number; name: string; sort_order: number; value: string }>;
          }>;
          thumbnail: { url: string };
          media_gallery: Array<
            | { role: Array<string>; label: string; url: string }
            | { label: string; url: string; video_content: { video_title: string; video_url: string } }
          >;
          price_tiers: Array<{
            quantity: number;
            label: string;
            discount: { percent_off: number; amount_off: number };
            final_price: { value: number; currency: Types.ICurrencyEnum };
            total_price: { value: number; currency: Types.ICurrencyEnum };
          }>;
          price_range: {
            minimum_price: {
              final_prices: Array<{ value: number; currency: Types.ICurrencyEnum; multiplier: number }>;
              final_price: { value: number; currency: Types.ICurrencyEnum };
              regular_price: { value: number; currency: Types.ICurrencyEnum };
              discount: { percent_off: number };
            };
          };
        }
      | {
          __typename: "ConfigurableProduct";
          sku: string;
          id: number;
          name: string;
          stock_status: Types.IProductStockStatus;
          flavor: number;
          flavor_label: string;
          product_brand: string;
          color: number;
          subtitle: string;
          product_disclaimer: string;
          variants: Array<{
            product: {
              sku: string;
              name: string;
              color: number;
              stock_status: Types.IProductStockStatus;
              flavor: number;
              color_label: string;
              subtitle: string;
              product_disclaimer: string;
              categories: Array<{ name: string }>;
              price_range: {
                minimum_price: {
                  final_price: { value: number; currency: Types.ICurrencyEnum };
                  regular_price: { value: number; currency: Types.ICurrencyEnum };
                  discount: { percent_off: number };
                };
              };
            };
          }>;
          categories: Array<{ name: string }>;
          flavour_details: Array<{
            name: string;
            description: string;
            attributes: Array<{ id: number; name: string; sort_order: number; value: string }>;
          }>;
          thumbnail: { url: string };
          media_gallery: Array<
            | { role: Array<string>; label: string; url: string }
            | { label: string; url: string; video_content: { video_title: string; video_url: string } }
          >;
          price_tiers: Array<{
            quantity: number;
            label: string;
            discount: { percent_off: number; amount_off: number };
            final_price: { value: number; currency: Types.ICurrencyEnum };
            total_price: { value: number; currency: Types.ICurrencyEnum };
          }>;
          price_range: {
            minimum_price: {
              final_prices: Array<{ value: number; currency: Types.ICurrencyEnum; multiplier: number }>;
              final_price: { value: number; currency: Types.ICurrencyEnum };
              regular_price: { value: number; currency: Types.ICurrencyEnum };
              discount: { percent_off: number };
            };
          };
        }
      | {
          __typename: "DownloadableProduct";
          sku: string;
          id: number;
          name: string;
          stock_status: Types.IProductStockStatus;
          flavor: number;
          flavor_label: string;
          product_brand: string;
          color: number;
          subtitle: string;
          product_disclaimer: string;
          categories: Array<{ name: string }>;
          flavour_details: Array<{
            name: string;
            description: string;
            attributes: Array<{ id: number; name: string; sort_order: number; value: string }>;
          }>;
          thumbnail: { url: string };
          media_gallery: Array<
            | { role: Array<string>; label: string; url: string }
            | { label: string; url: string; video_content: { video_title: string; video_url: string } }
          >;
          price_tiers: Array<{
            quantity: number;
            label: string;
            discount: { percent_off: number; amount_off: number };
            final_price: { value: number; currency: Types.ICurrencyEnum };
            total_price: { value: number; currency: Types.ICurrencyEnum };
          }>;
          price_range: {
            minimum_price: {
              final_prices: Array<{ value: number; currency: Types.ICurrencyEnum; multiplier: number }>;
              final_price: { value: number; currency: Types.ICurrencyEnum };
              regular_price: { value: number; currency: Types.ICurrencyEnum };
              discount: { percent_off: number };
            };
          };
        }
      | {
          __typename: "GiftCardProduct";
          sku: string;
          id: number;
          name: string;
          stock_status: Types.IProductStockStatus;
          flavor: number;
          flavor_label: string;
          product_brand: string;
          color: number;
          subtitle: string;
          product_disclaimer: string;
          categories: Array<{ name: string }>;
          flavour_details: Array<{
            name: string;
            description: string;
            attributes: Array<{ id: number; name: string; sort_order: number; value: string }>;
          }>;
          thumbnail: { url: string };
          media_gallery: Array<
            | { role: Array<string>; label: string; url: string }
            | { label: string; url: string; video_content: { video_title: string; video_url: string } }
          >;
          price_tiers: Array<{
            quantity: number;
            label: string;
            discount: { percent_off: number; amount_off: number };
            final_price: { value: number; currency: Types.ICurrencyEnum };
            total_price: { value: number; currency: Types.ICurrencyEnum };
          }>;
          price_range: {
            minimum_price: {
              final_prices: Array<{ value: number; currency: Types.ICurrencyEnum; multiplier: number }>;
              final_price: { value: number; currency: Types.ICurrencyEnum };
              regular_price: { value: number; currency: Types.ICurrencyEnum };
              discount: { percent_off: number };
            };
          };
        }
      | {
          __typename: "GroupedProduct";
          sku: string;
          id: number;
          name: string;
          stock_status: Types.IProductStockStatus;
          flavor: number;
          flavor_label: string;
          product_brand: string;
          color: number;
          subtitle: string;
          product_disclaimer: string;
          categories: Array<{ name: string }>;
          flavour_details: Array<{
            name: string;
            description: string;
            attributes: Array<{ id: number; name: string; sort_order: number; value: string }>;
          }>;
          thumbnail: { url: string };
          media_gallery: Array<
            | { role: Array<string>; label: string; url: string }
            | { label: string; url: string; video_content: { video_title: string; video_url: string } }
          >;
          price_tiers: Array<{
            quantity: number;
            label: string;
            discount: { percent_off: number; amount_off: number };
            final_price: { value: number; currency: Types.ICurrencyEnum };
            total_price: { value: number; currency: Types.ICurrencyEnum };
          }>;
          price_range: {
            minimum_price: {
              final_prices: Array<{ value: number; currency: Types.ICurrencyEnum; multiplier: number }>;
              final_price: { value: number; currency: Types.ICurrencyEnum };
              regular_price: { value: number; currency: Types.ICurrencyEnum };
              discount: { percent_off: number };
            };
          };
        }
      | {
          __typename: "SimpleProduct";
          sku: string;
          id: number;
          name: string;
          stock_status: Types.IProductStockStatus;
          flavor: number;
          flavor_label: string;
          product_brand: string;
          color: number;
          subtitle: string;
          product_disclaimer: string;
          categories: Array<{ name: string }>;
          flavour_details: Array<{
            name: string;
            description: string;
            attributes: Array<{ id: number; name: string; sort_order: number; value: string }>;
          }>;
          thumbnail: { url: string };
          media_gallery: Array<
            | { role: Array<string>; label: string; url: string }
            | { label: string; url: string; video_content: { video_title: string; video_url: string } }
          >;
          price_tiers: Array<{
            quantity: number;
            label: string;
            discount: { percent_off: number; amount_off: number };
            final_price: { value: number; currency: Types.ICurrencyEnum };
            total_price: { value: number; currency: Types.ICurrencyEnum };
          }>;
          price_range: {
            minimum_price: {
              final_prices: Array<{ value: number; currency: Types.ICurrencyEnum; multiplier: number }>;
              final_price: { value: number; currency: Types.ICurrencyEnum };
              regular_price: { value: number; currency: Types.ICurrencyEnum };
              discount: { percent_off: number };
            };
          };
        }
      | {
          __typename: "VirtualProduct";
          sku: string;
          id: number;
          name: string;
          stock_status: Types.IProductStockStatus;
          flavor: number;
          flavor_label: string;
          product_brand: string;
          color: number;
          subtitle: string;
          product_disclaimer: string;
          categories: Array<{ name: string }>;
          flavour_details: Array<{
            name: string;
            description: string;
            attributes: Array<{ id: number; name: string; sort_order: number; value: string }>;
          }>;
          thumbnail: { url: string };
          media_gallery: Array<
            | { role: Array<string>; label: string; url: string }
            | { label: string; url: string; video_content: { video_title: string; video_url: string } }
          >;
          price_tiers: Array<{
            quantity: number;
            label: string;
            discount: { percent_off: number; amount_off: number };
            final_price: { value: number; currency: Types.ICurrencyEnum };
            total_price: { value: number; currency: Types.ICurrencyEnum };
          }>;
          price_range: {
            minimum_price: {
              final_prices: Array<{ value: number; currency: Types.ICurrencyEnum; multiplier: number }>;
              final_price: { value: number; currency: Types.ICurrencyEnum };
              regular_price: { value: number; currency: Types.ICurrencyEnum };
              discount: { percent_off: number };
            };
          };
        }
    >;
  };
};

export type IGetProductsEssentialsQueryVariables = Exact<{
  sku?: Array<string | null | undefined> | string | null | undefined;
  pageSize?: number | null | undefined;
}>;

export type IGetProductsEssentialsQuery = {
  currency: { base_currency_code: string; base_currency_symbol: string };
  products: {
    items: Array<
      | {
          __typename: "BundleProduct";
          sku: string;
          id: number;
          name: string;
          url_key: string;
          stock_status: Types.IProductStockStatus;
          province: string;
          strength: number;
          items: Array<{
            __typename: "BundleItem";
            sku: string;
            options: Array<{
              id: number;
              label: string;
              product:
                | {
                    __typename: "BundleProduct";
                    id: number;
                    name: string;
                    sku: string;
                    stock_status: Types.IProductStockStatus;
                  }
                | {
                    __typename: "ConfigurableProduct";
                    id: number;
                    name: string;
                    sku: string;
                    stock_status: Types.IProductStockStatus;
                  }
                | {
                    __typename: "DownloadableProduct";
                    id: number;
                    name: string;
                    sku: string;
                    stock_status: Types.IProductStockStatus;
                  }
                | {
                    __typename: "GiftCardProduct";
                    id: number;
                    name: string;
                    sku: string;
                    stock_status: Types.IProductStockStatus;
                  }
                | {
                    __typename: "GroupedProduct";
                    id: number;
                    name: string;
                    sku: string;
                    stock_status: Types.IProductStockStatus;
                  }
                | {
                    __typename: "SimpleProduct";
                    id: number;
                    name: string;
                    sku: string;
                    stock_status: Types.IProductStockStatus;
                  }
                | {
                    __typename: "VirtualProduct";
                    id: number;
                    name: string;
                    sku: string;
                    stock_status: Types.IProductStockStatus;
                  };
            }>;
          }>;
          short_description: { html: string };
          thumbnail: { url: string };
          strength_details: { name: string; rating: number };
        }
      | {
          __typename: "ConfigurableProduct";
          sku: string;
          id: number;
          name: string;
          url_key: string;
          stock_status: Types.IProductStockStatus;
          province: string;
          strength: number;
          configurable_options: Array<{
            values: Array<{ label: string; swatch_data: { value: string } | { value: string } | { value: string } }>;
          }>;
          variants: Array<{ product: { sku: string; name: string; stock_status: Types.IProductStockStatus } }>;
          short_description: { html: string };
          thumbnail: { url: string };
          strength_details: { name: string; rating: number };
        }
      | {
          __typename: "DownloadableProduct";
          sku: string;
          id: number;
          name: string;
          url_key: string;
          stock_status: Types.IProductStockStatus;
          province: string;
          strength: number;
          short_description: { html: string };
          thumbnail: { url: string };
          strength_details: { name: string; rating: number };
        }
      | {
          __typename: "GiftCardProduct";
          sku: string;
          id: number;
          name: string;
          url_key: string;
          stock_status: Types.IProductStockStatus;
          province: string;
          strength: number;
          short_description: { html: string };
          thumbnail: { url: string };
          strength_details: { name: string; rating: number };
        }
      | {
          __typename: "GroupedProduct";
          sku: string;
          id: number;
          name: string;
          url_key: string;
          stock_status: Types.IProductStockStatus;
          province: string;
          strength: number;
          short_description: { html: string };
          thumbnail: { url: string };
          strength_details: { name: string; rating: number };
        }
      | {
          __typename: "SimpleProduct";
          sku: string;
          id: number;
          name: string;
          url_key: string;
          stock_status: Types.IProductStockStatus;
          province: string;
          strength: number;
          short_description: { html: string };
          thumbnail: { url: string };
          strength_details: { name: string; rating: number };
        }
      | {
          __typename: "VirtualProduct";
          sku: string;
          id: number;
          name: string;
          url_key: string;
          stock_status: Types.IProductStockStatus;
          province: string;
          strength: number;
          short_description: { html: string };
          thumbnail: { url: string };
          strength_details: { name: string; rating: number };
        }
    >;
  };
  products_prices: {
    total_count: number;
    items: Array<{
      sku: string;
      stock_status: Types.IProductStockStatus;
      price_range: {
        minimum_price: {
          final_price: { value: number };
          regular_price: { value: number };
          discount: { percent_off: number };
        };
      };
    }>;
  };
};

export type IGetPromoGiftInfoQueryVariables = Exact<{
  sku: Array<string | null | undefined> | string;
}>;

export type IGetPromoGiftInfoQuery = {
  products: {
    items: Array<
      | { sku: string; items: Array<{ options: Array<{ uid: string; is_default: boolean }> }>; image: { url: string } }
      | { sku: string; image: { url: string } }
      | { sku: string; image: { url: string } }
      | { sku: string; image: { url: string } }
      | { sku: string; image: { url: string } }
      | { sku: string; image: { url: string } }
      | { sku: string; image: { url: string } }
    >;
  };
};

export type IGetPromotionalOffersQueryVariables = Exact<{
  sku?: Array<string | null | undefined> | string | null | undefined;
  pageSize?: number | null | undefined;
}>;

export type IGetPromotionalOffersQuery = {
  products: {
    items: Array<
      | {
          sku: string;
          promotionalOffers: Array<{
            code: string;
            limit_qty: number;
            eligible: boolean;
            potentially_eligible: boolean;
            type: Types.ISpecialOfferTypeEnum;
            skus: Array<string>;
            description: { title: string; description: string; hint: string; label: string };
          }>;
        }
      | {
          sku: string;
          promotionalOffers: Array<{
            code: string;
            limit_qty: number;
            eligible: boolean;
            potentially_eligible: boolean;
            type: Types.ISpecialOfferTypeEnum;
            skus: Array<string>;
            description: { title: string; description: string; hint: string; label: string };
          }>;
        }
      | {
          sku: string;
          promotionalOffers: Array<{
            code: string;
            limit_qty: number;
            eligible: boolean;
            potentially_eligible: boolean;
            type: Types.ISpecialOfferTypeEnum;
            skus: Array<string>;
            description: { title: string; description: string; hint: string; label: string };
          }>;
        }
      | {
          sku: string;
          promotionalOffers: Array<{
            code: string;
            limit_qty: number;
            eligible: boolean;
            potentially_eligible: boolean;
            type: Types.ISpecialOfferTypeEnum;
            skus: Array<string>;
            description: { title: string; description: string; hint: string; label: string };
          }>;
        }
      | {
          sku: string;
          promotionalOffers: Array<{
            code: string;
            limit_qty: number;
            eligible: boolean;
            potentially_eligible: boolean;
            type: Types.ISpecialOfferTypeEnum;
            skus: Array<string>;
            description: { title: string; description: string; hint: string; label: string };
          }>;
        }
      | {
          sku: string;
          promotionalOffers: Array<{
            code: string;
            limit_qty: number;
            eligible: boolean;
            potentially_eligible: boolean;
            type: Types.ISpecialOfferTypeEnum;
            skus: Array<string>;
            description: { title: string; description: string; hint: string; label: string };
          }>;
        }
      | {
          sku: string;
          promotionalOffers: Array<{
            code: string;
            limit_qty: number;
            eligible: boolean;
            potentially_eligible: boolean;
            type: Types.ISpecialOfferTypeEnum;
            skus: Array<string>;
            description: { title: string; description: string; hint: string; label: string };
          }>;
        }
    >;
  };
};

export type IGetShippingMethodsQueryVariables = Exact<{
  cartId: string;
}>;

export type IGetShippingMethodsQuery = {
  cart: {
    shipping_addresses: Array<{
      available_shipping_methods: Array<{
        available: boolean;
        disable_for_subscription: boolean;
        carrier_code: string;
        carrier_title: string;
        method_code: string;
        method_title: string;
        description: string;
        estimated_delivery_time: string;
        amount: { currency: Types.ICurrencyEnum; value: number };
      }>;
      selected_shipping_method: {
        carrier_code: string;
        method_code: string;
        method_title: string;
        amount: { currency: Types.ICurrencyEnum; value: number };
      };
    }>;
  };
};

export type IGetSticksMatrixQueryVariables = Exact<{ [key: string]: never }>;

export type IGetSticksMatrixQuery = {
  getSticksMatrix: {
    single_packs: {
      onetime: Array<{ flavour: number; flavour_label: string; sku: string; swatch_data: string }>;
      subscription: Array<{ flavour: number; flavour_label: string; sku: string; swatch_data: string }>;
    };
    cartons: {
      onetime: Array<{ flavour: number; flavour_label: string; sku: string; swatch_data: string }>;
      subscription: Array<{ flavour: number; flavour_label: string; sku: string; swatch_data: string }>;
    };
    mix_n_match: { onetime: Array<{ sku: string }>; subscription: Array<{ sku: string }> };
  };
};

export type IGetStockStatusesQueryVariables = Exact<{
  sku?: Array<string | null | undefined> | string | null | undefined;
  pageSize?: number | null | undefined;
}>;

export type IGetStockStatusesQuery = {
  products: {
    items: Array<
      | {
          __typename: "BundleProduct";
          sku: string;
          stock_status: Types.IProductStockStatus;
          items: Array<{
            __typename: "BundleItem";
            option_id: number;
            title: string;
            sku: string;
            all_options: Array<{
              id: number;
              label: string;
              product:
                | {
                    __typename: "BundleProduct";
                    id: number;
                    name: string;
                    sku: string;
                    stock_status: Types.IProductStockStatus;
                  }
                | {
                    __typename: "ConfigurableProduct";
                    id: number;
                    name: string;
                    sku: string;
                    stock_status: Types.IProductStockStatus;
                  }
                | {
                    __typename: "DownloadableProduct";
                    id: number;
                    name: string;
                    sku: string;
                    stock_status: Types.IProductStockStatus;
                  }
                | {
                    __typename: "GiftCardProduct";
                    id: number;
                    name: string;
                    sku: string;
                    stock_status: Types.IProductStockStatus;
                  }
                | {
                    __typename: "GroupedProduct";
                    id: number;
                    name: string;
                    sku: string;
                    stock_status: Types.IProductStockStatus;
                  }
                | {
                    __typename: "SimpleProduct";
                    id: number;
                    name: string;
                    sku: string;
                    stock_status: Types.IProductStockStatus;
                  }
                | {
                    __typename: "VirtualProduct";
                    id: number;
                    name: string;
                    sku: string;
                    stock_status: Types.IProductStockStatus;
                  };
            }>;
          }>;
        }
      | {
          __typename: "ConfigurableProduct";
          sku: string;
          stock_status: Types.IProductStockStatus;
          variants: Array<{ product: { sku: string; name: string; stock_status: Types.IProductStockStatus } }>;
        }
      | { __typename: "DownloadableProduct"; sku: string; stock_status: Types.IProductStockStatus }
      | { __typename: "GiftCardProduct"; sku: string; stock_status: Types.IProductStockStatus }
      | { __typename: "GroupedProduct"; sku: string; stock_status: Types.IProductStockStatus }
      | { __typename: "SimpleProduct"; sku: string; stock_status: Types.IProductStockStatus }
      | { __typename: "VirtualProduct"; sku: string; stock_status: Types.IProductStockStatus }
    >;
  };
};

export type IGetStoreConfigQueryVariables = Exact<{ [key: string]: never }>;

export type IGetStoreConfigQuery = {
  storeConfig: {
    id: number;
    store_code: string;
    store_group_code: string;
    website_code: string;
    is_order_limit_enabled: boolean;
    is_age_verification_enabled: boolean;
    age_verification_mode: Types.IAgeVerificationMode;
    is_free_gifts_enabled: boolean;
    gift_basket_quantity_limitation: string;
    order_limit_value: number;
    base_currency_code: string;
    postcode_validation_enabled: boolean;
    postcode_is_required: boolean;
    postcode_max_length: number;
    postcode_min_length: number;
    postcode_validate_regex: string;
    allow_empty_firstname: boolean;
    cartons_limit_value: number;
  };
};

export type IGetUrlKeysQueryVariables = Exact<{
  sku: string;
}>;

export type IGetUrlKeysQuery = {
  products: {
    items: Array<
      | { url_key: string; categories: Array<{ url_path: string }> }
      | { url_key: string; categories: Array<{ url_path: string }> }
      | { url_key: string; categories: Array<{ url_path: string }> }
      | { url_key: string; categories: Array<{ url_path: string }> }
      | { url_key: string; categories: Array<{ url_path: string }> }
      | { url_key: string; categories: Array<{ url_path: string }> }
      | { url_key: string; categories: Array<{ url_path: string }> }
    >;
  };
};

export type IGetXSellingPopupQueryVariables = Exact<{
  cartId: string;
}>;

export type IGetXSellingPopupQuery = {
  cart: {
    cross_sell_popup: {
      id: string;
      max_displays_per_session: number;
      priority: number;
      offer: Array<{ sku: string; price: { currency: Types.ICurrencyEnum; value: number } }>;
    };
  };
};

export const CustomerOrderPriceRangeFragmentFragmentDoc = gql`
  fragment CustomerOrderPriceRangeFragment on PriceRange {
    minimum_price {
      regular_price {
        value
        currency
      }
      final_price {
        value
        currency
      }
      fixed_product_taxes {
        label
        amount {
          value
          currency
        }
      }
    }
    maximum_price {
      discount {
        amount_off
        percent_off
      }
      fixed_product_taxes {
        label
        amount {
          value
          currency
        }
      }
    }
  }
`;
export const CustomerOrderProductFragmentFragmentDoc = gql`
  fragment CustomerOrderProductFragment on ProductInterface {
    subscription
    subscription_format
    enable_order_quantity_limit
    order_quantity_limit
    description {
      html
    }
    short_description {
      html
    }
    categories {
      name
      uid
    }
    image {
      url
    }
    strength
    strength_details {
      name
      rating
    }
    price_range {
      ...CustomerOrderPriceRangeFragment
    }
  }
  ${CustomerOrderPriceRangeFragmentFragmentDoc}
`;
export const CustomerOrderItemFragmentFragmentDoc = gql`
  fragment CustomerOrderItemFragment on OrderItemInterface {
    id
    product_name
    product_sku
    product_type
    quantity_ordered
    trade_in
    row_total {
      currency
      value
    }
    row_total_incl_tax {
      currency
      value
    }
    product_sale_price {
      currency
      value
    }
    product_sale_price_incl_tax {
      currency
      value
    }
    gift_data {
      is_gift
      parent_gift_sku
      parent_gift_id
    }
    product {
      ...CustomerOrderProductFragment
    }
    ... on BundleOrderItem {
      bundle_options {
        id
        label
        values {
          id
          product_name
          quantity
          presentation_info {
            initial_price
            presentation_price
            product {
              tooltip_info
              small_image {
                label
                url
              }
            }
          }
        }
      }
    }
  }
  ${CustomerOrderProductFragmentFragmentDoc}
`;
export const CustomerOrderBillingAddressFragmentFragmentDoc = gql`
  fragment CustomerOrderBillingAddressFragment on OrderAddress {
    city
    country_code
    firstname
    lastname
    postcode
    street
    telephone
    administrative_area_level_2
    sublocality_level_2
    premise
    neighborhood
    landmark
    building_number
    district
    region
    short_address
  }
`;
export const CustomerOrderShippingAddressFragmentFragmentDoc = gql`
  fragment CustomerOrderShippingAddressFragment on OrderAddress {
    city
    country_code
    firstname
    lastname
    postcode
    street
    telephone
    pickup_information
    administrative_area_level_2
    sublocality_level_2
    premise
    neighborhood
    landmark
    building_number
    district
    region
    short_address
  }
`;
export const CustomerOrderTotalFragmentFragmentDoc = gql`
  fragment CustomerOrderTotalFragment on OrderTotal {
    discounts {
      amount {
        currency
        value
      }
      label
      coupon_code
    }
    grand_total {
      currency
      value
    }
    subtotal {
      currency
      value
    }
    subtotal_incl_tax {
      currency
      value
    }
    taxes {
      title
      rate
      amount {
        currency
        value
      }
    }
    total_shipping {
      currency
      value
    }
    total_refunded {
      currency
      value
    }
    total_tax {
      currency
      value
    }
  }
`;
export const CustomerOrderFragmentFragmentDoc = gql`
  fragment CustomerOrderFragment on CustomerOrder {
    id
    carrier
    number
    order_date
    shipping_method
    shipping_method_code
    status
    items {
      ...CustomerOrderItemFragment
    }
    payment_methods {
      type
      name
      additional_data {
        name
        value
      }
    }
    additional_attributes {
      attribute_code
      value
    }
    billing_address {
      ...CustomerOrderBillingAddressFragment
    }
    shipping_address {
      ...CustomerOrderShippingAddressFragment
    }
    loyalty_info {
      loyalty_discount_amount
      loyalty_discount_points
      loyalty_discount_uuid
    }
    invoices {
      url
    }
    total {
      ...CustomerOrderTotalFragment
    }
    total_including_trial {
      total {
        currency
        value
      }
      total_incl_tax {
        currency
        value
      }
      tax {
        currency
        value
      }
    }
    total_after_trial {
      total {
        currency
        value
      }
      total_incl_tax {
        currency
        value
      }
      tax {
        currency
        value
      }
    }
  }
  ${CustomerOrderItemFragmentFragmentDoc}
  ${CustomerOrderBillingAddressFragmentFragmentDoc}
  ${CustomerOrderShippingAddressFragmentFragmentDoc}
  ${CustomerOrderTotalFragmentFragmentDoc}
`;
export const AddBundleProductsToCartDocument = gql`
  mutation addBundleProductsToCart($cartId: String!, $cartItems: [BundleProductCartItemInput!]!) {
    addBundleProductsToCart(input: { cart_id: $cartId, cart_items: $cartItems }) {
      cart {
        id
      }
    }
  }
`;
export const AddConfigurableProductsToCartDocument = gql`
  mutation addConfigurableProductsToCart($cartId: String!, $sku: String!, $parentSku: String!, $quantity: Float!) {
    addConfigurableProductsToCart(
      input: { cart_id: $cartId, cart_items: [{ parent_sku: $parentSku, data: { quantity: $quantity, sku: $sku } }] }
    ) {
      cart {
        id
      }
    }
  }
`;
export const AddProductsToCartDocument = gql`
  mutation addProductsToCart($cartId: String!, $cartItems: [CartItemInput!]!) {
    addProductsToCart(cartId: $cartId, cartItems: $cartItems) {
      cart {
        id
      }
    }
  }
`;
export const AddSimpleProductsToCartDocument = gql`
  mutation addSimpleProductsToCart($cartId: String!, $cartItems: [SimpleProductCartItemInput!]!) {
    addSimpleProductsToCart(input: { cart_id: $cartId, cart_items: $cartItems }) {
      cart {
        id
      }
    }
  }
`;
export const ApplyCampaignToCartDocument = gql`
  mutation applyCampaignToCart($cartId: String!, $campaign_uuid: String!) {
    applyCampaignToCart(input: { cart_id: $cartId, campaign_uuid: $campaign_uuid }) {
      cart {
        applied_campaign {
          loyalty_discount_uuid
          loyalty_discount_points
          loyalty_discount_amount
        }
        id
        is_virtual
        items {
          product {
            sku
          }
          quantity
        }
      }
    }
  }
`;
export const ApplyCouponsToCartDocument = gql`
  mutation applyCouponsToCart($cartId: String!, $couponCodes: [String!]!) {
    applyCouponsToCart(input: { cart_id: $cartId, coupon_codes: $couponCodes, type: REPLACE }) {
      cart {
        id
        applied_coupons {
          code
          label
        }
        prices {
          discounts {
            amount {
              currency
              value
            }
            label
          }
        }
      }
    }
  }
`;
export const CancelOrderDocument = gql`
  mutation cancelOrder($orderNumber: String!) {
    cancelorder(orderId: $orderNumber)
  }
`;
export const CreateEmptyCartDocument = gql`
  mutation createEmptyCart {
    createEmptyCart
  }
`;
export const GetOrderStatusesDocument = gql`
  query getOrderStatuses {
    getorderstatus {
      status_label
      status_value
      cancelable
    }
  }
`;
export const MergeCartsDocument = gql`
  mutation mergeCarts($sourceCartId: String!, $destinationCartId: String!) {
    mergeCarts(source_cart_id: $sourceCartId, destination_cart_id: $destinationCartId) {
      id
    }
  }
`;
export const PlaceOrderDocument = gql`
  mutation placeOrder($cartId: String!, $additionalAttributes: [OrderAttributeInput]) {
    placeOrder(input: { cart_id: $cartId, additional_attributes: $additionalAttributes }) {
      orderV2 {
        ...CustomerOrderFragment
      }
      errors {
        message
        code
      }
    }
  }
  ${CustomerOrderFragmentFragmentDoc}
`;
export const RemoveCampaignFromCartDocument = gql`
  mutation removeCampaignFromCart($cartId: String!) {
    removeCampaignFromCart(input: { cart_id: $cartId }) {
      cart {
        applied_campaign {
          loyalty_discount_uuid
          loyalty_discount_points
          loyalty_discount_amount
        }
        id
        is_virtual
        items {
          product {
            sku
          }
          quantity
        }
      }
    }
  }
`;
export const RemoveCouponsFromCartDocument = gql`
  mutation removeCouponsFromCart($cartId: String!, $couponCodes: [String!]!) {
    removeCouponsFromCart(input: { cart_id: $cartId, coupon_codes: $couponCodes }) {
      cart {
        id
        applied_coupons {
          code
        }
        prices {
          discounts {
            amount {
              currency
              value
            }
            label
          }
        }
      }
    }
  }
`;
export const RemoveItemFromCartDocument = gql`
  mutation removeItemFromCart($cartId: String!, $itemId: Int!) {
    removeItemFromCart(input: { cart_id: $cartId, cart_item_id: $itemId }) {
      cart {
        id
      }
    }
  }
`;
export const SetAdditionalAttributesDocument = gql`
  mutation setAdditionalAttributes($cartId: String!, $additionalAttributes: [QuoteAttributeInput!]!) {
    setAdditionalAttributes(input: { cart_id: $cartId, additional_attributes: $additionalAttributes }) {
      errors {
        code
        message
      }
    }
  }
`;
export const SetAddressesOnCartDocument = gql`
  mutation setAddressesOnCart(
    $cartId: String!
    $shipping_addresses: CartAddressInput!
    $billing_address: CartAddressInput!
  ) {
    setShippingAddressesOnCart(input: { cart_id: $cartId, shipping_addresses: [{ address: $shipping_addresses }] }) {
      cart {
        id
      }
    }
    setBillingAddressOnCart(input: { cart_id: $cartId, billing_address: { address: $billing_address } }) {
      cart {
        id
      }
    }
  }
`;
export const SetBillingAddressOnCartDocument = gql`
  mutation setBillingAddressOnCart($cartId: String!, $address: CartAddressInput!) {
    setBillingAddressOnCart(input: { cart_id: $cartId, billing_address: { address: $address } }) {
      cart {
        id
      }
    }
  }
`;
export const SetBillingAddressOnCartByAddressIdDocument = gql`
  mutation setBillingAddressOnCartByAddressId($cartId: String!, $customer_address_id: Int!) {
    setBillingAddressOnCart(
      input: { cart_id: $cartId, billing_address: { customer_address_id: $customer_address_id } }
    ) {
      cart {
        id
      }
    }
  }
`;
export const SetCheckoutFastFlowCartDocument = gql`
  mutation setCheckoutFastFlowCart(
    $cartId: String!
    $shippingAddress: CartAddressInput!
    $billingAddress: CartAddressInput!
    $carrierCode: String!
    $methodCode: String!
  ) {
    setShippingAddressesOnCart(input: { cart_id: $cartId, shipping_addresses: [{ address: $shippingAddress }] }) {
      cart {
        id
      }
    }
    setShippingMethodsOnCart(
      input: { cart_id: $cartId, shipping_methods: [{ carrier_code: $carrierCode, method_code: $methodCode }] }
    ) {
      cart {
        id
      }
    }
    setBillingAddressOnCart(input: { cart_id: $cartId, billing_address: { address: $billingAddress } }) {
      cart {
        id
      }
    }
  }
`;
export const SetPaymentMethodOnCartDocument = gql`
  mutation setPaymentMethodOnCart($cartId: String!, $code: String!) {
    setPaymentMethodOnCart(input: { cart_id: $cartId, payment_method: { code: $code } }) {
      cart {
        selected_payment_method {
          code
        }
      }
    }
  }
`;
export const SetShippingAddressesOnCartDocument = gql`
  mutation setShippingAddressesOnCart($cartId: String!, $address: CartAddressInput!) {
    setShippingAddressesOnCart(input: { cart_id: $cartId, shipping_addresses: [{ address: $address }] }) {
      cart {
        id
      }
    }
  }
`;
export const SetShippingAddressesOnCartByAddressIdDocument = gql`
  mutation setShippingAddressesOnCartByAddressId($cartId: String!, $customer_address_id: Int!) {
    setShippingAddressesOnCart(
      input: { cart_id: $cartId, shipping_addresses: [{ customer_address_id: $customer_address_id }] }
    ) {
      cart {
        id
      }
    }
  }
`;
export const SetShippingAddressesOnCartWithMethodsDocument = gql`
  mutation setShippingAddressesOnCartWithMethods($cartId: String!, $address: CartAddressInput!) {
    setShippingAddressesOnCart(input: { cart_id: $cartId, shipping_addresses: [{ address: $address }] }) {
      cart {
        shipping_addresses {
          available_shipping_methods {
            amount {
              currency
              value
            }
            available
            disable_for_subscription
            carrier_code
            carrier_title
            method_code
            method_title
            description
            estimated_delivery_time
          }
          selected_shipping_method {
            amount {
              currency
              value
            }
            carrier_code
            method_code
            method_title
          }
        }
      }
    }
  }
`;
export const SetShippingMethodsOnCartDocument = gql`
  mutation setShippingMethodsOnCart($cartId: String!, $carrierCode: String!, $methodCode: String!) {
    setShippingMethodsOnCart(
      input: { cart_id: $cartId, shipping_methods: [{ carrier_code: $carrierCode, method_code: $methodCode }] }
    ) {
      cart {
        id
      }
    }
  }
`;
export const UpdateCartItemQuantityDocument = gql`
  mutation updateCartItemQuantity($cartId: String!, $cartItemId: Int!, $quantity: Float!) {
    updateCartItems(input: { cart_id: $cartId, cart_items: [{ cart_item_id: $cartItemId, quantity: $quantity }] }) {
      cart {
        id
      }
    }
  }
`;
export const UpdateCustomerAddressDocument = gql`
  mutation updateCustomerAddress($addressId: Int!, $address: CustomerAddressInput!) {
    updateCustomerAddress(id: $addressId, input: $address) {
      city
      company
      country_code
      country_id
      default_billing
      default_shipping
      firstname
      id
      lastname
      middlename
      postcode
      prefix
      region {
        region
        region_code
        region_id
      }
      street
      suffix
      telephone
    }
  }
`;
export const UpdatePaymentMethodDocument = gql`
  mutation updatePaymentMethod($orderId: String!, $methodCode: String!) {
    updatePaymentMethod(input: { order_id: $orderId, method_code: $methodCode }) {
      success
    }
  }
`;
export const GetAvailablePaymentMethodsDocument = gql`
  query getAvailablePaymentMethods($cartId: String!) {
    cart(cart_id: $cartId) {
      available_payment_methods {
        code
        title
      }
    }
  }
`;
export const GetBrandConsumablesMatrixDocument = gql`
  query GetBrandConsumablesMatrix($brandCode: String!) {
    getBrandConsumableMatrix(brandCode: $brandCode) {
      id
      code
      name
      brandIcon
      isNew
      brandLabel
      brandLabels {
        label
        language
      }
      productBrandOptionId
    }
  }
`;
export const GetBrandConsumablesDocument = gql`
  query GetBrandConsumables($brandCode: String!) {
    getBrandConsumableMatrix(brandCode: $brandCode) {
      id
      code
      name
      brandIcon
      brandLabel
      packagingFormats {
        id
        brandId
        label
        contentsType
        itemsPerPackage
        packagesPerBundle
        formatQuantity
        productTypeName
        icon
      }
      items {
        sku
        brandId
        packagingFormatId
        purchaseType
        flavorDetails {
          flavour
          flavour_label
          swatch_data
        }
        sortOrder
        isDefault
      }
    }
  }
`;
export const GetCartIdDocument = gql`
  query getCartId($cartId: String!) {
    cart(cart_id: $cartId) {
      id
    }
  }
`;
export const GetCartItemsDocument = gql`
  query getCartItems($cartId: String!) {
    cart(cart_id: $cartId) {
      available_free_gifts {
        sales_rule_id
        allowed_gift_products {
          id
          sku
          name
        }
        gift_qty_limit
        is_removable
      }
      items {
        id
        errors {
          code
          message
        }
        has_registration_consent
        product {
          id
          name
          sku
          subscription
          has_registration_consent
          trade_in
          type_id
          stock_status
          has_device
          is_discontinued
          subscription_format
          delivery_region_code
          region
          region_label
          promotionalOffers {
            code
            limit_qty
            eligible
            type
            skus
            description {
              title
              description
              hint
              label
            }
          }
          price_range {
            minimum_price {
              regular_price {
                value
                currency
              }
              final_price {
                value
                currency
              }
              fixed_product_taxes {
                label
                amount {
                  value
                  currency
                }
              }
            }
            maximum_price {
              discount {
                amount_off
                percent_off
              }
              fixed_product_taxes {
                label
                amount {
                  value
                  currency
                }
              }
            }
          }
          image {
            url
            label
          }
          short_description {
            html
          }
          flavor
          flavor_label
          enable_order_quantity_limit
          order_quantity_limit
          color_label
          categories {
            name
            uid
            store_locator_name
          }
          free_gifts {
            allowed_qty
            products {
              is_eligible
              eligibility_description
              product {
                name
                sku
                tooltip_info
                stock_status
                image {
                  url
                  label
                }
              }
            }
          }
          strength
          strength_details {
            name
            rating
          }
        }
        quantity
        gift_data {
          is_gift
          parent_gift_sku
          parent_gift_id
          is_gift_removable
        }
        prices {
          discounts {
            amount {
              currency
              value
            }
            label
          }
          price {
            currency
            value
          }
          row_total {
            currency
            value
          }
          row_total_including_tax {
            currency
            value
          }
          total_item_discount {
            currency
            value
          }
        }
        ... on ConfigurableCartItem {
          configured_variant {
            is_discontinued
          }
        }
        ... on BundleCartItem {
          bundle_options {
            id
            label
            type
            values {
              id
              label
              price
              quantity
              presentation_info {
                initial_price
                presentation_price
                product {
                  stock_status
                  tooltip_info
                  is_discontinued
                  small_image {
                    url
                  }
                  price_range {
                    maximum_price {
                      final_price {
                        currency
                        value
                      }
                      regular_price {
                        currency
                        value
                      }
                    }
                    minimum_price {
                      final_price {
                        currency
                        value
                      }
                      regular_price {
                        currency
                        value
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
export const GetCartPricesDocument = gql`
  query getCartPrices($cartId: String!) {
    cart(cart_id: $cartId) {
      subscription_amount
      shipping_addresses {
        selected_shipping_method {
          amount {
            currency
            value
          }
        }
      }
      estimated_shipping_cost {
        carrier_code
        method_code
        method_title
        is_market_default
        amount {
          value
          currency
        }
      }
      applied_coupons {
        code
        label
      }
      applied_campaign {
        loyalty_discount_amount
        loyalty_discount_uuid
      }
      prices {
        grand_total {
          currency
          value
        }
        subtotal_excluding_tax {
          currency
          value
        }
        subtotal_including_tax {
          currency
          value
        }
        applied_taxes {
          amount {
            currency
            value
          }
          label
          rate
        }
        discounts {
          amount {
            currency
            value
          }
          label
          coupon_code
        }
      }
      total_after_trial {
        total {
          currency
          value
        }
        total_incl_tax {
          currency
          value
        }
        tax {
          currency
          value
        }
      }
      available_payment_methods {
        code
        title
      }
      minimum_payable_amount {
        currency
        value
      }
    }
  }
`;
export const GetCartSelectedPaymentMethodDocument = gql`
  query getCartSelectedPaymentMethod($cartId: String!) {
    cart(cart_id: $cartId) {
      selected_payment_method {
        purchase_order_number
      }
    }
  }
`;
export const GetConsumablesMatrixDocument = gql`
  query getConsumablesMatrix {
    getConsumablesMatrix {
      packagingFormats {
        id
        label
        contentsType
        itemsPerPackage
        packagesPerBundle
        formatQuantity
        productTypeName
        icon
      }
      items {
        sku
        packagingFormatId
        purchaseType
        brandId
        flavorDetails {
          flavour
          flavour_label
          swatch_data
        }
      }
    }
  }
`;
export const GetCountiesForProfileDocument = gql`
  query getCountiesForProfile {
    countries {
      available_regions {
        id
        code
        name
      }
      full_name_english
      full_name_locale
      id
      three_letter_abbreviation
      two_letter_abbreviation
    }
  }
`;
export const GetCountriesDocument = gql`
  query getCountries {
    countries {
      available_regions {
        id
        code
        name
      }
      full_name_english
      full_name_locale
      id
      three_letter_abbreviation
      two_letter_abbreviation
    }
  }
`;
export const GetCountryDocument = gql`
  query getCountry($id: String!) {
    country(id: $id) {
      id
      two_letter_abbreviation
      three_letter_abbreviation
      full_name_english
      full_name_locale
      available_regions {
        id
        code
        name
      }
    }
  }
`;
export const GetCurrencyDocument = gql`
  query getCurrency {
    currency {
      default_display_currency_code
      default_display_currency_symbol
    }
  }
`;
export const GetCustomerAddressesDocument = gql`
  query getCustomerAddresses {
    customer {
      default_shipping
      addresses {
        region {
          region
          region_code
          region_id
        }
        id
        country_code
        city
        company
        telephone
        firstname
        lastname
        middlename
        postcode
        street
      }
    }
  }
`;
export const GetCustomerCartDocument = gql`
  query getCustomerCart {
    customerCart {
      id
      available_payment_methods {
        code
        title
      }
      is_trial_eligible
      can_apply_coupons
      applied_campaign {
        loyalty_discount_uuid
        loyalty_discount_points
        loyalty_discount_amount
      }
      additional_attributes {
        attribute_code
        value
      }
      free_shipping_threshold
    }
  }
`;
export const GetCustomerCartIdDocument = gql`
  query getCustomerCartId {
    customerCart {
      id
    }
  }
`;
export const GetCustomerCartOrderPricesDocument = gql`
  query getCustomerCartOrderPrices($cartId: String!) {
    cart(cart_id: $cartId) {
      subscription_amount
      shipping_addresses {
        selected_shipping_method {
          amount {
            currency
            value
          }
        }
      }
      estimated_shipping_cost {
        carrier_code
        method_code
        method_title
        is_market_default
        amount {
          value
          currency
        }
      }
      applied_campaign {
        loyalty_discount_amount
        loyalty_discount_uuid
      }
      prices {
        grand_total {
          currency
          value
        }
        subtotal_including_tax {
          currency
          value
        }
        subtotal_excluding_tax {
          currency
          value
        }
        applied_taxes {
          amount {
            currency
            value
          }
          label
          rate
        }
        discounts {
          amount {
            currency
            value
          }
          label
          coupon_code
        }
      }
      minimum_payable_amount {
        currency
        value
      }
    }
  }
`;
export const GetCustomerCartPricesDocument = gql`
  query getCustomerCartPrices($cartId: String!) {
    cart(cart_id: $cartId) {
      email
      shipping_addresses {
        selected_shipping_method {
          amount {
            currency
            value
          }
        }
      }
      items {
        product {
          sku
          special_price
          price_range {
            minimum_price {
              regular_price {
                value
                currency
              }
              final_price {
                value
                currency
              }
              fixed_product_taxes {
                label
                amount {
                  value
                  currency
                }
              }
            }
            maximum_price {
              discount {
                amount_off
                percent_off
              }
              fixed_product_taxes {
                label
                amount {
                  value
                  currency
                }
              }
            }
          }
          price_tiers {
            quantity
            discount {
              percent_off
              amount_off
            }
            final_price {
              value
              currency
            }
          }
          name
          id
          uid
        }
        uid
        quantity
        product {
          name
          sku
          price_tiers {
            quantity
            final_price {
              value
            }
            discount {
              amount_off
              percent_off
            }
          }
        }
        prices {
          price {
            value
          }
        }
      }
      prices {
        discounts {
          label
          amount {
            value
          }
        }
        subtotal_including_tax {
          value
        }
        subtotal_excluding_tax {
          value
        }
        applied_taxes {
          label
          amount {
            value
          }
        }
        grand_total {
          currency
          value
        }
      }
      total_including_trial {
        total {
          currency
          value
        }
        total_incl_tax {
          currency
          value
        }
        tax {
          currency
          value
        }
      }
      total_after_trial {
        total {
          currency
          value
        }
        total_incl_tax {
          currency
          value
        }
        tax {
          currency
          value
        }
      }
      available_payment_methods {
        code
        title
      }
      minimum_payable_amount {
        currency
        value
      }
    }
  }
`;
export const GetCustomerCouponsDocument = gql`
  query getCustomerCoupons($cartId: String!) {
    cart(cart_id: $cartId) {
      applied_coupons {
        code
        label
      }
      can_apply_coupons
    }
  }
`;
export const GetCustomerExportedOrderDetailsDocument = gql`
  query getCustomerExportedOrderDetails($number: String!) {
    customer {
      orders(filter: { number: { eq: $number } }) {
        items {
          id
          order_date
          status
          items {
            product_name
            selected_options {
              label
              value
            }
            quantity_ordered
            quantity_refunded
            quantity_canceled
            product_sale_price {
              value
              currency
            }
            product_sale_price_incl_tax {
              currency
              value
            }
            product_sku
          }
          shipping_address {
            firstname
            lastname
            street
            city
            country_code
            postcode
            telephone
          }
          billing_address {
            firstname
            lastname
            street
            city
            country_code
          }
          shipping_method
          shipments {
            tracking {
              number
            }
          }
          payment_methods {
            type
            name
            additional_data {
              name
              value
            }
          }
          total {
            subtotal {
              currency
              value
            }
            taxes {
              amount {
                currency
                value
              }
            }
            discounts {
              label
              amount {
                currency
                value
              }
            }
            total_shipping {
              currency
              value
            }
            grand_total {
              value
              currency
            }
          }
          invoices {
            url
          }
        }
      }
    }
  }
`;
export const GetCustomerOrderDocument = gql`
  query getCustomerOrder($orderNumber: String!) {
    customer {
      orders(filter: { number: { eq: $orderNumber } }, scope: WEBSITE) {
        items {
          ...CustomerOrderFragment
        }
      }
    }
  }
  ${CustomerOrderFragmentFragmentDoc}
`;
export const GetCustomerOrderDetailsDocument = gql`
  query getCustomerOrderDetails($number: String!, $scope: ScopeTypeEnum) {
    customer {
      orders(filter: { number: { eq: $number } }, scope: $scope) {
        items {
          id
          order_date
          website_code
          has_withdrawal
          withdrawal_id
          status
          status_reason {
            reason_code
            reason_message
          }
          items {
            id
            product {
              __typename
              color_label
              enable_order_quantity_limit
              order_quantity_limit
              hidden_sku
              subscription
              is_discontinued
              categories {
                name
                uid
              }
              image {
                url
              }
            }
            product_type
            product_name
            selected_options {
              label
              value
            }
            quantity_ordered
            quantity_refunded
            quantity_canceled
            row_total {
              currency
              value
            }
            row_total_incl_tax {
              currency
              value
            }
            product_sale_price {
              value
              currency
            }
            product_sale_price_incl_tax {
              currency
              value
            }
            product_sku
            gift_data {
              is_gift
              parent_gift_sku
              parent_gift_id
            }
            ... on BundleOrderItem {
              bundle_options {
                id
                label
                values {
                  uid
                  id
                  product_name
                  quantity
                  presentation_info {
                    initial_price
                    presentation_price
                    product {
                      uid
                      id
                      tooltip_info
                      is_discontinued
                      small_image {
                        url
                      }
                    }
                  }
                }
              }
            }
          }
          additional_attributes {
            attribute_code
            value
          }
          shipping_address {
            firstname
            lastname
            street
            city
            country_code
            postcode
            telephone
            pickup_information
            administrative_area_level_2
            sublocality_level_2
            premise
            neighborhood
            landmark
            building_number
            district
            region
            region_code
            region_id
          }
          billing_address {
            firstname
            lastname
            street
            city
            postcode
            country_code
            administrative_area_level_2
            sublocality_level_2
            premise
            neighborhood
            landmark
            building_number
            district
            region
            region_code
            region_id
          }
          shipping_method
          loyalty_info {
            loyalty_discount_amount
            loyalty_discount_points
            loyalty_discount_uuid
          }
          shipments {
            tracking {
              carrier
              number
              track_url
            }
          }
          payment_methods {
            type
            name
            method_code
            additional_data {
              name
              value
            }
          }
          total {
            subtotal {
              currency
              value
            }
            subtotal_incl_tax {
              currency
              value
            }
            taxes {
              title
              rate
              amount {
                currency
                value
              }
            }
            discounts {
              label
              amount {
                currency
                value
              }
            }
            total_shipping {
              currency
              value
            }
            total_refunded {
              currency
              value
            }
            total_after_refund {
              currency
              value
            }
            grand_total {
              value
              currency
            }
          }
          total_after_trial {
            total {
              currency
              value
            }
            total_incl_tax {
              currency
              value
            }
            tax {
              currency
              value
            }
          }
          invoices {
            url
          }
        }
      }
    }
  }
`;
export const GetCustomerOrdersDocument = gql`
  query getCustomerOrders($filter: CustomerOrdersFilterInput) {
    customer {
      orders(filter: $filter) {
        items {
          id
          status
          shipping_method
          carrier
          order_date
          items {
            id
            product_name
            quantity_shipped
            quantity_refunded
            quantity_canceled
            row_total_incl_tax {
              currency
              value
            }
          }
          number
          total {
            grand_total {
              currency
              value
            }
            subtotal {
              currency
              value
            }
          }
        }
      }
    }
  }
`;
export const GetCustomerOrdersAllStoresDocument = gql`
  query getCustomerOrdersAllStores {
    customer {
      orders(scope: GLOBAL) {
        items {
          id
          number
          status
          created_at
          store_code
        }
      }
    }
  }
`;
export const GetCustomerOrdersCountDocument = gql`
  query getCustomerOrdersCount($scope: ScopeTypeEnum) {
    customer {
      orders(scope: $scope) {
        total_count
      }
    }
  }
`;
export const GetCustomerOrdersPaginationDocument = gql`
  query getCustomerOrdersPagination(
    $filter: CustomerOrdersFilterInput
    $currentPage: Int
    $sort: CustomerOrderSortInput
    $scope: ScopeTypeEnum
    $order_type: OrderTypeEnum
  ) {
    customer {
      orders(filter: $filter, currentPage: $currentPage, sort: $sort, scope: $scope, order_type: $order_type) {
        page_info {
          current_page
          total_pages
        }
        items {
          id
          status
          shipping_method
          carrier
          order_date
          store_code
          website_code
          items {
            id
            product_name
            quantity_shipped
            product_subscription
          }
          payment_methods {
            type
            name
          }
          number
          shipments {
            tracking {
              track_url
            }
          }
          total {
            grand_total {
              currency
              value
            }
            subtotal {
              currency
              value
            }
          }
        }
      }
    }
  }
`;
export const GetCustomerOrdersStatusesDocument = gql`
  query getCustomerOrdersStatuses($filter: CustomerOrdersFilterInput) {
    customer {
      orders(filter: $filter) {
        items {
          id
          status
        }
      }
    }
  }
`;
export const GetLastCustomerOrderDocument = gql`
  query getLastCustomerOrder {
    LastCustomerOrder {
      shipping_method_code
      payment_methods {
        type
        method_code
      }
      additional_attributes {
        attribute_code
        value
      }
    }
  }
`;
export const GetOrderAttributesDocument = gql`
  query getOrderAttributes {
    getOrderAttributes {
      code
      label
      input_type
      data_type
      is_required
      min_length
      max_length
      validate_regex
      value
      description
      placeholder
      placement
      sort_order
    }
  }
`;
export const GetOrderDeliveryLimitsDocument = gql`
  query getOrderDeliveryLimits {
    getOrderDeliveryLimits {
      mode
      limits {
        id
        country_id
        name
      }
    }
  }
`;
export const GetProductImageDocument = gql`
  query getProductImage($sku: String!) {
    products(filter: { sku: { eq: $sku } }) {
      items {
        sku
        image {
          url
        }
        small_image {
          url
        }
      }
    }
  }
`;
export const GetProductImageDescriptionDocument = gql`
  query getProductImageDescription($sku: [String]!) {
    products(filter: { sku: { in: $sku } }) {
      items {
        sku
        description {
          html
        }
        image {
          url
        }
      }
    }
  }
`;
export const GetProductPriceDocument = gql`
  query getProductPrice($sku: String!, $quantity: Int!) {
    getProductPrice(sku: $sku, quantity: $quantity) {
      maximum_price {
        final_price {
          currency
          value
        }
        regular_price {
          currency
          value
        }
      }
      minimum_price {
        final_price {
          currency
          value
        }
        regular_price {
          currency
          value
        }
      }
    }
  }
`;
export const GetProductsDocument = gql`
  query getProducts($sku: [String], $pageSize: Int) {
    currency {
      base_currency_code
      base_currency_symbol
    }
    products(filter: { sku: { in: $sku } }, pageSize: $pageSize) {
      aggregations {
        attribute_code
        label
        options {
          count
          label
          value
        }
      }
      items {
        sku
        __typename
        id
        name
        stock_status
        flavor
        flavor_label
        product_brand
        color
        subtitle
        product_disclaimer
        categories {
          name
        }
        flavour_details {
          name
          description
          attributes {
            id
            name
            sort_order
            value
          }
        }
        thumbnail {
          url
        }
        media_gallery {
          label
          url
          ... on ProductImage {
            role
          }
          ... on ProductVideo {
            video_content {
              video_title
              video_url
            }
          }
        }
        price_tiers {
          quantity
          discount {
            percent_off
            amount_off
          }
          final_price {
            value
            currency
          }
          total_price {
            value
            currency
          }
          label
        }
        price_range {
          minimum_price {
            final_prices {
              value
              currency
              multiplier
            }
            final_price {
              value
              currency
            }
            regular_price {
              value
              currency
            }
            discount {
              percent_off
            }
          }
        }
        ... on ConfigurableProduct {
          variants {
            product {
              sku
              name
              color
              stock_status
              flavor
              color_label
              subtitle
              product_disclaimer
              categories {
                name
              }
              price_range {
                minimum_price {
                  final_price {
                    value
                    currency
                  }
                  regular_price {
                    value
                    currency
                  }
                  discount {
                    percent_off
                  }
                }
              }
            }
          }
        }
        ... on BundleProduct {
          items {
            option_id
            title
            required
            type
            qty
            __typename
            sku
            all_options {
              id
              label
              qty
              quantity
              is_default
              product {
                id
                name
                sku
                flavor
                flavor_label
                product_brand
                stock_status
                color_label
                subtitle
                flavour_details {
                  name
                  description
                  attributes {
                    id
                    name
                    sort_order
                    value
                  }
                }
                thumbnail {
                  url
                }
                media_gallery {
                  label
                  url
                  ... on ProductImage {
                    role
                  }
                  ... on ProductVideo {
                    video_content {
                      video_title
                      video_url
                    }
                  }
                }
                categories {
                  name
                }
                price_range {
                  minimum_price {
                    final_price {
                      value
                      currency
                    }
                    regular_price {
                      value
                      currency
                    }
                    discount {
                      percent_off
                    }
                  }
                }
                __typename
              }
            }
          }
        }
      }
    }
  }
`;
export const GetProductsEssentialsDocument = gql`
  query getProductsEssentials($sku: [String], $pageSize: Int) {
    currency {
      base_currency_code
      base_currency_symbol
    }
    products(filter: { sku: { in: $sku } }, pageSize: $pageSize) {
      items {
        sku
        __typename
        id
        name
        short_description {
          html
        }
        thumbnail {
          url
        }
        url_key
        stock_status
        province
        strength
        strength_details {
          name
          rating
        }
        ... on ConfigurableProduct {
          configurable_options {
            values {
              label
              swatch_data {
                value
              }
            }
          }
          variants {
            product {
              sku
              name
              stock_status
            }
          }
        }
        ... on BundleProduct {
          items {
            __typename
            sku
            options {
              id
              label
              product {
                id
                name
                sku
                stock_status
                __typename
              }
            }
          }
        }
      }
    }
    products_prices(filter: { sku: { in: $sku } }, pageSize: $pageSize) {
      total_count
      items {
        sku
        stock_status
        price_range {
          minimum_price {
            final_price {
              value
            }
            regular_price {
              value
            }
            discount {
              percent_off
            }
          }
        }
      }
    }
  }
`;
export const GetPromoGiftInfoDocument = gql`
  query getPromoGiftInfo($sku: [String]!) {
    products(filter: { sku: { in: $sku } }) {
      items {
        sku
        image {
          url
        }
        ... on BundleProduct {
          items {
            options {
              uid
              is_default
            }
          }
        }
      }
    }
  }
`;
export const GetPromotionalOffersDocument = gql`
  query getPromotionalOffers($sku: [String], $pageSize: Int) {
    products(filter: { sku: { in: $sku } }, pageSize: $pageSize) {
      items {
        sku
        promotionalOffers {
          code
          limit_qty
          eligible
          potentially_eligible
          type
          skus
          description {
            title
            description
            hint
            label
          }
        }
      }
    }
  }
`;
export const GetShippingMethodsDocument = gql`
  query getShippingMethods($cartId: String!) {
    cart(cart_id: $cartId) {
      shipping_addresses {
        available_shipping_methods {
          amount {
            currency
            value
          }
          available
          disable_for_subscription
          carrier_code
          carrier_title
          method_code
          method_title
          description
          estimated_delivery_time
        }
        selected_shipping_method {
          amount {
            currency
            value
          }
          carrier_code
          method_code
          method_title
        }
      }
    }
  }
`;
export const GetSticksMatrixDocument = gql`
  query getSticksMatrix {
    getSticksMatrix {
      single_packs {
        onetime {
          flavour
          flavour_label
          sku
          swatch_data
        }
        subscription {
          flavour
          flavour_label
          sku
          swatch_data
        }
      }
      cartons {
        onetime {
          flavour
          flavour_label
          sku
          swatch_data
        }
        subscription {
          flavour
          flavour_label
          sku
          swatch_data
        }
      }
      mix_n_match {
        onetime {
          sku
        }
        subscription {
          sku
        }
      }
    }
  }
`;
export const GetStockStatusesDocument = gql`
  query getStockStatuses($sku: [String], $pageSize: Int) {
    products(filter: { sku: { in: $sku } }, pageSize: $pageSize) {
      items {
        sku
        __typename
        stock_status
        ... on ConfigurableProduct {
          variants {
            product {
              sku
              name
              stock_status
            }
          }
        }
        ... on BundleProduct {
          items {
            option_id
            title
            __typename
            sku
            all_options {
              id
              label
              product {
                id
                name
                sku
                stock_status
                __typename
              }
            }
          }
        }
      }
    }
  }
`;
export const GetStoreConfigDocument = gql`
  query getStoreConfig {
    storeConfig {
      id
      store_code
      store_group_code
      website_code
      is_order_limit_enabled
      is_age_verification_enabled
      age_verification_mode
      is_free_gifts_enabled
      gift_basket_quantity_limitation
      order_limit_value
      base_currency_code
      postcode_validation_enabled
      postcode_is_required
      postcode_max_length
      postcode_min_length
      postcode_validate_regex
      allow_empty_firstname
      cartons_limit_value
    }
  }
`;
export const GetUrlKeysDocument = gql`
  query getUrlKeys($sku: String!) {
    products(filter: { sku: { eq: $sku } }) {
      items {
        url_key
        categories {
          url_path
        }
      }
    }
  }
`;
export const GetXSellingPopupDocument = gql`
  query getXSellingPopup($cartId: String!) {
    cart(cart_id: $cartId) {
      cross_sell_popup {
        id
        max_displays_per_session
        priority
        offer {
          sku
          price {
            currency
            value
          }
        }
      }
    }
  }
`;

export type SdkFunctionWrapper = <T>(
  action: (requestHeaders?: Record<string, string>) => Promise<T>,
  operationName: string,
  operationType?: string,
  variables?: any
) => Promise<T>;

const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    addBundleProductsToCart(
      variables: IAddBundleProductsToCartMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<IAddBundleProductsToCartMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IAddBundleProductsToCartMutation>({
            document: AddBundleProductsToCartDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "addBundleProductsToCart",
        "mutation",
        variables
      );
    },
    addConfigurableProductsToCart(
      variables: IAddConfigurableProductsToCartMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<IAddConfigurableProductsToCartMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IAddConfigurableProductsToCartMutation>({
            document: AddConfigurableProductsToCartDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "addConfigurableProductsToCart",
        "mutation",
        variables
      );
    },
    addProductsToCart(
      variables: IAddProductsToCartMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<IAddProductsToCartMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IAddProductsToCartMutation>({
            document: AddProductsToCartDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "addProductsToCart",
        "mutation",
        variables
      );
    },
    addSimpleProductsToCart(
      variables: IAddSimpleProductsToCartMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<IAddSimpleProductsToCartMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IAddSimpleProductsToCartMutation>({
            document: AddSimpleProductsToCartDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "addSimpleProductsToCart",
        "mutation",
        variables
      );
    },
    applyCampaignToCart(
      variables: IApplyCampaignToCartMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<IApplyCampaignToCartMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IApplyCampaignToCartMutation>({
            document: ApplyCampaignToCartDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "applyCampaignToCart",
        "mutation",
        variables
      );
    },
    applyCouponsToCart(
      variables: IApplyCouponsToCartMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<IApplyCouponsToCartMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IApplyCouponsToCartMutation>({
            document: ApplyCouponsToCartDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "applyCouponsToCart",
        "mutation",
        variables
      );
    },
    cancelOrder(
      variables: ICancelOrderMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<ICancelOrderMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ICancelOrderMutation>({
            document: CancelOrderDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "cancelOrder",
        "mutation",
        variables
      );
    },
    createEmptyCart(
      variables?: ICreateEmptyCartMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<ICreateEmptyCartMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ICreateEmptyCartMutation>({
            document: CreateEmptyCartDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "createEmptyCart",
        "mutation",
        variables
      );
    },
    getOrderStatuses(
      variables?: IGetOrderStatusesQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<IGetOrderStatusesQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetOrderStatusesQuery>({
            document: GetOrderStatusesDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getOrderStatuses",
        "query",
        variables
      );
    },
    mergeCarts(
      variables: IMergeCartsMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<IMergeCartsMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IMergeCartsMutation>({
            document: MergeCartsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "mergeCarts",
        "mutation",
        variables
      );
    },
    placeOrder(
      variables: IPlaceOrderMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<IPlaceOrderMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IPlaceOrderMutation>({
            document: PlaceOrderDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "placeOrder",
        "mutation",
        variables
      );
    },
    removeCampaignFromCart(
      variables: IRemoveCampaignFromCartMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<IRemoveCampaignFromCartMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IRemoveCampaignFromCartMutation>({
            document: RemoveCampaignFromCartDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "removeCampaignFromCart",
        "mutation",
        variables
      );
    },
    removeCouponsFromCart(
      variables: IRemoveCouponsFromCartMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<IRemoveCouponsFromCartMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IRemoveCouponsFromCartMutation>({
            document: RemoveCouponsFromCartDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "removeCouponsFromCart",
        "mutation",
        variables
      );
    },
    removeItemFromCart(
      variables: IRemoveItemFromCartMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<IRemoveItemFromCartMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IRemoveItemFromCartMutation>({
            document: RemoveItemFromCartDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "removeItemFromCart",
        "mutation",
        variables
      );
    },
    setAdditionalAttributes(
      variables: ISetAdditionalAttributesMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<ISetAdditionalAttributesMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ISetAdditionalAttributesMutation>({
            document: SetAdditionalAttributesDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "setAdditionalAttributes",
        "mutation",
        variables
      );
    },
    setAddressesOnCart(
      variables: ISetAddressesOnCartMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<ISetAddressesOnCartMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ISetAddressesOnCartMutation>({
            document: SetAddressesOnCartDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "setAddressesOnCart",
        "mutation",
        variables
      );
    },
    setBillingAddressOnCart(
      variables: ISetBillingAddressOnCartMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<ISetBillingAddressOnCartMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ISetBillingAddressOnCartMutation>({
            document: SetBillingAddressOnCartDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "setBillingAddressOnCart",
        "mutation",
        variables
      );
    },
    setBillingAddressOnCartByAddressId(
      variables: ISetBillingAddressOnCartByAddressIdMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<ISetBillingAddressOnCartByAddressIdMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ISetBillingAddressOnCartByAddressIdMutation>({
            document: SetBillingAddressOnCartByAddressIdDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "setBillingAddressOnCartByAddressId",
        "mutation",
        variables
      );
    },
    setCheckoutFastFlowCart(
      variables: ISetCheckoutFastFlowCartMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<ISetCheckoutFastFlowCartMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ISetCheckoutFastFlowCartMutation>({
            document: SetCheckoutFastFlowCartDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "setCheckoutFastFlowCart",
        "mutation",
        variables
      );
    },
    setPaymentMethodOnCart(
      variables: ISetPaymentMethodOnCartMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<ISetPaymentMethodOnCartMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ISetPaymentMethodOnCartMutation>({
            document: SetPaymentMethodOnCartDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "setPaymentMethodOnCart",
        "mutation",
        variables
      );
    },
    setShippingAddressesOnCart(
      variables: ISetShippingAddressesOnCartMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<ISetShippingAddressesOnCartMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ISetShippingAddressesOnCartMutation>({
            document: SetShippingAddressesOnCartDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "setShippingAddressesOnCart",
        "mutation",
        variables
      );
    },
    setShippingAddressesOnCartByAddressId(
      variables: ISetShippingAddressesOnCartByAddressIdMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<ISetShippingAddressesOnCartByAddressIdMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ISetShippingAddressesOnCartByAddressIdMutation>({
            document: SetShippingAddressesOnCartByAddressIdDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "setShippingAddressesOnCartByAddressId",
        "mutation",
        variables
      );
    },
    setShippingAddressesOnCartWithMethods(
      variables: ISetShippingAddressesOnCartWithMethodsMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<ISetShippingAddressesOnCartWithMethodsMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ISetShippingAddressesOnCartWithMethodsMutation>({
            document: SetShippingAddressesOnCartWithMethodsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "setShippingAddressesOnCartWithMethods",
        "mutation",
        variables
      );
    },
    setShippingMethodsOnCart(
      variables: ISetShippingMethodsOnCartMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<ISetShippingMethodsOnCartMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ISetShippingMethodsOnCartMutation>({
            document: SetShippingMethodsOnCartDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "setShippingMethodsOnCart",
        "mutation",
        variables
      );
    },
    updateCartItemQuantity(
      variables: IUpdateCartItemQuantityMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<IUpdateCartItemQuantityMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IUpdateCartItemQuantityMutation>({
            document: UpdateCartItemQuantityDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "updateCartItemQuantity",
        "mutation",
        variables
      );
    },
    updateCustomerAddress(
      variables: IUpdateCustomerAddressMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<IUpdateCustomerAddressMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IUpdateCustomerAddressMutation>({
            document: UpdateCustomerAddressDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "updateCustomerAddress",
        "mutation",
        variables
      );
    },
    updatePaymentMethod(
      variables: IUpdatePaymentMethodMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<IUpdatePaymentMethodMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IUpdatePaymentMethodMutation>({
            document: UpdatePaymentMethodDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "updatePaymentMethod",
        "mutation",
        variables
      );
    },
    getAvailablePaymentMethods(
      variables: IGetAvailablePaymentMethodsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<IGetAvailablePaymentMethodsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetAvailablePaymentMethodsQuery>({
            document: GetAvailablePaymentMethodsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getAvailablePaymentMethods",
        "query",
        variables
      );
    },
    GetBrandConsumablesMatrix(
      variables: IGetBrandConsumablesMatrixQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<IGetBrandConsumablesMatrixQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetBrandConsumablesMatrixQuery>({
            document: GetBrandConsumablesMatrixDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "GetBrandConsumablesMatrix",
        "query",
        variables
      );
    },
    GetBrandConsumables(
      variables: IGetBrandConsumablesQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<IGetBrandConsumablesQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetBrandConsumablesQuery>({
            document: GetBrandConsumablesDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "GetBrandConsumables",
        "query",
        variables
      );
    },
    getCartId(
      variables: IGetCartIdQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<IGetCartIdQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetCartIdQuery>({
            document: GetCartIdDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getCartId",
        "query",
        variables
      );
    },
    getCartItems(
      variables: IGetCartItemsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<IGetCartItemsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetCartItemsQuery>({
            document: GetCartItemsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getCartItems",
        "query",
        variables
      );
    },
    getCartPrices(
      variables: IGetCartPricesQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<IGetCartPricesQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetCartPricesQuery>({
            document: GetCartPricesDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getCartPrices",
        "query",
        variables
      );
    },
    getCartSelectedPaymentMethod(
      variables: IGetCartSelectedPaymentMethodQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<IGetCartSelectedPaymentMethodQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetCartSelectedPaymentMethodQuery>({
            document: GetCartSelectedPaymentMethodDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getCartSelectedPaymentMethod",
        "query",
        variables
      );
    },
    getConsumablesMatrix(
      variables?: IGetConsumablesMatrixQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<IGetConsumablesMatrixQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetConsumablesMatrixQuery>({
            document: GetConsumablesMatrixDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getConsumablesMatrix",
        "query",
        variables
      );
    },
    getCountiesForProfile(
      variables?: IGetCountiesForProfileQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<IGetCountiesForProfileQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetCountiesForProfileQuery>({
            document: GetCountiesForProfileDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getCountiesForProfile",
        "query",
        variables
      );
    },
    getCountries(
      variables?: IGetCountriesQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<IGetCountriesQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetCountriesQuery>({
            document: GetCountriesDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getCountries",
        "query",
        variables
      );
    },
    getCountry(
      variables: IGetCountryQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<IGetCountryQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetCountryQuery>({
            document: GetCountryDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getCountry",
        "query",
        variables
      );
    },
    getCurrency(
      variables?: IGetCurrencyQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<IGetCurrencyQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetCurrencyQuery>({
            document: GetCurrencyDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getCurrency",
        "query",
        variables
      );
    },
    getCustomerAddresses(
      variables?: IGetCustomerAddressesQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<IGetCustomerAddressesQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetCustomerAddressesQuery>({
            document: GetCustomerAddressesDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getCustomerAddresses",
        "query",
        variables
      );
    },
    getCustomerCart(
      variables?: IGetCustomerCartQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<IGetCustomerCartQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetCustomerCartQuery>({
            document: GetCustomerCartDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getCustomerCart",
        "query",
        variables
      );
    },
    getCustomerCartId(
      variables?: IGetCustomerCartIdQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<IGetCustomerCartIdQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetCustomerCartIdQuery>({
            document: GetCustomerCartIdDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getCustomerCartId",
        "query",
        variables
      );
    },
    getCustomerCartOrderPrices(
      variables: IGetCustomerCartOrderPricesQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<IGetCustomerCartOrderPricesQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetCustomerCartOrderPricesQuery>({
            document: GetCustomerCartOrderPricesDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getCustomerCartOrderPrices",
        "query",
        variables
      );
    },
    getCustomerCartPrices(
      variables: IGetCustomerCartPricesQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<IGetCustomerCartPricesQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetCustomerCartPricesQuery>({
            document: GetCustomerCartPricesDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getCustomerCartPrices",
        "query",
        variables
      );
    },
    getCustomerCoupons(
      variables: IGetCustomerCouponsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<IGetCustomerCouponsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetCustomerCouponsQuery>({
            document: GetCustomerCouponsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getCustomerCoupons",
        "query",
        variables
      );
    },
    getCustomerExportedOrderDetails(
      variables: IGetCustomerExportedOrderDetailsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<IGetCustomerExportedOrderDetailsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetCustomerExportedOrderDetailsQuery>({
            document: GetCustomerExportedOrderDetailsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getCustomerExportedOrderDetails",
        "query",
        variables
      );
    },
    getCustomerOrder(
      variables: IGetCustomerOrderQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<IGetCustomerOrderQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetCustomerOrderQuery>({
            document: GetCustomerOrderDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getCustomerOrder",
        "query",
        variables
      );
    },
    getCustomerOrderDetails(
      variables: IGetCustomerOrderDetailsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<IGetCustomerOrderDetailsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetCustomerOrderDetailsQuery>({
            document: GetCustomerOrderDetailsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getCustomerOrderDetails",
        "query",
        variables
      );
    },
    getCustomerOrders(
      variables?: IGetCustomerOrdersQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<IGetCustomerOrdersQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetCustomerOrdersQuery>({
            document: GetCustomerOrdersDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getCustomerOrders",
        "query",
        variables
      );
    },
    getCustomerOrdersAllStores(
      variables?: IGetCustomerOrdersAllStoresQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<IGetCustomerOrdersAllStoresQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetCustomerOrdersAllStoresQuery>({
            document: GetCustomerOrdersAllStoresDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getCustomerOrdersAllStores",
        "query",
        variables
      );
    },
    getCustomerOrdersCount(
      variables?: IGetCustomerOrdersCountQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<IGetCustomerOrdersCountQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetCustomerOrdersCountQuery>({
            document: GetCustomerOrdersCountDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getCustomerOrdersCount",
        "query",
        variables
      );
    },
    getCustomerOrdersPagination(
      variables?: IGetCustomerOrdersPaginationQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<IGetCustomerOrdersPaginationQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetCustomerOrdersPaginationQuery>({
            document: GetCustomerOrdersPaginationDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getCustomerOrdersPagination",
        "query",
        variables
      );
    },
    getCustomerOrdersStatuses(
      variables?: IGetCustomerOrdersStatusesQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<IGetCustomerOrdersStatusesQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetCustomerOrdersStatusesQuery>({
            document: GetCustomerOrdersStatusesDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getCustomerOrdersStatuses",
        "query",
        variables
      );
    },
    getLastCustomerOrder(
      variables?: IGetLastCustomerOrderQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<IGetLastCustomerOrderQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetLastCustomerOrderQuery>({
            document: GetLastCustomerOrderDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getLastCustomerOrder",
        "query",
        variables
      );
    },
    getOrderAttributes(
      variables?: IGetOrderAttributesQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<IGetOrderAttributesQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetOrderAttributesQuery>({
            document: GetOrderAttributesDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getOrderAttributes",
        "query",
        variables
      );
    },
    getOrderDeliveryLimits(
      variables?: IGetOrderDeliveryLimitsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<IGetOrderDeliveryLimitsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetOrderDeliveryLimitsQuery>({
            document: GetOrderDeliveryLimitsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getOrderDeliveryLimits",
        "query",
        variables
      );
    },
    getProductImage(
      variables: IGetProductImageQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<IGetProductImageQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetProductImageQuery>({
            document: GetProductImageDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getProductImage",
        "query",
        variables
      );
    },
    getProductImageDescription(
      variables: IGetProductImageDescriptionQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<IGetProductImageDescriptionQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetProductImageDescriptionQuery>({
            document: GetProductImageDescriptionDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getProductImageDescription",
        "query",
        variables
      );
    },
    getProductPrice(
      variables: IGetProductPriceQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<IGetProductPriceQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetProductPriceQuery>({
            document: GetProductPriceDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getProductPrice",
        "query",
        variables
      );
    },
    getProducts(
      variables?: IGetProductsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<IGetProductsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetProductsQuery>({
            document: GetProductsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getProducts",
        "query",
        variables
      );
    },
    getProductsEssentials(
      variables?: IGetProductsEssentialsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<IGetProductsEssentialsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetProductsEssentialsQuery>({
            document: GetProductsEssentialsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getProductsEssentials",
        "query",
        variables
      );
    },
    getPromoGiftInfo(
      variables: IGetPromoGiftInfoQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<IGetPromoGiftInfoQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetPromoGiftInfoQuery>({
            document: GetPromoGiftInfoDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getPromoGiftInfo",
        "query",
        variables
      );
    },
    getPromotionalOffers(
      variables?: IGetPromotionalOffersQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<IGetPromotionalOffersQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetPromotionalOffersQuery>({
            document: GetPromotionalOffersDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getPromotionalOffers",
        "query",
        variables
      );
    },
    getShippingMethods(
      variables: IGetShippingMethodsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<IGetShippingMethodsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetShippingMethodsQuery>({
            document: GetShippingMethodsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getShippingMethods",
        "query",
        variables
      );
    },
    getSticksMatrix(
      variables?: IGetSticksMatrixQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<IGetSticksMatrixQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetSticksMatrixQuery>({
            document: GetSticksMatrixDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getSticksMatrix",
        "query",
        variables
      );
    },
    getStockStatuses(
      variables?: IGetStockStatusesQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<IGetStockStatusesQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetStockStatusesQuery>({
            document: GetStockStatusesDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getStockStatuses",
        "query",
        variables
      );
    },
    getStoreConfig(
      variables?: IGetStoreConfigQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<IGetStoreConfigQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetStoreConfigQuery>({
            document: GetStoreConfigDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getStoreConfig",
        "query",
        variables
      );
    },
    getUrlKeys(
      variables: IGetUrlKeysQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<IGetUrlKeysQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetUrlKeysQuery>({
            document: GetUrlKeysDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getUrlKeys",
        "query",
        variables
      );
    },
    getXSellingPopup(
      variables: IGetXSellingPopupQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"]
    ): Promise<IGetXSellingPopupQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IGetXSellingPopupQuery>({
            document: GetXSellingPopupDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getXSellingPopup",
        "query",
        variables
      );
    },
  };
}
export type Sdk = ReturnType<typeof getSdk>;

export interface PossibleTypesResultData {
  possibleTypes: {
    [key: string]: string[];
  };
}
const result: PossibleTypesResultData = {
  possibleTypes: {
    AggregationOptionInterface: ["AggregationOption"],
    AttributeSelectedOptionInterface: ["AttributeSelectedOption"],
    AttributeValueInterface: ["AttributeSelectedOptions", "AttributeValue"],
    CartAddressInterface: ["BillingCartAddress", "ShippingCartAddress"],
    CartItemInterface: [
      "BundleCartItem",
      "ConfigurableCartItem",
      "DownloadableCartItem",
      "GiftCardCartItem",
      "SimpleCartItem",
      "VirtualCartItem",
    ],
    CategoryInterface: ["CategoryTree"],
    CreditMemoItemInterface: [
      "BundleCreditMemoItem",
      "CreditMemoItem",
      "DownloadableCreditMemoItem",
      "GiftCardCreditMemoItem",
    ],
    CustomAttributeMetadataInterface: [
      "AttributeMetadata",
      "CatalogAttributeMetadata",
      "CustomerAttributeMetadata",
      "ReturnItemAttributeMetadata",
    ],
    CustomAttributeOptionInterface: ["AttributeOptionMetadata"],
    CustomizableOptionInterface: [
      "CustomizableAreaOption",
      "CustomizableCheckboxOption",
      "CustomizableDateOption",
      "CustomizableDropDownOption",
      "CustomizableFieldOption",
      "CustomizableFileOption",
      "CustomizableMultipleOption",
      "CustomizableRadioOption",
    ],
    CustomizableProductInterface: [
      "BundleProduct",
      "ConfigurableProduct",
      "DownloadableProduct",
      "GiftCardProduct",
      "SimpleProduct",
      "VirtualProduct",
    ],
    Error: ["CartUserInputError", "InsufficientStockError"],
    ErrorInterface: ["InternalError", "NoSuchEntityUidError"],
    GiftRegistryDynamicAttributeInterface: ["GiftRegistryDynamicAttribute", "GiftRegistryRegistrantDynamicAttribute"],
    GiftRegistryDynamicAttributeMetadataInterface: ["GiftRegistryDynamicAttributeMetadata"],
    GiftRegistryItemInterface: ["GiftRegistryItem"],
    GiftRegistryItemUserErrorInterface: ["GiftRegistryItemUserErrors", "MoveCartItemsToGiftRegistryOutput"],
    GiftRegistryOutputInterface: ["GiftRegistryOutput", "MoveCartItemsToGiftRegistryOutput"],
    InvoiceItemInterface: ["BundleInvoiceItem", "DownloadableInvoiceItem", "GiftCardInvoiceItem", "InvoiceItem"],
    LayerFilterItemInterface: ["LayerFilterItem", "SwatchLayerFilterItem"],
    MediaGalleryInterface: ["ProductImage", "ProductVideo"],
    OrderItemInterface: [
      "BundleOrderItem",
      "ConfigurableOrderItem",
      "DownloadableOrderItem",
      "GiftCardOrderItem",
      "OrderItem",
    ],
    PaymentConfigItem: [
      "ApplePayConfig",
      "FastlaneConfig",
      "GooglePayConfig",
      "HostedFieldsConfig",
      "PaymentCommonConfig",
      "SmartButtonsConfig",
    ],
    PhysicalProductInterface: [
      "BundleProduct",
      "ConfigurableProduct",
      "GiftCardProduct",
      "GroupedProduct",
      "SimpleProduct",
    ],
    ProductInterface: [
      "BundleProduct",
      "ConfigurableProduct",
      "DownloadableProduct",
      "GiftCardProduct",
      "GroupedProduct",
      "SimpleProduct",
      "VirtualProduct",
    ],
    ProductLinksInterface: ["ProductLinks"],
    RoutableInterface: [
      "BundleProduct",
      "CategoryTree",
      "CmsPage",
      "ConfigurableProduct",
      "DownloadableProduct",
      "GiftCardProduct",
      "GroupedProduct",
      "RoutableUrl",
      "SimpleProduct",
      "VirtualProduct",
    ],
    ShipmentItemInterface: ["BundleShipmentItem", "GiftCardShipmentItem", "ShipmentItem"],
    SwatchDataInterface: ["ColorSwatchData", "ImageSwatchData", "TextSwatchData"],
    SwatchLayerFilterItemInterface: ["SwatchLayerFilterItem"],
    WishlistItemInterface: [
      "BundleWishlistItem",
      "ConfigurableWishlistItem",
      "DownloadableWishlistItem",
      "GiftCardWishlistItem",
      "GroupedProductWishlistItem",
      "SimpleWishlistItem",
      "VirtualWishlistItem",
    ],
  },
};
export default result;
